var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { defineComponent, reactive, provide, createElementBlock, openBlock, renderSlot, ref, computed, inject, watch, normalizeClass, createElementVNode, createVNode, unref, createCommentVNode, toDisplayString, Transition, withCtx, Fragment, renderList, createBlock, isRef, useSlots, resolveDirective, withDirectives, resolveDynamicComponent, mergeProps, withKeys, withModifiers, createTextVNode, normalizeStyle, useCssVars, onMounted, Comment, Text, nextTick, onBeforeUnmount, onUnmounted, resolveComponent, isVNode, h as h$2, getCurrentScope, onScopeDispose, toValue, getCurrentInstance, shallowRef, mergeModels, useModel, vModelCheckbox, createApp, pushScopeId, popScopeId, withScopeId, normalizeProps, guardReactiveProps, toRef, vModelText, vModelRadio, TransitionGroup, vModelDynamic, createSlots } from "vue";
import { RouterLink } from "vue-router";
const _sfc_main$1n = /* @__PURE__ */ defineComponent({
  __name: "Accordion",
  setup(__props) {
    const state2 = reactive({
      openItem: void 0
    });
    provide("accordionState", state2);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        renderSlot(_ctx.$slots, "default")
      ]);
    };
  }
});
const _hoisted_1$1b = ["aria-expanded", "aria-controls"];
const _hoisted_2$T = { class: "accordion-label" };
const _hoisted_3$J = ["id", "aria-hidden"];
const _sfc_main$1m = /* @__PURE__ */ defineComponent({
  __name: "AccordionItem",
  props: {
    label: {},
    id: {},
    open: { type: Boolean },
    iconType: {},
    iconPosition: {},
    flat: { type: Boolean },
    iconClass: {}
  },
  emits: ["update:open"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    let openVal = ref(!!props2.open);
    let isOpen = computed({
      get: () => openVal.value,
      set: (value) => {
        openVal.value = value;
        emit2("update:open", value);
      }
    });
    const accordionState = inject("accordionState");
    const id = props2.id || Math.random().toString(36).slice(7);
    const computedIcon = computed(() => {
      return props2.iconType === "plus_minus" ? isOpen.value ? "remove" : "add" : "expand_more";
    });
    const iconPosition = computed(() => props2.iconPosition || "end");
    watch(() => props2.open, () => isOpen.value = props2.open, { immediate: true });
    if (accordionState) {
      watch(
        () => accordionState.openItem,
        (currentOpenId) => {
          if (currentOpenId !== id) isOpen.value = false;
        },
        { immediate: true }
      );
    }
    function toggle() {
      isOpen.value = !isOpen.value;
      if (accordionState) {
        if (isOpen.value) {
          accordionState.openItem = id;
        } else if (accordionState.openItem === id) {
          accordionState.openItem = void 0;
        }
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["accordion-item txt-start", [{ flat: _ctx.flat }]])
      }, [
        createElementVNode("button", {
          "aria-expanded": unref(isOpen) ? "true" : "false",
          class: "accordion-head",
          "aria-controls": `accordion-body-${unref(id)}`,
          onClick: _cache[0] || (_cache[0] = ($event) => toggle())
        }, [
          iconPosition.value === "start" ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: normalizeClass(["accordion-icon", [_ctx.iconClass, { open: unref(isOpen) && _ctx.iconType === "expand_more" }]])
          }, [
            createVNode(unref(_sfc_main$s), { icon: computedIcon.value }, null, 8, ["icon"])
          ], 2)) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "head", {}, () => [
            createElementVNode("span", _hoisted_2$T, toDisplayString(_ctx.label), 1)
          ], true),
          iconPosition.value === "end" ? (openBlock(), createElementBlock("span", {
            key: 1,
            class: normalizeClass(["accordion-icon", [_ctx.iconClass, { open: unref(isOpen) && _ctx.iconType === "expand_more" }]])
          }, [
            createVNode(unref(_sfc_main$s), { icon: computedIcon.value }, null, 8, ["icon"])
          ], 2)) : createCommentVNode("", true)
        ], 8, _hoisted_1$1b),
        createVNode(Transition, { name: "expand" }, {
          default: withCtx(() => [
            unref(isOpen) ? (openBlock(), createElementBlock("div", {
              key: 0,
              id: `accordion-body-${unref(id)}`,
              class: "accordion-body",
              "aria-hidden": unref(isOpen) ? "false" : "true"
            }, [
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ], 8, _hoisted_3$J)) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 2);
    };
  }
});
const _export_sfc = (sfc, props2) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props2) {
    target[key] = val;
  }
  return target;
};
const AccordionItem = /* @__PURE__ */ _export_sfc(_sfc_main$1m, [["__scopeId", "data-v-3334f637"]]);
const _hoisted_1$1a = { class: "relative" };
const _sfc_main$1l = /* @__PURE__ */ defineComponent({
  __name: "AddressSearch",
  emits: ["addressSelected"],
  setup(__props, { emit: __emit }) {
    const emit2 = __emit;
    let addressInput = ref("");
    let searchResults = ref([]);
    const suggestion = ref();
    function emitAddress(address) {
      emit2("addressSelected", address);
      searchResults.value = [];
      addressInput.value = "";
    }
    async function searchAddresses() {
      var _a;
      const addressURL = addressInput.value.replaceAll(/\s+/g, "+");
      const geocodeUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURI(addressURL)}`;
      const res = await fetch(geocodeUrl);
      searchResults.value = await res.json() || [];
      (_a = suggestion.value) == null ? void 0 : _a.show();
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1a, [
        createVNode(unref(_sfc_main$W), {
          ref_key: "suggestion",
          ref: suggestion,
          noAutoFocus: true,
          placement: "bottom-start"
        }, {
          trigger: withCtx(() => [
            createVNode(unref(TextInput), {
              modelValue: unref(addressInput),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(addressInput) ? addressInput.value = $event : addressInput = $event),
              placeholder: "Enter address",
              onDebounce: searchAddresses
            }, null, 8, ["modelValue"])
          ]),
          default: withCtx(() => [
            createVNode(unref(ListView), { class: "-mt-2 hm-300px" }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(searchResults), (result2, index2) => {
                  return openBlock(), createBlock(unref(_sfc_main$h), {
                    key: index2,
                    icon: "location_on",
                    title: result2.display_name,
                    onClick: ($event) => emitAddress(result2)
                  }, null, 8, ["title", "onClick"]);
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]);
    };
  }
});
const _hoisted_1$19 = {
  key: 1,
  class: "bgl_btn-flex"
};
const _sfc_main$1k = /* @__PURE__ */ defineComponent({
  __name: "Btn",
  props: {
    disabled: { type: Boolean, default: false },
    icon: {},
    iconEnd: {},
    color: {},
    theme: {},
    flat: { type: Boolean },
    border: { type: Boolean, default: false },
    outline: { type: Boolean, default: false },
    thin: { type: Boolean },
    type: { default: "button" },
    loading: { type: Boolean, default: false },
    role: { default: "button" },
    value: {},
    to: {},
    href: {},
    round: { type: Boolean, default: false },
    is: { default: "button" },
    ripple: { type: Boolean, default: true },
    onClick: { type: Function, default: () => "" }
  },
  setup(__props) {
    const props2 = __props;
    const isComponent = computed(() => {
      if (props2.to) return RouterLink;
      if (props2.href) return "a";
      return props2.is;
    });
    const bind3 = computed(() => {
      const obj = {};
      if (props2.to) obj.to = props2.to;
      else if (props2.href) obj.href = props2.href;
      if (!props2.to && !props2.href) {
        obj.role = props2.role;
        obj.type = props2.type;
      }
      return obj;
    });
    const slots = useSlots();
    return (_ctx, _cache) => {
      const _directive_ripple = resolveDirective("ripple");
      return withDirectives((openBlock(), createBlock(resolveDynamicComponent(isComponent.value), mergeProps(bind3.value, {
        disabled: _ctx.disabled,
        class: ["bgl_btn", {
          "bgl_btn-icon": _ctx.icon && !unref(slots).default && !_ctx.value,
          thin: _ctx.thin,
          round: _ctx.round,
          "bgl_btn_flat": _ctx.flat,
          "bgl_btn-border": _ctx.border || _ctx.outline,
          [`bgl_btn-${_ctx.color}`]: _ctx.color,
          [`bgl_btn-${_ctx.theme}`]: _ctx.theme
        }],
        tabindex: _ctx.disabled ? -1 : 0,
        onClick: withModifiers(_ctx.onClick, ["stop"]),
        onKeydown: [
          withKeys(_ctx.onClick, ["enter"]),
          withKeys(_ctx.onClick, ["space"])
        ]
      }), {
        default: withCtx(() => [
          _ctx.loading ? (openBlock(), createBlock(unref(Loading), {
            key: 0,
            class: "h-100p",
            size: "15"
          })) : (openBlock(), createElementBlock("div", _hoisted_1$19, [
            _ctx.icon ? (openBlock(), createBlock(unref(_sfc_main$s), {
              key: 0,
              icon: _ctx.icon,
              class: "transition-400"
            }, null, 8, ["icon"])) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "default", {}, void 0, true),
            !unref(slots).default && _ctx.value ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(_ctx.value), 1)
            ], 64)) : createCommentVNode("", true),
            _ctx.iconEnd ? (openBlock(), createBlock(unref(_sfc_main$s), {
              key: 2,
              icon: _ctx.iconEnd,
              class: "transition-400"
            }, null, 8, ["icon"])) : createCommentVNode("", true)
          ]))
        ]),
        _: 3
      }, 16, ["disabled", "class", "tabindex", "onClick", "onKeydown"])), [
        [_directive_ripple, _ctx.ripple]
      ]);
    };
  }
});
const Btn = /* @__PURE__ */ _export_sfc(_sfc_main$1k, [["__scopeId", "data-v-bfc435b3"]]);
const _hoisted_1$18 = ["dismissable"];
const _hoisted_2$S = { class: "m-0" };
const _sfc_main$1j = /* @__PURE__ */ defineComponent({
  __name: "Alert",
  props: {
    message: {},
    dismissable: { type: Boolean },
    type: { default: "info" },
    icon: {}
  },
  setup(__props) {
    const isDismissed = ref(false);
    const color2 = {
      info: "var(--bgl-primary)",
      warning: "var(--bgl-yellow)",
      error: "var(--bgl-red)"
    };
    return (_ctx, _cache) => {
      return !isDismissed.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["alert", [_ctx.type]]),
        dismissable: _ctx.dismissable
      }, [
        _ctx.icon !== "none" ? (openBlock(), createBlock(unref(_sfc_main$s), {
          key: 0,
          class: "alert_icon",
          icon: _ctx.icon || _ctx.type,
          size: 2,
          color: color2[_ctx.type]
        }, null, 8, ["icon", "color"])) : createCommentVNode("", true),
        createElementVNode("p", _hoisted_2$S, toDisplayString(_ctx.message), 1),
        createVNode(Btn, {
          flat: "",
          thin: "",
          class: "alert_close",
          icon: "close",
          onClick: _cache[0] || (_cache[0] = ($event) => isDismissed.value = true)
        })
      ], 10, _hoisted_1$18)) : createCommentVNode("", true);
    };
  }
});
const Alert = /* @__PURE__ */ _export_sfc(_sfc_main$1j, [["__scopeId", "data-v-064bdd20"]]);
const _hoisted_1$17 = ["src", "alt"];
const _sfc_main$1i = /* @__PURE__ */ defineComponent({
  __name: "Avatar",
  props: {
    fallback: {},
    src: {},
    name: {},
    size: { default: 50 }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "avatar flex justify-content-center",
        style: normalizeStyle({ width: `${_ctx.size}px`, height: `${_ctx.size}px` })
      }, [
        _ctx.src ? (openBlock(), createElementBlock("img", {
          key: 0,
          src: _ctx.src,
          alt: _ctx.name
        }, null, 8, _hoisted_1$17)) : (openBlock(), createElementBlock("p", {
          key: 1,
          style: normalizeStyle({ "line-height": `${_ctx.size}px`, "font-size": `calc(1.5rem * ${_ctx.size} / 50)` })
        }, toDisplayString((_ctx.fallback || unref(initials)(_ctx.name || "")).toUpperCase()), 5))
      ], 4);
    };
  }
});
const Avatar = /* @__PURE__ */ _export_sfc(_sfc_main$1i, [["__scopeId", "data-v-46ad8c25"]]);
const _sfc_main$1h = /* @__PURE__ */ defineComponent({
  __name: "Badge",
  props: {
    color: {},
    size: {},
    text: {},
    icon: {},
    iconEnd: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["pill", [_ctx.color]])
      }, [
        _ctx.icon ? (openBlock(), createBlock(unref(_sfc_main$s), {
          key: 0,
          class: "inline",
          icon: _ctx.icon
        }, null, 8, ["icon"])) : createCommentVNode("", true),
        createTextVNode(" " + toDisplayString(_ctx.text) + " ", 1),
        _ctx.iconEnd ? (openBlock(), createBlock(unref(_sfc_main$s), {
          key: 1,
          class: "inline",
          icon: _ctx.iconEnd
        }, null, 8, ["icon"])) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const Badge = /* @__PURE__ */ _export_sfc(_sfc_main$1h, [["__scopeId", "data-v-689f051f"]]);
const _hoisted_1$16 = ["src"];
const _hoisted_2$R = ["autoplay", "muted", "loop", "controls", "playsinline"];
const _hoisted_3$I = ["src", "type"];
const _sfc_main$1g = /* @__PURE__ */ defineComponent({
  __name: "BglVideo",
  props: {
    src: {},
    autoplay: { type: Boolean },
    mute: { type: Boolean },
    aspectRatio: {},
    controls: { type: Boolean },
    loop: { type: Boolean },
    status: {},
    playsinline: { type: Boolean }
  },
  setup(__props, { expose: __expose }) {
    const props2 = __props;
    const videoFormat = computed(() => {
      var _a, _b, _c;
      return ((_c = (_b = (_a = props2.src) == null ? void 0 : _a.split(".").pop()) == null ? void 0 : _b.split("?").shift()) == null ? void 0 : _c.toLowerCase()) || "mp4";
    });
    const aspectRatio = computed(
      () => {
        var _a;
        return ((_a = props2.aspectRatio) == null ? void 0 : _a.replace(":", "/")) || "16/9";
      }
    );
    const video = ref();
    function play() {
      var _a;
      (_a = video.value) == null ? void 0 : _a.play();
    }
    function pause() {
      var _a;
      (_a = video.value) == null ? void 0 : _a.pause();
    }
    watch(() => props2.status, (status) => {
      if (status === "play") play();
      if (status === "pause") pause();
    });
    __expose({ play, pause });
    const embedType = computed(() => {
      const youtubeRegex2 = /youtube\.com|youtu\.be/;
      if (youtubeRegex2.test(props2.src || "")) return "YouTube";
      const vimeoRegex2 = /vimeo\.com/;
      if (vimeoRegex2.test(props2.src || "")) return "Vimeo";
    });
    const videoUrl = computed(() => {
      var _a, _b, _c, _d, _e2;
      if (embedType.value) {
        if (embedType.value === "YouTube") {
          const videoId = (_c = (_b = (_a = props2.src) == null ? void 0 : _a.split(/v=|youtu\.be\//)[1]) == null ? void 0 : _b.split("&")) == null ? void 0 : _c[0];
          const queryParams = new URLSearchParams({
            autoplay: props2.autoplay ? "1" : "0",
            controls: "0",
            showinfo: "0",
            modestbranding: "1"
          });
          return `https://www.youtube.com/embed/${videoId}?${queryParams}`;
        }
        if (embedType.value === "Vimeo") {
          const vimeoRegex2 = /vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/)?(\d+)(?:$|\/|\?)/;
          const videoId = (_e2 = (_d = props2.src) == null ? void 0 : _d.match(vimeoRegex2)) == null ? void 0 : _e2[3];
          return `https://player.vimeo.com/video/${videoId}`;
        }
      }
      return props2.src;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bgl_vid", { vid_empty: !_ctx.src }])
      }, [
        embedType.value ? (openBlock(), createElementBlock("iframe", {
          key: 0,
          src: videoUrl.value,
          style: normalizeStyle({ aspectRatio: aspectRatio.value }),
          frameborder: "0",
          allowfullscreen: "",
          title: "Video",
          allow: "autoplay"
        }, null, 12, _hoisted_1$16)) : _ctx.src ? (openBlock(), createElementBlock("video", {
          key: 1,
          ref_key: "video",
          ref: video,
          autoplay: _ctx.autoplay,
          muted: _ctx.mute,
          loop: _ctx.loop,
          style: normalizeStyle({ aspectRatio: aspectRatio.value }),
          controls: _ctx.controls,
          playsinline: _ctx.playsinline
        }, [
          createElementVNode("source", {
            src: _ctx.src,
            type: `video/${videoFormat.value}`
          }, null, 8, _hoisted_3$I)
        ], 12, _hoisted_2$R)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const BglVideo = /* @__PURE__ */ _export_sfc(_sfc_main$1g, [["__scopeId", "data-v-006552f6"]]);
const languageKeys = {
  /** The following three keys, describe the calendar modes */
  week: {
    "it-IT": "Settimana",
    "en-US": "Week",
    "de-DE": "Woche",
    "sv-SE": "Vecka",
    "zh-CN": "周",
    "pt-BR": "Semana",
    "fr-FR": "Semaine",
    "th-TH": "สัปดาห์",
    "nl-NL": "Week",
    "ru-RU": "Неделя",
    "ar-YE": "إسبوع",
    "es-ES": "Semana",
    "ja-JP": "週",
    "pl-PL": "Tydzień",
    "hu-HU": "Hét",
    "he-IL": "שבוע"
  },
  month: {
    "it-IT": "Mese",
    "en-US": "Month",
    "de-DE": "Monat",
    "sv-SE": "Månad",
    "zh-CN": "月",
    "pt-BR": "Mês",
    "fr-FR": "Mois",
    "th-TH": "เดือน",
    "nl-NL": "Maand",
    "ru-RU": "Месяц",
    "ar-YE": "شهر",
    "es-ES": "Mes",
    "ja-JP": "月",
    "pl-PL": "Miesiąc",
    "hu-HU": "Hónap",
    "he-IL": "חודש"
  },
  day: {
    "it-IT": "Giorno",
    "en-US": "Day",
    "de-DE": "Tag",
    "sv-SE": "Dag",
    "zh-CN": "日",
    "pt-BR": "Dia",
    "fr-FR": "Jour",
    "th-TH": "วัน",
    "nl-NL": "Dag",
    "ru-RU": "День",
    "ar-YE": "يوم",
    "es-ES": "Día",
    "ja-JP": "日",
    "pl-PL": "Dzień",
    "hu-HU": "Nap",
    "he-IL": "יום"
  },
  agenda: {
    "en-US": "Agenda",
    "he-IL": "סדר יום"
  },
  /** Other keys */
  moreEvents: {
    "it-IT": "+ altri eventi",
    "en-US": "+ more events",
    "de-DE": "+ weitere Ereignisse",
    "sv-SE": "+ fler event",
    "zh-CN": "列出其他结果",
    "pt-BR": "+ mais eventos",
    "fr-FR": "+ d'autres événements",
    "th-TH": "+ เหตุการณ์เพิ่มเติม",
    "nl-NL": "meer evenementen",
    "ru-RU": "+ ещё события",
    "ar-YE": "+ المزيد من الأحداث",
    "es-ES": "más eventos",
    "ja-JP": "その他イベント",
    "pl-PL": "+ więcej wydarzeń",
    "hu-HU": "További események",
    "he-IL": "+ עוד אירועים"
  },
  noEvent: {
    "it-IT": "Nessun evento",
    "en-US": "No events",
    "de-DE": "Keine Ereignisse",
    "sv-SE": "Inga event",
    "zh-CN": "沒有活動",
    "pt-BR": "Sem eventos",
    "fr-FR": "Aucun Evènement",
    "th-TH": "ไม่มีกิจกรรม",
    "nl-NL": "Geen evenementen",
    "ru-RU": "Нет событий",
    "ar-YE": "لا أحداث",
    "es-ES": "No hay eventos",
    "ja-JP": "イベントなし",
    "pl-PL": "Brak wydarzeń",
    "hu-HU": "Nincs esemény",
    "he-IL": "אין אירועים"
  }
};
const localeMap = /* @__PURE__ */ new Map([
  ["de", "de-DE"],
  ["en", "en-US"],
  ["it", "it-IT"],
  ["sv", "sv-SE"],
  ["zh", "zh-CN"],
  ["pt", "pt-BR"],
  ["fr", "fr-FR"],
  ["th", "th-TH"],
  ["nl", "nl-NL"],
  ["ru", "ru-RU"],
  ["ar", "ar-YE"],
  ["es", "es-ES"],
  ["ja", "ja-JP"],
  ["pl", "pl-PL"],
  ["hu", "hu-HU"],
  ["he", "he-IL"]
]);
function overrideShortLocaleWithLongLocale(locale2) {
  if (localeMap.has(locale2)) {
    locale2 = localeMap.get(locale2);
  }
  return locale2;
}
function getLanguage(languageKeys2, locale2 = "en-US") {
  locale2 = overrideShortLocaleWithLongLocale(locale2);
  return languageKeys2[locale2];
}
function translate(key, locale2 = "en-US") {
  const language = languageKeys[key] || {};
  return language[locale2] || key;
}
const _hoisted_1$15 = { class: "flex gap-05 space-between pb-1 datePick" };
const _hoisted_2$Q = { class: "flex gap-1 m_gap-025" };
const _sfc_main$1f = /* @__PURE__ */ defineComponent({
  __name: "Header",
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: "week"
    },
    time: {
      type: Object,
      default: () => ({})
    },
    period: {
      type: Object,
      required: true
    },
    isSmall: {
      type: Boolean,
      required: true
    }
  },
  emits: ["changeMode", "updatedPeriod"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const periodSelect = ref();
    const currentPeriod = ref(props2.period);
    const modeOptions = ref(["month", "week", "day", "agenda"]);
    const modeLocal = ref(props2.mode);
    const onlyDayModeIsEnabled = computed(() => {
      var _a, _b;
      const weekIsDisabled = (_a = props2.config.disableModes) == null ? void 0 : _a.includes("week");
      const monthIsDisabled = (_b = props2.config.disableModes) == null ? void 0 : _b.includes("month");
      return props2.config.disableModes && weekIsDisabled && monthIsDisabled;
    });
    watch(() => props2.isSmall, (value) => {
      if (value) modeOptions.value = ["day", "month"];
      else modeOptions.value = ["agenda", "day", "week", "month"];
    }, { immediate: true });
    function dateToPeriod(selectedDate) {
      const period = {
        start: /* @__PURE__ */ new Date(),
        end: /* @__PURE__ */ new Date(),
        selectedDate
      };
      if (props2.mode === "week") {
        period.start = props2.time.getCalendarWeekDateObjects(selectedDate)[0];
        period.end = props2.time.getCalendarWeekDateObjects(selectedDate)[6];
      } else if (props2.mode === "month") {
        period.start = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
        period.end = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
      } else {
        period.start = selectedDate;
        period.end = selectedDate;
      }
      return period;
    }
    function handlePeriodChange() {
      if (!currentPeriod.value) return;
      currentPeriod.value = dateToPeriod(currentPeriod.value.selectedDate);
      emit2("updatedPeriod", currentPeriod.value);
    }
    function goToPeriod(direction) {
      const date2 = currentPeriod.value.selectedDate;
      if (props2.mode === "month") {
        date2.setMonth(direction === "previous" ? date2.getMonth() - 1 : date2.getMonth() + 1);
      } else if (props2.mode === "week") {
        date2.setDate(direction === "previous" ? date2.getDate() - 7 : date2.getDate() + 7);
      } else {
        date2.setDate(direction === "previous" ? date2.getDate() - 1 : date2.getDate() + 1);
      }
      currentPeriod.value = dateToPeriod(date2);
      emit2("updatedPeriod", currentPeriod.value);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$15, [
        createElementVNode("div", _hoisted_2$Q, [
          createVNode(unref(Btn), {
            flat: "",
            icon: "chevron_left",
            onClick: _cache[0] || (_cache[0] = ($event) => goToPeriod("previous"))
          }),
          createVNode(unref(DatePick), {
            ref_key: "periodSelect",
            ref: periodSelect,
            modelValue: currentPeriod.value.selectedDate,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event) => currentPeriod.value.selectedDate = $event),
              handlePeriodChange
            ],
            class: "m-0 bg-input-transparent m_w-max-100px txt10 p-0",
            mode: __props.mode,
            center: ""
          }, null, 8, ["modelValue", "mode"]),
          createVNode(unref(Btn), {
            flat: "",
            icon: "chevron_right",
            onClick: _cache[2] || (_cache[2] = ($event) => goToPeriod("next"))
          })
        ]),
        !onlyDayModeIsEnabled.value ? (openBlock(), createBlock(unref(TabsNav), {
          key: 0,
          modelValue: modeLocal.value,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = ($event) => modeLocal.value = $event),
            _cache[4] || (_cache[4] = ($event) => emit2("changeMode", $event))
          ],
          tabs: modeOptions.value.map((id) => ({ id, label: unref(translate)(id) })),
          group: "mode"
        }, null, 8, ["modelValue", "tabs"])) : createCommentVNode("", true)
      ]);
    };
  }
});
const EVENT_COLORS = {
  yellow: "var(--bgl-yellow)",
  blue: "var(--bgl-blue)",
  green: "var(--bgl-green)",
  red: "var(--bgl-red)",
  pink: "var(--bgl-pink)",
  purple: "var(--bgl-purple)",
  turquoise: "var(--bgl-turquoise)",
  brown: "var(--bgl-brown)"
};
const DATE_TIME_STRING_PATTERN = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
const DATE_TIME_STRING_FULL_DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const _hoisted_1$14 = ["id"];
const _hoisted_2$P = { class: "flex txt14 flex column align-items-start gap-025 opacity-6" };
const _hoisted_3$H = {
  key: 0,
  class: "agenda__event-time flex gap-025"
};
const _hoisted_4$t = {
  key: 1,
  class: "agenda__event-location flex gap-025"
};
const _hoisted_5$q = { class: "agenda__event-title" };
const _hoisted_6$m = {
  key: 0,
  class: "agenda__event-with txt14 opacity-6"
};
const eventIdPrefix$1 = "agenda__event-";
const _sfc_main$1e = /* @__PURE__ */ defineComponent({
  __name: "AgendaEventTile",
  props: {
    time: {
      type: Object,
      required: true
    },
    calendarEvent: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },
  emits: ["eventWasClicked"],
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "26bbff92": eventBackgroundColor.value
    }));
    const props2 = __props;
    const emit2 = __emit;
    const icons = {
      clock: "clock",
      user: "user",
      location: "location_on"
    };
    const colors = EVENT_COLORS;
    const eventBackgroundColor = ref("");
    const eventColor = ref("#fff");
    const eventTime = computed(() => {
      return DATE_TIME_STRING_PATTERN.test(props2.calendarEvent.time.start) ? props2.time.getLocalizedTimeRange(
        props2.calendarEvent.time.start,
        props2.calendarEvent.time.end
      ) : null;
    });
    const elementId = computed(() => {
      return eventIdPrefix$1 + props2.calendarEvent.id;
    });
    function setColors() {
      var _a;
      if (props2.calendarEvent.colorScheme && ((_a = props2.config.style) == null ? void 0 : _a.colorSchemes) && props2.config.style.colorSchemes[props2.calendarEvent.colorScheme]) {
        eventColor.value = props2.config.style.colorSchemes[props2.calendarEvent.colorScheme].color;
        eventBackgroundColor.value = props2.config.style.colorSchemes[props2.calendarEvent.colorScheme].backgroundColor;
        return;
      }
      if (props2.calendarEvent.color) {
        eventBackgroundColor.value = colors[props2.calendarEvent.color];
        return;
      }
      eventBackgroundColor.value = colors.blue;
    }
    function handleClickOnEvent() {
      const eventElement = document.getElementById(elementId.value);
      emit2("eventWasClicked", {
        clickedEvent: props2.calendarEvent,
        eventElement
      });
    }
    onMounted(() => {
      setColors();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: elementId.value,
        class: "agenda__event is-event rounded mb-05 pointer user-select-none p-1 grid gap-1",
        onClick: withModifiers(handleClickOnEvent, ["prevent"])
      }, [
        createElementVNode("div", _hoisted_2$P, [
          eventTime.value && !__props.calendarEvent.originalEvent ? (openBlock(), createElementBlock("span", _hoisted_3$H, [
            createVNode(unref(_sfc_main$s), {
              icon: icons.clock,
              size: 0.8
            }, null, 8, ["icon"]),
            createTextVNode(" " + toDisplayString(eventTime.value), 1)
          ])) : createCommentVNode("", true),
          __props.calendarEvent.location ? (openBlock(), createElementBlock("span", _hoisted_4$t, [
            createVNode(unref(_sfc_main$s), {
              icon: icons.location,
              size: 1
            }, null, 8, ["icon"]),
            createTextVNode(" " + toDisplayString(__props.calendarEvent.location), 1)
          ])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", null, [
          createElementVNode("div", _hoisted_5$q, toDisplayString(__props.calendarEvent.title), 1),
          __props.calendarEvent.with ? (openBlock(), createElementBlock("div", _hoisted_6$m, [
            createVNode(unref(_sfc_main$s), {
              icon: icons.user
            }, null, 8, ["icon"]),
            createTextVNode(" " + toDisplayString(__props.calendarEvent.with), 1)
          ])) : createCommentVNode("", true)
        ])
      ], 8, _hoisted_1$14);
    };
  }
});
const AgendaEventTile = /* @__PURE__ */ _export_sfc(_sfc_main$1e, [["__scopeId", "data-v-d63dd40c"]]);
const _hoisted_1$13 = { class: "agenda__wrapper grid align-items-start gap-1 h-100p" };
const _hoisted_2$O = { class: "m_sticky" };
const _hoisted_3$G = { class: "agenda__header-day-name txt-center" };
const _hoisted_4$s = { class: "agenda__header-date flex justify-content-center rounded p-025 txt24 line-height-04" };
const _hoisted_5$p = { class: "agenda__content flex column w-100p h-100p min-h-100px pt-05 border-start ps-1 m_pt-0 min-h-50px" };
const _hoisted_6$l = {
  key: 0,
  class: "align-items-center flex justify-content-center h-100p opacity-6"
};
const _hoisted_7$g = {
  key: 1,
  class: "w-100p"
};
const _sfc_main$1d = /* @__PURE__ */ defineComponent({
  __name: "AgendaEvents",
  props: {
    config: {
      type: Object,
      required: true
    },
    time: {
      type: Object,
      required: true
    },
    day: {
      type: Object,
      required: true
    }
  },
  emits: ["eventWasClicked"],
  setup(__props, { emit: __emit }) {
    const emit2 = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$13, [
        createElementVNode("header", _hoisted_2$O, [
          createElementVNode("div", _hoisted_3$G, toDisplayString(__props.day.dayName.slice(0, 3)), 1),
          createElementVNode("div", _hoisted_4$s, toDisplayString(__props.day.dateTimeString.substring(8, 10)), 1)
        ]),
        createElementVNode("div", _hoisted_5$p, [
          __props.day.events.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_6$l, toDisplayString(unref(getLanguage)(unref(languageKeys).noEvent, __props.time.CALENDAR_LOCALE)), 1)) : (openBlock(), createElementBlock("div", _hoisted_7$g, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.day.events, (dayEvent) => {
              return openBlock(), createBlock(AgendaEventTile, {
                key: `agenda_event_${dayEvent.id}`,
                day: __props.day,
                config: __props.config,
                "calendar-event": dayEvent,
                time: __props.time,
                onEventWasClicked: _cache[0] || (_cache[0] = ($event) => emit2("eventWasClicked", $event))
              }, null, 8, ["day", "config", "calendar-event", "time"]);
            }), 128))
          ]))
        ])
      ]);
    };
  }
});
const AgendaEvents = /* @__PURE__ */ _export_sfc(_sfc_main$1d, [["__scopeId", "data-v-4523e7de"]]);
class EDate extends Date {
  get fullYear() {
    return this.getFullYear();
  }
  get month() {
    return this.getMonth();
  }
  get date() {
    return this.getDate();
  }
}
var DAY_TIME_POINT = /* @__PURE__ */ ((DAY_TIME_POINT2) => {
  DAY_TIME_POINT2[DAY_TIME_POINT2["MIDNIGHT"] = 0] = "MIDNIGHT";
  DAY_TIME_POINT2[DAY_TIME_POINT2["ONE_AM"] = 100] = "ONE_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["TWO_AM"] = 200] = "TWO_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["THREE_AM"] = 300] = "THREE_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["FOUR_AM"] = 400] = "FOUR_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["FIVE_AM"] = 500] = "FIVE_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["SIX_AM"] = 600] = "SIX_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["SEVEN_AM"] = 700] = "SEVEN_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["EIGHT_AM"] = 800] = "EIGHT_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["NINE_AM"] = 900] = "NINE_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["TEN_AM"] = 1e3] = "TEN_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["ELEVEN_AM"] = 1100] = "ELEVEN_AM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["TWELVE_PM"] = 1200] = "TWELVE_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["ONE_PM"] = 1300] = "ONE_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["TWO_PM"] = 1400] = "TWO_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["THREE_PM"] = 1500] = "THREE_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["FOUR_PM"] = 1600] = "FOUR_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["FIVE_PM"] = 1700] = "FIVE_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["SIX_PM"] = 1800] = "SIX_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["SEVEN_PM"] = 1900] = "SEVEN_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["EIGHT_PM"] = 2e3] = "EIGHT_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["NINE_PM"] = 2100] = "NINE_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["TEN_PM"] = 2200] = "TEN_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["ELEVEN_PM"] = 2300] = "ELEVEN_PM";
  DAY_TIME_POINT2[DAY_TIME_POINT2["TWELVE_AM"] = 2400] = "TWELVE_AM";
  return DAY_TIME_POINT2;
})(DAY_TIME_POINT || {});
var DAY_MODE = /* @__PURE__ */ ((DAY_MODE2) => {
  DAY_MODE2["REGULAR"] = "regular";
  DAY_MODE2["SHORTENED"] = "shortened";
  DAY_MODE2["FLEXIBLE"] = "flexible";
  return DAY_MODE2;
})(DAY_MODE || {});
class Helpers {
  /**
   * If navigator.languages is present (correlating to the browser's Accept-Language header), then use it
   * otherwise just use navigator.language
   */
  static getBrowserNavigatorLocale() {
    if (typeof navigator !== "object") return "en-US";
    return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
  }
  /**
   * Solution from https://github.com/vuejs/core/issues/4733#issuecomment-1024816095
   */
  static hasSlotContent(slot) {
    if (!slot) return false;
    return slot().some((vnode) => {
      if (vnode.type === Comment) return false;
      if (Array.isArray(vnode.children) && !vnode.children.length) return false;
      return vnode.type !== Text || typeof vnode.children === "string" && vnode.children.trim() !== "";
    });
  }
  static getEventType(event, time) {
    const isTimedEvent = DATE_TIME_STRING_PATTERN.test(event.time.start) && DATE_TIME_STRING_PATTERN.test(event.time.end);
    const isFullDayEvent = DATE_TIME_STRING_FULL_DAY_PATTERN.test(event.time.start) && DATE_TIME_STRING_FULL_DAY_PATTERN.test(event.time.end);
    if (isTimedEvent) return this.getTimedEventType(event, time);
    if (isFullDayEvent) return this.getFullDayEventType(event, time);
    throw new Error("Event has invalid type");
  }
  static getTimedEventType(event, time) {
    if (time.dateStringsHaveEqualDates(event.time.start, event.time.end)) {
      return "SINGLE_DAY_TIMED";
    }
    if (time.dayMode === DAY_MODE.FLEXIBLE) {
      const endBoundaryForSingleHybridDay = time.setHourInDateTimeString(
        time.addDaysToDateTimeString(
          1,
          time.dateStringFrom(event.time.start)
        ),
        Time.getHourFromTimePoints(time.DAY_END)
      );
      if (event.time.end < endBoundaryForSingleHybridDay) {
        return "SINGLE_HYBRID_DAY_TIMED";
      }
    }
    return "MULTI_DAY_TIMED";
  }
  static getFullDayEventType(event, time) {
    if (time.dateStringsHaveEqualDates(event.time.start, event.time.end)) {
      return "SINGLE_DAY_FULL_DAY";
    }
    return "MULTI_DAY_FULL_DAY";
  }
  static isUIEventTouchEvent(event) {
    return "touches" in event && typeof event.touches === "object";
  }
}
var WEEK_START_DAY = /* @__PURE__ */ ((WEEK_START_DAY2) => {
  WEEK_START_DAY2["SUNDAY"] = "sunday";
  WEEK_START_DAY2["MONDAY"] = "monday";
  return WEEK_START_DAY2;
})(WEEK_START_DAY || {});
class Time {
  constructor(firstDayOfWeek = "monday", locale2 = null, dayBoundaries = { start: 0, end: 2400 }) {
    __publicField(this, "FIRST_DAY_OF_WEEK");
    __publicField(this, "CALENDAR_LOCALE");
    __publicField(this, "ALL_HOURS", [
      0,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1e3,
      1100,
      1200,
      1300,
      1400,
      1500,
      1600,
      1700,
      1800,
      1900,
      2e3,
      2100,
      2200,
      2300
    ]);
    __publicField(this, "DAY_START");
    __publicField(this, "DAY_END");
    __publicField(this, "HOURS_PER_DAY", 24);
    __publicField(this, "MS_PER_DAY");
    this.FIRST_DAY_OF_WEEK = firstDayOfWeek;
    this.CALENDAR_LOCALE = locale2 || Helpers.getBrowserNavigatorLocale();
    this.DAY_START = dayBoundaries.start;
    this.DAY_END = dayBoundaries.end;
    this.HOURS_PER_DAY = (() => {
      const dayEnd = Time.getHourFromTimePoints(this.DAY_END);
      const dayStart = Time.getHourFromTimePoints(this.DAY_START);
      if (dayEnd > dayStart) return dayEnd - dayStart;
      return this.HOURS_PER_DAY - dayStart + dayEnd;
    })();
    this.MS_PER_DAY = 864e5;
  }
  get dayMode() {
    if (this.DAY_START === 0 && this.DAY_END === 2400) return DAY_MODE.REGULAR;
    if (this.DAY_START >= this.DAY_END) return DAY_MODE.FLEXIBLE;
    return DAY_MODE.SHORTENED;
  }
  getDatesBetweenTwoDates(start, end) {
    const arr = [];
    const dt2 = new Date(start);
    while (dt2 <= end) {
      arr.push(new Date(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()));
      dt2.setDate(dt2.getDate() + 1);
    }
    return arr;
  }
  getCalendarWeekDateObjects(date2) {
    let subtractedDaysToGetFirstDate;
    if (this.FIRST_DAY_OF_WEEK === "sunday") {
      subtractedDaysToGetFirstDate = date2.getDay();
    } else {
      subtractedDaysToGetFirstDate = date2.getDay() === 0 ? 6 : date2.getDay() - 1;
    }
    const dateOfFirstDayOfWeek = date2.getDate() - subtractedDaysToGetFirstDate;
    const firstDay = new Date(
      date2.getFullYear(),
      date2.getMonth(),
      dateOfFirstDayOfWeek
    );
    return this.getDatesBetweenTwoDates(
      firstDay,
      new Date(
        firstDay.getFullYear(),
        firstDay.getMonth(),
        firstDay.getDate() + 6
      )
    );
  }
  /**
   * Returns an array of the weeks that comprise a month
   *
   * @param {number} yyyy
   * @param {number} mm - zero indexed (January === 0)
   */
  getCalendarMonthSplitInWeeks(yyyy, mm) {
    const month = [];
    const selectedDate = new Date(yyyy, mm, 1);
    const firstDateOfMonth = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      1
    );
    const firstWeekOfMonth = this.getCalendarWeekDateObjects(firstDateOfMonth);
    month.push(firstWeekOfMonth);
    let isInMonth = true;
    let mondayOfWeekToPush = firstWeekOfMonth[0];
    const specifiedMonth = selectedDate.getMonth();
    while (isInMonth) {
      const newMonday = new Date(
        mondayOfWeekToPush.getFullYear(),
        mondayOfWeekToPush.getMonth(),
        mondayOfWeekToPush.getDate() + 7
      );
      if (newMonday.getMonth() === specifiedMonth) {
        month.push(this.getCalendarWeekDateObjects(newMonday));
        mondayOfWeekToPush = newMonday;
      } else {
        isInMonth = false;
      }
    }
    return month;
  }
  /**
   * Returns an array with the length of 12 dates,
   * one date for the first day of each month of the year
   */
  getCalendarYearMonths(year) {
    const yearList = [];
    let month = 0;
    while (month <= 11) {
      yearList.push(new Date(year, month, 1));
      month++;
    }
    return yearList;
  }
  getHourAndMinutesFromTimePoints(timePoints) {
    const time = timePoints.toString();
    let hour = "0";
    let minutes = "0";
    if (time.length === 4) {
      hour = time[0] + time[1];
      minutes = time[2] + time[3];
    } else if (time.length === 3) {
      hour = time[0];
      minutes = time[1] + time[2];
    }
    return {
      hour: +hour,
      minutes: +minutes
    };
  }
  /**
   * Given timePoints (0, 100, 200 etc.), this function returns
   * a localized string with the respective hour
   * (in en-US for example: 0 => 12 AM, 1600 => 4 PM )
   */
  getHourLocaleStringFromHourDigits(timePoints) {
    const { hour, minutes } = this.getHourAndMinutesFromTimePoints(timePoints);
    const hourLocaleString = new Date(
      2100,
      0,
      1,
      +hour,
      +minutes,
      0
    ).toLocaleTimeString(this.CALENDAR_LOCALE, {
      hour: "2-digit"
    });
    if (hourLocaleString[0] === "0") return hourLocaleString.substring(1);
    return hourLocaleString;
  }
  getLocalizedNameOfWeekday(date2, weekdayNameLength = "short") {
    return date2.toLocaleDateString(this.CALENDAR_LOCALE, {
      weekday: weekdayNameLength
    });
  }
  getLocalizedNameOfMonth(date2, monthNameLength = "short") {
    return date2.toLocaleDateString(this.CALENDAR_LOCALE, {
      month: monthNameLength
    });
  }
  getLocalizedDateString(date2) {
    return date2.toLocaleDateString(this.CALENDAR_LOCALE);
  }
  /**
   * Takes a date object, and creates a time string from it, in the format of
   * YYYY-MM-DD hh:mm
   */
  getDateTimeStringFromDate(date2, timeIsStartOrEndOfDay) {
    const y2 = date2.getFullYear();
    const m2 = date2.getMonth() + 1;
    const d2 = date2.getDate();
    const fullDate = `${y2}-${m2 >= 10 ? m2 : `0${m2}`}-${d2 >= 10 ? d2 : `0${d2}`}`;
    if (!timeIsStartOrEndOfDay) {
      const hour = date2.getHours();
      const minutes = date2.getMinutes();
      return `${fullDate} ${hour >= 10 ? hour : `0${hour}`}:${minutes >= 10 ? minutes : `0${minutes}`}`;
    }
    const fullTime = timeIsStartOrEndOfDay === "start" ? "00:00" : "23:59";
    return `${fullDate} ${fullTime}`;
  }
  getLocalizedTime(dateTimeString) {
    const {
      year,
      month,
      date: date2,
      hour,
      minutes
    } = this.getAllVariablesFromDateTimeString(dateTimeString);
    const d2 = new Date(year, month, date2, hour, minutes);
    return d2.toLocaleTimeString(this.CALENDAR_LOCALE, {
      hour: "numeric",
      minute: "numeric"
    });
  }
  getLocalizedHour(date2) {
    return date2.toLocaleTimeString(this.CALENDAR_LOCALE, { hour: "2-digit" });
  }
  getLocalizedTimeRange(start, end) {
    return `${this.getLocalizedTime(start)} - ${this.getLocalizedTime(end)}`;
  }
  /**
   * Returns numeric values for year, month, date, hour and minutes, given a dateTimeString
   * All variables are Date-Object compatible, meaning "month" is zero-indexed
   */
  getAllVariablesFromDateTimeString(dateTimeString) {
    return {
      year: +dateTimeString.substring(0, 4),
      month: +dateTimeString.substring(5, 7) - 1,
      date: +dateTimeString.substring(8, 10),
      hour: this.hourFrom(dateTimeString),
      minutes: this.minutesFrom(dateTimeString)
    };
  }
  dateIsToday(date2) {
    const {
      fullYear: yearToday,
      month: monthToday,
      date: dateToday
    } = new EDate();
    const {
      fullYear: dateYear,
      month: dateMonth,
      date: dateDate
    } = new EDate(date2);
    return yearToday === dateYear && monthToday === dateMonth && dateToday === dateDate;
  }
  dateIsInWeek(dateToCheck, week) {
    const { date: date2, month, fullYear } = new EDate(dateToCheck);
    for (const weekDay of week) {
      const dateIsSame = date2 === weekDay.getDate();
      const monthIsSame = month === weekDay.getMonth();
      const yearIsSame = fullYear === weekDay.getFullYear();
      if (dateIsSame && monthIsSame && yearIsSame) return true;
    }
    return false;
  }
  getDateStringFromDate(date2) {
    const yyyy = date2.getFullYear();
    const mm = date2.getMonth() + 1;
    const dd = date2.getDate();
    return `${yyyy}-${mm >= 10 ? mm : `0${mm}`}-${dd >= 10 ? dd : `0${dd}`}`;
  }
  addMinutesToDateTimeString(minutes, dateTimeString) {
    const {
      year: oldYear,
      month: oldMonth,
      date: oldDate,
      hour: oldHour,
      minutes: oldMinutes
    } = this.getAllVariablesFromDateTimeString(dateTimeString);
    const oldDateObject = new Date(oldYear, oldMonth, oldDate, oldHour, oldMinutes);
    const newDateObject = new Date(oldDateObject.getTime() + minutes * 6e4);
    return this.getDateTimeStringFromDate(newDateObject);
  }
  addDaysToDateTimeString(days, dateTimeString) {
    return this.addMinutesToDateTimeString(days * 1440, dateTimeString);
  }
  dateStringsHaveEqualDates(dateTimeString1, dateTimeString2) {
    const { year: year1, month: month1, date: date1 } = this.getAllVariablesFromDateTimeString(dateTimeString1);
    const { year: year2, month: month2, date: date2 } = this.getAllVariablesFromDateTimeString(dateTimeString2);
    return year1 === year2 && month1 === month2 && date1 === date2;
  }
  setDateToEndOfDay(date2) {
    return new Date(
      date2.getFullYear(),
      date2.getMonth(),
      date2.getDate(),
      23,
      59,
      59,
      999
    );
  }
  turnMinutesIntoPercentageOfHour(minutes) {
    const oneMinutePercentage = 100 / 60;
    const minutePoints = oneMinutePercentage * minutes;
    if (minutePoints < 10) return `0${minutePoints}`;
    return minutePoints.toString();
  }
  /**
   * Every hour between 'dayStart' and 'dayEnd' is 100, in this function referred to as 100 points
   * If an event starts 30 minutes after 'dayStart', it should have 50 pointsIntoDay
   * If a day consists of 4 hours (400 points), we then have to count
   * (50 / 400) * 100 = 12.5 => event starts after 12.5 percent of the day
   *
   * Result is supposed to be a number between 0 and 100, and is used for setting the CSS- top- and height-attributes for events
   */
  getPercentageOfDayFromDateTimeString(dateTimeString, dayStart, dayEnd) {
    const hour = this.hourFrom(dateTimeString);
    const hourPoints = hour * 100;
    const minutes = +dateTimeString.substring(14, 16);
    const minutesPoints = +this.turnMinutesIntoPercentageOfHour(+minutes);
    if (dayEnd > dayStart) {
      const pointsInDay2 = dayEnd - dayStart;
      const eventPoints2 = hourPoints + minutesPoints;
      const eventPointsIntoDay = eventPoints2 - dayStart;
      return eventPointsIntoDay / pointsInDay2 * 100;
    }
    const hourPointsInOriginalDay = DAY_TIME_POINT.TWELVE_AM - dayStart;
    const pointsInDay = hourPointsInOriginalDay + dayEnd;
    const eventPoints = hourPoints + minutesPoints;
    const pointsIntoDay = eventPoints >= dayStart ? eventPoints - dayStart : hourPointsInOriginalDay + eventPoints;
    return pointsIntoDay / pointsInDay * 100;
  }
  getTimeFromClick(clickOffsetY, weekHeight) {
    if (weekHeight <= 0) throw new Error("weekHeight cannot be a negative number");
    if (clickOffsetY < 0) throw new Error("clickOffsetY cannot be a negative number");
    const dayStartHour = this.DAY_START / 100;
    const hourHeight = weekHeight / this.HOURS_PER_DAY;
    const minutes = Math.floor(clickOffsetY % hourHeight / (hourHeight / 60));
    if (this.DAY_END <= this.DAY_START) {
      const dayEndHour = this.DAY_END / 100;
      const nightHeight = dayEndHour * hourHeight;
      const nightOffset = weekHeight - nightHeight;
      if (clickOffsetY > nightOffset) {
        const hour2 = Math.floor((clickOffsetY - nightOffset) / hourHeight);
        return `${this.doubleDigit(hour2)}:${this.doubleDigit(minutes)}`;
      }
    }
    const hour = Math.floor(clickOffsetY / hourHeight) + dayStartHour;
    return `${this.doubleDigit(hour)}:${this.doubleDigit(minutes)}`;
  }
  setSegmentOfDateTimeString(dateTimeString, segments) {
    if (segments.hour < 0 || segments.hour > 23) throw new Error("Invalid hour");
    const newHour = this.doubleDigit(segments.hour);
    dateTimeString = dateTimeString.replace(/\d{2}:/, `${newHour}:`);
    return dateTimeString;
  }
  isTrailingOrLeadingDate(date2, month) {
    const { month: dateMonth } = new EDate(date2);
    return month !== dateMonth;
  }
  static getTimePointsFromHour(boundary) {
    if (boundary < 0 || boundary > 24 || boundary % 1 !== 0) {
      throw new Error("Invalid day boundary");
    }
    if (boundary === 0) return boundary;
    return boundary * 100;
  }
  static getHourFromTimePoints(timePoints) {
    if (timePoints < 0 || timePoints > 2400 || timePoints % 100 !== 0) {
      throw new Error("Invalid time points");
    }
    if (timePoints === 0) return timePoints;
    return timePoints / 100;
  }
  getTimelineHours() {
    if (this.dayMode !== DAY_MODE.FLEXIBLE) {
      return this.ALL_HOURS.filter((hour) => {
        return hour >= this.DAY_START && hour < this.DAY_END;
      });
    }
    return [
      ...this.ALL_HOURS.filter((hour) => hour >= this.DAY_START),
      ...this.ALL_HOURS.filter((hour) => hour < this.DAY_END)
    ];
  }
  dateStringFrom(dateTimeString) {
    return dateTimeString.substring(0, 10);
  }
  timeStringFrom(dateTimeString) {
    return dateTimeString.substring(11, 16);
  }
  hourFrom(dateTimeString) {
    return +dateTimeString.substring(11, 13);
  }
  minutesFrom(dateTimeString) {
    return +dateTimeString.substring(14, 16);
  }
  areDaysConsecutive(dayOne, dayTwo) {
    const dayOnePlusOneDay = this.dateStringFrom(this.addDaysToDateTimeString(1, dayOne));
    return dayOnePlusOneDay === this.dateStringFrom(dayTwo);
  }
  setHourInDateTimeString(dateTimeString, hour) {
    const hourString = this.doubleDigit(hour);
    dateTimeString = dateTimeString.replace(/\d{2}:/, `${hourString}:`);
    return dateTimeString;
  }
  setMinutesInDateTimeString(dateTimeString, minutes) {
    const minutesString = this.doubleDigit(minutes);
    dateTimeString = dateTimeString.replace(/:\d{2}/, `:${minutesString}`);
    return dateTimeString;
  }
  getDateTimeStringDayBoundariesFrom(dateString) {
    if (this.DAY_END <= this.DAY_START) {
      const nextDay = this.addDaysToDateTimeString(1, dateString);
      const endOfDay2 = this.setHourInDateTimeString(nextDay, this.getHourAndMinutesFromTimePoints(this.DAY_END).hour);
      const startOfDay2 = this.setHourInDateTimeString(dateString, this.getHourAndMinutesFromTimePoints(this.DAY_START).hour);
      return { start: startOfDay2, end: endOfDay2 };
    }
    const startOfDay = this.setHourInDateTimeString(dateString, this.getHourAndMinutesFromTimePoints(this.DAY_START).hour);
    let endOfDay;
    if (this.DAY_END === DAY_TIME_POINT.TWELVE_AM) {
      endOfDay = this.setHourInDateTimeString(dateString, 23);
      endOfDay = this.setMinutesInDateTimeString(endOfDay, 59);
    } else {
      endOfDay = this.setHourInDateTimeString(dateString, this.getHourAndMinutesFromTimePoints(this.DAY_END).hour);
    }
    return { start: startOfDay, end: endOfDay };
  }
  doubleDigit(number2) {
    if (number2 < 0 || number2 > 60) throw new Error("Invalid number. This is not a valid hour or minute");
    return number2 < 10 ? `0${number2}` : String(number2);
  }
}
class EventPosition extends Time {
  /**
   * Yields a full calendar week, with all full-day events positioned in it
   */
  positionFullDayEventsInWeek(weekStart, weekEnd, events) {
    const eventsWithJSDates = events.map((scheduleEvent) => {
      const { year: startYear, month: startMonth, date: startDate } = this.getAllVariablesFromDateTimeString(scheduleEvent.time.start);
      const { year: endYear, month: endMonth, date: endDate } = this.getAllVariablesFromDateTimeString(scheduleEvent.time.end);
      scheduleEvent.timeJS = {
        start: new Date(startYear, startMonth, startDate),
        end: new Date(endYear, endMonth, endDate)
      };
      return scheduleEvent;
    }).sort((a2, b2) => {
      if (a2.time.start < b2.time.start) return -1;
      if (a2.time.start > b2.time.start) return 1;
      return 0;
    });
    const allDatesOfWeek = this.getDatesBetweenTwoDates(weekStart, weekEnd);
    const week = allDatesOfWeek.map((d2) => ({ date: d2 }));
    for (const scheduleEvent of eventsWithJSDates) {
      for (const [dayIndex, day] of week.entries()) {
        const thisDayDateString = this.getDateStringFromDate(day.date);
        if (this.getDateStringFromDate(scheduleEvent.timeJS.start) <= thisDayDateString && this.getDateStringFromDate(scheduleEvent.timeJS.end) >= thisDayDateString) {
          let levelToStartOn = 1;
          while (typeof week[dayIndex][`level${levelToStartOn}`] !== "undefined") {
            levelToStartOn++;
          }
          let eventNDays = Math.ceil((scheduleEvent.timeJS.end.getTime() - day.date.getTime()) / this.MS_PER_DAY) + 1;
          const remainingDaysOfWeek = week.length - dayIndex;
          if (eventNDays > remainingDaysOfWeek) eventNDays = remainingDaysOfWeek;
          week[dayIndex][`level${levelToStartOn}`] = {
            ...scheduleEvent,
            nDays: eventNDays
            // Denotes the number of days to display in the week, not the actual number of days
          };
          for (let i2 = 1; i2 < eventNDays; i2++) {
            week[dayIndex + i2][`level${levelToStartOn}`] = "blocked";
          }
          break;
        }
      }
    }
    const weekWithSortedLevelsInDays = [];
    for (const day of week) {
      weekWithSortedLevelsInDays.push(Object.keys(day).sort().reduce(
        (obj, key) => {
          obj[key] = day[key];
          return obj;
        },
        {}
      ));
    }
    return weekWithSortedLevelsInDays;
  }
  positionFullDayEventsInMonth(calendarMonth, fullDayEvents) {
    const newMonth = [];
    const flatMonth = calendarMonth.flat();
    const monthMap = /* @__PURE__ */ new Map();
    flatMonth.forEach((day) => monthMap.set(this.dateStringFrom(day.dateTimeString), day));
    fullDayEvents = fullDayEvents.sort((a2, b2) => {
      if (a2.time.start < b2.time.start) return 1;
      if (a2.time.start > b2.time.start) return -1;
      return 0;
    });
    for (const fullDayEvent of fullDayEvents) {
      const { year: startYear, month: startMonth, date: startDate } = this.getAllVariablesFromDateTimeString(fullDayEvent.time.start);
      const { year: endYear, month: endMonth, date: endDate } = this.getAllVariablesFromDateTimeString(fullDayEvent.time.end);
      const allDatesOfEvent = this.getDatesBetweenTwoDates(
        new Date(startYear, startMonth, startDate),
        new Date(endYear, endMonth, endDate)
      );
      for (const date2 of allDatesOfEvent) {
        const dateString = this.getDateStringFromDate(date2);
        const dateInMap = monthMap.get(dateString);
        if (dateInMap) {
          monthMap.set(dateString, {
            ...dateInMap,
            // Since we're iterating over the fullDayEvents sorted backwards, the earliest events will end up first (which is the wanted behavior)
            events: [fullDayEvent, ...dateInMap.events]
          });
        }
      }
    }
    let weekIterator = 0;
    monthMap.forEach((day) => {
      if (!newMonth.length) {
        newMonth.push([day]);
      } else if (newMonth[weekIterator] && newMonth[weekIterator].length < 7) {
        newMonth[weekIterator].push(day);
      } else if (newMonth[weekIterator] && newMonth[weekIterator].length === 7) {
        newMonth.push([day]);
        weekIterator++;
      }
    });
    return newMonth;
  }
}
const calendarDomRectForVitest = {
  top: 26,
  right: 911,
  bottom: 728,
  left: 8
};
const EVENT_FLYOUT_WIDTH = 400;
class EventFlyoutPosition {
  calculateFlyoutPosition(eventElementDOMRect, flyoutDimensions, calendarDomRectParam = null) {
    const calendarDomRect = calendarDomRectParam || calendarDomRectForVitest;
    const spaceTop = eventElementDOMRect.top - calendarDomRect.top;
    const spaceRight = calendarDomRect.right - eventElementDOMRect.right;
    const spaceBottom = calendarDomRect.bottom - eventElementDOMRect.bottom;
    const spaceLeft = eventElementDOMRect.left - calendarDomRect.left;
    const flyoutNeededWidth = flyoutDimensions.width + 10;
    const topWhenSpaceToBottomIsNegative = spaceBottom < 0 ? calendarDomRect.bottom - flyoutDimensions.height - 10 : null;
    const topWhenSpaceTopIsNegative = spaceTop < 0 ? calendarDomRect.top + 10 : null;
    if (spaceBottom > flyoutDimensions.height && spaceRight > flyoutNeededWidth) {
      return {
        top: topWhenSpaceTopIsNegative || Math.round(eventElementDOMRect.top),
        left: Math.round(eventElementDOMRect.right) + 10
      };
    }
    if (spaceTop > flyoutDimensions.height && spaceRight > flyoutNeededWidth) {
      return {
        top: topWhenSpaceToBottomIsNegative || Math.round(eventElementDOMRect.bottom) - flyoutDimensions.height,
        left: Math.round(eventElementDOMRect.right) + 10
      };
    }
    if (spaceLeft > flyoutNeededWidth && spaceBottom > flyoutDimensions.height) {
      return {
        top: topWhenSpaceTopIsNegative || eventElementDOMRect.top,
        left: Math.round(
          eventElementDOMRect.left - (flyoutDimensions.width + 10)
        )
      };
    }
    if (spaceLeft > flyoutNeededWidth && spaceTop > flyoutDimensions.height) {
      return {
        top: topWhenSpaceToBottomIsNegative || Math.round(eventElementDOMRect.bottom - flyoutDimensions.height),
        left: Math.round(
          eventElementDOMRect.left - (flyoutDimensions.width + 10)
        )
      };
    }
    if (spaceBottom < flyoutDimensions.height) {
      return { top: calendarDomRect.bottom - flyoutDimensions.height, left: null };
    }
    return { top: eventElementDOMRect.top, left: null };
  }
}
const _hoisted_1$12 = {
  key: 0,
  class: "event-flyout__relative-wrapper"
};
const _hoisted_2$N = { class: "event-flyout__menu" };
const _hoisted_3$F = {
  key: 0,
  class: "event-flyout__menu-editable"
};
const _hoisted_4$r = { class: "event-flyout__menu-close" };
const _hoisted_5$o = {
  key: 0,
  class: "event-flyout__info-wrapper"
};
const _hoisted_6$k = {
  key: 0,
  class: "event-flyout__row is-title"
};
const _hoisted_7$f = {
  key: 1,
  class: "event-flyout__row is-time"
};
const _hoisted_8$9 = {
  key: 2,
  class: "event-flyout__row is-location"
};
const _hoisted_9$7 = {
  key: 3,
  class: "event-flyout__row is-with"
};
const _hoisted_10$7 = {
  key: 4,
  class: "event-flyout__row is-topic"
};
const _hoisted_11$7 = {
  key: 5,
  class: "event-flyout__row is-description"
};
const _hoisted_12$5 = ["innerHTML"];
const _sfc_main$1c = /* @__PURE__ */ defineComponent({
  __name: "EventFlyout",
  props: {
    calendarEventProp: {
      type: Object,
      default: () => ({})
    },
    eventElement: {
      type: Object,
      default: null
    },
    time: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },
  emits: ["hide", "editEvent", "deleteEvent"],
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "c7702184": flyoutWidth
    }));
    const props2 = __props;
    const emit2 = __emit;
    const eventFlyoutPositionHelper = new EventFlyoutPosition();
    const isVisible = ref(false);
    const top2 = ref(0);
    const insetInlineEnd = ref(0);
    const calendarEvent = ref(props2.calendarEventProp);
    const flyoutWidth = `${EVENT_FLYOUT_WIDTH}px`;
    const colors = EVENT_COLORS;
    const icons = {
      user: "user",
      description: "comment",
      trash: "delete",
      edit: "edit",
      times: "close",
      topic: "help",
      location: "location_on"
    };
    const getEventTime = computed(() => {
      if (!calendarEvent.value || !calendarEvent.value.time) return null;
      const eventType = Helpers.getEventType(calendarEvent.value, props2.time);
      if (["MULTI_DAY_TIMED"].includes(eventType)) {
        const startLocalizedString = `${getDateFromDateString(
          calendarEvent.value.time.start
        )} ${props2.time.getLocalizedTime(calendarEvent.value.time.start)}`;
        const endLocalizedString = `${getDateFromDateString(
          calendarEvent.value.time.end
        )} ${props2.time.getLocalizedTime(calendarEvent.value.time.end)}`;
        return `${startLocalizedString} - ${endLocalizedString}`;
      }
      if (["SINGLE_DAY_FULL_DAY", "MULTI_DAY_FULL_DAY"].includes(eventType)) {
        const startDate = getDateFromDateString(calendarEvent.value.time.start);
        const endDate = getDateFromDateString(calendarEvent.value.time.end);
        if (startDate === endDate) return startDate;
        return `${startDate} - ${endDate}`;
      }
      const dateString = getDateFromDateString(calendarEvent.value.time.start);
      const timeString = props2.time.getLocalizedTimeRange(
        calendarEvent.value.time.start,
        calendarEvent.value.time.end
      );
      return `${dateString} ⋅ ${timeString}`;
    });
    const eventFlyoutInlineStyles = computed(() => {
      if (typeof top2.value === "number" && !insetInlineEnd.value) {
        return {
          top: `${top2.value}px`,
          left: "50%",
          position: "fixed",
          transform: "translateX(-50%)"
        };
      }
      return {
        top: `${top2.value}px`,
        insetInlineEnd: `${insetInlineEnd.value}px`,
        position: "fixed"
      };
    });
    const isEditable = computed(() => {
      var _a;
      return ((_a = props2.calendarEventProp) == null ? void 0 : _a.isEditable) || false;
    });
    const eventBackgroundColor = computed(() => {
      var _a, _b, _c;
      if (((_a = calendarEvent.value) == null ? void 0 : _a.colorScheme) && ((_b = props2.config.style) == null ? void 0 : _b.colorSchemes) && props2.config.style.colorSchemes[calendarEvent.value.colorScheme]) {
        return props2.config.style.colorSchemes[calendarEvent.value.colorScheme].backgroundColor;
      }
      return colors[((_c = calendarEvent.value) == null ? void 0 : _c.color) || "blue"];
    });
    function setFlyoutPosition() {
      var _a, _b;
      const calendar = (_a = props2.eventElement) == null ? void 0 : _a.closest(".calendar-root");
      const flyout = document.querySelector(".event-flyout");
      if (!props2.eventElement) return;
      const flyoutPosition = eventFlyoutPositionHelper.calculateFlyoutPosition(
        (_b = props2.eventElement) == null ? void 0 : _b.getBoundingClientRect(),
        {
          height: (flyout == null ? void 0 : flyout.clientHeight) || 300,
          width: (flyout == null ? void 0 : flyout.clientWidth) || 0
        },
        calendar ? calendar.getBoundingClientRect() : null
      );
      top2.value = typeof (flyoutPosition == null ? void 0 : flyoutPosition.top) === "number" ? flyoutPosition.top : null;
      insetInlineEnd.value = typeof (flyoutPosition == null ? void 0 : flyoutPosition.left) === "number" ? flyoutPosition.left : null;
    }
    function editEvent() {
      var _a;
      emit2("editEvent", (_a = calendarEvent.value) == null ? void 0 : _a.id);
      closeFlyout();
    }
    function deleteEvent() {
      var _a;
      emit2("deleteEvent", (_a = calendarEvent.value) == null ? void 0 : _a.id);
      closeFlyout();
    }
    function closeFlyout() {
      isVisible.value = false;
      setTimeout(() => {
        emit2("hide");
      }, 100);
    }
    function getDateFromDateString(dateString) {
      const { year, month, date: date2 } = props2.time.getAllVariablesFromDateTimeString(dateString);
      return new Date(year, month, date2).toLocaleDateString(
        props2.time.CALENDAR_LOCALE,
        {
          year: "numeric",
          month: "long",
          day: "numeric"
        }
      );
    }
    function closeFlyoutOnClickOutside(e) {
      var _a;
      const flyout = document.querySelector(".event-flyout");
      if (!flyout || !isVisible.value) return;
      const isClickOutside = !flyout.contains(e.target);
      const isClickOnEvent = !!e.target.closest(".is-event");
      const closeOnClickOutside = ((_a = props2.config.eventDialog) == null ? void 0 : _a.closeOnClickOutside) ?? true;
      if (isVisible.value && isClickOutside && !isClickOnEvent && closeOnClickOutside) {
        closeFlyout();
      }
    }
    watch(
      () => props2.calendarEventProp,
      (value) => {
        setTimeout(() => {
          calendarEvent.value = value;
          isVisible.value = !!value;
          nextTick(() => {
            setFlyoutPosition();
          });
        }, 10);
      },
      { deep: true }
    );
    onMounted(() => {
      document.addEventListener("click", closeFlyoutOnClickOutside);
    });
    onBeforeUnmount(() => {
      document.removeEventListener("click", closeFlyoutOnClickOutside);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["event-flyout p-05 bg-white", { "is-visible": isVisible.value, "is-not-editable": !isEditable.value }]),
        style: normalizeStyle(eventFlyoutInlineStyles.value)
      }, [
        !__props.config.eventDialog || !__props.config.eventDialog.isCustom ? (openBlock(), createElementBlock("div", _hoisted_1$12, [
          createElementVNode("div", _hoisted_2$N, [
            isEditable.value ? (openBlock(), createElementBlock("span", _hoisted_3$F, [
              createVNode(unref(_sfc_main$s), {
                class: "event-flyout__menu-item is-edit-icon",
                icon: icons.edit,
                onClick: editEvent
              }, null, 8, ["icon"]),
              createVNode(unref(_sfc_main$s), {
                class: "event-flyout__menu-item is-trash-icon",
                icon: icons.trash,
                onClick: deleteEvent
              }, null, 8, ["icon"])
            ])) : createCommentVNode("", true),
            createElementVNode("span", _hoisted_4$r, [
              createVNode(unref(_sfc_main$s), {
                class: "event-flyout__menu-item is-times-icon",
                icon: icons.times,
                onClick: closeFlyout
              }, null, 8, ["icon"])
            ])
          ]),
          calendarEvent.value ? (openBlock(), createElementBlock("div", _hoisted_5$o, [
            calendarEvent.value.title ? (openBlock(), createElementBlock("div", _hoisted_6$k, [
              createElementVNode("div", {
                class: "event-flyout__color-icon",
                style: normalizeStyle({ backgroundColor: eventBackgroundColor.value })
              }, null, 4),
              createTextVNode(" " + toDisplayString(calendarEvent.value.title), 1)
            ])) : createCommentVNode("", true),
            calendarEvent.value.time ? (openBlock(), createElementBlock("div", _hoisted_7$f, toDisplayString(getEventTime.value), 1)) : createCommentVNode("", true),
            calendarEvent.value.location ? (openBlock(), createElementBlock("div", _hoisted_8$9, [
              createVNode(unref(_sfc_main$s), {
                icon: icons.location
              }, null, 8, ["icon"]),
              createTextVNode(" " + toDisplayString(calendarEvent.value.location), 1)
            ])) : createCommentVNode("", true),
            calendarEvent.value.with ? (openBlock(), createElementBlock("div", _hoisted_9$7, [
              createVNode(unref(_sfc_main$s), {
                icon: icons.user
              }, null, 8, ["icon"]),
              createTextVNode(" " + toDisplayString(calendarEvent.value.with), 1)
            ])) : createCommentVNode("", true),
            calendarEvent.value.topic ? (openBlock(), createElementBlock("div", _hoisted_10$7, [
              createVNode(unref(_sfc_main$s), {
                icon: icons.topic
              }, null, 8, ["icon"]),
              createTextVNode(" " + toDisplayString(calendarEvent.value.topic), 1)
            ])) : createCommentVNode("", true),
            calendarEvent.value.description ? (openBlock(), createElementBlock("div", _hoisted_11$7, [
              createVNode(unref(_sfc_main$s), {
                icon: icons.description
              }, null, 8, ["icon"]),
              createElementVNode("p", {
                innerHTML: calendarEvent.value.description
              }, null, 8, _hoisted_12$5)
            ])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ])) : renderSlot(_ctx.$slots, "default", {
          key: 1,
          eventDialogData: calendarEvent.value,
          closeEventDialog: closeFlyout
        })
      ], 6);
    };
  }
});
const _hoisted_1$11 = {
  key: 0,
  class: "calendar-month__event"
};
const _hoisted_2$M = ["id", "draggable"];
const _hoisted_3$E = ["id", "draggable"];
const _hoisted_4$q = {
  key: 0,
  class: "calendar-month__event-time opacity-6 flex-shrink-0"
};
const _hoisted_5$n = { class: "calendar-month__event-title1 white-space ellipsis" };
const eventIdPrefix = "calendar-month__event-";
const _sfc_main$1b = /* @__PURE__ */ defineComponent({
  __name: "Event",
  props: {
    time: {
      type: Object,
      required: true
    },
    calendarEvent: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    day: {
      type: Object,
      required: true
    }
  },
  emits: ["eventWasClicked"],
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "1772761d": eventBackgroundColor.value
    }));
    const props2 = __props;
    const emit2 = __emit;
    const colors = ref(EVENT_COLORS);
    const eventBackgroundColor = ref("");
    const isCustomEvent = computed(() => {
      if (Array.isArray(props2.calendarEvent.isCustom)) {
        return props2.calendarEvent.isCustom.includes("month");
      }
      return props2.calendarEvent.isCustom || false;
    });
    const eventTimeStart = computed(() => {
      return DATE_TIME_STRING_PATTERN.test(props2.calendarEvent.time.start) ? props2.time.getLocalizedTime(props2.calendarEvent.time.start) : null;
    });
    const elementId = computed(() => eventIdPrefix + props2.calendarEvent.id + props2.time.dateStringFrom(props2.day.dateTimeString));
    const elementDraggableAttribute = computed(() => {
      const {
        year: startYear,
        month: startMonth,
        date: startDate
      } = props2.time.getAllVariablesFromDateTimeString(props2.calendarEvent.time.start);
      const {
        year: endYear,
        month: endMonth,
        date: endDate
      } = props2.time.getAllVariablesFromDateTimeString(props2.calendarEvent.time.end);
      const eventIsSingleDay = startYear === endYear && startMonth === endMonth && startDate === endDate;
      const dragAndDropIsDisabled = props2.calendarEvent.disableDnD && props2.calendarEvent.disableDnD.includes("month");
      return props2.calendarEvent.isEditable && eventIsSingleDay && !dragAndDropIsDisabled ? true : void 0;
    });
    function setColors() {
      var _a;
      if (props2.calendarEvent.colorScheme && ((_a = props2.config.style) == null ? void 0 : _a.colorSchemes) && props2.config.style.colorSchemes[props2.calendarEvent.colorScheme]) {
        return eventBackgroundColor.value = props2.config.style.colorSchemes[props2.calendarEvent.colorScheme].backgroundColor;
      }
      if (props2.calendarEvent.color) {
        return eventBackgroundColor.value = colors.value[props2.calendarEvent.color];
      }
      return eventBackgroundColor.value = colors.value.blue;
    }
    function handleClickOnEvent() {
      const eventElement = document.getElementById(elementId.value);
      emit2("eventWasClicked", {
        clickedEvent: props2.calendarEvent,
        eventElement
      });
    }
    function handleDragStart(dragEvent) {
      if (!dragEvent || !dragEvent.dataTransfer) return;
      dragEvent.dataTransfer.effectAllowed = "move";
      dragEvent.dataTransfer.setData("json", JSON.stringify(props2.calendarEvent));
    }
    onMounted(() => {
      setColors();
    });
    return (_ctx, _cache) => {
      return __props.config.isSmall ? (openBlock(), createElementBlock("div", _hoisted_1$11)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        isCustomEvent.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          id: elementId.value,
          class: normalizeClass(["is-event", { grab: elementDraggableAttribute.value }]),
          "data-ref": "custom-event",
          draggable: elementDraggableAttribute.value,
          onDragstart: handleDragStart,
          onClick: handleClickOnEvent
        }, [
          renderSlot(_ctx.$slots, "monthEvent", { eventData: __props.calendarEvent }, void 0, true)
        ], 42, _hoisted_2$M)) : (openBlock(), createElementBlock("div", {
          key: 1,
          id: elementId.value,
          "data-ref": "default-event",
          class: normalizeClass(["calendar-month__event hover is-event flex align-items-center overflow-hidden radius-05 txt10 px-025 pointer user-select-none gap-025 bg-white", { "is-draggable": elementDraggableAttribute.value }]),
          draggable: elementDraggableAttribute.value,
          onDragstart: handleDragStart,
          onClick: handleClickOnEvent
        }, [
          _cache[0] || (_cache[0] = createElementVNode("span", { class: "calendar-month__event-color round flex-shrink-0" }, null, -1)),
          eventTimeStart.value && !__props.calendarEvent.originalEvent ? (openBlock(), createElementBlock("span", _hoisted_4$q, toDisplayString(eventTimeStart.value), 1)) : createCommentVNode("", true),
          createElementVNode("span", _hoisted_5$n, toDisplayString(__props.calendarEvent.title), 1)
        ], 42, _hoisted_3$E))
      ], 64));
    };
  }
});
const Event = /* @__PURE__ */ _export_sfc(_sfc_main$1b, [["__scopeId", "data-v-16d8079e"]]);
const _hoisted_1$10 = ["id"];
const _hoisted_2$L = { class: "w-100p flex justify-content-end txt14 p-025 m_h-100p" };
const _hoisted_3$D = { class: "calendar-month_events" };
const _hoisted_4$p = {
  key: 1,
  class: "space-reserver"
};
const _sfc_main$1a = /* @__PURE__ */ defineComponent({
  __name: "Day",
  props: {
    config: {
      type: Object,
      required: true
    },
    time: {
      type: Object,
      required: true
    },
    day: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["eventWasClicked", "eventWasDragged", "updatedPeriod", "dateWasClicked", "dayWasSelected"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const isActiveDroppable = ref(false);
    const canBeDropped = computed(() => isActiveDroppable.value);
    const hideLeadingAndTrailingDate = computed(
      () => {
        var _a;
        return props2.day.isTrailingOrLeadingDate === true && ((_a = props2.config.month) == null ? void 0 : _a.showTrailingAndLeadingDates) === false;
      }
    );
    const isToday = computed(() => {
      const { year, month, date: date2 } = props2.time.getAllVariablesFromDateTimeString(props2.day.dateTimeString);
      return props2.time.dateIsToday(new Date(year, month, date2));
    });
    function getMoreEvents() {
      const { date: date2, month, year } = props2.time.getAllVariablesFromDateTimeString(props2.day.dateTimeString);
      const selectedDate = new Date(year, month, date2);
      const week = props2.time.getCalendarWeekDateObjects(selectedDate);
      const start = week[0];
      const end = week[6];
      emit2("updatedPeriod", { start, end, selectedDate });
    }
    function handleDragLeave() {
      isActiveDroppable.value = false;
    }
    function handleDragEnd(mouseEvent) {
      isActiveDroppable.value = false;
      mouseEvent.stopPropagation();
    }
    function handleDrop(dropEvent) {
      isActiveDroppable.value = false;
      dropEvent.stopPropagation();
      if (!dropEvent || !dropEvent.dataTransfer) return;
      const calendarEvent = JSON.parse(dropEvent.dataTransfer.getData("json"));
      const eventDroppedOnSameDay = props2.time.dateStringsHaveEqualDates(
        calendarEvent.time.start,
        props2.time.dateStringFrom(props2.day.dateTimeString)
      );
      if (eventDroppedOnSameDay) return;
      calendarEvent.time.start = calendarEvent.time.start.replace(
        /^\d{4}-\d{2}-\d{2}/,
        props2.time.dateStringFrom(props2.day.dateTimeString)
      );
      calendarEvent.time.end = calendarEvent.time.end.replace(
        /^\d{4}-\d{2}-\d{2}/,
        props2.time.dateStringFrom(props2.day.dateTimeString)
      );
      emit2("eventWasDragged", calendarEvent);
    }
    function handleDragOver(e) {
      isActiveDroppable.value = true;
      e.preventDefault();
      return false;
    }
    function emitDayWasClicked() {
      emit2("dateWasClicked", props2.time.dateStringFrom(props2.day.dateTimeString));
      if (props2.config.isSmall) emit2("dayWasSelected", props2.day);
    }
    return (_ctx, _cache) => {
      return !hideLeadingAndTrailingDate.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        id: `day-${__props.time.dateStringFrom(__props.day.dateTimeString)}`,
        class: normalizeClass(["calendar-month__weekday", {
          "is-droppable": canBeDropped.value,
          "color-gray": __props.day.isTrailingOrLeadingDate,
          "is-selected": __props.isSelected,
          "is-today": isToday.value
        }]),
        onClick: withModifiers(emitDayWasClicked, ["self"]),
        onDragleave: handleDragLeave,
        onDragover: handleDragOver,
        onDrop: handleDrop,
        onDragend: handleDragEnd
      }, [
        renderSlot(_ctx.$slots, "dayCell", { dayData: __props.day }, () => [
          createElementVNode("div", _hoisted_2$L, [
            createElementVNode("p", {
              class: "calendar-month__day-date ms-auto flex aspect-ratio-1 w-30px h-30px justify-content-center m_mx-auto",
              onClick: emitDayWasClicked
            }, toDisplayString(__props.day.dateTimeString.substring(8, 10).startsWith("0") ? __props.day.dateTimeString.substring(9, 10) : __props.day.dateTimeString.substring(8, 10)), 1)
          ]),
          createElementVNode("div", _hoisted_3$D, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.day.events, (calendarEvent, index2) => {
              return openBlock(), createElementBlock(Fragment, { key: index2 }, [
                index2 < 3 ? (openBlock(), createBlock(Event, {
                  key: calendarEvent.id,
                  "calendar-event": calendarEvent,
                  config: __props.config,
                  time: __props.time,
                  day: __props.day,
                  onEventWasClicked: _cache[0] || (_cache[0] = ($event) => emit2("eventWasClicked", $event.clickedEvent))
                }, {
                  monthEvent: withCtx((p2) => [
                    renderSlot(_ctx.$slots, "monthEvent", {
                      eventData: p2.eventData
                    }, void 0, true)
                  ]),
                  _: 2
                }, 1032, ["calendar-event", "config", "time", "day"])) : createCommentVNode("", true)
              ], 64);
            }), 128)),
            __props.day.events.length >= 4 ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "calendar-month__weekday-more",
              onClick: getMoreEvents
            }, toDisplayString(unref(getLanguage)(unref(languageKeys).moreEvents, __props.time.CALENDAR_LOCALE)), 1)) : createCommentVNode("", true)
          ])
        ], true)
      ], 42, _hoisted_1$10)) : (openBlock(), createElementBlock("div", _hoisted_4$p));
    };
  }
});
const Day$1 = /* @__PURE__ */ _export_sfc(_sfc_main$1a, [["__scopeId", "data-v-4b49a3b2"]]);
const _hoisted_1$$ = { class: "txt12 normal block color-black pb-025" };
const _sfc_main$19 = /* @__PURE__ */ defineComponent({
  __name: "WeekDay",
  props: {
    day: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", _hoisted_1$$, toDisplayString(_ctx.day.dayName), 1);
    };
  }
});
const _hoisted_1$_ = { class: "calendar-month relative column w-100p h-100p overflow-y flex flex-stretch" };
const _hoisted_2$K = { class: "flex space-between" };
const _hoisted_3$C = { class: "calendar-month__weeks h-100p flex-grow flex flex-stretch column space-between" };
const _hoisted_4$o = {
  key: 0,
  class: "calendar-month__day_events w-100p pt-1 m_pb-1"
};
const _sfc_main$18 = /* @__PURE__ */ defineComponent({
  __name: "Month",
  props: {
    config: {
      type: Object,
      required: true
    },
    time: {
      type: Object,
      required: true
    },
    period: {
      type: Object,
      required: true
    },
    eventsProp: {
      type: Array,
      default: () => []
    }
  },
  emits: ["editEvent", "deleteEvent", "updatedPeriod", "eventWasClicked", "eventWasDragged", "dateWasClicked"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const EventPositionHelper = new EventPosition();
    const month = ref([]);
    const selectedEvent = ref(null);
    const selectedEventElement = ref(null);
    const events = ref(props2.eventsProp);
    const fullDayEvents = ref([]);
    const selectedDay = ref(null);
    function initMonth() {
      month.value = [];
      sortOutFullDayEvents();
      setMonth();
      if (props2.config.isSmall) setInitialSelectedDay();
    }
    function setMonth() {
      const { month: currentMonth, fullYear } = new EDate(props2.period.selectedDate);
      const calendarMonth = props2.time.getCalendarMonthSplitInWeeks(
        fullYear,
        currentMonth
      );
      const monthWithEvents = calendarMonth.map((week) => {
        return week.map((day) => {
          const dateTimeString = props2.time.getDateTimeStringFromDate(day);
          const dayEvents = events.value.filter((event) => {
            return props2.time.dateStringsHaveEqualDates(event.time.start, dateTimeString);
          });
          return {
            isTrailingOrLeadingDate: props2.time.isTrailingOrLeadingDate(day, currentMonth),
            dayName: props2.time.getLocalizedNameOfWeekday(day),
            dateTimeString: props2.time.getDateTimeStringFromDate(day),
            events: dayEvents
          };
        });
      });
      month.value = EventPositionHelper.positionFullDayEventsInMonth(
        monthWithEvents,
        fullDayEvents.value
      );
    }
    function sortOutFullDayEvents() {
      const timedEvents = [];
      const fullDayEventsArray = [];
      for (const calendarEvent of events.value) {
        if (Helpers.getEventType(calendarEvent, props2.time) === "SINGLE_DAY_TIMED") {
          timedEvents.push(calendarEvent);
        } else {
          fullDayEventsArray.push(calendarEvent);
        }
      }
      events.value = timedEvents;
      fullDayEvents.value = fullDayEventsArray;
    }
    function handleClickOnEvent(event) {
      emit2("eventWasClicked", event);
      selectedEventElement.value = event.eventElement;
      selectedEvent.value = event.clickedEvent;
    }
    function handleEventWasDragged(calendarEvent) {
      emit2("eventWasDragged", calendarEvent);
      const newEvents = [...events.value, ...fullDayEvents.value].filter(
        (e) => e.id !== calendarEvent.id
      );
      newEvents.push(calendarEvent);
      events.value = [];
      fullDayEvents.value = [];
      events.value = newEvents;
      initMonth();
    }
    function setInitialSelectedDay() {
      const selectedDayDateString = props2.time.getDateStringFromDate(props2.period.selectedDate);
      selectedDay.value = month.value.flat().find((day) => {
        return props2.time.dateStringFrom(day.dateTimeString) === selectedDayDateString;
      }) || null;
    }
    onMounted(() => {
      initMonth();
    });
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", _hoisted_1$_, [
        createElementVNode("div", _hoisted_2$K, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(month.value[0], (day, dayIndex) => {
            return openBlock(), createBlock(_sfc_main$19, {
              key: dayIndex,
              class: "txt-center flex-shrink flex-grow",
              config: __props.config,
              day,
              time: __props.time
            }, null, 8, ["config", "day", "time"]);
          }), 128))
        ]),
        createElementVNode("div", _hoisted_3$C, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(month.value, (week, weekIndex) => {
            return openBlock(), createElementBlock("div", {
              key: weekIndex,
              class: "calendar-month__week"
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(week, (day, dayIndex) => {
                var _a2;
                return openBlock(), createBlock(Day$1, {
                  key: dayIndex,
                  config: __props.config,
                  day,
                  time: __props.time,
                  "is-selected": ((_a2 = selectedDay.value) == null ? void 0 : _a2.dateTimeString) === day.dateTimeString,
                  onEventWasDragged: handleEventWasDragged,
                  onDateWasClicked: _cache[0] || (_cache[0] = ($event) => emit2("dateWasClicked", $event)),
                  onDayWasSelected: _cache[1] || (_cache[1] = ($event) => selectedDay.value = $event),
                  onUpdatedPeriod: _cache[2] || (_cache[2] = ($event) => emit2("updatedPeriod", $event))
                }, {
                  monthEvent: withCtx(({ eventData }) => [
                    renderSlot(_ctx.$slots, "monthEvent", { eventData })
                  ]),
                  dayCell: withCtx(({ dayData }) => [
                    renderSlot(_ctx.$slots, "dayCell", { dayData })
                  ]),
                  _: 2
                }, 1032, ["config", "day", "time", "is-selected"]);
              }), 128))
            ]);
          }), 128))
        ]),
        !(((_a = __props.config.month) == null ? void 0 : _a.showEventsOnMobileView) === false) ? (openBlock(), createElementBlock("div", _hoisted_4$o, [
          selectedDay.value ? (openBlock(), createBlock(AgendaEvents, {
            key: 0,
            config: __props.config,
            time: __props.time,
            day: selectedDay.value,
            onEventWasClicked: handleClickOnEvent
          }, null, 8, ["config", "time", "day"])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        !__props.config.eventDialog || !__props.config.eventDialog.isDisabled ? (openBlock(), createBlock(_sfc_main$1c, {
          key: 1,
          "calendar-event-prop": selectedEvent.value,
          "event-element": selectedEventElement.value,
          time: __props.time,
          config: __props.config,
          onHide: _cache[3] || (_cache[3] = ($event) => selectedEvent.value = null),
          onEditEvent: _cache[4] || (_cache[4] = ($event) => emit2("editEvent", $event)),
          onDeleteEvent: _cache[5] || (_cache[5] = ($event) => emit2("deleteEvent", $event))
        }, {
          default: withCtx((p2) => [
            renderSlot(_ctx.$slots, "eventDialog", {
              eventDialogData: p2.eventDialogData,
              closeEventDialog: p2.closeEventDialog
            })
          ]),
          _: 3
        }, 8, ["calendar-event-prop", "event-element", "time", "config"])) : createCommentVNode("", true)
      ]);
    };
  }
});
class EventsFilter {
  constructor(events) {
    this.events = events;
  }
  getEventsForDay(timeInstance, startDateTimeString) {
    return this.events.filter((event) => this.isEventInDayBoundaries(event, timeInstance, startDateTimeString));
  }
  isEventInDayBoundaries(event, timeInstance, startDateTimeString) {
    const eventIsInDay = timeInstance.dateStringFrom(event.time.start) === timeInstance.dateStringFrom(startDateTimeString);
    if (timeInstance.dayMode === DAY_MODE.REGULAR) {
      return eventIsInDay;
    }
    if (eventIsInDay && timeInstance.dayMode === DAY_MODE.SHORTENED) {
      return this.handlePartialDayWithinOneDayBoundary(timeInstance, event);
    }
    if (timeInstance.dayMode === DAY_MODE.FLEXIBLE) {
      return this.handleDayStretchingTwoDates(timeInstance, event, startDateTimeString, eventIsInDay);
    }
    return false;
  }
  handleDayStretchingTwoDates(timeInstance, event, startDateTimeString, eventIsInDay) {
    const { hour: dayStartHour } = timeInstance.getHourAndMinutesFromTimePoints(timeInstance.DAY_START);
    const { hour: dayEndHour } = timeInstance.getHourAndMinutesFromTimePoints(timeInstance.DAY_END);
    const { hour: eventStartHour } = timeInstance.getAllVariablesFromDateTimeString(event.time.start);
    const nextDay = timeInstance.addDaysToDateTimeString(1, startDateTimeString);
    const eventStartsInNextDay = event.time.start.substring(0, 11) === nextDay.substring(0, 11);
    return eventIsInDay && eventStartHour >= dayStartHour || eventStartsInNextDay && eventStartHour < dayEndHour;
  }
  handlePartialDayWithinOneDayBoundary(timeInstance, event) {
    const { hour: dayStartHour } = timeInstance.getHourAndMinutesFromTimePoints(timeInstance.DAY_START);
    const { hour: dayEndHour } = timeInstance.getHourAndMinutesFromTimePoints(timeInstance.DAY_END);
    const { hour: eventStartHour } = timeInstance.getAllVariablesFromDateTimeString(event.time.start);
    return eventStartHour >= dayStartHour && eventStartHour < dayEndHour;
  }
}
class WeekHelper {
  static getNHoursIntoDayFromHour(hour, timeInstance) {
    const dayStartHour = Time.getHourFromTimePoints(timeInstance.DAY_START);
    if (timeInstance.dayMode === DAY_MODE.REGULAR) return hour;
    if (timeInstance.dayMode === DAY_MODE.SHORTENED || timeInstance.dayMode === DAY_MODE.FLEXIBLE && hour >= dayStartHour) {
      return hour - dayStartHour;
    }
    return 24 - dayStartHour + hour;
  }
  static eventSeparator(events, time) {
    const singleDayTimedEvents = [];
    const fullDayAndMultipleDayEvents = [];
    for (const scheduleEvent of events) {
      const eventType = Helpers.getEventType(scheduleEvent, time);
      if (["SINGLE_DAY_TIMED", "SINGLE_HYBRID_DAY_TIMED"].includes(eventType)) {
        singleDayTimedEvents.push(scheduleEvent);
      } else {
        fullDayAndMultipleDayEvents.push(scheduleEvent);
      }
    }
    return { fullDayAndMultipleDayEvents, singleDayTimedEvents };
  }
}
class DayIntervals extends Time {
  constructor(intervalMinutes, dayStartDateTimeString, hoursPerDay = 24) {
    super();
    __publicField(this, "INTERVAL_MINUTES");
    __publicField(this, "DAY_START_DATE_TIME_STRING");
    __publicField(this, "HOURS_PER_DAY", 24);
    this.INTERVAL_MINUTES = intervalMinutes;
    this.DAY_START_DATE_TIME_STRING = dayStartDateTimeString;
    this.HOURS_PER_DAY = hoursPerDay;
  }
  getIntervals() {
    const intervals = [];
    const numberOfIntervalsInDay = this.HOURS_PER_DAY * (60 / this.INTERVAL_MINUTES);
    let iteratorDateTimeString = this.DAY_START_DATE_TIME_STRING;
    while (intervals.length < numberOfIntervalsInDay) {
      const intervalEnd = this.addMinutesToDateTimeString(this.INTERVAL_MINUTES, iteratorDateTimeString);
      intervals.push({
        intervalStart: iteratorDateTimeString,
        intervalEnd,
        // Only show a border at the bottom of an interval, when the upcoming interval is not the start of a new hour.
        // This prevents double borders
        hasBorder: intervalEnd.substring(14, 16) !== "00"
      });
      iteratorDateTimeString = intervalEnd;
    }
    return intervals;
  }
}
class EventConcurrency {
  sortEventsAccordingToStartOfTime(events) {
    function compare2(a2, b2) {
      if (a2.time.start < b2.time.start) {
        return -1;
      }
      if (a2.time.start > b2.time.start) {
        return 1;
      }
      return 0;
    }
    return events.sort(compare2);
  }
  /**
   * Sets the "zIndex" and "nOfPreviousConcurrentEvents" properties on an event
   *
   * zIndex - lets the event know with which z-index it should be displayed
   * nOfPreviousConcurrentEvents - lets the event know, how many other, previous events, are competing for the same width
   */
  calculateConcurrencyForEvents(events) {
    const updatedEvents = this.sortEventsAccordingToStartOfTime(events);
    if (!updatedEvents.length) return [];
    for (const [index2, calendarEvent] of updatedEvents.entries()) {
      if (index2 === 0) continue;
      let iterator = 0;
      let nOfConcurrentEvents = 0;
      while (iterator < index2) {
        if (updatedEvents[iterator].time.end > calendarEvent.time.start)
          nOfConcurrentEvents++;
        iterator++;
      }
      if (nOfConcurrentEvents)
        updatedEvents[index2].nOfPreviousConcurrentEvents = nOfConcurrentEvents;
    }
    for (let index2 = updatedEvents.length - 1; index2 >= 0; index2--) {
      let nOfUpcomingConcurrentEvents = 0;
      let iterator = updatedEvents.length - 1;
      while (iterator > index2) {
        if (updatedEvents[iterator].time.start < updatedEvents[index2].time.end) {
          nOfUpcomingConcurrentEvents++;
        }
        iterator--;
      }
      const nfOfPreviousEvents = updatedEvents[index2].nOfPreviousConcurrentEvents || 0;
      updatedEvents[index2].totalConcurrentEvents = nfOfPreviousEvents + nOfUpcomingConcurrentEvents + 1;
    }
    return events;
  }
}
var DRAG_N_RESIZE_DIRECTION = /* @__PURE__ */ ((DRAG_N_RESIZE_DIRECTION2) => {
  DRAG_N_RESIZE_DIRECTION2["BACKWARDS"] = "backwards";
  DRAG_N_RESIZE_DIRECTION2["FORWARDS"] = "forwards";
  return DRAG_N_RESIZE_DIRECTION2;
})(DRAG_N_RESIZE_DIRECTION || {});
class EventChange {
  constructor(timeInstance, date2) {
    __publicField(this, "dayStart", "");
    __publicField(this, "dayEnd", "");
    this.timeInstance = timeInstance;
    this.date = date2;
    this.setDayBoundariesTimeStrings();
  }
  canEventBeMoved(event, direction) {
    if (this.timeInstance.dayMode !== DAY_MODE.FLEXIBLE) {
      return this.handleNonFlexibleDays(direction, event);
    }
    return this.handleFlexibleDays(direction, event);
  }
  handleNonFlexibleDays(direction, event) {
    if (direction === DRAG_N_RESIZE_DIRECTION.FORWARDS) {
      return this.handleForwardsMoveForNonFlexibleDays(event);
    }
    return this.handleBackwardsMoveForNonFlexibleDays(event);
  }
  handleFlexibleDays(direction, event) {
    if (direction == DRAG_N_RESIZE_DIRECTION.FORWARDS) {
      return this.handleForwardsMoveForFlexibleDays(event);
    }
    return this.handleBackwardsMoveForFlexibleDays(event);
  }
  handleForwardsMoveForNonFlexibleDays(event) {
    const endTimePlus15Minutes = this.timeInstance.addMinutesToDateTimeString(15, event.time.end);
    const endTimeString = this.timeInstance.timeStringFrom(endTimePlus15Minutes);
    const newEndDateString = this.timeInstance.dateStringFrom(endTimePlus15Minutes);
    if (newEndDateString > this.date) return false;
    return endTimeString <= this.dayEnd;
  }
  handleBackwardsMoveForNonFlexibleDays(event) {
    const startTimeMinus15Minutes = this.timeInstance.addMinutesToDateTimeString(-15, event.time.start);
    const startTimeString = this.timeInstance.timeStringFrom(startTimeMinus15Minutes);
    const newStartDateString = this.timeInstance.dateStringFrom(startTimeMinus15Minutes);
    if (newStartDateString < this.date) return false;
    return startTimeString >= this.dayStart;
  }
  handleForwardsMoveForFlexibleDays(event) {
    const endTimePlus15Minutes = this.timeInstance.addMinutesToDateTimeString(15, event.time.end);
    const endTimeString = this.timeInstance.timeStringFrom(endTimePlus15Minutes);
    const newEndDateString = this.timeInstance.dateStringFrom(endTimePlus15Minutes);
    if (newEndDateString === this.date) return true;
    return endTimeString <= this.dayEnd;
  }
  handleBackwardsMoveForFlexibleDays(event) {
    const startTimeMinus15Minutes = this.timeInstance.addMinutesToDateTimeString(-15, event.time.start);
    const startTimeString = this.timeInstance.timeStringFrom(startTimeMinus15Minutes);
    const newStartDateString = this.timeInstance.dateStringFrom(startTimeMinus15Minutes);
    if (newStartDateString > this.date) return true;
    return startTimeString >= this.dayStart;
  }
  setDayBoundariesTimeStrings() {
    const startHour = this.timeInstance.getHourAndMinutesFromTimePoints(this.timeInstance.DAY_START).hour;
    const endHour = this.timeInstance.getHourAndMinutesFromTimePoints(this.timeInstance.DAY_END).hour;
    const startHourString = this.timeInstance.doubleDigit(startHour);
    this.dayStart = `${startHourString}:00`;
    const endHourString = this.timeInstance.doubleDigit(endHour);
    this.dayEnd = `${endHourString}:00`;
  }
}
const _hoisted_1$Z = ["data-ref"];
const _hoisted_2$J = { class: "calendar-week__event-row is-title" };
const _hoisted_3$B = { class: "calendar-week__event-row is-time flex" };
const _hoisted_4$n = {
  key: 0,
  class: "calendar-week__event-row is-location"
};
const _hoisted_5$m = {
  key: 1,
  class: "calendar-week__event-row is-with"
};
const _hoisted_6$j = {
  key: 2,
  class: "calendar-week__event-row is-topic"
};
const _hoisted_7$e = {
  key: 3,
  class: "calendar-week__event-row is-description"
};
const _hoisted_8$8 = ["innerHTML"];
const _sfc_main$17 = /* @__PURE__ */ defineComponent({
  __name: "DayEvent",
  props: {
    eventProp: {
      type: Object,
      required: true
    },
    time: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    dayInfo: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  emits: ["eventWasClicked", "eventWasResized", "eventWasDragged", "dragStart", "dragEnd"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const event = ref(props2.eventProp);
    const icons = ref({
      clock: "clock",
      user: "user",
      description: "description",
      location: "location_on",
      topic: "topic"
    });
    const showResizeElements = ref(false);
    const eventTransformValue = ref("initial");
    const eventZIndexValue = ref("initial");
    const dayElement = ref(null);
    const resizingStartingPoint = ref(void 0);
    const resizingStartingPointEndOfTime = ref(props2.eventProp.time.end);
    const resizingStartingPointStartOfTime = ref(props2.eventProp.time.start);
    const resizingDirection = ref("");
    const changeInQuarterHoursEventStart = ref(0);
    const changeInQuarterHoursEventEnd = ref(0);
    const isEditable = ref(props2.eventProp.isEditable || false);
    const colors = ref(EVENT_COLORS);
    const eventColor = ref("#fff");
    const eventBackgroundColor = ref("");
    const isResizing = ref(false);
    const canDrag = ref(false);
    const clientYDragStart = ref(null);
    const clientXDragStart = ref(null);
    const changeInQuartersOnDrag = ref(0);
    const changeInDaysOnDrag = ref(0);
    const timeStartDragStart = ref(props2.eventProp.time.start);
    const timeEndDragStart = ref(props2.eventProp.time.end);
    const dragMoveListenerNameAndCallbacks = [
      ["mousemove", handleDrag],
      ["touchmove", handleDrag],
      ["mouseup", onMouseUpWhenDragging],
      ["touchend", onMouseUpWhenDragging]
    ];
    const eventChangeHelper = computed(() => {
      const eventCurrentDay = props2.time.addDaysToDateTimeString(changeInDaysOnDrag.value, props2.dayInfo.dateTimeString);
      return new EventChange(props2.time, props2.time.dateStringFrom(eventCurrentDay));
    });
    const isCustomEvent = computed(() => {
      if (Array.isArray(props2.eventProp.isCustom)) {
        return props2.eventProp.isCustom.includes(props2.mode);
      }
      return props2.eventProp.isCustom || false;
    });
    const getEventTime = computed(() => {
      return `${props2.time.getLocalizedTime(event.value.time.start)} - ${props2.time.getLocalizedTime(event.value.time.end)}`;
    });
    const timePointsInDay = computed(() => props2.time.HOURS_PER_DAY * 100);
    const timePointsInOneMinute = computed(() => 100 / 60);
    const getLeftRule = computed(() => {
      if (!event.value.totalConcurrentEvents || !event.value.nOfPreviousConcurrentEvents) {
        return 0;
      }
      return event.value.nOfPreviousConcurrentEvents / event.value.totalConcurrentEvents * 100;
    });
    const getWidthRule = computed(() => 100 - getLeftRule.value);
    const getBorderRule = computed(() => !event.value.nOfPreviousConcurrentEvents ? "none" : "1px solid #fff");
    const eventIsLongerThan30Minutes = computed(() => {
      const { hour: startHour, minutes: startMinutes } = props2.time.getAllVariablesFromDateTimeString(event.value.time.start);
      const { hour: endHour, minutes: endMinutes } = props2.time.getAllVariablesFromDateTimeString(event.value.time.end);
      const startDateMS = new Date(0, 0, 0, startHour, startMinutes).getTime();
      const endDateMS = new Date(0, 0, 0, endHour, endMinutes).getTime();
      return endDateMS - startDateMS >= 18e5;
    });
    const hasDisabledDragAndDrop = computed(() => {
      return !!(props2.eventProp.disableDnD && props2.eventProp.disableDnD.includes(props2.mode));
    });
    const hasDisabledResize = computed(() => {
      return !!(props2.eventProp.disableResize && props2.eventProp.disableResize.includes(props2.mode));
    });
    const requiredStyles = computed(() => ({
      top: getPositionInDay(event.value.time.start),
      height: getLengthOfEvent(event.value.time.start, event.value.time.end),
      // 'inset-inline-start': `${getInlineStartRule.value}%`,
      width: `${getWidthRule.value}%`,
      transform: eventTransformValue.value,
      zIndex: eventZIndexValue.value
    }));
    function getPositionInDay(dateTimeString) {
      return `${props2.time.getPercentageOfDayFromDateTimeString(dateTimeString, props2.time.DAY_START, props2.time.DAY_END).toString()}%`;
    }
    function getLengthOfEvent(start, end) {
      const startOfEvent = props2.time.getPercentageOfDayFromDateTimeString(start, props2.time.DAY_START, props2.time.DAY_END);
      const endOfEvent = props2.time.getPercentageOfDayFromDateTimeString(end, props2.time.DAY_START, props2.time.DAY_END);
      const length = Math.abs(endOfEvent - startOfEvent);
      return `${length}%`;
    }
    function handleClickOnEvent(event2) {
      const eventElement = getEventElementFromChildElement(event2);
      if (!eventElement) return;
      emit2("eventWasClicked", {
        clickedEvent: props2.eventProp,
        eventElement
      });
    }
    function getEventElementFromChildElement(event2) {
      const eventTarget = event2.target;
      if (!eventTarget || typeof eventTarget.className.includes !== "function") return null;
      if (eventTarget.className.includes(".calendar-week__event")) return event2.target;
      return eventTarget.closest(".calendar-week__event");
    }
    function onMouseMoveResize(event2) {
      const eventsContainer = document.querySelector(".calendar-week__events");
      if (!eventsContainer) return;
      if (typeof resizingStartingPoint.value === "undefined") {
        resizingStartingPoint.value = event2.clientY;
      }
      const cursorPositionY = event2.clientY;
      const nOfPixelsDistance = cursorPositionY - resizingStartingPoint.value;
      const eventsContainerHeight = eventsContainer.clientHeight;
      const percentageOfDayChanged = nOfPixelsDistance / eventsContainerHeight * 100;
      const changeInTimePoints = timePointsInDay.value / 100 * percentageOfDayChanged;
      const changeInMinutes = getMinutesFromTimePoints(changeInTimePoints);
      if (resizingDirection.value === "down") {
        changeInQuarterHoursEventEnd.value = Math.floor(changeInMinutes / 15);
      } else {
        changeInQuarterHoursEventStart.value = Math.floor(changeInMinutes / 15);
      }
    }
    function onMouseUpWhenResizing() {
      stopResizing();
    }
    function resizeEvent(direction) {
      isResizing.value = true;
      resizingDirection.value = direction;
      document.addEventListener("mousemove", onMouseMoveResize);
      document.addEventListener("mouseup", onMouseUpWhenResizing);
    }
    function stopResizing() {
      document.removeEventListener("mousemove", onMouseMoveResize);
      document.removeEventListener("mouseup", onMouseUpWhenResizing);
      resetResizingValues();
      emit2("eventWasResized", event.value);
      isResizing.value = false;
    }
    function resetResizingValues() {
      resizingStartingPoint.value = void 0;
      resizingStartingPointStartOfTime.value = props2.eventProp.time.start;
      resizingStartingPointEndOfTime.value = props2.eventProp.time.end;
      changeInQuarterHoursEventEnd.value = 0;
    }
    function getMinutesFromTimePoints(timePoints) {
      return timePoints / timePointsInOneMinute.value;
    }
    function setColors() {
      var _a;
      if (event.value.colorScheme && ((_a = props2.config.style) == null ? void 0 : _a.colorSchemes) && props2.config.style.colorSchemes[event.value.colorScheme]) {
        eventColor.value = props2.config.style.colorSchemes[event.value.colorScheme].color;
        eventBackgroundColor.value = props2.config.style.colorSchemes[event.value.colorScheme].backgroundColor;
        return;
      }
      if (event.value.color) {
        eventColor.value = "#fff";
        eventBackgroundColor.value = colors.value[event.value.color];
        return;
      }
      eventBackgroundColor.value = colors.value.blue;
    }
    function initDrag(domEvent) {
      if (!event.value.isEditable || hasDisabledDragAndDrop.value) return;
      emit2("dragStart");
      dragMoveListenerNameAndCallbacks.forEach(([name, callback]) => {
        document.addEventListener(name, callback);
      });
      if (Helpers.isUIEventTouchEvent(domEvent)) {
        setInitialDragValues(
          domEvent.touches[0].clientX,
          domEvent.touches[0].clientY
        );
      } else {
        setInitialDragValues(domEvent.clientX, domEvent.clientY);
      }
    }
    function setInitialDragValues(clientX, clientY) {
      canDrag.value = true;
      eventZIndexValue.value = 10;
      clientYDragStart.value = clientY;
      clientXDragStart.value = clientX;
      timeStartDragStart.value = event.value.time.start;
      timeEndDragStart.value = event.value.time.end;
    }
    function onMouseUpWhenDragging() {
      emit2("dragEnd");
      handleDragEnd();
    }
    function handleDragEnd() {
      canDrag.value = false;
      eventZIndexValue.value = "initial";
      dragMoveListenerNameAndCallbacks.forEach(([name, callback]) => {
        document.removeEventListener(name, callback);
      });
      const dayChanged = changeInDaysOnDrag.value <= -1 || changeInDaysOnDrag.value > 0;
      const timeChanged = changeInQuartersOnDrag.value <= -1 || changeInQuartersOnDrag.value > 0;
      if (dayChanged || timeChanged) emit2("eventWasDragged", event.value);
    }
    function handleDrag(mouseEvent) {
      if (isResizing.value || !canDrag.value || !clientYDragStart.value) return;
      if (Helpers.isUIEventTouchEvent(mouseEvent)) {
        handleVerticalDrag(mouseEvent.touches[0].clientY);
        handleHorizontalDrag(mouseEvent.touches[0].clientX);
      } else {
        handleVerticalDrag(mouseEvent.clientY);
        handleHorizontalDrag(mouseEvent.clientX);
      }
    }
    function handleVerticalDrag(clientY) {
      const eventsContainer = document.querySelector(".calendar-week__events");
      if (!eventsContainer || !clientYDragStart.value) return;
      const nOfPixelsDistance = clientY - clientYDragStart.value;
      const eventsContainerHeight = eventsContainer.clientHeight;
      const percentageOfDayChanged = nOfPixelsDistance / eventsContainerHeight * 100;
      const changeInTimePoints = timePointsInDay.value / 100 * percentageOfDayChanged;
      const changeInMinutes = getMinutesFromTimePoints(changeInTimePoints);
      changeInQuartersOnDrag.value = changeInMinutes < 0 ? Math.ceil(changeInMinutes / 15) : Math.floor(changeInMinutes / 15);
    }
    function handleHorizontalDrag(clientX) {
      if (!dayElement.value || !clientXDragStart.value) return;
      const dayWidth = dayElement.value.clientWidth;
      const changeInPixelsX = clientX - clientXDragStart.value;
      changeInDaysOnDrag.value = changeInPixelsX < 0 ? Math.ceil(changeInPixelsX / dayWidth) : Math.floor(changeInPixelsX / dayWidth);
    }
    function updatePositionOnDrag() {
      const minutesChangedVertically = changeInQuartersOnDrag.value * 15;
      const minutesChangedHorizontally = changeInDaysOnDrag.value * 1440;
      event.value.time.start = props2.time.addMinutesToDateTimeString(
        minutesChangedVertically + minutesChangedHorizontally,
        timeStartDragStart.value
      );
      event.value.time.end = props2.time.addMinutesToDateTimeString(
        minutesChangedVertically + minutesChangedHorizontally,
        timeEndDragStart.value
      );
    }
    watch(changeInQuarterHoursEventStart, (newValue, oldValue) => {
      const newStartOfTimeDateTimeString = props2.time.addMinutesToDateTimeString(
        15 * newValue,
        resizingStartingPointStartOfTime.value
      );
      const direction = newValue > oldValue ? DRAG_N_RESIZE_DIRECTION.FORWARDS : DRAG_N_RESIZE_DIRECTION.BACKWARDS;
      const eventCanBeResizedFurther = eventChangeHelper.value.canEventBeMoved(event.value, direction);
      if (newStartOfTimeDateTimeString < event.value.time.end && eventCanBeResizedFurther) {
        event.value.time.start = newStartOfTimeDateTimeString;
      }
    });
    watch(changeInQuarterHoursEventEnd, (newValue, oldValue) => {
      const newEndOfTimeDateTimeString = props2.time.addMinutesToDateTimeString(
        15 * newValue,
        resizingStartingPointEndOfTime.value
      );
      const direction = newValue > oldValue ? DRAG_N_RESIZE_DIRECTION.FORWARDS : DRAG_N_RESIZE_DIRECTION.BACKWARDS;
      const eventCanBeResizedFurther = eventChangeHelper.value.canEventBeMoved(event.value, direction);
      if (newEndOfTimeDateTimeString > event.value.time.start && eventCanBeResizedFurther) {
        event.value.time.end = newEndOfTimeDateTimeString;
      }
    });
    watch(changeInQuartersOnDrag, (newValue, oldValue) => {
      const direction = newValue > oldValue ? DRAG_N_RESIZE_DIRECTION.FORWARDS : DRAG_N_RESIZE_DIRECTION.BACKWARDS;
      const eventCanBeDraggedFurther = eventChangeHelper.value.canEventBeMoved(event.value, direction);
      if (!eventCanBeDraggedFurther) return;
      updatePositionOnDrag();
    });
    watch(changeInDaysOnDrag, (newValue) => {
      if (!dayElement.value) return;
      const upcomingDaysInWeek = props2.dayInfo.daysTotalN - (props2.dayInfo.thisDayIndex + 1);
      const previousDaysInWeek = 0 - props2.dayInfo.thisDayIndex;
      if (newValue > upcomingDaysInWeek || newValue < previousDaysInWeek) return;
      const pixelsToTransform = newValue * dayElement.value.clientWidth;
      eventTransformValue.value = `translateX(${pixelsToTransform}px)`;
      updatePositionOnDrag();
    });
    onMounted(() => {
      dayElement.value = document.querySelector(".calendar-week__day");
      setColors();
    });
    function handleFocus() {
      if (isEditable.value && !hasDisabledResize.value) {
        showResizeElements.value = true;
      }
    }
    function handleBlur() {
      showResizeElements.value = false;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["calendar-week__event is-event", {
          "is-editable": isEditable.value,
          "has-disabled-dnd": hasDisabledDragAndDrop.value
        }]),
        style: normalizeStyle({
          ...requiredStyles.value,
          border: getBorderRule.value
        }),
        "data-ref": `event-${event.value.id}`,
        tabindex: "0",
        onClick: handleClickOnEvent,
        onMouseenter: handleFocus,
        onMouseleave: handleBlur,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onMousedown: initDrag,
        onTouchstart: initDrag
      }, [
        !isCustomEvent.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "calendar-week__event-info-wrapper p-05",
          style: normalizeStyle({
            color: eventColor.value,
            width: "100%",
            height: "100%",
            backgroundColor: eventBackgroundColor.value
          })
        }, [
          createElementVNode("div", _hoisted_2$J, toDisplayString(event.value.title), 1),
          createElementVNode("div", _hoisted_3$B, [
            createVNode(unref(_sfc_main$s), {
              icon: icons.value.clock,
              class: "calendar-week__event-icon"
            }, null, 8, ["icon"]),
            createElementVNode("span", null, toDisplayString(getEventTime.value), 1)
          ]),
          event.value.location ? (openBlock(), createElementBlock("div", _hoisted_4$n, [
            createVNode(unref(_sfc_main$s), {
              icon: icons.value.location,
              class: "calendar-week__event-icon"
            }, null, 8, ["icon"]),
            createElementVNode("span", null, toDisplayString(event.value.location), 1)
          ])) : createCommentVNode("", true),
          event.value.with ? (openBlock(), createElementBlock("div", _hoisted_5$m, [
            createVNode(unref(_sfc_main$s), {
              icon: icons.value.user,
              class: "calendar-week__event-icon"
            }, null, 8, ["icon"]),
            createElementVNode("span", null, toDisplayString(event.value.with), 1)
          ])) : createCommentVNode("", true),
          event.value.topic ? (openBlock(), createElementBlock("div", _hoisted_6$j, [
            createVNode(unref(_sfc_main$s), {
              icon: icons.value.topic,
              class: "calendar-week__event-icon"
            }, null, 8, ["icon"]),
            createElementVNode("span", null, toDisplayString(event.value.topic), 1)
          ])) : createCommentVNode("", true),
          event.value.description ? (openBlock(), createElementBlock("div", _hoisted_7$e, [
            createVNode(unref(_sfc_main$s), {
              icon: icons.value.description,
              class: "calendar-week__event-icon"
            }, null, 8, ["icon"]),
            createElementVNode("p", {
              innerHTML: event.value.description
            }, null, 8, _hoisted_8$8)
          ])) : createCommentVNode("", true),
          eventIsLongerThan30Minutes.value ? (openBlock(), createElementBlock("div", {
            key: 4,
            class: "calendar-week__event-blend-out",
            style: normalizeStyle({
              backgroundImage: `linear-gradient(to bottom, transparent, ${eventBackgroundColor.value})`
            })
          }, null, 4)) : createCommentVNode("", true)
        ], 4)) : renderSlot(_ctx.$slots, "weekDayEvent", {
          key: 1,
          eventData: event.value
        }, void 0, true),
        showResizeElements.value ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: "calendar-week__event-resize calendar-week__event-resize-up",
          onMousedown: _cache[0] || (_cache[0] = ($event) => resizeEvent("up"))
        }, null, 32)) : createCommentVNode("", true),
        showResizeElements.value ? (openBlock(), createElementBlock("div", {
          key: 3,
          class: "calendar-week__event-resize calendar-week__event-resize-down",
          onMousedown: _cache[1] || (_cache[1] = ($event) => resizeEvent("down"))
        }, null, 32)) : createCommentVNode("", true)
      ], 46, _hoisted_1$Z);
    };
  }
});
const DayEvent = /* @__PURE__ */ _export_sfc(_sfc_main$17, [["__scopeId", "data-v-992d6df6"]]);
const _hoisted_1$Y = ["id", "onClick"];
const _sfc_main$16 = /* @__PURE__ */ defineComponent({
  __name: "Day",
  props: {
    day: {
      type: Object,
      required: true
    },
    time: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    dayInfo: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    dayIntervals: {
      type: Object,
      required: true
    },
    weekHeight: {
      type: Number,
      required: true
    }
  },
  emits: [
    "eventWasClicked",
    "eventWasResized",
    "eventWasDragged",
    "intervalWasClicked",
    "dayWasClicked",
    "datetimeWasClicked",
    "dragStart",
    "dragEnd"
  ],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const eventConcurrencyHelper = new EventConcurrency();
    const events = ref([]);
    const intervals = ref([]);
    const intervalStyles = computed(() => {
      var _a;
      return ((_a = props2.config.dayIntervals) == null ? void 0 : _a.intervalStyles) ? props2.config.dayIntervals.intervalStyles : {};
    });
    function calculateEventConcurrency() {
      events.value = eventConcurrencyHelper.calculateConcurrencyForEvents(
        props2.day.events
      );
    }
    function handleEventWasResized(event) {
      emit2("eventWasResized", event);
      calculateEventConcurrency();
    }
    function handleClickOnInterval(payload) {
      const { intervalStart, intervalEnd } = payload;
      emit2("intervalWasClicked", { intervalStart, intervalEnd });
    }
    function setClickableIntervals() {
      let dayStartTimeString = props2.day.dateTimeString;
      if (props2.time.DAY_START !== 0) {
        const { hour: startHour } = props2.time.getHourAndMinutesFromTimePoints(props2.time.DAY_START);
        dayStartTimeString = props2.time.setSegmentOfDateTimeString(dayStartTimeString, { hour: startHour });
      }
      intervals.value = new DayIntervals(
        props2.dayIntervals.length || 60,
        dayStartTimeString,
        props2.time.HOURS_PER_DAY
      ).getIntervals();
    }
    function getDateStringForFlexibleDayBoundaries(dateString, timeClickedHHMM) {
      const hourTwoDigits = props2.time.doubleDigit(props2.time.DAY_START / 100);
      const dayStartTimeHHMM = `${hourTwoDigits}:00`;
      const isClickOnNextDay = timeClickedHHMM < dayStartTimeHHMM;
      if (isClickOnNextDay) {
        dateString = props2.time.dateStringFrom(
          props2.time.addDaysToDateTimeString(1, dateString)
        );
      }
      return dateString;
    }
    function handleClickOnDay(event) {
      const timeClicked = props2.time.getTimeFromClick(event.offsetY, props2.weekHeight);
      let dateString = props2.time.dateStringFrom(props2.day.dateTimeString);
      const isFlexibleDay = props2.time.DAY_END <= props2.time.DAY_START;
      if (isFlexibleDay) dateString = getDateStringForFlexibleDayBoundaries(dateString, timeClicked);
      const dateTimeString = `${dateString} ${timeClicked}`;
      emit2("dayWasClicked", dateString);
      emit2("datetimeWasClicked", dateTimeString);
    }
    onMounted(() => {
      calculateEventConcurrency();
      if (props2.dayIntervals.displayClickableInterval) setClickableIntervals();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "calendar-week__day",
        onClick: withModifiers(handleClickOnDay, ["self"])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(events.value, (event, eventIndex) => {
          return openBlock(), createBlock(DayEvent, {
            key: eventIndex,
            "data-test": "day-event",
            "event-prop": event,
            day: __props.day,
            time: __props.time,
            config: __props.config,
            "day-info": __props.dayInfo,
            mode: __props.mode,
            onEventWasClicked: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("eventWasClicked", $event)),
            onEventWasDragged: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("eventWasDragged", $event)),
            onEventWasResized: handleEventWasResized,
            onDragStart: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("dragStart")),
            onDragEnd: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("dragEnd"))
          }, {
            weekDayEvent: withCtx((p2) => [
              renderSlot(_ctx.$slots, "weekDayEvent", {
                eventData: p2.eventData
              }, void 0, true)
            ]),
            _: 2
          }, 1032, ["event-prop", "day", "time", "config", "day-info", "mode"]);
        }), 128)),
        __props.dayIntervals && __props.dayIntervals.displayClickableInterval ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(intervals.value, (interval, intervalIndex) => {
          return openBlock(), createElementBlock("div", {
            id: `interval-${intervalIndex}`,
            key: interval.intervalStart,
            class: normalizeClass(["calendar-week__day-interval", { "has-border": interval.hasBorder }]),
            style: normalizeStyle(intervalStyles.value),
            onClick: ($event) => handleClickOnInterval(interval)
          }, toDisplayString(__props.time.getLocalizedTime(interval.intervalStart)), 15, _hoisted_1$Y);
        }), 128)) : createCommentVNode("", true)
      ]);
    };
  }
});
const Day = /* @__PURE__ */ _export_sfc(_sfc_main$16, [["__scopeId", "data-v-7947ee7a"]]);
const _hoisted_1$X = { class: "day-timeline absolute top-0 start-0 space-evenly column display-flex" };
const _hoisted_2$I = { class: "day-timeline__hour-text line-height-0" };
const _sfc_main$15 = /* @__PURE__ */ defineComponent({
  __name: "DayTimeline",
  props: {
    time: {
      type: Object,
      required: true
    },
    weekHeight: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "42711aca": __props.weekHeight
    }));
    const props2 = __props;
    const timelineHours = ref([]);
    onMounted(() => {
      timelineHours.value = props2.time.getTimelineHours();
    });
    function getLocaleTimeString(time) {
      const { hour } = props2.time.getHourAndMinutesFromTimePoints(time);
      return props2.time.getLocalizedHour(new Date(2100, 1, 1, hour));
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$X, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(timelineHours.value, (hour) => {
          return openBlock(), createElementBlock("div", {
            key: hour,
            class: "day-timeline__hour display-flex column ustify-content-start h-100p ps-05"
          }, [
            createElementVNode("span", _hoisted_2$I, toDisplayString(getLocaleTimeString(hour)), 1)
          ]);
        }), 128))
      ]);
    };
  }
});
const DayTimeline = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["__scopeId", "data-v-64469387"]]);
const _hoisted_1$W = ["id"];
const _hoisted_2$H = {
  key: 1,
  class: "week-timeline__event"
};
const eventElementIdPrefix = "week-timeline__event-id-";
const _sfc_main$14 = /* @__PURE__ */ defineComponent({
  __name: "FullDayEvent",
  props: {
    scheduleEvent: {
      type: Object,
      default: null
    },
    config: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  emits: ["eventWasClicked"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const colors = EVENT_COLORS;
    const eventColor = ref("#fff");
    const eventBackgroundColor = ref("");
    const eventWidth = computed(() => {
      if (props2.mode !== "day")
        return `calc(${props2.scheduleEvent.nDays * 100}%)`;
      return "calc(100%)";
    });
    function setColors() {
      var _a;
      if (props2.scheduleEvent.colorScheme && ((_a = props2.config.style) == null ? void 0 : _a.colorSchemes) && props2.config.style.colorSchemes[props2.scheduleEvent.colorScheme]) {
        eventColor.value = props2.config.style.colorSchemes[props2.scheduleEvent.colorScheme].color;
        eventBackgroundColor.value = props2.config.style.colorSchemes[props2.scheduleEvent.colorScheme].backgroundColor;
        return;
      }
      if (props2.scheduleEvent.color) {
        eventColor.value = "#fff";
        eventBackgroundColor.value = colors[props2.scheduleEvent.color];
        return;
      }
      eventBackgroundColor.value = colors.blue;
    }
    function handleClickOnEvent() {
      const eventElement = document.getElementById(
        eventElementIdPrefix + props2.scheduleEvent.id
      );
      emit2("eventWasClicked", {
        clickedEvent: props2.scheduleEvent,
        eventElement
      });
    }
    onMounted(() => {
      setColors();
    });
    return (_ctx, _cache) => {
      return __props.scheduleEvent ? (openBlock(), createElementBlock("div", {
        key: 0,
        id: `${eventElementIdPrefix}${__props.scheduleEvent.id}`,
        class: "week-timeline__event is-event",
        style: normalizeStyle({
          width: eventWidth.value,
          color: eventColor.value,
          backgroundColor: eventBackgroundColor.value,
          zIndex: 1
        }),
        onClick: handleClickOnEvent
      }, toDisplayString(__props.scheduleEvent.title), 13, _hoisted_1$W)) : (openBlock(), createElementBlock("div", _hoisted_2$H));
    };
  }
});
const FullDayEvent = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["__scopeId", "data-v-de98fbb8"]]);
const _hoisted_1$V = {
  class: "week-timeline flex space-between border-bottom ms-3-5",
  style: { "margin-inline-end": "0.5em" }
};
const _hoisted_2$G = ["onClick"];
const _hoisted_3$A = { class: "flex justify-content-center gap-025 txt12 pb-025" };
const _hoisted_4$m = { class: "" };
const _hoisted_5$l = { class: "week-timeline__date txt14 round inline-flex justify-content-center" };
const _hoisted_6$i = { class: "week-timeline__events" };
const _sfc_main$13 = /* @__PURE__ */ defineComponent({
  __name: "WeekTimeline",
  props: {
    days: {},
    time: {},
    fullDayEvents: {},
    config: {},
    mode: {}
  },
  emits: ["eventWasClicked", "dayWasClicked"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const now = ref(/* @__PURE__ */ new Date());
    function getDaysDate(day) {
      const { date: date2 } = props2.time.getAllVariablesFromDateTimeString(
        day.dateTimeString
      );
      return date2;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$V, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.days, (day, dayIndex) => {
          return openBlock(), createElementBlock("div", {
            key: dayIndex,
            class: normalizeClass(["week-timeline__day", {
              "is-today": _ctx.time.getDateTimeStringFromDate(now.value, "start") === day.dateTimeString
            }]),
            onClick: ($event) => emit2("dayWasClicked", _ctx.time.dateStringFrom(day.dateTimeString))
          }, [
            createElementVNode("div", _hoisted_3$A, [
              createElementVNode("div", _hoisted_4$m, toDisplayString(day.dayName.charAt(0).toUpperCase() + day.dayName.slice(1, 3).toLowerCase()), 1),
              createElementVNode("div", _hoisted_5$l, toDisplayString(getDaysDate(day)), 1)
            ]),
            createElementVNode("div", _hoisted_6$i, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(day.fullDayEvents, (event, key) => {
                return openBlock(), createElementBlock(Fragment, { key }, [
                  key !== "date" ? (openBlock(), createBlock(FullDayEvent, {
                    key: 0,
                    "schedule-event": typeof event === "object" ? event : null,
                    config: _ctx.config,
                    mode: _ctx.mode,
                    onEventWasClicked: _cache[0] || (_cache[0] = ($event) => emit2("eventWasClicked", $event))
                  }, null, 8, ["schedule-event", "config", "mode"])) : createCommentVNode("", true)
                ], 64);
              }), 128))
            ])
          ], 10, _hoisted_2$G);
        }), 128))
      ]);
    };
  }
});
const WeekTimeline = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["__scopeId", "data-v-9aaa9a54"]]);
const _hoisted_1$U = { class: "calendar-week__wrapper relative ps-3-5" };
const _hoisted_2$F = { class: "calendar-week" };
const _hoisted_3$z = { class: "calendar-week__events" };
const _sfc_main$12 = /* @__PURE__ */ defineComponent({
  __name: "Week",
  props: {
    config: {
      type: Object,
      required: true
    },
    eventsProp: {
      type: Array,
      default: () => []
    },
    period: {
      type: Object,
      required: true
    },
    modeProp: {
      type: String,
      default: "week"
    },
    time: {
      type: Object,
      required: true
    }
  },
  emits: [
    "eventWasClicked",
    "eventWasResized",
    "eventWasDragged",
    "editEvent",
    "deleteEvent",
    "intervalWasClicked",
    "dayWasClicked",
    "datetimeWasClicked"
  ],
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "ec938e6e": weekHeight.value
    }));
    const props2 = __props;
    const emit2 = __emit;
    const eventPosition = new EventPosition();
    const days = ref([]);
    const mode = ref(props2.modeProp);
    const selectedEvent = ref(null);
    const selectedEventElement = ref(null);
    const events = ref(props2.eventsProp);
    const fullDayEvents = ref([]);
    const weekVersion = ref(0);
    const dayIntervals = ref({
      length: 60,
      height: 66
    });
    const weekHeight = ref("1584px");
    const currentTimePercentage = ref(0);
    const showCurrentTime = ref(!!props2.config.showCurrentTime);
    const hasCustomCurrentTimeSlot = computed(() => {
      return Helpers.hasSlotContent(useSlots().customCurrentTime);
    });
    const nDays = computed(() => {
      var _a;
      return ((_a = props2.config.week) == null ? void 0 : _a.nDays) || 7;
    });
    watch(() => props2.period, () => {
      setInitialEvents(mode.value);
    }, { deep: true });
    watch(() => props2.modeProp, (value) => {
      mode.value = value;
      setInitialEvents(value);
    }, { deep: true });
    onMounted(() => {
      setDayIntervals();
      separateFullDayEventsFromOtherEvents();
      setInitialEvents(props2.modeProp);
      if (props2.config.showCurrentTime || hasCustomCurrentTimeSlot.value) setCurrentTime();
    });
    function separateFullDayEventsFromOtherEvents() {
      const {
        singleDayTimedEvents,
        fullDayAndMultipleDayEvents
      } = WeekHelper.eventSeparator(events.value, props2.time);
      events.value = singleDayTimedEvents;
      positionFullDayEvents(fullDayAndMultipleDayEvents);
    }
    function positionFullDayEvents(fullDayAndMultipleDayEvents) {
      const weekEndDate = nDays.value === 5 ? new Date(
        props2.period.end.getFullYear(),
        props2.period.end.getMonth(),
        props2.period.end.getDate() - 2
      ) : props2.period.end;
      fullDayEvents.value = fullDayAndMultipleDayEvents.length ? eventPosition.positionFullDayEventsInWeek(
        props2.period.start,
        weekEndDate,
        fullDayAndMultipleDayEvents
      ) : [];
    }
    function setDays() {
      const daysArray = props2.time.getCalendarWeekDateObjects(props2.period.start).map((day) => {
        const dayName = props2.time.getLocalizedNameOfWeekday(day, "long");
        const dateTimeString = props2.time.getDateTimeStringFromDate(
          day,
          "start"
        );
        const dayEvents = new EventsFilter(events.value).getEventsForDay(props2.time, dateTimeString);
        return { dayName, dateTimeString, events: dayEvents };
      });
      if (nDays.value === 5 && props2.time.FIRST_DAY_OF_WEEK === WEEK_START_DAY.MONDAY) {
        daysArray.splice(5, 2);
        fullDayEvents.value.splice(5, 2);
      } else if (nDays.value === 5 && props2.time.FIRST_DAY_OF_WEEK === WEEK_START_DAY.SUNDAY) {
        daysArray.splice(6, 1);
        fullDayEvents.value.splice(6, 1);
        daysArray.splice(0, 1);
        fullDayEvents.value.splice(0, 1);
      }
      days.value = daysArray;
    }
    function mergeFullDayEventsIntoDays() {
      for (const [dayIndex] of days.value.entries()) {
        days.value[dayIndex].fullDayEvents = fullDayEvents.value[dayIndex];
      }
    }
    function setDay() {
      const dayDateTimeString = props2.time.getDateTimeStringFromDate(
        props2.period.selectedDate
      );
      days.value = [
        {
          dayName: new Date(props2.period.selectedDate).toLocaleDateString(
            props2.time.CALENDAR_LOCALE,
            { weekday: "long" }
          ),
          dateTimeString: props2.time.getDateTimeStringFromDate(
            props2.period.selectedDate,
            "start"
          ),
          events: new EventsFilter(events.value).getEventsForDay(props2.time, dayDateTimeString)
        }
      ];
      if (!fullDayEvents.value.length) return;
      for (const day of fullDayEvents.value) {
        const dayDateString = props2.time.getDateTimeStringFromDate(day.date);
        if (dayDateString.substring(0, 11) === dayDateTimeString.substring(0, 11)) {
          fullDayEvents.value = [day];
          return;
        }
      }
    }
    function setInitialEvents(currentMode) {
      if (currentMode === "day") setDay();
      if (currentMode === "week") setDays();
      mergeFullDayEventsIntoDays();
    }
    function handleClickOnEvent(event) {
      emit2("eventWasClicked", event);
      selectedEventElement.value = event.eventElement;
      selectedEvent.value = event.clickedEvent;
    }
    function handleEventWasDragged(event) {
      const cleanedUpEvent = event;
      delete cleanedUpEvent.totalConcurrentEvents;
      delete cleanedUpEvent.nOfPreviousConcurrentEvents;
      const filteredEvents = events.value.filter((e) => e.id !== event.id);
      events.value = [
        cleanedUpEvent,
        ...filteredEvents.map((e) => {
          delete e.nOfPreviousConcurrentEvents;
          delete e.totalConcurrentEvents;
          return e;
        })
      ];
      setInitialEvents(mode.value);
      weekVersion.value = weekVersion.value + 1;
      emit2("eventWasDragged", event);
    }
    function setDayIntervals() {
      if (props2.config.dayIntervals) {
        for (const [key, value] of Object.entries(props2.config.dayIntervals)) {
          dayIntervals.value[key] = value;
        }
      }
      setWeekHeightBasedOnIntervals();
    }
    function setWeekHeightBasedOnIntervals() {
      if (![15, 30, 60].includes(dayIntervals.value.length)) {
        dayIntervals.value.length = 60;
        dayIntervals.value.height = 66;
        console.warn(
          "The dayIntervals configuration is faulty. It has been reset to default values."
        );
      }
      let intervalMultiplier = 1;
      if (dayIntervals.value.length === 15) intervalMultiplier = 4;
      if (dayIntervals.value.length === 30) intervalMultiplier = 2;
      weekHeight.value = `${dayIntervals.value.height * intervalMultiplier * props2.time.HOURS_PER_DAY}px`;
    }
    function setCurrentTime() {
      const setTime = () => {
        const nowString = props2.time.getDateTimeStringFromDate(/* @__PURE__ */ new Date());
        const currentTimePercentage2 = props2.time.getPercentageOfDayFromDateTimeString(
          nowString,
          props2.time.DAY_START,
          props2.time.DAY_END
        );
        if (currentTimePercentage2 < 0 || currentTimePercentage2 > 100) {
          showCurrentTime.value = false;
          return;
        }
        showCurrentTime.value = true;
        currentTimePercentage2.value = currentTimePercentage2;
      };
      setTime();
      setInterval(() => {
        setTime();
      }, 6e4);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(WeekTimeline, {
          days: days.value,
          time: __props.time,
          "full-day-events": fullDayEvents.value,
          config: __props.config,
          mode: mode.value,
          onEventWasClicked: handleClickOnEvent,
          onDayWasClicked: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("dayWasClicked", $event))
        }, null, 8, ["days", "time", "full-day-events", "config", "mode"]),
        createElementVNode("div", _hoisted_1$U, [
          !__props.config.eventDialog || !__props.config.eventDialog.isDisabled ? (openBlock(), createBlock(_sfc_main$1c, {
            key: 0,
            "calendar-event-prop": selectedEvent.value,
            "event-element": selectedEventElement.value,
            time: __props.time,
            config: __props.config,
            onHide: _cache[1] || (_cache[1] = ($event) => selectedEvent.value = null),
            onEditEvent: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("editEvent", $event)),
            onDeleteEvent: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("deleteEvent", $event))
          }, {
            default: withCtx((p2) => [
              renderSlot(_ctx.$slots, "eventDialog", {
                eventDialogData: p2.eventDialogData,
                closeEventDialog: p2.closeEventDialog
              }, void 0, true)
            ]),
            _: 3
          }, 8, ["calendar-event-prop", "event-element", "time", "config"])) : createCommentVNode("", true),
          createElementVNode("section", _hoisted_2$F, [
            hasCustomCurrentTimeSlot.value && showCurrentTime.value ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "custom-current-time",
              style: normalizeStyle({ top: `${currentTimePercentage.value}%` })
            }, [
              renderSlot(_ctx.$slots, "customCurrentTime", {}, void 0, true)
            ], 4)) : __props.config && __props.config.showCurrentTime && showCurrentTime.value ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: "current-time-line",
              style: normalizeStyle({ top: `${currentTimePercentage.value}%` })
            }, _cache[8] || (_cache[8] = [
              createElementVNode("div", { class: "current-time-line__circle" }, null, -1)
            ]), 4)) : createCommentVNode("", true),
            (openBlock(), createBlock(DayTimeline, {
              key: __props.period.start.getTime() + __props.period.end.getTime() + mode.value,
              time: __props.time,
              "day-intervals": dayIntervals.value,
              "week-height": weekHeight.value
            }, null, 8, ["time", "day-intervals", "week-height"])),
            createElementVNode("div", _hoisted_3$z, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(days.value, (day, dayIndex) => {
                return openBlock(), createBlock(Day, {
                  key: day.dateTimeString + mode.value + weekVersion.value,
                  day,
                  time: __props.time,
                  config: __props.config,
                  "day-info": { daysTotalN: days.value.length, thisDayIndex: dayIndex, dateTimeString: day.dateTimeString },
                  mode: mode.value,
                  "day-intervals": dayIntervals.value,
                  "week-height": +weekHeight.value.replace("px", ""),
                  onEventWasClicked: handleClickOnEvent,
                  onEventWasResized: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("eventWasResized", $event)),
                  onEventWasDragged: handleEventWasDragged,
                  onIntervalWasClicked: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("intervalWasClicked", $event)),
                  onDayWasClicked: _cache[6] || (_cache[6] = ($event) => _ctx.$emit("dayWasClicked", $event)),
                  onDatetimeWasClicked: _cache[7] || (_cache[7] = ($event) => _ctx.$emit("datetimeWasClicked", $event))
                }, {
                  weekDayEvent: withCtx((p2) => [
                    renderSlot(_ctx.$slots, "weekDayEvent", {
                      eventData: p2.eventData
                    }, void 0, true)
                  ]),
                  _: 2
                }, 1032, ["day", "time", "config", "day-info", "mode", "day-intervals", "week-height"]);
              }), 128))
            ])
          ])
        ])
      ], 64);
    };
  }
});
const Week = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["__scopeId", "data-v-65517675"]]);
const _Errors = class _Errors {
  static checkEventProperties(event) {
    var _a, _b, _c, _d;
    if (!event.id) console.warn(this.MISSING_ID_WARNING);
    if (!event.title) console.warn(this.MISSING_TITLE_WARNING);
    if (!event.time) console.warn(this.MISSING_TIME_WARNING);
    if (!((_a = event.time) == null ? void 0 : _a.start)) console.warn(this.MISSING_TIME_START_WARNING);
    if (!((_b = event.time) == null ? void 0 : _b.end)) console.warn(this.MISSING_TIME_END_WARNING);
    if (((_c = event.time) == null ? void 0 : _c.start) && event.time.end && !DATE_TIME_STRING_PATTERN.test(event.time.start) && !DATE_TIME_STRING_FULL_DAY_PATTERN.test(event.time.start)) {
      console.warn(
        `${this.PREFIX} event property 'time.start' expects a string formatted like 'YYYY-MM-DD hh:mm', or 'YYYY-MM-DD', received ${event.time.start} 
${this.SUFFIX}`
      );
    }
    if (((_d = event.time) == null ? void 0 : _d.start) && event.time.end && !DATE_TIME_STRING_PATTERN.test(event.time.end) && !DATE_TIME_STRING_FULL_DAY_PATTERN.test(event.time.end)) {
      console.warn(
        `${this.PREFIX} event property 'time.end' expects a string formatted like 'YYYY-MM-DD hh:mm',  or 'YYYY-MM-DD', received ${event.time.end} 
${this.SUFFIX}`
      );
    }
  }
  static checkConfig(config) {
    if (config.locale && !/^[a-z]{2}-[A-Z]{2}$/.test(config.locale)) {
      console.warn(
        `${this.PREFIX} config.locale expects a string of format xx-XX, received: ${config.locale}`
      );
    }
    if (config.defaultMode && !["month", "week", "day"].includes(config.defaultMode)) {
      console.warn(
        `${this.PREFIX} config.defaultMode expects either one of the values "day", "week" or "month"`
      );
    }
  }
};
__publicField(_Errors, "PREFIX", "[Qalendar warning]");
// public static SUFFIX = 'This is a development warning, which will never be displayed in production environments'
__publicField(_Errors, "SUFFIX", "");
__publicField(_Errors, "MISSING_ID_WARNING", `${_Errors.PREFIX} required event property 'id' is missing 
${_Errors.SUFFIX}`);
__publicField(_Errors, "MISSING_TITLE_WARNING", `${_Errors.PREFIX} required event property 'title' is missing 
${_Errors.SUFFIX}`);
__publicField(_Errors, "MISSING_TIME_WARNING", `${_Errors.PREFIX} required event property 'time' is missing 
${_Errors.SUFFIX}`);
__publicField(_Errors, "MISSING_TIME_START_WARNING", `${_Errors.PREFIX} required event property 'time.start' is missing 
${_Errors.SUFFIX}`);
__publicField(_Errors, "MISSING_TIME_END_WARNING", `${_Errors.PREFIX} required event property 'time.end' is missing 
${_Errors.SUFFIX}`);
let Errors = _Errors;
const _hoisted_1$T = { class: "calendar-root-wrapper txt16" };
const _hoisted_2$E = ["data-lang"];
const _hoisted_3$y = {
  key: 0,
  class: "top-bar-loader"
};
const _sfc_main$11 = /* @__PURE__ */ defineComponent({
  __name: "Index",
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    events: {
      type: Array,
      default: () => []
    },
    selectedDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "eventWasClicked",
    "eventWasResized",
    "eventWasDragged",
    "updatedPeriod",
    "updatedMode",
    "editEvent",
    "deleteEvent",
    "intervalWasClicked",
    "dayWasClicked",
    // TODO: remove with v4. day-was-clicked is deprecated
    "dateWasClicked",
    "datetimeWasClicked"
  ],
  setup(__props, { emit: __emit }) {
    var _a, _b, _c;
    const props2 = __props;
    const emit2 = __emit;
    const wasInitialized = ref(0);
    const period = ref({
      start: /* @__PURE__ */ new Date(),
      end: /* @__PURE__ */ new Date(),
      selectedDate: props2.selectedDate
    });
    const mode = ref(props2.config.defaultMode || "week");
    const time = ref(new Time((_a = props2.config.week) == null ? void 0 : _a.startsOn, props2.config.locale || null, {
      start: setTimePointsFromDayBoundary(((_b = props2.config.dayBoundaries) == null ? void 0 : _b.start) || 0),
      end: setTimePointsFromDayBoundary(((_c = props2.config.dayBoundaries) == null ? void 0 : _c.end) || 24)
    }));
    const eventRenderingKey = ref(0);
    const eventsDataProperty = ref(props2.events);
    const isSmall = ref(false);
    const ErrorsHelper = Errors;
    const appHeaderRef = ref();
    const enhancedConfig = computed(() => {
      return { ...props2.config, isSmall: isSmall.value };
    });
    watch(() => props2.events, (newVal, oldVal) => {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        eventsDataProperty.value = newVal;
        eventRenderingKey.value = eventRenderingKey.value + 1;
      }
      if (props2.config.isSilent) return;
      props2.events.forEach((e) => {
        ErrorsHelper.checkEventProperties(e);
      });
    }, { deep: true, immediate: true });
    watch(() => props2.config, (value) => {
      ErrorsHelper.checkConfig(value);
    }, { deep: true, immediate: true });
    onMounted(() => {
      setConfigOnMount();
      onCalendarResize();
      setPeriodOnMount();
      window.addEventListener("resize", onCalendarResize);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", onCalendarResize);
    });
    function setConfigOnMount() {
      wasInitialized.value = 1;
    }
    function handleUpdatedPeriod(value, leaveMonthMode = false) {
      emit2("updatedPeriod", { start: value.start, end: value.end });
      period.value = value;
      if (leaveMonthMode) mode.value = "day";
    }
    function handleChangeMode(payload) {
      if (payload === "day") {
        period.value.start = period.value.selectedDate;
        period.value.end = time.value.setDateToEndOfDay(period.value.selectedDate);
      }
      if (payload === "week") {
        const week = time.value.getCalendarWeekDateObjects(period.value.selectedDate);
        period.value.start = week[0];
        period.value.end = time.value.setDateToEndOfDay(week[6]);
      }
      if (payload === "month") {
        const month = time.value.getCalendarMonthSplitInWeeks(
          period.value.selectedDate.getFullYear(),
          period.value.selectedDate.getMonth()
        );
        period.value.start = month[0][0];
        const lastWeek = month[month.length - 1];
        period.value.end = time.value.setDateToEndOfDay(lastWeek[lastWeek.length - 1]);
      }
      mode.value = payload;
      emit2("updatedMode", { mode: payload, period: period.value });
    }
    const calendarRoot = ref();
    function onCalendarResize() {
      const documentRoot = document.documentElement;
      const documentFontSize = +window.getComputedStyle(documentRoot).fontSize.split("p")[0];
      const breakPointFor1RemEquals16px = 600;
      const multiplier = 16 / documentFontSize;
      const smallCalendarBreakpoint = breakPointFor1RemEquals16px / multiplier;
      if (!calendarRoot.value) return;
      isSmall.value = calendarRoot.value.clientWidth < smallCalendarBreakpoint;
      if (isSmall.value && !["day", "month"].includes(mode.value)) {
        mode.value = "day";
      }
    }
    function setPeriodOnMount() {
      if (mode.value === "week") {
        const currentWeek = time.value.getCalendarWeekDateObjects(period.value.selectedDate);
        period.value.start = currentWeek[0];
        period.value.end = currentWeek[6];
      } else if (mode.value === "month") {
        const month = time.value.getCalendarMonthSplitInWeeks(
          period.value.selectedDate.getFullYear(),
          period.value.selectedDate.getMonth()
        );
        period.value.start = month[0][0];
        const lastWeek = month[month.length - 1];
        period.value.end = lastWeek[lastWeek.length - 1];
      }
    }
    function handleEventWasUpdated(calendarEvent, eventType) {
      const newEvents = eventsDataProperty.value.filter(
        (e) => e.id !== calendarEvent.id
      );
      eventsDataProperty.value = [calendarEvent, ...newEvents];
      emit2(eventType === "dragged" ? "eventWasDragged" : "eventWasResized", calendarEvent);
    }
    function setTimePointsFromDayBoundary(boundary) {
      return Time.getTimePointsFromHour(boundary);
    }
    const day = computed(() => {
      return {
        dayName: time.value.getLocalizedNameOfWeekday(period.value.selectedDate, "long"),
        dateTimeString: period.value.selectedDate.toLocaleDateString("en-US", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        }),
        events: eventsDataProperty.value.filter((e) => {
          const eventDate = new Date(e.time.start);
          return eventDate >= period.value.start && eventDate <= period.value.end;
        }),
        fullDayEvents: {
          date: period.value.selectedDate,
          events: eventsDataProperty.value.filter((e) => {
            const eventDate = new Date(e.time.start);
            return eventDate >= period.value.start && eventDate <= period.value.end;
          })
        }
      };
    });
    function handleDateWasClicked(payload) {
      emit2("dayWasClicked", payload);
      emit2("dateWasClicked", payload);
    }
    return (_ctx, _cache) => {
      var _a2, _b2;
      return openBlock(), createElementBlock("div", _hoisted_1$T, [
        createElementVNode("div", {
          ref_key: "calendarRoot",
          ref: calendarRoot,
          class: normalizeClass(["calendar-root", {
            "mode-is-day": mode.value === "day",
            "mode-is-week": mode.value === "week",
            "mode-is-month": mode.value === "month",
            "qalendar-is-small": isSmall.value
          }]),
          "data-lang": ((_b2 = (_a2 = __props.config) == null ? void 0 : _a2.locale) == null ? void 0 : _b2.substring(0, 2)) || "en"
        }, [
          createVNode(Transition, { name: "loading" }, {
            default: withCtx(() => [
              __props.isLoading ? (openBlock(), createElementBlock("div", _hoisted_3$y)) : createCommentVNode("", true)
            ]),
            _: 1
          }),
          (openBlock(), createBlock(_sfc_main$1f, {
            ref_key: "appHeaderRef",
            ref: appHeaderRef,
            key: wasInitialized.value + mode.value,
            config: __props.config,
            mode: mode.value,
            time: time.value,
            period: period.value,
            "is-small": isSmall.value,
            onChangeMode: handleChangeMode,
            onUpdatedPeriod: handleUpdatedPeriod
          }, null, 8, ["config", "mode", "time", "period", "is-small"])),
          mode.value === "agenda" ? (openBlock(), createBlock(AgendaEvents, {
            key: 0,
            "events-prop": eventsDataProperty.value,
            period: period.value,
            config: __props.config,
            time: time.value,
            day: unref(day)
          }, null, 8, ["events-prop", "period", "config", "time", "day"])) : createCommentVNode("", true),
          ["week", "day"].includes(mode.value) ? (openBlock(), createBlock(Week, {
            key: period.value.start.getTime() + period.value.end.getTime() + eventRenderingKey.value,
            "events-prop": eventsDataProperty.value,
            period: period.value,
            config: __props.config,
            "mode-prop": mode.value,
            time: time.value,
            onEventWasClicked: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("eventWasClicked", $event)),
            onEventWasResized: _cache[1] || (_cache[1] = ($event) => handleEventWasUpdated($event, "resized")),
            onEventWasDragged: _cache[2] || (_cache[2] = ($event) => handleEventWasUpdated($event, "dragged")),
            onEditEvent: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("editEvent", $event)),
            onDeleteEvent: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("deleteEvent", $event)),
            onIntervalWasClicked: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("intervalWasClicked", $event)),
            onDayWasClicked: _cache[6] || (_cache[6] = ($event) => _ctx.$emit("dayWasClicked", $event)),
            onDatetimeWasClicked: _cache[7] || (_cache[7] = ($event) => _ctx.$emit("datetimeWasClicked", $event))
          }, {
            weekDayEvent: withCtx((p2) => [
              renderSlot(_ctx.$slots, "weekDayEvent", {
                eventData: p2.eventData
              })
            ]),
            eventDialog: withCtx((p2) => [
              renderSlot(_ctx.$slots, "eventDialog", {
                eventDialogData: p2.eventDialogData,
                closeEventDialog: p2.closeEventDialog
              })
            ]),
            customCurrentTime: withCtx(() => [
              renderSlot(_ctx.$slots, "customCurrentTime")
            ]),
            _: 3
          }, 8, ["events-prop", "period", "config", "mode-prop", "time"])) : createCommentVNode("", true),
          mode.value === "month" ? (openBlock(), createBlock(_sfc_main$18, {
            key: period.value.start.getTime() + period.value.end.getTime() + eventRenderingKey.value,
            "events-prop": eventsDataProperty.value,
            time: time.value,
            config: enhancedConfig.value,
            period: period.value,
            onEventWasClicked: _cache[8] || (_cache[8] = ($event) => _ctx.$emit("eventWasClicked", $event)),
            onDateWasClicked: handleDateWasClicked,
            onEventWasDragged: _cache[9] || (_cache[9] = ($event) => handleEventWasUpdated($event, "dragged")),
            onUpdatedPeriod: _cache[10] || (_cache[10] = ($event) => handleUpdatedPeriod($event, true)),
            onEditEvent: _cache[11] || (_cache[11] = ($event) => _ctx.$emit("editEvent", $event)),
            onDeleteEvent: _cache[12] || (_cache[12] = ($event) => _ctx.$emit("deleteEvent", $event))
          }, {
            eventDialog: withCtx((p2) => [
              renderSlot(_ctx.$slots, "eventDialog", {
                eventDialogData: p2.eventDialogData,
                closeEventDialog: p2.closeEventDialog
              })
            ]),
            monthEvent: withCtx((p2) => [
              renderSlot(_ctx.$slots, "monthEvent", {
                eventData: p2.eventData
              })
            ]),
            dayCell: withCtx(({ dayData }) => [
              renderSlot(_ctx.$slots, "dayCell", { dayData })
            ]),
            _: 3
          }, 8, ["events-prop", "time", "config", "period"])) : createCommentVNode("", true)
        ], 10, _hoisted_2$E)
      ]);
    };
  }
});
const _hoisted_1$S = {
  key: 0,
  class: "card_label"
};
const _sfc_main$10 = /* @__PURE__ */ defineComponent({
  __name: "Card",
  props: {
    label: {},
    thin: { type: Boolean },
    outline: { type: Boolean },
    h100: { type: Boolean },
    to: {},
    overflowX: { type: Boolean },
    overflowY: { type: Boolean },
    bg: {}
  },
  setup(__props) {
    const props2 = __props;
    const is4 = computed(() => props2.to ? "router-link" : "div");
    return (_ctx, _cache) => {
      const _directive_ripple = resolveDirective("ripple");
      return withDirectives((openBlock(), createBlock(resolveDynamicComponent(is4.value), {
        to: _ctx.to,
        class: normalizeClass(["bgl_card", {
          thin: _ctx.thin,
          "border": _ctx.outline,
          "h-100": _ctx.h100,
          [_ctx.bg || ""]: _ctx.bg,
          "overflow-x": _ctx.overflowX,
          "overflow-y": _ctx.overflowY
        }])
      }, {
        default: withCtx(() => [
          _ctx.label ? (openBlock(), createElementBlock("span", _hoisted_1$S, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to", "class"])), [
        [_directive_ripple, !!_ctx.to]
      ]);
    };
  }
});
const _hoisted_1$R = ["dir"];
const _hoisted_2$D = {
  key: 0,
  class: "dots"
};
const _hoisted_3$x = ["onClick"];
const GAP_PERCENT = 1;
const VELOCITY_SAMPLE_DURATION = 100;
const _sfc_main$$ = /* @__PURE__ */ defineComponent({
  __name: "Carousel",
  props: {
    autoHeight: { type: Boolean, default: false },
    allowScroll: { type: Boolean, default: true },
    freeDrag: { type: Boolean, default: true },
    items: { type: Number, default: 4 },
    index: { type: Number, default: 0 },
    rtl: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: false },
    autoPlaySpeed: { type: Number, default: 4e3 },
    dots: { type: Boolean, default: false }
  },
  emits: ["update:index"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const ANIMATION_TIMINGS = {
      TOUCH: 150,
      MOBILE: 420,
      DESKTOP: 840,
      MAX_DURATION: 300,
      BASE_DURATION: 150,
      DURATION_PER_PANEL: 50
    };
    const THRESHOLDS = {
      DRAG: 20,
      TOUCH: 5,
      SWIPE_PERCENT: 0.1,
      VELOCITY: 0.15,
      WHEEL_PERCENT: 0.3
    };
    const bglSlider = ref();
    const isSliderAvailable = computed(() => !!bglSlider.value);
    let itemCount = ref(props2.items);
    let activeSlideIndex = ref(props2.index);
    let slideCount = ref(0);
    let yHeight = ref("auto");
    let isDragging = ref(false);
    let isPressed = ref(false);
    let startX = ref(0);
    let startY = ref(0);
    let translateX2 = ref(0);
    let lastX = ref(0);
    let lastTime = ref(0);
    let accumulatedDeltaX = ref(0);
    let wheelTimeout;
    let autoPlayInterval;
    let velocityTracker = ref([]);
    function getAverageVelocity() {
      if (velocityTracker.value.length < 2) return 0;
      const now = Date.now();
      const recentSamples = velocityTracker.value.filter((sample) => now - sample.time < VELOCITY_SAMPLE_DURATION);
      if (recentSamples.length < 2) return 0;
      const first = recentSamples[0];
      const last = recentSamples[recentSamples.length - 1];
      const timeDelta = last.time - first.time;
      if (timeDelta === 0) return 0;
      return (last.position - first.position) / timeDelta;
    }
    function getCurrentTransform() {
      if (!bglSlider.value) return 0;
      const { transform } = bglSlider.value.style;
      const value = transform ? Number.parseInt(transform.replace(/[^-\d.]/g, "")) : 0;
      return props2.rtl ? -value : value;
    }
    function setTransform(value) {
      if (!bglSlider.value) return;
      const rtlValue = props2.rtl ? -value : value;
      bglSlider.value.style.transform = `translateX(${rtlValue}px)`;
    }
    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
    function animateTransform(start, end, duration) {
      const startTime = performance.now();
      function animate(currentTime) {
        if (!isSliderAvailable.value) return;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        const currentTransform = start + (end - start) * easeInOutQuad(progress);
        setTransform(currentTransform);
        if (progress < 1) requestAnimationFrame(animate);
      }
      requestAnimationFrame(animate);
    }
    function goToSlide(index2, isTouchNav = false) {
      countSlides();
      if (!isSliderAvailable.value || !bglSlider.value || index2 < 0 || index2 >= slideCount.value) return;
      const containerWidth = bglSlider.value.offsetWidth;
      const gapWidth = containerWidth * GAP_PERCENT / 100;
      const totalGapWidth = (itemCount.value - 1) * gapWidth;
      const singleItemWidth = (containerWidth - totalGapWidth) / itemCount.value;
      const gapsBeforeSlide = index2 * gapWidth;
      const targetTransform = -(singleItemWidth * index2 + gapsBeforeSlide);
      const currentTransform = getCurrentTransform();
      const duration = isTouchNav ? ANIMATION_TIMINGS.TOUCH : window.innerWidth < 600 ? ANIMATION_TIMINGS.MOBILE : ANIMATION_TIMINGS.DESKTOP;
      animateTransform(currentTransform, targetTransform, duration);
      activeSlideIndex.value = index2;
      updateHeight();
    }
    function next() {
      if (!isSliderAvailable.value) return;
      countSlides();
      const nextIndex = props2.rtl ? (activeSlideIndex.value - 1 + slideCount.value) % slideCount.value : (activeSlideIndex.value + 1) % slideCount.value;
      goToSlide(nextIndex);
    }
    function prev() {
      if (!isSliderAvailable.value) return;
      countSlides();
      const prevIndex = props2.rtl ? (activeSlideIndex.value + 1) % slideCount.value : (activeSlideIndex.value - 1 + slideCount.value) % slideCount.value;
      goToSlide(prevIndex);
    }
    function calcHeight() {
      if (!isSliderAvailable.value || !bglSlider.value) return;
      try {
        const activeSlide = bglSlider.value.children[activeSlideIndex.value];
        if (!activeSlide) return;
        const children2 = Array.from(activeSlide.children);
        const totalHeight = children2.reduce((sum, el) => sum + el.clientHeight, 0);
        yHeight.value = `${totalHeight}px`;
      } catch (error) {
        console.error("Error calculating height:", error);
      }
    }
    function updateHeight() {
      if (!props2.autoHeight) return;
      setTimeout(calcHeight, 200);
    }
    function countSlides() {
      if (!isSliderAvailable.value || !bglSlider.value) return;
      slideCount.value = bglSlider.value.children.length;
    }
    function handleSlideChange() {
      if (props2.index !== activeSlideIndex.value) {
        emit2("update:index", activeSlideIndex.value);
      }
    }
    function handleResize() {
      if (!isSliderAvailable.value || !bglSlider.value) return;
      itemCount.value = window.innerWidth < 600 ? 1 : window.innerWidth < 991 ? Math.min(props2.items, 2) : props2.items;
      const containerWidth = bglSlider.value.offsetWidth;
      const gapWidth = containerWidth * GAP_PERCENT / 100;
      const totalGapWidth = (itemCount.value - 1) * gapWidth;
      const singleItemWidth = (containerWidth - totalGapWidth) / itemCount.value;
      const gapsBeforeSlide = activeSlideIndex.value * gapWidth;
      const targetTransform = -(singleItemWidth * activeSlideIndex.value + gapsBeforeSlide);
      setTransform(targetTransform);
      updateHeight();
    }
    function clearAutoplay() {
      if (autoPlayInterval) clearInterval(autoPlayInterval);
    }
    function preventDefaultClick(e) {
      if (isDragging.value) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
    async function disableDrag() {
      await nextTick();
      if (!isSliderAvailable.value || !bglSlider.value) return;
      const elements = Array.from(bglSlider.value.querySelectorAll("img, a"));
      elements.forEach((el) => {
        el.setAttribute("draggable", "false");
        el.removeEventListener("click", preventDefaultClick, true);
        el.addEventListener("click", preventDefaultClick, true);
      });
      const slides = Array.from(bglSlider.value.children);
      slides.forEach((slide) => {
        const element = slide;
        element.setAttribute("draggable", "false");
        element.removeEventListener("click", preventDefaultClick, true);
        element.addEventListener("click", preventDefaultClick, true);
      });
    }
    function startDrag(e) {
      e.stopPropagation();
      if (e.button !== 0 || !props2.freeDrag || !isSliderAvailable.value) return;
      clearAutoplay();
      startX.value = e.pageX;
      translateX2.value = getCurrentTransform();
      isPressed.value = true;
      isDragging.value = false;
      document.addEventListener("mousemove", onDrag);
      document.addEventListener("mouseup", endDrag);
    }
    function onDrag(e) {
      if (!isSliderAvailable.value || !bglSlider.value || !isPressed.value) return;
      const x2 = e.pageX;
      const distance = x2 - startX.value;
      if (Math.abs(distance) > THRESHOLDS.DRAG) isDragging.value = true;
      if (isDragging.value) {
        const newTranslate = translateX2.value + (props2.rtl ? -distance : distance);
        const maxTranslate = 0;
        const containerWidth = bglSlider.value.offsetWidth;
        const gapWidth = containerWidth * GAP_PERCENT / 100;
        const totalGapWidth = (itemCount.value - 1) * gapWidth;
        const singleItemWidth = (containerWidth - totalGapWidth) / itemCount.value;
        const minTranslate = -(singleItemWidth * (slideCount.value - 1) + gapWidth * (slideCount.value - 1));
        const boundedTranslate = Math.max(minTranslate, Math.min(maxTranslate, newTranslate));
        setTransform(boundedTranslate);
      }
    }
    function endDrag() {
      isPressed.value = false;
      document.removeEventListener("mousemove", onDrag);
      document.removeEventListener("mouseup", endDrag);
      if (!isSliderAvailable.value || !bglSlider.value) return;
      const currentTransform = getCurrentTransform();
      const singleItemWidth = bglSlider.value.offsetWidth / itemCount.value;
      const currentPanel = -currentTransform / singleItemWidth;
      const totalDragDistance = currentTransform - translateX2.value;
      const dragPercentage = Math.abs(totalDragDistance) / singleItemWidth;
      let targetPanel = currentPanel;
      if (dragPercentage > THRESHOLDS.SWIPE_PERCENT) {
        const distnace = totalDragDistance > 0 ? -1 : 1;
        targetPanel = Math.floor(currentPanel) + (distnace < 0 ? 0 : 1);
      } else {
        targetPanel = Math.round(currentPanel);
      }
      targetPanel = Math.max(0, Math.min(targetPanel, slideCount.value - 1));
      goToSlide(targetPanel, true);
      if (isDragging.value) {
        setTimeout(() => {
          isDragging.value = false;
        }, 10);
      }
    }
    let hasScrollDirectionLock = ref(false);
    let isHorizontalScroll = ref(false);
    function onTouchStart(e) {
      if (!props2.freeDrag || !isSliderAvailable.value) return;
      const target = e.target;
      const isInteractive = target.matches('button, a, input, select, textarea, [role="button"]') || target.closest('button, a, input, select, textarea, [role="button"]');
      if (!isInteractive) {
        clearAutoplay();
        const touch = e.touches[0];
        startX.value = touch.pageX;
        startY.value = touch.pageY;
        lastX.value = touch.pageX;
        lastTime.value = Date.now();
        translateX2.value = getCurrentTransform();
        velocityTracker.value = [{ time: lastTime.value, position: lastX.value }];
        isPressed.value = true;
        hasScrollDirectionLock.value = false;
        if (bglSlider.value) {
          bglSlider.value.style.transition = "none";
        }
      }
    }
    function onTouchMove(e) {
      if (!isSliderAvailable.value || !bglSlider.value || !isPressed.value) return;
      const touch = e.touches[0];
      const x2 = touch.pageX;
      const y2 = touch.pageY;
      const deltaX = x2 - startX.value;
      const deltaY = y2 - startY.value;
      if (!hasScrollDirectionLock.value) {
        if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
          isHorizontalScroll.value = Math.abs(deltaX) > Math.abs(deltaY);
          hasScrollDirectionLock.value = true;
          if (!isHorizontalScroll.value) {
            isPressed.value = false;
            return;
          }
        }
        return;
      }
      if (!isHorizontalScroll.value) return;
      const now = Date.now();
      velocityTracker.value.push({ time: now, position: x2 });
      lastX.value = x2;
      const cutoffTime = now - VELOCITY_SAMPLE_DURATION;
      velocityTracker.value = velocityTracker.value.filter((sample) => sample.time >= cutoffTime);
      if (Math.abs(deltaX) > THRESHOLDS.TOUCH) {
        isDragging.value = true;
        e.preventDefault();
      }
      if (isDragging.value) {
        const containerWidth = bglSlider.value.offsetWidth;
        const gapWidth = containerWidth * GAP_PERCENT / 100;
        const totalGapWidth = (itemCount.value - 1) * gapWidth;
        const singleItemWidth = (containerWidth - totalGapWidth) / itemCount.value;
        const totalWidth = singleItemWidth * slideCount.value + gapWidth * (slideCount.value - 1);
        let newTranslate = translateX2.value + (props2.rtl ? -deltaX : deltaX);
        if (newTranslate > 0) {
          newTranslate = newTranslate * 0.5;
        } else if (newTranslate < -totalWidth + containerWidth) {
          const overDrag = -totalWidth + containerWidth - newTranslate;
          newTranslate = -totalWidth + containerWidth - overDrag * 0.5;
        }
        setTransform(newTranslate);
      }
    }
    function onTouchEnd() {
      if (!isSliderAvailable.value || !bglSlider.value || !isPressed.value || !isHorizontalScroll.value) {
        isPressed.value = false;
        hasScrollDirectionLock.value = false;
        return;
      }
      const containerWidth = bglSlider.value.offsetWidth;
      const gapWidth = containerWidth * GAP_PERCENT / 100;
      const totalGapWidth = (itemCount.value - 1) * gapWidth;
      const singleItemWidth = (containerWidth - totalGapWidth) / itemCount.value;
      const totalSlideWidth = singleItemWidth + gapWidth;
      const currentTransform = getCurrentTransform();
      let normalizedTransform = currentTransform;
      if (currentTransform > 0) {
        normalizedTransform = 0;
      } else {
        const minTransform = -(singleItemWidth * (slideCount.value - 1) + gapWidth * (slideCount.value - 1));
        if (currentTransform < minTransform) {
          normalizedTransform = minTransform;
        }
      }
      const currentPanel = Math.abs(normalizedTransform / totalSlideWidth);
      const totalSwipeDistance = lastX.value - startX.value;
      const swipePercentage = Math.abs(totalSwipeDistance) / totalSlideWidth;
      const finalVelocity = getAverageVelocity();
      let targetPanel = currentPanel;
      let velocityDirection = 0;
      if (Math.abs(finalVelocity) > THRESHOLDS.VELOCITY) {
        velocityDirection = finalVelocity < 0 ? 1 : -1;
      }
      const isMobile = window.innerWidth < 600;
      if (swipePercentage > THRESHOLDS.SWIPE_PERCENT || Math.abs(finalVelocity) > THRESHOLDS.VELOCITY) {
        const direction = swipePercentage > THRESHOLDS.SWIPE_PERCENT ? totalSwipeDistance > 0 ? -1 : 1 : velocityDirection;
        const rtlDirection = props2.rtl ? -direction : direction;
        if (isMobile) {
          targetPanel = activeSlideIndex.value + rtlDirection;
        } else {
          targetPanel = Math.round(currentPanel) + rtlDirection;
        }
      } else {
        targetPanel = isMobile ? activeSlideIndex.value : Math.round(currentPanel);
      }
      targetPanel = Math.max(0, Math.min(targetPanel, slideCount.value - 1));
      activeSlideIndex.value = targetPanel;
      const distance = Math.abs(targetPanel - currentPanel);
      const velocityFactor = Math.min(Math.abs(finalVelocity) * 1e3, 1);
      const duration = Math.min(
        ANIMATION_TIMINGS.BASE_DURATION * (1 - velocityFactor * 0.5) + distance * ANIMATION_TIMINGS.DURATION_PER_PANEL,
        ANIMATION_TIMINGS.MAX_DURATION
      );
      bglSlider.value.style.transition = `transform ${duration}ms cubic-bezier(0.4, 0, 0.2, 1)`;
      const gapsBeforeSlide = targetPanel * gapWidth;
      const targetTransform = -(singleItemWidth * targetPanel + gapsBeforeSlide);
      setTransform(targetTransform);
      setTimeout(() => {
        if (bglSlider.value) bglSlider.value.style.transition = "none";
      }, duration);
      velocityTracker.value = [];
      isDragging.value = false;
      hasScrollDirectionLock.value = false;
    }
    function onWheel(e) {
      if (!props2.allowScroll || !isSliderAvailable.value || !bglSlider.value || isPressed.value || isDragging.value) return;
      const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
      if (!isHorizontal) return;
      clearAutoplay();
      if (wheelTimeout) clearTimeout(wheelTimeout);
      accumulatedDeltaX.value += props2.rtl ? -e.deltaX : e.deltaX;
      wheelTimeout = setTimeout(() => {
        accumulatedDeltaX.value = 0;
      }, 50);
      const singleItemWidth = bglSlider.value.offsetWidth / itemCount.value;
      const moveThreshold = singleItemWidth * THRESHOLDS.WHEEL_PERCENT;
      if (Math.abs(accumulatedDeltaX.value) > moveThreshold) {
        const direction = accumulatedDeltaX.value > 0 ? 1 : -1;
        const nextPanel = Math.max(0, Math.min(activeSlideIndex.value + direction, slideCount.value - 1));
        if (nextPanel !== activeSlideIndex.value) {
          goToSlide(nextPanel, true);
          accumulatedDeltaX.value = 0;
        }
      }
    }
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      updateHeight();
      handleResize();
      countSlides();
      disableDrag();
      if (bglSlider.value) {
        slideCount.value = bglSlider.value.children.length;
      }
      if (props2.autoplay) {
        autoPlayInterval = setInterval(next, props2.autoPlaySpeed);
      }
    });
    onUnmounted(() => {
      if (isSliderAvailable.value && bglSlider.value) {
        Array.from(bglSlider.value.children).forEach((child) => {
          const element = child;
          element.removeEventListener("click", preventDefaultClick);
        });
      }
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousemove", onDrag);
      document.removeEventListener("mouseup", endDrag);
      clearAutoplay();
      if (wheelTimeout) clearTimeout(wheelTimeout);
    });
    watch(() => props2.index, (newIndex2) => {
      goToSlide(newIndex2);
    });
    watch(() => activeSlideIndex.value, handleSlideChange);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "BglCarousel",
        dir: __props.rtl ? "rtl" : "ltr"
      }, [
        createElementVNode("div", {
          ref_key: "bglSlider",
          ref: bglSlider,
          class: normalizeClass(["bgl-slider", { dragging: unref(isDragging), clicking: unref(isPressed), [`slides-${unref(itemCount)}`]: true, grab: __props.freeDrag && unref(slideCount) > 1, autoHeight: __props.autoHeight }]),
          style: normalizeStyle({ "--item-count": unref(itemCount), "height": unref(yHeight) }),
          onMousedown: startDrag,
          onMouseover: clearAutoplay,
          onFocusin: clearAutoplay,
          onTouchstart: onTouchStart,
          onTouchmove: onTouchMove,
          onTouchend: onTouchEnd,
          onWheel
        }, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 38),
        props2.dots && unref(slideCount) > 1 ? (openBlock(), createElementBlock("div", _hoisted_2$D, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(slideCount), (i2) => {
            return openBlock(), createElementBlock("span", {
              key: i2,
              class: normalizeClass(["dot", { current: unref(activeSlideIndex) === i2 - 1 }]),
              onClick: ($event) => goToSlide(i2 - 1)
            }, null, 10, _hoisted_3$x);
          }), 128))
        ])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(["navigation-buttons", { rtl: __props.rtl }])
        }, [
          createElementVNode("span", {
            class: "prev",
            onClick: prev
          }, [
            renderSlot(_ctx.$slots, "prev", {
              index: unref(activeSlideIndex),
              prev
            }, void 0, true)
          ]),
          createElementVNode("span", {
            class: "next",
            onClick: next
          }, [
            renderSlot(_ctx.$slots, "next", {
              index: unref(activeSlideIndex),
              next
            }, void 0, true)
          ])
        ], 2)
      ], 8, _hoisted_1$R);
    };
  }
});
const Carousel = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["__scopeId", "data-v-c2b21a75"]]);
function _isPlaceholder(a2) {
  return a2 != null && typeof a2 === "object" && a2["@@functional/placeholder"] === true;
}
function _curry1(fn) {
  return function f1(a2) {
    if (arguments.length === 0 || _isPlaceholder(a2)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}
function _curry2(fn) {
  return function f2(a2, b2) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a2) ? f2 : _curry1(function(_b) {
          return fn(a2, _b);
        });
      default:
        return _isPlaceholder(a2) && _isPlaceholder(b2) ? f2 : _isPlaceholder(a2) ? _curry1(function(_a) {
          return fn(_a, b2);
        }) : _isPlaceholder(b2) ? _curry1(function(_b) {
          return fn(a2, _b);
        }) : fn(a2, b2);
    }
  };
}
function _arity(n2, fn) {
  switch (n2) {
    case 0:
      return function() {
        return fn.apply(this, arguments);
      };
    case 1:
      return function(a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function(a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function(a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function(a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function(a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function(a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function(a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function(a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
function _curryN(length, received, fn) {
  return function() {
    var combined = [];
    var argsIdx = 0;
    var left2 = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result2;
      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result2 = received[combinedIdx];
      } else {
        result2 = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result2;
      if (!_isPlaceholder(result2)) {
        left2 -= 1;
      }
      combinedIdx += 1;
    }
    return left2 <= 0 ? fn.apply(this, combined) : _arity(left2, _curryN(length, combined, fn));
  };
}
var curryN = /* @__PURE__ */ _curry2(function curryN2(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});
function _curry3(fn) {
  return function f3(a2, b2, c2) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a2) ? f3 : _curry2(function(_b, _c) {
          return fn(a2, _b, _c);
        });
      case 2:
        return _isPlaceholder(a2) && _isPlaceholder(b2) ? f3 : _isPlaceholder(a2) ? _curry2(function(_a, _c) {
          return fn(_a, b2, _c);
        }) : _isPlaceholder(b2) ? _curry2(function(_b, _c) {
          return fn(a2, _b, _c);
        }) : _curry1(function(_c) {
          return fn(a2, b2, _c);
        });
      default:
        return _isPlaceholder(a2) && _isPlaceholder(b2) && _isPlaceholder(c2) ? f3 : _isPlaceholder(a2) && _isPlaceholder(b2) ? _curry2(function(_a, _b) {
          return fn(_a, _b, c2);
        }) : _isPlaceholder(a2) && _isPlaceholder(c2) ? _curry2(function(_a, _c) {
          return fn(_a, b2, _c);
        }) : _isPlaceholder(b2) && _isPlaceholder(c2) ? _curry2(function(_b, _c) {
          return fn(a2, _b, _c);
        }) : _isPlaceholder(a2) ? _curry1(function(_a) {
          return fn(_a, b2, c2);
        }) : _isPlaceholder(b2) ? _curry1(function(_b) {
          return fn(a2, _b, c2);
        }) : _isPlaceholder(c2) ? _curry1(function(_c) {
          return fn(a2, b2, _c);
        }) : fn(a2, b2, c2);
    }
  };
}
var _isArray = Array.isArray || function _isArray2(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};
function _isTransformer(obj) {
  return obj != null && typeof obj["@@transducer/step"] === "function";
}
function _dispatchable(methodNames, transducerCreator, fn) {
  return function() {
    if (arguments.length === 0) {
      return fn();
    }
    var obj = arguments[arguments.length - 1];
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === "function") {
          return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}
var _xfBase = {
  init: function() {
    return this.xf["@@transducer/init"]();
  },
  result: function(result2) {
    return this.xf["@@transducer/result"](result2);
  }
};
function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result2 = Array(len);
  while (idx < len) {
    result2[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result2;
}
function _isString(x2) {
  return Object.prototype.toString.call(x2) === "[object String]";
}
var _isArrayLike = /* @__PURE__ */ _curry1(function isArrayLike(x2) {
  if (_isArray(x2)) {
    return true;
  }
  if (!x2) {
    return false;
  }
  if (typeof x2 !== "object") {
    return false;
  }
  if (_isString(x2)) {
    return false;
  }
  if (x2.length === 0) {
    return true;
  }
  if (x2.length > 0) {
    return x2.hasOwnProperty(0) && x2.hasOwnProperty(x2.length - 1);
  }
  return false;
});
var XWrap = /* @__PURE__ */ function() {
  function XWrap2(fn) {
    this.f = fn;
  }
  XWrap2.prototype["@@transducer/init"] = function() {
    throw new Error("init not implemented on XWrap");
  };
  XWrap2.prototype["@@transducer/result"] = function(acc) {
    return acc;
  };
  XWrap2.prototype["@@transducer/step"] = function(acc, x2) {
    return this.f(acc, x2);
  };
  return XWrap2;
}();
function _xwrap(fn) {
  return new XWrap(fn);
}
var bind$1 = /* @__PURE__ */ _curry2(function bind2(fn, thisObj) {
  return _arity(fn.length, function() {
    return fn.apply(thisObj, arguments);
  });
});
function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf["@@transducer/step"](acc, list[idx]);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    idx += 1;
  }
  return xf["@@transducer/result"](acc);
}
function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf["@@transducer/step"](acc, step.value);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    step = iter.next();
  }
  return xf["@@transducer/result"](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
  return xf["@@transducer/result"](obj[methodName](bind$1(xf["@@transducer/step"], xf), acc));
}
var symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function _reduce(fn, acc, list) {
  if (typeof fn === "function") {
    fn = _xwrap(fn);
  }
  if (_isArrayLike(list)) {
    return _arrayReduce(fn, acc, list);
  }
  if (typeof list["fantasy-land/reduce"] === "function") {
    return _methodReduce(fn, acc, list, "fantasy-land/reduce");
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }
  if (typeof list.next === "function") {
    return _iterableReduce(fn, acc, list);
  }
  if (typeof list.reduce === "function") {
    return _methodReduce(fn, acc, list, "reduce");
  }
  throw new TypeError("reduce: list must be array or iterable");
}
var XMap = /* @__PURE__ */ function() {
  function XMap2(f2, xf) {
    this.xf = xf;
    this.f = f2;
  }
  XMap2.prototype["@@transducer/init"] = _xfBase.init;
  XMap2.prototype["@@transducer/result"] = _xfBase.result;
  XMap2.prototype["@@transducer/step"] = function(result2, input) {
    return this.xf["@@transducer/step"](result2, this.f(input));
  };
  return XMap2;
}();
var _xmap = /* @__PURE__ */ _curry2(function _xmap2(f2, xf) {
  return new XMap(f2, xf);
});
function _has(prop3, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop3);
}
var toString$1$1 = Object.prototype.toString;
var _isArguments = /* @__PURE__ */ function() {
  return toString$1$1.call(arguments) === "[object Arguments]" ? function _isArguments2(x2) {
    return toString$1$1.call(x2) === "[object Arguments]";
  } : function _isArguments2(x2) {
    return _has("callee", x2);
  };
}();
var hasEnumBug = !/* @__PURE__ */ {
  toString: null
}.propertyIsEnumerable("toString");
var nonEnumerableProps = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"];
var hasArgsEnumBug = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}();
var contains = function contains2(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};
var keys = typeof Object.keys === "function" && !hasArgsEnumBug ? /* @__PURE__ */ _curry1(function keys2(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /* @__PURE__ */ _curry1(function keys3(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop3, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
  for (prop3 in obj) {
    if (_has(prop3, obj) && (!checkArgsLength || prop3 !== "length")) {
      ks[ks.length] = prop3;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop3 = nonEnumerableProps[nIdx];
      if (_has(prop3, obj) && !contains(ks, prop3)) {
        ks[ks.length] = prop3;
      }
      nIdx -= 1;
    }
  }
  return ks;
});
var map$1 = /* @__PURE__ */ _curry2(
  /* @__PURE__ */ _dispatchable(["fantasy-land/map", "map"], _xmap, function map2(fn, functor) {
    switch (Object.prototype.toString.call(functor)) {
      case "[object Function]":
        return curryN(functor.length, function() {
          return fn.call(this, functor.apply(this, arguments));
        });
      case "[object Object]":
        return _reduce(function(acc, key) {
          acc[key] = fn(functor[key]);
          return acc;
        }, {}, keys(functor));
      default:
        return _map(fn, functor);
    }
  })
);
var map$2 = map$1;
var _isInteger = Number.isInteger || function _isInteger2(n2) {
  return n2 << 0 === n2;
};
var nth = /* @__PURE__ */ _curry2(function nth2(offset2, list) {
  var idx = offset2 < 0 ? list.length + offset2 : offset2;
  return _isString(list) ? list.charAt(idx) : list[idx];
});
var nth$1 = nth;
var prop = /* @__PURE__ */ _curry2(function prop2(p2, obj) {
  if (obj == null) {
    return;
  }
  return _isInteger(p2) ? nth$1(p2, obj) : obj[p2];
});
var prop$1 = prop;
var reduce = /* @__PURE__ */ _curry3(_reduce);
var reduce$1 = reduce;
var values = /* @__PURE__ */ _curry1(function values2(obj) {
  var props2 = keys(obj);
  var len = props2.length;
  var vals = [];
  var idx = 0;
  while (idx < len) {
    vals[idx] = obj[props2[idx]];
    idx += 1;
  }
  return vals;
});
var values$1 = values;
function _isFunction(x2) {
  var type3 = Object.prototype.toString.call(x2);
  return type3 === "[object Function]" || type3 === "[object AsyncFunction]" || type3 === "[object GeneratorFunction]" || type3 === "[object AsyncGeneratorFunction]";
}
var type = /* @__PURE__ */ _curry1(function type2(val) {
  return val === null ? "Null" : val === void 0 ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
function _pipe(f2, g2) {
  return function() {
    return g2.call(this, f2.apply(this, arguments));
  };
}
function _checkForMethod(methodname, fn) {
  return function() {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return _isArray(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
}
var slice = /* @__PURE__ */ _curry3(
  /* @__PURE__ */ _checkForMethod("slice", function slice2(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
  })
);
var tail = /* @__PURE__ */ _curry1(
  /* @__PURE__ */ _checkForMethod(
    "tail",
    /* @__PURE__ */ slice(1, Infinity)
  )
);
var tail$1 = tail;
function pipe() {
  if (arguments.length === 0) {
    throw new Error("pipe requires at least one argument");
  }
  return _arity(arguments[0].length, reduce$1(_pipe, arguments[0], tail$1(arguments)));
}
function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}
function _includesWith(pred, x2, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (pred(x2, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}
function _functionName(f2) {
  var match = String(f2).match(/^function (\w*)/);
  return match == null ? "" : match[1];
}
function _objectIs(a2, b2) {
  if (a2 === b2) {
    return a2 !== 0 || 1 / a2 === 1 / b2;
  } else {
    return a2 !== a2 && b2 !== b2;
  }
}
var _objectIs$1 = typeof Object.is === "function" ? Object.is : _objectIs;
function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a2 = _arrayFromIterator(aIterator);
  var b2 = _arrayFromIterator(bIterator);
  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  }
  return !_includesWith(function(b3, aItem) {
    return !_includesWith(eq, aItem, b3);
  }, b2, a2);
}
function _equals(a2, b2, stackA, stackB) {
  if (_objectIs$1(a2, b2)) {
    return true;
  }
  var typeA = type(a2);
  if (typeA !== type(b2)) {
    return false;
  }
  if (typeof a2["fantasy-land/equals"] === "function" || typeof b2["fantasy-land/equals"] === "function") {
    return typeof a2["fantasy-land/equals"] === "function" && a2["fantasy-land/equals"](b2) && typeof b2["fantasy-land/equals"] === "function" && b2["fantasy-land/equals"](a2);
  }
  if (typeof a2.equals === "function" || typeof b2.equals === "function") {
    return typeof a2.equals === "function" && a2.equals(b2) && typeof b2.equals === "function" && b2.equals(a2);
  }
  switch (typeA) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof a2.constructor === "function" && _functionName(a2.constructor) === "Promise") {
        return a2 === b2;
      }
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof a2 === typeof b2 && _objectIs$1(a2.valueOf(), b2.valueOf()))) {
        return false;
      }
      break;
    case "Date":
      if (!_objectIs$1(a2.valueOf(), b2.valueOf())) {
        return false;
      }
      break;
    case "Error":
      return a2.name === b2.name && a2.message === b2.message;
    case "RegExp":
      if (!(a2.source === b2.source && a2.global === b2.global && a2.ignoreCase === b2.ignoreCase && a2.multiline === b2.multiline && a2.sticky === b2.sticky && a2.unicode === b2.unicode)) {
        return false;
      }
      break;
  }
  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a2) {
      return stackB[idx] === b2;
    }
    idx -= 1;
  }
  switch (typeA) {
    case "Map":
      if (a2.size !== b2.size) {
        return false;
      }
      return _uniqContentEquals(a2.entries(), b2.entries(), stackA.concat([a2]), stackB.concat([b2]));
    case "Set":
      if (a2.size !== b2.size) {
        return false;
      }
      return _uniqContentEquals(a2.values(), b2.values(), stackA.concat([a2]), stackB.concat([b2]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return false;
  }
  var keysA = keys(a2);
  if (keysA.length !== keys(b2).length) {
    return false;
  }
  var extendedStackA = stackA.concat([a2]);
  var extendedStackB = stackB.concat([b2]);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b2) && _equals(b2[key], a2[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}
var equals = /* @__PURE__ */ _curry2(function equals2(a2, b2) {
  return _equals(a2, b2, [], []);
});
function _indexOf(list, a2, idx) {
  var inf, item;
  if (typeof list.indexOf === "function") {
    switch (typeof a2) {
      case "number":
        if (a2 === 0) {
          inf = 1 / a2;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a2 !== a2) {
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === "number" && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        return list.indexOf(a2, idx);
      // all these types can utilise Set
      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return list.indexOf(a2, idx);
      case "object":
        if (a2 === null) {
          return list.indexOf(a2, idx);
        }
    }
  }
  while (idx < list.length) {
    if (equals(list[idx], a2)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}
function _includes(a2, list) {
  return _indexOf(list, a2, 0) >= 0;
}
function _quote(s2) {
  var escaped = s2.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
  return '"' + escaped.replace(/"/g, '\\"') + '"';
}
var pad = function pad2(n2) {
  return (n2 < 10 ? "0" : "") + n2;
};
var _toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString2(d2) {
  return d2.toISOString();
} : function _toISOString3(d2) {
  return d2.getUTCFullYear() + "-" + pad(d2.getUTCMonth() + 1) + "-" + pad(d2.getUTCDate()) + "T" + pad(d2.getUTCHours()) + ":" + pad(d2.getUTCMinutes()) + ":" + pad(d2.getUTCSeconds()) + "." + (d2.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
};
function _complement(f2) {
  return function() {
    return !f2.apply(this, arguments);
  };
}
function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result2 = [];
  while (idx < len) {
    if (fn(list[idx])) {
      result2[result2.length] = list[idx];
    }
    idx += 1;
  }
  return result2;
}
function _isObject(x2) {
  return Object.prototype.toString.call(x2) === "[object Object]";
}
var XFilter = /* @__PURE__ */ function() {
  function XFilter2(f2, xf) {
    this.xf = xf;
    this.f = f2;
  }
  XFilter2.prototype["@@transducer/init"] = _xfBase.init;
  XFilter2.prototype["@@transducer/result"] = _xfBase.result;
  XFilter2.prototype["@@transducer/step"] = function(result2, input) {
    return this.f(input) ? this.xf["@@transducer/step"](result2, input) : result2;
  };
  return XFilter2;
}();
var _xfilter = /* @__PURE__ */ _curry2(function _xfilter2(f2, xf) {
  return new XFilter(f2, xf);
});
var filter$1 = /* @__PURE__ */ _curry2(
  /* @__PURE__ */ _dispatchable(["fantasy-land/filter", "filter"], _xfilter, function(pred, filterable) {
    return _isObject(filterable) ? _reduce(function(acc, key) {
      if (pred(filterable[key])) {
        acc[key] = filterable[key];
      }
      return acc;
    }, {}, keys(filterable)) : (
      // else
      _filter(pred, filterable)
    );
  })
);
var reject = /* @__PURE__ */ _curry2(function reject2(pred, filterable) {
  return filter$1(_complement(pred), filterable);
});
function _toString(x2, seen) {
  var recur = function recur2(y2) {
    var xs = seen.concat([x2]);
    return _includes(y2, xs) ? "<Circular>" : _toString(y2, xs);
  };
  var mapPairs = function(obj, keys4) {
    return _map(function(k2) {
      return _quote(k2) + ": " + recur(obj[k2]);
    }, keys4.slice().sort());
  };
  switch (Object.prototype.toString.call(x2)) {
    case "[object Arguments]":
      return "(function() { return arguments; }(" + _map(recur, x2).join(", ") + "))";
    case "[object Array]":
      return "[" + _map(recur, x2).concat(mapPairs(x2, reject(function(k2) {
        return /^\d+$/.test(k2);
      }, keys(x2)))).join(", ") + "]";
    case "[object Boolean]":
      return typeof x2 === "object" ? "new Boolean(" + recur(x2.valueOf()) + ")" : x2.toString();
    case "[object Date]":
      return "new Date(" + (isNaN(x2.valueOf()) ? recur(NaN) : _quote(_toISOString(x2))) + ")";
    case "[object Null]":
      return "null";
    case "[object Number]":
      return typeof x2 === "object" ? "new Number(" + recur(x2.valueOf()) + ")" : 1 / x2 === -Infinity ? "-0" : x2.toString(10);
    case "[object String]":
      return typeof x2 === "object" ? "new String(" + recur(x2.valueOf()) + ")" : _quote(x2);
    case "[object Undefined]":
      return "undefined";
    default:
      if (typeof x2.toString === "function") {
        var repr = x2.toString();
        if (repr !== "[object Object]") {
          return repr;
        }
      }
      return "{" + mapPairs(x2, keys(x2)).join(", ") + "}";
  }
}
var toString$2 = /* @__PURE__ */ _curry1(function toString2(val) {
  return _toString(val, []);
});
var curry = /* @__PURE__ */ _curry1(function curry2(fn) {
  return curryN(fn.length, fn);
});
var curry$1 = curry;
var invoker = /* @__PURE__ */ _curry2(function invoker2(arity, method) {
  return curryN(arity + 1, function() {
    var target = arguments[arity];
    if (target != null && _isFunction(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }
    throw new TypeError(toString$2(target) + ' does not have a method named "' + method + '"');
  });
});
var invoker$1 = invoker;
var is = /* @__PURE__ */ _curry2(function is2(Ctor, val) {
  return val instanceof Ctor || val != null && (val.constructor === Ctor || Ctor.name === "Object" && typeof val === "object");
});
var is$1 = is;
var join = /* @__PURE__ */ invoker$1(1, "join");
var join$1 = join;
var mergeWithKey = /* @__PURE__ */ _curry3(function mergeWithKey2(fn, l2, r2) {
  var result2 = {};
  var k2;
  for (k2 in l2) {
    if (_has(k2, l2)) {
      result2[k2] = _has(k2, r2) ? fn(k2, l2[k2], r2[k2]) : l2[k2];
    }
  }
  for (k2 in r2) {
    if (_has(k2, r2) && !_has(k2, result2)) {
      result2[k2] = r2[k2];
    }
  }
  return result2;
});
var mergeDeepWithKey = /* @__PURE__ */ _curry3(function mergeDeepWithKey2(fn, lObj, rObj) {
  return mergeWithKey(function(k2, lVal, rVal) {
    if (_isObject(lVal) && _isObject(rVal)) {
      return mergeDeepWithKey2(fn, lVal, rVal);
    } else {
      return fn(k2, lVal, rVal);
    }
  }, lObj, rObj);
});
var mergeDeepLeft = /* @__PURE__ */ _curry2(function mergeDeepLeft2(lObj, rObj) {
  return mergeDeepWithKey(function(k2, lVal, rVal) {
    return lVal;
  }, lObj, rObj);
});
var mergeDeepLeft$1 = mergeDeepLeft;
var omit = /* @__PURE__ */ _curry2(function omit2(names, obj) {
  var result2 = {};
  var index2 = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    index2[names[idx]] = 1;
    idx += 1;
  }
  for (var prop3 in obj) {
    if (!index2.hasOwnProperty(prop3)) {
      result2[prop3] = obj[prop3];
    }
  }
  return result2;
});
var omit$1 = omit;
var pickBy = /* @__PURE__ */ _curry2(function pickBy2(test2, obj) {
  var result2 = {};
  for (var prop3 in obj) {
    if (test2(obj[prop3], prop3, obj)) {
      result2[prop3] = obj[prop3];
    }
  }
  return result2;
});
var pickBy$1 = pickBy;
var split = /* @__PURE__ */ invoker$1(1, "split");
var split$1 = split;
var toLower = /* @__PURE__ */ invoker$1(0, "toLowerCase");
var toLower$1 = toLower;
var zipObj = /* @__PURE__ */ _curry2(function zipObj2(keys4, values3) {
  var idx = 0;
  var len = Math.min(keys4.length, values3.length);
  var out = {};
  while (idx < len) {
    out[keys4[idx]] = values3[idx];
    idx += 1;
  }
  return out;
});
var zipObj$1 = zipObj;
pipe(toLower$1, split$1(" "), join$1("-"));
const getCol = curry$1((col, df) => {
  if (is$1(Number)) {
    return map$2((v2) => nth$1(col, v2) || "", df).filter((x2) => x2 !== "");
  }
  return map$2(prop$1(col), df);
});
const mapKeys = (fn, data2) => zipObj$1(map$2(fn, keys(data2)), values$1(data2));
const kebabize = (str) => {
  return str.split("").map((letter, idx) => {
    return letter.toUpperCase() === letter ? `${idx !== 0 ? "-" : ""}${letter.toLowerCase()}` : letter;
  }).join("");
};
function ascending$1(a2, b2) {
  return a2 == null || b2 == null ? NaN : a2 < b2 ? -1 : a2 > b2 ? 1 : a2 >= b2 ? 0 : NaN;
}
function descending$1(a2, b2) {
  return a2 == null || b2 == null ? NaN : b2 < a2 ? -1 : b2 > a2 ? 1 : b2 >= a2 ? 0 : NaN;
}
function bisector(f2) {
  let compare1, compare2, delta;
  if (f2.length !== 2) {
    compare1 = ascending$1;
    compare2 = (d2, x2) => ascending$1(f2(d2), x2);
    delta = (d2, x2) => f2(d2) - x2;
  } else {
    compare1 = f2 === ascending$1 || f2 === descending$1 ? f2 : zero$1;
    compare2 = f2;
    delta = f2;
  }
  function left2(a2, x2, lo = 0, hi = a2.length) {
    if (lo < hi) {
      if (compare1(x2, x2) !== 0) return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a2[mid], x2) < 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right2(a2, x2, lo = 0, hi = a2.length) {
    if (lo < hi) {
      if (compare1(x2, x2) !== 0) return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a2[mid], x2) <= 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center2(a2, x2, lo = 0, hi = a2.length) {
    const i2 = left2(a2, x2, lo, hi - 1);
    return i2 > lo && delta(a2[i2 - 1], x2) > -delta(a2[i2], x2) ? i2 - 1 : i2;
  }
  return { left: left2, center: center2, right: right2 };
}
function zero$1() {
  return 0;
}
function number$2(x2) {
  return x2 === null ? NaN : +x2;
}
const ascendingBisect = bisector(ascending$1);
const bisectRight = ascendingBisect.right;
const bisectCenter = bisector(number$2).center;
function extent(values3, valueof) {
  let min2;
  let max2;
  {
    for (const value of values3) {
      if (value != null) {
        if (min2 === void 0) {
          if (value >= value) min2 = max2 = value;
        } else {
          if (min2 > value) min2 = value;
          if (max2 < value) max2 = value;
        }
      }
    }
  }
  return [min2, max2];
}
class InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
    if (entries != null) for (const [key2, value] of entries) this.set(key2, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}
function intern_get({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count2) {
  const step = (stop - start) / Math.max(0, count2), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start * inc);
    i2 = Math.round(stop * inc);
    if (i1 / inc < start) ++i1;
    if (i2 / inc > stop) --i2;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start / inc);
    i2 = Math.round(stop / inc);
    if (i1 * inc < start) ++i1;
    if (i2 * inc > stop) --i2;
  }
  if (i2 < i1 && 0.5 <= count2 && count2 < 2) return tickSpec(start, stop, count2 * 2);
  return [i1, i2, inc];
}
function ticks(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  if (!(count2 > 0)) return [];
  if (start === stop) return [start];
  const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count2) : tickSpec(start, stop, count2);
  if (!(i2 >= i1)) return [];
  const n2 = i2 - i1 + 1, ticks2 = new Array(n2);
  if (reverse) {
    if (inc < 0) for (let i3 = 0; i3 < n2; ++i3) ticks2[i3] = (i2 - i3) / -inc;
    else for (let i3 = 0; i3 < n2; ++i3) ticks2[i3] = (i2 - i3) * inc;
  } else {
    if (inc < 0) for (let i3 = 0; i3 < n2; ++i3) ticks2[i3] = (i1 + i3) / -inc;
    else for (let i3 = 0; i3 < n2; ++i3) ticks2[i3] = (i1 + i3) * inc;
  }
  return ticks2;
}
function tickIncrement(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  return tickSpec(start, stop, count2)[2];
}
function tickStep(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count2) : tickIncrement(start, stop, count2);
  return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}
function max$1(values3, valueof) {
  let max2;
  if (valueof === void 0) {
    for (const value of values3) {
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values3) {
      if ((value = valueof(value, ++index2, values3)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  }
  return max2;
}
function min$1(values3, valueof) {
  let min2;
  if (valueof === void 0) {
    for (const value of values3) {
      if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values3) {
      if ((value = valueof(value, ++index2, values3)) != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  }
  return min2;
}
function range(start, stop, step) {
  start = +start, stop = +stop, step = (n2 = arguments.length) < 2 ? (stop = start, start = 0, 1) : n2 < 3 ? 1 : +step;
  var i2 = -1, n2 = Math.max(0, Math.ceil((stop - start) / step)) | 0, range2 = new Array(n2);
  while (++i2 < n2) {
    range2[i2] = start + i2 * step;
  }
  return range2;
}
function initRange(domain2, range2) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain2);
      break;
    default:
      this.range(range2).domain(domain2);
      break;
  }
  return this;
}
function initInterpolator(domain2, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain2 === "function") this.interpolator(domain2);
      else this.range(domain2);
      break;
    }
    default: {
      this.domain(domain2);
      if (typeof interpolator === "function") this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}
const implicit = Symbol("implicit");
function ordinal() {
  var index2 = new InternMap(), domain2 = [], range2 = [], unknown = implicit;
  function scale(d2) {
    let i2 = index2.get(d2);
    if (i2 === void 0) {
      if (unknown !== implicit) return unknown;
      index2.set(d2, i2 = domain2.push(d2) - 1);
    }
    return range2[i2 % range2.length];
  }
  scale.domain = function(_2) {
    if (!arguments.length) return domain2.slice();
    domain2 = [], index2 = new InternMap();
    for (const value of _2) {
      if (index2.has(value)) continue;
      index2.set(value, domain2.push(value) - 1);
    }
    return scale;
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), scale) : range2.slice();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown = _2, scale) : unknown;
  };
  scale.copy = function() {
    return ordinal(domain2, range2).unknown(unknown);
  };
  initRange.apply(scale, arguments);
  return scale;
}
function band() {
  var scale = ordinal().unknown(void 0), domain2 = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
  delete scale.unknown;
  function rescale() {
    var n2 = domain2().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n2 - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n2 - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values3 = range(n2).map(function(i2) {
      return start + step * i2;
    });
    return ordinalRange(reverse ? values3.reverse() : values3);
  }
  scale.domain = function(_2) {
    return arguments.length ? (domain2(_2), rescale()) : domain2();
  };
  scale.range = function(_2) {
    return arguments.length ? ([r0, r1] = _2, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale.rangeRound = function(_2) {
    return [r0, r1] = _2, r0 = +r0, r1 = +r1, round = true, rescale();
  };
  scale.bandwidth = function() {
    return bandwidth;
  };
  scale.step = function() {
    return step;
  };
  scale.round = function(_2) {
    return arguments.length ? (round = !!_2, rescale()) : round;
  };
  scale.padding = function(_2) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_2), rescale()) : paddingInner;
  };
  scale.paddingInner = function(_2) {
    return arguments.length ? (paddingInner = Math.min(1, _2), rescale()) : paddingInner;
  };
  scale.paddingOuter = function(_2) {
    return arguments.length ? (paddingOuter = +_2, rescale()) : paddingOuter;
  };
  scale.align = function(_2) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _2)), rescale()) : align;
  };
  scale.copy = function() {
    return band(domain2(), [r0, r1]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return initRange.apply(rescale(), arguments);
}
function define(constructor, factory, prototype2) {
  constructor.prototype = factory.prototype = prototype2;
  prototype2.constructor = constructor;
}
function extend$2(parent, definition) {
  var prototype2 = Object.create(parent.prototype);
  for (var key in definition) prototype2[key] = definition[key];
  return prototype2;
}
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m2, l2;
  format2 = (format2 + "").trim().toLowerCase();
  return (m2 = reHex.exec(format2)) ? (l2 = m2[1].length, m2 = parseInt(m2[1], 16), l2 === 6 ? rgbn(m2) : l2 === 3 ? new Rgb(m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, (m2 & 15) << 4 | m2 & 15, 1) : l2 === 8 ? rgba(m2 >> 24 & 255, m2 >> 16 & 255, m2 >> 8 & 255, (m2 & 255) / 255) : l2 === 4 ? rgba(m2 >> 12 & 15 | m2 >> 8 & 240, m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, ((m2 & 15) << 4 | m2 & 15) / 255) : null) : (m2 = reRgbInteger.exec(format2)) ? new Rgb(m2[1], m2[2], m2[3], 1) : (m2 = reRgbPercent.exec(format2)) ? new Rgb(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, 1) : (m2 = reRgbaInteger.exec(format2)) ? rgba(m2[1], m2[2], m2[3], m2[4]) : (m2 = reRgbaPercent.exec(format2)) ? rgba(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, m2[4]) : (m2 = reHslPercent.exec(format2)) ? hsla(m2[1], m2[2] / 100, m2[3] / 100, 1) : (m2 = reHslaPercent.exec(format2)) ? hsla(m2[1], m2[2] / 100, m2[3] / 100, m2[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n2) {
  return new Rgb(n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255, 1);
}
function rgba(r2, g2, b2, a2) {
  if (a2 <= 0) r2 = g2 = b2 = NaN;
  return new Rgb(r2, g2, b2, a2);
}
function rgbConvert(o2) {
  if (!(o2 instanceof Color)) o2 = color(o2);
  if (!o2) return new Rgb();
  o2 = o2.rgb();
  return new Rgb(o2.r, o2.g, o2.b, o2.opacity);
}
function rgb$1(r2, g2, b2, opacity) {
  return arguments.length === 1 ? rgbConvert(r2) : new Rgb(r2, g2, b2, opacity == null ? 1 : opacity);
}
function Rgb(r2, g2, b2, opacity) {
  this.r = +r2;
  this.g = +g2;
  this.b = +b2;
  this.opacity = +opacity;
}
define(Rgb, rgb$1, extend$2(Color, {
  brighter(k2) {
    k2 = k2 == null ? brighter : Math.pow(brighter, k2);
    return new Rgb(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  darker(k2) {
    k2 = k2 == null ? darker : Math.pow(darker, k2);
    return new Rgb(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a2 = clampa(this.opacity);
  return `${a2 === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a2 === 1 ? ")" : `, ${a2})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h2, s2, l2, a2) {
  if (a2 <= 0) h2 = s2 = l2 = NaN;
  else if (l2 <= 0 || l2 >= 1) h2 = s2 = NaN;
  else if (s2 <= 0) h2 = NaN;
  return new Hsl(h2, s2, l2, a2);
}
function hslConvert(o2) {
  if (o2 instanceof Hsl) return new Hsl(o2.h, o2.s, o2.l, o2.opacity);
  if (!(o2 instanceof Color)) o2 = color(o2);
  if (!o2) return new Hsl();
  if (o2 instanceof Hsl) return o2;
  o2 = o2.rgb();
  var r2 = o2.r / 255, g2 = o2.g / 255, b2 = o2.b / 255, min2 = Math.min(r2, g2, b2), max2 = Math.max(r2, g2, b2), h2 = NaN, s2 = max2 - min2, l2 = (max2 + min2) / 2;
  if (s2) {
    if (r2 === max2) h2 = (g2 - b2) / s2 + (g2 < b2) * 6;
    else if (g2 === max2) h2 = (b2 - r2) / s2 + 2;
    else h2 = (r2 - g2) / s2 + 4;
    s2 /= l2 < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h2 *= 60;
  } else {
    s2 = l2 > 0 && l2 < 1 ? 0 : h2;
  }
  return new Hsl(h2, s2, l2, o2.opacity);
}
function hsl(h2, s2, l2, opacity) {
  return arguments.length === 1 ? hslConvert(h2) : new Hsl(h2, s2, l2, opacity == null ? 1 : opacity);
}
function Hsl(h2, s2, l2, opacity) {
  this.h = +h2;
  this.s = +s2;
  this.l = +l2;
  this.opacity = +opacity;
}
define(Hsl, hsl, extend$2(Color, {
  brighter(k2) {
    k2 = k2 == null ? brighter : Math.pow(brighter, k2);
    return new Hsl(this.h, this.s, this.l * k2, this.opacity);
  },
  darker(k2) {
    k2 = k2 == null ? darker : Math.pow(darker, k2);
    return new Hsl(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb() {
    var h2 = this.h % 360 + (this.h < 0) * 360, s2 = isNaN(h2) || isNaN(this.s) ? 0 : this.s, l2 = this.l, m2 = l2 + (l2 < 0.5 ? l2 : 1 - l2) * s2, m1 = 2 * l2 - m2;
    return new Rgb(
      hsl2rgb(h2 >= 240 ? h2 - 240 : h2 + 120, m1, m2),
      hsl2rgb(h2, m1, m2),
      hsl2rgb(h2 < 120 ? h2 + 240 : h2 - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a2 = clampa(this.opacity);
    return `${a2 === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a2 === 1 ? ")" : `, ${a2})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb(h2, m1, m2) {
  return (h2 < 60 ? m1 + (m2 - m1) * h2 / 60 : h2 < 180 ? m2 : h2 < 240 ? m1 + (m2 - m1) * (240 - h2) / 60 : m1) * 255;
}
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;
const K$1 = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o2) {
  if (o2 instanceof Lab) return new Lab(o2.l, o2.a, o2.b, o2.opacity);
  if (o2 instanceof Hcl) return hcl2lab(o2);
  if (!(o2 instanceof Rgb)) o2 = rgbConvert(o2);
  var r2 = rgb2lrgb(o2.r), g2 = rgb2lrgb(o2.g), b2 = rgb2lrgb(o2.b), y2 = xyz2lab((0.2225045 * r2 + 0.7168786 * g2 + 0.0606169 * b2) / Yn), x2, z2;
  if (r2 === g2 && g2 === b2) x2 = z2 = y2;
  else {
    x2 = xyz2lab((0.4360747 * r2 + 0.3850649 * g2 + 0.1430804 * b2) / Xn);
    z2 = xyz2lab((0.0139322 * r2 + 0.0971045 * g2 + 0.7141733 * b2) / Zn);
  }
  return new Lab(116 * y2 - 16, 500 * (x2 - y2), 200 * (y2 - z2), o2.opacity);
}
function lab(l2, a2, b2, opacity) {
  return arguments.length === 1 ? labConvert(l2) : new Lab(l2, a2, b2, opacity == null ? 1 : opacity);
}
function Lab(l2, a2, b2, opacity) {
  this.l = +l2;
  this.a = +a2;
  this.b = +b2;
  this.opacity = +opacity;
}
define(Lab, lab, extend$2(Color, {
  brighter(k2) {
    return new Lab(this.l + K$1 * (k2 == null ? 1 : k2), this.a, this.b, this.opacity);
  },
  darker(k2) {
    return new Lab(this.l - K$1 * (k2 == null ? 1 : k2), this.a, this.b, this.opacity);
  },
  rgb() {
    var y2 = (this.l + 16) / 116, x2 = isNaN(this.a) ? y2 : y2 + this.a / 500, z2 = isNaN(this.b) ? y2 : y2 - this.b / 200;
    x2 = Xn * lab2xyz(x2);
    y2 = Yn * lab2xyz(y2);
    z2 = Zn * lab2xyz(z2);
    return new Rgb(
      lrgb2rgb(3.1338561 * x2 - 1.6168667 * y2 - 0.4906146 * z2),
      lrgb2rgb(-0.9787684 * x2 + 1.9161415 * y2 + 0.033454 * z2),
      lrgb2rgb(0.0719453 * x2 - 0.2289914 * y2 + 1.4052427 * z2),
      this.opacity
    );
  }
}));
function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x2) {
  return 255 * (x2 <= 31308e-7 ? 12.92 * x2 : 1.055 * Math.pow(x2, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x2) {
  return (x2 /= 255) <= 0.04045 ? x2 / 12.92 : Math.pow((x2 + 0.055) / 1.055, 2.4);
}
function hclConvert(o2) {
  if (o2 instanceof Hcl) return new Hcl(o2.h, o2.c, o2.l, o2.opacity);
  if (!(o2 instanceof Lab)) o2 = labConvert(o2);
  if (o2.a === 0 && o2.b === 0) return new Hcl(NaN, 0 < o2.l && o2.l < 100 ? 0 : NaN, o2.l, o2.opacity);
  var h2 = Math.atan2(o2.b, o2.a) * degrees;
  return new Hcl(h2 < 0 ? h2 + 360 : h2, Math.sqrt(o2.a * o2.a + o2.b * o2.b), o2.l, o2.opacity);
}
function hcl$1(h2, c2, l2, opacity) {
  return arguments.length === 1 ? hclConvert(h2) : new Hcl(h2, c2, l2, opacity == null ? 1 : opacity);
}
function Hcl(h2, c2, l2, opacity) {
  this.h = +h2;
  this.c = +c2;
  this.l = +l2;
  this.opacity = +opacity;
}
function hcl2lab(o2) {
  if (isNaN(o2.h)) return new Lab(o2.l, 0, 0, o2.opacity);
  var h2 = o2.h * radians;
  return new Lab(o2.l, Math.cos(h2) * o2.c, Math.sin(h2) * o2.c, o2.opacity);
}
define(Hcl, hcl$1, extend$2(Color, {
  brighter(k2) {
    return new Hcl(this.h, this.c, this.l + K$1 * (k2 == null ? 1 : k2), this.opacity);
  },
  darker(k2) {
    return new Hcl(this.h, this.c, this.l - K$1 * (k2 == null ? 1 : k2), this.opacity);
  },
  rgb() {
    return hcl2lab(this).rgb();
  }
}));
var constant$3 = (x2) => () => x2;
function linear$1(a2, d2) {
  return function(t) {
    return a2 + t * d2;
  };
}
function exponential(a2, b2, y2) {
  return a2 = Math.pow(a2, y2), b2 = Math.pow(b2, y2) - a2, y2 = 1 / y2, function(t) {
    return Math.pow(a2 + t * b2, y2);
  };
}
function hue(a2, b2) {
  var d2 = b2 - a2;
  return d2 ? linear$1(a2, d2 > 180 || d2 < -180 ? d2 - 360 * Math.round(d2 / 360) : d2) : constant$3(isNaN(a2) ? b2 : a2);
}
function gamma(y2) {
  return (y2 = +y2) === 1 ? nogamma : function(a2, b2) {
    return b2 - a2 ? exponential(a2, b2, y2) : constant$3(isNaN(a2) ? b2 : a2);
  };
}
function nogamma(a2, b2) {
  var d2 = b2 - a2;
  return d2 ? linear$1(a2, d2) : constant$3(isNaN(a2) ? b2 : a2);
}
var rgb = function rgbGamma(y2) {
  var color2 = gamma(y2);
  function rgb2(start, end) {
    var r2 = color2((start = rgb$1(start)).r, (end = rgb$1(end)).r), g2 = color2(start.g, end.g), b2 = color2(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r2(t);
      start.g = g2(t);
      start.b = b2(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
  rgb2.gamma = rgbGamma;
  return rgb2;
}(1);
function numberArray(a2, b2) {
  if (!b2) b2 = [];
  var n2 = a2 ? Math.min(b2.length, a2.length) : 0, c2 = b2.slice(), i2;
  return function(t) {
    for (i2 = 0; i2 < n2; ++i2) c2[i2] = a2[i2] * (1 - t) + b2[i2] * t;
    return c2;
  };
}
function isNumberArray(x2) {
  return ArrayBuffer.isView(x2) && !(x2 instanceof DataView);
}
function genericArray(a2, b2) {
  var nb = b2 ? b2.length : 0, na = a2 ? Math.min(nb, a2.length) : 0, x2 = new Array(na), c2 = new Array(nb), i2;
  for (i2 = 0; i2 < na; ++i2) x2[i2] = interpolate(a2[i2], b2[i2]);
  for (; i2 < nb; ++i2) c2[i2] = b2[i2];
  return function(t) {
    for (i2 = 0; i2 < na; ++i2) c2[i2] = x2[i2](t);
    return c2;
  };
}
function date(a2, b2) {
  var d2 = /* @__PURE__ */ new Date();
  return a2 = +a2, b2 = +b2, function(t) {
    return d2.setTime(a2 * (1 - t) + b2 * t), d2;
  };
}
function interpolateNumber(a2, b2) {
  return a2 = +a2, b2 = +b2, function(t) {
    return a2 * (1 - t) + b2 * t;
  };
}
function object(a2, b2) {
  var i2 = {}, c2 = {}, k2;
  if (a2 === null || typeof a2 !== "object") a2 = {};
  if (b2 === null || typeof b2 !== "object") b2 = {};
  for (k2 in b2) {
    if (k2 in a2) {
      i2[k2] = interpolate(a2[k2], b2[k2]);
    } else {
      c2[k2] = b2[k2];
    }
  }
  return function(t) {
    for (k2 in i2) c2[k2] = i2[k2](t);
    return c2;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b2) {
  return function() {
    return b2;
  };
}
function one(b2) {
  return function(t) {
    return b2(t) + "";
  };
}
function string(a2, b2) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i2 = -1, s2 = [], q2 = [];
  a2 = a2 + "", b2 = b2 + "";
  while ((am = reA.exec(a2)) && (bm = reB.exec(b2))) {
    if ((bs = bm.index) > bi) {
      bs = b2.slice(bi, bs);
      if (s2[i2]) s2[i2] += bs;
      else s2[++i2] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s2[i2]) s2[i2] += bm;
      else s2[++i2] = bm;
    } else {
      s2[++i2] = null;
      q2.push({ i: i2, x: interpolateNumber(am, bm) });
    }
    bi = reB.lastIndex;
  }
  if (bi < b2.length) {
    bs = b2.slice(bi);
    if (s2[i2]) s2[i2] += bs;
    else s2[++i2] = bs;
  }
  return s2.length < 2 ? q2[0] ? one(q2[0].x) : zero(b2) : (b2 = q2.length, function(t) {
    for (var i3 = 0, o2; i3 < b2; ++i3) s2[(o2 = q2[i3]).i] = o2.x(t);
    return s2.join("");
  });
}
function interpolate(a2, b2) {
  var t = typeof b2, c2;
  return b2 == null || t === "boolean" ? constant$3(b2) : (t === "number" ? interpolateNumber : t === "string" ? (c2 = color(b2)) ? (b2 = c2, rgb) : string : b2 instanceof color ? rgb : b2 instanceof Date ? date : isNumberArray(b2) ? numberArray : Array.isArray(b2) ? genericArray : typeof b2.valueOf !== "function" && typeof b2.toString !== "function" || isNaN(b2) ? object : interpolateNumber)(a2, b2);
}
function interpolateRound(a2, b2) {
  return a2 = +a2, b2 = +b2, function(t) {
    return Math.round(a2 * (1 - t) + b2 * t);
  };
}
function hcl(hue2) {
  return function(start, end) {
    var h2 = hue2((start = hcl$1(start)).h, (end = hcl$1(end)).h), c2 = nogamma(start.c, end.c), l2 = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h2(t);
      start.c = c2(t);
      start.l = l2(t);
      start.opacity = opacity(t);
      return start + "";
    };
  };
}
var interpolateHcl = hcl(hue);
function constants(x2) {
  return function() {
    return x2;
  };
}
function number$1(x2) {
  return +x2;
}
var unit = [0, 1];
function identity$3(x2) {
  return x2;
}
function normalize$1(a2, b2) {
  return (b2 -= a2 = +a2) ? function(x2) {
    return (x2 - a2) / b2;
  } : constants(isNaN(b2) ? NaN : 0.5);
}
function clamper(a2, b2) {
  var t;
  if (a2 > b2) t = a2, a2 = b2, b2 = t;
  return function(x2) {
    return Math.max(a2, Math.min(b2, x2));
  };
}
function bimap(domain2, range2, interpolate2) {
  var d0 = domain2[0], d1 = domain2[1], r0 = range2[0], r1 = range2[1];
  if (d1 < d0) d0 = normalize$1(d1, d0), r0 = interpolate2(r1, r0);
  else d0 = normalize$1(d0, d1), r0 = interpolate2(r0, r1);
  return function(x2) {
    return r0(d0(x2));
  };
}
function polymap(domain2, range2, interpolate2) {
  var j = Math.min(domain2.length, range2.length) - 1, d2 = new Array(j), r2 = new Array(j), i2 = -1;
  if (domain2[j] < domain2[0]) {
    domain2 = domain2.slice().reverse();
    range2 = range2.slice().reverse();
  }
  while (++i2 < j) {
    d2[i2] = normalize$1(domain2[i2], domain2[i2 + 1]);
    r2[i2] = interpolate2(range2[i2], range2[i2 + 1]);
  }
  return function(x2) {
    var i3 = bisectRight(domain2, x2, 1, j) - 1;
    return r2[i3](d2[i3](x2));
  };
}
function copy$1(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer$1() {
  var domain2 = unit, range2 = unit, interpolate$1 = interpolate, transform, untransform, unknown, clamp2 = identity$3, piecewise, output, input;
  function rescale() {
    var n2 = Math.min(domain2.length, range2.length);
    if (clamp2 !== identity$3) clamp2 = clamper(domain2[0], domain2[n2 - 1]);
    piecewise = n2 > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown : (output || (output = piecewise(domain2.map(transform), range2, interpolate$1)))(transform(clamp2(x2)));
  }
  scale.invert = function(y2) {
    return clamp2(untransform((input || (input = piecewise(range2, domain2.map(transform), interpolateNumber)))(y2)));
  };
  scale.domain = function(_2) {
    return arguments.length ? (domain2 = Array.from(_2, number$1), rescale()) : domain2.slice();
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), rescale()) : range2.slice();
  };
  scale.rangeRound = function(_2) {
    return range2 = Array.from(_2), interpolate$1 = interpolateRound, rescale();
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp2 = _2 ? true : identity$3, rescale()) : clamp2 !== identity$3;
  };
  scale.interpolate = function(_2) {
    return arguments.length ? (interpolate$1 = _2, rescale()) : interpolate$1;
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown = _2, scale) : unknown;
  };
  return function(t, u2) {
    transform = t, untransform = u2;
    return rescale();
  };
}
function continuous() {
  return transformer$1()(identity$3, identity$3);
}
function formatDecimal(x2) {
  return Math.abs(x2 = Math.round(x2)) >= 1e21 ? x2.toLocaleString("en").replace(/,/g, "") : x2.toString(10);
}
function formatDecimalParts(x2, p2) {
  if ((i2 = (x2 = p2 ? x2.toExponential(p2 - 1) : x2.toExponential()).indexOf("e")) < 0) return null;
  var i2, coefficient = x2.slice(0, i2);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x2.slice(i2 + 1)
  ];
}
function exponent(x2) {
  return x2 = formatDecimalParts(Math.abs(x2)), x2 ? x2[1] : NaN;
}
function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i2 = value.length, t = [], j = 0, g2 = grouping[0], length = 0;
    while (i2 > 0 && g2 > 0) {
      if (length + g2 + 1 > width) g2 = Math.max(1, width - length);
      t.push(value.substring(i2 -= g2, i2 + g2));
      if ((length += g2 + 1) > width) break;
      g2 = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i2) {
      return numerals[+i2];
    });
  };
}
var re$1 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match = re$1.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s2) {
  out: for (var n2 = s2.length, i2 = 1, i0 = -1, i1; i2 < n2; ++i2) {
    switch (s2[i2]) {
      case ".":
        i0 = i1 = i2;
        break;
      case "0":
        if (i0 === 0) i0 = i2;
        i1 = i2;
        break;
      default:
        if (!+s2[i2]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s2.slice(0, i0) + s2.slice(i1 + 1) : s2;
}
var prefixExponent;
function formatPrefixAuto(x2, p2) {
  var d2 = formatDecimalParts(x2, p2);
  if (!d2) return x2 + "";
  var coefficient = d2[0], exponent2 = d2[1], i2 = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n2 = coefficient.length;
  return i2 === n2 ? coefficient : i2 > n2 ? coefficient + new Array(i2 - n2 + 1).join("0") : i2 > 0 ? coefficient.slice(0, i2) + "." + coefficient.slice(i2) : "0." + new Array(1 - i2).join("0") + formatDecimalParts(x2, Math.max(0, p2 + i2 - 1))[0];
}
function formatRounded(x2, p2) {
  var d2 = formatDecimalParts(x2, p2);
  if (!d2) return x2 + "";
  var coefficient = d2[0], exponent2 = d2[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
var formatTypes = {
  "%": (x2, p2) => (x2 * 100).toFixed(p2),
  "b": (x2) => Math.round(x2).toString(2),
  "c": (x2) => x2 + "",
  "d": formatDecimal,
  "e": (x2, p2) => x2.toExponential(p2),
  "f": (x2, p2) => x2.toFixed(p2),
  "g": (x2, p2) => x2.toPrecision(p2),
  "o": (x2) => Math.round(x2).toString(8),
  "p": (x2, p2) => formatRounded(x2 * 100, p2),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x2) => Math.round(x2).toString(16).toUpperCase(),
  "x": (x2) => Math.round(x2).toString(16)
};
function identity$2(x2) {
  return x2;
}
var map = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale(locale2) {
  var group = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$2 : formatGroup(map.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$2 : formatNumerals(map.call(locale2.numerals, String)), percent = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "−" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign2 = specifier.sign, symbol = specifier.symbol, zero2 = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim2 = specifier.trim, type3 = specifier.type;
    if (type3 === "n") comma = true, type3 = "g";
    else if (!formatTypes[type3]) precision === void 0 && (precision = 12), trim2 = true, type3 = "g";
    if (zero2 || fill === "0" && align === "=") zero2 = true, fill = "0", align = "=";
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type3) ? "0" + type3.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type3) ? percent : "";
    var formatType = formatTypes[type3], maybeSuffix = /[defgprs%]/.test(type3);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type3) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix, valueSuffix = suffix, i2, n2, c2;
      if (type3 === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim2) value = formatTrim(value);
        if (valueNegative && +value === 0 && sign2 !== "+") valueNegative = false;
        valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix;
        valueSuffix = (type3 === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : "");
        if (maybeSuffix) {
          i2 = -1, n2 = value.length;
          while (++i2 < n2) {
            if (c2 = value.charCodeAt(i2), 48 > c2 || c2 > 57) {
              valueSuffix = (c2 === 46 ? decimal + value.slice(i2 + 1) : value.slice(i2)) + valueSuffix;
              value = value.slice(0, i2);
              break;
            }
          }
        }
      }
      if (comma && !zero2) value = group(value, Infinity);
      var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
      if (comma && zero2) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value) {
    var f2 = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k2 = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
    return function(value2) {
      return f2(k2 * value2) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var locale;
var format;
var formatPrefix;
defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}
function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}
function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}
function precisionRound(step, max2) {
  step = Math.abs(step), max2 = Math.abs(max2) - step;
  return Math.max(0, exponent(max2) - exponent(step)) + 1;
}
function tickFormat(start, stop, count2, specifier) {
  var step = tickStep(start, stop, count2), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}
function linearish(scale) {
  var domain2 = scale.domain;
  scale.ticks = function(count2) {
    var d2 = domain2();
    return ticks(d2[0], d2[d2.length - 1], count2 == null ? 10 : count2);
  };
  scale.tickFormat = function(count2, specifier) {
    var d2 = domain2();
    return tickFormat(d2[0], d2[d2.length - 1], count2 == null ? 10 : count2, specifier);
  };
  scale.nice = function(count2) {
    if (count2 == null) count2 = 10;
    var d2 = domain2();
    var i0 = 0;
    var i1 = d2.length - 1;
    var start = d2[i0];
    var stop = d2[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count2);
      if (step === prestep) {
        d2[i0] = start;
        d2[i1] = stop;
        return domain2(d2);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale;
  };
  return scale;
}
function linear() {
  var scale = continuous();
  scale.copy = function() {
    return copy$1(scale, linear());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function transformer() {
  var x0 = 0, x1 = 1, t02, t12, k10, transform, interpolator = identity$3, clamp2 = false, unknown;
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown : interpolator(k10 === 0 ? 0.5 : (x2 = (transform(x2) - t02) * k10, clamp2 ? Math.max(0, Math.min(1, x2)) : x2));
  }
  scale.domain = function(_2) {
    return arguments.length ? ([x0, x1] = _2, t02 = transform(x0 = +x0), t12 = transform(x1 = +x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale) : [x0, x1];
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp2 = !!_2, scale) : clamp2;
  };
  scale.interpolator = function(_2) {
    return arguments.length ? (interpolator = _2, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_2) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _2, interpolator = interpolate2(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }
  scale.range = range2(interpolate);
  scale.rangeRound = range2(interpolateRound);
  scale.unknown = function(_2) {
    return arguments.length ? (unknown = _2, scale) : unknown;
  };
  return function(t) {
    transform = t, t02 = t(x0), t12 = t(x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02);
    return scale;
  };
}
function copy(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
  var scale = linearish(transformer()(identity$3));
  scale.copy = function() {
    return copy(scale, sequential());
  };
  return initInterpolator.apply(scale, arguments);
}
class Scale {
  constructor(config) {
    this.config = config;
    this.createScale(config.type);
  }
  createScale(type3) {
    switch (type3) {
      case "band":
        this.scale = band();
        break;
      case "linear":
        this.scale = linear();
        break;
    }
  }
  changeConfig(config) {
    this.createScale(config.type);
    this.config = config;
  }
  get type() {
    return this.config.type;
  }
  bandwidth() {
    if (this.type === "band") {
      return this.scale.bandwidth();
    }
    return 0;
  }
  updateRange(range2) {
    this.scale = this.scale.copy().range(range2);
  }
  updateDomain(data2, stackedData2, keys4) {
    const domain2 = this.config.type === "band" ? this.categoryDomain(data2, keys4) : this.numericDomain(data2, stackedData2, keys4);
    this.scale = this.scale.copy().domain(domain2);
  }
  map(values3) {
    return values3.map((v2) => this.mapOne(v2));
  }
  mapOne(val) {
    const { type: type3 } = this.config;
    if (type3 === "band") {
      return this.scale(val) + this.scale.bandwidth() / 2;
    }
    return this.scale(val);
  }
  ticks() {
    const { type: type3 } = this.config;
    if (this.config.tickValues !== void 0) {
      return this.config.tickValues;
    }
    if (type3 === "band") {
      return this.scale.domain();
    }
    return this.scale.ticks(this.config.ticks || 5);
  }
  categoryDomain(data2, keys4) {
    const values3 = keys4.reduce((arr, key) => arr.concat(getCol(key, data2)), []);
    return Array.from(new Set(values3));
  }
  numericDomain(data, stackedData, keys) {
    const { domain } = this.config;
    const values = keys.reduce((arr, key) => arr.concat(getCol(key, data)), []);
    const valueMax = max$1(stackedData, (arr) => max$1(arr, (x2) => max$1(x2))) || 0;
    const valueMin = min$1(stackedData, (arr) => min$1(arr, (x2) => min$1(x2))) || 0;
    const [dataMin, dataMax] = extent(Array.from(new Set(values.concat([valueMin, valueMax]))));
    const yMin = eval(`
      let dataMin = ${dataMin || 0}
      ${domain[0]}
    `);
    const yMax = eval(`
      let dataMax = ${dataMax || 0}
      ${domain[1]}
    `);
    return [yMin, yMax];
  }
}
class Scales {
  constructor(config) {
    this.config = config;
    this.primary = new Scale(config.primary);
    this.secondary = new Scale(config.secondary);
  }
  changeConfig(config) {
    this.config = config;
    this.primary.changeConfig(config.primary);
    this.secondary.changeConfig(config.secondary);
  }
  updateRange(canvas, direction) {
    if (direction === "horizontal") {
      this.primary.updateRange([canvas.x, canvas.width]);
      this.secondary.updateRange([canvas.height, canvas.y]);
    } else if (direction === "vertical") {
      this.primary.updateRange([canvas.y, canvas.height]);
      this.secondary.updateRange([canvas.x, canvas.width]);
    }
  }
  updateDomain(data2, stackedData2, keys4) {
    this.primary.updateDomain(data2, stackedData2, getCol(0, keys4));
    this.secondary.updateDomain(data2, stackedData2, getCol(1, keys4));
  }
}
function constant$2(x2) {
  return function constant2() {
    return x2;
  };
}
const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max$2 = Math.max;
const min$2 = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon$2 = 1e-12;
const pi$1 = Math.PI;
const halfPi = pi$1 / 2;
const tau$1 = 2 * pi$1;
function acos(x2) {
  return x2 > 1 ? 0 : x2 < -1 ? pi$1 : Math.acos(x2);
}
function asin(x2) {
  return x2 >= 1 ? halfPi : x2 <= -1 ? -halfPi : Math.asin(x2);
}
const pi = Math.PI, tau = 2 * pi, epsilon$1 = 1e-6, tauEpsilon = tau - epsilon$1;
function append(strings) {
  this._ += strings[0];
  for (let i2 = 1, n2 = strings.length; i2 < n2; ++i2) {
    this._ += arguments[i2] + strings[i2];
  }
}
function appendRound(digits) {
  let d2 = Math.floor(digits);
  if (!(d2 >= 0)) throw new Error(`invalid digits: ${digits}`);
  if (d2 > 15) return append;
  const k2 = 10 ** d2;
  return function(strings) {
    this._ += strings[0];
    for (let i2 = 1, n2 = strings.length; i2 < n2; ++i2) {
      this._ += Math.round(arguments[i2] * k2) / k2 + strings[i2];
    }
  };
}
class Path {
  constructor(digits) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null;
    this._ = "";
    this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x2, y2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x2, y2) {
    this._append`L${this._x1 = +x2},${this._y1 = +y2}`;
  }
  quadraticCurveTo(x1, y1, x2, y2) {
    this._append`Q${+x1},${+y1},${this._x1 = +x2},${this._y1 = +y2}`;
  }
  bezierCurveTo(x1, y1, x2, y2, x3, y3) {
    this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x3},${this._y1 = +y3}`;
  }
  arcTo(x1, y1, x2, y2, r2) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r2 = +r2;
    if (r2 < 0) throw new Error(`negative radius: ${r2}`);
    let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    } else if (!(l01_2 > epsilon$1)) ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r2) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    } else {
      let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l2 = r2 * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l2 / l01, t21 = l2 / l21;
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }
      this._append`A${r2},${r2},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x2, y2, r2, a0, a1, ccw) {
    x2 = +x2, y2 = +y2, r2 = +r2, ccw = !!ccw;
    if (r2 < 0) throw new Error(`negative radius: ${r2}`);
    let dx = r2 * Math.cos(a0), dy = r2 * Math.sin(a0), x0 = x2 + dx, y0 = y2 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    } else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._append`L${x0},${y0}`;
    }
    if (!r2) return;
    if (da < 0) da = da % tau + tau;
    if (da > tauEpsilon) {
      this._append`A${r2},${r2},0,1,${cw},${x2 - dx},${y2 - dy}A${r2},${r2},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    } else if (da > epsilon$1) {
      this._append`A${r2},${r2},0,${+(da >= pi)},${cw},${this._x1 = x2 + r2 * Math.cos(a1)},${this._y1 = y2 + r2 * Math.sin(a1)}`;
    }
  }
  rect(x2, y2, w2, h2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}h${w2 = +w2}v${+h2}h${-w2}Z`;
  }
  toString() {
    return this._;
  }
}
function withPath(shape) {
  let digits = 3;
  shape.digits = function(_2) {
    if (!arguments.length) return digits;
    if (_2 == null) {
      digits = null;
    } else {
      const d2 = Math.floor(_2);
      if (!(d2 >= 0)) throw new RangeError(`invalid digits: ${_2}`);
      digits = d2;
    }
    return shape;
  };
  return () => new Path(digits);
}
function arcInnerRadius(d2) {
  return d2.innerRadius;
}
function arcOuterRadius(d2) {
  return d2.outerRadius;
}
function arcStartAngle(d2) {
  return d2.startAngle;
}
function arcEndAngle(d2) {
  return d2.endAngle;
}
function arcPadAngle(d2) {
  return d2 && d2.padAngle;
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
  if (t * t < epsilon$2) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r2 = r1 - rc, D2 = x11 * y10 - x10 * y11, d3 = (dy < 0 ? -1 : 1) * sqrt(max$2(0, r2 * r2 * d2 - D2 * D2)), cx0 = (D2 * dy - dx * d3) / d2, cy0 = (-D2 * dx - dy * d3) / d2, cx1 = (D2 * dy + dx * d3) / d2, cy1 = (-D2 * dx + dy * d3) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r2 - 1),
    y11: cy0 * (r1 / r2 - 1)
  };
}
function arc() {
  var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant$2(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path = withPath(arc2);
  function arc2() {
    var buffer, r2, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi, a1 = endAngle.apply(this, arguments) - halfPi, da = abs(a1 - a0), cw = a1 > a0;
    if (!context) context = buffer = path();
    if (r1 < r0) r2 = r1, r1 = r0, r0 = r2;
    if (!(r1 > epsilon$2)) context.moveTo(0, 0);
    else if (da > tau$1 - epsilon$2) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$2) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    } else {
      var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon$2 && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)), rc = min$2(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t02, t12;
      if (rp > epsilon$2) {
        var p0 = asin(rp / r0 * sin(ap)), p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon$2) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$2) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos(a01), y01 = r1 * sin(a01), x10 = r0 * cos(a10), y10 = r0 * sin(a10);
      if (rc > epsilon$2) {
        var x11 = r1 * cos(a11), y11 = r1 * sin(a11), x00 = r0 * cos(a00), y00 = r0 * sin(a00), oc;
        if (da < pi$1) {
          if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2), lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
            rc0 = min$2(rc, (r0 - lc) / (kc - 1));
            rc1 = min$2(rc, (r1 - lc) / (kc + 1));
          } else {
            rc0 = rc1 = 0;
          }
        }
      }
      if (!(da1 > epsilon$2)) context.moveTo(x01, y01);
      else if (rc1 > epsilon$2) {
        t02 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t12 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t02.cx + t02.x01, t02.cy + t02.y01);
        if (rc1 < rc) context.arc(t02.cx, t02.cy, rc1, atan2(t02.y01, t02.x01), atan2(t12.y01, t12.x01), !cw);
        else {
          context.arc(t02.cx, t02.cy, rc1, atan2(t02.y01, t02.x01), atan2(t02.y11, t02.x11), !cw);
          context.arc(0, 0, r1, atan2(t02.cy + t02.y11, t02.cx + t02.x11), atan2(t12.cy + t12.y11, t12.cx + t12.x11), !cw);
          context.arc(t12.cx, t12.cy, rc1, atan2(t12.y11, t12.x11), atan2(t12.y01, t12.x01), !cw);
        }
      } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
      if (!(r0 > epsilon$2) || !(da0 > epsilon$2)) context.lineTo(x10, y10);
      else if (rc0 > epsilon$2) {
        t02 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t12 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo(t02.cx + t02.x01, t02.cy + t02.y01);
        if (rc0 < rc) context.arc(t02.cx, t02.cy, rc0, atan2(t02.y01, t02.x01), atan2(t12.y01, t12.x01), !cw);
        else {
          context.arc(t02.cx, t02.cy, rc0, atan2(t02.y01, t02.x01), atan2(t02.y11, t02.x11), !cw);
          context.arc(0, 0, r0, atan2(t02.cy + t02.y11, t02.cx + t02.x11), atan2(t12.cy + t12.y11, t12.cx + t12.x11), cw);
          context.arc(t12.cx, t12.cy, rc0, atan2(t12.y11, t12.x11), atan2(t12.y01, t12.x01), !cw);
        }
      } else context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer) return context = null, buffer + "" || null;
  }
  arc2.centroid = function() {
    var r2 = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a2 = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$1 / 2;
    return [cos(a2) * r2, sin(a2) * r2];
  };
  arc2.innerRadius = function(_2) {
    return arguments.length ? (innerRadius = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : innerRadius;
  };
  arc2.outerRadius = function(_2) {
    return arguments.length ? (outerRadius = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : outerRadius;
  };
  arc2.cornerRadius = function(_2) {
    return arguments.length ? (cornerRadius = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : cornerRadius;
  };
  arc2.padRadius = function(_2) {
    return arguments.length ? (padRadius = _2 == null ? null : typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : padRadius;
  };
  arc2.startAngle = function(_2) {
    return arguments.length ? (startAngle = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : startAngle;
  };
  arc2.endAngle = function(_2) {
    return arguments.length ? (endAngle = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : endAngle;
  };
  arc2.padAngle = function(_2) {
    return arguments.length ? (padAngle = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : padAngle;
  };
  arc2.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, arc2) : context;
  };
  return arc2;
}
function array$1(x2) {
  return typeof x2 === "object" && "length" in x2 ? x2 : Array.from(x2);
}
function Linear(context) {
  this._context = context;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(x2, y2);
        break;
    }
  }
};
function curveLinear(context) {
  return new Linear(context);
}
function x$2(p2) {
  return p2[0];
}
function y$2(p2) {
  return p2[1];
}
function line(x$12, y$12) {
  var defined = constant$2(true), context = null, curve = curveLinear, output = null, path = withPath(line2);
  x$12 = typeof x$12 === "function" ? x$12 : x$12 === void 0 ? x$2 : constant$2(x$12);
  y$12 = typeof y$12 === "function" ? y$12 : y$12 === void 0 ? y$2 : constant$2(y$12);
  function line2(data2) {
    var i2, n2 = (data2 = array$1(data2)).length, d2, defined0 = false, buffer;
    if (context == null) output = curve(buffer = path());
    for (i2 = 0; i2 <= n2; ++i2) {
      if (!(i2 < n2 && defined(d2 = data2[i2], i2, data2)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x$12(d2, i2, data2), +y$12(d2, i2, data2));
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  line2.x = function(_2) {
    return arguments.length ? (x$12 = typeof _2 === "function" ? _2 : constant$2(+_2), line2) : x$12;
  };
  line2.y = function(_2) {
    return arguments.length ? (y$12 = typeof _2 === "function" ? _2 : constant$2(+_2), line2) : y$12;
  };
  line2.defined = function(_2) {
    return arguments.length ? (defined = typeof _2 === "function" ? _2 : constant$2(!!_2), line2) : defined;
  };
  line2.curve = function(_2) {
    return arguments.length ? (curve = _2, context != null && (output = curve(context)), line2) : curve;
  };
  line2.context = function(_2) {
    return arguments.length ? (_2 == null ? context = output = null : output = curve(context = _2), line2) : context;
  };
  return line2;
}
function area(x0, y0, y1) {
  var x1 = null, defined = constant$2(true), context = null, curve = curveLinear, output = null, path = withPath(area2);
  x0 = typeof x0 === "function" ? x0 : x0 === void 0 ? x$2 : constant$2(+x0);
  y0 = typeof y0 === "function" ? y0 : y0 === void 0 ? constant$2(0) : constant$2(+y0);
  y1 = typeof y1 === "function" ? y1 : y1 === void 0 ? y$2 : constant$2(+y1);
  function area2(data2) {
    var i2, j, k2, n2 = (data2 = array$1(data2)).length, d2, defined0 = false, buffer, x0z = new Array(n2), y0z = new Array(n2);
    if (context == null) output = curve(buffer = path());
    for (i2 = 0; i2 <= n2; ++i2) {
      if (!(i2 < n2 && defined(d2 = data2[i2], i2, data2)) === defined0) {
        if (defined0 = !defined0) {
          j = i2;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k2 = i2 - 1; k2 >= j; --k2) {
            output.point(x0z[k2], y0z[k2]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i2] = +x0(d2, i2, data2), y0z[i2] = +y0(d2, i2, data2);
        output.point(x1 ? +x1(d2, i2, data2) : x0z[i2], y1 ? +y1(d2, i2, data2) : y0z[i2]);
      }
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }
  area2.x = function(_2) {
    return arguments.length ? (x0 = typeof _2 === "function" ? _2 : constant$2(+_2), x1 = null, area2) : x0;
  };
  area2.x0 = function(_2) {
    return arguments.length ? (x0 = typeof _2 === "function" ? _2 : constant$2(+_2), area2) : x0;
  };
  area2.x1 = function(_2) {
    return arguments.length ? (x1 = _2 == null ? null : typeof _2 === "function" ? _2 : constant$2(+_2), area2) : x1;
  };
  area2.y = function(_2) {
    return arguments.length ? (y0 = typeof _2 === "function" ? _2 : constant$2(+_2), y1 = null, area2) : y0;
  };
  area2.y0 = function(_2) {
    return arguments.length ? (y0 = typeof _2 === "function" ? _2 : constant$2(+_2), area2) : y0;
  };
  area2.y1 = function(_2) {
    return arguments.length ? (y1 = _2 == null ? null : typeof _2 === "function" ? _2 : constant$2(+_2), area2) : y1;
  };
  area2.lineX0 = area2.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };
  area2.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };
  area2.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };
  area2.defined = function(_2) {
    return arguments.length ? (defined = typeof _2 === "function" ? _2 : constant$2(!!_2), area2) : defined;
  };
  area2.curve = function(_2) {
    return arguments.length ? (curve = _2, context != null && (output = curve(context)), area2) : curve;
  };
  area2.context = function(_2) {
    return arguments.length ? (_2 == null ? context = output = null : output = curve(context = _2), area2) : context;
  };
  return area2;
}
function descending(a2, b2) {
  return b2 < a2 ? -1 : b2 > a2 ? 1 : b2 >= a2 ? 0 : NaN;
}
function identity$1(d2) {
  return d2;
}
function pie() {
  var value = identity$1, sortValues = descending, sort2 = null, startAngle = constant$2(0), endAngle = constant$2(tau$1), padAngle = constant$2(0);
  function pie2(data2) {
    var i2, n2 = (data2 = array$1(data2)).length, j, k2, sum = 0, index2 = new Array(n2), arcs = new Array(n2), a0 = +startAngle.apply(this, arguments), da = Math.min(tau$1, Math.max(-tau$1, endAngle.apply(this, arguments) - a0)), a1, p2 = Math.min(Math.abs(da) / n2, padAngle.apply(this, arguments)), pa = p2 * (da < 0 ? -1 : 1), v2;
    for (i2 = 0; i2 < n2; ++i2) {
      if ((v2 = arcs[index2[i2] = i2] = +value(data2[i2], i2, data2)) > 0) {
        sum += v2;
      }
    }
    if (sortValues != null) index2.sort(function(i3, j2) {
      return sortValues(arcs[i3], arcs[j2]);
    });
    else if (sort2 != null) index2.sort(function(i3, j2) {
      return sort2(data2[i3], data2[j2]);
    });
    for (i2 = 0, k2 = sum ? (da - n2 * pa) / sum : 0; i2 < n2; ++i2, a0 = a1) {
      j = index2[i2], v2 = arcs[j], a1 = a0 + (v2 > 0 ? v2 * k2 : 0) + pa, arcs[j] = {
        data: data2[j],
        index: i2,
        value: v2,
        startAngle: a0,
        endAngle: a1,
        padAngle: p2
      };
    }
    return arcs;
  }
  pie2.value = function(_2) {
    return arguments.length ? (value = typeof _2 === "function" ? _2 : constant$2(+_2), pie2) : value;
  };
  pie2.sortValues = function(_2) {
    return arguments.length ? (sortValues = _2, sort2 = null, pie2) : sortValues;
  };
  pie2.sort = function(_2) {
    return arguments.length ? (sort2 = _2, sortValues = null, pie2) : sort2;
  };
  pie2.startAngle = function(_2) {
    return arguments.length ? (startAngle = typeof _2 === "function" ? _2 : constant$2(+_2), pie2) : startAngle;
  };
  pie2.endAngle = function(_2) {
    return arguments.length ? (endAngle = typeof _2 === "function" ? _2 : constant$2(+_2), pie2) : endAngle;
  };
  pie2.padAngle = function(_2) {
    return arguments.length ? (padAngle = typeof _2 === "function" ? _2 : constant$2(+_2), pie2) : padAngle;
  };
  return pie2;
}
function sign(x2) {
  return x2 < 0 ? -1 : 1;
}
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p2 = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p2)) || 0;
}
function slope2(that, t) {
  var h2 = that._x1 - that._x0;
  return h2 ? (3 * (that._y1 - that._y0) / h2 - t) / 2 : t;
}
function point(that, t02, t12) {
  var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t02, x1 - dx, y1 - dx * t12, x1, y1);
}
function MonotoneX(context) {
  this._context = context;
}
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    var t12 = NaN;
    x2 = +x2, y2 = +y2;
    if (x2 === this._x1 && y2 === this._y1) return;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point(this, slope2(this, t12 = slope3(this, x2, y2)), t12);
        break;
      default:
        point(this, this._t0, t12 = slope3(this, x2, y2));
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
    this._t0 = t12;
  }
};
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x2, y2) {
  MonotoneX.prototype.point.call(this, y2, x2);
};
function ReflectContext(context) {
  this._context = context;
}
ReflectContext.prototype = {
  moveTo: function(x2, y2) {
    this._context.moveTo(y2, x2);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(x2, y2) {
    this._context.lineTo(y2, x2);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x3, y3) {
    this._context.bezierCurveTo(y1, x1, y2, x2, y3, x3);
  }
};
function monotoneX(context) {
  return new MonotoneX(context);
}
function monotoneY(context) {
  return new MonotoneY(context);
}
function Natural(context) {
  this._context = context;
}
Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x2 = this._x, y2 = this._y, n2 = x2.length;
    if (n2) {
      this._line ? this._context.lineTo(x2[0], y2[0]) : this._context.moveTo(x2[0], y2[0]);
      if (n2 === 2) {
        this._context.lineTo(x2[1], y2[1]);
      } else {
        var px = controlPoints(x2), py = controlPoints(y2);
        for (var i0 = 0, i1 = 1; i1 < n2; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x2[i1], y2[i1]);
        }
      }
    }
    if (this._line || this._line !== 0 && n2 === 1) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x2, y2) {
    this._x.push(+x2);
    this._y.push(+y2);
  }
};
function controlPoints(x2) {
  var i2, n2 = x2.length - 1, m2, a2 = new Array(n2), b2 = new Array(n2), r2 = new Array(n2);
  a2[0] = 0, b2[0] = 2, r2[0] = x2[0] + 2 * x2[1];
  for (i2 = 1; i2 < n2 - 1; ++i2) a2[i2] = 1, b2[i2] = 4, r2[i2] = 4 * x2[i2] + 2 * x2[i2 + 1];
  a2[n2 - 1] = 2, b2[n2 - 1] = 7, r2[n2 - 1] = 8 * x2[n2 - 1] + x2[n2];
  for (i2 = 1; i2 < n2; ++i2) m2 = a2[i2] / b2[i2 - 1], b2[i2] -= m2, r2[i2] -= m2 * r2[i2 - 1];
  a2[n2 - 1] = r2[n2 - 1] / b2[n2 - 1];
  for (i2 = n2 - 2; i2 >= 0; --i2) a2[i2] = (r2[i2] - a2[i2 + 1]) / b2[i2];
  b2[n2 - 1] = (x2[n2] + a2[n2 - 1]) / 2;
  for (i2 = 0; i2 < n2 - 1; ++i2) b2[i2] = 2 * x2[i2 + 1] - a2[i2 + 1];
  return [a2, b2];
}
function curveNatural(context) {
  return new Natural(context);
}
function Step(context, t) {
  this._context = context;
  this._t = t;
}
Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y2);
          this._context.lineTo(x2, y2);
        } else {
          var x1 = this._x * (1 - this._t) + x2 * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y2);
        }
        break;
      }
    }
    this._x = x2, this._y = y2;
  }
};
function curveStep(context) {
  return new Step(context, 0.5);
}
function stepAfter(context) {
  return new Step(context, 1);
}
function none$1(series, order) {
  if (!((n2 = series.length) > 1)) return;
  for (var i2 = 1, j, s0, s1 = series[order[0]], n2, m2 = s1.length; i2 < n2; ++i2) {
    s0 = s1, s1 = series[order[i2]];
    for (j = 0; j < m2; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}
function stackOrderNone(series) {
  var n2 = series.length, o2 = new Array(n2);
  while (--n2 >= 0) o2[n2] = n2;
  return o2;
}
function stackValue(d2, key) {
  return d2[key];
}
function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}
function stack() {
  var keys4 = constant$2([]), order = stackOrderNone, offset2 = none$1, value = stackValue;
  function stack2(data2) {
    var sz = Array.from(keys4.apply(this, arguments), stackSeries), i2, n2 = sz.length, j = -1, oz;
    for (const d2 of data2) {
      for (i2 = 0, ++j; i2 < n2; ++i2) {
        (sz[i2][j] = [0, +value(d2, sz[i2].key, j, data2)]).data = d2;
      }
    }
    for (i2 = 0, oz = array$1(order(sz)); i2 < n2; ++i2) {
      sz[oz[i2]].index = i2;
    }
    offset2(sz, oz);
    return sz;
  }
  stack2.keys = function(_2) {
    return arguments.length ? (keys4 = typeof _2 === "function" ? _2 : constant$2(Array.from(_2)), stack2) : keys4;
  };
  stack2.value = function(_2) {
    return arguments.length ? (value = typeof _2 === "function" ? _2 : constant$2(+_2), stack2) : value;
  };
  stack2.order = function(_2) {
    return arguments.length ? (order = _2 == null ? stackOrderNone : typeof _2 === "function" ? _2 : constant$2(Array.from(_2)), stack2) : order;
  };
  stack2.offset = function(_2) {
    return arguments.length ? (offset2 = _2 == null ? none$1 : _2, stack2) : offset2;
  };
  return stack2;
}
const defaultConfig = {
  size: { width: 500, height: 400 },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  direction: "horizontal",
  axis: {
    primary: {
      domain: ["dataMin", "dataMax"],
      type: "band"
    },
    secondary: {
      domain: ["dataMin", "dataMax"],
      type: "linear"
    }
  },
  axisSpace: {
    x: 40,
    y: 20
  }
};
class Chart {
  constructor(data2, config) {
    this.data = data2;
    this.layers = [];
    this.config = mergeDeepLeft$1(pickBy$1((p2) => p2 !== void 0, config), defaultConfig);
    this.scales = new Scales(this.config.axis);
    this.updates = ref(0);
  }
  get bandScale() {
    if (this.scales.primary.type === "band")
      return this.scales.primary;
    if (this.scales.secondary.type === "band")
      return this.scales.secondary;
    return null;
  }
  get canvas() {
    const { margin, size: size2 } = this.config;
    const axisSpace = this.config.axisSpace;
    if (this.config.axis.primary.hide) {
      axisSpace.y = 0;
    }
    if (this.config.axis.secondary.hide) {
      axisSpace.x = 0;
    }
    return {
      x: margin.left + axisSpace.x,
      y: margin.top,
      width: size2.width - margin.right,
      height: size2.height - margin.bottom - axisSpace.y
    };
  }
  getStackedData(keys4) {
    return stack().keys(keys4).order(stackOrderNone)(this.data);
  }
  changeData(data2) {
    this.data = data2;
    this.update("data");
  }
  changeConfig(config) {
    this.config = mergeDeepLeft$1(pickBy$1((p2) => p2 !== void 0, config), this.config);
    this.scales.changeConfig(this.config.axis);
    this.update("config");
  }
  addLayer(layer) {
    this.layers.push(layer);
    this.update("layers");
  }
  removeLayer(id) {
    this.layers = this.layers.filter((l2) => l2.id !== id);
    this.update("layers");
  }
  getLayers(type3) {
    if (type3) {
      return this.layers.filter((l2) => l2.type === type3);
    }
    return this.layers;
  }
  getData(keys4) {
    return keys4.reduce((arr, key) => arr.concat(getCol(key, this.data)), []);
  }
  getKeys(idx = -1, type3 = null) {
    const keys4 = this.layers.filter((l2) => {
      if (type3)
        return l2.type === type3;
      return true;
    }).map((l2) => l2.dataKeys);
    if (idx === -1) {
      return keys4;
    }
    return getCol(idx, keys4);
  }
  getStackedKeys(idx = -1, type3 = null) {
    const keys4 = this.layers.filter((l2) => {
      if (type3)
        return l2.type === type3 && l2.props.stacked;
      return l2.props.stacked;
    }).map((l2) => l2.dataKeys);
    if (idx === -1) {
      return keys4;
    }
    return getCol(idx, keys4);
  }
  update(_2) {
    const stackedData2 = this.getStackedData(this.getStackedKeys(1));
    this.scales.updateRange(this.canvas, this.config.direction);
    this.scales.updateDomain(this.data, stackedData2, this.getKeys());
    this.updates.value += 1;
  }
}
var xhtml = "http://www.w3.org/1999/xhtml";
var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function namespace(name) {
  var prefix = name += "", i2 = prefix.indexOf(":");
  if (i2 >= 0 && (prefix = name.slice(0, i2)) !== "xmlns") name = name.slice(i2 + 1);
  return namespaces.hasOwnProperty(prefix) ? { space: namespaces[prefix], local: name } : name;
}
function creatorInherit(name) {
  return function() {
    var document2 = this.ownerDocument, uri = this.namespaceURI;
    return uri === xhtml && document2.documentElement.namespaceURI === xhtml ? document2.createElement(name) : document2.createElementNS(uri, name);
  };
}
function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}
function creator(name) {
  var fullname = namespace(name);
  return (fullname.local ? creatorFixed : creatorInherit)(fullname);
}
function none() {
}
function selector(selector2) {
  return selector2 == null ? none : function() {
    return this.querySelector(selector2);
  };
}
function selection_select(select2) {
  if (typeof select2 !== "function") select2 = selector(select2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group = groups2[j], n2 = group.length, subgroup = subgroups[j] = new Array(n2), node, subnode, i2 = 0; i2 < n2; ++i2) {
      if ((node = group[i2]) && (subnode = select2.call(node, node.__data__, i2, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i2] = subnode;
      }
    }
  }
  return new Selection(subgroups, this._parents);
}
function array(x2) {
  return x2 == null ? [] : Array.isArray(x2) ? x2 : Array.from(x2);
}
function empty() {
  return [];
}
function selectorAll(selector2) {
  return selector2 == null ? empty : function() {
    return this.querySelectorAll(selector2);
  };
}
function arrayAll(select2) {
  return function() {
    return array(select2.apply(this, arguments));
  };
}
function selection_selectAll(select2) {
  if (typeof select2 === "function") select2 = arrayAll(select2);
  else select2 = selectorAll(select2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = [], parents = [], j = 0; j < m2; ++j) {
    for (var group = groups2[j], n2 = group.length, node, i2 = 0; i2 < n2; ++i2) {
      if (node = group[i2]) {
        subgroups.push(select2.call(node, node.__data__, i2, group));
        parents.push(node);
      }
    }
  }
  return new Selection(subgroups, parents);
}
function matcher(selector2) {
  return function() {
    return this.matches(selector2);
  };
}
function childMatcher(selector2) {
  return function(node) {
    return node.matches(selector2);
  };
}
var find$1 = Array.prototype.find;
function childFind(match) {
  return function() {
    return find$1.call(this.children, match);
  };
}
function childFirst() {
  return this.firstElementChild;
}
function selection_selectChild(match) {
  return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
}
var filter = Array.prototype.filter;
function children() {
  return Array.from(this.children);
}
function childrenFilter(match) {
  return function() {
    return filter.call(this.children, match);
  };
}
function selection_selectChildren(match) {
  return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
}
function selection_filter(match) {
  if (typeof match !== "function") match = matcher(match);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group = groups2[j], n2 = group.length, subgroup = subgroups[j] = [], node, i2 = 0; i2 < n2; ++i2) {
      if ((node = group[i2]) && match.call(node, node.__data__, i2, group)) {
        subgroup.push(node);
      }
    }
  }
  return new Selection(subgroups, this._parents);
}
function sparse(update) {
  return new Array(update.length);
}
function selection_enter() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
}
function EnterNode(parent, datum2) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum2;
}
EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) {
    return this._parent.insertBefore(child, this._next);
  },
  insertBefore: function(child, next) {
    return this._parent.insertBefore(child, next);
  },
  querySelector: function(selector2) {
    return this._parent.querySelector(selector2);
  },
  querySelectorAll: function(selector2) {
    return this._parent.querySelectorAll(selector2);
  }
};
function constant$1(x2) {
  return function() {
    return x2;
  };
}
function bindIndex(parent, group, enter, update, exit, data2) {
  var i2 = 0, node, groupLength = group.length, dataLength = data2.length;
  for (; i2 < dataLength; ++i2) {
    if (node = group[i2]) {
      node.__data__ = data2[i2];
      update[i2] = node;
    } else {
      enter[i2] = new EnterNode(parent, data2[i2]);
    }
  }
  for (; i2 < groupLength; ++i2) {
    if (node = group[i2]) {
      exit[i2] = node;
    }
  }
}
function bindKey(parent, group, enter, update, exit, data2, key) {
  var i2, node, nodeByKeyValue = /* @__PURE__ */ new Map(), groupLength = group.length, dataLength = data2.length, keyValues = new Array(groupLength), keyValue;
  for (i2 = 0; i2 < groupLength; ++i2) {
    if (node = group[i2]) {
      keyValues[i2] = keyValue = key.call(node, node.__data__, i2, group) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i2] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }
  for (i2 = 0; i2 < dataLength; ++i2) {
    keyValue = key.call(parent, data2[i2], i2, data2) + "";
    if (node = nodeByKeyValue.get(keyValue)) {
      update[i2] = node;
      node.__data__ = data2[i2];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i2] = new EnterNode(parent, data2[i2]);
    }
  }
  for (i2 = 0; i2 < groupLength; ++i2) {
    if ((node = group[i2]) && nodeByKeyValue.get(keyValues[i2]) === node) {
      exit[i2] = node;
    }
  }
}
function datum(node) {
  return node.__data__;
}
function selection_data(value, key) {
  if (!arguments.length) return Array.from(this, datum);
  var bind3 = key ? bindKey : bindIndex, parents = this._parents, groups2 = this._groups;
  if (typeof value !== "function") value = constant$1(value);
  for (var m2 = groups2.length, update = new Array(m2), enter = new Array(m2), exit = new Array(m2), j = 0; j < m2; ++j) {
    var parent = parents[j], group = groups2[j], groupLength = group.length, data2 = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data2.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
    bind3(parent, group, enterGroup, updateGroup, exitGroup, data2, key);
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength) ;
        previous._next = next || null;
      }
    }
  }
  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}
function arraylike(data2) {
  return typeof data2 === "object" && "length" in data2 ? data2 : Array.from(data2);
}
function selection_exit() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
}
function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  if (typeof onenter === "function") {
    enter = onenter(enter);
    if (enter) enter = enter.selection();
  } else {
    enter = enter.append(onenter + "");
  }
  if (onupdate != null) {
    update = onupdate(update);
    if (update) update = update.selection();
  }
  if (onexit == null) exit.remove();
  else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}
function selection_merge(context) {
  var selection = context.selection ? context.selection() : context;
  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m2 = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m2; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n2 = group0.length, merge2 = merges[j] = new Array(n2), node, i2 = 0; i2 < n2; ++i2) {
      if (node = group0[i2] || group1[i2]) {
        merge2[i2] = node;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Selection(merges, this._parents);
}
function selection_order() {
  for (var groups2 = this._groups, j = -1, m2 = groups2.length; ++j < m2; ) {
    for (var group = groups2[j], i2 = group.length - 1, next = group[i2], node; --i2 >= 0; ) {
      if (node = group[i2]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }
  return this;
}
function selection_sort(compare2) {
  if (!compare2) compare2 = ascending;
  function compareNode(a2, b2) {
    return a2 && b2 ? compare2(a2.__data__, b2.__data__) : !a2 - !b2;
  }
  for (var groups2 = this._groups, m2 = groups2.length, sortgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group = groups2[j], n2 = group.length, sortgroup = sortgroups[j] = new Array(n2), node, i2 = 0; i2 < n2; ++i2) {
      if (node = group[i2]) {
        sortgroup[i2] = node;
      }
    }
    sortgroup.sort(compareNode);
  }
  return new Selection(sortgroups, this._parents).order();
}
function ascending(a2, b2) {
  return a2 < b2 ? -1 : a2 > b2 ? 1 : a2 >= b2 ? 0 : NaN;
}
function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}
function selection_nodes() {
  return Array.from(this);
}
function selection_node() {
  for (var groups2 = this._groups, j = 0, m2 = groups2.length; j < m2; ++j) {
    for (var group = groups2[j], i2 = 0, n2 = group.length; i2 < n2; ++i2) {
      var node = group[i2];
      if (node) return node;
    }
  }
  return null;
}
function selection_size() {
  let size2 = 0;
  for (const node of this) ++size2;
  return size2;
}
function selection_empty() {
  return !this.node();
}
function selection_each(callback) {
  for (var groups2 = this._groups, j = 0, m2 = groups2.length; j < m2; ++j) {
    for (var group = groups2[j], i2 = 0, n2 = group.length, node; i2 < n2; ++i2) {
      if (node = group[i2]) callback.call(node, node.__data__, i2, group);
    }
  }
  return this;
}
function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}
function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}
function attrFunction(name, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null) this.removeAttribute(name);
    else this.setAttribute(name, v2);
  };
}
function attrFunctionNS(fullname, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v2);
  };
}
function selection_attr(name, value) {
  var fullname = namespace(name);
  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
  }
  return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
}
function defaultView(node) {
  return node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView;
}
function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}
function styleFunction(name, value, priority) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v2, priority);
  };
}
function selection_style(name, value, priority) {
  return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
}
function styleValue(node, name) {
  return node.style.getPropertyValue(name) || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}
function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}
function propertyFunction(name, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null) delete this[name];
    else this[name] = v2;
  };
}
function selection_property(name, value) {
  return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
}
function classArray(string2) {
  return string2.trim().split(/^|\s+/);
}
function classList(node) {
  return node.classList || new ClassList(node);
}
function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
  add: function(name) {
    var i2 = this._names.indexOf(name);
    if (i2 < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i2 = this._names.indexOf(name);
    if (i2 >= 0) {
      this._names.splice(i2, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};
function classedAdd(node, names) {
  var list = classList(node), i2 = -1, n2 = names.length;
  while (++i2 < n2) list.add(names[i2]);
}
function classedRemove(node, names) {
  var list = classList(node), i2 = -1, n2 = names.length;
  while (++i2 < n2) list.remove(names[i2]);
}
function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}
function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}
function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}
function selection_classed(name, value) {
  var names = classArray(name + "");
  if (arguments.length < 2) {
    var list = classList(this.node()), i2 = -1, n2 = names.length;
    while (++i2 < n2) if (!list.contains(names[i2])) return false;
    return true;
  }
  return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
}
function textRemove() {
  this.textContent = "";
}
function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction(value) {
  return function() {
    var v2 = value.apply(this, arguments);
    this.textContent = v2 == null ? "" : v2;
  };
}
function selection_text(value) {
  return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
}
function htmlRemove() {
  this.innerHTML = "";
}
function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}
function htmlFunction(value) {
  return function() {
    var v2 = value.apply(this, arguments);
    this.innerHTML = v2 == null ? "" : v2;
  };
}
function selection_html(value) {
  return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
}
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}
function selection_raise() {
  return this.each(raise);
}
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function selection_lower() {
  return this.each(lower);
}
function selection_append(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}
function constantNull() {
  return null;
}
function selection_insert(name, before) {
  var create = typeof name === "function" ? name : creator(name), select2 = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select2.apply(this, arguments) || null);
  });
}
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}
function selection_remove() {
  return this.each(remove);
}
function selection_cloneShallow() {
  var clone2 = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone2, this.nextSibling) : clone2;
}
function selection_cloneDeep() {
  var clone2 = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone2, this.nextSibling) : clone2;
}
function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}
function selection_datum(value) {
  return arguments.length ? this.property("__data__", value) : this.node().__data__;
}
function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}
function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i2 = t.indexOf(".");
    if (i2 >= 0) name = t.slice(i2 + 1), t = t.slice(0, i2);
    return { type: t, name };
  });
}
function onRemove(typename) {
  return function() {
    var on2 = this.__on;
    if (!on2) return;
    for (var j = 0, i2 = -1, m2 = on2.length, o2; j < m2; ++j) {
      if (o2 = on2[j], (!typename.type || o2.type === typename.type) && o2.name === typename.name) {
        this.removeEventListener(o2.type, o2.listener, o2.options);
      } else {
        on2[++i2] = o2;
      }
    }
    if (++i2) on2.length = i2;
    else delete this.__on;
  };
}
function onAdd(typename, value, options) {
  return function() {
    var on2 = this.__on, o2, listener = contextListener(value);
    if (on2) for (var j = 0, m2 = on2.length; j < m2; ++j) {
      if ((o2 = on2[j]).type === typename.type && o2.name === typename.name) {
        this.removeEventListener(o2.type, o2.listener, o2.options);
        this.addEventListener(o2.type, o2.listener = listener, o2.options = options);
        o2.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, options);
    o2 = { type: typename.type, name: typename.name, value, listener, options };
    if (!on2) this.__on = [o2];
    else on2.push(o2);
  };
}
function selection_on(typename, value, options) {
  var typenames = parseTypenames(typename + ""), i2, n2 = typenames.length, t;
  if (arguments.length < 2) {
    var on2 = this.node().__on;
    if (on2) for (var j = 0, m2 = on2.length, o2; j < m2; ++j) {
      for (i2 = 0, o2 = on2[j]; i2 < n2; ++i2) {
        if ((t = typenames[i2]).type === o2.type && t.name === o2.name) {
          return o2.value;
        }
      }
    }
    return;
  }
  on2 = value ? onAdd : onRemove;
  for (i2 = 0; i2 < n2; ++i2) this.each(on2(typenames[i2], value, options));
  return this;
}
function dispatchEvent$1(node, type3, params) {
  var window2 = defaultView(node), event = window2.CustomEvent;
  if (typeof event === "function") {
    event = new event(type3, params);
  } else {
    event = window2.document.createEvent("Event");
    if (params) event.initEvent(type3, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type3, false, false);
  }
  node.dispatchEvent(event);
}
function dispatchConstant(type3, params) {
  return function() {
    return dispatchEvent$1(this, type3, params);
  };
}
function dispatchFunction(type3, params) {
  return function() {
    return dispatchEvent$1(this, type3, params.apply(this, arguments));
  };
}
function selection_dispatch(type3, params) {
  return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type3, params));
}
function* selection_iterator() {
  for (var groups2 = this._groups, j = 0, m2 = groups2.length; j < m2; ++j) {
    for (var group = groups2[j], i2 = 0, n2 = group.length, node; i2 < n2; ++i2) {
      if (node = group[i2]) yield node;
    }
  }
}
var root = [null];
function Selection(groups2, parents) {
  this._groups = groups2;
  this._parents = parents;
}
function selection_selection() {
  return this;
}
Selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selection_selectAll,
  selectChild: selection_selectChild,
  selectChildren: selection_selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  selection: selection_selection,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: selection_iterator
};
function select(selector2) {
  return typeof selector2 === "string" ? new Selection([[document.querySelector(selector2)]], [document.documentElement]) : new Selection([[selector2]], root);
}
function sourceEvent(event) {
  let sourceEvent2;
  while (sourceEvent2 = event.sourceEvent) event = sourceEvent2;
  return event;
}
function pointer(event, node) {
  event = sourceEvent(event);
  if (node === void 0) node = event.currentTarget;
  if (node) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
      var point2 = svg.createSVGPoint();
      point2.x = event.clientX, point2.y = event.clientY;
      point2 = point2.matrixTransform(node.getScreenCTM().inverse());
      return [point2.x, point2.y];
    }
    if (node.getBoundingClientRect) {
      var rect = node.getBoundingClientRect();
      return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
    }
  }
  return [event.pageX, event.pageY];
}
function identity(x2) {
  return x2;
}
var top = 1, right = 2, bottom = 3, left = 4, epsilon = 1e-6;
function translateX(x2) {
  return "translate(" + x2 + ",0)";
}
function translateY(y2) {
  return "translate(0," + y2 + ")";
}
function number(scale) {
  return (d2) => +scale(d2);
}
function center(scale, offset2) {
  offset2 = Math.max(0, scale.bandwidth() - offset2 * 2) / 2;
  if (scale.round()) offset2 = Math.round(offset2);
  return (d2) => +scale(d2) + offset2;
}
function entering() {
  return !this.__axis;
}
function axis(orient, scale) {
  var tickArguments = [], tickValues = null, tickFormat2 = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset2 = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k2 = orient === top || orient === left ? -1 : 1, x2 = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
  function axis2(context) {
    var values3 = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format2 = tickFormat2 == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity : tickFormat2, spacing = Math.max(tickSizeInner, 0) + tickPadding, range2 = scale.range(), range0 = +range2[0] + offset2, range1 = +range2[range2.length - 1] + offset2, position = (scale.bandwidth ? center : number)(scale.copy(), offset2), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([null]), tick = selection.selectAll(".tick").data(values3, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line2 = tick.select("line"), text = tick.select("text");
    path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
    tick = tick.merge(tickEnter);
    line2 = line2.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x2 + "2", k2 * tickSizeInner));
    text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x2, k2 * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line2 = line2.transition(context);
      text = text.transition(context);
      tickExit = tickExit.transition(context).attr("opacity", epsilon).attr("transform", function(d2) {
        return isFinite(d2 = position(d2)) ? transform(d2 + offset2) : this.getAttribute("transform");
      });
      tickEnter.attr("opacity", epsilon).attr("transform", function(d2) {
        var p2 = this.parentNode.__axis;
        return transform((p2 && isFinite(p2 = p2(d2)) ? p2 : position(d2)) + offset2);
      });
    }
    tickExit.remove();
    path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k2 * tickSizeOuter + "," + range0 + "H" + offset2 + "V" + range1 + "H" + k2 * tickSizeOuter : "M" + offset2 + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k2 * tickSizeOuter + "V" + offset2 + "H" + range1 + "V" + k2 * tickSizeOuter : "M" + range0 + "," + offset2 + "H" + range1);
    tick.attr("opacity", 1).attr("transform", function(d2) {
      return transform(position(d2) + offset2);
    });
    line2.attr(x2 + "2", k2 * tickSizeInner);
    text.attr(x2, k2 * spacing).text(format2);
    selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
    selection.each(function() {
      this.__axis = position;
    });
  }
  axis2.scale = function(_2) {
    return arguments.length ? (scale = _2, axis2) : scale;
  };
  axis2.ticks = function() {
    return tickArguments = Array.from(arguments), axis2;
  };
  axis2.tickArguments = function(_2) {
    return arguments.length ? (tickArguments = _2 == null ? [] : Array.from(_2), axis2) : tickArguments.slice();
  };
  axis2.tickValues = function(_2) {
    return arguments.length ? (tickValues = _2 == null ? null : Array.from(_2), axis2) : tickValues && tickValues.slice();
  };
  axis2.tickFormat = function(_2) {
    return arguments.length ? (tickFormat2 = _2, axis2) : tickFormat2;
  };
  axis2.tickSize = function(_2) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_2, axis2) : tickSizeInner;
  };
  axis2.tickSizeInner = function(_2) {
    return arguments.length ? (tickSizeInner = +_2, axis2) : tickSizeInner;
  };
  axis2.tickSizeOuter = function(_2) {
    return arguments.length ? (tickSizeOuter = +_2, axis2) : tickSizeOuter;
  };
  axis2.tickPadding = function(_2) {
    return arguments.length ? (tickPadding = +_2, axis2) : tickPadding;
  };
  axis2.offset = function(_2) {
    return arguments.length ? (offset2 = +_2, axis2) : offset2;
  };
  return axis2;
}
function axisBottom(scale) {
  return axis(bottom, scale);
}
function axisLeft(scale) {
  return axis(left, scale);
}
var useChart = () => {
  const chart = inject("chart");
  return chart;
};
var usePoints = (dataKeys, props2 = { stacked: false, type: "line" }) => {
  const points = ref([]);
  const chart = useChart();
  const { stacked, type: type3 } = props2;
  function getPoints(key, values3) {
    const { primary, secondary } = chart.scales;
    if (chart.config.direction === "horizontal") {
      const res = values3.map((val) => {
        return {
          x: primary.mapOne(val.data[key]),
          y: secondary.mapOne(val[1]),
          props: { values: [...val], data: val.data }
        };
      }).filter((p2) => !isNaN(p2.x) && !isNaN(p2.y));
      return res;
    } else if (chart.config.direction === "vertical") {
      return values3.map((val) => {
        return {
          x: secondary.mapOne(val[1]),
          y: primary.mapOne(val.data[key]),
          props: { values: [...val], data: val.data }
        };
      }).filter((p2) => !isNaN(p2.x) && !isNaN(p2.y));
    }
    return [];
  }
  function update() {
    const keys4 = chart.getStackedKeys(1, type3);
    const [primaryKey, secondaryKey] = dataKeys;
    const stack2 = chart.getStackedData(stacked ? keys4 : [dataKeys[1]]);
    const data2 = stack2.find((s2) => s2.key === secondaryKey);
    if (data2) {
      points.value = getPoints(primaryKey, data2);
    }
  }
  watch(chart.updates, () => {
    update();
  }, { immediate: true });
  return {
    points
  };
};
var useMouse = () => {
  const mouse = inject("chartMouse", {
    index: -1,
    position: { x: 0, y: 0 },
    hover: false
  });
  return mouse;
};
var useBars = (dataKeys, props2 = { maxWidth: -1, gap: 5, stacked: false, type: "bar" }) => {
  const bars = ref([]);
  const chart = useChart();
  const { stacked, type: type3, gap } = props2;
  function scales() {
    const { primary, secondary } = chart.scales;
    const bandScale = primary.type === "band" ? primary : secondary;
    const linearScale = primary.type === "band" ? secondary : primary;
    return { bandScale, linearScale };
  }
  function getIndex() {
    if (stacked) {
      return 0;
    }
    const barLayers = chart.getLayers(type3);
    const idx = barLayers.findIndex((l2) => l2.dataKeys.join(",") === dataKeys.join(","));
    return idx > -1 ? idx : 0;
  }
  function getBarWidth() {
    const { bandScale } = scales();
    const maxWidth = props2.maxWidth > -1 ? Math.min(bandScale.bandwidth() - gap, props2.maxWidth) : bandScale.bandwidth() - gap;
    const barLayers = chart.getLayers(type3);
    return barLayers.length > 0 && !stacked ? maxWidth / barLayers.length : maxWidth;
  }
  function getDiffWidth() {
    if (stacked) {
      return 0;
    }
    const { bandScale } = scales();
    const max2 = bandScale.bandwidth() - gap;
    const total = chart.getLayers(type3).length * getBarWidth();
    return (max2 - total) / 2;
  }
  function getBars(key, values3) {
    const { bandScale, linearScale } = scales();
    const index2 = getIndex();
    const barSize = getBarWidth();
    const diff = getDiffWidth();
    return values3.map((val) => {
      const rect = { x: 0, y: 0, width: 0, height: 0, props: { values: [...val], data: val.data } };
      const xVal = bandScale.scale(val.data[key]);
      const [yVal0, yVal1] = linearScale.map(val);
      if (chart.config.direction === "horizontal") {
        rect.y = Math.min(yVal0, yVal1);
        rect.height = Math.abs(yVal0 - yVal1);
        rect.x = diff + xVal + index2 * barSize + gap / 2;
        rect.width = barSize;
      } else if (chart.config.direction === "vertical") {
        rect.x = Math.min(yVal0, yVal1);
        rect.width = Math.abs(yVal0 - yVal1);
        rect.y = diff + xVal + index2 * barSize + gap / 2;
        rect.height = barSize;
      }
      return rect;
    });
  }
  function update() {
    const keys4 = stacked ? chart.getStackedKeys(1, type3) : [dataKeys[1]];
    const [primaryKey, secondaryKey] = dataKeys;
    const stack2 = chart.getStackedData(keys4);
    const data2 = stack2.find((s2) => s2.key === secondaryKey);
    if (data2) {
      bars.value = getBars(primaryKey, data2);
    }
  }
  watch(chart.updates, () => {
    update();
  });
  return {
    bars
  };
};
var useTooltip = () => {
  const mouse = useMouse();
  const chart = useChart();
  const show = computed(() => mouse.hover);
  const position = ref({ x: 0, y: 0 });
  const payload = ref({});
  watch(mouse, () => {
    const { primary } = chart.scales;
    const keys4 = chart.getKeys(0);
    const vals = chart.getData(keys4);
    const [x2] = primary.map([vals[mouse.index]]);
    if (x2) {
      if (chart.config.direction === "horizontal") {
        position.value = {
          x: x2,
          y: mouse.position.y
        };
      } else if (chart.config.direction === "vertical") {
        position.value = {
          x: mouse.position.x,
          y: x2
        };
      } else {
        position.value = {
          x: mouse.position.x,
          y: mouse.position.y
        };
      }
    }
    const d2 = chart.data[mouse.index];
    if (d2) {
      payload.value = Object.assign(Object.assign({}, d2), { idx: mouse.index });
    }
  });
  return { position, payload, show };
};
var useResize = (el) => {
  const width = ref(0);
  const height = ref(0);
  let observer = null;
  let resizeCallback = null;
  function onUpdate(w2, h2) {
    width.value = w2;
    height.value = h2;
    if (resizeCallback) {
      resizeCallback();
    }
  }
  function onResize(callback) {
    resizeCallback = callback;
  }
  onMounted(() => {
    observer = new window.ResizeObserver((entries) => {
      const w2 = entries[0].contentRect.width;
      const h2 = entries[0].contentRect.height;
      onUpdate(w2, h2);
    });
    observer.observe(el.value);
  });
  onUnmounted(() => {
    observer.disconnect();
  });
  return { width, height, onResize };
};
var script$d = defineComponent({
  name: "Axis",
  props: {
    position: {
      type: String,
      default: "bottom"
    },
    rotate: {
      type: Boolean,
      default: false
    },
    isPrimary: {
      type: Boolean,
      default: false
    }
  },
  setup(props2) {
    const el = ref();
    const chart = useChart();
    const axis2 = computed(() => {
      return props2.position === "bottom" ? axisBottom : axisLeft;
    });
    const canvas = ref(chart.canvas);
    const defaultConfig2 = { ticks: 5 };
    function drawAxis() {
      if (chart.data.length > 0) {
        const { primary, secondary } = chart.scales;
        const current = props2.isPrimary ? primary : secondary;
        const config = Object.assign({}, props2.isPrimary ? primary.config : secondary.config, defaultConfig2);
        const ax = axis2.value(current.scale);
        if (config.format) {
          ax.tickFormat(config.format);
        }
        if (config.ticks !== void 0) {
          ax.ticks(config.ticks);
        }
        if (config.tickValues !== void 0) {
          ax.tickValues(config.tickValues);
        }
        if (config.useConfig) {
          config.useConfig(ax);
        }
        const res = select(el.value).call(ax);
        if (props2.position === "bottom" && props2.rotate) {
          res.selectAll("text").attr("y", 0).attr("x", 9).attr("dy", ".35em").attr("transform", "rotate(90)").style("text-anchor", "start");
        }
        return ax;
      }
      return null;
    }
    watch(() => props2.isPrimary, () => {
      drawAxis();
    });
    watch(chart.updates, () => {
      canvas.value = chart.canvas;
      drawAxis();
    });
    return { el, canvas };
  }
});
const _hoisted_1$b$1 = ["transform"];
const _hoisted_2$8$1 = ["transform"];
function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.position === "bottom" ? (openBlock(), createElementBlock("g", {
    key: 0,
    class: normalizeClass(`layer-axis-x`),
    ref: "el",
    transform: `translate(0, ${_ctx.canvas.height})`
  }, null, 8, _hoisted_1$b$1)) : (openBlock(), createElementBlock("g", {
    key: 1,
    class: normalizeClass(`layer-axis-y`),
    ref: "el",
    transform: `translate(${_ctx.canvas.x}, 0)`
  }, null, 8, _hoisted_2$8$1));
}
script$d.render = render$d;
script$d.__file = "src/components/Axis/index.vue";
var script$c = defineComponent({
  name: "Chart",
  components: { Axis: script$d },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    margin: {
      type: Object,
      default: () => ({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }),
      required: false
    },
    size: {
      type: Object,
      default: () => ({ width: 500, height: 400 }),
      required: false
    },
    direction: {
      type: String,
      default: "horizontal",
      required: false
    },
    axis: {
      type: Object,
      required: false
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props2) {
    const chartEl = ref(null);
    const axLeftEl = ref();
    const axBottomEl = ref();
    const axisSpace = reactive({ x: 40, y: 20 });
    const chart = new Chart(props2.data, props2.config);
    const rotateX = computed(() => props2.axis && props2.axis.primary && props2.axis.primary.rotate);
    const hideX = computed(() => {
      return props2.axis && props2.axis.primary && props2.axis.primary.hide;
    });
    const hideY = computed(() => {
      return props2.axis && props2.axis.secondary && props2.axis.secondary.hide;
    });
    const mouse = reactive({
      index: -1,
      position: { x: 0, y: 0 },
      hover: false
    });
    provide("chart", chart);
    provide("chartMouse", mouse);
    watch(() => props2.data, () => {
      if (chart)
        chart.changeData(props2.data);
    }, { immediate: true });
    watch(() => props2.config, () => {
      if (chart)
        chart.changeConfig(props2.config);
    });
    watch(() => [Object.assign({}, axisSpace), props2.direction, props2.size, props2.margin, props2.axis], () => {
      if (chart) {
        chart.changeConfig({
          axisSpace: Object.assign({}, axisSpace),
          direction: props2.direction,
          size: props2.size,
          margin: props2.margin,
          axis: props2.axis
        });
      }
    }, { immediate: true });
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (axBottomEl.value && entry.target === axBottomEl.value.$el) {
          axisSpace.y = entry.contentRect.height;
        } else if (axLeftEl.value && entry.target === axLeftEl.value.$el) {
          axisSpace.x = entry.contentRect.width;
        }
      }
    });
    onMounted(() => {
      if (axBottomEl.value) {
        resizeObserver.observe(axBottomEl.value.$el);
      }
      if (axLeftEl.value) {
        resizeObserver.observe(axLeftEl.value.$el);
      }
    });
    onUnmounted(() => {
      resizeObserver.disconnect();
    });
    function onMouseOut() {
      if (props2.config.controlHover === false) {
        return;
      }
      mouse.index = -1;
      mouse.hover = false;
    }
    function onMouseMove(e) {
      if (props2.config.controlHover === false) {
        return;
      }
      mouse.hover = true;
      mouse.position = { x: pointer(e)[0], y: pointer(e)[1] };
      const { primary } = chart.scales;
      const keys4 = chart.getKeys(0);
      const vals = chart.getData(keys4);
      if (chart.config.direction === "horizontal") {
        if (primary.type === "band") {
          const band2 = primary.bandwidth();
          const delta = mouse.position.x - chart.canvas.x;
          mouse.index = Math.round((delta + band2 / 2) / band2) - 1;
        } else {
          mouse.index = bisectCenter(vals, primary.scale.invert(mouse.position.x));
        }
      } else if (chart.config.direction === "vertical") {
        if (primary.type === "band") {
          const band2 = primary.bandwidth();
          const delta = mouse.position.y - chart.canvas.y;
          mouse.index = Math.round((delta + band2 / 2) / band2) - 1;
        } else {
          mouse.index = bisectCenter(vals, primary.scale.invert(mouse.position.y));
        }
      }
    }
    return { axBottomEl, axLeftEl, chartEl, hideX, hideY, rotateX, onMouseMove, onMouseOut };
  }
});
const _hoisted_1$a$1 = {
  class: "chart",
  ref: "chartEl"
};
const _hoisted_2$7$1 = ["width", "height", "viewBox"];
const _hoisted_3$6$1 = { class: "layers" };
const _hoisted_4$3$1 = { class: "axis" };
const _hoisted_5$3$1 = { class: "widgets" };
function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_axis = resolveComponent("axis");
  return openBlock(), createElementBlock(
    "div",
    _hoisted_1$a$1,
    [
      (openBlock(), createElementBlock("svg", {
        width: _ctx.size.width,
        height: _ctx.size.height,
        viewBox: `0 0 ${_ctx.size.width} ${_ctx.size.height}`,
        onPointermove: _cache[0] || (_cache[0] = (...args) => _ctx.onMouseMove && _ctx.onMouseMove(...args)),
        onPointerleave: _cache[1] || (_cache[1] = (...args) => _ctx.onMouseOut && _ctx.onMouseOut(...args))
      }, [
        createElementVNode("g", _hoisted_3$6$1, [
          renderSlot(_ctx.$slots, "layers")
        ]),
        createElementVNode("g", _hoisted_4$3$1, [
          !_ctx.hideX ? (openBlock(), createBlock(_component_axis, {
            key: 0,
            position: "bottom",
            ref: "axBottomEl",
            rotate: _ctx.rotateX,
            isPrimary: _ctx.direction === "horizontal"
          }, null, 8, ["rotate", "isPrimary"])) : createCommentVNode("v-if", true),
          !_ctx.hideY ? (openBlock(), createBlock(_component_axis, {
            key: 1,
            position: "left",
            ref: "axLeftEl",
            isPrimary: _ctx.direction === "vertical"
          }, null, 8, ["isPrimary"])) : createCommentVNode("v-if", true)
        ])
      ], 40, _hoisted_2$7$1)),
      createElementVNode("div", _hoisted_5$3$1, [
        renderSlot(_ctx.$slots, "widgets")
      ])
    ],
    512
    /* NEED_PATCH */
  );
}
function styleInject(css2, ref2) {
  if (ref2 === void 0) ref2 = {};
  var insertAt = ref2.insertAt;
  if (!css2 || typeof document === "undefined") {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.type = "text/css";
  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css2;
  } else {
    style.appendChild(document.createTextNode(css2));
  }
}
var css_248z$1 = "\n.chart {\n  position: relative;\n}\n";
styleInject(css_248z$1);
script$c.render = render$c;
script$c.__file = "src/components/Chart/index.vue";
var script$b = defineComponent({
  name: "Layer",
  props: {
    type: {
      type: String,
      default: "custom"
    },
    dataKeys: {
      type: Object,
      required: true
    }
  },
  setup(props2) {
    const chart = useChart();
    const id = (/* @__PURE__ */ new Date()).getTime().toString();
    const extraProps = inject("layerProps", {});
    onMounted(() => {
      chart.addLayer({ id, type: props2.type, dataKeys: props2.dataKeys, props: extraProps });
    });
    onUnmounted(() => {
      chart.removeLayer(id);
    });
    return {};
  }
});
function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "g",
    {
      class: normalizeClass(`layer-${_ctx.type}`)
    },
    [
      renderSlot(_ctx.$slots, "default")
    ],
    2
    /* CLASS */
  );
}
script$b.render = render$b;
script$b.__file = "src/components/Layer/index.vue";
var script$a = defineComponent({
  name: "AreaComponent",
  components: { Layer: script$b },
  props: {
    areaStyle: {
      type: Object,
      required: false
    },
    dataKeys: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: () => "normal"
    },
    gap: {
      type: Number,
      default: 0
    }
  },
  setup(props2) {
    const chart = useChart();
    const { stacked } = inject("layerProps", { stacked: false });
    const { points } = usePoints(props2.dataKeys, {
      stacked: false,
      type: "area"
    });
    const { bars } = useBars(props2.dataKeys, {
      stacked,
      type: "area",
      gap: props2.gap,
      maxWidth: -1
    });
    const d2 = ref("");
    const lineType = (type3) => {
      const map3 = {
        normal: curveLinear,
        natural: curveNatural,
        step: curveStep,
        monotone: chart.config.direction === "horizontal" ? monotoneX : monotoneY
      };
      return map3[type3];
    };
    const buildArea = () => {
      console.log(points.value);
      const { secondary } = chart.scales;
      if (stacked) {
        return area().curve(lineType(props2.type)).x0((p2) => p2.x + p2.width / 2).y0((p2) => p2.y).x1((p2) => p2.x + p2.width / 2).y1((p2) => p2.y + p2.height);
      }
      if (chart.config.direction === "vertical") {
        return area().curve(lineType(props2.type)).y0((p2) => p2.y).y1((p2) => p2.y).x0((p2) => p2.x).x1(() => secondary.scale(0));
      }
      return area().curve(lineType(props2.type)).x0((p2) => p2.x).x1((p2) => p2.x).y0((p2) => p2.y).y1(() => secondary.scale(0));
    };
    const getStyle = computed(() => {
      return () => Object.assign({ fill: "blue", fillOpacity: 0.25, stroke: "none" }, props2.areaStyle);
    });
    const toKebabCase = (data2) => mapKeys(kebabize, data2);
    watch(points, () => {
      d2.value = stacked ? buildArea()(bars.value) : buildArea()(points.value);
    });
    return { d: d2, getStyle, toKebabCase };
  }
});
const _hoisted_1$9$1 = ["d"];
function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Layer = resolveComponent("Layer");
  return openBlock(), createBlock(_component_Layer, {
    type: "area",
    dataKeys: _ctx.dataKeys
  }, {
    default: withCtx(() => [
      createElementVNode("path", mergeProps(_ctx.toKebabCase(_ctx.getStyle()), { d: _ctx.d }), null, 16, _hoisted_1$9$1)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["dataKeys"]);
}
script$a.render = render$a;
script$a.__file = "src/components/Area/index.vue";
var script$9 = defineComponent({
  name: "LineComponent",
  components: { Layer: script$b },
  props: {
    lineStyle: {
      type: Object,
      required: false
    },
    dotStyle: {
      type: Object,
      required: false
    },
    hideDot: {
      type: Boolean,
      default: false
    },
    dataKeys: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: () => "normal"
    }
  },
  setup(props2) {
    const { stacked } = inject("layerProps", { stacked: false });
    const mouse = useMouse();
    const chart = useChart();
    const d2 = ref("");
    const { points } = usePoints(props2.dataKeys, { stacked, type: "line" });
    const lineType = {
      normal: curveLinear,
      natural: curveNatural,
      step: stepAfter,
      monotone: monotoneX
    };
    function updateLine() {
      let type3 = lineType[props2.type];
      if (props2.type === "monotone" && chart.config.direction === "vertical") {
        type3 = monotoneY;
      }
      d2.value = line().x((p2) => p2.x).y((p2) => p2.y).curve(type3)(points.value);
    }
    function computeDotStyle(active) {
      const dotStyle = props2.dotStyle;
      const style = getStyle.value();
      return Object.assign({ r: active ? 5 : 3, stroke: style.stroke, strokeWidth: style.strokeWidth, fill: "white" }, dotStyle);
    }
    const getStyle = computed(() => {
      if (is$1(Function, props2.lineStyle)) {
        return props2.lineStyle;
      }
      return () => Object.assign({ stroke: "#8884d8", strokeWidth: 2 }, props2.lineStyle);
    });
    const getDotStyle = computed(() => {
      if (is$1(Function, props2.dotStyle)) {
        return props2.dotStyle;
      }
      return ({ active }) => computeDotStyle(active);
    });
    watch(points, () => updateLine());
    watch(chart.updates, () => updateLine());
    const toKebabCase = (data2) => mapKeys(kebabize, data2);
    return { d: d2, mouse, points, toKebabCase, getStyle, getDotStyle };
  }
});
const _hoisted_1$8$1 = ["d"];
const _hoisted_2$6$1 = { key: 0 };
const _hoisted_3$5$1 = ["cx", "cy"];
function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Layer = resolveComponent("Layer");
  return openBlock(), createBlock(_component_Layer, {
    dataKeys: _ctx.dataKeys,
    type: "line"
  }, {
    default: withCtx(() => [
      createElementVNode("path", mergeProps({ class: "chart-line" }, _ctx.toKebabCase(_ctx.getStyle()), {
        d: _ctx.d,
        fill: "none"
      }), null, 16, _hoisted_1$8$1),
      createCommentVNode(' :stroke="stroke"\n      :stroke-width="strokeWidth"\n      stroke-linejoin="round"\n      stroke-linecap="round" '),
      !_ctx.hideDot ? (openBlock(), createElementBlock("g", _hoisted_2$6$1, [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList(_ctx.points, (c2, i2) => {
            return openBlock(), createElementBlock("circle", mergeProps(_ctx.toKebabCase(_ctx.getDotStyle({ active: i2 === _ctx.mouse.index, index: i2 })), {
              key: i2,
              cx: c2.x,
              cy: c2.y
            }), null, 16, _hoisted_3$5$1);
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ])) : createCommentVNode("v-if", true)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["dataKeys"]);
}
script$9.render = render$9;
script$9.__file = "src/components/Line/index.vue";
var script$8 = defineComponent({
  name: "Bar",
  components: { Layer: script$b },
  props: {
    selectedBar: {
      type: Object,
      default: () => null
    },
    barStyle: {
      type: [Function, Object],
      default: () => ({
        fill: "blue"
      })
    },
    barStyleSelected: {
      type: [Function, Object],
      default: () => ({
        fill: "darkblue"
      })
    },
    maxWidth: {
      type: Number,
      default: -1
    },
    dataKeys: {
      type: Object,
      required: true
    },
    gap: {
      type: Number,
      default: 5
    }
  },
  setup(props2, { emit: emit2 }) {
    const mouse = useMouse();
    const { stacked, maxWidth } = inject("layerProps", {
      stacked: false,
      maxWidth: -1
    });
    const { bars } = useBars(props2.dataKeys, {
      maxWidth: Math.max(props2.maxWidth, maxWidth),
      stacked,
      gap: props2.gap,
      type: "bar"
    });
    const getStyle = computed(() => {
      if (is$1(Function, props2.barStyle)) {
        return props2.barStyle;
      }
      return () => props2.barStyle;
    });
    const getStyleSelected = computed(() => {
      if (is$1(Function, props2.barStyleSelected)) {
        return props2.barStyleSelected;
      }
      return () => props2.barStyleSelected;
    });
    const toKebabCase = (data2) => mapKeys(kebabize, data2);
    function onBarClick(bar, idx) {
      emit2("barClick", Object.assign(Object.assign({}, bar), { idx }));
    }
    return { getStyle, getStyleSelected, toKebabCase, bars, mouse, onBarClick };
  }
});
const _hoisted_1$7$1 = { key: 0 };
const _hoisted_2$5$1 = ["x", "y", "width", "height", "onClick"];
const _hoisted_3$4$1 = ["x", "y", "width", "height"];
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Layer = resolveComponent("Layer");
  return openBlock(), createBlock(_component_Layer, {
    dataKeys: _ctx.dataKeys,
    type: "bar"
  }, {
    default: withCtx(() => [
      _ctx.bars.length === 0 ? (openBlock(), createElementBlock("text", _hoisted_1$7$1, "No Data")) : createCommentVNode("v-if", true),
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList(_ctx.bars, (bar, i2) => {
          return openBlock(), createElementBlock("rect", mergeProps(
            { class: "chart-bar" },
            _ctx.toKebabCase(_ctx.getStyle({ ...bar.props, active: i2 === _ctx.mouse.index })),
            {
              key: i2,
              x: bar.x,
              y: bar.y,
              width: bar.width > 0 ? bar.width : 0,
              height: bar.height > 0 ? bar.height : 0,
              onClick: () => _ctx.onBarClick(bar, i2)
            }
          ), null, 16, _hoisted_2$5$1);
        }),
        128
        /* KEYED_FRAGMENT */
      )),
      _ctx.selectedBar ? (openBlock(), createElementBlock("rect", mergeProps(
        {
          key: 1,
          class: "chart-bar"
        },
        _ctx.toKebabCase(_ctx.getStyleSelected({ ..._ctx.selectedBar.props })),
        {
          x: _ctx.selectedBar.x,
          y: _ctx.selectedBar.y,
          width: _ctx.selectedBar.width > 0 ? _ctx.selectedBar.width : 0,
          height: _ctx.selectedBar.height > 0 ? _ctx.selectedBar.height : 0
        }
      ), null, 16, _hoisted_3$4$1)) : createCommentVNode("v-if", true)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["dataKeys"]);
}
script$8.render = render$8;
script$8.__file = "src/components/Bar/index.vue";
const PieSort = String;
var script$7 = defineComponent({
  name: "PieLayer",
  components: { Layer: script$b },
  props: {
    pieStyle: {
      type: Object,
      required: false
    },
    dataKeys: {
      type: Object,
      required: true
    },
    sort: {
      type: PieSort,
      default: "desc",
      required: false
    },
    sortFunc: {
      type: Function,
      required: false
    }
  },
  setup(props2) {
    var _a;
    const chart = useChart();
    const mouse = useMouse();
    const size2 = ref(Math.min(chart.canvas.width - chart.canvas.x, chart.canvas.height - chart.canvas.y) / 2);
    const getStyle = computed(() => {
      return () => Object.assign({ colors: ["#4daf4a", "#377eb8", "#ff7f00", "#984ea3", "#e41a1c"], innerRadius: 2, cornerRadius: 0, padAngle: 0.01 }, props2.pieStyle);
    });
    const style = getStyle.value();
    const arcs = ref([]);
    const colors = ordinal(getStyle.value().colors);
    const arcGen = () => {
      return arc().outerRadius(size2.value).innerRadius(style.innerRadius).cornerRadius(style.cornerRadius).padAngle(style.padAngle);
    };
    const transform = ref(`translate(${size2.value + chart.canvas.x}, ${size2.value + chart.canvas.y})`);
    let pieSort;
    switch (props2.sort) {
      case "desc":
        pieSort = descending$1;
        break;
      case "asc":
        pieSort = ascending$1;
        break;
      case "none":
        pieSort = null;
        break;
      case "custom":
        pieSort = (_a = props2.sortFunc) !== null && _a !== void 0 ? _a : null;
        break;
      default:
        pieSort = null;
    }
    function updatePie() {
      const data2 = chart.getData([props2.dataKeys[1]]);
      arcs.value = pie().sort(pieSort)(data2);
    }
    function getColor(index2) {
      return colors(index2.toString());
    }
    function showTooltip(event, index2) {
      mouse.hover = true;
      mouse.index = index2;
      const [x2, y2] = pointer(event);
      mouse.position = { x: x2 + size2.value, y: y2 + size2.value };
    }
    function hideTooltip() {
      mouse.hover = false;
      mouse.index = -1;
    }
    function toKebabCase(data2) {
      mapKeys(kebabize, data2);
    }
    watch(chart.updates, () => {
      size2.value = Math.min(chart.canvas.width - chart.canvas.x, (chart.canvas.height - chart.canvas.y) / 2);
      transform.value = `translate(${size2.value + chart.canvas.x}, ${size2.value + chart.canvas.y})`;
      updatePie();
    });
    return {
      arcs,
      arcGen,
      getStyle,
      transform,
      getColor,
      hideTooltip,
      toKebabCase,
      showTooltip
    };
  }
});
const _hoisted_1$6$1 = { key: 0 };
const _hoisted_2$4$1 = ["transform"];
const _hoisted_3$3$1 = ["id", "fill", "d", "onMousemove"];
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Layer = resolveComponent("Layer");
  return openBlock(), createBlock(_component_Layer, {
    dataKeys: _ctx.dataKeys,
    type: "pie"
  }, {
    default: withCtx(() => [
      _ctx.arcs.length === 0 ? (openBlock(), createElementBlock("text", _hoisted_1$6$1, "No Data")) : createCommentVNode("v-if", true),
      createElementVNode("g", { transform: _ctx.transform }, [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList(_ctx.arcs, (arc2, i2) => {
            return openBlock(), createElementBlock("path", mergeProps({
              key: i2,
              id: `arc-${i2}`,
              class: "chart-pie"
            }, _ctx.toKebabCase(_ctx.getStyle()), {
              fill: _ctx.getColor(i2),
              d: _ctx.arcGen()(arc2),
              onMousemove: ($event) => _ctx.showTooltip($event, i2),
              onMouseleave: _cache[0] || (_cache[0] = ($event) => _ctx.hideTooltip())
            }), null, 16, _hoisted_3$3$1);
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ], 8, _hoisted_2$4$1)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["dataKeys"]);
}
script$7.render = render$7;
script$7.__file = "src/components/Pie/index.vue";
var script$6 = defineComponent({
  name: "Responsive",
  setup() {
    const el = ref(null);
    const { width, height } = useResize(el);
    return { el, width, height };
  }
});
const _hoisted_1$5$1 = { ref: "el" };
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    _hoisted_1$5$1,
    [
      renderSlot(_ctx.$slots, "main", {
        width: _ctx.width,
        height: _ctx.height
      })
    ],
    512
    /* NEED_PATCH */
  );
}
script$6.render = render$6;
script$6.__file = "src/components/Responsive/index.vue";
var script$5 = defineComponent({
  name: "Grid",
  props: {
    strokeDasharray: {
      type: String,
      default: () => "3 3"
    },
    hideX: {
      type: Boolean,
      default: false
    },
    hideY: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: true
    }
  },
  setup(props2) {
    const chart = useChart();
    const data2 = ref([]);
    const canvas = ref(null);
    const xLines = ref([]);
    const yLines = ref([]);
    function updateXLines() {
      const { primary, secondary } = chart.scales;
      const current = chart.config.direction === "horizontal" ? secondary : primary;
      if (current.type === "band" && !props2.center) {
        const vals = current.map(chart.getData(chart.getKeys(0))).map((x2) => x2 + current.bandwidth() / 2);
        vals.pop();
        xLines.value = vals;
      } else {
        const ticks2 = current.ticks();
        xLines.value = current.map(ticks2);
      }
    }
    function updateYLines() {
      const { primary, secondary } = chart.scales;
      const current = chart.config.direction === "horizontal" ? primary : secondary;
      if (current.type === "band" && !props2.center) {
        const vals = current.map(chart.getData(chart.getKeys(0))).map((x2) => x2 + current.bandwidth() / 2);
        vals.pop();
        yLines.value = vals;
      } else {
        const ticks2 = current.ticks();
        yLines.value = current.map(ticks2);
      }
    }
    watch(chart.updates, () => {
      data2.value = chart.data;
      canvas.value = chart.canvas;
      updateXLines();
      updateYLines();
    });
    return { data: data2, canvas, xLines, yLines };
  }
});
const _hoisted_1$4$1 = ["stroke-dasharray"];
const _hoisted_2$3$1 = {
  key: 0,
  class: "grid-x"
};
const _hoisted_3$2$1 = ["x1", "y1", "x2", "y2"];
const _hoisted_4$2$1 = {
  key: 1,
  class: "grid-y"
};
const _hoisted_5$2$1 = ["x1", "y1", "x2", "y2"];
const _hoisted_6$2$1 = ["x1", "y1", "x2", "y2"];
const _hoisted_7$d = ["x1", "y1", "x2", "y2"];
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.data.length ? (openBlock(), createElementBlock("g", {
    key: 0,
    class: "layer-grid",
    stroke: "black",
    "stroke-opacity": "0.15",
    "stroke-width": "1",
    "stroke-dasharray": _ctx.strokeDasharray
  }, [
    !_ctx.hideX ? (openBlock(), createElementBlock("g", _hoisted_2$3$1, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList(_ctx.xLines, (y2, i2) => {
          return openBlock(), createElementBlock("line", {
            key: i2,
            x1: _ctx.canvas.x,
            y1: y2,
            x2: _ctx.canvas.width,
            y2
          }, null, 8, _hoisted_3$2$1);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : createCommentVNode("v-if", true),
    !_ctx.hideY ? (openBlock(), createElementBlock("g", _hoisted_4$2$1, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList(_ctx.yLines, (x2, i2) => {
          return openBlock(), createElementBlock("line", {
            key: i2,
            x1: x2,
            y1: _ctx.canvas.y,
            x2,
            y2: _ctx.canvas.height
          }, null, 8, _hoisted_5$2$1);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : createCommentVNode("v-if", true),
    createElementVNode("g", null, [
      createElementVNode("line", {
        x1: _ctx.canvas.x,
        y1: _ctx.canvas.y,
        x2: _ctx.canvas.width,
        y2: _ctx.canvas.y
      }, null, 8, _hoisted_6$2$1),
      createElementVNode("line", {
        x1: _ctx.canvas.width - 1,
        y1: _ctx.canvas.y,
        x2: _ctx.canvas.width - 1,
        y2: _ctx.canvas.height
      }, null, 8, _hoisted_7$d)
    ])
  ], 8, _hoisted_1$4$1)) : createCommentVNode("v-if", true);
}
script$5.render = render$5;
script$5.__file = "src/components/Grid/index.vue";
var script$4 = defineComponent({
  name: "Tooltip",
  components: {},
  props: {
    format: {
      type: String,
      default: ",.0f"
    },
    color: {
      type: String,
      default: "#7876ec"
    },
    hideLine: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props2) {
    const el = ref(null);
    const chart = useChart();
    const canvas = ref(chart.canvas);
    const direction = ref(chart.config.direction);
    const { position, payload, show } = useTooltip();
    const isRight = computed(() => {
      return position.value.x >= canvas.value.width / 4 * 3;
    });
    const style = computed(() => {
      if (direction.value === "vertical") {
        return {
          top: position.value.y - 0.5 + "px",
          left: canvas.value.x + "px"
        };
      } else if (direction.value === "horizontal") {
        return {
          top: canvas.value.y + "px",
          left: position.value.x - 0.5 + "px"
        };
      } else {
        return {
          top: canvas.value.y + "px",
          left: canvas.value.x + "px"
        };
      }
    });
    const styleContent = computed(() => {
      if (direction.value === "vertical") {
        return {
          top: "5px",
          left: position.value.x - 30 + "px"
        };
      } else if (direction.value === "horizontal") {
        return {
          top: position.value.y + "px",
          transform: `translateX(${isRight.value ? "-100%" : 0})`
        };
      } else {
        return {
          top: position.value.y + "px",
          left: position.value.x + "px"
        };
      }
    });
    const formatValue = (val, formatter) => {
      return is$1(Function, formatter) ? formatter(val) : is$1(Number, val) ? format(formatter)(val) : val;
    };
    const items = computed(() => {
      return Object.keys(omit$1(["idx"], payload.value)).map((key) => {
        const config = Object.assign({ label: key, format: props2.format, color: props2.color, hide: false }, props2.config[key]);
        return {
          key,
          label: config.label,
          value: payload.value[key],
          valueFormatted: formatValue(payload.value[key], config.format),
          color: is$1(Function, config.color) ? config.color(payload.value) : config.color,
          hide: config.hide
        };
      }).filter((i2) => !i2.hide);
    });
    watch(chart.updates, () => {
      direction.value = chart.config.direction;
      canvas.value = chart.canvas;
    });
    return { el, show, canvas, direction, style, styleContent, position, items, isRight };
  }
});
const _hoisted_1$3$1 = { key: 0 };
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.show ? (openBlock(), createElementBlock(
    "div",
    {
      key: 0,
      class: "v-tooltip",
      style: normalizeStyle(_ctx.style)
    },
    [
      createElementVNode(
        "div",
        {
          class: "v-tooltip-content",
          style: normalizeStyle(_ctx.styleContent),
          ref: "el"
        },
        [
          renderSlot(_ctx.$slots, "default", { payload: _ctx.items }, () => [
            createElementVNode(
              "div",
              {
                style: normalizeStyle({ borderColor: _ctx.color })
              },
              [
                (openBlock(true), createElementBlock(
                  Fragment,
                  null,
                  renderList(_ctx.items, (item, i2) => {
                    return openBlock(), createElementBlock(
                      "div",
                      {
                        key: i2,
                        style: normalizeStyle({ color: item.color })
                      },
                      [
                        createElementVNode(
                          "b",
                          null,
                          toDisplayString(item.label),
                          1
                          /* TEXT */
                        ),
                        createTextVNode(
                          ": " + toDisplayString(item.valueFormatted),
                          1
                          /* TEXT */
                        )
                      ],
                      4
                      /* STYLE */
                    );
                  }),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ],
              4
              /* STYLE */
            )
          ])
        ],
        4
        /* STYLE */
      ),
      !_ctx.hideLine ? (openBlock(), createElementBlock("div", _hoisted_1$3$1, [
        _ctx.direction === "horizontal" ? (openBlock(), createElementBlock(
          "div",
          {
            key: 0,
            class: "v-tooltip-line-vertical",
            style: normalizeStyle({
              height: _ctx.canvas.height + "px"
            })
          },
          null,
          4
          /* STYLE */
        )) : (openBlock(), createElementBlock(
          "div",
          {
            key: 1,
            class: "v-tooltip-line-horizontal",
            style: normalizeStyle({
              width: _ctx.canvas.width - 40 + "px"
            })
          },
          null,
          4
          /* STYLE */
        ))
      ])) : createCommentVNode("v-if", true)
    ],
    4
    /* STYLE */
  )) : createCommentVNode("v-if", true);
}
var css_248z = "\n.v-tooltip[data-v-43da20c6] {\n  position: absolute;\n  pointer-events: none;\n}\n.v-tooltip-content[data-v-43da20c6] {\n  position: absolute;\n  white-space: nowrap;\n  pointer-events: none;\n}\n.v-tooltip-content > div[data-v-43da20c6] {\n  margin-left: 5px;\n  margin-right: 5px;\n  border: 2px solid;\n  background-color: white;\n  padding: 8px;\n  text-align: left;\n  border-radius: 4px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n.v-tooltip-right[data-v-43da20c6] {\n  transform: translateX(-100%);\n  margin-left: 0;\n}\n.v-tooltip-line-vertical[data-v-43da20c6] {\n  top: 0px;\n  position: absolute;\n  width: 1px;\n  background-color: black;\n  pointer-events: none;\n  opacity: 0.3;\n}\n.v-tooltip-line-horizontal[data-v-43da20c6] {\n  left: 0px;\n  position: absolute;\n  height: 1px;\n  background-color: black;\n  pointer-events: none;\n  opacity: 0.3;\n}\n";
styleInject(css_248z);
script$4.render = render$4;
script$4.__scopeId = "data-v-43da20c6";
script$4.__file = "src/components/Tooltip/index.vue";
var script$3 = defineComponent({
  props: {
    stacked: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: -1
    }
  },
  setup(props2) {
    provide("layerProps", props2);
  }
});
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
script$3.render = render$3;
script$3.__file = "src/components/Group/index.vue";
var script$2 = defineComponent({
  name: "Grid",
  props: {
    value: {
      type: Number
    },
    label: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "red"
    },
    strokeDasharray: {
      type: String,
      default: () => "3"
    },
    strokeWidth: {
      type: Number,
      default: 1
    },
    strokeOpacity: {
      type: Number,
      default: 0.5
    }
  },
  setup(props2) {
    const chart = useChart();
    const y2 = ref(0);
    const direction = ref("horizontal");
    const canvas = ref({});
    watch(chart.updates, () => {
      if (props2.value !== void 0) {
        y2.value = chart.scales.secondary.scale(props2.value);
      }
      canvas.value = chart.canvas;
      direction.value = chart.config.direction;
    }, { immediate: true });
    watch(() => props2.value, () => {
      y2.value = chart.scales.secondary.scale(props2.value);
    }, { immediate: true });
    return { y: y2, canvas, direction };
  }
});
const _hoisted_1$2$1 = {
  key: 0,
  class: "layer-marker"
};
const _hoisted_2$2$1 = ["x", "y", "fill"];
const _hoisted_3$1$1 = ["x1", "y1", "x2", "y2", "stroke", "stroke-opacity", "stroke-width", "stroke-dasharray"];
const _hoisted_4$1$1 = {
  key: 1,
  class: "layer-marker"
};
const _hoisted_5$1$1 = ["x", "y", "fill"];
const _hoisted_6$1$1 = ["x1", "y1", "x2", "y2", "stroke", "stroke-opacity", "stroke-width", "stroke-dasharray"];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.direction === "horizontal" ? (openBlock(), createElementBlock("g", _hoisted_1$2$1, [
    createElementVNode("text", {
      x: _ctx.canvas.x + 5,
      y: _ctx.y - 5,
      "text-anchor": "start",
      fill: _ctx.color
    }, toDisplayString(_ctx.label), 9, _hoisted_2$2$1),
    createElementVNode("line", {
      x1: _ctx.canvas.x,
      y1: _ctx.y,
      x2: _ctx.canvas.width,
      y2: _ctx.y,
      stroke: _ctx.color,
      "stroke-opacity": _ctx.strokeOpacity,
      "stroke-width": _ctx.strokeWidth,
      "stroke-dasharray": _ctx.strokeDasharray
    }, null, 8, _hoisted_3$1$1)
  ])) : (openBlock(), createElementBlock("g", _hoisted_4$1$1, [
    createElementVNode("text", {
      x: _ctx.y + 10,
      y: _ctx.canvas.y + 5,
      "text-anchor": "start",
      fill: _ctx.color,
      style: { "writing-mode": "tb" }
    }, toDisplayString(_ctx.label), 9, _hoisted_5$1$1),
    createElementVNode("line", {
      x1: _ctx.y,
      y1: _ctx.canvas.y,
      x2: _ctx.y,
      y2: _ctx.canvas.height,
      stroke: _ctx.color,
      "stroke-opacity": _ctx.strokeOpacity,
      "stroke-width": _ctx.strokeWidth,
      "stroke-dasharray": _ctx.strokeDasharray
    }, null, 8, _hoisted_6$1$1)
  ]));
}
script$2.render = render$2;
script$2.__file = "src/components/Marker/index.vue";
function count(node) {
  var sum = 0, children2 = node.children, i2 = children2 && children2.length;
  if (!i2) sum = 1;
  else while (--i2 >= 0) sum += children2[i2].value;
  node.value = sum;
}
function node_count() {
  return this.eachAfter(count);
}
function node_each(callback, that) {
  let index2 = -1;
  for (const node of this) {
    callback.call(that, node, ++index2, this);
  }
  return this;
}
function node_eachBefore(callback, that) {
  var node = this, nodes = [node], children2, i2, index2 = -1;
  while (node = nodes.pop()) {
    callback.call(that, node, ++index2, this);
    if (children2 = node.children) {
      for (i2 = children2.length - 1; i2 >= 0; --i2) {
        nodes.push(children2[i2]);
      }
    }
  }
  return this;
}
function node_eachAfter(callback, that) {
  var node = this, nodes = [node], next = [], children2, i2, n2, index2 = -1;
  while (node = nodes.pop()) {
    next.push(node);
    if (children2 = node.children) {
      for (i2 = 0, n2 = children2.length; i2 < n2; ++i2) {
        nodes.push(children2[i2]);
      }
    }
  }
  while (node = next.pop()) {
    callback.call(that, node, ++index2, this);
  }
  return this;
}
function node_find(callback, that) {
  let index2 = -1;
  for (const node of this) {
    if (callback.call(that, node, ++index2, this)) {
      return node;
    }
  }
}
function node_sum(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0, children2 = node.children, i2 = children2 && children2.length;
    while (--i2 >= 0) sum += children2[i2].value;
    node.value = sum;
  });
}
function node_sort(compare2) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare2);
    }
  });
}
function node_path(end) {
  var start = this, ancestor = leastCommonAncestor(start, end), nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k2 = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k2, 0, end);
    end = end.parent;
  }
  return nodes;
}
function leastCommonAncestor(a2, b2) {
  if (a2 === b2) return a2;
  var aNodes = a2.ancestors(), bNodes = b2.ancestors(), c2 = null;
  a2 = aNodes.pop();
  b2 = bNodes.pop();
  while (a2 === b2) {
    c2 = a2;
    a2 = aNodes.pop();
    b2 = bNodes.pop();
  }
  return c2;
}
function node_ancestors() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
}
function node_descendants() {
  return Array.from(this);
}
function node_leaves() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
}
function node_links() {
  var root2 = this, links = [];
  root2.each(function(node) {
    if (node !== root2) {
      links.push({ source: node.parent, target: node });
    }
  });
  return links;
}
function* node_iterator() {
  var node = this, current, next = [node], children2, i2, n2;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      yield node;
      if (children2 = node.children) {
        for (i2 = 0, n2 = children2.length; i2 < n2; ++i2) {
          next.push(children2[i2]);
        }
      }
    }
  } while (next.length);
}
function hierarchy(data2, children2) {
  if (data2 instanceof Map) {
    data2 = [void 0, data2];
    if (children2 === void 0) children2 = mapChildren;
  } else if (children2 === void 0) {
    children2 = objectChildren;
  }
  var root2 = new Node$1(data2), node, nodes = [root2], child, childs, i2, n2;
  while (node = nodes.pop()) {
    if ((childs = children2(node.data)) && (n2 = (childs = Array.from(childs)).length)) {
      node.children = childs;
      for (i2 = n2 - 1; i2 >= 0; --i2) {
        nodes.push(child = childs[i2] = new Node$1(childs[i2]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }
  return root2.eachBefore(computeHeight);
}
function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d2) {
  return d2.children;
}
function mapChildren(d2) {
  return Array.isArray(d2) ? d2[1] : null;
}
function copyData(node) {
  if (node.data.value !== void 0) node.value = node.data.value;
  node.data = node.data.data;
}
function computeHeight(node) {
  var height = 0;
  do
    node.height = height;
  while ((node = node.parent) && node.height < ++height);
}
function Node$1(data2) {
  this.data = data2;
  this.depth = this.height = 0;
  this.parent = null;
}
Node$1.prototype = hierarchy.prototype = {
  constructor: Node$1,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  find: node_find,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy,
  [Symbol.iterator]: node_iterator
};
function optional(f2) {
  return f2 == null ? null : required(f2);
}
function required(f2) {
  if (typeof f2 !== "function") throw new Error();
  return f2;
}
function constantZero() {
  return 0;
}
function constant(x2) {
  return function() {
    return x2;
  };
}
function roundNode(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
}
function treemapDice(parent, x0, y0, x1, y1) {
  var nodes = parent.children, node, i2 = -1, n2 = nodes.length, k2 = parent.value && (x1 - x0) / parent.value;
  while (++i2 < n2) {
    node = nodes[i2], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k2;
  }
}
var preroot = { depth: -1 }, ambiguous = {}, imputed = {};
function defaultId(d2) {
  return d2.id;
}
function defaultParentId(d2) {
  return d2.parentId;
}
function stratify() {
  var id = defaultId, parentId = defaultParentId, path;
  function stratify2(data2) {
    var nodes = Array.from(data2), currentId = id, currentParentId = parentId, n2, d2, i2, root2, parent, node, nodeId, nodeKey, nodeByKey = /* @__PURE__ */ new Map();
    if (path != null) {
      const I = nodes.map((d3, i3) => normalize(path(d3, i3, data2)));
      const P2 = I.map(parentof);
      const S2 = new Set(I).add("");
      for (const i3 of P2) {
        if (!S2.has(i3)) {
          S2.add(i3);
          I.push(i3);
          P2.push(parentof(i3));
          nodes.push(imputed);
        }
      }
      currentId = (_2, i3) => I[i3];
      currentParentId = (_2, i3) => P2[i3];
    }
    for (i2 = 0, n2 = nodes.length; i2 < n2; ++i2) {
      d2 = nodes[i2], node = nodes[i2] = new Node$1(d2);
      if ((nodeId = currentId(d2, i2, data2)) != null && (nodeId += "")) {
        nodeKey = node.id = nodeId;
        nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
      }
      if ((nodeId = currentParentId(d2, i2, data2)) != null && (nodeId += "")) {
        node.parent = nodeId;
      }
    }
    for (i2 = 0; i2 < n2; ++i2) {
      node = nodes[i2];
      if (nodeId = node.parent) {
        parent = nodeByKey.get(nodeId);
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      } else {
        if (root2) throw new Error("multiple roots");
        root2 = node;
      }
    }
    if (!root2) throw new Error("no root");
    if (path != null) {
      while (root2.data === imputed && root2.children.length === 1) {
        root2 = root2.children[0], --n2;
      }
      for (let i3 = nodes.length - 1; i3 >= 0; --i3) {
        node = nodes[i3];
        if (node.data !== imputed) break;
        node.data = null;
      }
    }
    root2.parent = preroot;
    root2.eachBefore(function(node2) {
      node2.depth = node2.parent.depth + 1;
      --n2;
    }).eachBefore(computeHeight);
    root2.parent = null;
    if (n2 > 0) throw new Error("cycle");
    return root2;
  }
  stratify2.id = function(x2) {
    return arguments.length ? (id = optional(x2), stratify2) : id;
  };
  stratify2.parentId = function(x2) {
    return arguments.length ? (parentId = optional(x2), stratify2) : parentId;
  };
  stratify2.path = function(x2) {
    return arguments.length ? (path = optional(x2), stratify2) : path;
  };
  return stratify2;
}
function normalize(path) {
  path = `${path}`;
  let i2 = path.length;
  if (slash(path, i2 - 1) && !slash(path, i2 - 2)) path = path.slice(0, -1);
  return path[0] === "/" ? path : `/${path}`;
}
function parentof(path) {
  let i2 = path.length;
  if (i2 < 2) return "";
  while (--i2 > 1) if (slash(path, i2)) break;
  return path.slice(0, i2);
}
function slash(path, i2) {
  if (path[i2] === "/") {
    let k2 = 0;
    while (i2 > 0 && path[--i2] === "\\") ++k2;
    if ((k2 & 1) === 0) return true;
  }
  return false;
}
function treemapSlice(parent, x0, y0, x1, y1) {
  var nodes = parent.children, node, i2 = -1, n2 = nodes.length, k2 = parent.value && (y1 - y0) / parent.value;
  while (++i2 < n2) {
    node = nodes[i2], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k2;
  }
}
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n2 = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
  while (i0 < n2) {
    dx = x1 - x0, dy = y1 - y0;
    do
      sumValue = nodes[i1++].value;
    while (!sumValue && i1 < n2);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);
    for (; i1 < n2; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) {
        sumValue -= nodeValue;
        break;
      }
      minRatio = newRatio;
    }
    rows.push(row = { value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1) });
    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }
  return rows;
}
var squarify = function custom(ratio) {
  function squarify2(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }
  squarify2.ratio = function(x2) {
    return custom((x2 = +x2) > 1 ? x2 : 1);
  };
  return squarify2;
}(phi);
function treemap() {
  var tile = squarify, round = false, dx = 1, dy = 1, paddingStack = [0], paddingInner = constantZero, paddingTop = constantZero, paddingRight = constantZero, paddingBottom = constantZero, paddingLeft = constantZero;
  function treemap2(root2) {
    root2.x0 = root2.y0 = 0;
    root2.x1 = dx;
    root2.y1 = dy;
    root2.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root2.eachBefore(roundNode);
    return root2;
  }
  function positionNode(node) {
    var p2 = paddingStack[node.depth], x0 = node.x0 + p2, y0 = node.y0 + p2, x1 = node.x1 - p2, y1 = node.y1 - p2;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p2 = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p2;
      y0 += paddingTop(node) - p2;
      x1 -= paddingRight(node) - p2;
      y1 -= paddingBottom(node) - p2;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }
  treemap2.round = function(x2) {
    return arguments.length ? (round = !!x2, treemap2) : round;
  };
  treemap2.size = function(x2) {
    return arguments.length ? (dx = +x2[0], dy = +x2[1], treemap2) : [dx, dy];
  };
  treemap2.tile = function(x2) {
    return arguments.length ? (tile = required(x2), treemap2) : tile;
  };
  treemap2.padding = function(x2) {
    return arguments.length ? treemap2.paddingInner(x2).paddingOuter(x2) : treemap2.paddingInner();
  };
  treemap2.paddingInner = function(x2) {
    return arguments.length ? (paddingInner = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingInner;
  };
  treemap2.paddingOuter = function(x2) {
    return arguments.length ? treemap2.paddingTop(x2).paddingRight(x2).paddingBottom(x2).paddingLeft(x2) : treemap2.paddingTop();
  };
  treemap2.paddingTop = function(x2) {
    return arguments.length ? (paddingTop = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingTop;
  };
  treemap2.paddingRight = function(x2) {
    return arguments.length ? (paddingRight = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingRight;
  };
  treemap2.paddingBottom = function(x2) {
    return arguments.length ? (paddingBottom = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingBottom;
  };
  treemap2.paddingLeft = function(x2) {
    return arguments.length ? (paddingLeft = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingLeft;
  };
  return treemap2;
}
var script$1 = defineComponent({
  name: "Treemap",
  props: {
    size: {
      type: Object,
      default: () => ({ width: 500, height: 400 }),
      required: false
    },
    margin: {
      type: Object,
      default: () => ({ top: 0, right: 0, bottom: 0, left: 0 })
    },
    padding: {
      type: Number,
      default: 8
    },
    data: {
      type: Array,
      default: () => []
    },
    dataKeys: {
      type: Object,
      required: true
    },
    colorFn: {
      type: Function,
      default: () => interpolateHcl("#60c96e", "#6b46c1")
    },
    rcStyle: {
      type: Function,
      required: false
    }
  },
  setup(props2) {
    const el = ref(null);
    const data2 = ref(props2.data);
    const selected = ref(null);
    const canvas = ref({
      x: props2.margin.left,
      y: props2.margin.top,
      width: props2.size.width - props2.margin.right,
      height: props2.size.height - props2.margin.bottom
    });
    const rectangles = ref([]);
    function getScales() {
      const values3 = extent(data2.value.map((d2) => d2[props2.dataKeys[1]]));
      const x2 = linear().domain(values3).range([0, 100]).nice();
      const y2 = sequential().domain(values3).interpolator(props2.colorFn());
      return { x: x2, y: y2 };
    }
    function buildRectangles() {
      const { y: y2 } = getScales();
      const res = buildTree(data2.value).leaves().map((d2, idx) => {
        return {
          idx,
          x0: canvas.value.x + d2.x0,
          x1: canvas.value.x + d2.x1,
          y0: canvas.value.y + d2.y0,
          y1: canvas.value.y + d2.y1,
          width: d2.x1 - d2.x0,
          height: d2.y1 - d2.y0,
          data: d2.data,
          color: y2(d2.value)
          // props.color
        };
      });
      return res;
    }
    function buildTree(data3) {
      const { x: x2 } = getScales();
      const createTreeMap = treemap().size([canvas.value.width - canvas.value.x, canvas.value.height - canvas.value.y]).padding(props2.padding);
      const treeFn = stratify().id((d2) => d2.name).parentId((d2) => d2.parent);
      const tree = treeFn([{ name: "root" }].concat(data3.map((x3) => {
        return {
          name: x3[props2.dataKeys[0]],
          value: x3[props2.dataKeys[1]],
          parent: "root"
        };
      })));
      tree.sum((d2) => x2(d2.value));
      createTreeMap(tree);
      return tree;
    }
    const toKebabCase = (data3) => mapKeys(kebabize, data3);
    const getStyle = (r2) => {
      const style = {
        stroke: r2.color,
        strokeWidth: 5,
        fill: r2.color,
        fillOpacity: 0.9
      };
      if (props2.rcStyle && typeof props2.rcStyle === "function") {
        return Object.assign(Object.assign({}, style), props2.rcStyle(r2));
      }
      return style;
    };
    function onMouseOver(i2) {
      selected.value = i2;
    }
    function onMouseOut() {
      selected.value = null;
    }
    watch(props2, () => {
      data2.value = props2.data;
      canvas.value = {
        x: props2.margin.left,
        y: props2.margin.top,
        width: props2.size.width - props2.margin.right,
        height: props2.size.height - props2.margin.bottom
      };
      rectangles.value = buildRectangles();
    }, { immediate: true });
    return { el, rectangles, selected, getStyle, toKebabCase, onMouseOver, onMouseOut };
  }
});
const _hoisted_1$1$1 = {
  class: "treemap",
  style: { display: "flex", position: "relative" }
};
const _hoisted_2$1$1 = ["width", "height", "viewBox"];
const _hoisted_3$w = { class: "layer-rectangles" };
const _hoisted_4$l = ["transform", "onMouseover"];
const _hoisted_5$k = ["width", "height"];
const _hoisted_6$h = {
  x: 0 + 10,
  y: 0 + 20,
  "font-size": `15px`,
  fill: `white`,
  "font-weight": "bold"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1$1, [
    (openBlock(), createElementBlock("svg", {
      width: _ctx.size.width,
      height: _ctx.size.height,
      viewBox: `0 0 ${_ctx.size.width} ${_ctx.size.height}`,
      ref: "el"
    }, [
      createElementVNode("g", _hoisted_3$w, [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList(_ctx.rectangles, (r2, i2) => {
            return openBlock(), createElementBlock("g", {
              class: normalizeClass(["rectangle", { selected: _ctx.selected === i2 }]),
              key: i2,
              transform: `translate(${r2.x0}, ${r2.y0})`,
              onMouseover: () => _ctx.onMouseOver(i2),
              onMouseleave: _cache[0] || (_cache[0] = (...args) => _ctx.onMouseOut && _ctx.onMouseOut(...args))
            }, [
              renderSlot(_ctx.$slots, "default", {
                r: r2,
                selected: _ctx.selected === i2
              }, () => [
                createElementVNode("rect", mergeProps(_ctx.toKebabCase(_ctx.getStyle(r2)), {
                  x: 0,
                  y: 0,
                  width: r2.width,
                  height: r2.height
                }), null, 16, _hoisted_5$k),
                renderSlot(_ctx.$slots, "text", {
                  r: r2,
                  selected: _ctx.selected === i2
                }, () => [
                  createElementVNode(
                    "text",
                    _hoisted_6$h,
                    toDisplayString(r2.data.name),
                    1
                    /* TEXT */
                  )
                ])
              ])
            ], 42, _hoisted_4$l);
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ])
    ], 8, _hoisted_2$1$1)),
    renderSlot(_ctx.$slots, "widgets")
  ]);
}
script$1.render = render$1;
script$1.__file = "src/components/Treemap/index.vue";
var script = defineComponent({
  name: "HoverBar",
  props: {
    barStyle: {
      type: Object,
      default: () => ({ "fill-opacity": 0.05 })
    }
  },
  setup() {
    const chart = useChart();
    const mouse = useMouse();
    const bar = ref({ x: 0, y: 0, width: 0, height: 0 });
    const direction = ref("horizontal");
    const canvas = ref({ x: 0, y: 0, width: 0, height: 0 });
    watch(chart.updates, () => {
      canvas.value = chart.canvas;
      direction.value = chart.config.direction;
    }, { immediate: true });
    watch(mouse, () => {
      if (chart.bandScale) {
        const vals = chart.getData(chart.getKeys(0));
        const [x2] = chart.bandScale.map([vals[mouse.index]]);
        const width = chart.bandScale.bandwidth();
        if (x2) {
          if (chart.config.direction === "horizontal") {
            bar.value = {
              x: x2 - width / 2,
              y: 0,
              width,
              height: canvas.value.height
            };
          } else {
            bar.value = {
              x: 40,
              y: x2 - width / 2,
              width: canvas.value.width - 40,
              height: width
            };
          }
        }
      }
    });
    return { bar, canvas, direction, mouse };
  }
});
const _hoisted_1$Q = {
  key: 0,
  class: "layer-hover-bar"
};
const _hoisted_2$C = ["x", "y", "width", "height"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.mouse.hover ? (openBlock(), createElementBlock("g", _hoisted_1$Q, [
    createElementVNode("rect", mergeProps({ class: "hover-bar" }, _ctx.barStyle, {
      x: _ctx.bar.x,
      y: _ctx.bar.y,
      width: _ctx.bar.width > 0 ? _ctx.bar.width : 0,
      height: _ctx.bar.height > 0 ? _ctx.bar.height : 0
    }), null, 16, _hoisted_2$C)
  ])) : createCommentVNode("v-if", true);
}
script.render = render;
script.__file = "src/components/HoverBar/index.vue";
const BRAND_COLOR = "var(--bgl-primary)";
const _sfc_main$_ = /* @__PURE__ */ defineComponent({
  __name: "Lineart",
  props: {
    data: {},
    locale: {}
  },
  setup(__props) {
    const props2 = __props;
    const data2 = computed(() => props2.locale === "he" ? [...props2.data].reverse() : props2.data);
    const meanValue = computed(() => {
      const sum = props2.data.reduce((acc, curr) => acc + +curr.total_value, 0);
      return sum / props2.data.length;
    });
    const axisConfig = computed(() => ({
      primary: {
        type: "band",
        rotate: true,
        ticks: 5,
        domain: ["dataMin", "dataMax"],
        tickValues: props2.data.length > 100 ? [""] : props2.data.map((d2) => d2.date)
      },
      secondary: {
        domain: ["dataMin", "dataMax * 1.05"],
        type: "linear",
        ticks: 8
      }
    }));
    const tooltipConfiguration = {
      date: { label: "תאריך" },
      total_value: {
        color: BRAND_COLOR,
        label: "סכום",
        format: (v2) => `₪${v2.toLocaleString() || ""}`
      },
      total_count: {
        label: "מספר התרומות",
        format: (v2) => `${v2.toLocaleString() || ""}`
      }
    };
    let chartSize = ref();
    const chartContainer = ref();
    const displayMarker = ref(true);
    const chartMargin = ref({
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    });
    function adjustChartSize() {
      chartSize.value = void 0;
      const el = chartContainer.value;
      if (!el) return;
      const { width, height } = el.getBoundingClientRect();
      chartSize.value = { width: width - 5, height: height - 10 };
    }
    function handleResize() {
      setTimeout(adjustChartSize, 300);
    }
    onMounted(() => {
      adjustChartSize();
      window.addEventListener("resize", handleResize);
    });
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    function dotStyling(ctx) {
      return {
        r: ctx.active ? 5 : 1,
        fill: BRAND_COLOR
      };
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "chartContainer",
        ref: chartContainer,
        class: "chart-line"
      }, [
        unref(chartSize) ? (openBlock(), createBlock(unref(script$c), {
          key: 0,
          size: unref(chartSize),
          data: data2.value,
          margin: chartMargin.value,
          axis: axisConfig.value
        }, {
          layers: withCtx(() => [
            createVNode(unref(script$5), {
              center: true,
              strokeDasharray: "2,2",
              hideY: true
            }),
            createVNode(unref(script$a), {
              "aria-label": "Profit/Loss",
              dataKeys: ["date", "total_value"],
              type: "monotone",
              areaStyle: { fill: "url(#grad)" }
            }),
            createVNode(unref(script$9), {
              dataKeys: ["date", "total_value"],
              type: "monotone",
              dotStyle: dotStyling,
              lineStyle: { stroke: BRAND_COLOR, r: 2 }
            }, null, 8, ["lineStyle"]),
            displayMarker.value ? (openBlock(), createBlock(unref(script$2), {
              key: 0,
              value: meanValue.value,
              label: "ממוצע",
              color: BRAND_COLOR,
              strokeWidth: 2,
              strokeDasharray: "6 6"
            }, null, 8, ["value"])) : createCommentVNode("", true),
            createElementVNode("defs", null, [
              createElementVNode("linearGradient", {
                id: "grad",
                gradientTransform: "rotate(90)"
              }, [
                createElementVNode("stop", {
                  offset: "0%",
                  "stop-color": BRAND_COLOR,
                  "stop-opacity": "1"
                }),
                _cache[0] || (_cache[0] = createElementVNode("stop", {
                  offset: "100%",
                  "stop-color": "white",
                  "stop-opacity": "0.4"
                }, null, -1))
              ])
            ])
          ]),
          widgets: withCtx(() => [
            createVNode(unref(script$4), {
              color: "white",
              config: tooltipConfiguration
            })
          ]),
          _: 1
        }, 8, ["size", "data", "margin", "axis"])) : createCommentVNode("", true)
      ], 512);
    };
  }
});
const SLOT_VALUE_COMPONENTS$1 = /* @__PURE__ */ new Set(["div", "span", "p"]);
const SRC_VALUE_COMPONENTS$1 = /* @__PURE__ */ new Set(["img", "iframe"]);
function useSchemaField(optns) {
  const { mode = "form", getRowData, onUpdate, includeUnset = false } = optns;
  function renderObject(obj, depth = 0) {
    if (obj === null || obj === void 0) return "";
    if (typeof obj !== "object") return String(obj);
    if (Array.isArray(obj)) return obj.map((item) => renderObject(item, depth + 1)).join(", ");
    const indent = depth > 0 ? "  ".repeat(depth) : "";
    const nextIndent = "  ".repeat(depth + 1);
    const entries = Object.entries(obj);
    if (entries.length === 0) return "{}";
    if (depth > 0) {
      return `{
${entries.map(([key, value]) => `${nextIndent}${key}: ${renderObject(value, depth + 1)}`).join(",\n")}
${indent}}`;
    }
    return entries.map(([key, value]) => {
      const valueStr = typeof value === "object" && value !== null ? renderObject(value, depth + 1) : String(value);
      return `${key}: ${valueStr}`;
    }).join("\n");
  }
  function getComponent(field) {
    var _a;
    const componentMap = {
      text: TextInput,
      textarea: TextInput,
      number: NumberInput,
      array: _sfc_main$S,
      color: _sfc_main$O,
      tel: TelInput,
      select: SelectInput,
      toggle: ToggleInput,
      check: CheckInput,
      richtext: RichText,
      upload: UploadInput,
      file: UploadInput,
      date: DateInput,
      tabs: TabsNav,
      form: _sfc_main$T,
      range: RangeInput
    };
    if (field.$el === "textarea" && !((_a = field.attrs) == null ? void 0 : _a.multiline)) {
      field.attrs = { ...field.attrs, multiline: true };
    }
    return typeof field.$el === "object" ? field.$el : componentMap[field.$el] ?? field.$el ?? "div";
  }
  function renderChild(child, slots) {
    if (typeof child === "string") return child;
    if (isVNode(child)) return child;
    return renderField(child, slots);
  }
  function renderField(field, slots) {
    const Component = getComponent(field);
    if (!Component) return null;
    const rowData = (getRowData == null ? void 0 : getRowData()) || {};
    const condition = field.vIf ?? field["v-if"];
    if (condition !== void 0) {
      if (typeof condition === "function") {
        if (!condition(field.id ? rowData[field.id] : void 0, rowData)) {
          return null;
        }
      } else if (typeof condition === "string") {
        if (!rowData[condition]) {
          return null;
        }
      } else if (!condition) {
        return null;
      }
    }
    const {
      $el,
      children: children2,
      options,
      attrs,
      class: fieldClass,
      id,
      transform,
      slots: fieldSlots,
      required: required2,
      label,
      placeholder,
      disabled,
      ...fieldProps
    } = field;
    const currentValue = field.id ? "get" in rowData ? rowData.get(field.id) : rowData[field.id] : void 0;
    const transformedValue = transform ? transform(currentValue, rowData) : currentValue;
    const boundFieldProps = bindAttrs(fieldProps, currentValue, rowData);
    const isSlotValueComponent = typeof Component === "string" && SLOT_VALUE_COMPONENTS$1.has(Component);
    const isSrcValueComponent = typeof Component === "string" && SRC_VALUE_COMPONENTS$1.has(Component);
    const props2 = {
      ...boundFieldProps,
      required: required2,
      label,
      placeholder,
      disabled
    };
    if (mode === "form") {
      props2.modelValue = currentValue;
      props2["onUpdate:modelValue"] = (value) => {
        onUpdate == null ? void 0 : onUpdate(field, value);
      };
    } else {
      if (isSlotValueComponent) ;
      else if (isSrcValueComponent) {
        props2.src = transformedValue;
      } else {
        props2.modelValue = transformedValue;
      }
    }
    Object.keys(props2).forEach((key) => props2[key] === void 0 && delete props2[key]);
    if (field.options) {
      props2.options = typeof field.options === "function" ? field.options(currentValue, rowData) : field.options;
    }
    if (field.attrs) {
      const boundAttrs = bindAttrs(field.attrs, currentValue, rowData);
      Object.entries(boundAttrs).forEach(([key, value]) => {
        if (typeof value === "function") {
          if (key.startsWith("on")) {
            props2[key] = value;
          } else {
            props2[key] = value(currentValue, rowData);
          }
        } else {
          props2[key] = value;
        }
      });
    }
    props2.class = classify(currentValue, rowData, fieldClass, props2.class);
    const componentSlots = {};
    if (children2 == null ? void 0 : children2.length) {
      componentSlots.default = () => children2.map((child) => renderChild(child, slots)).filter(Boolean);
    }
    if (isSlotValueComponent && transformedValue !== void 0) {
      componentSlots.default = () => (transformedValue == null ? void 0 : transformedValue.toString()) || "";
    }
    if (fieldSlots) {
      Object.entries(fieldSlots).forEach(([name, slot]) => {
        componentSlots[name] = () => {
          if (Array.isArray(slot)) {
            return slot.map((schemaField) => renderField(schemaField, slots));
          }
          if (isVNode(slot)) {
            return slot;
          }
          if (typeof slot === "function") {
            const slotFn = slot;
            return slotFn({ row: rowData, field });
          }
          return slot;
        };
      });
    }
    const slotContent = field.id && (slots == null ? void 0 : slots[field.id]) ? slots[field.id]({ row: rowData, field }) : void 0;
    if (mode === "preview") {
      if (!includeUnset && (transformedValue === void 0 || transformedValue === null || transformedValue.length === 0)) {
        return null;
      }
      return h$2("div", { class: "preview-field" }, [
        h$2("div", { class: "field-label" }, `${field.label || keyToLabel(field.id || "")}:`),
        h$2("div", { class: "field-value" }, [
          slotContent || (typeof field.$el === "object" ? h$2(Component, props2, componentSlots) : typeof transformedValue === "object" && transformedValue !== null ? h$2("pre", { style: "margin: 0; white-space: pre-wrap; font-family: inherit; font-size: inherit;" }, renderObject(transformedValue)) : (transformedValue == null ? void 0 : transformedValue.toString()) || "")
        ])
      ]);
    }
    return slotContent || h$2(Component, props2, componentSlots);
  }
  return {
    renderField,
    getComponent
  };
}
const NON_DIGIT_REGEX = /[^\d.-]/g;
const SLOT_VALUE_COMPONENTS = /* @__PURE__ */ new Set(["div", "span", "p"]);
const SRC_VALUE_COMPONENTS = /* @__PURE__ */ new Set(["img", "iframe"]);
function useTableData(options) {
  const sortField = ref("");
  const sortDirection = ref("ASC");
  const schemaState = ref("loading");
  const resolvedSchema = ref([]);
  function getValue(value) {
    if (value === void 0 || value === null) {
      return void 0;
    }
    try {
      if (value && typeof value === "object" && "value" in value) {
        return value.value;
      }
      return value;
    } catch (error) {
      console.error("Error in getValue:", error);
      return void 0;
    }
  }
  async function resolveSchemaAsync() {
    try {
      schemaState.value = "loading";
      const dataValue = options.data.value || [];
      const schema = useBglSchema({
        schema: await getValue(options.schema),
        columns: getValue(options.columns),
        data: dataValue
      });
      if (Array.isArray(schema) && schema.length > 0) {
        resolvedSchema.value = schema.filter((field) => field && field.id);
      } else if (Array.isArray(dataValue) && dataValue.length > 0) {
        const firstItem = dataValue[0];
        resolvedSchema.value = Object.keys(firstItem || {}).filter((key) => key !== "id" && !key.startsWith("_")).map((key) => ({
          id: key,
          label: keyToLabel(key),
          $el: "div",
          transform: (val) => {
            const dateFields = ["created_at", "updated_at"];
            if (dateFields.includes(key)) return val ? new Date(val).toLocaleString() : val;
            return val;
          }
        }));
      } else {
        resolvedSchema.value = [];
      }
      schemaState.value = "loaded";
    } catch (error) {
      console.error("Error resolving schema:", error);
      schemaState.value = "error";
      resolvedSchema.value = [];
    }
  }
  watch([
    () => getValue(options.schema),
    () => getValue(options.columns),
    () => options.data.value
  ], () => {
    resolveSchemaAsync();
  }, { immediate: true });
  onMounted(() => {
    resolveSchemaAsync();
  });
  const computedSchema = computed(() => resolvedSchema.value);
  function transform(rowData) {
    const transformed = { ...rowData };
    const schemaFields = computedSchema.value.filter((f2) => f2.id);
    for (const field of schemaFields) {
      const fieldId = field.id;
      const fieldData = rowData[fieldId];
      const transformKey = `_transformed_${String(fieldId)}`;
      const slotKey = `_slot_${String(fieldId)}`;
      const srcKey = `_src_${String(fieldId)}`;
      const originalKey = `_original_${String(fieldId)}`;
      transformed[originalKey] = fieldData;
      const isSlotValueComponent = typeof field.$el === "string" && SLOT_VALUE_COMPONENTS.has(field.$el);
      const isSrcValueComponent = typeof field.$el === "string" && SRC_VALUE_COMPONENTS.has(field.$el);
      transformed[slotKey] = isSlotValueComponent;
      transformed[srcKey] = isSrcValueComponent;
      if (field.transform) {
        const newFieldVal = field.transform(fieldData, rowData);
        transformed[transformKey] = newFieldVal;
      } else {
        transformed[transformKey] = fieldData;
      }
    }
    return transformed;
  }
  function cleanTransformedData(data2) {
    const cleanData = { ...data2 };
    Object.keys(cleanData).forEach((key) => {
      if (key.startsWith("_")) {
        delete cleanData[key];
      }
    });
    return cleanData;
  }
  const computedSortField = computed(() => sortField.value ? `_transformed_${sortField.value}` : "");
  const computedData = computed(() => {
    const currentData = options.data.value || [];
    if (!Array.isArray(currentData) || currentData.length === 0) {
      return [];
    }
    const useServerSortValue = getValue(options.useServerSort);
    if (!sortField.value || useServerSortValue === true) {
      return currentData.map(transform);
    }
    return currentData.map(transform).sort((a2, z2) => {
      const aValue = a2[computedSortField.value] ?? "";
      const bValue = z2[computedSortField.value] ?? "";
      if (isDate$1(aValue) && isDate$1(bValue)) {
        return sortDirection.value === "ASC" ? new Date(aValue).getTime() - new Date(bValue).getTime() : new Date(bValue).getTime() - new Date(aValue).getTime();
      }
      const numAValue = Number.parseInt(`${aValue}`.replaceAll(NON_DIGIT_REGEX, ""), 10);
      const numBValue = Number.parseInt(`${bValue}`.replaceAll(NON_DIGIT_REGEX, ""), 10);
      if (!Number.isNaN(numAValue) && !Number.isNaN(numBValue)) {
        return sortDirection.value === "ASC" ? numAValue - numBValue : numBValue - numAValue;
      }
      if (typeof aValue === "string") {
        return sortDirection.value === "ASC" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      }
      return sortDirection.value === "ASC" ? aValue < bValue ? -1 : 1 : aValue < bValue ? 1 : -1;
    });
  });
  function toggleSort(fieldname) {
    var _a;
    if (sortField.value === fieldname) {
      if (sortDirection.value === "ASC") {
        sortDirection.value = "DESC";
      } else {
        sortField.value = "";
      }
    } else {
      sortField.value = fieldname;
      sortDirection.value = "ASC";
    }
    (_a = options.onSort) == null ? void 0 : _a.call(options, sortField.value, sortDirection.value);
  }
  return {
    computedSchema,
    computedData,
    transform,
    sortField: computed(() => sortField.value),
    sortDirection: computed(() => sortDirection.value),
    toggleSort,
    cleanTransformedData,
    schemaState: computed(() => schemaState.value)
  };
}
const _hoisted_1$P = { class: "data-preview" };
const _hoisted_2$B = {
  key: 1,
  class: "empty-preview"
};
const _sfc_main$Z = /* @__PURE__ */ defineComponent({
  __name: "DataPreview",
  props: {
    schema: { type: Function },
    columns: {},
    useServerSort: { type: Boolean },
    selectable: { type: Boolean },
    onLastItemVisible: { type: Function },
    modelValue: {},
    includeUnset: { type: Boolean }
  },
  setup(__props) {
    const props2 = __props;
    const slots = useSlots();
    const data2 = computed(() => {
      if (!props2.modelValue) {
        return [];
      }
      return Array.isArray(props2.modelValue) ? props2.modelValue : [props2.modelValue];
    });
    const {
      computedSchema,
      computedData
    } = useTableData({
      data: data2,
      schema: props2.schema,
      columns: props2.columns,
      useServerSort: false
    });
    const firstItem = computed(() => {
      if (!computedData.value || computedData.value.length === 0) {
        return {};
      }
      return computedData.value[0] || {};
    });
    const { renderField } = useSchemaField({
      mode: "preview",
      getRowData: () => firstItem.value,
      includeUnset: props2.includeUnset
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$P, [
        unref(computedSchema) && unref(computedSchema).length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(unref(computedSchema), (field) => {
          return openBlock(), createBlock(resolveDynamicComponent(unref(renderField)(field, unref(slots))), {
            key: field.id
          });
        }), 128)) : (openBlock(), createElementBlock("div", _hoisted_2$B, " No data to display "))
      ]);
    };
  }
});
const DataPreview = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["__scopeId", "data-v-2a466c93"]]);
function useTableSelection(options) {
  const allSelectorEl = ref();
  const computedSelectedItems = computed(() => options.selectedItems.value);
  const isSelectable = computed(() => options.selectable === true && Array.isArray(options.selectedItems.value));
  function updateAllSelectorState() {
    if (!allSelectorEl.value) return;
    const allSelected = computedSelectedItems.value.length === options.selectedItems.value.length && computedSelectedItems.value.every((id) => options.selectedItems.value.includes(id));
    allSelectorEl.value.checked = allSelected;
    allSelectorEl.value.indeterminate = !allSelected && computedSelectedItems.value.length > 0;
  }
  function toggleSelectItem(item) {
    if (computedSelectedItems.value.length === 0) {
      const cleanItem = options.cleanData ? options.cleanData(item) : { ...item };
      if (!options.cleanData) {
        Object.keys(cleanItem).forEach((key) => {
          if (key.startsWith("_")) {
            delete cleanItem[key];
          }
        });
      }
      options.onSelect(cleanItem);
      return;
    }
    const index2 = computedSelectedItems.value.indexOf(item.id);
    if (index2 > -1) {
      options.selectedItems.value.splice(index2, 1);
    } else {
      options.selectedItems.value.push(item.id);
    }
  }
  function toggleSelectAll(event) {
    const value = event.target.checked;
    options.selectedItems.value = value ? computedSelectedItems.value.map((d2) => d2.id) : [];
  }
  return {
    computedSelectedItems,
    isSelectable,
    allSelectorEl,
    updateAllSelectorState,
    toggleSelectItem,
    toggleSelectAll
  };
}
function tryOnScopeDispose(fn) {
  if (getCurrentScope()) {
    onScopeDispose(fn);
    return true;
  }
  return false;
}
const isClient = typeof window !== "undefined" && typeof document !== "undefined";
typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const notNullish = (val) => val != null;
const toString$1 = Object.prototype.toString;
const isObject$2 = (val) => toString$1.call(val) === "[object Object]";
const noop$1 = () => {
};
const isIOS = /* @__PURE__ */ getIsIOS();
function getIsIOS() {
  var _a, _b;
  return isClient && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((_b = window == null ? void 0 : window.navigator) == null ? void 0 : _b.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function createFilterWrapper(filter3, fn) {
  function wrapper(...args) {
    return new Promise((resolve, reject3) => {
      Promise.resolve(filter3(() => fn.apply(this, args), { fn, thisArg: this, args })).then(resolve).catch(reject3);
    });
  }
  return wrapper;
}
function debounceFilter(ms, options = {}) {
  let timer;
  let maxTimer;
  let lastRejector = noop$1;
  const _clearTimeout = (timer2) => {
    clearTimeout(timer2);
    lastRejector();
    lastRejector = noop$1;
  };
  let lastInvoker;
  const filter3 = (invoke) => {
    const duration = toValue(ms);
    const maxDuration = toValue(options.maxWait);
    if (timer)
      _clearTimeout(timer);
    if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
      if (maxTimer) {
        _clearTimeout(maxTimer);
        maxTimer = null;
      }
      return Promise.resolve(invoke());
    }
    return new Promise((resolve, reject3) => {
      lastRejector = options.rejectOnCancel ? reject3 : resolve;
      lastInvoker = invoke;
      if (maxDuration && !maxTimer) {
        maxTimer = setTimeout(() => {
          if (timer)
            _clearTimeout(timer);
          maxTimer = null;
          resolve(lastInvoker());
        }, maxDuration);
      }
      timer = setTimeout(() => {
        if (maxTimer)
          _clearTimeout(maxTimer);
        maxTimer = null;
        resolve(invoke());
      }, duration);
    });
  };
  return filter3;
}
function promiseTimeout(ms, throwOnTimeout = false, reason = "Timeout") {
  return new Promise((resolve, reject3) => {
    if (throwOnTimeout)
      setTimeout(() => reject3(reason), ms);
    else
      setTimeout(resolve, ms);
  });
}
function toArray$1(value) {
  return Array.isArray(value) ? value : [value];
}
function getLifeCycleTarget(target) {
  return getCurrentInstance();
}
function useDebounceFn(fn, ms = 200, options = {}) {
  return createFilterWrapper(
    debounceFilter(ms, options),
    fn
  );
}
function tryOnMounted(fn, sync = true, target) {
  const instance = getLifeCycleTarget();
  if (instance)
    onMounted(fn, target);
  else if (sync)
    fn();
  else
    nextTick(fn);
}
function createUntil(r2, isNot = false) {
  function toMatch(condition, { flush = "sync", deep = false, timeout, throwOnTimeout } = {}) {
    let stop = null;
    const watcher = new Promise((resolve) => {
      stop = watch(
        r2,
        (v2) => {
          if (condition(v2) !== isNot) {
            if (stop)
              stop();
            else
              nextTick(() => stop == null ? void 0 : stop());
            resolve(v2);
          }
        },
        {
          flush,
          deep,
          immediate: true
        }
      );
    });
    const promises = [watcher];
    if (timeout != null) {
      promises.push(
        promiseTimeout(timeout, throwOnTimeout).then(() => toValue(r2)).finally(() => stop == null ? void 0 : stop())
      );
    }
    return Promise.race(promises);
  }
  function toBe(value, options) {
    if (!isRef(value))
      return toMatch((v2) => v2 === value, options);
    const { flush = "sync", deep = false, timeout, throwOnTimeout } = options != null ? options : {};
    let stop = null;
    const watcher = new Promise((resolve) => {
      stop = watch(
        [r2, value],
        ([v1, v2]) => {
          if (isNot !== (v1 === v2)) {
            if (stop)
              stop();
            else
              nextTick(() => stop == null ? void 0 : stop());
            resolve(v1);
          }
        },
        {
          flush,
          deep,
          immediate: true
        }
      );
    });
    const promises = [watcher];
    if (timeout != null) {
      promises.push(
        promiseTimeout(timeout, throwOnTimeout).then(() => toValue(r2)).finally(() => {
          stop == null ? void 0 : stop();
          return toValue(r2);
        })
      );
    }
    return Promise.race(promises);
  }
  function toBeTruthy(options) {
    return toMatch((v2) => Boolean(v2), options);
  }
  function toBeNull(options) {
    return toBe(null, options);
  }
  function toBeUndefined(options) {
    return toBe(void 0, options);
  }
  function toBeNaN(options) {
    return toMatch(Number.isNaN, options);
  }
  function toContains(value, options) {
    return toMatch((v2) => {
      const array2 = Array.from(v2);
      return array2.includes(value) || array2.includes(toValue(value));
    }, options);
  }
  function changed(options) {
    return changedTimes(1, options);
  }
  function changedTimes(n2 = 1, options) {
    let count2 = -1;
    return toMatch(() => {
      count2 += 1;
      return count2 >= n2;
    }, options);
  }
  if (Array.isArray(toValue(r2))) {
    const instance = {
      toMatch,
      toContains,
      changed,
      changedTimes,
      get not() {
        return createUntil(r2, !isNot);
      }
    };
    return instance;
  } else {
    const instance = {
      toMatch,
      toBe,
      toBeTruthy,
      toBeNull,
      toBeNaN,
      toBeUndefined,
      changed,
      changedTimes,
      get not() {
        return createUntil(r2, !isNot);
      }
    };
    return instance;
  }
}
function until(r2) {
  return createUntil(r2);
}
function watchImmediate(source, cb, options) {
  return watch(
    source,
    cb,
    {
      ...options,
      immediate: true
    }
  );
}
const defaultWindow = isClient ? window : void 0;
function unrefElement(elRef) {
  var _a;
  const plain = toValue(elRef);
  return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
function useEventListener(...args) {
  const cleanups = [];
  const cleanup = () => {
    cleanups.forEach((fn) => fn());
    cleanups.length = 0;
  };
  const register = (el, event, listener, options) => {
    el.addEventListener(event, listener, options);
    return () => el.removeEventListener(event, listener, options);
  };
  const firstParamTargets = computed(() => {
    const test2 = toArray$1(toValue(args[0])).filter((e) => e != null);
    return test2.every((e) => typeof e !== "string") ? test2 : void 0;
  });
  const stopWatch = watchImmediate(
    () => {
      var _a, _b;
      return [
        (_b = (_a = firstParamTargets.value) == null ? void 0 : _a.map((e) => unrefElement(e))) != null ? _b : [defaultWindow].filter((e) => e != null),
        toArray$1(toValue(firstParamTargets.value ? args[1] : args[0])),
        toArray$1(unref(firstParamTargets.value ? args[2] : args[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        toValue(firstParamTargets.value ? args[3] : args[2])
      ];
    },
    ([raw_targets, raw_events, raw_listeners, raw_options]) => {
      cleanup();
      if (!(raw_targets == null ? void 0 : raw_targets.length) || !(raw_events == null ? void 0 : raw_events.length) || !(raw_listeners == null ? void 0 : raw_listeners.length))
        return;
      const optionsClone = isObject$2(raw_options) ? { ...raw_options } : raw_options;
      cleanups.push(
        ...raw_targets.flatMap(
          (el) => raw_events.flatMap(
            (event) => raw_listeners.map((listener) => register(el, event, listener, optionsClone))
          )
        )
      );
    },
    { flush: "post" }
  );
  const stop = () => {
    stopWatch();
    cleanup();
  };
  tryOnScopeDispose(cleanup);
  return stop;
}
let _iOSWorkaround = false;
function onClickOutside(target, handler, options = {}) {
  const { window: window2 = defaultWindow, ignore = [], capture = true, detectIframe = false, controls = false } = options;
  if (!window2) {
    return controls ? { stop: noop$1, cancel: noop$1, trigger: noop$1 } : noop$1;
  }
  if (isIOS && !_iOSWorkaround) {
    _iOSWorkaround = true;
    const listenerOptions = { passive: true };
    Array.from(window2.document.body.children).forEach((el) => useEventListener(el, "click", noop$1, listenerOptions));
    useEventListener(window2.document.documentElement, "click", noop$1, listenerOptions);
  }
  let shouldListen = true;
  const shouldIgnore = (event) => {
    return toValue(ignore).some((target2) => {
      if (typeof target2 === "string") {
        return Array.from(window2.document.querySelectorAll(target2)).some((el) => el === event.target || event.composedPath().includes(el));
      } else {
        const el = unrefElement(target2);
        return el && (event.target === el || event.composedPath().includes(el));
      }
    });
  };
  function hasMultipleRoots(target2) {
    const vm = toValue(target2);
    return vm && vm.$.subTree.shapeFlag === 16;
  }
  function checkMultipleRoots(target2, event) {
    const vm = toValue(target2);
    const children2 = vm.$.subTree && vm.$.subTree.children;
    if (children2 == null || !Array.isArray(children2))
      return false;
    return children2.some((child) => child.el === event.target || event.composedPath().includes(child.el));
  }
  const listener = (event) => {
    const el = unrefElement(target);
    if (event.target == null)
      return;
    if (!(el instanceof Element) && hasMultipleRoots(target) && checkMultipleRoots(target, event))
      return;
    if (!el || el === event.target || event.composedPath().includes(el))
      return;
    if ("detail" in event && event.detail === 0)
      shouldListen = !shouldIgnore(event);
    if (!shouldListen) {
      shouldListen = true;
      return;
    }
    handler(event);
  };
  let isProcessingClick = false;
  const cleanup = [
    useEventListener(window2, "click", (event) => {
      if (!isProcessingClick) {
        isProcessingClick = true;
        setTimeout(() => {
          isProcessingClick = false;
        }, 0);
        listener(event);
      }
    }, { passive: true, capture }),
    useEventListener(window2, "pointerdown", (e) => {
      const el = unrefElement(target);
      shouldListen = !shouldIgnore(e) && !!(el && !e.composedPath().includes(el));
    }, { passive: true }),
    detectIframe && useEventListener(window2, "blur", (event) => {
      setTimeout(() => {
        var _a;
        const el = unrefElement(target);
        if (((_a = window2.document.activeElement) == null ? void 0 : _a.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window2.document.activeElement))) {
          handler(event);
        }
      }, 0);
    }, { passive: true })
  ].filter(Boolean);
  const stop = () => cleanup.forEach((fn) => fn());
  if (controls) {
    return {
      stop,
      cancel: () => {
        shouldListen = false;
      },
      trigger: (event) => {
        shouldListen = true;
        listener(event);
        shouldListen = false;
      }
    };
  }
  return stop;
}
function useMounted() {
  const isMounted = shallowRef(false);
  const instance = getCurrentInstance();
  if (instance) {
    onMounted(() => {
      isMounted.value = true;
    }, instance);
  }
  return isMounted;
}
function useSupported(callback) {
  const isMounted = useMounted();
  return computed(() => {
    isMounted.value;
    return Boolean(callback());
  });
}
function useResizeObserver(target, callback, options = {}) {
  const { window: window2 = defaultWindow, ...observerOptions } = options;
  let observer;
  const isSupported = useSupported(() => window2 && "ResizeObserver" in window2);
  const cleanup = () => {
    if (observer) {
      observer.disconnect();
      observer = void 0;
    }
  };
  const targets = computed(() => {
    const _targets = toValue(target);
    return Array.isArray(_targets) ? _targets.map((el) => unrefElement(el)) : [unrefElement(_targets)];
  });
  const stopWatch = watch(
    targets,
    (els) => {
      cleanup();
      if (isSupported.value && window2) {
        observer = new ResizeObserver(callback);
        for (const _el of els) {
          if (_el)
            observer.observe(_el, observerOptions);
        }
      }
    },
    { immediate: true, flush: "post" }
  );
  const stop = () => {
    cleanup();
    stopWatch();
  };
  tryOnScopeDispose(stop);
  return {
    isSupported,
    stop
  };
}
function useElementSize(target, initialSize = { width: 0, height: 0 }, options = {}) {
  const { window: window2 = defaultWindow, box = "content-box" } = options;
  const isSVG = computed(() => {
    var _a, _b;
    return (_b = (_a = unrefElement(target)) == null ? void 0 : _a.namespaceURI) == null ? void 0 : _b.includes("svg");
  });
  const width = shallowRef(initialSize.width);
  const height = shallowRef(initialSize.height);
  const { stop: stop1 } = useResizeObserver(
    target,
    ([entry]) => {
      const boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
      if (window2 && isSVG.value) {
        const $elem = unrefElement(target);
        if ($elem) {
          const rect = $elem.getBoundingClientRect();
          width.value = rect.width;
          height.value = rect.height;
        }
      } else {
        if (boxSize) {
          const formatBoxSize = toArray$1(boxSize);
          width.value = formatBoxSize.reduce((acc, { inlineSize }) => acc + inlineSize, 0);
          height.value = formatBoxSize.reduce((acc, { blockSize }) => acc + blockSize, 0);
        } else {
          width.value = entry.contentRect.width;
          height.value = entry.contentRect.height;
        }
      }
    },
    options
  );
  tryOnMounted(() => {
    const ele = unrefElement(target);
    if (ele) {
      width.value = "offsetWidth" in ele ? ele.offsetWidth : initialSize.width;
      height.value = "offsetHeight" in ele ? ele.offsetHeight : initialSize.height;
    }
  });
  const stop2 = watch(
    () => unrefElement(target),
    (ele) => {
      width.value = ele ? initialSize.width : 0;
      height.value = ele ? initialSize.height : 0;
    }
  );
  function stop() {
    stop1();
    stop2();
  }
  return {
    width,
    height,
    stop
  };
}
function useIntersectionObserver(target, callback, options = {}) {
  const {
    root: root2,
    rootMargin = "0px",
    threshold = 0,
    window: window2 = defaultWindow,
    immediate = true
  } = options;
  const isSupported = useSupported(() => window2 && "IntersectionObserver" in window2);
  const targets = computed(() => {
    const _target = toValue(target);
    return toArray$1(_target).map(unrefElement).filter(notNullish);
  });
  let cleanup = noop$1;
  const isActive = shallowRef(immediate);
  const stopWatch = isSupported.value ? watch(
    () => [targets.value, unrefElement(root2), isActive.value],
    ([targets2, root22]) => {
      cleanup();
      if (!isActive.value)
        return;
      if (!targets2.length)
        return;
      const observer = new IntersectionObserver(
        callback,
        {
          root: unrefElement(root22),
          rootMargin,
          threshold
        }
      );
      targets2.forEach((el) => el && observer.observe(el));
      cleanup = () => {
        observer.disconnect();
        cleanup = noop$1;
      };
    },
    { immediate, flush: "post" }
  ) : noop$1;
  const stop = () => {
    cleanup();
    stopWatch();
    isActive.value = false;
  };
  tryOnScopeDispose(stop);
  return {
    isSupported,
    isActive,
    pause() {
      cleanup();
      isActive.value = false;
    },
    resume() {
      isActive.value = true;
    },
    stop
  };
}
function useVirtualList(list, options) {
  const { containerStyle, wrapperProps, scrollTo, calculateRange, currentList, containerRef } = "itemHeight" in options ? useVerticalVirtualList(options, list) : useHorizontalVirtualList(options, list);
  return {
    list: currentList,
    scrollTo,
    containerProps: {
      ref: containerRef,
      onScroll: () => {
        calculateRange();
      },
      style: containerStyle
    },
    wrapperProps
  };
}
function useVirtualListResources(list) {
  const containerRef = shallowRef(null);
  const size2 = useElementSize(containerRef);
  const currentList = ref([]);
  const source = shallowRef(list);
  const state2 = ref({ start: 0, end: 10 });
  return { state: state2, source, currentList, size: size2, containerRef };
}
function createGetViewCapacity(state2, source, itemSize) {
  return (containerSize) => {
    if (typeof itemSize === "number")
      return Math.ceil(containerSize / itemSize);
    const { start = 0 } = state2.value;
    let sum = 0;
    let capacity = 0;
    for (let i2 = start; i2 < source.value.length; i2++) {
      const size2 = itemSize(i2);
      sum += size2;
      capacity = i2;
      if (sum > containerSize)
        break;
    }
    return capacity - start;
  };
}
function createGetOffset(source, itemSize) {
  return (scrollDirection) => {
    if (typeof itemSize === "number")
      return Math.floor(scrollDirection / itemSize) + 1;
    let sum = 0;
    let offset2 = 0;
    for (let i2 = 0; i2 < source.value.length; i2++) {
      const size2 = itemSize(i2);
      sum += size2;
      if (sum >= scrollDirection) {
        offset2 = i2;
        break;
      }
    }
    return offset2 + 1;
  };
}
function createCalculateRange(type3, overscan, getOffset, getViewCapacity, { containerRef, state: state2, currentList, source }) {
  return () => {
    const element = containerRef.value;
    if (element) {
      const offset2 = getOffset(type3 === "vertical" ? element.scrollTop : element.scrollLeft);
      const viewCapacity = getViewCapacity(type3 === "vertical" ? element.clientHeight : element.clientWidth);
      const from = offset2 - overscan;
      const to = offset2 + viewCapacity + overscan;
      state2.value = {
        start: from < 0 ? 0 : from,
        end: to > source.value.length ? source.value.length : to
      };
      currentList.value = source.value.slice(state2.value.start, state2.value.end).map((ele, index2) => ({
        data: ele,
        index: index2 + state2.value.start
      }));
    }
  };
}
function createGetDistance(itemSize, source) {
  return (index2) => {
    if (typeof itemSize === "number") {
      const size22 = index2 * itemSize;
      return size22;
    }
    const size2 = source.value.slice(0, index2).reduce((sum, _2, i2) => sum + itemSize(i2), 0);
    return size2;
  };
}
function useWatchForSizes(size2, list, containerRef, calculateRange) {
  watch([size2.width, size2.height, list, containerRef], () => {
    calculateRange();
  });
}
function createComputedTotalSize(itemSize, source) {
  return computed(() => {
    if (typeof itemSize === "number")
      return source.value.length * itemSize;
    return source.value.reduce((sum, _2, index2) => sum + itemSize(index2), 0);
  });
}
const scrollToDictionaryForElementScrollKey = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function createScrollTo(type3, calculateRange, getDistance, containerRef) {
  return (index2) => {
    if (containerRef.value) {
      containerRef.value[scrollToDictionaryForElementScrollKey[type3]] = getDistance(index2);
      calculateRange();
    }
  };
}
function useHorizontalVirtualList(options, list) {
  const resources = useVirtualListResources(list);
  const { state: state2, source, currentList, size: size2, containerRef } = resources;
  const containerStyle = { overflowX: "auto" };
  const { itemWidth, overscan = 5 } = options;
  const getViewCapacity = createGetViewCapacity(state2, source, itemWidth);
  const getOffset = createGetOffset(source, itemWidth);
  const calculateRange = createCalculateRange("horizontal", overscan, getOffset, getViewCapacity, resources);
  const getDistanceLeft = createGetDistance(itemWidth, source);
  const offsetLeft = computed(() => getDistanceLeft(state2.value.start));
  const totalWidth = createComputedTotalSize(itemWidth, source);
  useWatchForSizes(size2, list, containerRef, calculateRange);
  const scrollTo = createScrollTo("horizontal", calculateRange, getDistanceLeft, containerRef);
  const wrapperProps = computed(() => {
    return {
      style: {
        height: "100%",
        width: `${totalWidth.value - offsetLeft.value}px`,
        marginLeft: `${offsetLeft.value}px`,
        display: "flex"
      }
    };
  });
  return {
    scrollTo,
    calculateRange,
    wrapperProps,
    containerStyle,
    currentList,
    containerRef
  };
}
function useVerticalVirtualList(options, list) {
  const resources = useVirtualListResources(list);
  const { state: state2, source, currentList, size: size2, containerRef } = resources;
  const containerStyle = { overflowY: "auto" };
  const { itemHeight, overscan = 5 } = options;
  const getViewCapacity = createGetViewCapacity(state2, source, itemHeight);
  const getOffset = createGetOffset(source, itemHeight);
  const calculateRange = createCalculateRange("vertical", overscan, getOffset, getViewCapacity, resources);
  const getDistanceTop = createGetDistance(itemHeight, source);
  const offsetTop = computed(() => getDistanceTop(state2.value.start));
  const totalHeight = createComputedTotalSize(itemHeight, source);
  useWatchForSizes(size2, list, containerRef, calculateRange);
  const scrollTo = createScrollTo("vertical", calculateRange, getDistanceTop, containerRef);
  const wrapperProps = computed(() => {
    return {
      style: {
        width: "100%",
        height: `${totalHeight.value - offsetTop.value}px`,
        marginTop: `${offsetTop.value}px`
      }
    };
  });
  return {
    calculateRange,
    scrollTo,
    containerStyle,
    wrapperProps,
    currentList,
    containerRef
  };
}
function useTableVirtualization(options) {
  const lastItemEl = ref(null);
  const { list, containerProps, wrapperProps, scrollTo } = useVirtualList(
    options.data,
    {
      itemHeight: options.itemHeight,
      overscan: 10
    }
  );
  async function registerLastItemObserver() {
    await until(() => lastItemEl.value).toBeTruthy();
    useIntersectionObserver(lastItemEl, ([entry]) => {
      var _a;
      let dataLength = 0;
      if (isRef(options.data) && options.data.value) {
        dataLength = Array.isArray(options.data.value) ? options.data.value.length : 0;
      } else if (Array.isArray(options.data)) {
        dataLength = options.data.length;
      }
      if (entry.isIntersecting && dataLength > 0) {
        (_a = options.onLastItemVisible) == null ? void 0 : _a.call(options);
      }
    });
  }
  return {
    list,
    containerProps,
    wrapperProps,
    scrollTo,
    lastItemEl,
    registerLastItemObserver
  };
}
const _hoisted_1$O = {
  key: 0,
  class: "loading-table-wrapper z-99 h-100 w-100 absolute inset"
};
const _hoisted_2$A = {
  key: 1,
  class: "flex-center h-300px txt-red"
};
const _hoisted_3$v = { class: "infinite-wrapper" };
const _hoisted_4$k = { class: "row first-row" };
const _hoisted_5$j = { key: 0 };
const _hoisted_6$g = ["onClick"];
const _hoisted_7$c = { class: "flex" };
const _hoisted_8$7 = ["onClick"];
const _hoisted_9$6 = { key: 0 };
const _hoisted_10$6 = ["value"];
const _hoisted_11$6 = { key: 1 };
const _sfc_main$Y = /* @__PURE__ */ defineComponent({
  __name: "DataTable",
  props: /* @__PURE__ */ mergeModels({
    data: {},
    schema: { type: Function },
    columns: {},
    useServerSort: { type: Boolean },
    selectable: { type: Boolean },
    onLastItemVisible: { type: Function }
  }, {
    "loading": { default: false },
    "loadingModifiers": {},
    "itemHeight": { default: 50 },
    "itemHeightModifiers": {},
    "selectedItems": { default: [] },
    "selectedItemsModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["orderBy", "select", "lastItemVisible"], ["update:loading", "update:itemHeight", "update:selectedItems"]),
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "104156b0": unref(computedItemHeight)
    }));
    const props2 = __props;
    const emit2 = __emit;
    const slots = useSlots();
    const loading = useModel(__props, "loading");
    const itemHeight = useModel(__props, "itemHeight");
    const selectedItems = useModel(__props, "selectedItems");
    const data2 = computed(() => props2.data);
    const schema = computed(() => props2.schema);
    const columns = computed(() => props2.columns);
    const useServerSort = computed(() => props2.useServerSort);
    const {
      computedSchema,
      computedData,
      sortField,
      sortDirection,
      toggleSort,
      cleanTransformedData,
      schemaState
    } = useTableData({
      data: data2,
      schema,
      columns,
      useServerSort,
      onSort: (field, direction) => {
        emit2("orderBy", `${field.trim()} ${direction.trim()}`);
      }
    });
    const {
      computedSelectedItems,
      isSelectable,
      allSelectorEl,
      updateAllSelectorState,
      toggleSelectItem,
      toggleSelectAll
    } = useTableSelection({
      selectable: props2.selectable,
      selectedItems,
      cleanData: cleanTransformedData,
      onSelect: (item) => {
        emit2("select", item);
      }
    });
    const {
      list,
      containerProps,
      wrapperProps,
      scrollTo,
      lastItemEl,
      registerLastItemObserver
    } = useTableVirtualization({
      data: computedData,
      itemHeight: itemHeight.value,
      onLastItemVisible: () => {
        var _a;
        emit2("lastItemVisible");
        (_a = props2.onLastItemVisible) == null ? void 0 : _a.call(props2);
      }
    });
    function renderFieldForRow(field, row) {
      const { renderField } = useSchemaField({
        mode: "table",
        getRowData: () => {
          if (field.id) {
            return { [field.id]: getNestedValue(row, field.id) };
          }
          return row;
        }
      });
      return renderField({ ...field, label: "" }, slots);
    }
    const computedItemHeight = computed(() => `${itemHeight.value}px`);
    watch(
      () => loading.value,
      (newLoadingVal, oldLoadingVal) => {
        if (newLoadingVal === oldLoadingVal) return;
        if (!newLoadingVal) registerLastItemObserver();
      },
      { immediate: true }
    );
    watch(
      computedSelectedItems,
      () => {
        updateAllSelectorState();
      }
    );
    watch(
      computedData,
      (newData, oldData) => {
        if (newData.length === oldData.length || props2.onLastItemVisible !== void 0) return;
        scrollTo(0);
      }
    );
    const showLoading = computed(() => loading.value || schemaState.value === "loading");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({ class: "table-list-wrap h-100" }, unref(containerProps), {
        class: { "loading-table": showLoading.value }
      }), [
        showLoading.value ? (openBlock(), createElementBlock("div", _hoisted_1$O, _cache[4] || (_cache[4] = [
          createElementVNode("div", { class: "loading-table-animation fixed oval top-7" }, null, -1)
        ]))) : unref(schemaState) === "error" ? (openBlock(), createElementBlock("div", _hoisted_2$A, " Error loading table schema ")) : createCommentVNode("", true),
        createElementVNode("div", mergeProps(unref(wrapperProps), {
          class: { "pointer-events-none": showLoading.value }
        }), [
          createElementVNode("table", _hoisted_3$v, [
            createElementVNode("thead", _hoisted_4$k, [
              unref(isSelectable) ? (openBlock(), createElementBlock("th", _hoisted_5$j, [
                createElementVNode("input", {
                  ref_key: "allSelectorEl",
                  ref: allSelectorEl,
                  type: "checkbox",
                  onClick: _cache[0] || (_cache[0] = withModifiers(() => {
                  }, ["stop"])),
                  onChange: _cache[1] || (_cache[1] = //@ts-ignore
                  (...args) => unref(toggleSelectAll) && unref(toggleSelectAll)(...args))
                }, null, 544)
              ])) : createCommentVNode("", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(computedSchema), (field) => {
                return openBlock(), createElementBlock("th", {
                  key: field.id,
                  class: "col",
                  onClick: ($event) => unref(toggleSort)((field == null ? void 0 : field.id) || "")
                }, [
                  createElementVNode("div", _hoisted_7$c, [
                    createTextVNode(toDisplayString(field.label || unref(keyToLabel)(field == null ? void 0 : field.id)) + " ", 1),
                    createElementVNode("div", {
                      class: normalizeClass(["list-arrows", { sorted: unref(sortField) === (field == null ? void 0 : field.id) }])
                    }, [
                      createVNode(unref(_sfc_main$s), {
                        class: normalizeClass({ desc: unref(sortDirection) === "DESC" }),
                        icon: "keyboard_arrow_up"
                      }, null, 8, ["class"])
                    ], 2)
                  ])
                ], 8, _hoisted_6$g);
              }), 128))
            ]),
            createElementVNode("tbody", null, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(list), ({ data: row }) => {
                return openBlock(), createElementBlock("tr", {
                  key: (row == null ? void 0 : row.id) || `row-${Math.random()}`,
                  class: normalizeClass(["row row-item position-relative", { selected: (row == null ? void 0 : row.id) && unref(computedSelectedItems).includes(row.id) }]),
                  onClick: ($event) => unref(toggleSelectItem)(row)
                }, [
                  unref(isSelectable) ? (openBlock(), createElementBlock("td", _hoisted_9$6, [
                    createElementVNode("div", {
                      onClick: _cache[3] || (_cache[3] = withModifiers(() => {
                      }, ["stop"]))
                    }, [
                      withDirectives(createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => selectedItems.value = $event),
                        type: "checkbox",
                        value: (row == null ? void 0 : row.id) || ""
                      }, null, 8, _hoisted_10$6), [
                        [vModelCheckbox, selectedItems.value]
                      ])
                    ])
                  ])) : createCommentVNode("", true),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(computedSchema), (field) => {
                    return openBlock(), createElementBlock("td", {
                      key: `${field.id}-${(row == null ? void 0 : row.id) || Math.random()}`,
                      class: "col"
                    }, [
                      field.id && unref(slots)[field.id] ? renderSlot(_ctx.$slots, field.id, {
                        key: 0,
                        row,
                        field
                      }, void 0, true) : (openBlock(), createElementBlock("div", _hoisted_11$6, [
                        (openBlock(), createBlock(resolveDynamicComponent(renderFieldForRow(field, row))))
                      ]))
                    ]);
                  }), 128))
                ], 10, _hoisted_8$7);
              }), 128)),
              props2.onLastItemVisible !== void 0 ? (openBlock(), createElementBlock("tr", {
                key: 0,
                ref_key: "lastItemEl",
                ref: lastItemEl,
                style: { "height": "1px" }
              }, null, 512)) : createCommentVNode("", true)
            ])
          ])
        ], 16)
      ], 16);
    };
  }
});
const DataTable = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["__scopeId", "data-v-6cf42b66"]]);
function useDraggable(options = {}) {
  const isDragging = ref(false);
  const dragElement = ref(null);
  const ghostElement = ref(null);
  const dropIndicator = ref(null);
  const dropTarget = ref(null);
  const isBrowser = typeof window !== "undefined";
  if (isBrowser) {
    const existingStyle = document.getElementById("draggable-style");
    if (!existingStyle) {
      const style = document.createElement("style");
      style.id = "draggable-style";
      style.textContent = `
				.draggable-ghost {
					opacity: 0.5;
					box-shadow: 0 2px 10px rgba(0,0,0,0.1);
					transition: transform 0.1s;
				}
			`;
      document.head.appendChild(style);
    }
  }
  const defaultOptions = {
    animation: 150,
    mode: "line",
    ghostClass: "draggable-ghost",
    dragClass: "draggable-dragging",
    dropIndicatorClass: "draggable-drop-indicator",
    ...options
  };
  let startX = 0;
  let startY = 0;
  let initialX = 0;
  let initialY = 0;
  let shiftAmount = 0;
  let cleanupFn;
  let scrollRAF = null;
  let lastDropIndex = -1;
  let lastUpdateTime = 0;
  const UPDATE_THRESHOLD = 150;
  const POSITION_CACHE = /* @__PURE__ */ new Map();
  function createGhost(el) {
    if (!isBrowser) return null;
    const ghost = el.cloneNode(true);
    const rect = el.getBoundingClientRect();
    ghost.style.position = "fixed";
    ghost.style.margin = "0";
    ghost.style.top = `${rect.top}px`;
    ghost.style.left = `${rect.left}px`;
    ghost.style.width = `${rect.width}px`;
    ghost.style.height = `${rect.height}px`;
    ghost.style.transform = "translate3d(0, 0, 0)";
    ghost.style.pointerEvents = "none";
    ghost.style.zIndex = "9999";
    ghost.style.cursor = "grabbing";
    ghost.style.willChange = "transform";
    ghost.classList.add(defaultOptions.ghostClass);
    document.body.appendChild(ghost);
    return ghost;
  }
  function createDropIndicator(el) {
    if (!isBrowser) return null;
    const line2 = document.createElement("div");
    line2.classList.add(defaultOptions.dropIndicatorClass);
    line2.style.position = "fixed";
    line2.style.pointerEvents = "none";
    line2.style.zIndex = "9999";
    line2.style.height = "2px";
    line2.style.background = "var(--primary-color, #0066ff)";
    line2.style.boxShadow = "0 0 4px rgba(0, 102, 255, 0.5)";
    line2.style.transition = "all 0.15s ease";
    line2.style.display = "none";
    const dot = document.createElement("div");
    dot.style.position = "absolute";
    dot.style.left = "-4px";
    dot.style.top = "-3px";
    dot.style.width = "8px";
    dot.style.height = "8px";
    dot.style.borderRadius = "50%";
    dot.style.background = "var(--primary-color, #0066ff)";
    line2.appendChild(dot);
    document.body.appendChild(line2);
    return line2;
  }
  function updateDropIndicator(target, isAfter) {
    if (!dropIndicator.value) return;
    const rect = target.getBoundingClientRect();
    dropIndicator.value.style.display = "block";
    dropIndicator.value.style.width = `${rect.width}px`;
    dropIndicator.value.style.left = `${rect.left}px`;
    if (isAfter) {
      dropIndicator.value.style.top = `${rect.bottom}px`;
    } else {
      dropIndicator.value.style.top = `${rect.top}px`;
    }
  }
  function findDraggableParent(element) {
    let current = element;
    while (current && (!("__drag_group" in current) || current.dataset.draggable === "false")) {
      current = current.parentElement;
    }
    return current;
  }
  function handleGhostMode(dragEl2) {
    dragEl2.style.opacity = "0.4";
    dragEl2.style.transform = "scale(0.95)";
    return dragEl2.offsetHeight;
  }
  function handleLineMode(dragEl2) {
    dragEl2.style.opacity = "0.5";
    return 2;
  }
  function cacheElementPositions(draggedList) {
    POSITION_CACHE.clear();
    draggedList.forEach((el, index2) => {
      const rect = el.getBoundingClientRect();
      POSITION_CACHE.set(index2, {
        top: rect.top,
        bottom: rect.bottom
      });
    });
  }
  function calculateDropIndex(e, draggedList, dragIndex, newDropTarget) {
    const now = Date.now();
    if (now - lastUpdateTime < UPDATE_THRESHOLD) {
      return lastDropIndex !== -1 ? lastDropIndex : dragIndex;
    }
    if (POSITION_CACHE.size === 0) {
      cacheElementPositions(draggedList);
    }
    const mouseY = e.clientY;
    const targetIndex = draggedList.indexOf(newDropTarget);
    const targetPos = POSITION_CACHE.get(targetIndex);
    if (!targetPos) return dragIndex;
    const elementHeight = targetPos.bottom - targetPos.top;
    const relativeY = mouseY - targetPos.top;
    const upperSticky = elementHeight * 0.3;
    const lowerSticky = elementHeight * 0.7;
    let dropIndex = targetIndex;
    if (targetIndex === dragIndex) {
      if (relativeY > lowerSticky) dropIndex += 1;
    } else if (targetIndex === lastDropIndex) {
      if (targetIndex > dragIndex) {
        if (relativeY < upperSticky) dropIndex = targetIndex;
        else dropIndex = targetIndex + 1;
      } else {
        if (relativeY > lowerSticky) dropIndex = targetIndex + 1;
        else dropIndex = targetIndex;
      }
    } else {
      if (relativeY > elementHeight * 0.6) dropIndex += 1;
    }
    lastDropIndex = dropIndex;
    lastUpdateTime = now;
    return dropIndex;
  }
  function cleanup() {
    if (!isBrowser) return;
    document.removeEventListener("mousemove", onDragMove);
    document.removeEventListener("mouseup", onDragEnd);
    document.removeEventListener("keydown", onKeyDown);
    document.removeEventListener("touchmove", onTouchMove);
    document.removeEventListener("touchend", onTouchEnd);
    document.removeEventListener("touchcancel", onTouchEnd);
    window.removeEventListener("blur", cleanup);
    if (ghostElement.value) {
      ghostElement.value.style.opacity = "0";
      ghostElement.value.style.transform += " scale(0.8)";
      setTimeout(() => {
        var _a, _b;
        (_b = (_a = ghostElement.value) == null ? void 0 : _a.parentNode) == null ? void 0 : _b.removeChild(ghostElement.value);
        ghostElement.value = null;
      }, 150);
    }
    if (dropIndicator.value) {
      dropIndicator.value.style.opacity = "0";
      setTimeout(() => {
        var _a, _b;
        (_b = (_a = dropIndicator.value) == null ? void 0 : _a.parentNode) == null ? void 0 : _b.removeChild(dropIndicator.value);
        dropIndicator.value = null;
      }, 150);
    }
    if (dragElement.value) {
      const list = dragElement.value.__drag_list;
      list == null ? void 0 : list.forEach((el) => {
        el.style.transition = "";
        el.style.transform = "";
        el.style.opacity = "";
      });
      dragElement.value.classList.remove(defaultOptions.dragClass);
      dragElement.value = null;
    }
    isDragging.value = false;
    dropTarget.value = null;
    if (isBrowser) {
      document.body.style.userSelect = "";
      document.body.style.webkitUserSelect = "";
      document.body.style.cursor = "";
    }
    if (scrollRAF) {
      cancelAnimationFrame(scrollRAF);
      scrollRAF = null;
    }
    lastDropIndex = -1;
    lastUpdateTime = 0;
    POSITION_CACHE.clear();
  }
  function onKeyDown(e) {
    if (e.key === "Escape" && isDragging.value) {
      cleanup();
    }
  }
  function onDragStart(e) {
    var _a;
    if (!isBrowser || defaultOptions.disabled) return;
    if (e.button !== 0) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    const dragEl2 = findDraggableParent(e.target);
    if (!dragEl2 || dragEl2.dataset.draggable === "false") return;
    if (defaultOptions.handle) {
      const handleEl = e.target.closest(defaultOptions.handle);
      if (!handleEl || !dragEl2.contains(handleEl)) return;
    }
    e.preventDefault();
    isDragging.value = true;
    dragElement.value = dragEl2;
    startX = e.clientX;
    startY = e.clientY;
    const rect = dragEl2.getBoundingClientRect();
    initialX = rect.left;
    initialY = rect.top;
    ghostElement.value = createGhost(dragEl2);
    if (ghostElement.value) {
      ghostElement.value.style.left = `${initialX}px`;
      ghostElement.value.style.top = `${initialY}px`;
    }
    if (defaultOptions.mode === "line") {
      dropIndicator.value = createDropIndicator();
    }
    dragEl2.classList.add(defaultOptions.dragClass);
    shiftAmount = defaultOptions.mode === "ghost" ? handleGhostMode(dragEl2) : handleLineMode(dragEl2);
    (_a = defaultOptions.onStart) == null ? void 0 : _a.call(defaultOptions, e);
    if (isBrowser) {
      document.body.style.userSelect = "none";
      document.body.style.webkitUserSelect = "none";
      document.body.style.cursor = "grabbing";
      window.addEventListener("blur", cleanup);
      document.addEventListener("mousemove", onDragMove);
      document.addEventListener("mouseup", onDragEnd);
      document.addEventListener("keydown", onKeyDown);
    }
  }
  function findScrollParent(element) {
    let parent = element.parentElement;
    while (parent) {
      const { overflow, overflowY } = window.getComputedStyle(parent);
      if (/auto|scroll/.test(overflow + overflowY)) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return document.scrollingElement || document.documentElement || document.body;
  }
  function autoScroll2(e) {
    if (!dragElement.value) return;
    if (scrollRAF) cancelAnimationFrame(scrollRAF);
    scrollRAF = requestAnimationFrame(() => {
      const scrollParent = findScrollParent(dragElement.value);
      const rect = scrollParent.getBoundingClientRect();
      const margin = 50;
      const speed = Math.min(20, rect.height * 0.1);
      const { scrollTop } = scrollParent;
      const maxScroll = scrollParent.scrollHeight - scrollParent.clientHeight;
      if (e.clientY - rect.top < margin) {
        const newScroll = Math.max(0, scrollTop - speed);
        scrollParent.scrollTop = newScroll;
      } else if (rect.bottom - e.clientY < margin) {
        const newScroll = Math.min(maxScroll, scrollTop + speed);
        scrollParent.scrollTop = newScroll;
      }
    });
  }
  function onDragMove(e) {
    if (!isDragging.value || !dragElement.value) return;
    if (ghostElement.value) {
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      ghostElement.value.style.transform = `translate3d(${dx}px, ${dy}px, 0)`;
    }
    const list = dragElement.value.__drag_list;
    const draggedList = list.filter((el) => el.dataset.draggable !== "false");
    const dragIndex = draggedList.indexOf(dragElement.value);
    const elementAtPoint = document.elementFromPoint(e.clientX, e.clientY);
    const newDropTarget = findDraggableParent(elementAtPoint);
    if (!newDropTarget || newDropTarget.__drag_group !== dragElement.value.__drag_group) {
      if (dropIndicator.value) {
        dropIndicator.value.style.display = "none";
      }
      return;
    }
    const dropIndex = calculateDropIndex(e, draggedList, dragIndex, newDropTarget);
    if (dropTarget.value !== newDropTarget || dropTarget.value.__intended_index !== dropIndex) {
      dropTarget.value = newDropTarget;
      dropTarget.value.__intended_index = dropIndex;
      if (dropIndicator.value && defaultOptions.mode === "line") {
        const isAfter = dropIndex > dragIndex;
        updateDropIndicator(newDropTarget, isAfter);
      }
      const shift2 = shiftAmount;
      draggedList.forEach((el) => {
        el.style.transition = `transform ${defaultOptions.animation}ms cubic-bezier(0.2, 0, 0, 1)`;
        el.style.transform = "translate3d(0, 0, 0)";
        if (el === dragElement.value) {
          if (defaultOptions.mode === "ghost") {
            const offset2 = (dropIndex - dragIndex) * shift2;
            el.style.transform = `translate3d(0, ${offset2}px, 0)`;
          }
        } else {
          const currentIndex = draggedList.indexOf(el);
          if (dragIndex < dropIndex) {
            if (currentIndex > dragIndex && currentIndex <= dropIndex) {
              el.style.transform = `translate3d(0, -${shift2}px, 0)`;
            }
          } else if (dragIndex > dropIndex) {
            if (currentIndex >= dropIndex && currentIndex < dragIndex) {
              el.style.transform = `translate3d(0, ${shift2}px, 0)`;
            }
          }
        }
      });
    }
    autoScroll2(e);
  }
  function onDragEnd(e) {
    var _a;
    if (!isDragging.value || !dragElement.value || !dropTarget.value) {
      cleanup();
      return;
    }
    const list = dragElement.value.__drag_list;
    if (!list || !list.length) {
      cleanup();
      return;
    }
    const draggedList = list.filter((el) => el.dataset.draggable !== "false");
    const actualDragIndex = draggedList.indexOf(dragElement.value);
    const actualDropIndex = dropTarget.value.__intended_index;
    if (actualDragIndex !== -1 && actualDropIndex !== -1) {
      list.forEach((el) => {
        el.style.transition = "none";
        el.style.transform = "";
      });
      void document.body.offsetHeight;
      const dragEvent = new MouseEvent("mouseup", e);
      dragEvent.oldIndex = actualDragIndex;
      dragEvent.newIndex = actualDropIndex;
      dragEvent.item = dragElement.value.__drag_data;
      (_a = defaultOptions.onEnd) == null ? void 0 : _a.call(defaultOptions, dragEvent);
    }
    cleanup();
  }
  function onTouchStart(e) {
    var _a;
    if (!isBrowser || defaultOptions.disabled || !e.target) return;
    const touch = e.touches[0];
    if (!touch) return;
    const target = e.target;
    const draggableParent = findDraggableParent(target);
    if (!draggableParent) return;
    const { handle } = defaultOptions;
    if (handle && !target.closest(handle)) return;
    e.preventDefault();
    isDragging.value = true;
    dragElement.value = draggableParent;
    startX = touch.clientX;
    startY = touch.clientY;
    const rect = draggableParent.getBoundingClientRect();
    initialX = rect.left;
    initialY = rect.top;
    ghostElement.value = createGhost(draggableParent);
    if (ghostElement.value) {
      ghostElement.value.style.left = `${initialX}px`;
      ghostElement.value.style.top = `${initialY}px`;
    }
    if (defaultOptions.mode === "line") {
      dropIndicator.value = createDropIndicator();
    }
    dragElement.value.classList.add(defaultOptions.dragClass);
    shiftAmount = defaultOptions.mode === "ghost" ? handleGhostMode(dragElement.value) : handleLineMode(dragElement.value);
    (_a = defaultOptions.onStart) == null ? void 0 : _a.call(defaultOptions, e);
    if (isBrowser) {
      document.body.style.userSelect = "none";
      document.body.style.webkitUserSelect = "none";
      document.body.style.cursor = "grabbing";
      window.addEventListener("blur", cleanup);
      document.addEventListener("touchmove", onTouchMove, { passive: false });
      document.addEventListener("touchend", onTouchEnd);
      document.addEventListener("touchcancel", onTouchEnd);
    }
  }
  function onTouchMove(e) {
    e.preventDefault();
    const touch = e.touches[0];
    if (!touch) return;
    const mouseEvent = {
      clientX: touch.clientX,
      clientY: touch.clientY,
      target: document.elementFromPoint(touch.clientX, touch.clientY)
    };
    onDragMove(mouseEvent);
    autoScroll2(mouseEvent);
  }
  function onTouchEnd(e) {
    const touch = e.changedTouches[0];
    if (!touch) return;
    const mouseEvent = {
      clientX: touch.clientX,
      clientY: touch.clientY,
      target: document.elementFromPoint(touch.clientX, touch.clientY)
    };
    onDragEnd(mouseEvent);
    document.removeEventListener("touchmove", onTouchMove);
    document.removeEventListener("touchend", onTouchEnd);
    document.removeEventListener("touchcancel", onTouchEnd);
  }
  function initDraggableContainer(container) {
    if (!isBrowser) return;
    cleanupFn == null ? void 0 : cleanupFn();
    isDragging.value = false;
    dragElement.value = null;
    ghostElement.value = null;
    dropIndicator.value = null;
    dropTarget.value = null;
    const elements = Array.from(container.children);
    elements.forEach((el) => {
      delete el.__drag_group;
      delete el.__drag_index;
      delete el.__drag_list;
    });
    let currentIndex = 0;
    elements.forEach((el, index2) => {
      if (el.dataset.draggable !== "false") {
        el.style.userSelect = "none";
        el.style.webkitUserSelect = "none";
        el.__drag_group = options.group;
        el.__drag_index = currentIndex++;
        el.__drag_list = elements.filter((e) => e.dataset.draggable !== "false");
        if (options.items) {
          el.__drag_data = options.items[index2];
        }
        el.addEventListener("mousedown", onDragStart);
        el.addEventListener("touchstart", onTouchStart);
      }
    });
    cleanupFn = () => {
      elements.forEach((el) => {
        el.removeEventListener("mousedown", onDragStart);
        el.removeEventListener("touchstart", onTouchStart);
        delete el.__drag_group;
        delete el.__drag_index;
        delete el.__drag_list;
      });
      cleanup();
    };
  }
  onUnmounted(() => {
    cleanupFn == null ? void 0 : cleanupFn();
  });
  return {
    isDragging,
    dragElement,
    initDraggableContainer
  };
}
const _sfc_main$X = /* @__PURE__ */ defineComponent({
  __name: "Draggable",
  props: {
    modelValue: {},
    group: {},
    handle: {},
    mode: { default: "line" },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "start", "end"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const dragContainer = ref();
    const { initDraggableContainer } = useDraggable({
      group: props2.group,
      handle: props2.handle,
      mode: props2.mode,
      disabled: props2.disabled,
      items: props2.modelValue,
      onStart: (event) => {
        emit2("start", event);
      },
      onEnd: (event) => {
        const newList = [...props2.modelValue];
        const [removed] = newList.splice(event.oldIndex, 1);
        newList.splice(event.newIndex, 0, removed);
        emit2("update:modelValue", newList);
        emit2("end", event);
        nextTick(() => {
          if (dragContainer.value) {
            initDraggableContainer(dragContainer.value);
          }
        });
      }
    });
    watch(() => props2.modelValue, () => {
      if (dragContainer.value) {
        initDraggableContainer(dragContainer.value);
      }
    }, { deep: true });
    onMounted(() => {
      if (dragContainer.value) {
        initDraggableContainer(dragContainer.value);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "dragContainer",
        ref: dragContainer
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelValue, (item, index2) => {
          return renderSlot(_ctx.$slots, "default", {
            key: index2,
            item,
            index: index2
          });
        }), 128))
      ], 512);
    };
  }
});
const vDraggable = {
  mounted(el, binding) {
    const { initDraggableContainer } = useDraggable(binding.value || {});
    initDraggableContainer(el);
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      const { initDraggableContainer } = useDraggable(binding.value || {});
      initDraggableContainer(el);
    }
  }
};
const sides = ["top", "right", "bottom", "left"];
const alignments = ["start", "end"];
const placements = /* @__PURE__ */ sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis2) {
  return axis2 === "x" ? "y" : "x";
}
function getAxisLength(axis2) {
  return axis2 === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt2 = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt2;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y: y2,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y2,
    left: x2,
    right: x2 + width,
    bottom: y2 + height,
    x: x2,
    y: y2
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i2 = 0; i2 < validMiddleware.length; i2++) {
    const {
      name,
      fn
    } = validMiddleware[i2];
    const {
      x: nextX,
      y: nextY,
      data: data2,
      reset
    } = await fn({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data2
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i2 = -1;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state2, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state2;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state2);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x2,
    y: y2,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const arrow = (options) => ({
  name: "arrow",
  options,
  async fn(state2) {
    const {
      x: x2,
      y: y2,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state2;
    const {
      element,
      padding = 0
    } = evaluate(options, state2) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x: x2,
      y: y2
    };
    const axis2 = getAlignmentAxis(placement);
    const length = getAxisLength(axis2);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis2 === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis2] - coords[axis2] - rects.floating[length];
    const startDiff = coords[axis2] - rects.reference[axis2];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$12 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center2 = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = clamp(min$12, center2, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center2 !== offset2 && rects.reference[length] / 2 - (center2 < min$12 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center2 < min$12 ? center2 - min$12 : center2 - max2 : 0;
    return {
      [axis2]: coords[axis2] + alignmentOffset,
      data: {
        [axis2]: offset2,
        centerOffset: center2 - offset2 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter((placement) => getAlignment(placement) === alignment), ...allowedPlacements.filter((placement) => getAlignment(placement) !== alignment)] : allowedPlacements.filter((placement) => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter((placement) => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
const autoPlacement = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "autoPlacement",
    options,
    async fn(state2) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform: platform2,
        elements
      } = state2;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state2);
      const placements$1 = alignment !== void 0 || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)));
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [], {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map((d2) => {
        const alignment2 = getAlignment(d2.placement);
        return [d2.placement, alignment2 && crossAxis ? (
          // Check along the mainAxis and main crossAxis side.
          d2.overflows.slice(0, 2).reduce((acc, v2) => acc + v2, 0)
        ) : (
          // Check only the mainAxis.
          d2.overflows[0]
        ), d2.overflows];
      }).sort((a2, b2) => a2[1] - b2[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d2) => d2[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        getAlignment(d2[0]) ? 2 : 3
      ).every((v2) => v2 <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};
const flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state2) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state2;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state2);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a2, b2) => a2.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d2) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d2.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d2) => [d2.placement, d2.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
async function convertValueToCoords(state2, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state2;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state2);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state2) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y: y2,
        placement,
        middlewareData
      } = state2;
      const diffCoords = await convertValueToCoords(state2, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state2) {
      const {
        x: x2,
        y: y2,
        placement
      } = state2;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x3,
              y: y3
            } = _ref;
            return {
              x: x3,
              y: y3
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state2);
      const coords = {
        x: x2,
        y: y2
      };
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state2,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y2,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
const size = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state2) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state2;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state2);
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state2.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state2.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state2.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin2 = max(overflow.top, 0);
        const yMax2 = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin2 !== 0 || yMax2 !== 0 ? yMin2 + yMax2 : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state2,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
function n$1(t) {
  var e;
  return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function o(t) {
  return n$1(t).getComputedStyle(t);
}
const i = Math.min, r = Math.max, l = Math.round;
function c$1(t) {
  const e = o(t);
  let n2 = parseFloat(e.width), i2 = parseFloat(e.height);
  const r2 = t.offsetWidth, c2 = t.offsetHeight, s2 = l(n2) !== r2 || l(i2) !== c2;
  return s2 && (n2 = r2, i2 = c2), { width: n2, height: i2, fallback: s2 };
}
function s(t) {
  return h$1(t) ? (t.nodeName || "").toLowerCase() : "";
}
let f;
function u() {
  if (f) return f;
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? (f = t.brands.map((t4) => t4.brand + "/" + t4.version).join(" "), f) : navigator.userAgent;
}
function a(t) {
  return t instanceof n$1(t).HTMLElement;
}
function d$1(t) {
  return t instanceof n$1(t).Element;
}
function h$1(t) {
  return t instanceof n$1(t).Node;
}
function p(t) {
  if ("undefined" == typeof ShadowRoot) return false;
  return t instanceof n$1(t).ShadowRoot || t instanceof ShadowRoot;
}
function g$1(t) {
  const { overflow: e, overflowX: n2, overflowY: i2, display: r2 } = o(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + i2 + n2) && !["inline", "contents"].includes(r2);
}
function m$1(t) {
  return ["table", "td", "th"].includes(s(t));
}
function y$1(t) {
  const e = /firefox/i.test(u()), n2 = o(t), i2 = n2.backdropFilter || n2.WebkitBackdropFilter;
  return "none" !== n2.transform || "none" !== n2.perspective || !!i2 && "none" !== i2 || e && "filter" === n2.willChange || e && !!n2.filter && "none" !== n2.filter || ["transform", "perspective"].some((t4) => n2.willChange.includes(t4)) || ["paint", "layout", "strict", "content"].some((t4) => {
    const e3 = n2.contain;
    return null != e3 && e3.includes(t4);
  });
}
function x$1() {
  return !/^((?!chrome|android).)*safari/i.test(u());
}
function w(t) {
  return ["html", "body", "#document"].includes(s(t));
}
function v(t) {
  return d$1(t) ? t : t.contextElement;
}
const b$1 = { x: 1, y: 1 };
function L(t) {
  const e = v(t);
  if (!a(e)) return b$1;
  const n2 = e.getBoundingClientRect(), { width: o2, height: i2, fallback: r2 } = c$1(e);
  let s2 = (r2 ? l(n2.width) : n2.width) / o2, f2 = (r2 ? l(n2.height) : n2.height) / i2;
  return s2 && Number.isFinite(s2) || (s2 = 1), f2 && Number.isFinite(f2) || (f2 = 1), { x: s2, y: f2 };
}
function E$1(t, e, o2, i2) {
  var r2, l2;
  void 0 === e && (e = false), void 0 === o2 && (o2 = false);
  const c2 = t.getBoundingClientRect(), s2 = v(t);
  let f2 = b$1;
  e && (i2 ? d$1(i2) && (f2 = L(i2)) : f2 = L(t));
  const u2 = s2 ? n$1(s2) : window, a2 = !x$1() && o2;
  let h2 = (c2.left + (a2 && (null == (r2 = u2.visualViewport) ? void 0 : r2.offsetLeft) || 0)) / f2.x, p2 = (c2.top + (a2 && (null == (l2 = u2.visualViewport) ? void 0 : l2.offsetTop) || 0)) / f2.y, g2 = c2.width / f2.x, m2 = c2.height / f2.y;
  if (s2) {
    const t4 = n$1(s2), e3 = i2 && d$1(i2) ? n$1(i2) : i2;
    let o3 = t4.frameElement;
    for (; o3 && i2 && e3 !== t4; ) {
      const t5 = L(o3), e4 = o3.getBoundingClientRect(), i3 = getComputedStyle(o3);
      e4.x += (o3.clientLeft + parseFloat(i3.paddingLeft)) * t5.x, e4.y += (o3.clientTop + parseFloat(i3.paddingTop)) * t5.y, h2 *= t5.x, p2 *= t5.y, g2 *= t5.x, m2 *= t5.y, h2 += e4.x, p2 += e4.y, o3 = n$1(o3).frameElement;
    }
  }
  return { width: g2, height: m2, top: p2, right: h2 + g2, bottom: p2 + m2, left: h2, x: h2, y: p2 };
}
function R(t) {
  return ((h$1(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function T(t) {
  return d$1(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function C$1(t) {
  return E$1(R(t)).left + T(t).scrollLeft;
}
function F(t) {
  if ("html" === s(t)) return t;
  const e = t.assignedSlot || t.parentNode || p(t) && t.host || R(t);
  return p(e) ? e.host : e;
}
function W(t) {
  const e = F(t);
  return w(e) ? e.ownerDocument.body : a(e) && g$1(e) ? e : W(e);
}
function D(t, e) {
  var o2;
  void 0 === e && (e = []);
  const i2 = W(t), r2 = i2 === (null == (o2 = t.ownerDocument) ? void 0 : o2.body), l2 = n$1(i2);
  return r2 ? e.concat(l2, l2.visualViewport || [], g$1(i2) ? i2 : []) : e.concat(i2, D(i2));
}
function S$1(e, i2, l2) {
  return "viewport" === i2 ? rectToClientRect(function(t, e3) {
    const o2 = n$1(t), i3 = R(t), r2 = o2.visualViewport;
    let l3 = i3.clientWidth, c2 = i3.clientHeight, s2 = 0, f2 = 0;
    if (r2) {
      l3 = r2.width, c2 = r2.height;
      const t4 = x$1();
      (t4 || !t4 && "fixed" === e3) && (s2 = r2.offsetLeft, f2 = r2.offsetTop);
    }
    return { width: l3, height: c2, x: s2, y: f2 };
  }(e, l2)) : d$1(i2) ? rectToClientRect(function(t, e3) {
    const n2 = E$1(t, true, "fixed" === e3), o2 = n2.top + t.clientTop, i3 = n2.left + t.clientLeft, r2 = a(t) ? L(t) : { x: 1, y: 1 };
    return { width: t.clientWidth * r2.x, height: t.clientHeight * r2.y, x: i3 * r2.x, y: o2 * r2.y };
  }(i2, l2)) : rectToClientRect(function(t) {
    const e3 = R(t), n2 = T(t), i3 = t.ownerDocument.body, l3 = r(e3.scrollWidth, e3.clientWidth, i3.scrollWidth, i3.clientWidth), c2 = r(e3.scrollHeight, e3.clientHeight, i3.scrollHeight, i3.clientHeight);
    let s2 = -n2.scrollLeft + C$1(t);
    const f2 = -n2.scrollTop;
    return "rtl" === o(i3).direction && (s2 += r(e3.clientWidth, i3.clientWidth) - l3), { width: l3, height: c2, x: s2, y: f2 };
  }(R(e)));
}
function A(t) {
  return a(t) && "fixed" !== o(t).position ? t.offsetParent : null;
}
function H$1(t) {
  const e = n$1(t);
  let i2 = A(t);
  for (; i2 && m$1(i2) && "static" === o(i2).position; ) i2 = A(i2);
  return i2 && ("html" === s(i2) || "body" === s(i2) && "static" === o(i2).position && !y$1(i2)) ? e : i2 || function(t4) {
    let e3 = F(t4);
    for (; a(e3) && !w(e3); ) {
      if (y$1(e3)) return e3;
      e3 = F(e3);
    }
    return null;
  }(t) || e;
}
function O(t, e, n2) {
  const o2 = a(e), i2 = R(e), r2 = E$1(t, true, "fixed" === n2, e);
  let l2 = { scrollLeft: 0, scrollTop: 0 };
  const c2 = { x: 0, y: 0 };
  if (o2 || !o2 && "fixed" !== n2) if (("body" !== s(e) || g$1(i2)) && (l2 = T(e)), a(e)) {
    const t4 = E$1(e, true);
    c2.x = t4.x + e.clientLeft, c2.y = t4.y + e.clientTop;
  } else i2 && (c2.x = C$1(i2));
  return { x: r2.left + l2.scrollLeft - c2.x, y: r2.top + l2.scrollTop - c2.y, width: r2.width, height: r2.height };
}
const P = { getClippingRect: function(t) {
  let { element: e, boundary: n2, rootBoundary: l2, strategy: c2 } = t;
  const f2 = "clippingAncestors" === n2 ? function(t4, e3) {
    const n3 = e3.get(t4);
    if (n3) return n3;
    let i2 = D(t4).filter((t5) => d$1(t5) && "body" !== s(t5)), r2 = null;
    const l3 = "fixed" === o(t4).position;
    let c3 = l3 ? F(t4) : t4;
    for (; d$1(c3) && !w(c3); ) {
      const t5 = o(c3), e4 = y$1(c3);
      (l3 ? e4 || r2 : e4 || "static" !== t5.position || !r2 || !["absolute", "fixed"].includes(r2.position)) ? r2 = t5 : i2 = i2.filter((t6) => t6 !== c3), c3 = F(c3);
    }
    return e3.set(t4, i2), i2;
  }(e, this._c) : [].concat(n2), u2 = [...f2, l2], a2 = u2[0], h2 = u2.reduce((t4, n3) => {
    const o2 = S$1(e, n3, c2);
    return t4.top = r(o2.top, t4.top), t4.right = i(o2.right, t4.right), t4.bottom = i(o2.bottom, t4.bottom), t4.left = r(o2.left, t4.left), t4;
  }, S$1(e, a2, c2));
  return { width: h2.right - h2.left, height: h2.bottom - h2.top, x: h2.left, y: h2.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: e, offsetParent: n2, strategy: o2 } = t;
  const i2 = a(n2), r2 = R(n2);
  if (n2 === r2) return e;
  let l2 = { scrollLeft: 0, scrollTop: 0 }, c2 = { x: 1, y: 1 };
  const f2 = { x: 0, y: 0 };
  if ((i2 || !i2 && "fixed" !== o2) && (("body" !== s(n2) || g$1(r2)) && (l2 = T(n2)), a(n2))) {
    const t4 = E$1(n2);
    c2 = L(n2), f2.x = t4.x + n2.clientLeft, f2.y = t4.y + n2.clientTop;
  }
  return { width: e.width * c2.x, height: e.height * c2.y, x: e.x * c2.x - l2.scrollLeft * c2.x + f2.x, y: e.y * c2.y - l2.scrollTop * c2.y + f2.y };
}, isElement: d$1, getDimensions: function(t) {
  return a(t) ? c$1(t) : t.getBoundingClientRect();
}, getOffsetParent: H$1, getDocumentElement: R, getScale: L, async getElementRects(t) {
  let { reference: e, floating: n2, strategy: o2 } = t;
  const i2 = this.getOffsetParent || H$1, r2 = this.getDimensions;
  return { reference: O(e, await i2(n2), o2), floating: { x: 0, y: 0, ...await r2(n2) } };
}, getClientRects: (t) => Array.from(t.getClientRects()), isRTL: (t) => "rtl" === o(t).direction };
const B$1 = (t, n2, o2) => {
  const i2 = /* @__PURE__ */ new Map(), r2 = { platform: P, ...o2 }, l2 = { ...r2.platform, _c: i2 };
  return computePosition(t, n2, { ...r2, platform: l2 });
};
function ye(e, t) {
  for (const o2 in t)
    Object.prototype.hasOwnProperty.call(t, o2) && (typeof t[o2] == "object" && e[o2] ? ye(e[o2], t[o2]) : e[o2] = t[o2]);
}
const h = {
  // Disable popper components
  disabled: false,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: false,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 150,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: true,
  // Flip to the opposite placement if needed
  flip: true,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: true,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: true,
  /**
   * By default, compute autohide on 'click'.
   */
  autoHideOnMousedown: false,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (e) => [...e, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: false,
      // Enable HTML content in directive
      html: false,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: true,
      // Hide on clock outside
      autoHide: true
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function S(e, t) {
  let o2 = h.themes[e] || {}, i2;
  do
    i2 = o2[t], typeof i2 > "u" ? o2.$extend ? o2 = h.themes[o2.$extend] || {} : (o2 = null, i2 = h[t]) : o2 = null;
  while (o2);
  return i2;
}
function Ze(e) {
  const t = [e];
  let o2 = h.themes[e] || {};
  do
    o2.$extend && !o2.$resetCss ? (t.push(o2.$extend), o2 = h.themes[o2.$extend] || {}) : o2 = null;
  while (o2);
  return t.map((i2) => `v-popper--theme-${i2}`);
}
function re(e) {
  const t = [e];
  let o2 = h.themes[e] || {};
  do
    o2.$extend ? (t.push(o2.$extend), o2 = h.themes[o2.$extend] || {}) : o2 = null;
  while (o2);
  return t;
}
let $ = false;
if (typeof window < "u") {
  $ = false;
  try {
    const e = Object.defineProperty({}, "passive", {
      get() {
        $ = true;
      }
    });
    window.addEventListener("test", null, e);
  } catch {
  }
}
let _e = false;
typeof window < "u" && typeof navigator < "u" && (_e = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const Te = ["auto", "top", "bottom", "left", "right"].reduce((e, t) => e.concat([
  t,
  `${t}-start`,
  `${t}-end`
]), []), pe = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, ae = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function de(e, t) {
  const o2 = e.indexOf(t);
  o2 !== -1 && e.splice(o2, 1);
}
function G() {
  return new Promise((e) => requestAnimationFrame(() => {
    requestAnimationFrame(e);
  }));
}
const d = [];
let g = null;
const le = {};
function he(e) {
  let t = le[e];
  return t || (t = le[e] = []), t;
}
let Y = function() {
};
typeof window < "u" && (Y = window.Element);
function n(e) {
  return function(t) {
    return S(t.theme, e);
  };
}
const q = "__floating-vue__popper", Q = () => defineComponent({
  name: "VPopper",
  provide() {
    return {
      [q]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [q]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: true
    },
    targetNodes: {
      type: Function,
      required: true
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: true
    },
    shown: {
      type: Boolean,
      default: false
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: n("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: n("positioningDisabled")
    },
    placement: {
      type: String,
      default: n("placement"),
      validator: (e) => Te.includes(e)
    },
    delay: {
      type: [String, Number, Object],
      default: n("delay")
    },
    distance: {
      type: [Number, String],
      default: n("distance")
    },
    skidding: {
      type: [Number, String],
      default: n("skidding")
    },
    triggers: {
      type: Array,
      default: n("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: n("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: n("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: n("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: n("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: n("popperHideTriggers")
    },
    container: {
      type: [String, Object, Y, Boolean],
      default: n("container")
    },
    boundary: {
      type: [String, Y],
      default: n("boundary")
    },
    strategy: {
      type: String,
      validator: (e) => ["absolute", "fixed"].includes(e),
      default: n("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: n("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: n("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: n("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: n("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: n("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: n("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: n("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: n("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: n("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: n("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: n("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: n("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: n("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: n("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: n("flip")
    },
    shift: {
      type: Boolean,
      default: n("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: n("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: n("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: n("disposeTimeout")
    }
  },
  emits: {
    show: () => true,
    hide: () => true,
    "update:shown": (e) => true,
    "apply-show": () => true,
    "apply-hide": () => true,
    "close-group": () => true,
    "close-directive": () => true,
    "auto-hide": () => true,
    resize: () => true
  },
  data() {
    return {
      isShown: false,
      isMounted: false,
      skipTransition: false,
      classes: {
        showFrom: false,
        showTo: false,
        hideFrom: false,
        hideTo: true
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      randomId: `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join("_")}`,
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: true,
      pendingHide: false,
      containsGlobalTarget: false,
      isDisposed: true,
      mouseDownContains: false
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var e;
      return (e = this[q]) == null ? void 0 : e.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var e, t;
      return ((e = this.popperTriggers) == null ? void 0 : e.includes("hover")) || ((t = this.popperShowTriggers) == null ? void 0 : t.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(e) {
      e ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    triggers: {
      handler: "$_refreshListeners",
      deep: true
    },
    positioningDisabled: "$_refreshListeners",
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((e, t) => (e[t] = "$_computePosition", e), {})
  },
  created() {
    this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: e = null, skipDelay: t = false, force: o2 = false } = {}) {
      var i2, s2;
      (i2 = this.parentPopper) != null && i2.lockedChild && this.parentPopper.lockedChild !== this || (this.pendingHide = false, (o2 || !this.disabled) && (((s2 = this.parentPopper) == null ? void 0 : s2.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(e, t), this.$emit("show"), this.$_showFrameLocked = true, requestAnimationFrame(() => {
        this.$_showFrameLocked = false;
      })), this.$emit("update:shown", true));
    },
    hide({ event: e = null, skipDelay: t = false } = {}) {
      var o2;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.pendingHide = true;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: t }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((o2 = this.parentPopper) == null ? void 0 : o2.lockedChild) === this && (this.parentPopper.lockedChild = null), this.pendingHide = false, this.$_scheduleHide(e, t), this.$emit("hide"), this.$emit("update:shown", false);
      }
    },
    init() {
      var e;
      this.isDisposed && (this.isDisposed = false, this.isMounted = false, this.$_events = [], this.$_preventShow = false, this.$_referenceNode = ((e = this.referenceNode) == null ? void 0 : e.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((t) => t.nodeType === t.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.isDisposed || (this.isDisposed = true, this.$_removeEventListeners(), this.hide({ skipDelay: true }), this.$_detachPopperNode(), this.isMounted = false, this.isShown = false, this.$_updateParentShownChildren(false), this.$_swapTargetAttrs("data-original-title", "title"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.isDisposed || this.positioningDisabled)
        return;
      const e = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && e.middleware.push(offset({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const t = this.placement.startsWith("auto");
      if (t ? e.middleware.push(autoPlacement({
        alignment: this.placement.split("-")[1] ?? ""
      })) : e.placement = this.placement, this.preventOverflow && (this.shift && e.middleware.push(shift({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !t && this.flip && e.middleware.push(flip({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), e.middleware.push(arrow({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && e.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: i2, rects: s2, middlewareData: r2 }) => {
          let p2;
          const { centerOffset: a2 } = r2.arrow;
          return i2.startsWith("top") || i2.startsWith("bottom") ? p2 = Math.abs(a2) > s2.reference.width / 2 : p2 = Math.abs(a2) > s2.reference.height / 2, {
            data: {
              overflow: p2
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const i2 = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        e.middleware.push({
          name: "autoSize",
          fn: ({ rects: s2, placement: r2, middlewareData: p2 }) => {
            var u2;
            if ((u2 = p2.autoSize) != null && u2.skip)
              return {};
            let a2, l2;
            return r2.startsWith("top") || r2.startsWith("bottom") ? a2 = s2.reference.width : l2 = s2.reference.height, this.$_innerNode.style[i2 === "min" ? "minWidth" : i2 === "max" ? "maxWidth" : "width"] = a2 != null ? `${a2}px` : null, this.$_innerNode.style[i2 === "min" ? "minHeight" : i2 === "max" ? "maxHeight" : "height"] = l2 != null ? `${l2}px` : null, {
              data: {
                skip: true
              },
              reset: {
                rects: true
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, e.middleware.push(size({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: i2, availableHeight: s2 }) => {
          this.$_innerNode.style.maxWidth = i2 != null ? `${i2}px` : null, this.$_innerNode.style.maxHeight = s2 != null ? `${s2}px` : null;
        }
      })));
      const o2 = await B$1(this.$_referenceNode, this.$_popperNode, e);
      Object.assign(this.result, {
        x: o2.x,
        y: o2.y,
        placement: o2.placement,
        strategy: o2.strategy,
        arrow: {
          ...o2.middlewareData.arrow,
          ...o2.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(e, t = false) {
      if (this.$_updateParentShownChildren(true), this.$_hideInProgress = false, clearTimeout(this.$_scheduleTimer), g && this.instantMove && g.instantMove && g !== this.parentPopper) {
        g.$_applyHide(true), this.$_applyShow(true);
        return;
      }
      t ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(e, t = false) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = true;
        return;
      }
      this.$_updateParentShownChildren(false), this.$_hideInProgress = true, clearTimeout(this.$_scheduleTimer), this.isShown && (g = this), t ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(e) {
      const t = this.delay;
      return parseInt(t && t[e] || t || 0);
    },
    async $_applyShow(e = false) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = e, !this.isShown && (this.$_ensureTeleport(), await G(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...D(this.$_referenceNode),
        ...D(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const t = this.$_referenceNode.getBoundingClientRect(), o2 = this.$_popperNode.querySelector(".v-popper__wrapper"), i2 = o2.parentNode.getBoundingClientRect(), s2 = t.x + t.width / 2 - (i2.left + o2.offsetLeft), r2 = t.y + t.height / 2 - (i2.top + o2.offsetTop);
        this.result.transformOrigin = `${s2}px ${r2}px`;
      }
      this.isShown = true, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const e = this.showGroup;
      if (e) {
        let t;
        for (let o2 = 0; o2 < d.length; o2++)
          t = d[o2], t.showGroup !== e && (t.hide(), t.$emit("close-group"));
      }
      d.push(this), document.body.classList.add("v-popper--some-open");
      for (const t of re(this.theme))
        he(t).push(this), document.body.classList.add(`v-popper--some-open--${t}`);
      this.$emit("apply-show"), this.classes.showFrom = true, this.classes.showTo = false, this.classes.hideFrom = false, this.classes.hideTo = false, await G(), this.classes.showFrom = false, this.classes.showTo = true, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(e = false) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = true, this.$_hideInProgress = false;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = e, de(d, this), d.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const o2 of re(this.theme)) {
        const i2 = he(o2);
        de(i2, this), i2.length === 0 && document.body.classList.remove(`v-popper--some-open--${o2}`);
      }
      g === this && (g = null), this.isShown = false, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const t = this.disposeTimeout;
      t !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = false);
      }, t)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = false, this.classes.showTo = false, this.classes.hideFrom = true, this.classes.hideTo = false, await G(), this.classes.hideFrom = false, this.classes.hideTo = true;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.isDisposed)
        return;
      let e = this.container;
      if (typeof e == "string" ? e = window.document.querySelector(e) : e === false && (e = this.$_targetNodes[0].parentNode), !e)
        throw new Error("No container for popover: " + this.container);
      e.appendChild(this.$_popperNode), this.isMounted = true;
    },
    $_addEventListeners() {
      const e = (o2) => {
        this.isShown && !this.$_hideInProgress || (o2.usedByTooltip = true, !this.$_preventShow && this.show({ event: o2 }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, pe, this.triggers, this.showTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], pe, this.popperTriggers, this.popperShowTriggers, e);
      const t = (o2) => {
        o2.usedByTooltip || this.hide({ event: o2 });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, ae, this.triggers, this.hideTriggers, t), this.$_registerTriggerListeners([this.$_popperNode], ae, this.popperTriggers, this.popperHideTriggers, t);
    },
    $_registerEventListeners(e, t, o2) {
      this.$_events.push({ targetNodes: e, eventType: t, handler: o2 }), e.forEach((i2) => i2.addEventListener(t, o2, $ ? {
        passive: true
      } : void 0));
    },
    $_registerTriggerListeners(e, t, o2, i2, s2) {
      let r2 = o2;
      i2 != null && (r2 = typeof i2 == "function" ? i2(r2) : i2), r2.forEach((p2) => {
        const a2 = t[p2];
        a2 && this.$_registerEventListeners(e, a2, s2);
      });
    },
    $_removeEventListeners(e) {
      const t = [];
      this.$_events.forEach((o2) => {
        const { targetNodes: i2, eventType: s2, handler: r2 } = o2;
        !e || e === s2 ? i2.forEach((p2) => p2.removeEventListener(s2, r2)) : t.push(o2);
      }), this.$_events = t;
    },
    $_refreshListeners() {
      this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(e, t = false) {
      this.$_showFrameLocked || (this.hide({ event: e }), e.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), t && (this.$_preventShow = true, setTimeout(() => {
        this.$_preventShow = false;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(e, t) {
      for (const o2 of this.$_targetNodes) {
        const i2 = o2.getAttribute(e);
        i2 && (o2.removeAttribute(e), o2.setAttribute(t, i2));
      }
    },
    $_applyAttrsToTarget(e) {
      for (const t of this.$_targetNodes)
        for (const o2 in e) {
          const i2 = e[o2];
          i2 == null ? t.removeAttribute(o2) : t.setAttribute(o2, i2);
        }
    },
    $_updateParentShownChildren(e) {
      let t = this.parentPopper;
      for (; t; )
        e ? t.shownChildren.add(this.randomId) : (t.shownChildren.delete(this.randomId), t.pendingHide && t.hide()), t = t.parentPopper;
    },
    $_isAimingPopper() {
      const e = this.$_referenceNode.getBoundingClientRect();
      if (y >= e.left && y <= e.right && _ >= e.top && _ <= e.bottom) {
        const t = this.$_popperNode.getBoundingClientRect(), o2 = y - c, i2 = _ - m, r2 = t.left + t.width / 2 - c + (t.top + t.height / 2) - m + t.width + t.height, p2 = c + o2 * r2, a2 = m + i2 * r2;
        return C(c, m, p2, a2, t.left, t.top, t.left, t.bottom) || // Left edge
        C(c, m, p2, a2, t.left, t.top, t.right, t.top) || // Top edge
        C(c, m, p2, a2, t.right, t.top, t.right, t.bottom) || // Right edge
        C(c, m, p2, a2, t.left, t.bottom, t.right, t.bottom);
      }
      return false;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
if (typeof document < "u" && typeof window < "u") {
  if (_e) {
    const e = $ ? {
      passive: true,
      capture: true
    } : true;
    document.addEventListener("touchstart", (t) => ue(t, true), e), document.addEventListener("touchend", (t) => fe(t, true), e);
  } else
    window.addEventListener("mousedown", (e) => ue(e, false), true), window.addEventListener("click", (e) => fe(e, false), true);
  window.addEventListener("resize", tt);
}
function ue(e, t) {
  if (h.autoHideOnMousedown)
    Pe(e, t);
  else
    for (let o2 = 0; o2 < d.length; o2++) {
      const i2 = d[o2];
      try {
        i2.mouseDownContains = i2.popperNode().contains(e.target);
      } catch {
      }
    }
}
function fe(e, t) {
  h.autoHideOnMousedown || Pe(e, t);
}
function Pe(e, t) {
  const o2 = {};
  for (let i2 = d.length - 1; i2 >= 0; i2--) {
    const s2 = d[i2];
    try {
      const r2 = s2.containsGlobalTarget = s2.mouseDownContains || s2.popperNode().contains(e.target);
      s2.pendingHide = false, requestAnimationFrame(() => {
        if (s2.pendingHide = false, !o2[s2.randomId] && ce(s2, r2, e)) {
          if (s2.$_handleGlobalClose(e, t), !e.closeAllPopover && e.closePopover && r2) {
            let a2 = s2.parentPopper;
            for (; a2; )
              o2[a2.randomId] = true, a2 = a2.parentPopper;
            return;
          }
          let p2 = s2.parentPopper;
          for (; p2 && ce(p2, p2.containsGlobalTarget, e); ) {
            p2.$_handleGlobalClose(e, t);
            p2 = p2.parentPopper;
          }
        }
      });
    } catch {
    }
  }
}
function ce(e, t, o2) {
  return o2.closeAllPopover || o2.closePopover && t || et(e, o2) && !t;
}
function et(e, t) {
  if (typeof e.autoHide == "function") {
    const o2 = e.autoHide(t);
    return e.lastAutoHide = o2, o2;
  }
  return e.autoHide;
}
function tt() {
  for (let e = 0; e < d.length; e++)
    d[e].$_computePosition();
}
let c = 0, m = 0, y = 0, _ = 0;
typeof window < "u" && window.addEventListener("mousemove", (e) => {
  c = y, m = _, y = e.clientX, _ = e.clientY;
}, $ ? {
  passive: true
} : void 0);
function C(e, t, o2, i2, s2, r2, p2, a2) {
  const l2 = ((p2 - s2) * (t - r2) - (a2 - r2) * (e - s2)) / ((a2 - r2) * (o2 - e) - (p2 - s2) * (i2 - t)), u2 = ((o2 - e) * (t - r2) - (i2 - t) * (e - s2)) / ((a2 - r2) * (o2 - e) - (p2 - s2) * (i2 - t));
  return l2 >= 0 && l2 <= 1 && u2 >= 0 && u2 <= 1;
}
const ot = {
  extends: Q()
}, B = (e, t) => {
  const o2 = e.__vccOpts || e;
  for (const [i2, s2] of t)
    o2[i2] = s2;
  return o2;
};
function it(e, t, o2, i2, s2, r2) {
  return openBlock(), createElementBlock("div", {
    ref: "reference",
    class: normalizeClass(["v-popper", {
      "v-popper--shown": e.slotData.isShown
    }])
  }, [
    renderSlot(e.$slots, "default", normalizeProps(guardReactiveProps(e.slotData)))
  ], 2);
}
const st = /* @__PURE__ */ B(ot, [["render", it]]);
function nt() {
  var e = window.navigator.userAgent, t = e.indexOf("MSIE ");
  if (t > 0)
    return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
  var o2 = e.indexOf("Trident/");
  if (o2 > 0) {
    var i2 = e.indexOf("rv:");
    return parseInt(e.substring(i2 + 3, e.indexOf(".", i2)), 10);
  }
  var s2 = e.indexOf("Edge/");
  return s2 > 0 ? parseInt(e.substring(s2 + 5, e.indexOf(".", s2)), 10) : -1;
}
let z;
function X() {
  X.init || (X.init = true, z = nt() !== -1);
}
var E = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: false
    },
    ignoreWidth: {
      type: Boolean,
      default: false
    },
    ignoreHeight: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    X(), nextTick(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", z && this.$el.appendChild(e), e.data = "about:blank", z || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!z && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const rt = /* @__PURE__ */ withScopeId("data-v-b329ee4c");
pushScopeId("data-v-b329ee4c");
const pt = {
  class: "resize-observer",
  tabindex: "-1"
};
popScopeId();
const at = /* @__PURE__ */ rt((e, t, o2, i2, s2, r2) => (openBlock(), createBlock("div", pt)));
E.render = at;
E.__scopeId = "data-v-b329ee4c";
E.__file = "src/components/ResizeObserver.vue";
const Z = (e = "theme") => ({
  computed: {
    themeClass() {
      return Ze(this[e]);
    }
  }
}), dt = defineComponent({
  name: "VPopperContent",
  components: {
    ResizeObserver: E
  },
  mixins: [
    Z()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(e) {
      return e != null && !isNaN(e) ? `${e}px` : null;
    }
  }
}), lt = ["id", "aria-hidden", "tabindex", "data-popper-placement"], ht = {
  ref: "inner",
  class: "v-popper__inner"
}, ut = /* @__PURE__ */ createElementVNode("div", { class: "v-popper__arrow-outer" }, null, -1), ft = /* @__PURE__ */ createElementVNode("div", { class: "v-popper__arrow-inner" }, null, -1), ct = [
  ut,
  ft
];
function mt(e, t, o2, i2, s2, r2) {
  const p2 = resolveComponent("ResizeObserver");
  return openBlock(), createElementBlock("div", {
    id: e.popperId,
    ref: "popover",
    class: normalizeClass(["v-popper__popper", [
      e.themeClass,
      e.classes.popperClass,
      {
        "v-popper__popper--shown": e.shown,
        "v-popper__popper--hidden": !e.shown,
        "v-popper__popper--show-from": e.classes.showFrom,
        "v-popper__popper--show-to": e.classes.showTo,
        "v-popper__popper--hide-from": e.classes.hideFrom,
        "v-popper__popper--hide-to": e.classes.hideTo,
        "v-popper__popper--skip-transition": e.skipTransition,
        "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
        "v-popper__popper--no-positioning": !e.result
      }
    ]]),
    style: normalizeStyle(e.result ? {
      position: e.result.strategy,
      transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`
    } : void 0),
    "aria-hidden": e.shown ? "false" : "true",
    tabindex: e.autoHide ? 0 : void 0,
    "data-popper-placement": e.result ? e.result.placement : void 0,
    onKeyup: t[2] || (t[2] = withKeys((a2) => e.autoHide && e.$emit("hide"), ["esc"]))
  }, [
    createElementVNode("div", {
      class: "v-popper__backdrop",
      onClick: t[0] || (t[0] = (a2) => e.autoHide && e.$emit("hide"))
    }),
    createElementVNode("div", {
      class: "v-popper__wrapper",
      style: normalizeStyle(e.result ? {
        transformOrigin: e.result.transformOrigin
      } : void 0)
    }, [
      createElementVNode("div", ht, [
        e.mounted ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("div", null, [
            renderSlot(e.$slots, "default")
          ]),
          e.handleResize ? (openBlock(), createBlock(p2, {
            key: 0,
            onNotify: t[1] || (t[1] = (a2) => e.$emit("resize", a2))
          })) : createCommentVNode("", true)
        ], 64)) : createCommentVNode("", true)
      ], 512),
      createElementVNode("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: normalizeStyle(e.result ? {
          left: e.toPx(e.result.arrow.x),
          top: e.toPx(e.result.arrow.y)
        } : void 0)
      }, ct, 4)
    ], 4)
  ], 46, lt);
}
const ee = /* @__PURE__ */ B(dt, [["render", mt]]), te = {
  methods: {
    show(...e) {
      return this.$refs.popper.show(...e);
    },
    hide(...e) {
      return this.$refs.popper.hide(...e);
    },
    dispose(...e) {
      return this.$refs.popper.dispose(...e);
    },
    onResize(...e) {
      return this.$refs.popper.onResize(...e);
    }
  }
};
let K = function() {
};
typeof window < "u" && (K = window.Element);
const gt = defineComponent({
  name: "VPopperWrapper",
  components: {
    Popper: st,
    PopperContent: ee
  },
  mixins: [
    te,
    Z("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    },
    referenceNode: {
      type: Function,
      default: null
    },
    shown: {
      type: Boolean,
      default: false
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    delay: {
      type: [String, Number, Object],
      default: void 0
    },
    distance: {
      type: [Number, String],
      default: void 0
    },
    skidding: {
      type: [Number, String],
      default: void 0
    },
    triggers: {
      type: Array,
      default: void 0
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperTriggers: {
      type: Array,
      default: void 0
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    container: {
      type: [String, Object, K, Boolean],
      default: void 0
    },
    boundary: {
      type: [String, K],
      default: void 0
    },
    strategy: {
      type: String,
      default: void 0
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0
    },
    handleResize: {
      type: Boolean,
      default: void 0
    },
    instantMove: {
      type: Boolean,
      default: void 0
    },
    eagerMount: {
      type: Boolean,
      default: void 0
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: void 0
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: void 0
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0
    },
    preventOverflow: {
      type: Boolean,
      default: void 0
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: void 0
    },
    shift: {
      type: Boolean,
      default: void 0
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0
    },
    disposeTimeout: {
      type: Number,
      default: void 0
    }
  },
  emits: {
    show: () => true,
    hide: () => true,
    "update:shown": (e) => true,
    "apply-show": () => true,
    "apply-hide": () => true,
    "close-group": () => true,
    "close-directive": () => true,
    "auto-hide": () => true,
    resize: () => true
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    }
  }
});
function wt(e, t, o2, i2, s2, r2) {
  const p2 = resolveComponent("PopperContent"), a2 = resolveComponent("Popper");
  return openBlock(), createBlock(a2, mergeProps({ ref: "popper" }, e.$props, {
    theme: e.finalTheme,
    "target-nodes": e.getTargetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    class: [
      e.themeClass
    ],
    onShow: t[0] || (t[0] = () => e.$emit("show")),
    onHide: t[1] || (t[1] = () => e.$emit("hide")),
    "onUpdate:shown": t[2] || (t[2] = (l2) => e.$emit("update:shown", l2)),
    onApplyShow: t[3] || (t[3] = () => e.$emit("apply-show")),
    onApplyHide: t[4] || (t[4] = () => e.$emit("apply-hide")),
    onCloseGroup: t[5] || (t[5] = () => e.$emit("close-group")),
    onCloseDirective: t[6] || (t[6] = () => e.$emit("close-directive")),
    onAutoHide: t[7] || (t[7] = () => e.$emit("auto-hide")),
    onResize: t[8] || (t[8] = () => e.$emit("resize"))
  }), {
    default: withCtx(({
      popperId: l2,
      isShown: u2,
      shouldMountContent: L2,
      skipTransition: D2,
      autoHide: I,
      show: F2,
      hide: v2,
      handleResize: R2,
      onResize: j,
      classes: V,
      result: Ee
    }) => [
      renderSlot(e.$slots, "default", {
        shown: u2,
        show: F2,
        hide: v2
      }),
      createVNode(p2, {
        ref: "popperContent",
        "popper-id": l2,
        theme: e.finalTheme,
        shown: u2,
        mounted: L2,
        "skip-transition": D2,
        "auto-hide": I,
        "handle-resize": R2,
        classes: V,
        result: Ee,
        onHide: v2,
        onResize: j
      }, {
        default: withCtx(() => [
          renderSlot(e.$slots, "popper", {
            shown: u2,
            hide: v2
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 16, ["theme", "target-nodes", "popper-node", "class"]);
}
const k = /* @__PURE__ */ B(gt, [["render", wt]]), Se = {
  ...k,
  name: "VDropdown",
  vPopperTheme: "dropdown"
}, be = {
  ...k,
  name: "VMenu",
  vPopperTheme: "menu"
}, Ce = {
  ...k,
  name: "VTooltip",
  vPopperTheme: "tooltip"
}, $t = defineComponent({
  name: "VTooltipDirective",
  components: {
    Popper: Q(),
    PopperContent: ee
  },
  mixins: [
    te
  ],
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (e) => S(e.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (e) => S(e.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(true);
      },
      immediate: true
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(e) {
      if (typeof this.content == "function" && this.$_isShown && (e || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = true;
        const t = ++this.$_fetchId, o2 = this.content(this);
        o2.then ? o2.then((i2) => this.onResult(t, i2)) : this.onResult(t, o2);
      }
    },
    onResult(e, t) {
      e === this.$_fetchId && (this.$_loading = false, this.asyncContent = t);
    },
    onShow() {
      this.$_isShown = true, this.fetchContent();
    },
    onHide() {
      this.$_isShown = false;
    }
  }
}), vt = ["innerHTML"], yt = ["textContent"];
function _t(e, t, o2, i2, s2, r2) {
  const p2 = resolveComponent("PopperContent"), a2 = resolveComponent("Popper");
  return openBlock(), createBlock(a2, mergeProps({ ref: "popper" }, e.$attrs, {
    theme: e.theme,
    "target-nodes": e.targetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    onApplyShow: e.onShow,
    onApplyHide: e.onHide
  }), {
    default: withCtx(({
      popperId: l2,
      isShown: u2,
      shouldMountContent: L2,
      skipTransition: D2,
      autoHide: I,
      hide: F2,
      handleResize: v2,
      onResize: R2,
      classes: j,
      result: V
    }) => [
      createVNode(p2, {
        ref: "popperContent",
        class: normalizeClass({
          "v-popper--tooltip-loading": e.loading
        }),
        "popper-id": l2,
        theme: e.theme,
        shown: u2,
        mounted: L2,
        "skip-transition": D2,
        "auto-hide": I,
        "handle-resize": v2,
        classes: j,
        result: V,
        onHide: F2,
        onResize: R2
      }, {
        default: withCtx(() => [
          e.html ? (openBlock(), createElementBlock("div", {
            key: 0,
            innerHTML: e.finalContent
          }, null, 8, vt)) : (openBlock(), createElementBlock("div", {
            key: 1,
            textContent: toDisplayString(e.finalContent)
          }, null, 8, yt))
        ]),
        _: 2
      }, 1032, ["class", "popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 1
  }, 16, ["theme", "target-nodes", "popper-node", "onApplyShow", "onApplyHide"]);
}
const ze = /* @__PURE__ */ B($t, [["render", _t]]), Ae = "v-popper--has-tooltip";
function Tt(e, t) {
  let o2 = e.placement;
  if (!o2 && t)
    for (const i2 of Te)
      t[i2] && (o2 = i2);
  return o2 || (o2 = S(e.theme || "tooltip", "placement")), o2;
}
function Ne(e, t, o2) {
  let i2;
  const s2 = typeof t;
  return s2 === "string" ? i2 = { content: t } : t && s2 === "object" ? i2 = t : i2 = { content: false }, i2.placement = Tt(i2, o2), i2.targetNodes = () => [e], i2.referenceNode = () => e, i2;
}
let x, b, Pt = 0;
function St() {
  if (x)
    return;
  b = ref([]), x = createApp({
    name: "VTooltipDirectiveApp",
    setup() {
      return {
        directives: b
      };
    },
    render() {
      return this.directives.map((t) => h$2(ze, {
        ...t.options,
        shown: t.shown || t.options.shown,
        key: t.id
      }));
    },
    devtools: {
      hide: true
    }
  });
  const e = document.createElement("div");
  document.body.appendChild(e), x.mount(e);
}
function bt(e, t, o2) {
  St();
  const i2 = ref(Ne(e, t, o2)), s2 = ref(false), r2 = {
    id: Pt++,
    options: i2,
    shown: s2
  };
  return b.value.push(r2), e.classList && e.classList.add(Ae), e.$_popper = {
    options: i2,
    item: r2,
    show() {
      s2.value = true;
    },
    hide() {
      s2.value = false;
    }
  };
}
function He(e) {
  if (e.$_popper) {
    const t = b.value.indexOf(e.$_popper.item);
    t !== -1 && b.value.splice(t, 1), delete e.$_popper, delete e.$_popperOldShown, delete e.$_popperMountTarget;
  }
  e.classList && e.classList.remove(Ae);
}
function me(e, { value: t, modifiers: o2 }) {
  const i2 = Ne(e, t, o2);
  if (!i2.content || S(i2.theme || "tooltip", "disabled"))
    He(e);
  else {
    let s2;
    e.$_popper ? (s2 = e.$_popper, s2.options.value = i2) : s2 = bt(e, t, o2), typeof t.shown < "u" && t.shown !== e.$_popperOldShown && (e.$_popperOldShown = t.shown, t.shown ? s2.show() : s2.hide());
  }
}
const oe = {
  beforeMount: me,
  updated: me,
  beforeUnmount(e) {
    He(e);
  }
};
function ge(e) {
  e.addEventListener("mousedown", H), e.addEventListener("click", H), e.addEventListener("touchstart", Oe, $ ? {
    passive: true
  } : false);
}
function we(e) {
  e.removeEventListener("mousedown", H), e.removeEventListener("click", H), e.removeEventListener("touchstart", Oe), e.removeEventListener("touchend", Me), e.removeEventListener("touchcancel", Be);
}
function H(e) {
  const t = e.currentTarget;
  e.closePopover = !t.$_vclosepopover_touch, e.closeAllPopover = t.$_closePopoverModifiers && !!t.$_closePopoverModifiers.all;
}
function Oe(e) {
  if (e.changedTouches.length === 1) {
    const t = e.currentTarget;
    t.$_vclosepopover_touch = true;
    const o2 = e.changedTouches[0];
    t.$_vclosepopover_touchPoint = o2, t.addEventListener("touchend", Me), t.addEventListener("touchcancel", Be);
  }
}
function Me(e) {
  const t = e.currentTarget;
  if (t.$_vclosepopover_touch = false, e.changedTouches.length === 1) {
    const o2 = e.changedTouches[0], i2 = t.$_vclosepopover_touchPoint;
    e.closePopover = Math.abs(o2.screenY - i2.screenY) < 20 && Math.abs(o2.screenX - i2.screenX) < 20, e.closeAllPopover = t.$_closePopoverModifiers && !!t.$_closePopoverModifiers.all;
  }
}
function Be(e) {
  const t = e.currentTarget;
  t.$_vclosepopover_touch = false;
}
const ie = {
  beforeMount(e, { value: t, modifiers: o2 }) {
    e.$_closePopoverModifiers = o2, (typeof t > "u" || t) && ge(e);
  },
  updated(e, { value: t, oldValue: o2, modifiers: i2 }) {
    e.$_closePopoverModifiers = i2, t !== o2 && (typeof t > "u" || t ? ge(e) : we(e));
  },
  beforeUnmount(e) {
    we(e);
  }
}, kt = Se;
function Ct(e, t = {}) {
  e.$_vTooltipInstalled || (e.$_vTooltipInstalled = true, ye(h, t), e.directive("tooltip", oe), e.directive("close-popper", ie), e.component("VTooltip", Ce), e.component("VDropdown", Se), e.component("VMenu", be));
}
const Gt = {
  // eslint-disable-next-line no-undef
  version: "5.2.2",
  install: Ct,
  options: h
};
const _sfc_main$W = /* @__PURE__ */ defineComponent({
  __name: "Dropdown",
  props: /* @__PURE__ */ mergeModels({
    value: {},
    thin: { type: Boolean },
    flat: { type: Boolean },
    disabled: { type: Boolean },
    icon: {},
    color: {},
    triggerClass: {},
    iconEnd: {},
    border: { type: Boolean },
    outline: { type: Boolean },
    round: { type: Boolean },
    placement: { default: "bottom-start" },
    disablePlacement: { type: Boolean, default: false },
    noAutoFocus: { type: Boolean },
    autoHide: { type: Boolean, default: true },
    triggers: { default: () => ["click"] }
  }, {
    "shown": {
      type: Boolean,
      default: false
    },
    "shownModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["show", "hide"], ["update:shown"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit2 = __emit;
    const ddownRef = ref();
    const triggerRef = ref();
    const shown = useModel(__props, "shown");
    const show = () => {
      var _a;
      return (_a = ddownRef.value) == null ? void 0 : _a.show();
    };
    function hide() {
      var _a, _b;
      (_a = triggerRef.value) == null ? void 0 : _a.focus();
      (_b = ddownRef.value) == null ? void 0 : _b.hide();
    }
    const { isMobile } = useDevice();
    const shouldDisablePositioning = computed(() => {
      return __props.disablePlacement && isMobile;
    });
    __expose({ show, hide, shown });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(kt), {
        ref_key: "ddownRef",
        ref: ddownRef,
        shown: shown.value,
        "onUpdate:shown": _cache[0] || (_cache[0] = ($event) => shown.value = $event),
        disabled: _ctx.disabled,
        noAutoFocus: _ctx.noAutoFocus,
        "positioning-disabled": shouldDisablePositioning.value,
        placement: _ctx.placement,
        autoHide: _ctx.autoHide,
        triggers: _ctx.triggers,
        onHide: _cache[1] || (_cache[1] = ($event) => emit2("hide")),
        onShow: _cache[2] || (_cache[2] = ($event) => emit2("show"))
      }, {
        popper: withCtx(({ hide: hide2, show: show2 }) => [
          renderSlot(_ctx.$slots, "default", {
            hide: hide2,
            show: show2
          })
        ]),
        default: withCtx(() => [
          createElementVNode("div", {
            ref_key: "triggerRef",
            ref: triggerRef
          }, null, 512),
          renderSlot(_ctx.$slots, "trigger", {}, () => [
            createVNode(unref(Btn), {
              class: normalizeClass(_ctx.triggerClass),
              iconEnd: _ctx.iconEnd,
              icon: _ctx.icon,
              value: _ctx.value,
              thin: _ctx.thin,
              flat: _ctx.flat,
              outline: _ctx.outline,
              round: _ctx.round,
              color: _ctx.color
            }, null, 8, ["class", "iconEnd", "icon", "value", "thin", "flat", "outline", "round", "color"])
          ])
        ]),
        _: 3
      }, 8, ["shown", "disabled", "noAutoFocus", "positioning-disabled", "placement", "autoHide", "triggers"]);
    };
  }
});
const _hoisted_1$N = { class: "px-1 pt-025 pb-1" };
const _hoisted_2$z = { class: "ms-1" };
const _sfc_main$V = /* @__PURE__ */ defineComponent({
  __name: "FieldSetVue",
  props: {
    label: {},
    legend: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("fieldset", _hoisted_1$N, [
        createElementVNode("legend", _hoisted_2$z, toDisplayString(_ctx.legend || _ctx.label), 1),
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]);
    };
  }
});
const FieldSetVue = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["__scopeId", "data-v-f7e758e5"]]);
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "Flag",
  props: {
    country: {},
    size: {},
    circle: { type: Boolean },
    square: { type: Boolean }
  },
  setup(__props) {
    const props2 = __props;
    const fis = computed(() => {
      if (props2.circle || props2.square) return true;
      return false;
    });
    const height = computed(() => `${props2.size || 1}rem`);
    const backgroundImage = computed(() => {
      let country = props2.country.toLowerCase();
      if (country === "ac") country = "sh-ac";
      const baseURL = "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.0.0/flags";
      if (fis.value) return `url(${baseURL}/1x1/${country.toLowerCase()}.svg)`;
      return `url(${baseURL}/4x3/${country.toLowerCase()}.svg)`;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(["fi", { fis: fis.value, circle: _ctx.circle }]),
        style: normalizeStyle({ height: height.value, backgroundImage: backgroundImage.value })
      }, null, 6);
    };
  }
});
const Flag = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["__scopeId", "data-v-f99f1900"]]);
function getBaseField(id, labelOrRest = {}, rest = {}) {
  if (typeof labelOrRest === "object") return { id, ...labelOrRest };
  return { id, label: labelOrRest, ...rest };
}
function richText(id, label, options) {
  return {
    $el: "richtext",
    class: options == null ? void 0 : options.class,
    required: options == null ? void 0 : options.required,
    id,
    label,
    vIf: options == null ? void 0 : options.vIf,
    placeholder: options == null ? void 0 : options.placeholder,
    attrs: {
      autocomplete: options == null ? void 0 : options.autocomplete
    }
  };
}
function txtField(id, label, options) {
  return {
    $el: "text",
    class: options == null ? void 0 : options.class,
    required: options == null ? void 0 : options.required,
    id,
    label,
    vIf: options == null ? void 0 : options.vIf,
    disabled: options == null ? void 0 : options.disabled,
    placeholder: options == null ? void 0 : options.placeholder,
    defaultValue: options == null ? void 0 : options.defaultValue,
    attrs: {
      type: options == null ? void 0 : options.type,
      pattern: options == null ? void 0 : options.pattern,
      multiline: options == null ? void 0 : options.multiline,
      autocomplete: options == null ? void 0 : options.autocomplete
    }
  };
}
function selectField(id, label, options, config) {
  return {
    $el: "select",
    id,
    options,
    class: config == null ? void 0 : config.class,
    placeholder: config == null ? void 0 : config.placeholder,
    required: config == null ? void 0 : config.required,
    label,
    defaultValue: config == null ? void 0 : config.defaultValue,
    vIf: config == null ? void 0 : config.vIf,
    attrs: {
      disabled: config == null ? void 0 : config.disabled,
      searchable: config == null ? void 0 : config.searchable,
      multiselect: config == null ? void 0 : config.multiselect,
      onSearch: config == null ? void 0 : config.onSearch,
      clearable: config == null ? void 0 : config.clearable,
      autocomplete: config == null ? void 0 : config.autocomplete
    }
  };
}
const slctField = selectField;
function checkField(id, label, options) {
  return {
    $el: "check",
    class: options == null ? void 0 : options.class,
    required: options == null ? void 0 : options.required,
    id,
    label
  };
}
function dateField(id, label, options) {
  return {
    $el: "date",
    class: options == null ? void 0 : options.class,
    required: options == null ? void 0 : options.required,
    id,
    disabled: options == null ? void 0 : options.disabled,
    label,
    defaultValue: options == null ? void 0 : options.defaultValue,
    vIf: options == null ? void 0 : options.vIf,
    attrs: {
      disabled: options == null ? void 0 : options.disabled,
      autocomplete: options == null ? void 0 : options.autocomplete,
      enableTime: options == null ? void 0 : options.enableTime,
      mode: options == null ? void 0 : options.mode,
      locale: options == null ? void 0 : options.locale,
      timezone: options == null ? void 0 : options.timezone
    }
  };
}
function numField(id, label, options) {
  return {
    $el: "number",
    class: options == null ? void 0 : options.class,
    required: options == null ? void 0 : options.required,
    defaultValue: options == null ? void 0 : options.defaultValue,
    id,
    label,
    disabled: options == null ? void 0 : options.disabled,
    placeholder: options == null ? void 0 : options.placeholder,
    helptext: options == null ? void 0 : options.helptext,
    vIf: options == null ? void 0 : options.vIf,
    attrs: {
      autocomplete: options == null ? void 0 : options.autocomplete,
      step: options == null ? void 0 : options.step,
      min: options == null ? void 0 : options.min,
      max: options == null ? void 0 : options.max,
      layout: options == null ? void 0 : options.layout,
      padZero: options == null ? void 0 : options.padZero,
      center: options == null ? void 0 : options.center,
      useGrouping: options == null ? void 0 : options.useGrouping
    }
  };
}
function frmRow(...children2) {
  return {
    $el: "div",
    class: "flex gap-1 m_block align-items-end",
    children: children2
  };
}
function uploadField(id, label, options) {
  return {
    $el: "upload",
    id,
    label,
    vIf: options == null ? void 0 : options.vIf,
    attrs: {
      ...options
    }
  };
}
function rangeField(id, label, options) {
  return {
    $el: "range",
    id,
    label,
    vIf: options == null ? void 0 : options.vIf,
    attrs: {
      autocomplete: options == null ? void 0 : options.autocomplete,
      min: options == null ? void 0 : options.min,
      max: options == null ? void 0 : options.max,
      step: options == null ? void 0 : options.step,
      rtl: options == null ? void 0 : options.rtl,
      multiRange: options == null ? void 0 : options.multiRange,
      formatValue: options == null ? void 0 : options.formatValue
    }
  };
}
function bglForm(idOrField, ...schema) {
  if (typeof idOrField === "string") {
    return {
      $el: "bagelform",
      id: idOrField,
      attrs: {
        schema: [idOrField, ...schema]
      }
    };
  }
  return {
    $el: "bagelform",
    attrs: {
      schema: [idOrField, ...schema]
    }
  };
}
function telField(id, label, options) {
  return {
    $el: "tel",
    id,
    label,
    vIf: options == null ? void 0 : options.vIf,
    attrs: options,
    class: options == null ? void 0 : options.class
  };
}
function colorField(id, label, options) {
  return {
    $el: "color",
    id,
    label,
    vIf: options == null ? void 0 : options.vIf,
    attrs: options,
    class: options == null ? void 0 : options.class
  };
}
function findBglFieldById(id, _schema) {
  for (const field of _schema) {
    if (field.id === id) return field;
    if (field.children && Number(field.children.length) > 0) {
      const fieldChildren = field.children.filter((c2) => typeof c2 === "object" && "$el" in c2);
      const child = findBglFieldById(id, fieldChildren);
      if (child) return child;
    }
  }
  return void 0;
}
function arrField(id, label, schemaOrType, options) {
  const attrs = { delete: true, add: true, ...options };
  if (typeof schemaOrType === "string") attrs.type = schemaOrType;
  else attrs.schema = schemaOrType;
  return {
    label,
    id,
    class: options == null ? void 0 : options.class,
    $el: "array",
    vIf: options == null ? void 0 : options.vIf,
    attrs
  };
}
const BagelFormUtils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrField,
  bglForm,
  checkField,
  colorField,
  dateField,
  findBglFieldById,
  frmRow,
  getBaseField,
  numField,
  rangeField,
  richText,
  selectField,
  slctField,
  telField,
  txtField,
  uploadField
}, Symbol.toStringTag, { value: "Module" }));
const state$1 = reactive({
  defaultLang: "",
  availableLangs: [],
  lang: "en"
});
function $tdb(langEl) {
  if (!langEl) {
    console.warn("No language element provided for $tdb function");
    return "";
  }
  return langEl[state$1.lang] || langEl[state$1.defaultLang] || "";
}
function useLang() {
  const lang = computed({
    get: () => state$1.lang,
    set: (val) => state$1.lang = val
  });
  const availableLangs = computed({
    get: () => state$1.availableLangs,
    set: (val) => state$1.availableLangs = val
  });
  const defaultLang = computed({
    get: () => state$1.defaultLang,
    set: (val) => state$1.defaultLang = val
  });
  return {
    lang,
    $tdb,
    availableLangs,
    defaultLang
  };
}
function formatString(str, format2) {
  if (format2 === "titleCase") {
    return str.split("_").map((word) => word[0].toUpperCase() + word.slice(1).toLocaleLowerCase()).join(" ");
  }
  if (format2 === "pascal") {
    return str.split("_").map((word) => word[0].toUpperCase() + word.slice(1).toLocaleLowerCase()).join("");
  }
  if (format2 === "camel") {
    return str.split("_").map((word, index2) => index2 === 0 ? word : word[0].toUpperCase() + word.slice(1)).join("");
  }
  if (format2 === "snake") {
    return [...str].map((letter) => {
      if (letter === letter.toUpperCase()) {
        return `_${letter.toLowerCase()}`;
      }
      return letter;
    }).join("");
  }
  return str;
}
const debouncers = /* @__PURE__ */ new Map();
function debounce(fn, wait = 500) {
  clearTimeout(debouncers.get(fn));
  const timeout = setTimeout(() => {
    fn();
    debouncers.delete(fn);
  }, wait);
  debouncers.set(fn, timeout);
}
function slugify(str) {
  return str.toLowerCase().replace(/[^a-z0-9-\s]/g, "").split(/[\s-]+/).join("-");
}
function keyToLabel(key) {
  if (key === void 0) return key;
  return key.split("_").map((k2) => k2.charAt(0).toUpperCase() + k2.slice(1)).join(" ") || key;
}
async function copyText(text, cb) {
  await navigator.clipboard.writeText(text);
  if (cb) cb("Copied to clipboard");
}
function initials(...strArr) {
  strArr = strArr.flatMap((str) => str.split(/\s/));
  return strArr.map((str) => str.charAt(0)).join("");
}
function useEscape(event, closeModel) {
  if (event.key === "Escape") {
    closeModel();
  }
}
function classify(fieldVal, row, ...classes) {
  return classes.map((cls) => {
    if (typeof cls === "function") return cls(fieldVal, row);
    return cls;
  }).join(" ");
}
function bindAttrs(attrs, fieldVal, row) {
  if (!attrs) return {};
  const exclude = ["class"];
  const arr = Object.entries(attrs).filter(([key]) => !exclude.includes(key)).map(([key, value]) => [
    key,
    typeof value === "function" ? value(fieldVal, row) : value
  ]);
  const resolvedAttrs = Object.fromEntries(arr);
  return resolvedAttrs;
}
function iffer(field, itemData) {
  var _a;
  if (field["v-if"] === void 0) return true;
  if (typeof field["v-if"] === "boolean") return field["v-if"];
  if (typeof field["v-if"] === "string") return true;
  if (typeof field["v-if"] === "function")
    return (_a = field["v-if"]) == null ? void 0 : _a.call(field, itemData == null ? void 0 : itemData[field.id], itemData);
  return true;
}
function denullify(itemData, fieldID) {
  if (!fieldID) return;
  return itemData ? itemData[fieldID] : void 0;
}
const isDate$1 = (dateToTest) => !Number.isNaN(Date.parse(dateToTest));
function getFallbackSchema(data2, columns) {
  const keys4 = Array.from(new Set((data2 ?? []).flatMap(Object.keys)));
  const schema = keys4.map((id) => ({
    id,
    label: keyToLabel(id),
    transform: (val) => {
      const dateFields = ["created_at", "updated_at"];
      if (dateFields.includes(id)) return val ? new Date(val).toLocaleString() : val;
      return val;
    }
  }));
  return columns ? schema.filter((f2) => columns.includes(f2.id) || !f2.id) : schema;
}
function sleep(ms = 100) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
function appendScript(src, options) {
  return new Promise((resolve, reject3) => {
    if (options == null ? void 0 : options.id) {
      if (document.getElementById(options.id)) {
        resolve();
        return;
      }
    } else if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const script2 = document.createElement("script");
    script2.src = src;
    if (options == null ? void 0 : options.id) {
      script2.id = options.id;
    }
    script2.onload = () => {
      resolve();
    };
    script2.onerror = reject3;
    document.head.append(script2);
  });
}
function appendStyle(src) {
  return new Promise((resolve, reject3) => {
    if (document.querySelector(`link[href="${src}"]`)) {
      resolve();
      return;
    }
    const link = document.createElement("link");
    link.href = src;
    link.rel = "stylesheet";
    link.onload = () => {
      resolve();
    };
    link.onerror = reject3;
    document.head.append(link);
  });
}
function normalizeURL(url) {
  if (url.startsWith("https://")) return url;
  url = url.replace(/http:\/\//, "");
  return `https://${url}`;
}
function normalizeDimension(value, defaultMetric = "px") {
  if (typeof value === "number") return `${value}${defaultMetric}`;
  return value;
}
const fileBaseUrl = "https://files.bagel.design".replace(/\/$/, "");
const bagelBaseUrl = void 0;
const URL_REGEX = /^https?:\/\/|^\/\//;
function pathKeyToURL(pathKey) {
  if (!pathKey || URL_REGEX.test(pathKey)) return pathKey;
  if (pathKey.startsWith("static/")) {
    return `${bagelBaseUrl}/${pathKey}`;
  }
  return `${fileBaseUrl}/${pathKey}`;
}
function getNestedValue(obj, path, defaultValue = void 0) {
  if (!path) return obj;
  const keys4 = path.split(/[.[]/);
  let current = obj;
  for (const key of keys4) {
    if (!current || typeof current !== "object" || !(key in current)) {
      return defaultValue;
    }
    current = current[key];
  }
  return current ?? defaultValue;
}
const _hoisted_1$M = { class: "flex-center h-300px" };
const _sfc_main$T = /* @__PURE__ */ defineComponent({
  __name: "BagelForm",
  props: {
    modelValue: { default: void 0 },
    schema: { default: void 0 },
    tag: { default: "form" },
    class: { default: "" },
    onSubmit: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const clone2 = (obj) => !obj ? obj : JSON.parse(JSON.stringify(obj));
    const form = ref();
    const formData = ref(clone2(props2.modelValue ?? {}));
    const initialFormData = ref(clone2(props2.modelValue ?? {}));
    const formState = ref("idle");
    const schemaState = ref("loaded");
    const resolvedSchemaData = ref();
    const schemaRef = toRef(props2, "schema");
    const resolvedSchema = computed(() => resolvedSchemaData.value);
    const isDirty = computed(() => {
      try {
        return JSON.stringify(formData.value) !== JSON.stringify(initialFormData.value);
      } catch {
        return false;
      }
    });
    onMounted(() => {
      if (props2.modelValue) initialFormData.value = clone2(props2.modelValue);
      refreshSchema();
    });
    watch(() => props2.modelValue, (val) => {
      if (val !== void 0) formData.value = clone2(val);
    }, { immediate: true, deep: true });
    async function resolveSchema(schema) {
      if (!schema) {
        resolvedSchemaData.value = void 0;
        schemaState.value = "loaded";
        return;
      }
      try {
        schemaState.value = "loading";
        const isPromise = (obj) => obj && typeof obj.then === "function";
        let result2;
        if (typeof schema === "function") {
          result2 = schema();
          result2 = isPromise(result2) ? await result2 : result2;
        } else {
          result2 = isPromise(schema) ? await schema : schema;
        }
        resolvedSchemaData.value = result2;
        schemaState.value = "loaded";
      } catch (error) {
        console.error("Schema error:", error);
        schemaState.value = "error";
        resolvedSchemaData.value = void 0;
      }
    }
    async function refreshSchema() {
      await resolveSchema(props2.schema);
      return resolvedSchemaData.value;
    }
    watch(schemaRef, resolveSchema, { immediate: true, deep: true });
    function updateFormData(fieldId, value) {
      const keys4 = fieldId.split(".");
      const newData = clone2(formData.value);
      let current = newData;
      for (let i2 = 0; i2 < keys4.length - 1; i2++) {
        const key = keys4[i2];
        if (!current[key] || typeof current[key] !== "object") current[key] = {};
        current = current[key];
      }
      current[keys4[keys4.length - 1]] = value;
      formData.value = newData;
      emit2("update:modelValue", formData.value);
    }
    const validateForm = () => {
      var _a;
      return ((_a = form.value) == null ? void 0 : _a.reportValidity()) ?? false;
    };
    let formError = ref();
    async function handleSubmit() {
      var _a;
      try {
        const valid = validateForm();
        if (!valid) return;
        if (formState.value === "submitting") return;
        formState.value = "submitting";
        await ((_a = props2.onSubmit) == null ? void 0 : _a.call(props2, formData.value));
        initialFormData.value = clone2(formData.value);
        formState.value = "success";
        window.parent.postMessage({ type: "BAGEL_FORM_SUCCESS", data: JSON.stringify(formData.value) }, "*");
      } catch (error) {
        formState.value = "error";
        formError.value = error;
        console.error("Submit error:", formError.value);
      }
    }
    const { renderField } = useSchemaField({
      mode: "form",
      getRowData: () => ({
        ...formData.value,
        get: (path) => getNestedValue(formData.value, path, "")
      }),
      onUpdate: (field, value) => {
        var _a;
        if (field.id) {
          updateFormData(field.id, value);
          (_a = field.onUpdate) == null ? void 0 : _a.call(field, value, formData.value);
        }
      }
    });
    const renderSchemaField = (field) => renderField(field);
    function handleSlotInputChange(event) {
      const input = event.target;
      if (input.name) {
        const value = input.type === "checkbox" ? input.checked : input.value;
        updateFormData(input.name, value);
      }
    }
    __expose({ form, isDirty, validateForm, resolveSchema, refreshSchema });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        formState.value !== "success" || !_ctx.$slots.success ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          props2.tag === "form" ? (openBlock(), createElementBlock("form", {
            key: 0,
            ref_key: "form",
            ref: form,
            class: normalizeClass(props2.class),
            onSubmit: withModifiers(handleSubmit, ["prevent"]),
            onInput: handleSlotInputChange
          }, [
            schemaState.value === "loading" ? renderSlot(_ctx.$slots, "loading", { key: 0 }, () => [
              createElementVNode("div", _hoisted_1$M, [
                createVNode(unref(Loading))
              ])
            ]) : schemaState.value === "error" ? renderSlot(_ctx.$slots, "schema-error", { key: 1 }, () => [
              _cache[0] || (_cache[0] = createElementVNode("div", { class: "flex-center h-300px txt-red" }, " Error loading form ", -1))
            ]) : resolvedSchema.value ? (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(resolvedSchema.value, (field) => {
              return openBlock(), createBlock(resolveDynamicComponent(renderSchemaField(field)), {
                key: field.id
              });
            }), 128)) : renderSlot(_ctx.$slots, "default", { key: 3 }),
            renderSlot(_ctx.$slots, "submit", {
              submit: handleSubmit,
              isDirty: isDirty.value,
              validateForm,
              formState: formState.value,
              schemaState: schemaState.value
            })
          ], 34)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            schemaState.value === "loading" ? renderSlot(_ctx.$slots, "loading", { key: 0 }, () => [
              createVNode(unref(Loading))
            ]) : schemaState.value === "error" ? renderSlot(_ctx.$slots, "schema-error", { key: 1 }, () => [
              _cache[1] || (_cache[1] = createElementVNode("div", { class: "flex-center h-300px txt-red" }, " Error loading form ", -1))
            ]) : resolvedSchema.value ? (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(resolvedSchema.value, (field) => {
              return openBlock(), createBlock(resolveDynamicComponent(renderSchemaField(field)), {
                key: field.id,
                class: normalizeClass(props2.class)
              }, null, 8, ["class"]);
            }), 128)) : createCommentVNode("", true)
          ], 64))
        ], 64)) : createCommentVNode("", true),
        formState.value === "success" ? renderSlot(_ctx.$slots, "success", { key: 1 }) : createCommentVNode("", true),
        formState.value === "error" ? renderSlot(_ctx.$slots, "error", {
          key: 2,
          error: unref(formError)
        }) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _hoisted_1$L = {
  key: 0,
  class: "label mb-05"
};
const _hoisted_2$y = { class: "ps-025 border-start mb-05" };
const _hoisted_3$u = {
  key: 0,
  class: "flex-center h-300px"
};
const _hoisted_4$j = {
  key: 1,
  class: "py-1"
};
const _hoisted_5$i = {
  key: 0,
  class: "minimizedText txt14 p-025 opacity-7"
};
const _hoisted_6$f = { class: "bg-gray-80 -my-05 px-025 pt-065 pb-05 txt-center space-between flex column" };
const _sfc_main$S = /* @__PURE__ */ defineComponent({
  __name: "FieldArray",
  props: {
    el: { default: "div" },
    id: {},
    label: {},
    placeholder: {},
    children: {},
    class: { type: [String, Number, Boolean, Object] },
    attrs: {},
    required: { type: Boolean },
    disabled: { type: Boolean },
    helptext: {},
    options: {},
    defaultValue: {},
    add: { type: Boolean, default: true },
    delete: { type: Boolean, default: true },
    transform: {},
    schema: {},
    modelValue: {},
    type: { default: "object" }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const minimizedItems = ref([]);
    const internalData = ref(props2.modelValue || []);
    const schemaState = ref("loaded");
    const resolvedSchemaData = ref([]);
    watch(() => props2.modelValue, (newValue) => {
      internalData.value = newValue || [];
    }, { deep: true });
    const primitiveSchema = computed(() => {
      if (props2.type === "text") {
        return [{ id: "value", type: "text", label: "" }];
      } else if (props2.type === "number") {
        return [{ id: "value", type: "number", label: "" }];
      }
      return [];
    });
    async function resolveSchema() {
      if (props2.type !== "object") {
        resolvedSchemaData.value = primitiveSchema.value;
        schemaState.value = "loaded";
        return;
      }
      if (!props2.schema) {
        resolvedSchemaData.value = [];
        schemaState.value = "loaded";
        return;
      }
      try {
        schemaState.value = "loading";
        const isPromise = (obj) => obj && typeof obj.then === "function";
        let result2;
        if (typeof props2.schema === "function") {
          result2 = props2.schema();
          result2 = isPromise(result2) ? await result2 : result2;
        } else {
          result2 = isPromise(props2.schema) ? await props2.schema : props2.schema;
        }
        resolvedSchemaData.value = result2;
        schemaState.value = "loaded";
      } catch (error) {
        console.error("Schema error:", error);
        schemaState.value = "error";
        resolvedSchemaData.value = [];
      }
    }
    onMounted(resolveSchema);
    function emitValue() {
      emit2("update:modelValue", internalData.value);
    }
    function deleteItem(i2) {
      internalData.value.splice(i2, 1);
      emitValue();
    }
    function addItem() {
      const defaultValues = {
        text: "",
        number: 0,
        object: {}
      };
      internalData.value.push(defaultValues[props2.type]);
      emitValue();
    }
    function toggleMinimized(index2) {
      minimizedItems.value[index2] = !minimizedItems.value[index2];
    }
    function updateItem(index2, value) {
      if (props2.type === "text" || props2.type === "number") {
        internalData.value[index2] = props2.type === "number" ? Number(value.value) : value.value;
      } else {
        internalData.value[index2] = value;
      }
      emitValue();
    }
    const isPrimitiveType = computed(() => props2.type === "text" || props2.type === "number");
    const canRenderItems = computed(
      () => isPrimitiveType.value || props2.type === "object" && resolvedSchemaData.value.length > 0
    );
    const showMinimizeButton = computed(() => {
      return resolvedSchemaData.value.length > 2 || resolvedSchemaData.value.some((schema) => schema.$el === "richtext");
    });
    return (_ctx, _cache) => {
      const _component_Icon = resolveComponent("Icon");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(props2.class)
      }, [
        _ctx.label ? (openBlock(), createElementBlock("p", _hoisted_1$L, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2$y, [
          schemaState.value !== "loaded" ? (openBlock(), createElementBlock("div", _hoisted_3$u, [
            schemaState.value === "loading" ? (openBlock(), createBlock(unref(Loading), { key: 0 })) : schemaState.value === "error" ? (openBlock(), createBlock(_component_Icon, {
              key: 1,
              icon: "error",
              color: "red"
            })) : createCommentVNode("", true)
          ])) : !canRenderItems.value ? (openBlock(), createElementBlock("div", _hoisted_4$j, _cache[0] || (_cache[0] = [
            createElementVNode("p", { class: "opacity-7" }, " No schema available ", -1)
          ]))) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(internalData.value, (item, i2) => {
              return openBlock(), createElementBlock("div", {
                key: i2,
                outline: "",
                thin: "",
                class: normalizeClass(["mb-05 itemBox transition ps-05 pb-025 pt-025 radius-05 gap-05 overflow-hidden", { minimized: minimizedItems.value[i2] }])
              }, [
                minimizedItems.value[i2] ? (openBlock(), createElementBlock("p", _hoisted_5$i, toDisplayString(_ctx.label) + " " + toDisplayString(i2 + 1), 1)) : (openBlock(), createBlock(unref(_sfc_main$T), {
                  key: 1,
                  "model-value": isPrimitiveType.value ? { value: item } : item,
                  schema: resolvedSchemaData.value,
                  "onUpdate:modelValue": (val) => updateItem(i2, val)
                }, null, 8, ["model-value", "schema", "onUpdate:modelValue"])),
                createElementVNode("div", _hoisted_6$f, [
                  showMinimizeButton.value ? (openBlock(), createBlock(unref(Btn), {
                    key: 0,
                    class: "block rotate-180 txt10 opacity-7 p-025",
                    flat: "",
                    thin: "",
                    icon: "keyboard_arrow_down",
                    onClick: ($event) => toggleMinimized(i2)
                  }, null, 8, ["onClick"])) : createCommentVNode("", true),
                  props2.delete ? (openBlock(), createBlock(unref(Btn), {
                    key: 1,
                    icon: "delete",
                    class: "txt10 opacity-7",
                    thin: "",
                    flat: "",
                    onClick: ($event) => deleteItem(i2)
                  }, null, 8, ["onClick"])) : createCommentVNode("", true)
                ])
              ], 2);
            }), 128)),
            _ctx.add ? (openBlock(), createBlock(unref(Btn), {
              key: 0,
              thin: "",
              icon: "add",
              color: "gray",
              class: "txt12 arrayAddButton",
              onClick: addItem
            }, {
              default: withCtx(() => [
                createElementVNode("p", null, toDisplayString(_ctx.label), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ], 64))
        ])
      ], 2);
    };
  }
});
const _hoisted_1$K = { class: "primary-checkbox" };
const _sfc_main$R = /* @__PURE__ */ defineComponent({
  __name: "Checkbox",
  props: {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const val = useModel(__props, "modelValue");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("label", _hoisted_1$K, [
        renderSlot(_ctx.$slots, "label", {}, void 0, true),
        withDirectives(createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => val.value = $event),
          type: "checkbox"
        }, null, 512), [
          [vModelCheckbox, val.value]
        ])
      ]);
    };
  }
});
const Checkbox = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["__scopeId", "data-v-73f1d9ad"]]);
const _hoisted_1$J = ["title"];
const _hoisted_2$x = ["id", "value", "required"];
const _hoisted_3$t = ["for"];
const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  __name: "CheckInput",
  props: /* @__PURE__ */ mergeModels({
    label: {},
    id: {},
    title: {},
    small: { type: Boolean },
    required: { type: Boolean },
    defaultValue: { default: false },
    value: {}
  }, {
    "modelValue": { default: void 0 },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const inputId = computed(() => __props.id || Math.random().toString(36).slice(7));
    const checked = useModel(__props, "modelValue");
    onMounted(() => {
      if (checked.value === void 0) checked.value = __props.defaultValue;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bagel-input bgl-checkbox align-items-center ps-025", { small: _ctx.small }]),
        title: _ctx.title
      }, [
        withDirectives(createElementVNode("input", {
          id: inputId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => checked.value = $event),
          value: _ctx.value,
          required: _ctx.required,
          type: "checkbox",
          class: "me-05"
        }, null, 8, _hoisted_2$x), [
          [vModelCheckbox, checked.value]
        ]),
        createElementVNode("label", { for: inputId.value }, [
          renderSlot(_ctx.$slots, "label", {}, () => [
            createTextVNode(toDisplayString(_ctx.label), 1)
          ], true)
        ], 8, _hoisted_3$t)
      ], 10, _hoisted_1$J);
    };
  }
});
const CheckInput = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["__scopeId", "data-v-0c86700b"]]);
const _hoisted_1$I = { class: "mb-05" };
const _hoisted_2$w = {
  key: 0,
  class: "label txt-start"
};
const _hoisted_3$s = {
  key: 1,
  class: "code-editor-wrap grid rounded p-1 overflow hm-300px ltr txt-start relative h-100p"
};
const _hoisted_4$i = { class: "overflow-hidden absolute inset-0 p-0 m-0 h-100 codeText" };
const _hoisted_5$h = ["innerHTML"];
const _hoisted_6$e = ["onKeydown"];
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "Index",
  props: {
    language: {},
    readonly: { type: Boolean, default: false },
    modelValue: { default: "" },
    autodetect: { type: Boolean },
    ignoreIllegals: { type: Boolean, default: true },
    label: {},
    height: { default: "300px" }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emit2 = __emit;
    let hljs = ref(null);
    let elHeight = ref(__props.height);
    let code = ref("");
    const textarea = ref();
    let loaded = ref(false);
    const cannotDetectLanguage = computed(() => {
      var _a;
      const lang = __props.language || "";
      return !(__props.autodetect ?? !lang) && !((_a = hljs.value) == null ? void 0 : _a.getLanguage(lang));
    });
    const className = computed(() => {
      if (cannotDetectLanguage.value) return "";
      return `hljs ${__props.language || ""}`;
    });
    const highlightedCode = computed(() => {
      var _a, _b;
      if (cannotDetectLanguage.value) {
        console.warn(`The language "${__props.language}" you specified could not be found.`);
        return escapeHtml(code.value);
      }
      const lang = __props.language || "";
      const result2 = __props.autodetect ? (_a = hljs.value) == null ? void 0 : _a.highlightAuto(code.value) : (_b = hljs.value) == null ? void 0 : _b.highlight(code.value, { language: lang, ignoreIllegals: __props.ignoreIllegals });
      return (result2 == null ? void 0 : result2.value) || "";
    });
    function escapeHtml(unsafe) {
      return unsafe.replace(/[&<>"']/g, (m2) => {
        const replacements = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;"
        };
        return replacements[m2] || "";
      });
    }
    function handleTab(event) {
      const target = event.target;
      const start = target.selectionStart;
      const tab = "  ";
      code.value = code.value.slice(0, start) + tab + code.value.slice(start);
      nextTick(() => {
        target.selectionStart = target.selectionEnd = start + tab.length;
      });
    }
    function adjustHeight() {
      var _a;
      if (((_a = textarea.value) == null ? void 0 : _a.scrollHeight) && textarea.value.scrollHeight > Number.parseInt(elHeight.value)) {
        elHeight.value = `${textarea.value.scrollHeight}px`;
      }
    }
    onMounted(async () => {
      await appendScript("https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.11.0/highlight.min.js", { id: "hljs-cdn" });
      await appendStyle("https://cdn.jsdelivr.net/npm/highlight.js/styles/atom-one-dark.min.css");
      if (window.hljs) {
        hljs.value = window.hljs;
        loaded.value = true;
      } else {
        console.error("Highlight.js failed to load.");
      }
    });
    watch(() => __props.modelValue, (newVal) => {
      adjustHeight();
      if (newVal !== code.value) {
        code.value = newVal;
      }
    }, { immediate: true });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$I, [
        _ctx.label ? (openBlock(), createElementBlock("label", _hoisted_2$w, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
        unref(loaded) ? (openBlock(), createElementBlock("div", _hoisted_3$s, [
          createElementVNode("div", {
            class: "relative block h-100",
            style: normalizeStyle({ height: `calc(${unref(elHeight)} - 2rem)` })
          }, [
            createElementVNode("pre", _hoisted_4$i, [
              _cache[2] || (_cache[2] = createTextVNode("					")),
              createElementVNode("code", {
                class: normalizeClass(["absolute inset-0", className.value]),
                innerHTML: highlightedCode.value
              }, null, 10, _hoisted_5$h),
              _cache[3] || (_cache[3] = createTextVNode("\n				"))
            ]),
            !_ctx.readonly ? withDirectives((openBlock(), createElementBlock("textarea", {
              key: 0,
              ref_key: "textarea",
              ref: textarea,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(code) ? code.value = $event : code = $event),
              class: "code-editor absolute inset-0 bg-transparent overflow-hidden h-100 p-0 m-0 codeText border-none txt-start",
              spellcheck: "false",
              placeholder: "Write your code here",
              "aria-label": "Code Editor",
              "data-gramm": "false",
              onKeydown: withKeys(withModifiers(handleTab, ["prevent"]), ["tab"]),
              onInput: _cache[1] || (_cache[1] = ($event) => emit2("update:modelValue", unref(code)))
            }, null, 40, _hoisted_6$e)), [
              [vModelText, unref(code)]
            ]) : createCommentVNode("", true)
          ], 4)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const CodeEditor = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["__scopeId", "data-v-1fbc9b61"]]);
const _hoisted_1$H = ["title"];
const _hoisted_2$v = { class: "flex bg-input rounded px-025 colorInputPickWrap" };
const _hoisted_3$r = ["id", "placeholder", "required"];
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  __name: "ColorInput",
  props: {
    label: {},
    id: {},
    placeholder: {},
    modelValue: {},
    editMode: { type: Boolean, default: true },
    small: { type: Boolean },
    required: { type: Boolean },
    nativeInputAttrs: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emits = __emit;
    const inputVal = ref(props2.modelValue);
    watch(
      () => inputVal.value,
      (newVal) => {
        emits("update:modelValue", newVal);
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bagel-input", { small: _ctx.small }]),
        title: _ctx.label
      }, [
        createElementVNode("label", null, [
          createTextVNode(toDisplayString(_ctx.label) + " ", 1),
          createElementVNode("div", _hoisted_2$v, [
            withDirectives(createElementVNode("input", mergeProps({
              id: _ctx.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => inputVal.value = $event),
              class: ["border", { "no-edit": !_ctx.editMode, "opacity-1": !inputVal.value }],
              type: "color",
              placeholder: _ctx.placeholder || _ctx.label,
              required: _ctx.required
            }, _ctx.nativeInputAttrs), null, 16, _hoisted_3$r), [
              [vModelText, inputVal.value]
            ]),
            withDirectives(createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => inputVal.value = $event),
              class: "flex-grow-4 border colorInputPick",
              style: { "width": "50px" },
              type: "text",
              placeholder: "Enter color"
            }, null, 512), [
              [vModelText, inputVal.value]
            ]),
            createVNode(unref(Btn), {
              class: normalizeClass({ "not-allowed opacity-3": !inputVal.value }),
              round: "",
              flat: "",
              thin: "",
              icon: "clear",
              onClick: _cache[2] || (_cache[2] = ($event) => inputVal.value = "")
            }, null, 8, ["class"])
          ])
        ])
      ], 10, _hoisted_1$H);
    };
  }
});
const _hoisted_1$G = ["title"];
const _hoisted_2$u = { key: 0 };
const _hoisted_3$q = {
  key: 0,
  class: "required"
};
const _hoisted_4$h = { class: "calendar-section m_border-none pe-05 m_p-0" };
const _hoisted_5$g = { class: "flex space-between pb-1" };
const _hoisted_6$d = { class: "flex gap-05" };
const _hoisted_7$b = { class: "month-year" };
const _hoisted_8$6 = {
  key: 0,
  class: "calendar-grid grid gap-025"
};
const _hoisted_9$5 = ["disabled", "onClick"];
const _hoisted_10$5 = {
  key: 1,
  class: "month-grid grid gap-05 p-05"
};
const _hoisted_11$5 = ["disabled", "onClick"];
const _hoisted_12$4 = {
  key: 2,
  class: "year-grid grid gap-05 p-0"
};
const _hoisted_13$3 = ["disabled", "onClick"];
const _hoisted_14$3 = {
  key: 0,
  class: "time-picker border-start flex column gap-1 w-120px px-025"
};
const _hoisted_15$3 = { class: "flex gap-025" };
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  __name: "DateInput",
  props: {
    required: { type: Boolean },
    label: {},
    editMode: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    enableTime: { type: Boolean, default: false },
    modelValue: {},
    min: {},
    max: {},
    mode: { default: "day" },
    defaultValue: {},
    firstDayOfWeek: { default: WEEK_START_DAY.SUNDAY },
    locale: { default: "" },
    center: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const isOpen = ref(false);
    const currentMonth = ref(/* @__PURE__ */ new Date());
    const currentView = ref("days");
    const time = new Time(props2.firstDayOfWeek, props2.locale);
    function parseDate(value) {
      if (!value) return null;
      const date2 = typeof value === "string" ? new Date(value) : value;
      return Number.isNaN(date2.getTime()) ? null : date2;
    }
    function useFormatting() {
      const formatDisplayDate = (date2) => {
        if (!date2) return "";
        return formatDate(date2, props2.enableTime ? "DD.MM.YY HH:mm" : "DD.MM.YY");
      };
      const parseUserInput = (input) => {
        const date2 = new Date(input);
        if (!Number.isNaN(date2.getTime())) {
          return date2;
        }
        const parts = input.split(/[/.-]/);
        if (parts.length === 3) {
          const [day, month, year] = parts.map((p2) => Number.parseInt(p2, 10));
          if (!Number.isNaN(day) && !Number.isNaN(month) && !Number.isNaN(year)) {
            const date22 = new Date(year, month - 1, day);
            if (date22.getFullYear() === year && date22.getMonth() === month - 1 && date22.getDate() === day) {
              return date22;
            }
          }
        }
        return null;
      };
      return {
        formatDisplayDate,
        parseUserInput
      };
    }
    function useDateValidation() {
      const isDateDisabled2 = (date2) => {
        if (!date2) return true;
        const minDate = parseDate(props2.min);
        const maxDate = parseDate(props2.max);
        if (minDate && date2 < minDate) return true;
        if (maxDate && date2 > maxDate) return true;
        return false;
      };
      const isYearDisabled2 = (year) => {
        const minDate = parseDate(props2.min);
        const maxDate = parseDate(props2.max);
        if (minDate && year < minDate.getFullYear()) return true;
        if (maxDate && year > maxDate.getFullYear()) return true;
        return false;
      };
      return {
        isDateDisabled: isDateDisabled2,
        isYearDisabled: isYearDisabled2
      };
    }
    function useDateState() {
      const { formatDisplayDate } = useFormatting();
      const formattedDisplayValue2 = computed(() => formatDisplayDate(props2.modelValue));
      const formattedMin2 = computed(() => formatDate(props2.min, props2.enableTime ? "DD.MM.YY HH:mm" : "DD.MM.YY"));
      const formattedMax2 = computed(() => formatDate(props2.max, props2.enableTime ? "DD.MM.YY HH:mm" : "DD.MM.YY"));
      const selectedDate2 = computed(() => {
        return parseDate(props2.modelValue || props2.defaultValue);
      });
      return {
        formattedDisplayValue: formattedDisplayValue2,
        formattedMin: formattedMin2,
        formattedMax: formattedMax2,
        selectedDate: selectedDate2
      };
    }
    const { isDateDisabled, isYearDisabled } = useDateValidation();
    const { formattedDisplayValue, formattedMin, formattedMax, selectedDate } = useDateState();
    function useCalendarView() {
      const currentMonthDays2 = computed(() => {
        const year = currentMonth.value.getFullYear();
        const month = currentMonth.value.getMonth();
        return time.getCalendarMonthSplitInWeeks(year, month).flat();
      });
      const currentMonthValue2 = computed(() => ({
        month: currentMonth.value.getMonth(),
        year: currentMonth.value.getFullYear(),
        formatted: {
          month: time.getLocalizedNameOfMonth(currentMonth.value, "long"),
          year: time.getLocalizedDateString(currentMonth.value).split("/").pop()
        }
      }));
      const months2 = computed(() => Array.from({ length: 12 }, (_2, i2) => {
        const date2 = new Date(currentMonthValue2.value.year, i2, 1);
        return {
          name: time.getLocalizedNameOfMonth(date2, "short"),
          value: i2,
          disabled: isDateDisabled(date2)
        };
      }));
      const years2 = computed(() => {
        const startYear = currentMonthValue2.value.year - 10;
        return Array.from({ length: 21 }, (_2, i2) => ({
          value: startYear + i2,
          disabled: isYearDisabled(startYear + i2)
        }));
      });
      const weekDays2 = computed(() => {
        const weekStart = /* @__PURE__ */ new Date();
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + (props2.firstDayOfWeek === WEEK_START_DAY.MONDAY ? 1 : 0));
        return Array.from({ length: 7 }, (_2, i2) => {
          const day = new Date(weekStart);
          day.setDate(weekStart.getDate() + i2);
          return time.getLocalizedNameOfWeekday(day, "short");
        });
      });
      const isSelected2 = (date2) => {
        if (!date2 || !selectedDate.value) return false;
        return date2.getFullYear() === selectedDate.value.getFullYear() && date2.getMonth() === selectedDate.value.getMonth() && date2.getDate() === selectedDate.value.getDate();
      };
      const isToday2 = (date2) => {
        if (!date2) return false;
        return time.dateIsToday(date2);
      };
      const isNotInMonth2 = (date2) => {
        return time.isTrailingOrLeadingDate(date2, currentMonth.value.getMonth());
      };
      return {
        currentMonthDays: currentMonthDays2,
        currentMonthValue: currentMonthValue2,
        months: months2,
        years: years2,
        weekDays: weekDays2,
        isSelected: isSelected2,
        isToday: isToday2,
        isNotInMonth: isNotInMonth2
      };
    }
    function useNavigation() {
      const selectMonth2 = (monthIndex) => {
        currentMonth.value = new Date(currentMonth.value.getFullYear(), monthIndex, 1);
        currentView.value = "days";
      };
      const selectYear2 = (year) => {
        currentMonth.value = new Date(year, currentMonth.value.getMonth(), 1);
        currentView.value = "months";
      };
      const previousMonth2 = () => {
        currentMonth.value = new Date(currentMonth.value.getFullYear(), currentMonth.value.getMonth() - 1, 1);
      };
      const nextMonth2 = () => {
        currentMonth.value = new Date(currentMonth.value.getFullYear(), currentMonth.value.getMonth() + 1, 1);
      };
      const previousYear2 = () => {
        const offset2 = currentView.value === "months" ? 1 : 21;
        currentMonth.value = new Date(currentMonth.value.getFullYear() - offset2, currentMonth.value.getMonth(), 1);
      };
      const nextYear2 = () => {
        const offset2 = currentView.value === "months" ? 1 : 21;
        currentMonth.value = new Date(currentMonth.value.getFullYear() + offset2, currentMonth.value.getMonth(), 1);
      };
      return {
        selectMonth: selectMonth2,
        selectYear: selectYear2,
        previousMonth: previousMonth2,
        nextMonth: nextMonth2,
        previousYear: previousYear2,
        nextYear: nextYear2
      };
    }
    function useTimeHandling() {
      const hours2 = computed(() => {
        var _a;
        return ((_a = selectedDate.value) == null ? void 0 : _a.getHours()) ?? 0;
      });
      const minutes2 = computed(() => {
        var _a;
        return ((_a = selectedDate.value) == null ? void 0 : _a.getMinutes()) ?? 0;
      });
      const handleHourInput2 = (value) => {
        if (!selectedDate.value) return;
        const newDate = new Date(selectedDate.value);
        newDate.setHours(value);
        emitDateValue(newDate);
      };
      const handleMinuteInput2 = (value) => {
        if (!selectedDate.value) return;
        const newDate = new Date(selectedDate.value);
        newDate.setMinutes(value);
        emitDateValue(newDate);
      };
      return {
        hours: hours2,
        minutes: minutes2,
        handleHourInput: handleHourInput2,
        handleMinuteInput: handleMinuteInput2
      };
    }
    function emitDateValue(date2) {
      if (props2.enableTime) {
        emit2("update:modelValue", formatDate(date2, "YYYY-MM-DD HH:mm"));
      } else {
        emit2("update:modelValue", formatDate(date2, "YYYY-MM-DD"));
      }
    }
    function useInputHandling() {
      const { parseUserInput } = useFormatting();
      const inputValue = ref("");
      const handleInput2 = (event) => {
        const input = event.target;
        inputValue.value = input.value;
        const date2 = parseUserInput(input.value);
        if (date2) {
          emitDateValue(date2);
        }
      };
      const handleFocus2 = (e) => {
        e.preventDefault();
        e.stopPropagation();
        isOpen.value = true;
      };
      const handleClick2 = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      const handleKeydown2 = (event) => {
        if (event.key === "Escape") {
          isOpen.value = false;
        } else if (event.key === "Enter" && inputValue.value) {
          const date2 = parseUserInput(inputValue.value);
          if (date2) {
            emitDateValue(date2);
            isOpen.value = false;
          }
        }
      };
      return {
        inputValue,
        handleInput: handleInput2,
        handleFocus: handleFocus2,
        handleClick: handleClick2,
        handleKeydown: handleKeydown2
      };
    }
    const {
      // inputValue: unused_inputValue,
      handleInput,
      handleFocus,
      handleClick,
      handleKeydown
    } = useInputHandling();
    const { currentMonthDays, currentMonthValue, months, years, weekDays, isSelected, isToday, isNotInMonth } = useCalendarView();
    const { selectMonth, selectYear, previousMonth, nextMonth, previousYear, nextYear } = useNavigation();
    const { hours, minutes, handleHourInput, handleMinuteInput } = useTimeHandling();
    function selectDate(date2) {
      var _a, _b;
      if (!date2 || !props2.editMode) return;
      if (props2.enableTime) {
        const newDate = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        const currentHours = ((_a = selectedDate.value) == null ? void 0 : _a.getHours()) ?? (/* @__PURE__ */ new Date()).getHours();
        const currentMinutes = ((_b = selectedDate.value) == null ? void 0 : _b.getMinutes()) ?? (/* @__PURE__ */ new Date()).getMinutes();
        newDate.setHours(currentHours);
        newDate.setMinutes(currentMinutes);
        emitDateValue(newDate);
      } else {
        const newDate = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        emitDateValue(newDate);
        isOpen.value = false;
      }
    }
    const datePickerRef = ref(null);
    const calendarRef = ref(null);
    onMounted(() => {
      if (selectedDate.value) {
        currentMonth.value = new Date(
          selectedDate.value.getFullYear(),
          selectedDate.value.getMonth(),
          1
        );
      }
      onClickOutside(datePickerRef.value, () => {
        isOpen.value = false;
      }, {
        ignore: () => [calendarRef.value]
      });
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bagel-input", { small: _ctx.small }]),
        title: _ctx.label,
        onFocusin: _cache[6] || (_cache[6] = //@ts-ignore
        (...args) => unref(handleFocus) && unref(handleFocus)(...args))
      }, [
        _ctx.label ? (openBlock(), createElementBlock("label", _hoisted_2$u, [
          createTextVNode(toDisplayString(_ctx.label) + " ", 1),
          _ctx.required ? (openBlock(), createElementBlock("span", _hoisted_3$q, "*")) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createVNode(unref(_sfc_main$W), {
          shown: isOpen.value,
          placement: "bottom-start",
          autoHide: false,
          triggers: ["click"]
        }, {
          trigger: withCtx(() => [
            createElementVNode("div", {
              ref_key: "datePickerRef",
              ref: datePickerRef,
              class: "date-picker-container",
              onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {
              }, ["stop"])),
              onClick: _cache[1] || (_cache[1] = withModifiers(() => {
              }, ["stop"]))
            }, [
              createVNode(unref(TextInput), {
                modelValue: unref(formattedDisplayValue),
                icon: "calendar",
                min: unref(formattedMin),
                max: unref(formattedMax),
                required: _ctx.required,
                disabled: !_ctx.editMode,
                class: normalizeClass(["date-input m-0", {
                  "txt-center": _ctx.center
                }]),
                readonly: false,
                onInput: unref(handleInput),
                onFocus: unref(handleFocus),
                onClick: unref(handleClick),
                onKeydown: unref(handleKeydown)
              }, null, 8, ["modelValue", "min", "max", "required", "disabled", "class", "onInput", "onFocus", "onClick", "onKeydown"])
            ], 544)
          ]),
          default: withCtx(() => [
            createElementVNode("div", {
              ref_key: "calendarRef",
              ref: calendarRef,
              class: "ltr flex gap-075 p-05 m_flex-wrap calendar-container justify-content-center h-100p",
              onClick: _cache[5] || (_cache[5] = withModifiers(() => {
              }, ["stop"]))
            }, [
              createElementVNode("div", _hoisted_4$h, [
                createElementVNode("div", _hoisted_5$g, [
                  currentView.value === "days" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createVNode(unref(Btn), {
                      flat: "",
                      icon: "chevron_left",
                      onClick: unref(previousMonth)
                    }, null, 8, ["onClick"]),
                    createElementVNode("div", _hoisted_6$d, [
                      createVNode(unref(Btn), {
                        flat: "",
                        class: "month-btn",
                        onClick: _cache[2] || (_cache[2] = ($event) => currentView.value = "months")
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(currentMonthValue).formatted.month), 1)
                        ]),
                        _: 1
                      }),
                      createVNode(unref(Btn), {
                        flat: "",
                        class: "year-btn",
                        onClick: _cache[3] || (_cache[3] = ($event) => currentView.value = "years")
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(currentMonthValue).formatted.year), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    createVNode(unref(Btn), {
                      flat: "",
                      icon: "chevron_right",
                      onClick: unref(nextMonth)
                    }, null, 8, ["onClick"])
                  ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createVNode(unref(Btn), {
                      flat: "",
                      icon: "chevron_left",
                      onClick: unref(previousYear)
                    }, null, 8, ["onClick"]),
                    createElementVNode("span", _hoisted_7$b, toDisplayString(unref(currentMonthValue).formatted.year), 1),
                    createVNode(unref(Btn), {
                      flat: "",
                      icon: "chevron_right",
                      onClick: unref(nextYear)
                    }, null, 8, ["onClick"])
                  ], 64))
                ]),
                currentView.value === "days" ? (openBlock(), createElementBlock("div", _hoisted_8$6, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(weekDays), (day) => {
                    return openBlock(), createElementBlock("div", {
                      key: day,
                      class: "txt-center txt-12 opacity-6"
                    }, toDisplayString(day), 1);
                  }), 128)),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(currentMonthDays), (date2) => {
                    return openBlock(), createElementBlock("button", {
                      key: date2 == null ? void 0 : date2.toISOString(),
                      type: "button",
                      class: normalizeClass(["day aspect-ratio-1 flex align-items-center justify-content-center pointer round txt14 p-0", {
                        "selected": unref(isSelected)(date2),
                        "today": unref(isToday)(date2),
                        "disabled": unref(isDateDisabled)(date2),
                        "not-in-month": unref(isNotInMonth)(date2)
                      }]),
                      disabled: unref(isDateDisabled)(date2),
                      onClick: ($event) => selectDate(date2)
                    }, toDisplayString(date2 == null ? void 0 : date2.getDate()), 11, _hoisted_9$5);
                  }), 128))
                ])) : currentView.value === "months" ? (openBlock(), createElementBlock("div", _hoisted_10$5, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(months), (month) => {
                    return openBlock(), createElementBlock("button", {
                      key: month.value,
                      class: normalizeClass(["month-item flex align-items-center justify-content-center pointer rounded p-05 txt14 border-none", {
                        selected: month.value === unref(currentMonthValue).month,
                        disabled: month.disabled
                      }]),
                      disabled: month.disabled,
                      onClick: ($event) => unref(selectMonth)(month.value)
                    }, toDisplayString(month.name), 11, _hoisted_11$5);
                  }), 128))
                ])) : (openBlock(), createElementBlock("div", _hoisted_12$4, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(years), (year) => {
                    return openBlock(), createElementBlock("button", {
                      key: year.value,
                      class: normalizeClass(["year-item flex align-items-center justify-content-center pointer rounded p-05 txt14 border-none", {
                        selected: year.value === unref(currentMonthValue).year,
                        disabled: year.disabled
                      }]),
                      disabled: year.disabled,
                      onClick: ($event) => unref(selectYear)(year.value)
                    }, toDisplayString(year.value), 11, _hoisted_13$3);
                  }), 128))
                ]))
              ]),
              _ctx.enableTime && currentView.value === "days" ? (openBlock(), createElementBlock("div", _hoisted_14$3, [
                createElementVNode("div", _hoisted_15$3, [
                  createVNode(unref(NumberInput), {
                    center: "",
                    modelValue: unref(hours),
                    disabled: !unref(selectedDate),
                    min: 0,
                    max: 23,
                    layout: "vertical",
                    padZero: 2,
                    "onUpdate:modelValue": unref(handleHourInput)
                  }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"]),
                  _cache[7] || (_cache[7] = createElementVNode("p", { class: "pb-075" }, " : ", -1)),
                  createVNode(unref(NumberInput), {
                    center: "",
                    modelValue: unref(minutes),
                    disabled: !unref(selectedDate),
                    min: 0,
                    max: 59,
                    padZero: 2,
                    layout: "vertical",
                    "onUpdate:modelValue": unref(handleMinuteInput)
                  }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"])
                ]),
                unref(selectedDate) ? (openBlock(), createBlock(unref(Btn), {
                  key: 0,
                  flat: "",
                  onClick: _cache[4] || (_cache[4] = ($event) => isOpen.value = false)
                }, {
                  default: withCtx(() => _cache[8] || (_cache[8] = [
                    createTextVNode(" Done ")
                  ])),
                  _: 1
                })) : createCommentVNode("", true)
              ])) : createCommentVNode("", true)
            ], 512)
          ]),
          _: 1
        }, 8, ["shown"])
      ], 42, _hoisted_1$G);
    };
  }
});
const DateInput = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["__scopeId", "data-v-7d6fb8a5"]]);
const _hoisted_1$F = ["title"];
const _hoisted_2$t = { key: 0 };
const _hoisted_3$p = {
  key: 0,
  class: "required"
};
const _hoisted_4$g = { class: "date-picker-container" };
const _hoisted_5$f = ["value", "min", "max", "required", "disabled"];
const _hoisted_6$c = { class: "flex gap-075 p-05 m_flex-wrap calendar-container justify-content-center h-100p" };
const _hoisted_7$a = { class: "calendar-section m_border-none pe-05 m_p-0" };
const _hoisted_8$5 = { class: "flex space-between pb-1" };
const _hoisted_9$4 = { class: "flex gap-05" };
const _hoisted_10$4 = { class: "month-year" };
const _hoisted_11$4 = {
  key: 0,
  class: "calendar-grid grid gap-025"
};
const _hoisted_12$3 = ["disabled", "onClick"];
const _hoisted_13$2 = {
  key: 1,
  class: "month-grid grid gap-05 p-05"
};
const _hoisted_14$2 = ["disabled", "onClick"];
const _hoisted_15$2 = {
  key: 2,
  class: "year-grid grid gap-05 p-0"
};
const _hoisted_16$2 = ["disabled", "onClick"];
const _hoisted_17$2 = {
  key: 0,
  class: "time-picker border-start flex column gap-1 w-120px"
};
const _hoisted_18 = { class: "flex gap-025" };
const _hoisted_19 = { class: "txt-center opacity-6 txt14" };
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  __name: "DatePick",
  props: {
    required: { type: Boolean },
    label: {},
    editMode: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    enableTime: { type: Boolean, default: false },
    modelValue: {},
    min: {},
    max: {},
    timezone: { default: "UTC" },
    mode: { default: "day" },
    firstDayOfWeek: { default: WEEK_START_DAY.MONDAY },
    locale: { default: "" },
    center: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    let isOpen = ref(false);
    let currentMonth = ref(/* @__PURE__ */ new Date());
    let currentView = ref("days");
    const time = new Time(props2.firstDayOfWeek, props2.locale);
    function formatDisplayDate(date2) {
      if (!date2) return "";
      console.log("date", date2);
      return formatDate(date2, props2.enableTime ? "DD.MM.YY HH:mm" : "DD.MM.YY", props2.locale);
    }
    const formattedDisplayValue = computed(() => formatDisplayDate(props2.modelValue));
    const formattedMin = computed(() => formatDate(props2.min, props2.enableTime ? "DD.MM.YY HH:mm" : "DD.MM.YY"));
    const formattedMax = computed(() => formatDate(props2.max, props2.enableTime ? "DD.MM.YY HH:mm" : "DD.MM.YY"));
    const selectedDate = computed(() => {
      if (!props2.modelValue) return null;
      return typeof props2.modelValue === "string" ? new Date(props2.modelValue) : props2.modelValue;
    });
    const currentMonthDays = computed(() => {
      const year = currentMonth.value.getFullYear();
      const month = currentMonth.value.getMonth();
      return time.getCalendarMonthSplitInWeeks(year, month).flat();
    });
    const currentMonthValue = computed(() => ({
      month: currentMonth.value.getMonth(),
      year: currentMonth.value.getFullYear(),
      formatted: {
        month: time.getLocalizedNameOfMonth(currentMonth.value, "long"),
        year: time.getLocalizedDateString(currentMonth.value).split("/").pop()
        // Get just the year part
      }
    }));
    const months = computed(() => Array.from({ length: 12 }, (_2, i2) => {
      const date2 = new Date(currentMonthValue.value.year, i2, 1);
      return {
        name: time.getLocalizedNameOfMonth(date2, "short"),
        value: i2,
        disabled: isDateDisabled(date2)
      };
    }));
    const years = computed(() => {
      const startYear = currentMonthValue.value.year - 10;
      return Array.from({ length: 21 }, (_2, i2) => ({
        value: startYear + i2,
        disabled: isYearDisabled(startYear + i2)
      }));
    });
    const weekDays = computed(() => {
      const weekStart = /* @__PURE__ */ new Date();
      weekStart.setDate(weekStart.getDate() - weekStart.getDay() + (props2.firstDayOfWeek === WEEK_START_DAY.MONDAY ? 1 : 0));
      return Array.from({ length: 7 }, (_2, i2) => {
        const day = new Date(weekStart);
        day.setDate(weekStart.getDate() + i2);
        return time.getLocalizedNameOfWeekday(day, "short");
      });
    });
    function isDateDisabled(date2) {
      if (!date2) return true;
      const minDate = props2.min ? new Date(props2.min) : null;
      const maxDate = props2.max ? new Date(props2.max) : null;
      if (minDate && date2 < minDate) return true;
      if (maxDate && date2 > maxDate) return true;
      return false;
    }
    function isYearDisabled(year) {
      const minDate = props2.min ? new Date(props2.min) : null;
      const maxDate = props2.max ? new Date(props2.max) : null;
      if (minDate && year < minDate.getFullYear()) return true;
      if (maxDate && year > maxDate.getFullYear()) return true;
      return false;
    }
    function selectMonth(monthIndex) {
      currentMonth.value = new Date(currentMonth.value.getFullYear(), monthIndex, 1);
      currentView.value = "days";
    }
    function selectYear(year) {
      currentMonth.value = new Date(year, currentMonth.value.getMonth(), 1);
      currentView.value = "months";
    }
    function previousMonth() {
      currentMonth.value = new Date(currentMonth.value.getFullYear(), currentMonth.value.getMonth() - 1, 1);
    }
    function nextMonth() {
      currentMonth.value = new Date(currentMonth.value.getFullYear(), currentMonth.value.getMonth() + 1, 1);
    }
    function previousYear() {
      const offset2 = currentView.value === "months" ? 1 : 21;
      currentMonth.value = new Date(currentMonth.value.getFullYear() - offset2, currentMonth.value.getMonth(), 1);
    }
    function nextYear() {
      const offset2 = currentView.value === "months" ? 1 : 21;
      currentMonth.value = new Date(currentMonth.value.getFullYear() + offset2, currentMonth.value.getMonth(), 1);
    }
    function selectDate(date2) {
      var _a, _b;
      if (!date2 || !props2.editMode) return;
      const newDate = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate(), 0, 0, 0);
      if (props2.enableTime) {
        const currentHours = ((_a = selectedDate.value) == null ? void 0 : _a.getHours()) ?? (/* @__PURE__ */ new Date()).getHours();
        const currentMinutes = ((_b = selectedDate.value) == null ? void 0 : _b.getMinutes()) ?? (/* @__PURE__ */ new Date()).getMinutes();
        newDate.setHours(currentHours);
        newDate.setMinutes(currentMinutes);
      } else {
        isOpen.value = false;
      }
      emit2("update:modelValue", newDate);
    }
    const hours = computed(() => {
      var _a;
      return ((_a = selectedDate.value) == null ? void 0 : _a.getHours()) ?? 0;
    });
    const minutes = computed(() => {
      var _a;
      return ((_a = selectedDate.value) == null ? void 0 : _a.getMinutes()) ?? 0;
    });
    function handleHourInput(value) {
      if (!selectedDate.value) return;
      const newDate = new Date(selectedDate.value);
      newDate.setHours(value);
      emit2("update:modelValue", newDate.toISOString());
    }
    function handleMinuteInput(value) {
      if (!selectedDate.value) return;
      const newDate = new Date(selectedDate.value);
      newDate.setMinutes(value);
      emit2("update:modelValue", newDate.toISOString());
    }
    function isSelected(date2) {
      if (!date2 || !selectedDate.value) return false;
      return date2.toISOString().split("T")[0] === selectedDate.value.toISOString().split("T")[0];
    }
    function isToday(date2) {
      if (!date2) return false;
      return time.dateIsToday(date2);
    }
    const timezoneDisplay = computed(() => {
      if (!props2.enableTime) return "";
      try {
        return (/* @__PURE__ */ new Date()).toLocaleString("en-US", {
          timeZoneName: "short",
          timeZone: props2.timezone
        }).split(" ").pop();
      } catch {
        return "UTC";
      }
    });
    function isNotInMonth(date2) {
      return time.isTrailingOrLeadingDate(date2, currentMonth.value.getMonth());
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bagel-input", { small: _ctx.small }]),
        title: _ctx.label
      }, [
        _ctx.label ? (openBlock(), createElementBlock("label", _hoisted_2$t, [
          createTextVNode(toDisplayString(_ctx.label) + " ", 1),
          _ctx.required ? (openBlock(), createElementBlock("span", _hoisted_3$p, "*")) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createVNode(unref(_sfc_main$W), {
          shown: unref(isOpen),
          placement: "bottom-start",
          onApplyShow: _cache[4] || (_cache[4] = ($event) => isRef(isOpen) ? isOpen.value = true : isOpen = true),
          onApplyHide: _cache[5] || (_cache[5] = ($event) => isRef(isOpen) ? isOpen.value = false : isOpen = false)
        }, {
          trigger: withCtx(() => [
            createElementVNode("div", _hoisted_4$g, [
              createElementVNode("input", {
                type: "text",
                value: formattedDisplayValue.value,
                min: formattedMin.value,
                max: formattedMax.value,
                required: _ctx.required,
                disabled: !_ctx.editMode,
                class: normalizeClass(["date-input", {
                  "txt-center": _ctx.center
                }]),
                readonly: "",
                onClick: _cache[0] || (_cache[0] = ($event) => isRef(isOpen) ? isOpen.value = true : isOpen = true)
              }, null, 10, _hoisted_5$f)
            ])
          ]),
          default: withCtx(() => [
            createElementVNode("div", _hoisted_6$c, [
              createElementVNode("div", _hoisted_7$a, [
                createElementVNode("div", _hoisted_8$5, [
                  unref(currentView) === "days" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createVNode(unref(Btn), {
                      flat: "",
                      icon: "chevron_left",
                      onClick: previousMonth
                    }),
                    createElementVNode("div", _hoisted_9$4, [
                      createVNode(unref(Btn), {
                        flat: "",
                        class: "month-btn",
                        onClick: _cache[1] || (_cache[1] = ($event) => isRef(currentView) ? currentView.value = "months" : currentView = "months")
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(currentMonthValue.value.formatted.month), 1)
                        ]),
                        _: 1
                      }),
                      createVNode(unref(Btn), {
                        flat: "",
                        class: "year-btn",
                        onClick: _cache[2] || (_cache[2] = ($event) => isRef(currentView) ? currentView.value = "years" : currentView = "years")
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(currentMonthValue.value.formatted.year), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    createVNode(unref(Btn), {
                      flat: "",
                      icon: "chevron_right",
                      onClick: nextMonth
                    })
                  ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createVNode(unref(Btn), {
                      flat: "",
                      icon: "chevron_left",
                      onClick: previousYear
                    }),
                    createElementVNode("span", _hoisted_10$4, toDisplayString(currentMonthValue.value.formatted.year), 1),
                    createVNode(unref(Btn), {
                      flat: "",
                      icon: "chevron_right",
                      onClick: nextYear
                    })
                  ], 64))
                ]),
                unref(currentView) === "days" ? (openBlock(), createElementBlock("div", _hoisted_11$4, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(weekDays.value, (day) => {
                    return openBlock(), createElementBlock("div", {
                      key: day,
                      class: "txt-center txt-12 opacity-6"
                    }, toDisplayString(day), 1);
                  }), 128)),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(currentMonthDays.value, (date2) => {
                    return openBlock(), createElementBlock("button", {
                      key: date2 == null ? void 0 : date2.toISOString(),
                      type: "button",
                      class: normalizeClass(["day aspect-ratio-1 flex align-items-center justify-content-center pointer round txt14 p-0", {
                        "selected": isSelected(date2),
                        "today": isToday(date2),
                        "disabled": isDateDisabled(date2),
                        "not-in-month": isNotInMonth(date2)
                      }]),
                      disabled: isDateDisabled(date2),
                      onClick: ($event) => selectDate(date2)
                    }, toDisplayString(date2 == null ? void 0 : date2.getDate()), 11, _hoisted_12$3);
                  }), 128))
                ])) : unref(currentView) === "months" ? (openBlock(), createElementBlock("div", _hoisted_13$2, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(months.value, (month) => {
                    return openBlock(), createElementBlock("button", {
                      key: month.value,
                      class: normalizeClass(["month-item flex align-items-center justify-content-center pointer rounded p-05 txt14 border-none", {
                        selected: month.value === currentMonthValue.value.month,
                        disabled: month.disabled
                      }]),
                      disabled: month.disabled,
                      onClick: ($event) => selectMonth(month.value)
                    }, toDisplayString(month.name), 11, _hoisted_14$2);
                  }), 128))
                ])) : (openBlock(), createElementBlock("div", _hoisted_15$2, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(years.value, (year) => {
                    return openBlock(), createElementBlock("button", {
                      key: year.value,
                      class: normalizeClass(["year-item flex align-items-center justify-content-center pointer rounded p-05 txt14 border-none", {
                        selected: year.value === currentMonthValue.value.year,
                        disabled: year.disabled
                      }]),
                      disabled: year.disabled,
                      onClick: ($event) => selectYear(year.value)
                    }, toDisplayString(year.value), 11, _hoisted_16$2);
                  }), 128))
                ]))
              ]),
              _ctx.enableTime && unref(currentView) === "days" ? (openBlock(), createElementBlock("div", _hoisted_17$2, [
                createElementVNode("div", _hoisted_18, [
                  createVNode(unref(NumberInput), {
                    center: "",
                    "model-value": hours.value,
                    disabled: !selectedDate.value,
                    min: 0,
                    max: 23,
                    layout: "vertical",
                    padZero: 2,
                    "onUpdate:modelValue": handleHourInput
                  }, null, 8, ["model-value", "disabled"]),
                  _cache[6] || (_cache[6] = createElementVNode("p", { class: "pb-075" }, " : ", -1)),
                  createVNode(unref(NumberInput), {
                    center: "",
                    "model-value": minutes.value,
                    disabled: !selectedDate.value,
                    min: 0,
                    max: 59,
                    padZero: 2,
                    layout: "vertical",
                    "onUpdate:modelValue": handleMinuteInput
                  }, null, 8, ["model-value", "disabled"])
                ]),
                createElementVNode("span", _hoisted_19, toDisplayString(timezoneDisplay.value), 1),
                selectedDate.value ? (openBlock(), createBlock(unref(Btn), {
                  key: 0,
                  flat: "",
                  onClick: _cache[3] || (_cache[3] = ($event) => isRef(isOpen) ? isOpen.value = false : isOpen = false)
                }, {
                  default: withCtx(() => _cache[7] || (_cache[7] = [
                    createTextVNode(" Done ")
                  ])),
                  _: 1
                })) : createCommentVNode("", true)
              ])) : createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["shown"])
      ], 10, _hoisted_1$F);
    };
  }
});
const DatePick = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["__scopeId", "data-v-43cb2e62"]]);
const _hoisted_1$E = { class: "datetime-wrap" };
const _hoisted_2$s = {
  key: 0,
  class: "time-wrap"
};
const _hoisted_3$o = ["id", "name", "value"];
const _hoisted_4$f = ["for"];
const _sfc_main$L = /* @__PURE__ */ defineComponent({
  __name: "DatePicker",
  props: {
    label: {},
    id: {},
    options: {},
    showTimeWrap: { type: Boolean },
    modelValue: {},
    allowedDates: {},
    disabledDates: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const selectedHour = ref();
    const hours = Array.from({ length: 18 }, (_2, index2) => {
      const hour = Math.floor(index2 / 2) + 9;
      const minute = index2 % 2 === 0 ? "00" : "30";
      return `${hour}:${minute}`;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$E, [
        _ctx.showTimeWrap ? (openBlock(), createElementBlock("div", _hoisted_2$s, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(hours), (hr) => {
            return openBlock(), createElementBlock(Fragment, { key: hr }, [
              withDirectives(createElementVNode("input", {
                id: `${hr}_${_ctx.id}`,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectedHour.value = $event),
                type: "radio",
                name: _ctx.label,
                value: hr
              }, null, 8, _hoisted_3$o), [
                [vModelRadio, selectedHour.value]
              ]),
              createElementVNode("label", {
                for: `${hr}_${_ctx.id}`
              }, toDisplayString(hr), 9, _hoisted_4$f)
            ], 64);
          }), 128))
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const _hoisted_1$D = { class: "bagel-input" };
const _hoisted_2$r = {
  key: 0,
  placeholder: "required",
  type: "text",
  required: "",
  class: "pixel"
};
const _hoisted_3$n = { class: "m-05 flex opacity-7 z-99" };
const _hoisted_4$e = { class: "ellipsis-1 word-break-all h-20 m-0 color-black" };
const _hoisted_5$e = { class: "flex gap-025 rounded pe-1 ps-05 py-025 bg-gray-80 -my-1" };
const _hoisted_6$b = { class: "ellipsis-1 word-break-all h-20 m-0 color-black txt16" };
const _hoisted_7$9 = {
  key: 1,
  class: "txt-gray txt-12"
};
const _hoisted_8$4 = {
  key: 0,
  class: "bgl-multi-preview"
};
const _hoisted_9$3 = { class: "m-0" };
const _hoisted_10$3 = { class: "no-margin multi-preview-txt" };
const _hoisted_11$3 = {
  key: 0,
  class: "progress"
};
const _hoisted_12$2 = {
  key: 1,
  class: "bgl-single-preview"
};
const _hoisted_13$1 = { class: "position-start m-05 flex opacity-7 z-99 gap-025" };
const _hoisted_14$1 = {
  key: 0,
  class: "h-100"
};
const _hoisted_15$1 = {
  key: 0,
  class: "progress"
};
const _hoisted_16$1 = { class: "p-1 flex column hover fileUploadPlaceHolder justify-content-center mb-05" };
const _hoisted_17$1 = { class: "pretty balance" };
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "FileUpload",
  props: /* @__PURE__ */ mergeModels({
    label: {},
    multiple: { type: Boolean },
    files: {},
    bindkey: { default: "id" },
    modelValue: {},
    width: {},
    height: { default: "215px" },
    topic: {},
    fill: { type: Boolean },
    oval: { type: Boolean },
    theme: { default: "dropzone" },
    accept: { default: "*" },
    required: { type: Boolean },
    disabled: { type: Boolean },
    dropPlaceholder: {},
    noFilePlaceholder: {},
    btnPlaceholder: {}
  }, {
    "modelValue": {
      default: () => []
    },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["update:modelValue", "addFileStart"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    const emit2 = __emit;
    const bindKey2 = __props.bindkey;
    const bagel = useBagel();
    const isImage = (str) => IMAGE_FORMATS_REGEXP.test(str);
    const file_bindkeys = useModel(__props, "modelValue");
    const storageFiles = ref([]);
    async function fetchTopicFiles() {
      const files2 = await bagel.get(`/files?topic=${__props.topic}`);
      storageFiles.value.push(...files2);
    }
    function loadFiles() {
      const ids = [file_bindkeys.value].flat().filter(Boolean);
      if (!ids.length) {
        storageFiles.value.splice(0, storageFiles.value.length);
        return;
      }
      const currentIds = storageFiles.value.map((file) => file[bindKey2]);
      const idsToAdd = ids.filter((id) => !currentIds.includes(id));
      const idsToRemove = currentIds.filter((id) => typeof id === "string" && !ids.includes(id));
      idsToRemove.forEach((id) => {
        const index2 = storageFiles.value.findIndex((file) => file[bindKey2] === id);
        if (index2 !== -1) storageFiles.value.splice(index2, 1);
      });
      if (bindKey2 === "url") {
        idsToAdd.forEach((url) => {
          storageFiles.value.push({ url });
        });
        return;
      }
      if (__props.multiple) {
        idsToAdd.forEach((id) => {
          void bagel.get(`/files/${id}`).then((file) => {
            storageFiles.value.push(file);
          }).catch(console.error);
        });
      } else {
        void bagel.get(`/files/${idsToAdd[0]}`).then((file) => {
          storageFiles.value.push(file);
        }).catch(console.error);
      }
    }
    onMounted(() => {
      if (__props.topic) fetchTopicFiles();
      if (!__props.files && [file_bindkeys.value].flat().length > 0) {
        loadFiles();
      }
    });
    watch(() => __props.topic, fetchTopicFiles);
    watch(() => __props.modelValue, loadFiles);
    watch(
      () => __props.files,
      (newFiles) => {
        if (newFiles) {
          const filesToAdd = [newFiles].flat().filter((f2) => !storageFiles.value.some((sf) => sf[bindKey2] === f2[bindKey2]));
          for (const file of filesToAdd) {
            storageFiles.value.push(file);
          }
        }
      },
      { immediate: true }
    );
    function compareLists(a2, b2) {
      return [a2].flat().every((id) => [b2].flat().includes(id)) && [b2].flat().every((id) => [a2].flat().includes(id));
    }
    function updateModelValue() {
      let idValue;
      if (__props.multiple) {
        idValue = storageFiles.value.map((f2) => f2[bindKey2]);
      } else {
        idValue = storageFiles.value[0][bindKey2] || "";
      }
      const isSame = compareLists(file_bindkeys.value, idValue);
      if (!isSame) {
        file_bindkeys.value = idValue;
      }
    }
    const fileQueue = ref([]);
    let isDragOver = ref(false);
    function preventDefault(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const fileToUrl = (file) => URL.createObjectURL(file);
    function removeFile(file) {
      const index2 = storageFiles.value.indexOf(file);
      storageFiles.value.splice(index2, 1);
      void bagel.delete(`/static_files/${file.id}`);
      updateModelValue();
    }
    async function flushQueue() {
      emit2("addFileStart");
      for (const file of fileQueue.value) {
        file.uploading = true;
        if (!__props.multiple) storageFiles.value.splice(0, 1);
        const serverFile = await bagel.uploadFile(file.file, {
          onUploadProgress: (e) => file.progress = e.progress * 100 - 1,
          topic: __props.topic
        });
        storageFiles.value.push(serverFile);
      }
      fileQueue.value.splice(0, fileQueue.value.length);
      updateModelValue();
    }
    function browse() {
      if (__props.disabled) return;
      const input = document.createElement("input");
      input.type = "file";
      input.multiple = __props.multiple;
      input.accept = __props.accept;
      input.onchange = (e) => {
        const target = e.target;
        if (target.files) {
          const files2 = Array.from(target.files);
          for (const file of files2) {
            fileQueue.value.push({ name: file.name, file, progress: 0 });
          }
        }
        flushQueue();
      };
      console.log(fileQueue.value);
      input.click();
    }
    function dragleave(e) {
      preventDefault(e);
      if (e.dataTransfer) isDragOver.value = false;
      else isDragOver.value = false;
    }
    function dragover(e) {
      if (__props.disabled) return;
      preventDefault(e);
      if (e.dataTransfer) isDragOver.value = true;
      else isDragOver.value = false;
    }
    function drop3(e) {
      if (__props.disabled) return;
      preventDefault(e);
      if (e.dataTransfer) {
        Array.from(e.dataTransfer.files).forEach(
          (file) => fileQueue.value.push({ name: file.name, file, progress: 0 })
        );
      }
      isDragOver.value = false;
      flushQueue();
    }
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      const _directive_lightbox = resolveDirective("lightbox");
      return openBlock(), createElementBlock("div", _hoisted_1$D, [
        createElementVNode("label", null, toDisplayString(_ctx.label), 1),
        _ctx.required && !storageFiles.value.length ? (openBlock(), createElementBlock("input", _hoisted_2$r)) : createCommentVNode("", true),
        _ctx.theme === "basic" ? (openBlock(), createBlock(unref(_sfc_main$10), {
          key: 1,
          outline: "",
          class: "flex p-05 gap-1",
          onDragover: dragover,
          onDrop: drop3
        }, {
          default: withCtx(() => [
            !storageFiles.value.length && !fileQueue.value.length ? (openBlock(), createBlock(unref(Btn), {
              key: 0,
              class: "px-1-5",
              icon: "upload",
              outline: "",
              value: _ctx.btnPlaceholder || "Upload",
              onClick: browse
            }, null, 8, ["value"])) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(storageFiles.value, (file) => {
              return openBlock(), createElementBlock("div", {
                key: file.id,
                class: "txt-gray txt-12 flex"
              }, [
                createElementVNode("div", _hoisted_3$n, [
                  withDirectives(createVNode(unref(Btn), {
                    color: "gray",
                    thin: "",
                    icon: "delete",
                    onClick: withModifiers(($event) => removeFile(file), ["stop"])
                  }, null, 8, ["onClick"]), [
                    [_directive_tooltip, "Delete"]
                  ]),
                  withDirectives(createVNode(unref(Btn), {
                    color: "gray",
                    thin: "",
                    icon: "autorenew",
                    onClick: browse
                  }, null, 512), [
                    [_directive_tooltip, "Replace"]
                  ]),
                  withDirectives(createVNode(unref(Btn), {
                    href: file.url,
                    download: file.name,
                    color: "gray",
                    thin: "",
                    icon: "download",
                    target: "_blank",
                    onClick: _cache[0] || (_cache[0] = withModifiers(() => {
                    }, ["stop"]))
                  }, null, 8, ["href", "download"]), [
                    [_directive_tooltip, "Download"]
                  ]),
                  withDirectives((openBlock(), createElementBlock("p", _hoisted_4$e, [
                    createTextVNode(toDisplayString(file.name), 1)
                  ])), [
                    [_directive_lightbox, { src: file.url, download: true }]
                  ]),
                  createElementVNode("div", _hoisted_5$e, [
                    createVNode(unref(_sfc_main$s), {
                      icon: "draft",
                      size: 1.5
                    }),
                    withDirectives((openBlock(), createElementBlock("p", _hoisted_6$b, [
                      createTextVNode(toDisplayString(file.name), 1)
                    ])), [
                      [_directive_lightbox, { src: file.url, download: true }]
                    ])
                  ]),
                  createVNode(unref(Btn), {
                    thin: "",
                    flat: "",
                    icon: "delete",
                    color: "red",
                    onClick: withModifiers(($event) => removeFile(file), ["stop"])
                  }, null, 8, ["onClick"])
                ])
              ]);
            }), 128)),
            !storageFiles.value.length && !fileQueue.value.length ? (openBlock(), createElementBlock("span", _hoisted_7$9, toDisplayString(_ctx.noFilePlaceholder || "No file selected"), 1)) : createCommentVNode("", true)
          ]),
          _: 1
        })) : (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(["fileUploadWrap", {
            "fileDropZone": !storageFiles.value.length && !fileQueue.value.length,
            "dragover": unref(isDragOver),
            "bgl_oval-upload": _ctx.oval
          }]),
          style: normalizeStyle({ width: _ctx.width, height: _ctx.height }),
          onClick: browse,
          onDragover: dragover,
          onDrop: drop3,
          onDragleave: dragleave
        }, [
          renderSlot(_ctx.$slots, "files", {
            files: storageFiles.value,
            fileQueue: fileQueue.value
          }, () => [
            _ctx.multiple ? (openBlock(), createElementBlock("div", _hoisted_8$4, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(storageFiles.value, (file) => {
                return withDirectives((openBlock(), createElementBlock("div", {
                  key: file.id,
                  class: "multi-image-item-preview"
                }, [
                  isImage(file.extension || file.url) ? (openBlock(), createBlock(unref(Image$1), {
                    key: 0,
                    class: "multi-preview",
                    src: file.url,
                    alt: ""
                  }, null, 8, ["src"])) : (openBlock(), createBlock(unref(_sfc_main$s), {
                    key: 1,
                    icon: "draft",
                    class: "multi-preview"
                  })),
                  createElementVNode("p", _hoisted_9$3, toDisplayString(file.name), 1),
                  createVNode(unref(Btn), {
                    thin: "",
                    flat: "",
                    icon: "delete",
                    color: "red",
                    onClick: withModifiers(($event) => removeFile(file), ["stop"])
                  }, null, 8, ["onClick"])
                ])), [
                  [_directive_lightbox, { src: file.url, download: true }]
                ]);
              }), 128)),
              (openBlock(true), createElementBlock(Fragment, null, renderList(fileQueue.value, (fileQ) => {
                return openBlock(), createElementBlock("div", {
                  key: fileQ.file.name,
                  class: "multi-image-item-preview"
                }, [
                  isImage(fileQ.file.type) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    _ctx.multiple ? (openBlock(), createBlock(unref(Image$1), {
                      key: 0,
                      width: _ctx.width || "220",
                      class: "multi-preview",
                      src: fileToUrl(fileQ.file),
                      alt: ""
                    }, null, 8, ["width", "src"])) : createCommentVNode("", true)
                  ], 64)) : (openBlock(), createBlock(unref(_sfc_main$s), {
                    key: 1,
                    icon: "draft",
                    class: "multi-preview"
                  })),
                  createElementVNode("p", _hoisted_10$3, toDisplayString(fileQ.name), 1),
                  createElementVNode("div", {
                    class: normalizeClass(["pie", { complete: fileQ.progress === 100 }]),
                    style: normalizeStyle([`--p:${fileQ.progress}`, { "--b": "2px" }])
                  }, [
                    fileQ.progress < 100 ? (openBlock(), createElementBlock("span", _hoisted_11$3, toDisplayString(`${fileQ.progress.toFixed(0)}`), 1)) : createCommentVNode("", true),
                    createVNode(unref(_sfc_main$s), {
                      class: "success",
                      icon: "check"
                    })
                  ], 6)
                ]);
              }), 128))
            ])) : createCommentVNode("", true),
            !_ctx.multiple && (storageFiles.value.length > 0 || fileQueue.value.length > 0) ? (openBlock(), createElementBlock("div", _hoisted_12$2, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(storageFiles.value, (file) => {
                return openBlock(), createElementBlock("div", {
                  key: file.id,
                  class: normalizeClass(["single-image-item-preview", { "bgl_fill-image": _ctx.fill }])
                }, [
                  createElementVNode("div", _hoisted_13$1, [
                    withDirectives(createVNode(unref(Btn), {
                      color: "gray",
                      thin: "",
                      icon: "delete",
                      onClick: withModifiers(($event) => removeFile(file), ["stop"])
                    }, null, 8, ["onClick"]), [
                      [_directive_tooltip, "Delete"]
                    ]),
                    withDirectives(createVNode(unref(Btn), {
                      color: "gray",
                      thin: "",
                      icon: "autorenew",
                      onClick: browse
                    }, null, 512), [
                      [_directive_tooltip, "Replace"]
                    ]),
                    withDirectives(createVNode(unref(Btn), {
                      href: file.url,
                      download: file.name,
                      color: "gray",
                      thin: "",
                      icon: "download",
                      target: "_blank",
                      onClick: _cache[1] || (_cache[1] = withModifiers(() => {
                      }, ["stop"]))
                    }, null, 8, ["href", "download"]), [
                      [_directive_tooltip, "Download"]
                    ])
                  ]),
                  isImage(file.extension || file.url) ? (openBlock(), createElementBlock("div", _hoisted_14$1, [
                    withDirectives(createVNode(unref(Image$1), {
                      class: "single-preview",
                      src: file.url,
                      alt: ""
                    }, null, 8, ["src"]), [
                      [_directive_lightbox, { src: file.url, download: true }]
                    ])
                  ])) : withDirectives((openBlock(), createBlock(unref(_sfc_main$s), {
                    key: 1,
                    size: 4,
                    weight: "2",
                    icon: "draft",
                    class: "color-primary w-100"
                  }, null, 512)), [
                    [_directive_lightbox, { src: file.url, download: true }]
                  ])
                ], 2);
              }), 128)),
              (openBlock(true), createElementBlock(Fragment, null, renderList(fileQueue.value, (fileQ) => {
                return openBlock(), createElementBlock("div", {
                  key: fileQ.file.name,
                  class: normalizeClass(["single-image-item-preview", { "bgl_fill-image": _ctx.fill }])
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(["pie", { complete: fileQ.progress === 100 }]),
                    style: normalizeStyle([`--p:${fileQ.progress}`, { "--b": "2px" }])
                  }, [
                    fileQ.progress < 100 ? (openBlock(), createElementBlock("span", _hoisted_15$1, toDisplayString(`${fileQ.progress.toFixed(0)}`), 1)) : createCommentVNode("", true),
                    createVNode(unref(_sfc_main$s), {
                      class: "success",
                      icon: "check"
                    })
                  ], 6),
                  isImage(fileQ.file.type) ? withDirectives((openBlock(), createBlock(unref(Image$1), {
                    key: 0,
                    class: "single-preview",
                    src: fileToUrl(fileQ.file),
                    alt: ""
                  }, null, 8, ["src"])), [
                    [_directive_lightbox, { src: fileToUrl(fileQ.file), download: true }]
                  ]) : createCommentVNode("", true)
                ], 2);
              }), 128))
            ])) : createCommentVNode("", true)
          ], true),
          !storageFiles.value.length && !fileQueue.value.length || _ctx.multiple ? renderSlot(_ctx.$slots, "placeholder", {
            key: 0,
            files: storageFiles.value,
            fileQueue: fileQueue.value,
            browse
          }, () => [
            createElementVNode("p", _hoisted_16$1, [
              createVNode(unref(_sfc_main$s), { icon: "upload_2" }),
              createElementVNode("span", _hoisted_17$1, toDisplayString(_ctx.dropPlaceholder || "Drag and Drop files here or click to upload"), 1)
            ])
          ], true) : createCommentVNode("", true)
        ], 38))
      ]);
    };
  }
});
const FileUpload = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["__scopeId", "data-v-50fd0597"]]);
const _hoisted_1$C = ["title"];
const _hoisted_2$q = { key: 0 };
const _hoisted_3$m = ["value", "placeholder"];
const _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "JSONInput",
  props: {
    description: { default: "" },
    label: { default: "" },
    modelValue: {},
    placeholder: { default: "" },
    editMode: { type: Boolean, default: true },
    small: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emits = __emit;
    function handleInput(e) {
      const el = e.target;
      emits("update:modelValue", el.value);
    }
    return (_ctx, _cache) => {
      const _component_LangText = resolveComponent("LangText");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bagel-input", { small: _ctx.small }]),
        title: _ctx.description
      }, [
        _ctx.label ? (openBlock(), createElementBlock("label", _hoisted_2$q, [
          createVNode(_component_LangText, { input: _ctx.label }, null, 8, ["input"])
        ])) : createCommentVNode("", true),
        createElementVNode("textarea", {
          value: _ctx.modelValue,
          class: normalizeClass({ "no-edit": !_ctx.editMode }),
          placeholder: _ctx.placeholder,
          onInput: handleInput
        }, null, 42, _hoisted_3$m)
      ], 10, _hoisted_1$C);
    };
  }
});
const JSONInput = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["__scopeId", "data-v-1cbaeab2"]]);
const _hoisted_1$B = ["for"];
const _hoisted_2$p = {
  key: 0,
  class: "block"
};
const _hoisted_3$l = ["id", "placeholder", "disabled", "required", "readonly", "pattern", "onKeydown"];
const _hoisted_4$d = {
  key: 1,
  class: "opacity-7 light"
};
const _hoisted_5$d = {
  key: 5,
  class: "flex column spinner"
};
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "NumberInput",
  props: {
    modelValue: {},
    min: {},
    max: {},
    step: { default: 1 },
    spinner: { type: Boolean, default: true },
    iconStart: {},
    icon: {},
    label: {},
    defaultValue: {},
    placeholder: {},
    disabled: { type: Boolean },
    required: { type: Boolean },
    id: {},
    helptext: {},
    layout: {},
    center: { type: Boolean },
    padZero: { default: 1 },
    useGrouping: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emit2 = __emit;
    let numberValue = ref();
    onMounted(() => {
      const num = __props.modelValue !== void 0 ? Number.parseFloat(`${__props.modelValue}`) : void 0;
      const defaultNum = __props.defaultValue !== void 0 ? Number.parseFloat(`${__props.defaultValue}`) : void 0;
      numberValue.value = num ?? defaultNum;
    });
    const btnLayouts = ["horizontal", "vertical"];
    function add(...numbers) {
      var _a;
      const numArr = numbers.map((n2) => n2 || 0);
      const precision = ((_a = __props.step.toString().split(".")[1]) == null ? void 0 : _a.length) || 0;
      return Number.parseFloat(numArr.reduce((acc, curr) => acc + curr, 0).toFixed(precision));
    }
    function subtract(...numbers) {
      var _a;
      const numArr = numbers.map((n2) => n2 || 0);
      const firstNum = numArr.shift() || 0;
      const precision = ((_a = __props.step.toString().split(".")[1]) == null ? void 0 : _a.length) || 0;
      return Number.parseFloat(numArr.reduce((acc, curr) => acc - curr, firstNum).toFixed(precision));
    }
    const canAdd = computed(() => __props.max === void 0 || add(numberValue.value, __props.step) <= __props.max);
    const canDecrement = computed(() => __props.min === void 0 || subtract(numberValue.value, __props.step) >= __props.min);
    function increment() {
      if (!canAdd.value) return;
      numberValue.value = add(numberValue.value ?? 0, __props.step);
      emit2("update:modelValue", numberValue.value);
    }
    function decrement() {
      if (!canDecrement.value) return;
      numberValue.value = subtract(numberValue.value || 0, __props.step);
      emit2("update:modelValue", numberValue.value);
    }
    function formatNumber2(num) {
      if (Number.isNaN(num)) return "";
      const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 20,
        useGrouping: __props.useGrouping
      });
      const formattedNum = formatter.format(num);
      const [integerPart, decimalPart] = formattedNum.split(".");
      const padding = __props.padZero && __props.padZero > integerPart.replace(/,/g, "").length ? "0".repeat(__props.padZero - integerPart.replace(/,/g, "").length) : "";
      return decimalPart ? `${padding}${integerPart}.${decimalPart}` : `${padding}${integerPart}`;
    }
    let formattedValue = ref("");
    function inputHandler() {
      const numeric = formattedValue.value.replace(/[^\d.-]/g, "");
      const emptyValue = ["", "-", ".", "-."].includes(numeric);
      const isTypingDecimal = formattedValue.value.endsWith(".");
      if (emptyValue || isTypingDecimal) {
        emit2("update:modelValue", numeric === "-" ? "-" : numeric);
        return;
      }
      numberValue.value = Number.parseFloat(numeric);
      formattedValue.value = emptyValue ? "" : formatNumber2(numberValue.value);
      emit2("update:modelValue", numberValue.value);
    }
    watch(() => numberValue.value, () => {
      nextTick(() => {
        formattedValue.value = numberValue.value !== void 0 ? formatNumber2(numberValue.value) : "";
      });
    });
    watch(() => __props.modelValue, (newVal) => {
      if (newVal !== numberValue.value) {
        if (typeof newVal === "string" && (newVal === "-" || newVal.endsWith("."))) {
          formattedValue.value = newVal;
          return;
        }
        numberValue.value = Number.parseFloat(`${newVal}`) || 0;
      }
    }, { immediate: true });
    return (_ctx, _cache) => {
      const _directive_pattern = resolveDirective("pattern");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bagel-input num-input", {
          textInputSpinnerWrap: _ctx.icon || _ctx.spinner,
          txtInputIconStart: _ctx.iconStart
        }])
      }, [
        createElementVNode("div", { for: _ctx.id }, [
          _ctx.label ? (openBlock(), createElementBlock("label", _hoisted_2$p, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(["gap-025", { "column flex": _ctx.layout === "vertical", "flex": _ctx.layout === "horizontal" }])
          }, [
            _ctx.layout && btnLayouts.includes(_ctx.layout) ? (openBlock(), createBlock(unref(Btn), {
              key: 0,
              flat: "",
              icon: "add",
              class: normalizeClass(["radius", [{ "bgl-big-ctrl-num-btn": _ctx.layout === "vertical" }]]),
              tabindex: "-1",
              onClick: increment
            }, null, 8, ["class"])) : createCommentVNode("", true),
            withDirectives(createElementVNode("input", {
              id: _ctx.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(formattedValue) ? formattedValue.value = $event : formattedValue = $event),
              type: "text",
              class: normalizeClass({
                "txt-center": _ctx.center,
                "min0": _ctx.layout,
                "bgl-number-input": _ctx.layout !== "vertical" && _ctx.layout !== "horizontal"
              }),
              placeholder: _ctx.placeholder || _ctx.label,
              disabled: _ctx.disabled,
              required: _ctx.required,
              readonly: _ctx.disabled,
              inputmode: "decimal",
              autocomplete: "off",
              pattern: _ctx.useGrouping ? "^-?\\d{1,3}(,\\d{3})*(.\\d+)?$" : "^-?\\d*.?d*$",
              autocorrect: "off",
              spellcheck: "false",
              onInput: inputHandler,
              onKeydown: [
                withKeys(withModifiers(increment, ["prevent"]), ["up"]),
                withKeys(withModifiers(decrement, ["prevent"]), ["down"])
              ]
            }, null, 42, _hoisted_3$l), [
              [
                vModelText,
                unref(formattedValue),
                void 0,
                { trim: true }
              ],
              [
                _directive_pattern,
                void 0,
                void 0,
                { number: true }
              ]
            ]),
            _ctx.helptext ? (openBlock(), createElementBlock("p", _hoisted_4$d, toDisplayString(_ctx.helptext), 1)) : createCommentVNode("", true),
            _ctx.iconStart ? (openBlock(), createBlock(unref(_sfc_main$s), {
              key: 2,
              class: "iconStart",
              icon: _ctx.iconStart
            }, null, 8, ["icon"])) : createCommentVNode("", true),
            _ctx.icon ? (openBlock(), createBlock(unref(_sfc_main$s), {
              key: 3,
              icon: _ctx.icon
            }, null, 8, ["icon"])) : createCommentVNode("", true),
            _ctx.layout && btnLayouts.includes(_ctx.layout) ? (openBlock(), createBlock(unref(Btn), {
              key: 4,
              flat: "",
              icon: "remove",
              class: normalizeClass(["radius", [{ "bgl-big-ctrl-num-btn": _ctx.layout === "vertical" }]]),
              tabindex: "-1",
              onClick: decrement
            }, null, 8, ["class"])) : createCommentVNode("", true),
            _ctx.spinner && (!_ctx.layout || !btnLayouts.includes(_ctx.layout)) ? (openBlock(), createElementBlock("div", _hoisted_5$d, [
              createVNode(unref(Btn), {
                icon: "add",
                flat: "",
                thin: "",
                class: "bgl-ctrl-num-btn ctrl-add color-gray top-bgl-ctrl-num-btn",
                disabled: !canAdd.value,
                tabindex: "-1",
                onClick: increment
              }, null, 8, ["disabled"]),
              createVNode(unref(Btn), {
                icon: "remove",
                flat: "",
                thin: "",
                class: "bgl-ctrl-num-btn ctrl-remove color-gray",
                disabled: !canDecrement.value,
                tabindex: "-1",
                onClick: decrement
              }, null, 8, ["disabled"])
            ])) : createCommentVNode("", true)
          ], 2)
        ], 8, _hoisted_1$B)
      ], 2);
    };
  }
});
const NumberInput = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["__scopeId", "data-v-f5b06aa8"]]);
const _hoisted_1$A = ["value", "autofocus", "onKeydown", "onPaste"];
const _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "OTP",
  props: {
    digitCount: {},
    default: {},
    modelValue: {}
  },
  emits: ["update:modelValue", "complete"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const digits = reactive([]);
    const otpCont = ref();
    function handlePaste(event, index2) {
      event.preventDefault();
      const { clipboardData } = event;
      const pastedText = clipboardData == null ? void 0 : clipboardData.getData("text").replaceAll(/\D/g, "");
      const pastedDigits = [...pastedText ?? ""];
      if (!pastedDigits) return;
      for (let i2 = 0; i2 < pastedDigits.length; i2++) {
        const digit = pastedDigits[i2];
        if (index2 + i2 < digits.length) {
          digits[index2 + i2] = digit;
        }
      }
      emitUpdate();
    }
    function emitUpdate() {
      emit2("update:modelValue", digits.join(""));
      if (isDigitsFull()) {
        emit2("complete", digits.join(""));
      }
    }
    function handleKeyDown(event, index2) {
      var _a;
      const noPreventKeys = ["Tab", "ArrowRight", "ArrowLeft", "Control", "Shift", "Alt", "Meta"];
      if (noPreventKeys.includes(event.key)) {
        return;
      }
      const preventKeys = ["ArrowUp", "ArrowDown"];
      if (preventKeys.includes(event.key)) {
        event.preventDefault();
        return;
      }
      if (event.key === "Backspace") {
        digits[index2] = void 0;
        if (index2 !== 0) {
          const prevDigit = (_a = otpCont.value) == null ? void 0 : _a.children[index2 - 1];
          prevDigit.focus();
        }
        emitUpdate();
        return;
      }
      const numberRegex = /^\d$/;
      if (numberRegex.test(event.key)) {
        digits[index2] = event.key;
        if (index2 !== props2.digitCount - 1) {
          setTimeout(() => {
            var _a2;
            const nextDigit = (_a2 = otpCont.value) == null ? void 0 : _a2.children[index2 + 1];
            nextDigit.focus();
          }, 10);
        }
        emitUpdate();
      }
    }
    if (props2.default && props2.default.length === props2.digitCount) {
      for (let i2 = 0; i2 < props2.digitCount; i2++) {
        digits[i2] = props2.default.charAt(i2);
      }
    } else {
      for (let i2 = 0; i2 < props2.digitCount; i2++) {
        digits[i2] = void 0;
      }
    }
    function isDigitsFull() {
      for (const elem of digits) {
        if (elem === void 0) {
          return false;
        }
      }
      return true;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "otpCont",
        ref: otpCont,
        class: "otp_wrap"
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(digits, (_el, ind) => {
          return openBlock(), createElementBlock("input", {
            key: ind,
            value: digits[ind] || "",
            type: "number",
            inputmode: "numeric",
            class: "digit-box",
            autofocus: ind === 0,
            maxlength: "1",
            pattern: "[0-9]*",
            oninput: "this.value = this.value.slice(0, 1)",
            onKeydown: ($event) => handleKeyDown($event, ind),
            onPaste: ($event) => handlePaste($event, ind),
            onKeyup: _cache[0] || (_cache[0] = withModifiers(() => {
            }, ["prevent"]))
          }, null, 40, _hoisted_1$A);
        }), 128))
      ], 512);
    };
  }
});
const OTP = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["__scopeId", "data-v-ab0a46bf"]]);
const _hoisted_1$z = { class: "relative passwordInput" };
const _hoisted_2$o = { class: "m-password position-bottom-end flex column justify-content-center" };
const _sfc_main$G = /* @__PURE__ */ defineComponent({
  __name: "PasswordInput",
  props: /* @__PURE__ */ mergeModels({
    id: {},
    title: {},
    helptext: {},
    placeholder: {},
    label: { default: "" },
    small: { type: Boolean },
    dense: { type: Boolean },
    required: { type: Boolean },
    pattern: {},
    shrink: { type: Boolean },
    disabled: { type: Boolean },
    name: {},
    nativeInputAttrs: {},
    icon: {},
    iconStart: {},
    multiline: { type: Boolean },
    autoheight: { type: Boolean },
    code: { type: Boolean },
    lines: {},
    autofocus: { type: Boolean },
    debounceDelay: {},
    autocomplete: { default: "current-password" },
    onFocusout: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
    "showPwd": { type: Boolean, ...{ default: false } },
    "showPwdModifiers": {}
  }),
  emits: ["update:modelValue", "update:showPwd"],
  setup(__props) {
    const props2 = __props;
    const password = useModel(__props, "modelValue");
    const showPwd = useModel(__props, "showPwd");
    const toggleShowPwdIcon = computed(() => showPwd.value ? "visibility_off" : "visibility");
    const inputType = computed(() => showPwd.value ? "text" : "password");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$z, [
        createVNode(unref(TextInput), mergeProps({
          modelValue: password.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => password.value = $event)
        }, props2, {
          type: inputType.value,
          class: "mb-0",
          name: props2.name
        }), null, 16, ["modelValue", "type", "name"]),
        createElementVNode("div", _hoisted_2$o, [
          createVNode(unref(Btn), {
            flat: "",
            thin: "",
            class: "mx-05",
            icon: toggleShowPwdIcon.value,
            onClick: _cache[1] || (_cache[1] = ($event) => showPwd.value = !showPwd.value)
          }, null, 8, ["icon"])
        ])
      ]);
    };
  }
});
function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = /* @__PURE__ */ ((cache) => (thing) => {
  const str = toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null));
const kindOfTest = (type3) => {
  type3 = type3.toLowerCase();
  return (thing) => kindOf(thing) === type3;
};
const typeOfTest = (type3) => (thing) => typeof thing === type3;
const { isArray } = Array;
const isUndefined = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result2;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result2 = ArrayBuffer.isView(val);
  } else {
    result2 = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result2;
}
const isString = typeOfTest("string");
const isFunction = typeOfTest("function");
const isNumber = typeOfTest("number");
const isObject$1 = (thing) => thing !== null && typeof thing === "object";
const isBoolean = (thing) => thing === true || thing === false;
const isPlainObject = (val) => {
  if (kindOf(val) !== "object") {
    return false;
  }
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject$1(val) && isFunction(val.pipe);
const isFormData = (thing) => {
  let kind;
  return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
  kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest);
const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(obj, fn, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i2;
  let l2;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (i2 = 0, l2 = obj.length; i2 < l2; i2++) {
      fn.call(null, obj[i2], i2, obj);
    }
  } else {
    const keys4 = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys4.length;
    let key;
    for (i2 = 0; i2 < len; i2++) {
      key = keys4[i2];
      fn.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys4 = Object.keys(obj);
  let i2 = keys4.length;
  let _key;
  while (i2-- > 0) {
    _key = keys4[i2];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context) => !isUndefined(context) && context !== _global;
function merge() {
  const { caseless } = isContextDefined(this) && this || {};
  const result2 = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result2, key) || key;
    if (isPlainObject(result2[targetKey]) && isPlainObject(val)) {
      result2[targetKey] = merge(result2[targetKey], val);
    } else if (isPlainObject(val)) {
      result2[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result2[targetKey] = val.slice();
    } else {
      result2[targetKey] = val;
    }
  };
  for (let i2 = 0, l2 = arguments.length; i2 < l2; i2++) {
    arguments[i2] && forEach(arguments[i2], assignValue);
  }
  return result2;
}
const extend$1 = (a2, b2, thisArg, { allOwnKeys } = {}) => {
  forEach(b2, (val, key) => {
    if (thisArg && isFunction(val)) {
      a2[key] = bind(val, thisArg);
    } else {
      a2[key] = val;
    }
  }, { allOwnKeys });
  return a2;
};
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props2, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props2 && Object.assign(constructor.prototype, props2);
};
const toFlatObject = (sourceObj, destObj, filter3, propFilter) => {
  let props2;
  let i2;
  let prop3;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null) return destObj;
  do {
    props2 = Object.getOwnPropertyNames(sourceObj);
    i2 = props2.length;
    while (i2-- > 0) {
      prop3 = props2[i2];
      if ((!propFilter || propFilter(prop3, sourceObj, destObj)) && !merged[prop3]) {
        destObj[prop3] = sourceObj[prop3];
        merged[prop3] = true;
      }
    }
    sourceObj = filter3 !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter3 || filter3(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i2 = thing.length;
  if (!isNumber(i2)) return null;
  const arr = new Array(i2);
  while (i2-- > 0) {
    arr[i2] = thing[i2];
  }
  return arr;
};
const isTypedArray = /* @__PURE__ */ ((TypedArray) => {
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result2;
  while ((result2 = iterator.next()) && !result2.done) {
    const pair = result2.value;
    fn.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches2;
  const arr = [];
  while ((matches2 = regExp.exec(str)) !== null) {
    arr.push(matches2);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function replacer(m2, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};
const hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop3) => hasOwnProperty2.call(obj, prop3))(Object.prototype);
const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors2, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    if (isFunction(obj) && ["arguments", "caller", "callee"].indexOf(name) !== -1) {
      return false;
    }
    const value = obj[name];
    if (!isFunction(value)) return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define2 = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };
  isArray(arrayOrString) ? define2(arrayOrString) : define2(String(arrayOrString).split(delimiter));
  return obj;
};
const noop = () => {
};
const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj) => {
  const stack2 = new Array(10);
  const visit = (source, i2) => {
    if (isObject$1(source)) {
      if (stack2.indexOf(source) >= 0) {
        return;
      }
      if (!("toJSON" in source)) {
        stack2[i2] = source;
        const target = isArray(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit(value, i2 + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });
        stack2[i2] = void 0;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing) => thing && (isObject$1(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }
  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({ source, data: data2 }) => {
      if (source === _global && data2 === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);
    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    };
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === "function",
  isFunction(_global.postMessage)
);
const asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind(_global) : typeof process !== "undefined" && process.nextTick || _setImmediate;
const utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: isObject$1,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend: extend$1,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
};
function AxiosError$1(message, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}
utils$1.inherits(AxiosError$1, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const prototype$1 = AxiosError$1.prototype;
const descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError$1, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: true });
AxiosError$1.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  utils$1.toFlatObject(error, axiosError, function filter3(obj) {
    return obj !== Error.prototype;
  }, (prop3) => {
    return prop3 !== "isAxiosError";
  });
  AxiosError$1.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
const httpAdapter = null;
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}
function removeBrackets(key) {
  return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i2) {
    token = removeBrackets(token);
    return !dots && i2 ? "[" + token + "]" : token;
  }).join(dots ? "." : "");
}
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter2(prop3) {
  return /^is[A-Z]/.test(prop3);
});
function toFormData$1(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError("target must be an object");
  }
  formData = formData || new FormData();
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option2, source) {
    return !utils$1.isUndefined(source[option2]);
  });
  const metaTokens = options.metaTokens;
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
  if (!utils$1.isFunction(visitor)) {
    throw new TypeError("visitor must be a function");
  }
  function convertValue(value) {
    if (value === null) return "";
    if (utils$1.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError$1("Blob is not supported. Use a Buffer instead.");
    }
    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === "object") {
      if (utils$1.endsWith(key, "{}")) {
        key = metaTokens ? key : key.slice(0, -2);
        value = JSON.stringify(value);
      } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value))) {
        key = removeBrackets(key);
        arr.forEach(function each(el, index2) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index2, dots) : indexes === null ? key : key + "[]",
            convertValue(el)
          );
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack2 = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (utils$1.isUndefined(value)) return;
    if (stack2.indexOf(value) !== -1) {
      throw Error("Circular reference detected in " + path.join("."));
    }
    stack2.push(value);
    utils$1.forEach(value, function each(el, key) {
      const result2 = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData,
        el,
        utils$1.isString(key) ? key.trim() : key,
        path,
        exposedHelpers
      );
      if (result2 === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });
    stack2.pop();
  }
  if (!utils$1.isObject(obj)) {
    throw new TypeError("data must be an object");
  }
  build(obj);
  return formData;
}
function encode$1(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && toFormData$1(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append2(name, value) {
  this._pairs.push([name, value]);
};
prototype.toString = function toString3(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;
  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + "=" + _encode(pair[1]);
  }, "").join("&");
};
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
  if (!params) {
    return url;
  }
  const _encode = options && options.encode || encode;
  if (utils$1.isFunction(options)) {
    options = {
      serialize: options
    };
  }
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h2) {
      if (h2 !== null) {
        fn(h2);
      }
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
const FormData$1 = typeof FormData !== "undefined" ? FormData : null;
const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
const platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
const _navigator = typeof navigator === "object" && navigator || void 0;
const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0);
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const origin = hasBrowserEnv && window.location.href || "http://localhost";
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin
}, Symbol.toStringTag, { value: "Module" }));
const platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(data2, options) {
  return toFormData$1(data2, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString("base64"));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
function parsePropPath(name) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map((match) => {
    return match[0] === "[]" ? "" : match[1] || match[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys4 = Object.keys(arr);
  let i2;
  const len = keys4.length;
  let key;
  for (i2 = 0; i2 < len; i2++) {
    key = keys4[i2];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path, value, target, index2) {
    let name = path[index2++];
    if (name === "__proto__") return true;
    const isNumericKey = Number.isFinite(+name);
    const isLast = index2 >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;
    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }
      return !isNumericKey;
    }
    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }
    const result2 = buildPath(path, value, target[name], index2);
    if (result2 && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }
    return !isNumericKey;
  }
  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};
    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });
    return obj;
  }
  return null;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults$1 = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function transformRequest(data2, headers) {
    const contentType = headers.getContentType() || "";
    const hasJSONContentType = contentType.indexOf("application/json") > -1;
    const isObjectPayload = utils$1.isObject(data2);
    if (isObjectPayload && utils$1.isHTMLForm(data2)) {
      data2 = new FormData(data2);
    }
    const isFormData2 = utils$1.isFormData(data2);
    if (isFormData2) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data2)) : data2;
    }
    if (utils$1.isArrayBuffer(data2) || utils$1.isBuffer(data2) || utils$1.isStream(data2) || utils$1.isFile(data2) || utils$1.isBlob(data2) || utils$1.isReadableStream(data2)) {
      return data2;
    }
    if (utils$1.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$1.isURLSearchParams(data2)) {
      headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
      return data2.toString();
    }
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
        return toURLEncodedForm(data2, this.formSerializer).toString();
      }
      if ((isFileList2 = utils$1.isFileList(data2)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData$1(
          isFileList2 ? { "files[]": data2 } : data2,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType("application/json", false);
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    const transitional2 = this.transitional || defaults$1.transitional;
    const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    const JSONRequested = this.responseType === "json";
    if (utils$1.isResponse(data2) || utils$1.isReadableStream(data2)) {
      return data2;
    }
    if (data2 && utils$1.isString(data2) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data2);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data2;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
  defaults$1.headers[method] = {};
});
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
const parseHeaders = (rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i2;
  rawHeaders && rawHeaders.split("\n").forEach(function parser(line2) {
    i2 = line2.indexOf(":");
    key = line2.substring(0, i2).trim().toLowerCase();
    val = line2.substring(i2 + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === "set-cookie") {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    }
  });
  return parsed;
};
const $internals = Symbol("internals");
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens = /* @__PURE__ */ Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;
  while (match = tokensRE.exec(str)) {
    tokens[match[1]] = match[2];
  }
  return tokens;
}
const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter3, isHeaderNameFilter) {
  if (utils$1.isFunction(filter3)) {
    return filter3.call(this, value, header);
  }
  if (isHeaderNameFilter) {
    value = header;
  }
  if (!utils$1.isString(value)) return;
  if (utils$1.isString(filter3)) {
    return value.indexOf(filter3) !== -1;
  }
  if (utils$1.isRegExp(filter3)) {
    return filter3.test(value);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w2, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(" " + header);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
let AxiosHeaders$1 = class AxiosHeaders2 {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error("header name must be a non-empty string");
      }
      const key = utils$1.findKey(self2, lHeader);
      if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
        self2[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers, _rewrite) => utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  }
  get(header, parser) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(header, matcher2) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      return !!(key && this[key] !== void 0 && (!matcher2 || matchHeaderValue(this, this[key], key, matcher2)));
    }
    return false;
  }
  delete(header, matcher2) {
    const self2 = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils$1.findKey(self2, _header);
        if (key && (!matcher2 || matchHeaderValue(self2, self2[key], key, matcher2))) {
          delete self2[key];
          deleted = true;
        }
      }
    }
    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  }
  clear(matcher2) {
    const keys4 = Object.keys(this);
    let i2 = keys4.length;
    let deleted = false;
    while (i2--) {
      const key = keys4[i2];
      if (!matcher2 || matchHeaderValue(this, this[key], key, matcher2, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format2) {
    const self2 = this;
    const headers = {};
    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);
      if (key) {
        self2[key] = normalizeValue(value);
        delete self2[header];
        return;
      }
      const normalized = format2 ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self2[header];
      }
      self2[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = /* @__PURE__ */ Object.create(null);
    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed2 = new this(first);
    targets.forEach((target) => computed2.set(target));
    return computed2;
  }
  static accessor(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype2, _header);
        accessors[lHeader] = true;
      }
    }
    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
};
AxiosHeaders$1.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders$1.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders$1);
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data2 = context.data;
  utils$1.forEach(fns, function transform(fn) {
    data2 = fn.call(config, data2, headers.normalize(), response ? response.status : void 0);
  });
  headers.normalize();
  return data2;
}
function isCancel$1(value) {
  return !!(value && value.__CANCEL__);
}
function CanceledError$1(message, config, request) {
  AxiosError$1.call(this, message == null ? "canceled" : message, AxiosError$1.ERR_CANCELED, config, request);
  this.name = "CanceledError";
}
utils$1.inherits(CanceledError$1, AxiosError$1, {
  __CANCEL__: true
});
function settle(resolve, reject3, response) {
  const validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject3(new AxiosError$1(
      "Request failed with status code " + response.status,
      [AxiosError$1.ERR_BAD_REQUEST, AxiosError$1.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}
function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || "";
}
function speedometer(samplesCount, min2) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail2 = 0;
  let firstSampleTS;
  min2 = min2 !== void 0 ? min2 : 1e3;
  return function push(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail2];
    if (!firstSampleTS) {
      firstSampleTS = now;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i2 = tail2;
    let bytesCount = 0;
    while (i2 !== head) {
      bytesCount += bytes[i2++];
      i2 = i2 % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail2) {
      tail2 = (tail2 + 1) % samplesCount;
    }
    if (now - firstSampleTS < min2) {
      return;
    }
    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  };
}
function throttle$2(fn, freq) {
  let timestamp = 0;
  let threshold = 1e3 / freq;
  let lastArgs;
  let timer;
  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  };
  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if (passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };
  const flush = () => lastArgs && invoke(lastArgs);
  return [throttled, flush];
}
const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return throttle$2((e) => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : void 0;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data2 = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate ? rate : void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? "download" : "upload"]: true
    };
    listener(data2);
  }, freq);
};
const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;
  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};
const asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));
const isURLSameOrigin = platform.hasStandardBrowserEnv ? /* @__PURE__ */ ((origin2, isMSIE) => (url) => {
  url = new URL(url, platform.origin);
  return origin2.protocol === url.protocol && origin2.host === url.host && (isMSIE || origin2.port === url.port);
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true;
const cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain2, secure) {
      const cookie = [name + "=" + encodeURIComponent(value)];
      utils$1.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
      utils$1.isString(path) && cookie.push("path=" + path);
      utils$1.isString(domain2) && cookie.push("domain=" + domain2);
      secure === true && cookie.push("secure");
      document.cookie = cookie.join("; ");
    },
    read(name) {
      const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  let isRelativeUrl = !isAbsoluteURL(requestedURL);
  if (baseURL && isRelativeUrl || allowAbsoluteUrls == false) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? { ...thing } : thing;
function mergeConfig$1(config1, config2) {
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source, prop3, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({ caseless }, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a2, b2, prop3, caseless) {
    if (!utils$1.isUndefined(b2)) {
      return getMergedValue(a2, b2, prop3, caseless);
    } else if (!utils$1.isUndefined(a2)) {
      return getMergedValue(void 0, a2, prop3, caseless);
    }
  }
  function valueFromConfig2(a2, b2) {
    if (!utils$1.isUndefined(b2)) {
      return getMergedValue(void 0, b2);
    }
  }
  function defaultToConfig2(a2, b2) {
    if (!utils$1.isUndefined(b2)) {
      return getMergedValue(void 0, b2);
    } else if (!utils$1.isUndefined(a2)) {
      return getMergedValue(void 0, a2);
    }
  }
  function mergeDirectKeys(a2, b2, prop3) {
    if (prop3 in config2) {
      return getMergedValue(a2, b2);
    } else if (prop3 in config1) {
      return getMergedValue(void 0, a2);
    }
  }
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a2, b2, prop3) => mergeDeepProperties(headersToObject(a2), headersToObject(b2), prop3, true)
  };
  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop3) {
    const merge2 = mergeMap[prop3] || mergeDeepProperties;
    const configValue = merge2(config1[prop3], config2[prop3], prop3);
    utils$1.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop3] = configValue);
  });
  return config;
}
const resolveConfig = (config) => {
  const newConfig = mergeConfig$1({}, config);
  let { data: data2, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
  newConfig.headers = headers = AxiosHeaders$1.from(headers);
  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
  if (auth) {
    headers.set(
      "Authorization",
      "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : ""))
    );
  }
  let contentType;
  if (utils$1.isFormData(data2)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(void 0);
    } else if ((contentType = headers.getContentType()) !== false) {
      const [type3, ...tokens] = contentType ? contentType.split(";").map((token) => token.trim()).filter(Boolean) : [];
      headers.setContentType([type3 || "multipart/form-data", ...tokens].join("; "));
    }
  }
  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
    if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(newConfig.url)) {
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }
  return newConfig;
};
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
const xhrAdapter = isXHRAdapterSupported && function(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject3) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders$1.from(_config.headers).normalize();
    let { responseType, onUploadProgress, onDownloadProgress } = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;
    function done() {
      flushUpload && flushUpload();
      flushDownload && flushDownload();
      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
      _config.signal && _config.signal.removeEventListener("abort", onCanceled);
    }
    let request = new XMLHttpRequest();
    request.open(_config.method.toUpperCase(), _config.url, true);
    request.timeout = _config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders$1.from(
        "getAllResponseHeaders" in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject3(err);
        done();
      }, response);
      request = null;
    }
    if ("onloadend" in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject3(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, config, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject3(new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, config, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject3(new AxiosError$1(
        timeoutErrorMessage,
        transitional2.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
        config,
        request
      ));
      request = null;
    };
    requestData === void 0 && requestHeaders.setContentType(null);
    if ("setRequestHeader" in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request.responseType = _config.responseType;
    }
    if (onDownloadProgress) {
      [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
      request.addEventListener("progress", downloadThrottled);
    }
    if (onUploadProgress && request.upload) {
      [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
      request.upload.addEventListener("progress", uploadThrottled);
      request.upload.addEventListener("loadend", flushUpload);
    }
    if (_config.cancelToken || _config.signal) {
      onCanceled = (cancel) => {
        if (!request) {
          return;
        }
        reject3(!cancel || cancel.type ? new CanceledError$1(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
      }
    }
    const protocol = parseProtocol(_config.url);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject3(new AxiosError$1("Unsupported protocol " + protocol + ":", AxiosError$1.ERR_BAD_REQUEST, config));
      return;
    }
    request.send(requestData || null);
  });
};
const composeSignals = (signals, timeout) => {
  const { length } = signals = signals ? signals.filter(Boolean) : [];
  if (timeout || length) {
    let controller = new AbortController();
    let aborted;
    const onabort = function(reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError$1 ? err : new CanceledError$1(err instanceof Error ? err.message : err));
      }
    };
    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError$1(`timeout ${timeout} of ms exceeded`, AxiosError$1.ETIMEDOUT));
    }, timeout);
    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal2) => {
          signal2.unsubscribe ? signal2.unsubscribe(onabort) : signal2.removeEventListener("abort", onabort);
        });
        signals = null;
      }
    };
    signals.forEach((signal2) => signal2.addEventListener("abort", onabort));
    const { signal } = controller;
    signal.unsubscribe = () => utils$1.asap(unsubscribe);
    return signal;
  }
};
const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;
  if (len < chunkSize) {
    yield chunk;
    return;
  }
  let pos = 0;
  let end;
  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};
const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};
const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }
  const reader = stream.getReader();
  try {
    for (; ; ) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};
const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);
  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };
  return new ReadableStream({
    async pull(controller) {
      try {
        const { done: done2, value } = await iterator.next();
        if (done2) {
          _onFinish();
          controller.close();
          return;
        }
        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  });
};
const isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === "function";
const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? /* @__PURE__ */ ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) : async (str) => new Uint8Array(await new Response(str).arrayBuffer()));
const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false;
  }
};
const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;
  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      duplexAccessed = true;
      return "half";
    }
  }).headers.has("Content-Type");
  return duplexAccessed && !hasContentType;
});
const DEFAULT_CHUNK_SIZE = 64 * 1024;
const supportsResponseStream = isReadableStreamSupported && test(() => utils$1.isReadableStream(new Response("").body));
const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};
isFetchSupported && ((res) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((type3) => {
    !resolvers[type3] && (resolvers[type3] = utils$1.isFunction(res[type3]) ? (res2) => res2[type3]() : (_2, config) => {
      throw new AxiosError$1(`Response type '${type3}' is not supported`, AxiosError$1.ERR_NOT_SUPPORT, config);
    });
  });
})(new Response());
const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }
  if (utils$1.isBlob(body)) {
    return body.size;
  }
  if (utils$1.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: "POST",
      body
    });
    return (await _request.arrayBuffer()).byteLength;
  }
  if (utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }
  if (utils$1.isURLSearchParams(body)) {
    body = body + "";
  }
  if (utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};
const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());
  return length == null ? getBodyLength(body) : length;
};
const fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data: data2,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = "same-origin",
    fetchOptions
  } = resolveConfig(config);
  responseType = responseType ? (responseType + "").toLowerCase() : "text";
  let composedSignal = composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);
  let request;
  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
    composedSignal.unsubscribe();
  });
  let requestContentLength;
  try {
    if (onUploadProgress && supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await resolveBodyLength(headers, data2)) !== 0) {
      let _request = new Request(url, {
        method: "POST",
        body: data2,
        duplex: "half"
      });
      let contentTypeHeader;
      if (utils$1.isFormData(data2) && (contentTypeHeader = _request.headers.get("content-type"))) {
        headers.setContentType(contentTypeHeader);
      }
      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );
        data2 = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }
    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? "include" : "omit";
    }
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data2,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : void 0
    });
    let response = await fetch(request);
    const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
    if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
      const options = {};
      ["status", "statusText", "headers"].forEach((prop3) => {
        options[prop3] = response[prop3];
      });
      const responseContentLength = utils$1.toFiniteNumber(response.headers.get("content-length"));
      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];
      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }
    responseType = responseType || "text";
    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || "text"](response, config);
    !isStreamResponse && unsubscribe && unsubscribe();
    return await new Promise((resolve, reject3) => {
      settle(resolve, reject3, {
        data: responseData,
        headers: AxiosHeaders$1.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    });
  } catch (err) {
    unsubscribe && unsubscribe();
    if (err && err.name === "TypeError" && /fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      );
    }
    throw AxiosError$1.from(err, err && err.code, config, request);
  }
});
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};
utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, "name", { value });
    } catch (e) {
    }
    Object.defineProperty(fn, "adapterName", { value });
  }
});
const renderReason = (reason) => `- ${reason}`;
const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;
const adapters = {
  getAdapter: (adapters2) => {
    adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
    const { length } = adapters2;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i2 = 0; i2 < length; i2++) {
      nameOrAdapter = adapters2[i2];
      let id;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === void 0) {
          throw new AxiosError$1(`Unknown adapter '${id}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id || "#" + i2] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id, state2]) => `adapter ${id} ` + (state2 === false ? "is not supported by the environment" : "is not available in the build")
      );
      let s2 = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError$1(
        `There is no suitable adapter to dispatch the request ` + s2,
        "ERR_NOT_SUPPORT"
      );
    }
    return adapter;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError$1(null, config);
  }
}
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = AxiosHeaders$1.from(config.headers);
  config.data = transformData.call(
    config,
    config.transformRequest
  );
  if (["post", "put", "patch"].indexOf(config.method) !== -1) {
    config.headers.setContentType("application/x-www-form-urlencoded", false);
  }
  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );
    response.headers = AxiosHeaders$1.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel$1(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
const VERSION$1 = "1.8.3";
const validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type3, i2) => {
  validators$1[type3] = function validator2(thing) {
    return typeof thing === type3 || "a" + (i2 < 1 ? "n " : " ") + type3;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return (value, opt, opts) => {
    if (validator2 === false) {
      throw new AxiosError$1(
        formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
        AxiosError$1.ERR_DEPRECATED
      );
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version2 + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
validators$1.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
  }
  const keys4 = Object.keys(options);
  let i2 = keys4.length;
  while (i2-- > 0) {
    const opt = keys4[i2];
    const validator2 = schema[opt];
    if (validator2) {
      const value = options[opt];
      const result2 = value === void 0 || validator2(value, opt, options);
      if (result2 !== true) {
        throw new AxiosError$1("option " + opt + " must be " + result2, AxiosError$1.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError$1("Unknown option " + opt, AxiosError$1.ERR_BAD_OPTION);
    }
  }
}
const validator = {
  assertOptions,
  validators: validators$1
};
const validators = validator.validators;
let Axios$1 = class Axios2 {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};
        Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
        const stack2 = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
        try {
          if (!err.stack) {
            err.stack = stack2;
          } else if (stack2 && !String(err.stack).endsWith(stack2.replace(/^.+\n.+\n/, ""))) {
            err.stack += "\n" + stack2;
          }
        } catch (e) {
        }
      }
      throw err;
    }
  }
  _request(configOrUrl, config) {
    if (typeof configOrUrl === "string") {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig$1(this.defaults, config);
    const { transitional: transitional2, paramsSerializer, headers } = config;
    if (transitional2 !== void 0) {
      validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }
    if (config.allowAbsoluteUrls !== void 0) ;
    else if (this.defaults.allowAbsoluteUrls !== void 0) {
      config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
    } else {
      config.allowAbsoluteUrls = true;
    }
    validator.assertOptions(config, {
      baseUrl: validators.spelling("baseURL"),
      withXsrfToken: validators.spelling("withXSRFToken")
    }, true);
    config.method = (config.method || this.defaults.method || "get").toLowerCase();
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );
    headers && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (method) => {
        delete headers[method];
      }
    );
    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i2 = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), void 0];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);
      while (i2 < len) {
        promise = promise.then(chain[i2++], chain[i2++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i2 = 0;
    while (i2 < len) {
      const onFulfilled = requestInterceptorChain[i2++];
      const onRejected = requestInterceptorChain[i2++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i2 = 0;
    len = responseInterceptorChain.length;
    while (i2 < len) {
      promise = promise.then(responseInterceptorChain[i2++], responseInterceptorChain[i2++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig$1(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
};
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data2, config) {
      return this.request(mergeConfig$1(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data: data2
      }));
    };
  }
  Axios$1.prototype[method] = generateHTTPMethod();
  Axios$1.prototype[method + "Form"] = generateHTTPMethod(true);
});
let CancelToken$1 = class CancelToken2 {
  constructor(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token = this;
    this.promise.then((cancel) => {
      if (!token._listeners) return;
      let i2 = token._listeners.length;
      while (i2-- > 0) {
        token._listeners[i2](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve) => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject3() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config, request) {
      if (token.reason) {
        return;
      }
      token.reason = new CanceledError$1(message, config, request);
      resolvePromise(token.reason);
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index2 = this._listeners.indexOf(listener);
    if (index2 !== -1) {
      this._listeners.splice(index2, 1);
    }
  }
  toAbortSignal() {
    const controller = new AbortController();
    const abort = (err) => {
      controller.abort(err);
    };
    this.subscribe(abort);
    controller.signal.unsubscribe = () => this.unsubscribe(abort);
    return controller.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken2(function executor(c2) {
      cancel = c2;
    });
    return {
      token,
      cancel
    };
  }
};
function spread$1(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
function isAxiosError$1(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
}
const HttpStatusCode$1 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode$1).forEach(([key, value]) => {
  HttpStatusCode$1[value] = key;
});
function createInstance(defaultConfig2) {
  const context = new Axios$1(defaultConfig2);
  const instance = bind(Axios$1.prototype.request, context);
  utils$1.extend(instance, Axios$1.prototype, context, { allOwnKeys: true });
  utils$1.extend(instance, context, null, { allOwnKeys: true });
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig$1(defaultConfig2, instanceConfig));
  };
  return instance;
}
const axios$1 = createInstance(defaults$1);
axios$1.Axios = Axios$1;
axios$1.CanceledError = CanceledError$1;
axios$1.CancelToken = CancelToken$1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = VERSION$1;
axios$1.toFormData = toFormData$1;
axios$1.AxiosError = AxiosError$1;
axios$1.Cancel = axios$1.CanceledError;
axios$1.all = function all2(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread$1;
axios$1.isAxiosError = isAxiosError$1;
axios$1.mergeConfig = mergeConfig$1;
axios$1.AxiosHeaders = AxiosHeaders$1;
axios$1.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
axios$1.getAdapter = adapters.getAdapter;
axios$1.HttpStatusCode = HttpStatusCode$1;
axios$1.default = axios$1;
const {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = axios$1;
const metadata = { "version": 4, "country_calling_codes": { "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], "7": ["RU", "KZ"], "20": ["EG"], "27": ["ZA"], "30": ["GR"], "31": ["NL"], "32": ["BE"], "33": ["FR"], "34": ["ES"], "36": ["HU"], "39": ["IT", "VA"], "40": ["RO"], "41": ["CH"], "43": ["AT"], "44": ["GB", "GG", "IM", "JE"], "45": ["DK"], "46": ["SE"], "47": ["NO", "SJ"], "48": ["PL"], "49": ["DE"], "51": ["PE"], "52": ["MX"], "53": ["CU"], "54": ["AR"], "55": ["BR"], "56": ["CL"], "57": ["CO"], "58": ["VE"], "60": ["MY"], "61": ["AU", "CC", "CX"], "62": ["ID"], "63": ["PH"], "64": ["NZ"], "65": ["SG"], "66": ["TH"], "81": ["JP"], "82": ["KR"], "84": ["VN"], "86": ["CN"], "90": ["TR"], "91": ["IN"], "92": ["PK"], "93": ["AF"], "94": ["LK"], "95": ["MM"], "98": ["IR"], "211": ["SS"], "212": ["MA", "EH"], "213": ["DZ"], "216": ["TN"], "218": ["LY"], "220": ["GM"], "221": ["SN"], "222": ["MR"], "223": ["ML"], "224": ["GN"], "225": ["CI"], "226": ["BF"], "227": ["NE"], "228": ["TG"], "229": ["BJ"], "230": ["MU"], "231": ["LR"], "232": ["SL"], "233": ["GH"], "234": ["NG"], "235": ["TD"], "236": ["CF"], "237": ["CM"], "238": ["CV"], "239": ["ST"], "240": ["GQ"], "241": ["GA"], "242": ["CG"], "243": ["CD"], "244": ["AO"], "245": ["GW"], "246": ["IO"], "247": ["AC"], "248": ["SC"], "249": ["SD"], "250": ["RW"], "251": ["ET"], "252": ["SO"], "253": ["DJ"], "254": ["KE"], "255": ["TZ"], "256": ["UG"], "257": ["BI"], "258": ["MZ"], "260": ["ZM"], "261": ["MG"], "262": ["RE", "YT"], "263": ["ZW"], "264": ["NA"], "265": ["MW"], "266": ["LS"], "267": ["BW"], "268": ["SZ"], "269": ["KM"], "290": ["SH", "TA"], "291": ["ER"], "297": ["AW"], "298": ["FO"], "299": ["GL"], "350": ["GI"], "351": ["PT"], "352": ["LU"], "353": ["IE"], "354": ["IS"], "355": ["AL"], "356": ["MT"], "357": ["CY"], "358": ["FI", "AX"], "359": ["BG"], "370": ["LT"], "371": ["LV"], "372": ["EE"], "373": ["MD"], "374": ["AM"], "375": ["BY"], "376": ["AD"], "377": ["MC"], "378": ["SM"], "380": ["UA"], "381": ["RS"], "382": ["ME"], "383": ["XK"], "385": ["HR"], "386": ["SI"], "387": ["BA"], "389": ["MK"], "420": ["CZ"], "421": ["SK"], "423": ["LI"], "500": ["FK"], "501": ["BZ"], "502": ["GT"], "503": ["SV"], "504": ["HN"], "505": ["NI"], "506": ["CR"], "507": ["PA"], "508": ["PM"], "509": ["HT"], "590": ["GP", "BL", "MF"], "591": ["BO"], "592": ["GY"], "593": ["EC"], "594": ["GF"], "595": ["PY"], "596": ["MQ"], "597": ["SR"], "598": ["UY"], "599": ["CW", "BQ"], "670": ["TL"], "672": ["NF"], "673": ["BN"], "674": ["NR"], "675": ["PG"], "676": ["TO"], "677": ["SB"], "678": ["VU"], "679": ["FJ"], "680": ["PW"], "681": ["WF"], "682": ["CK"], "683": ["NU"], "685": ["WS"], "686": ["KI"], "687": ["NC"], "688": ["TV"], "689": ["PF"], "690": ["TK"], "691": ["FM"], "692": ["MH"], "850": ["KP"], "852": ["HK"], "853": ["MO"], "855": ["KH"], "856": ["LA"], "880": ["BD"], "886": ["TW"], "960": ["MV"], "961": ["LB"], "962": ["JO"], "963": ["SY"], "964": ["IQ"], "965": ["KW"], "966": ["SA"], "967": ["YE"], "968": ["OM"], "970": ["PS"], "971": ["AE"], "972": ["IL"], "973": ["BH"], "974": ["QA"], "975": ["BT"], "976": ["MN"], "977": ["NP"], "992": ["TJ"], "993": ["TM"], "994": ["AZ"], "995": ["GE"], "996": ["KG"], "998": ["UZ"] }, "countries": { "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], "BF": ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], "BG": ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], "BJ": ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], "BL": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], "BO": ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], "BT": ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], "CA": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CD": ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], "CU": ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "FK": ["500", "00", "[2-7]\\d{4}", [5]], "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], "GF": ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], "GI": ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], "GP": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], "GT": ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], "GY": ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], "HR": ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], "HT": ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], "ID": ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "IT": ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "JP": ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "KG": ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], "LR": ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], "LV": ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], "MF": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], "MQ": ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MW": ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], "MX": ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], "NG": ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], "NR": ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], "NU": ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], "NZ": ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], "PL": ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], "PM": ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], "QA": ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], "RE": ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], "RO": ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], "SA": ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], "SB": ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], "SC": ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], "SR": ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], "SV": ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], "SY": ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], "TD": ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "TJ": ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], "TM": ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], "TZ": ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], "UY": ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], "UZ": ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], "WF": ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "XK": ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], "YT": ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "ZM": ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, "nonGeographic": { "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], "870": ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], "881": ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], "883": ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata);
  return func.apply(this, args);
}
function compare(a2, b2) {
  a2 = a2.split("-");
  b2 = b2.split("-");
  var pa = a2[0].split(".");
  var pb = b2[0].split(".");
  for (var i2 = 0; i2 < 3; i2++) {
    var na = Number(pa[i2]);
    var nb = Number(pb[i2]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }
  if (a2[1] && b2[1]) {
    return a2[1] > b2[1] ? 1 : a2[1] < b2[1] ? -1 : 0;
  }
  return !a2[1] && b2[1] ? 1 : a2[1] && !b2[1] ? -1 : 0;
}
var objectConstructor = {}.constructor;
function isObject(object2) {
  return object2 !== void 0 && object2 !== null && object2.constructor === objectConstructor;
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props2) {
  for (var i2 = 0; i2 < props2.length; i2++) {
    var descriptor = props2[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata2) {
    _classCallCheck$2(this, Metadata2);
    validateMetadata(metadata2);
    this.metadata = metadata2;
    setVersion.call(this, metadata2);
  }
  _createClass$2(Metadata2, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function(_2) {
        return _2 !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
    // Deprecated.
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = void 0;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata2 = this.nonGeographic()[callingCode];
        if (metadata2) {
          return metadata2;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return this.metadata.countries["001"];
        }
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function type3(_type) {
      return this.numberingPlan.type(_type);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== void 0;
    }
  }]);
  return Metadata2;
}();
var NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata2, globalMetadataObject) {
    _classCallCheck$2(this, NumberingPlan2);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata2;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  _createClass$2(NumberingPlan2, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata2) {
      return metadata2[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_2) {
        return new Format(_2, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata2) {
      return metadata2[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type3(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
  return NumberingPlan2;
}();
var Format = /* @__PURE__ */ function() {
  function Format2(format2, metadata2) {
    _classCallCheck$2(this, Format2);
    this._format = format2;
    this.metadata = metadata2;
  }
  _createClass$2(Format2, [{
    key: "pattern",
    value: function pattern2() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format2() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
  return Format2;
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /* @__PURE__ */ function() {
  function Type2(type3, metadata2) {
    _classCallCheck$2(this, Type2);
    this.type = type3;
    this.metadata = metadata2;
  }
  _createClass$2(Type2, [{
    key: "pattern",
    value: function pattern2() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
  return Type2;
}();
function getType(types, type3) {
  switch (type3) {
    case "FIXED_LINE":
      return types[0];
    case "MOBILE":
      return types[1];
    case "TOLL_FREE":
      return types[2];
    case "PREMIUM_RATE":
      return types[3];
    case "PERSONAL_NUMBER":
      return types[4];
    case "VOICEMAIL":
      return types[5];
    case "UAN":
      return types[6];
    case "PAGER":
      return types[7];
    case "VOIP":
      return types[8];
    case "SHARED_COST":
      return types[9];
  }
}
function validateMetadata(metadata2) {
  if (!metadata2) {
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  }
  if (!isObject(metadata2) || !isObject(metadata2.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata2) ? "an object of shape: { " + Object.keys(metadata2).join(", ") + " }" : "a " + typeOf(metadata2) + ": " + metadata2, "."));
  }
}
var typeOf = function typeOf2(_2) {
  return _typeof$2(_2);
};
function getCountryCallingCode(country, metadata2) {
  metadata2 = new Metadata(metadata2);
  if (metadata2.hasCountry(country)) {
    return metadata2.country(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata2) {
  return metadata2.countries.hasOwnProperty(country);
}
function setVersion(metadata2) {
  var version2 = metadata2.version;
  if (typeof version2 === "number") {
    this.v1 = version2 === 1;
    this.v2 = version2 === 2;
    this.v3 = version2 === 3;
    this.v4 = version2 === 4;
  } else {
    if (!version2) {
      this.v1 = true;
    } else if (compare(version2, V3) === -1) {
      this.v2 = true;
    } else if (compare(version2, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}
function checkNumberLength(nationalNumber, metadata2) {
  return checkNumberLengthForType(nationalNumber, void 0, metadata2);
}
function checkNumberLengthForType(nationalNumber, type3, metadata2) {
  var type_info = metadata2.type(type3);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata2.possibleLengths();
  if (!possible_lengths) {
    return "IS_POSSIBLE";
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return "IS_POSSIBLE";
  }
  if (minimum_length > actual_length) {
    return "TOO_SHORT";
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return "TOO_LONG";
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function isPossiblePhoneNumber(input, options, metadata2) {
  if (options === void 0) {
    options = {};
  }
  metadata2 = new Metadata(metadata2);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error("Invalid phone number object passed");
    }
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata2.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata2.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error("Invalid phone number object passed");
      }
      metadata2.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata2.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata2);
  } else {
    if (input.countryCallingCode && metadata2.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "IS_POSSIBLE":
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return false;
  }
}
function matchesEntirely(text, regular_expression) {
  text = text || "";
  return new RegExp("^(?:" + regular_expression + ")$").test(text);
}
function _createForOfIteratorHelperLoose$3(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it2) return (it2 = it2.call(o2)).next.bind(it2);
  if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$4(o2)) || allowArrayLike) {
    if (it2) o2 = it2;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length) return { done: true };
      return { done: false, value: o2[i2++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$4(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$4(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$4(o2, minLen);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata2) {
  options = options || {};
  if (!input.country && !input.countryCallingCode) {
    return;
  }
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata2)) {
    if (metadata2.type("MOBILE") && metadata2.type("MOBILE").pattern() === "") {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (!metadata2.type("MOBILE")) {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata2)) {
      return "FIXED_LINE_OR_MOBILE";
    }
    return "FIXED_LINE";
  }
  for (var _iterator = _createForOfIteratorHelperLoose$3(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done; ) {
    var type3 = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type3, metadata2)) {
      return type3;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type3, metadata2) {
  type3 = metadata2.type(type3);
  if (!type3 || !type3.pattern()) {
    return false;
  }
  if (type3.possibleLengths() && type3.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type3.pattern());
}
function isValidNumber(input, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata2.hasTypes()) {
    return getNumberType(input, options, metadata2.metadata) !== void 0;
  }
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata2.nationalNumberPattern());
}
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata2) {
  var _metadata = new Metadata(metadata2);
  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return [];
  }
  return possibleCountries.filter(function(country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata2);
  });
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata2) {
  var _metadata = new Metadata(metadata2);
  _metadata.selectNumberingPlan(country);
  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }
  return false;
}
var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9０-９٠-٩۰-۹";
var DASHES = "-‐-―−ー－";
var SLASHES = "／/";
var DOTS = "．.";
var WHITESPACE = "  ­​⁠　";
var BRACKETS = "()（）［］\\[\\]";
var TILDES = "~⁓∼～";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+＋";
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number2, country, callingCode, metadata2) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number2.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number2 = number2.slice(number2.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number2.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === "0") {
      return;
    }
  }
  return number2;
}
function extractNationalNumberFromPossiblyIncompleteNumber(number2, metadata2) {
  if (number2 && metadata2.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata2.numberingPlan.nationalPrefixForParsing() + ")");
    var prefixMatch = prefixPattern.exec(number2);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata2.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number2.replace(prefixPattern, metadata2.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number2.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number2.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number2.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata2.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata2.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number2
  };
}
function extractNationalNumber(number2, metadata2) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number2, metadata2), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number2) {
    if (!shouldHaveExtractedNationalPrefix(number2, nationalNumber, metadata2)) {
      return {
        nationalNumber: number2
      };
    }
    if (metadata2.possibleLengths()) {
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata2)) {
        return {
          nationalNumber: number2
        };
      }
    }
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata2) {
  if (matchesEntirely(nationalNumberBefore, metadata2.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata2.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return false;
    default:
      return true;
  }
}
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number2, country, callingCode, metadata2) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata2) : callingCode;
  if (number2.indexOf(countryCallingCode) === 0) {
    metadata2 = new Metadata(metadata2);
    metadata2.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number2.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata2), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number2, metadata2), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata2.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata2) === "TOO_LONG") {
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number: number2
  };
}
function extractCountryCallingCode(number2, country, callingCode, metadata2) {
  if (!number2) {
    return {};
  }
  var isNumberWithIddPrefix;
  if (number2[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number2, country, callingCode, metadata2);
    if (numberWithoutIDD && numberWithoutIDD !== number2) {
      isNumberWithIddPrefix = true;
      number2 = "+" + numberWithoutIDD;
    } else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number2, country, callingCode, metadata2), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number2
      };
    }
  }
  if (number2[1] === "0") {
    return {};
  }
  metadata2 = new Metadata(metadata2);
  var i2 = 2;
  while (i2 - 1 <= MAX_LENGTH_COUNTRY_CODE && i2 <= number2.length) {
    var _countryCallingCode = number2.slice(1, i2);
    if (metadata2.hasCallingCode(_countryCallingCode)) {
      metadata2.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: _countryCallingCode,
        number: number2.slice(i2)
      };
    }
    i2++;
  }
  return {};
}
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number2, format2, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix;
  var formattedNumber = number2.replace(new RegExp(format2.pattern()), useInternationalFormat ? format2.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format2.nationalPrefixFormattingRule() ? format2.format().replace(FIRST_GROUP_PATTERN, format2.nationalPrefixFormattingRule()) : format2.format()
  ));
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata2) {
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
var RFC3966_EXTN_PREFIX = ";ext=";
var getExtensionDigitsPattern = function getExtensionDigitsPattern2(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20";
  var extLimitAfterLikelyLabel = "15";
  var extLimitAfterAmbiguousChar = "9";
  var extLimitWhenNotSure = "6";
  var possibleSeparatorsBetweenNumberAndExtLabel = "[  \\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.．]?[  \\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)";
  var ambiguousExtLabels = "(?:[xｘ#＃~～]|int|ｉｎｔ)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[  \\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
"(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
  // Either a short two-digit-only phone number
  "^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$",
  "i"
);
function isViablePhoneNumber(number2) {
  return number2.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number2);
}
function isViablePhoneNumberStart(number2) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number2);
}
function formatRFC3966(_ref) {
  var number2 = _ref.number, ext = _ref.ext;
  if (!number2) {
    return "";
  }
  if (number2[0] !== "+") {
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  }
  return "tel:".concat(number2).concat(ext ? ";ext=" + ext : "");
}
function _createForOfIteratorHelperLoose$2(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it2) return (it2 = it2.call(o2)).next.bind(it2);
  if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$3(o2)) || allowArrayLike) {
    if (it2) o2 = it2;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length) return { done: true };
      return { done: false, value: o2[i2++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$3(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$3(o2, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function ownKeys$5(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread$4(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$5(Object(source), true).forEach(function(key) {
      _defineProperty$5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata2) {
    return "".concat(formattedNumber).concat(metadata2.ext()).concat(extension);
  }
};
function formatNumber(input, format2, options, metadata2) {
  if (options) {
    options = _objectSpread$4(_objectSpread$4({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata2 = new Metadata(metadata2);
  if (input.country && input.country !== "001") {
    if (!metadata2.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata2.country(input.country);
  } else if (input.countryCallingCode) {
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || "";
  var countryCallingCode = metadata2.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number2;
  switch (format2) {
    case "NATIONAL":
      if (!nationalNumber) {
        return "";
      }
      number2 = formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata2, options);
      return addExtension(number2, input.ext, metadata2, options.formatExtension);
    case "INTERNATIONAL":
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number2 = formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2, options);
      number2 = "+".concat(countryCallingCode, " ").concat(number2);
      return addExtension(number2, input.ext, metadata2, options.formatExtension);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata2);
      return addExtension(formattedNumber, input.ext, metadata2, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format2, '"'));
  }
}
function formatNationalNumber(number2, carrierCode, formatAs, metadata2, options) {
  var format2 = chooseFormatForNumber(metadata2.formats(), number2);
  if (!format2) {
    return number2;
  }
  return formatNationalNumberUsingFormat(number2, format2, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: format2.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true
  });
}
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$2(availableFormats), _step; !(_step = _iterator()).done; ) {
    var format2 = _step.value;
    if (format2.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format2.leadingDigitsPatterns()[format2.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    }
    if (matchesEntirely(nationalNnumber, format2.pattern())) {
      return format2;
    }
  }
}
function addExtension(formattedNumber, ext, metadata2, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata2) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata2) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata2.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata2);
    if (countryCallingCode === "1") {
      return countryCallingCode + " " + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata2.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2));
  }
}
function ownKeys$4(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread$3(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$4(Object(source), true).forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props2) {
  for (var i2 = 0; i2 < props2.length; i2++) {
    var descriptor = props2[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryOrCountryCallingCode, nationalNumber, metadata2) {
    _classCallCheck$1(this, PhoneNumber2);
    if (!countryOrCountryCallingCode) {
      throw new TypeError("First argument is required");
    }
    if (typeof countryOrCountryCallingCode !== "string") {
      throw new TypeError("First argument must be a string");
    }
    if (typeof countryOrCountryCallingCode === "string") {
      if (countryOrCountryCallingCode[0] === "+" && !nationalNumber) {
        throw new TypeError("`metadata` argument not passed");
      }
      if (isObject(nationalNumber) && isObject(nationalNumber.countries)) {
        metadata2 = nationalNumber;
        var e164Number = countryOrCountryCallingCode;
        if (!E164_NUMBER_REGEXP.test(e164Number)) {
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        }
        var _extractCountryCallin = extractCountryCallingCode(e164Number, void 0, void 0, metadata2), _countryCallingCode = _extractCountryCallin.countryCallingCode, number2 = _extractCountryCallin.number;
        nationalNumber = number2;
        countryOrCountryCallingCode = _countryCallingCode;
        if (!nationalNumber) {
          throw new Error("Invalid `number` argument passed: too short");
        }
      }
    }
    if (!nationalNumber) {
      throw new TypeError("`nationalNumber` argument is required");
    }
    if (typeof nationalNumber !== "string") {
      throw new TypeError("`nationalNumber` argument must be a string");
    }
    validateMetadata(metadata2);
    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata2), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = "+" + this.countryCallingCode + this.nationalNumber;
    this.getMetadata = function() {
      return metadata2;
    };
  }
  _createClass$1(PhoneNumber2, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }
      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata2 = new Metadata(this.getMetadata());
      return metadata2.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function getType2() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format2(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$3(_objectSpread$3({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format("NATIONAL", options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format("INTERNATIONAL", options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format("RFC3966", options);
    }
  }]);
  return PhoneNumber2;
}();
var isCountryCode = function isCountryCode2(value) {
  return /^[A-Z]{2}$/.test(value);
};
function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata2 = new Metadata(metadataJson);
  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata2.selectNumberingPlan(country);
    countryCallingCode = metadata2.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
  }
  return {
    country,
    countryCallingCode
  };
}
var E164_NUMBER_REGEXP = /^\+\d+$/;
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _createClass(Constructor, protoProps, staticProps) {
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result2);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2)) return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2)) return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a2 = [null];
      a2.push.apply(a2, args2);
      var Constructor = Function.bind.apply(Parent2, a2);
      var instance = new Constructor();
      if (Class2) _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
var ParseError = /* @__PURE__ */ function(_Error) {
  _inherits(ParseError2, _Error);
  var _super = _createSuper(ParseError2);
  function ParseError2(code) {
    var _this;
    _classCallCheck(this, ParseError2);
    _this = _super.call(this, code);
    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError2.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass(ParseError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number2) {
  var start = number2.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  var numberWithoutExtension = number2.slice(0, start);
  var matches2 = number2.match(EXTN_PATTERN);
  var i2 = 1;
  while (i2 < matches2.length) {
    if (matches2[i2]) {
      return {
        number: numberWithoutExtension,
        ext: matches2[i2]
      };
    }
    i2++;
  }
}
var DIGITS = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function parseDigit(character) {
  return DIGITS[character];
}
function _createForOfIteratorHelperLoose$1(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it2) return (it2 = it2.call(o2)).next.bind(it2);
  if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$2(o2)) || allowArrayLike) {
    if (it2) o2 = it2;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length) return { done: true };
      return { done: false, value: o2[i2++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$2(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$2(o2, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function parseIncompletePhoneNumber(string2) {
  var result2 = "";
  for (var _iterator = _createForOfIteratorHelperLoose$1(string2.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  if (character === "+") {
    if (prevParsedCharacters) {
      return;
    }
    return "+";
  }
  return parseDigit(character);
}
function _createForOfIteratorHelperLoose(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it2) return (it2 = it2.call(o2)).next.bind(it2);
  if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$1(o2)) || allowArrayLike) {
    if (it2) o2 = it2;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length) return { done: true };
      return { done: false, value: o2[i2++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$1(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$1(o2, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries, metadata2 = _ref.metadata;
  metadata2 = new Metadata(metadata2);
  for (var _iterator = _createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done; ) {
    var country = _step.value;
    metadata2.country(country);
    if (metadata2.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata2.leadingDigits()) === 0) {
        return country;
      }
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata2.metadata)) {
      return country;
    }
  }
}
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber, metadata2 = _ref.metadata;
  var possibleCountries = metadata2.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    metadata: metadata2.metadata
  });
}
var PLUS_SIGN = "+";
var RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")";
var RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$";
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g");
var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var VALID_ALPHA_ = "a-zA-Z";
var RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$";
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g");
var RFC3966_PREFIX_ = "tel:";
var RFC3966_PHONE_CONTEXT_ = ";phone-context=";
var RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  if (indexOfPhoneContext < 0) {
    return null;
  }
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  if (phoneContextStart >= numberToExtractFrom.length) {
    return "";
  }
  var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart);
  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }
  if (phoneContext.length === 0) {
    return false;
  }
  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError("NOT_A_NUMBER");
  }
  var phoneNumberString;
  if (phoneContext === null) {
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
  } else {
    phoneNumberString = "";
    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    }
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber;
    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  }
  if (phoneNumberString !== "") {
    return phoneNumberString;
  }
}
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse(text, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  if (options.defaultCountry && !metadata2.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === "TOO_SHORT") {
        throw new ParseError("TOO_SHORT");
      }
      throw new ParseError("NOT_A_NUMBER");
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber$3(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata2), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata2.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_SHORT");
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_LONG");
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata2.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  }
  var valid = (options.extended ? metadata2.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? true : options.extended === true && metadata2.possibleLengths() && isPossibleNumber(nationalNumber, metadata2) ? true : false,
    phone: nationalNumber,
    ext
  };
}
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError("TOO_LONG");
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
function parseInput(text, v2, extract) {
  var number2 = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text2) {
      return _extractFormattedPhoneNumber(text2, extract, v2);
    }
  });
  if (!number2) {
    return {};
  }
  if (!isViablePhoneNumber(number2)) {
    if (isViablePhoneNumberStart(number2)) {
      return {
        error: "TOO_SHORT"
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number2);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number: number2
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function parsePhoneNumber$3(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata2) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata2.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number2 = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata2.selectNumberingPlan(countryCallingCode);
  } else if (number2 && (defaultCountry || defaultCallingCode)) {
    metadata2.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata2.metadata);
  } else return {};
  if (!number2) {
    return {
      countryCallingCodeSource,
      countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number2), metadata2), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber,
    metadata: metadata2
  });
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === "001") ;
    else {
      metadata2.country(country);
    }
  }
  return {
    country,
    countryCallingCode,
    countryCallingCodeSource,
    nationalNumber,
    carrierCode
  };
}
function ownKeys$3(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread$2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$3(Object(source), true).forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumberWithError(text, options, metadata2) {
  return parse(text, _objectSpread$2(_objectSpread$2({}, options), {}, {
    v2: true
  }), metadata2);
}
function ownKeys$2(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2) break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata2;
  if (typeof arg_1 === "string") {
    text = arg_1;
  } else throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 === "string") {
    if (arg_4) {
      options = arg_3;
      metadata2 = arg_4;
    } else {
      options = void 0;
      metadata2 = arg_3;
    }
    if (arg_2) {
      options = _objectSpread$1({
        defaultCountry: arg_2
      }, options);
    }
  } else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata2 = arg_3;
    } else {
      metadata2 = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text,
    options,
    metadata: metadata2
  };
}
function ownKeys$1(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumber$2(text, options, metadata2) {
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata2)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      defaultCountry: void 0
    });
  }
  try {
    return parsePhoneNumberWithError(text, options, metadata2);
  } catch (error) {
    if (error instanceof ParseError) ;
    else {
      throw error;
    }
  }
}
function parsePhoneNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata2 = _normalizeArguments.metadata;
  return parsePhoneNumber$2(text, options, metadata2);
}
function parsePhoneNumber() {
  return withMetadataArgument(parsePhoneNumber$1, arguments);
}
const _hoisted_1$y = ["aria-expanded"];
const _hoisted_2$n = { class: "flex gap-05 country-code-display" };
const _hoisted_3$k = { class: "p-075 tel-countryp-dropdown" };
const _hoisted_4$c = {
  class: "overflow-y p-0 max-h-300px",
  role: "listbox"
};
const _hoisted_5$c = ["aria-selected", "onClick"];
const _hoisted_6$a = { class: "tel-country" };
const _hoisted_7$8 = ["id", "required", "placeholder", "disabled", "name"];
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  __name: "PhoneInput",
  props: {
    id: {},
    label: {},
    modelValue: {},
    placeholder: {},
    excludeCountries: {},
    onlyCountries: {},
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "blur", "focus", "keydown", "input", "paste"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    let phoneNumber = ref(props2.modelValue);
    let search = ref("");
    let activeCountry = ref();
    const searchInput = ref();
    let open = ref(false);
    const inputRef = ref(null);
    let isValid = ref(true);
    watch(() => phoneNumber.value, (newValue) => {
      emit2("update:modelValue", newValue);
    });
    watch(() => props2.modelValue, (newValue) => {
      if (newValue !== phoneNumber.value) {
        phoneNumber.value = newValue;
      }
    });
    const countries = computed(() => {
      let filteredCountries = allCountries;
      if (props2.excludeCountries && props2.excludeCountries.length) {
        const excludeCountries = props2.excludeCountries.map((c2) => c2.toLowerCase());
        filteredCountries = filteredCountries.filter((c2) => !excludeCountries.includes(c2.iso2.toLowerCase()));
      }
      if (props2.onlyCountries && props2.onlyCountries.length) {
        const onlyCountries = props2.onlyCountries.map((c2) => c2.toLowerCase());
        filteredCountries = filteredCountries.filter((c2) => onlyCountries.includes(c2.iso2.toLowerCase()));
      }
      if (search.value.length) {
        const lowerCaseSearch = search.value.toLowerCase();
        filteredCountries = filteredCountries.filter(
          (c2) => c2.name.toLowerCase().includes(lowerCaseSearch) || c2.iso2.toLowerCase().includes(lowerCaseSearch) || c2.dialCode.includes(search.value)
        );
      }
      return filteredCountries;
    });
    const activeCountryCode = computed(() => {
      var _a;
      return (_a = activeCountry.value) == null ? void 0 : _a.iso2;
    });
    function selectCountry(country) {
      activeCountry.value = country;
      open.value = false;
      search.value = "";
      if (!phoneNumber.value) phoneNumber.value = `+${activeCountry.value.dialCode}`;
    }
    async function getIp() {
      let apiData = sessionStorage.getItem("ipapi");
      if (!apiData) {
        apiData = (await axios$1.get("https://ipapi.co/json/")).data;
        apiData = JSON.stringify(apiData);
        sessionStorage.setItem("ipapi", apiData);
      }
      const { country_code } = JSON.parse(apiData);
      selectCountry(countries.value.find((c2) => c2.iso2 === country_code) ?? countries.value[0]);
    }
    function getCountryCode() {
      var _a;
      return ((_a = activeCountry.value) == null ? void 0 : _a.iso2) ? activeCountry.value.iso2.toUpperCase() : void 0;
    }
    function parseAndFormatPhoneNumber(value) {
      if (!value) return value;
      try {
        const parsedNumber = parsePhoneNumber(value, getCountryCode());
        if (parsedNumber && parsedNumber.isValid()) {
          return parsedNumber.formatInternational();
        }
      } catch (error) {
        console.error("Error parsing phone number:", error);
      }
      return value;
    }
    function validatePhoneNumber() {
      if (!inputRef.value) return;
      try {
        const parsedNumber = parsePhoneNumber(phoneNumber.value, getCountryCode());
        if (parsedNumber && parsedNumber.isValid()) {
          inputRef.value.setCustomValidity("");
          isValid.value = true;
        } else {
          inputRef.value.setCustomValidity("Please enter a valid phone number");
          isValid.value = false;
        }
      } catch (error) {
        inputRef.value.setCustomValidity("Please enter a valid phone number");
        isValid.value = false;
      }
    }
    function detectCountryFromNumber(value) {
      if (!value.startsWith("+")) return false;
      const digits = value.replace(/\D/g, "");
      if (digits.length <= 1) return false;
      for (const country of countries.value) {
        if (digits.startsWith(country.dialCode) && country !== activeCountry.value) {
          selectCountry(country);
          return true;
        }
      }
      return false;
    }
    async function initializeCountry() {
      if (phoneNumber.value) {
        detectCountryFromNumber(phoneNumber.value);
      } else {
        await getIp();
      }
      const formatted = parseAndFormatPhoneNumber(phoneNumber.value);
      if (formatted !== phoneNumber.value) {
        phoneNumber.value = formatted;
        emit2("input", phoneNumber.value);
        validatePhoneNumber();
      }
      validatePhoneNumber();
    }
    function handlePhoneInput(event) {
      const input = event.target;
      const { value } = input;
      detectCountryFromNumber(value);
      if (value.startsWith("+")) {
        const formatted = parseAndFormatPhoneNumber(value);
        if (formatted !== value) {
          phoneNumber.value = formatted;
          emit2("input", event);
          validatePhoneNumber();
          return;
        }
      }
      phoneNumber.value = value;
      emit2("input", event);
      validatePhoneNumber();
    }
    function handleBlur(event) {
      if (phoneNumber.value && !phoneNumber.value.startsWith("+") && activeCountry.value) {
        const nationalNumber = phoneNumber.value.replace(/^0+/, "");
        phoneNumber.value = `+${activeCountry.value.dialCode} ${nationalNumber}`;
      } else if (phoneNumber.value) {
        phoneNumber.value = parseAndFormatPhoneNumber(phoneNumber.value);
      }
      validatePhoneNumber();
      emit2("blur", event);
    }
    const disableDropdown = computed(() => countries.value.length === 1 && !search.value);
    const searchable = computed(() => countries.value.length > 7 || search.value);
    function focusSearchInput() {
      setTimeout(() => {
        var _a;
        return (_a = searchInput.value) == null ? void 0 : _a.focus();
      }, 100);
    }
    onMounted(initializeCountry);
    return (_ctx, _cache) => {
      const _directive_pattern = resolveDirective("pattern");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bagel-input text-input", { invalid: !unref(isValid) }])
      }, [
        createElementVNode("label", null, [
          createTextVNode(toDisplayString(_ctx.label) + " ", 1),
          createElementVNode("div", {
            dir: "ltr",
            class: "flex gap-05 tel-input",
            tabindex: "-1",
            "aria-label": "Country Code Selector",
            "aria-haspopup": "listbox",
            "aria-expanded": unref(open)
          }, [
            createVNode(unref(_sfc_main$W), {
              shown: unref(open),
              "onUpdate:shown": _cache[1] || (_cache[1] = ($event) => isRef(open) ? open.value = $event : open = $event),
              placement: "bottom-start",
              disabled: disableDropdown.value,
              onShow: focusSearchInput
            }, {
              trigger: withCtx(() => [
                createElementVNode("span", _hoisted_2$n, [
                  !disableDropdown.value ? (openBlock(), createBlock(unref(_sfc_main$s), {
                    key: 0,
                    icon: unref(open) ? "collapse_all" : "expand_all"
                  }, null, 8, ["icon"])) : createCommentVNode("", true),
                  activeCountryCode.value ? (openBlock(), createBlock(unref(Flag), {
                    key: 1,
                    country: activeCountryCode.value
                  }, null, 8, ["country"])) : createCommentVNode("", true)
                ])
              ]),
              default: withCtx(() => [
                createElementVNode("div", _hoisted_3$k, [
                  searchable.value ? (openBlock(), createBlock(unref(TextInput), {
                    key: 0,
                    ref_key: "searchInput",
                    ref: searchInput,
                    modelValue: unref(search),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(search) ? search.value = $event : search = $event),
                    "aria-label": "Search by country name or country code",
                    placeholder: "Search",
                    icon: "search"
                  }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                  createElementVNode("ul", _hoisted_4$c, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(countries.value, (pb) => {
                      return openBlock(), createElementBlock("li", {
                        key: pb.iso2,
                        role: "option",
                        class: "flex gap-075 pointer hover",
                        tabindex: "-1",
                        "aria-selected": activeCountryCode.value === pb.iso2,
                        onClick: ($event) => selectCountry(pb)
                      }, [
                        createVNode(unref(Flag), {
                          country: pb.iso2
                        }, null, 8, ["country"]),
                        createElementVNode("p", _hoisted_6$a, toDisplayString(pb.name), 1),
                        createElementVNode("span", null, " +" + toDisplayString(pb.dialCode), 1)
                      ], 8, _hoisted_5$c);
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["shown", "disabled"]),
            withDirectives(createElementVNode("input", {
              id: _ctx.id,
              ref_key: "inputRef",
              ref: inputRef,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isRef(phoneNumber) ? phoneNumber.value = $event : phoneNumber = $event),
              required: _ctx.required,
              placeholder: _ctx.placeholder || _ctx.label || "Phone Number",
              disabled: _ctx.disabled,
              type: "tel",
              autocomplete: "tel",
              name: _ctx.id,
              tabindex: "0",
              class: "national-number-input",
              onBlur: _cache[3] || (_cache[3] = ($event) => handleBlur($event)),
              onFocus: _cache[4] || (_cache[4] = ($event) => emit2("focus", $event)),
              onKeydown: _cache[5] || (_cache[5] = ($event) => emit2("keydown", $event)),
              onInput: _cache[6] || (_cache[6] = ($event) => handlePhoneInput($event)),
              onPaste: _cache[7] || (_cache[7] = ($event) => emit2("paste", $event))
            }, null, 40, _hoisted_7$8), [
              [vModelText, unref(phoneNumber)],
              [
                _directive_pattern,
                void 0,
                void 0,
                { tel: true }
              ]
            ])
          ], 8, _hoisted_1$y)
        ])
      ], 2);
    };
  }
});
const TelInput = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["__scopeId", "data-v-ea318aee"]]);
const _hoisted_1$x = ["for"];
const _hoisted_2$m = ["id", "disabled", "name", "value", "required"];
const _hoisted_3$j = { class: "flex w-100 gap-1 flex-wrap m_gap-05 m_gap-row-025" };
const _hoisted_4$b = ["src", "alt"];
const _hoisted_5$b = { class: "" };
const _hoisted_6$9 = {
  key: 0,
  class: "m-0 m_txt-14"
};
const _hoisted_7$7 = {
  key: 1,
  class: "txt-gray txt-12 m-0"
};
const _sfc_main$E = /* @__PURE__ */ defineComponent({
  __name: "RadioGroup",
  props: /* @__PURE__ */ mergeModels({
    groupName: {},
    options: {},
    deletable: { type: Boolean },
    required: { type: Boolean },
    error: {},
    disabled: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["delete", "focus", "blur", "change"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const name = computed(() => props2.groupName || Math.random().toString(36).substring(2, 15));
    const selectedOption = useModel(__props, "modelValue");
    let isFocused = ref(false);
    const containerClasses = computed(() => ({
      "has-error": !!props2.error,
      "is-disabled": props2.disabled,
      "is-focused": isFocused.value
    }));
    function handleFocus() {
      isFocused.value = true;
      emit2("focus");
    }
    function handleBlur() {
      isFocused.value = false;
      emit2("blur");
    }
    function handleChange() {
      emit2("change", selectedOption.value);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(containerClasses.value)
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (opt, index2) => {
          return openBlock(), createElementBlock("label", {
            key: opt.id || `${name.value}-${index2}`,
            class: "border rounded p-1 flex bg-gray-light mb-05 gap-075 active-list-item hover",
            for: opt.id || `${name.value}-${index2}`
          }, [
            withDirectives(createElementVNode("input", {
              id: opt.id || `${name.value}-${index2}`,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectedOption.value = $event),
              disabled: _ctx.disabled,
              class: "radio-input-list",
              type: "radio",
              name: name.value,
              value: opt.value,
              required: _ctx.required,
              onFocus: handleFocus,
              onBlur: handleBlur,
              onChange: handleChange
            }, null, 40, _hoisted_2$m), [
              [vModelRadio, selectedOption.value]
            ]),
            createElementVNode("div", _hoisted_3$j, [
              opt.imgSrc ? (openBlock(), createElementBlock("img", {
                key: 0,
                class: "bg-popup shadow-light py-025 radius-05 m_w40",
                width: "60",
                src: opt.imgSrc,
                alt: opt.imgAlt
              }, null, 8, _hoisted_4$b)) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_5$b, [
                opt.label ? (openBlock(), createElementBlock("p", _hoisted_6$9, toDisplayString(opt.label), 1)) : createCommentVNode("", true),
                opt.subLabel ? (openBlock(), createElementBlock("p", _hoisted_7$7, toDisplayString(opt.subLabel), 1)) : createCommentVNode("", true)
              ]),
              renderSlot(_ctx.$slots, "radioItem", mergeProps({ ref_for: true }, opt), void 0, true)
            ]),
            _ctx.deletable ? (openBlock(), createBlock(unref(Btn), {
              key: 0,
              class: "ms-auto",
              flat: "",
              thin: "",
              icon: "delete",
              onClick: ($event) => _ctx.$emit("delete", opt)
            }, null, 8, ["onClick"])) : createCommentVNode("", true)
          ], 8, _hoisted_1$x);
        }), 128))
      ], 2);
    };
  }
});
const RadioGroup = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["__scopeId", "data-v-a692c596"]]);
const _hoisted_1$w = { class: "bagel-input" };
const _hoisted_2$l = { class: "pb-025" };
const _hoisted_3$i = { class: "flex gap-05 flex-wrap" };
const _hoisted_4$a = ["id", "name", "value", "checked"];
const _hoisted_5$a = ["for"];
const _sfc_main$D = /* @__PURE__ */ defineComponent({
  __name: "RadioPillsInput",
  props: {
    options: {},
    modelValue: { default: "" },
    id: { default: () => `radio-pill-${Math.random().toString(36).slice(2, 9)}` },
    label: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emits = __emit;
    function getLabel(option2) {
      if (typeof option2 === "string") return option2;
      if (typeof option2 === "number") return `${option2}`;
      if (typeof option2 === "boolean") return option2 ? "Yes" : "No";
      return option2.label;
    }
    function getValue(option2) {
      if (typeof option2 === "string") return option2;
      if (typeof option2 === "number") return option2;
      if (typeof option2 === "boolean") return option2 ? "Yes" : "No";
      return option2.value;
    }
    let selectedValue = ref(props2.modelValue);
    function handleSelect(e) {
      var _a;
      const newVal = (_a = e.target) == null ? void 0 : _a.value;
      emits("update:modelValue", newVal);
      selectedValue.value = newVal;
    }
    watch(
      () => props2.modelValue,
      (newVal, oldVal) => {
        if (newVal === oldVal || oldVal === void 0) return;
        if (selectedValue.value !== newVal) selectedValue.value = newVal;
      },
      { immediate: true }
    );
    onMounted(() => {
      selectedValue.value = props2.modelValue;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$w, [
        createElementVNode("label", _hoisted_2$l, toDisplayString(_ctx.label), 1),
        createElementVNode("div", _hoisted_3$i, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option2, index2) => {
            return openBlock(), createElementBlock("div", {
              key: index2,
              class: "radio-pill"
            }, [
              createElementVNode("input", {
                id: `${_ctx.id}-${getValue(option2)}`,
                type: "radio",
                name: _ctx.id,
                value: getValue(option2),
                checked: unref(selectedValue) === getValue(option2),
                onChange: handleSelect
              }, null, 40, _hoisted_4$a),
              createElementVNode("label", {
                for: `${_ctx.id}-${getValue(option2)}`
              }, toDisplayString(getLabel(option2)), 9, _hoisted_5$a)
            ]);
          }), 128))
        ])
      ]);
    };
  }
});
const RadioPillsInput = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["__scopeId", "data-v-68b4cdd0"]]);
const _hoisted_1$v = ["dir"];
const _hoisted_2$k = {
  key: 0,
  class: "label"
};
const _hoisted_3$h = { class: "range-slider relative w-100" };
const _hoisted_4$9 = ["id", "value", "min", "max", "step", "required", "disabled", "aria-label"];
const _hoisted_5$9 = ["value", "min", "max", "step", "required", "disabled"];
const _hoisted_6$8 = { class: "track absolute pointer-events-none overflow-hidden round" };
const _hoisted_7$6 = { class: "txt-center txt-14 user-select-none range-slider-txt flex space-between opacity-4 mx-05" };
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "RangeInput",
  props: {
    modelValue: {},
    min: {},
    max: {},
    step: {},
    required: { type: Boolean },
    label: {},
    disabled: { type: Boolean },
    id: {},
    rtl: { type: Boolean },
    multiRange: { type: Boolean },
    formatValue: { type: Function }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const {
      min: min2 = 0,
      max: max2 = 100,
      step = 1,
      multiRange = false,
      formatValue = (value) => value.toString()
    } = props2;
    let from = ref(Array.isArray(props2.modelValue) ? props2.modelValue[0] : props2.modelValue ?? min2);
    let to = ref(Array.isArray(props2.modelValue) ? props2.modelValue[1] : max2);
    const validFrom = computed(() => Math.min(Math.max(from.value, min2), multiRange ? to.value : max2));
    const validTo = computed(() => Math.max(Math.min(to.value, max2), from.value));
    const fromPercentage = computed(() => (validFrom.value - min2) / (max2 - min2) * 100);
    const toPercentage = computed(() => (validTo.value - min2) / (max2 - min2) * 100);
    watch(() => props2.modelValue, (newVal) => {
      if (Array.isArray(newVal) && multiRange) {
        from.value = newVal[0] ?? min2;
        to.value = newVal[1] ?? max2;
      } else if (!Array.isArray(newVal)) {
        from.value = newVal ?? min2;
        to.value = max2;
      }
    }, { immediate: true });
    function handleInput(value, isFromInput) {
      if (isFromInput) {
        from.value = value;
      } else {
        to.value = value;
      }
      emit2("update:modelValue", multiRange ? [validFrom.value, validTo.value] : validFrom.value);
    }
    const rangeStyle = computed(() => {
      if (multiRange) {
        return {
          left: `${fromPercentage.value}%`,
          width: `${toPercentage.value - fromPercentage.value}%`
        };
      }
      return props2.rtl ? { left: `${100 - fromPercentage.value}%`, width: `${fromPercentage.value}%` } : { left: "0", width: `${fromPercentage.value}%` };
    });
    const displayFrom = computed(() => formatValue(validFrom.value));
    const displayTo = computed(() => formatValue(validTo.value));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        dir: _ctx.rtl ? "rtl" : "ltr"
      }, [
        props2.label ? (openBlock(), createElementBlock("label", _hoisted_2$k, toDisplayString(props2.label), 1)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_3$h, [
          createElementVNode("input", {
            id: _ctx.id,
            value: validFrom.value,
            class: "from",
            type: "range",
            min: unref(min2),
            max: unref(max2),
            step: unref(step),
            required: _ctx.required,
            disabled: _ctx.disabled,
            "aria-label": unref(multiRange) ? "Minimum value" : "Value",
            onInput: _cache[0] || (_cache[0] = (e) => handleInput(+e.target.value, true))
          }, null, 40, _hoisted_4$9),
          unref(multiRange) ? (openBlock(), createElementBlock("input", {
            key: 0,
            value: validTo.value,
            class: "to",
            type: "range",
            min: unref(min2),
            max: unref(max2),
            step: unref(step),
            required: _ctx.required,
            disabled: _ctx.disabled,
            "aria-label": "Maximum value",
            onInput: _cache[1] || (_cache[1] = (e) => handleInput(+e.target.value, false))
          }, null, 40, _hoisted_5$9)) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_6$8, [
            createElementVNode("div", {
              class: "active-range absolute h-100 pointer-events-none bg-primary",
              style: normalizeStyle(rangeStyle.value)
            }, null, 4)
          ]),
          validFrom.value !== unref(min2) ? (openBlock(), createElementBlock("p", {
            key: 1,
            class: "txt-center txt-12 range-slider-position-txt absolute line-height-1",
            style: normalizeStyle({ "--progress": `${fromPercentage.value}` })
          }, [
            !unref(multiRange) ? renderSlot(_ctx.$slots, "progress", {
              key: 0,
              progress: displayFrom.value,
              min: unref(formatValue)(unref(min2)),
              max: unref(formatValue)(unref(max2))
            }, () => [
              createTextVNode(toDisplayString(displayFrom.value), 1)
            ], true) : createCommentVNode("", true),
            unref(multiRange) ? renderSlot(_ctx.$slots, "from", {
              key: 1,
              from: displayFrom.value,
              to: displayTo.value,
              min: unref(formatValue)(unref(min2)),
              max: unref(formatValue)(unref(max2))
            }, () => [
              createTextVNode(toDisplayString(displayFrom.value), 1)
            ], true) : createCommentVNode("", true)
          ], 4)) : createCommentVNode("", true),
          unref(multiRange) && validTo.value !== unref(max2) ? (openBlock(), createElementBlock("p", {
            key: 2,
            class: "txt-center txt-12 range-slider-position-txt line-height-1 absolute",
            style: normalizeStyle({ "--progress": `${toPercentage.value}` })
          }, [
            renderSlot(_ctx.$slots, "to", {
              to: displayTo.value,
              from: displayFrom.value,
              min: unref(formatValue)(unref(min2)),
              max: unref(formatValue)(unref(max2))
            }, () => [
              createTextVNode(toDisplayString(displayTo.value), 1)
            ], true)
          ], 4)) : createCommentVNode("", true)
        ]),
        createElementVNode("p", _hoisted_7$6, [
          renderSlot(_ctx.$slots, "min", {
            max: unref(formatValue)(unref(max2)),
            min: unref(formatValue)(unref(min2)),
            from: displayFrom.value,
            to: displayTo.value,
            progress: displayFrom.value
          }, () => [
            createElementVNode("span", null, toDisplayString(unref(formatValue)(unref(min2))), 1)
          ], true),
          renderSlot(_ctx.$slots, "max", {
            max: unref(formatValue)(unref(max2)),
            min: unref(formatValue)(unref(min2)),
            from: displayFrom.value,
            to: displayTo.value,
            progress: displayFrom.value
          }, () => [
            createElementVNode("span", null, toDisplayString(unref(formatValue)(unref(max2))), 1)
          ], true)
        ])
      ], 8, _hoisted_1$v);
    };
  }
});
const RangeInput = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["__scopeId", "data-v-46e22f3e"]]);
const basicToolbarConfig = [
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "separator",
  "p",
  "blockquote",
  "orderedList",
  "unorderedList",
  "separator",
  "bold",
  "italic",
  "underline",
  "separator",
  "link",
  "image",
  "embed",
  "clear",
  "splitView",
  "fullScreen"
];
const toolbarOptions = [
  { name: "h2", label: "h2", icon: "format_h2" },
  { name: "h3", label: "h3", icon: "format_h3" },
  { name: "h4", label: "h4", icon: "format_h4" },
  { name: "h5", label: "h5", icon: "format_h5" },
  { name: "h6", label: "h6", icon: "format_h6" },
  { name: "p", label: "Paragraph", icon: "format_paragraph" },
  { name: "blockquote", label: "Blockquote", icon: "format_quote" },
  { name: "bold", label: "Bold", icon: "format_bold" },
  { name: "italic", label: "Italic", icon: "format_italic" },
  { name: "underline", label: "Underline", icon: "format_underlined" },
  { name: "orderedList", label: "Ordered List", icon: "format_list_numbered" },
  { name: "unorderedList", label: "Unordered List", icon: "format_list_bulleted" },
  { name: "link", label: "Link", icon: "add_link" },
  { name: "image", label: "Image", icon: "add_photo_alternate" },
  { name: "embed", label: "Embed", icon: "media_link" },
  { name: "splitView", label: "Split View", icon: "code" },
  { name: "clear", label: "Clear Formatting", icon: "format_clear" },
  { name: "alignLeft", label: "Align Left", icon: "format_align_left" },
  { name: "alignCenter", label: "Align Center", icon: "format_align_center" },
  { name: "alignRight", label: "Align Right", icon: "format_align_right" },
  { name: "alignJustify", label: "Align Justify", icon: "format_align_justify" },
  { name: "indent", label: "Indent", icon: "format_indent_increase" },
  { name: "outdent", label: "Outdent", icon: "format_indent_decrease" },
  { name: "fontColor", label: "Font Color", icon: "format_color_text" },
  { name: "bgColor", label: "Background Color", icon: "format_color_fill" },
  { name: "insertTable", label: "Insert Table", icon: "table" },
  { name: "deleteTable", label: "Delete Table", icon: "table_rows" },
  { name: "insertRowAbove", label: "Insert Row Above", icon: "table_rows" },
  { name: "insertRowBelow", label: "Insert Row Below", icon: "table_rows" },
  { name: "deleteRow", label: "Delete Row", icon: "table_rows" },
  { name: "insertColumnLeft", label: "Insert Column Left", icon: "add_column_left" },
  { name: "insertColumnRight", label: "Insert Column Right", icon: "add_column_right" },
  { name: "deleteColumn", label: "Delete Column", icon: "view_column" },
  { name: "separator" },
  { name: "undo", label: "Undo", icon: "undo" },
  { name: "redo", label: "Redo", icon: "redo" },
  { name: "separator" },
  { name: "fullScreen", label: "Full Screen", icon: "fullscreen", class: "ms-auto" }
];
const _hoisted_1$u = { class: "grid grid-wrap p-05" };
const _hoisted_2$j = ["onMousemove", "onClick"];
const _hoisted_3$g = { class: "txt-center txt-12 color-gray" };
const fb = 1;
const base = 5;
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "gridBox",
  emits: ["select"],
  setup(__props, { emit: __emit }) {
    const emit2 = __emit;
    const hoveredRow = ref(fb);
    const hoveredCol = ref(fb);
    const rowSize = computed(() => {
      const enlarge = Math.min(hoveredRow.value + 1, 20);
      return hoveredRow.value > base - 1 ? enlarge : base;
    });
    const colSize = computed(() => {
      const enlarge = Math.min(hoveredCol.value + 1, 20);
      return hoveredCol.value > base - 1 ? enlarge : base;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$u, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(rowSize.value, (row) => {
          return openBlock(), createElementBlock("div", {
            key: `row-${row}`,
            class: "flex",
            onMouseout: _cache[0] || (_cache[0] = ($event) => {
              hoveredRow.value = fb;
              hoveredCol.value = fb;
            }),
            onFocusout: _cache[1] || (_cache[1] = ($event) => {
              hoveredRow.value = fb;
              hoveredCol.value = fb;
            })
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(colSize.value, (col) => {
              return openBlock(), createElementBlock("div", {
                key: `col-${col}`,
                role: "button",
                tabindex: "0",
                "aria-label": "Insert Table",
                style: { width: "20px", height: "20px" },
                class: normalizeClass(["flex pointer gap-025 tableBoxSelect", { borderSelect: hoveredRow.value >= row && hoveredCol.value >= col }]),
                onMousemove: ($event) => {
                  hoveredRow.value = row;
                  hoveredCol.value = col;
                },
                onClick: ($event) => emit2("select", `${row}x${col}`)
              }, null, 42, _hoisted_2$j);
            }), 128))
          ], 32);
        }), 128)),
        createElementVNode("p", _hoisted_3$g, toDisplayString(hoveredRow.value) + "x" + toDisplayString(hoveredCol.value), 1)
      ]);
    };
  }
});
const GridBox = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["__scopeId", "data-v-4548b70f"]]);
const _hoisted_1$t = {
  class: "toolbar flex gap-025 pb-05 flex-wrap",
  role: "toolbar"
};
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "EditorToolbar",
  props: {
    config: { default: basicToolbarConfig },
    selectedStyles: {}
  },
  emits: ["action"],
  setup(__props, { emit: __emit }) {
    const emit2 = __emit;
    const configToOption = (action) => toolbarOptions.find((option2) => option2.name === action);
    function runAction(name, value) {
      emit2("action", name, value);
    }
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      return openBlock(), createElementBlock("div", _hoisted_1$t, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.config.map(configToOption).filter(Boolean), (action, index2) => {
          return openBlock(), createElementBlock(Fragment, { key: index2 }, [
            action.name === "insertTable" ? (openBlock(), createBlock(unref(_sfc_main$W), {
              key: 0,
              placement: "bottom-start",
              thin: "",
              flat: "",
              icon: "table"
            }, {
              default: withCtx(({ hide }) => [
                createVNode(GridBox, {
                  gridSize: 5,
                  onSelect: ($event) => {
                    var _a;
                    runAction("insertTable", $event);
                    (_a = $event.target) == null ? void 0 : _a.blur();
                    hide();
                  }
                }, null, 8, ["onSelect"])
              ]),
              _: 1
            })) : action.name !== "separator" ? withDirectives((openBlock(), createBlock(unref(Btn), {
              key: 1,
              icon: action.icon,
              thin: "",
              flat: "",
              "aria-label": action.name,
              class: normalizeClass([[action.class, { active: _ctx.selectedStyles.has(action.name) }], ""]),
              tabindex: "-1",
              onClick: ($event) => runAction(action.name)
            }, null, 8, ["icon", "aria-label", "class", "onClick"])), [
              [_directive_tooltip, action.label]
            ]) : action.name === "separator" ? (openBlock(), createElementBlock("span", {
              key: `separator-${index2}`,
              class: "opacity-2 mb-025"
            }, "|")) : createCommentVNode("", true)
          ], 64);
        }), 128))
      ]);
    };
  }
});
const EditorToolbar = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["__scopeId", "data-v-9d8a6eb6"]]);
function isStyleActive(style, doc) {
  const selection = doc.getSelection();
  if (!selection || !selection.rangeCount) return false;
  const range2 = selection.getRangeAt(0);
  const container = range2.commonAncestorContainer;
  const parent = container.nodeType === Node.TEXT_NODE ? container.parentElement : container;
  if (!parent) return false;
  const checkParent = (element, tags2) => {
    if (!element || !element.tagName) return false;
    const tagName = element.tagName.toLowerCase();
    if (tags2.includes(tagName)) return true;
    return checkParent(element.parentElement, tags2);
  };
  const styleMappings = {
    // Inline styles
    bold: ["strong", "b"],
    italic: ["em", "i"],
    underline: ["u"],
    // Block styles
    h1: ["h1"],
    h2: ["h2"],
    h3: ["h3"],
    h4: ["h4"],
    h5: ["h5"],
    h6: ["h6"],
    p: ["p"],
    blockquote: ["blockquote"],
    // List styles
    orderedList: ["ol"],
    unorderedList: ["ul"]
  };
  if (["splitView", "codeView", "fullScreen"].includes(style)) {
    return false;
  }
  if (style === "orderedList" || style === "unorderedList") {
    const listParent = parent.closest(style === "orderedList" ? "ol" : "ul");
    return !!listParent;
  }
  const tags = styleMappings[style];
  if (tags) {
    return checkParent(parent, tags);
  }
  return checkParent(parent, [style]);
}
function analyzeSelection(doc, range2) {
  const container = range2.commonAncestorContainer;
  const parent = container.nodeType === 3 ? container.parentElement : container;
  if (!parent) return null;
  const startBlock = parent.closest("p,h1,h2,h3,h4,h5,h6,blockquote,li") || parent;
  const isMultiBlock = (() => {
    if (!range2.collapsed) {
      const { endContainer: endContainer2 } = range2;
      const endParent2 = endContainer2.nodeType === 3 ? endContainer2.parentElement : endContainer2;
      const endBlock2 = (endParent2 == null ? void 0 : endParent2.closest("p,h1,h2,h3,h4,h5,h6,blockquote,li")) || endParent2;
      return startBlock !== endBlock2;
    }
    return false;
  })();
  const { endContainer } = range2;
  const endParent = endContainer.nodeType === 3 ? endContainer.parentElement : endContainer;
  const endBlock = (endParent == null ? void 0 : endParent.closest("p,h1,h2,h3,h4,h5,h6,blockquote,li")) || endParent;
  if (!endBlock) return null;
  return {
    startBlock,
    endBlock,
    isMultiBlock,
    originalStart: range2.startContainer,
    originalEnd: range2.endContainer,
    originalStartOffset: range2.startOffset,
    originalEndOffset: range2.endOffset,
    parent
  };
}
function restoreSelection(doc, range2, selection, info, fallbackNode) {
  try {
    range2.setStart(info.originalStart, info.originalStartOffset);
    range2.setEnd(info.originalEnd, info.originalEndOffset);
  } catch (e) {
    if (fallbackNode) {
      range2.selectNodeContents(fallbackNode);
    }
  }
  selection.removeAllRanges();
  selection.addRange(range2);
}
function getBlocksBetween(startBlock, endBlock) {
  const blocks = [];
  let currentBlock = startBlock;
  while (currentBlock) {
    blocks.push(currentBlock);
    if (currentBlock === endBlock) break;
    currentBlock = currentBlock.nextElementSibling;
  }
  return blocks;
}
function formatting(state2) {
  const { doc } = state2;
  if (!doc) return { text: () => {
  }, block: () => {
  }, list: () => {
  }, clear: () => {
  } };
  const text = (command) => {
    const selection = doc.getSelection();
    if (!selection || !selection.rangeCount) return;
    const range2 = selection.getRangeAt(0);
    const container = range2.commonAncestorContainer;
    const parentBlock = container.nodeType === 3 ? container.parentElement : container;
    const isRTL = (parentBlock == null ? void 0 : parentBlock.closest('[dir="rtl"]')) !== null;
    if (parentBlock == null ? void 0 : parentBlock.tagName.match(/^H[1-6]|P|BLOCKQUOTE|LI$/)) {
      if (!range2.collapsed && range2.toString().trim()) {
        const span = doc.createElement("span");
        if (command === "underline") span.style.textDecoration = "underline";
        else if (command === "bold") span.style.fontWeight = "bold";
        else if (command === "italic") span.style.fontStyle = "italic";
        if (isRTL) span.dir = "rtl";
        range2.surroundContents(span);
      }
    } else {
      doc.execCommand(command, false);
    }
  };
  const block = (command, tag) => {
    var _a, _b;
    const selection = doc.getSelection();
    if (!selection || !selection.rangeCount) return;
    const range2 = selection.getRangeAt(0);
    const container = range2.commonAncestorContainer;
    const parentBlock = container.nodeType === 3 ? container.parentElement : container;
    const isRTL = (parentBlock == null ? void 0 : parentBlock.closest('[dir="rtl"]')) !== null;
    if (parentBlock == null ? void 0 : parentBlock.closest("u, b, i")) {
      const wrapper = parentBlock.closest("u, b, i");
      if (wrapper) {
        const parent = wrapper.parentNode;
        while (wrapper.firstChild) {
          parent == null ? void 0 : parent.insertBefore(wrapper.firstChild, wrapper);
        }
        wrapper.remove();
      }
    }
    doc.execCommand("formatBlock", false, tag);
    if (isRTL) {
      const newBlock = (_b = (_a = selection.anchorNode) == null ? void 0 : _a.parentElement) == null ? void 0 : _b.closest(tag.toLowerCase());
      if (newBlock) newBlock.dir = "rtl";
    }
  };
  const list = (command) => {
    var _a, _b, _c, _d;
    if (!state2.doc || !state2.range || !state2.selection) return;
    const listTag = command === "orderedList" ? "ol" : "ul";
    const selectionInfo = analyzeSelection(state2.doc, state2.range);
    if (!selectionInfo) return;
    const isRTL = selectionInfo.parent.closest('[dir="rtl"]') !== null;
    const listItem = selectionInfo.parent.closest("li");
    if (listItem) {
      const listParent = listItem.parentElement;
      if (!listParent) return;
      if (listParent.tagName.toLowerCase() === listTag) {
        const p2 = state2.doc.createElement("p");
        if (isRTL) p2.dir = "rtl";
        while (listItem.firstChild) {
          p2.appendChild(listItem.firstChild);
        }
        (_a = listParent.parentNode) == null ? void 0 : _a.insertBefore(p2, listParent);
        listItem.remove();
        if (!listParent.querySelector("li")) {
          listParent.remove();
        }
        restoreSelection(state2.doc, state2.range, state2.selection, selectionInfo, p2);
        return;
      }
      const newList = state2.doc.createElement(listTag);
      if (isRTL) newList.dir = "rtl";
      const allItems = Array.from(listParent.children);
      allItems.forEach((item) => newList.appendChild(item.cloneNode(true)));
      (_b = listParent.parentNode) == null ? void 0 : _b.replaceChild(newList, listParent);
      const newListItem = newList.children[Array.from(allItems).indexOf(listItem)];
      restoreSelection(state2.doc, state2.range, state2.selection, selectionInfo, newListItem);
      return;
    }
    if (!selectionInfo.isMultiBlock) {
      const li = state2.doc.createElement("li");
      const listEl2 = state2.doc.createElement(listTag);
      if (isRTL) listEl2.dir = "rtl";
      while (selectionInfo.startBlock.firstChild) {
        li.appendChild(selectionInfo.startBlock.firstChild);
      }
      listEl2.appendChild(li);
      (_c = selectionInfo.startBlock.parentNode) == null ? void 0 : _c.replaceChild(listEl2, selectionInfo.startBlock);
      restoreSelection(state2.doc, state2.range, state2.selection, selectionInfo, li);
      return;
    }
    const blocks = getBlocksBetween(selectionInfo.startBlock, selectionInfo.endBlock);
    const listEl = state2.doc.createElement(listTag);
    if (isRTL) listEl.dir = "rtl";
    blocks.forEach((block2) => {
      if (!state2.doc) return;
      const li = state2.doc.createElement("li");
      while (block2.firstChild) {
        li.appendChild(block2.firstChild);
      }
      listEl.appendChild(li);
      block2.remove();
    });
    (_d = selectionInfo.startBlock.parentNode) == null ? void 0 : _d.insertBefore(listEl, selectionInfo.startBlock);
    restoreSelection(state2.doc, state2.range, state2.selection, selectionInfo, listEl);
  };
  const clear = () => {
    if (!state2.doc || !state2.range || !state2.selection) return;
    const selectionInfo = analyzeSelection(state2.doc, state2.range);
    if (!selectionInfo) return;
    const inlineTags = ["b", "i", "u", "strong", "em", "span"];
    const fragment = state2.range.cloneContents();
    const tempDiv = state2.doc.createElement("div");
    tempDiv.appendChild(fragment);
    const cleanNode = (node) => {
      if (!state2.doc) return node;
      if (node.nodeType === 3) {
        return node.cloneNode(true);
      }
      if (node.nodeType === 1) {
        const el = node;
        const nodeName = el.nodeName.toLowerCase();
        if (inlineTags.includes(nodeName)) {
          return state2.doc.createTextNode(el.textContent || "");
        }
        const newEl = state2.doc.createElement(nodeName);
        newEl.removeAttribute("style");
        newEl.removeAttribute("class");
        Array.from(el.childNodes).forEach((child) => {
          newEl.appendChild(cleanNode(child));
        });
        return newEl;
      }
      return node.cloneNode(true);
    };
    const cleanedFragment = state2.doc.createDocumentFragment();
    Array.from(tempDiv.childNodes).forEach((node) => {
      cleanedFragment.appendChild(cleanNode(node));
    });
    state2.range.deleteContents();
    state2.range.insertNode(cleanedFragment);
    restoreSelection(state2.doc, state2.range, state2.selection, selectionInfo);
  };
  return { text, block, list, clear };
}
function insertImage(modal, state2) {
  const { range: range2, doc } = state2;
  if (!range2 || !doc) return;
  modal.showModalForm({
    title: "Upload Image",
    schema: [
      { id: "src", $el: "file", attrs: { bindkey: "url" } },
      { id: "alt", $el: "text", label: "Alt Text" },
      frmRow(
        numField("width", "Width", { min: 1 }),
        numField("height", "Height", { min: 1 })
      ),
      { id: "figcaption", $el: "check", label: "Show Caption" }
    ],
    onSubmit: (data2) => {
      if (data2.src) {
        const img = doc.createElement("img");
        Object.assign(img, {
          src: data2.src,
          alt: data2.alt || "",
          width: data2.width || void 0,
          height: data2.height || void 0
        });
        const node = data2.figcaption ? (() => {
          const figcaption = doc.createElement("figcaption");
          figcaption.textContent = data2.alt;
          const figure = doc.createElement("figure");
          figure.append(img, figcaption);
          return figure;
        })() : img;
        range2.collapse(false);
        range2.insertNode(node);
        state2.content = doc.body.innerHTML;
      }
    }
  });
}
function insertLink(modal, state2) {
  const { range: range2, doc } = state2;
  if (!range2 || !doc) return;
  modal.showModalForm({
    title: "Insert Link",
    schema: [
      { id: "url", $el: "text", label: "URL" },
      { id: "openInNewTab", $el: "check", label: "Open in new tab" }
    ],
    onSubmit: (data2) => {
      if (data2.url) {
        const anchor = doc.createElement("a");
        anchor.href = data2.url;
        if (data2.openInNewTab) anchor.target = "_blank";
        range2.surroundContents(anchor);
        state2.content = doc.body.innerHTML;
      }
    }
  });
}
function insertEmbed(modal, state2) {
  const { range: range2, doc } = state2;
  if (!range2 || !doc) return;
  modal.showModalForm({
    title: "Insert Embed",
    schema: [
      { id: "url", $el: "text", label: "URL", attrs: { placeholder: "Enter URL (YouTube, Vimeo, etc.)" } },
      frmRow(
        numField("width", "Width", { min: 200, placeholder: "560" }),
        numField("height", "Height", { min: 200, placeholder: "315" })
      ),
      { id: "allowFullscreen", $el: "check", label: "Allow Fullscreen", value: true }
    ],
    onSubmit: (data2) => {
      if (!data2.url) return;
      const url = new URL(data2.url);
      let embedUrl = data2.url;
      if (url.hostname.includes("youtube.com") || url.hostname === "youtu.be") {
        const videoId = url.hostname === "youtu.be" ? url.pathname.slice(1) : url.searchParams.get("v");
        if (videoId) {
          embedUrl = `https://www.youtube.com/embed/${videoId}`;
        }
      } else if (url.hostname.includes("vimeo.com")) {
        const videoId = url.pathname.split("/").pop();
        if (videoId) {
          embedUrl = `https://player.vimeo.com/video/${videoId}`;
        }
      }
      const iframe = doc.createElement("iframe");
      Object.assign(iframe, {
        src: embedUrl,
        width: data2.width || 560,
        height: data2.height || 315,
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullscreen: data2.allowFullscreen
      });
      const wrapper = doc.createElement("div");
      wrapper.style.textAlign = "center";
      wrapper.style.margin = "1em 0";
      wrapper.appendChild(iframe);
      range2.deleteContents();
      range2.insertNode(wrapper);
      state2.content = doc.body.innerHTML;
    }
  });
}
function insertTable(rows, cols, state2) {
  if (!state2.doc) return;
  const table = state2.doc.createElement("table");
  table.style.width = "100%";
  table.style.borderCollapse = "collapse";
  for (let i2 = 0; i2 < rows; i2++) {
    const row = table.insertRow();
    for (let j = 0; j < cols; j++) {
      const cell = row.insertCell();
      cell.innerHTML = "&nbsp;";
    }
  }
  const { range: range2 } = state2;
  if (range2) {
    range2.insertNode(table);
  } else {
    state2.doc.body.appendChild(table);
  }
  state2.content = state2.doc.body.innerHTML;
}
function mergeCells(range2, doc) {
  var _a;
  const cells = Array.from(range2.cloneContents().querySelectorAll("td"));
  if (cells.length < 2) return;
  const firstCell = (_a = range2.startContainer.parentElement) == null ? void 0 : _a.closest("td");
  if (!firstCell) return;
  firstCell.colSpan = cells.length;
  firstCell.innerHTML = cells.map((cell) => cell.innerHTML).join(" ");
  cells.slice(1).forEach((cell) => {
    const actualCell = doc.getElementById(cell.id);
    actualCell == null ? void 0 : actualCell.remove();
  });
  const state2 = doc.editorState;
  if (state2) {
    state2.content = doc.body.innerHTML;
  }
}
function splitCell(range2, doc) {
  var _a;
  const cell = (_a = range2.startContainer.parentElement) == null ? void 0 : _a.closest("td");
  if (!cell || !cell.colSpan || cell.colSpan === 1) return;
  const newCells = new Array(cell.colSpan - 1).fill(0).map(() => {
    const newCell = doc.createElement("td");
    newCell.style.border = "1px solid var(--border-color)";
    newCell.style.padding = "8px";
    newCell.innerHTML = "&nbsp;";
    return newCell;
  });
  cell.colSpan = 1;
  cell.insertAdjacentElement("afterend", newCells[0]);
  newCells.slice(1).forEach((newCell) => {
    newCells[0].insertAdjacentElement("afterend", newCell);
  });
  const state2 = doc.editorState;
  if (state2) {
    state2.content = doc.body.innerHTML;
  }
}
function addRow(position, range2, doc) {
  var _a;
  const cell = (_a = range2.startContainer.parentElement) == null ? void 0 : _a.closest("td");
  if (!cell) return;
  const row = cell.parentElement;
  const table = row == null ? void 0 : row.parentElement;
  if (!row || !table) return;
  const newRow = row.cloneNode(true);
  Array.from(newRow.cells).forEach((cell2) => cell2.innerHTML = "&nbsp;");
  row.insertAdjacentElement(position === "before" ? "beforebegin" : "afterend", newRow);
  const state2 = doc.editorState;
  if (state2) {
    state2.content = doc.body.innerHTML;
  }
}
function deleteRow(range2) {
  var _a;
  const cell = (_a = range2.startContainer.parentElement) == null ? void 0 : _a.closest("td");
  if (!cell) return;
  const row = cell.parentElement;
  if (!row) return;
  const doc = row.ownerDocument;
  row.remove();
  const state2 = doc.editorState;
  if (state2) {
    state2.content = doc.body.innerHTML;
  }
}
function deleteTable(range2) {
  var _a;
  const cell = (_a = range2.startContainer.parentElement) == null ? void 0 : _a.closest("td");
  if (!cell) return;
  const table = cell.closest("table");
  if (!table) return;
  const doc = table.ownerDocument;
  table.remove();
  const state2 = doc.editorState;
  if (state2) {
    state2.content = doc.body.innerHTML;
  }
}
function insertColumn(position, range2) {
  var _a;
  const cell = (_a = range2.startContainer.parentElement) == null ? void 0 : _a.closest("td");
  if (!cell) return;
  const table = cell.closest("table");
  if (!table) return;
  const columnIndex = cell.cellIndex;
  const { rows } = table;
  for (let i2 = 0; i2 < rows.length; i2++) {
    const newCell = rows[i2].insertCell(position === "after" ? columnIndex + 1 : columnIndex);
    newCell.innerHTML = "&nbsp;";
    newCell.style.border = "1px solid var(--border-color)";
    newCell.style.padding = "8px";
  }
  const state2 = table.ownerDocument.editorState;
  if (state2) {
    state2.content = table.ownerDocument.body.innerHTML;
  }
}
function deleteColumn(range2) {
  var _a;
  const cell = (_a = range2.startContainer.parentElement) == null ? void 0 : _a.closest("td");
  if (!cell) return;
  const table = cell.closest("table");
  if (!table) return;
  const columnIndex = cell.cellIndex;
  const { rows } = table;
  const doc = table.ownerDocument;
  for (let i2 = 0; i2 < rows.length; i2++) {
    rows[i2].deleteCell(columnIndex);
  }
  if (rows[0].cells.length === 0) {
    table.remove();
  }
  const state2 = doc.editorState;
  if (state2) {
    state2.content = doc.body.innerHTML;
  }
}
function alignColumn(range2, alignment) {
  var _a;
  const cell = (_a = range2.startContainer.parentElement) == null ? void 0 : _a.closest("td");
  if (!cell) return;
  const table = cell.closest("table");
  if (!table) return;
  const columnIndex = cell.cellIndex;
  const { rows } = table;
  for (let i2 = 0; i2 < rows.length; i2++) {
    const cell2 = rows[i2].cells[columnIndex];
    if (cell2) {
      cell2.style.textAlign = alignment;
    }
  }
  const state2 = table.ownerDocument.editorState;
  if (state2) {
    state2.content = table.ownerDocument.body.innerHTML;
  }
}
function createCommand(name, execute, isActive) {
  return {
    name,
    execute: (state2, value) => {
      if (!state2.doc) return;
      execute(state2, value);
    },
    isActive
  };
}
function createFormattingCommand(state2, type3, command, tag) {
  const format2 = formatting(state2);
  return createCommand(
    command,
    () => {
      var _a, _b;
      if (!state2.doc) return;
      if (type3 === "text") {
        if (command === "bold") state2.doc.execCommand("bold", false);
        else if (command === "italic") state2.doc.execCommand("italic", false);
        else if (command === "underline") state2.doc.execCommand("underline", false);
        else format2.text(command);
      } else if (type3 === "block") {
        state2.doc.execCommand("formatBlock", false, `<${command}>`);
      } else if (type3 === "list") {
        const selection = state2.doc.getSelection();
        if (!selection || !selection.rangeCount) return;
        const range2 = selection.getRangeAt(0);
        if (range2.collapsed && (!((_a = range2.startContainer.textContent) == null ? void 0 : _a.trim()) || range2.startContainer === state2.doc.body)) {
          const list = state2.doc.createElement(command === "orderedList" ? "ol" : "ul");
          const li = state2.doc.createElement("li");
          li.innerHTML = "&nbsp;<br>";
          list.appendChild(li);
          const currentBlock = range2.startContainer.nodeType === 1 ? range2.startContainer : range2.startContainer.parentElement;
          if ((currentBlock == null ? void 0 : currentBlock.tagName.toLowerCase()) === "p" && isNodeEmpty$1(currentBlock)) {
            (_b = currentBlock.parentNode) == null ? void 0 : _b.replaceChild(list, currentBlock);
          } else {
            range2.insertNode(list);
          }
          range2.selectNodeContents(li);
          range2.collapse(true);
          selection.removeAllRanges();
          selection.addRange(range2);
        } else {
          state2.doc.execCommand(
            command === "orderedList" ? "insertOrderedList" : "insertUnorderedList",
            false
          );
        }
      }
    },
    () => state2.selectedStyles.has(command)
  );
}
function isNodeEmpty$1(node) {
  var _a;
  const text = ((_a = node.textContent) == null ? void 0 : _a.trim()) || "";
  if (text) return false;
  const brElements = node.getElementsByTagName("br");
  if (brElements.length === 0) return true;
  return brElements.length === 1 && node.childNodes.length === 1;
}
function createCommandRegistry(state2) {
  const format2 = formatting(state2);
  const historyCommands = {
    undo: createCommand("Undo", () => {
      var _a;
      return (_a = state2.doc) == null ? void 0 : _a.execCommand("undo", false);
    }),
    redo: createCommand("Redo", () => {
      var _a;
      return (_a = state2.doc) == null ? void 0 : _a.execCommand("redo", false);
    })
  };
  const textCommands = ["bold", "italic", "underline"].reduce((acc, cmd) => ({
    ...acc,
    [cmd]: createFormattingCommand(state2, "text", cmd)
  }), {});
  const headingCommands = ["h1", "h2", "h3", "h4", "h5", "h6"].reduce((acc, cmd) => ({
    ...acc,
    [cmd]: createFormattingCommand(state2, "block", cmd)
  }), {});
  const blockCommands = {
    p: createFormattingCommand(state2, "block", "p"),
    blockquote: createFormattingCommand(state2, "block", "blockquote")
  };
  const listCommands = {
    orderedList: createFormattingCommand(state2, "list", "orderedList"),
    unorderedList: createFormattingCommand(state2, "list", "unorderedList")
  };
  const tableCommands = {
    insertTable: createCommand("Insert Table", (state22, value) => {
      const [rows, cols] = (value == null ? void 0 : value.split("x").map(Number)) || [3, 3];
      insertTable(rows, cols, state22);
    }),
    deleteTable: createCommand("Delete Table", (state22) => state22.range && deleteTable(state22.range)),
    mergeCells: createCommand("Merge Cells", (state22) => state22.range && state22.doc && mergeCells(state22.range, state22.doc)),
    splitCells: createCommand("Split Cells", (state22) => state22.range && state22.doc && splitCell(state22.range, state22.doc)),
    addRowBefore: createCommand("Add Row Before", (state22) => state22.range && state22.doc && addRow("before", state22.range, state22.doc)),
    addRowAfter: createCommand("Add Row After", (state22) => state22.range && state22.doc && addRow("after", state22.range, state22.doc)),
    deleteRow: createCommand("Delete Row", (state22) => state22.range && deleteRow(state22.range)),
    insertColumnLeft: createCommand("Insert Column Left", (state22) => state22.range && insertColumn("before", state22.range)),
    insertColumnRight: createCommand("Insert Column Right", (state22) => state22.range && insertColumn("after", state22.range)),
    deleteColumn: createCommand("Delete Column", (state22) => state22.range && deleteColumn(state22.range))
  };
  const alignmentCommands = ["Left", "Center", "Right", "Justify"].reduce((acc, align) => ({
    ...acc,
    [`align${align}`]: createCommand(`Align ${align}`, (state22) => state22.range && alignColumn(state22.range, align.toLowerCase()))
  }), {});
  const viewCommands = {
    fullScreen: createCommand("Full Screen", (state22) => {
      state22.isFullscreen = !state22.isFullscreen;
    }, (state22) => state22.isFullscreen),
    splitView: createCommand("Split View", (state22) => {
      state22.isSplitView = !state22.isSplitView;
    }, (state22) => state22.isSplitView),
    codeView: createCommand("Code View", (state22) => {
      state22.isCodeView = !state22.isCodeView;
    }, (state22) => state22.isCodeView)
  };
  const mediaCommands = {
    image: createCommand("Insert Image", (state22) => state22.modal && insertImage(state22.modal, state22)),
    link: createCommand("Insert Link", (state22) => state22.modal && state22.range && insertLink(state22.modal, state22)),
    embed: createCommand("Insert Embed", (state22) => state22.modal && insertEmbed(state22.modal, state22))
  };
  const otherCommands = {
    clear: createCommand("Clear Formatting", () => {
      format2.clear();
    }),
    indent: createCommand("Indent", () => {
      format2.text("indent");
    }),
    outdent: createCommand("Outdent", () => {
      format2.text("outdent");
    })
  };
  return {
    ...historyCommands,
    ...textCommands,
    ...headingCommands,
    ...blockCommands,
    ...listCommands,
    ...tableCommands,
    ...alignmentCommands,
    ...viewCommands,
    ...mediaCommands,
    ...otherCommands
  };
}
function createCommandExecutor(state2, commands) {
  return {
    execute(command, value) {
      const cmd = commands[command];
      if (cmd) {
        cmd.execute(state2, value);
      }
    },
    isActive(command) {
      var _a;
      const cmd = commands[command];
      return ((_a = cmd.isActive) == null ? void 0 : _a.call(cmd, state2)) || false;
    },
    getValue(command) {
      var _a;
      const cmd = commands[command];
      return ((_a = cmd.getValue) == null ? void 0 : _a.call(cmd, state2)) || null;
    }
  };
}
function useCommands(state2, debug) {
  const commands = createCommandRegistry(state2);
  const executor = createCommandExecutor(state2, commands);
  return {
    execute: (command, value) => {
      if (!state2.doc) return;
      debug == null ? void 0 : debug.logCommand(command, value);
      if (["splitView", "codeView", "fullScreen"].includes(command)) {
        switch (command) {
          case "splitView":
            state2.isSplitView = !state2.isSplitView;
            return;
          case "codeView":
            state2.isCodeView = !state2.isCodeView;
            return;
          case "fullScreen":
            state2.isFullscreen = !state2.isFullscreen;
            return;
        }
      }
      state2.doc.body.focus();
      executor.execute(command, value);
      const newContent = state2.doc.body.innerHTML;
      if (newContent !== state2.content) {
        state2.content = newContent;
      }
      const selection = state2.doc.getSelection();
      if (selection == null ? void 0 : selection.rangeCount) {
        const hasSelectionChanged = !state2.selection || state2.selection !== selection || state2.rangeCount !== selection.rangeCount;
        if (hasSelectionChanged) {
          state2.selection = selection;
          state2.range = selection.getRangeAt(0).cloneRange();
          state2.rangeCount = selection.rangeCount;
        }
      }
    },
    isActive: executor.isActive,
    getValue: executor.getValue
  };
}
class EditorDebugger {
  constructor(maxActions = 1e3) {
    __publicField(this, "session");
    __publicField(this, "maxActions");
    __publicField(this, "isDevelopment");
    this.maxActions = maxActions;
    this.session = this.createNewSession();
    this.isDevelopment = false;
  }
  createNewSession() {
    return {
      id: `session_${Date.now()}`,
      startTime: Date.now(),
      actions: []
    };
  }
  getNodeDescription(node) {
    var _a;
    if (node.nodeType === Node.TEXT_NODE) {
      return `Text("${(_a = node.textContent) == null ? void 0 : _a.slice(0, 20)}${node.textContent && node.textContent.length > 20 ? "..." : ""}")`;
    }
    const element = node;
    return `${element.tagName.toLowerCase()}${element.id ? `#${element.id}` : ""}`;
  }
  captureState(state2) {
    if (!state2.doc || !state2.selection) {
      return {
        content: "",
        selection: null,
        activeStyles: [],
        caretPosition: null
      };
    }
    const { selection } = state2;
    const range2 = selection.rangeCount ? selection.getRangeAt(0) : null;
    return {
      content: state2.doc.body.innerHTML,
      selection: range2 ? {
        start: range2.startOffset,
        end: range2.endOffset,
        collapsed: range2.collapsed,
        text: range2.toString()
      } : null,
      activeStyles: Array.from(state2.selectedStyles),
      caretPosition: range2 ? {
        node: this.getNodeDescription(range2.startContainer),
        offset: range2.startOffset
      } : null
    };
  }
  logCommand(command, value, state2) {
    this.addAction({
      type: "command",
      name: command,
      timestamp: Date.now(),
      details: { value },
      state: this.captureState(state2)
    });
  }
  logPaste(data2, state2) {
    this.addAction({
      type: "paste",
      name: "paste",
      timestamp: Date.now(),
      details: {
        html: data2.getData("text/html"),
        text: data2.getData("text/plain"),
        types: Array.from(data2.types)
      },
      state: this.captureState(state2)
    });
  }
  logKeyboard(event, state2) {
    this.addAction({
      type: "keyboard",
      name: "keypress",
      timestamp: Date.now(),
      details: {
        key: event.key,
        code: event.code,
        ctrl: event.ctrlKey,
        alt: event.altKey,
        shift: event.shiftKey,
        meta: event.metaKey
      },
      state: this.captureState(state2)
    });
  }
  logSelection(state2) {
    this.addAction({
      type: "selection",
      name: "selection_change",
      timestamp: Date.now(),
      details: {},
      state: this.captureState(state2)
    });
  }
  logInput(inputType, data2, state2) {
    this.addAction({
      type: "input",
      name: inputType,
      timestamp: Date.now(),
      details: { data: data2 },
      state: this.captureState(state2)
    });
  }
  addAction(action) {
    this.session.actions.push(action);
    if (this.session.actions.length > this.maxActions) {
      this.session.actions.shift();
    }
    if (this.isDevelopment) {
      console.log("Editor Action:", action);
    }
  }
  getSession() {
    return this.session;
  }
  clearSession() {
    this.session = this.createNewSession();
  }
  exportSession() {
    return JSON.stringify(this.session, null, 2);
  }
  downloadSession() {
    const blob = new Blob([this.exportSession()], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a2 = document.createElement("a");
    a2.href = url;
    a2.download = `editor_session_${this.session.id}.json`;
    document.body.appendChild(a2);
    a2.click();
    document.body.removeChild(a2);
    URL.revokeObjectURL(url);
  }
  exportSessionWithPrompt(userMessage) {
    const prompt = {
      message: userMessage || "here is a debug log, can you analyze and fix accordingly?",
      session: this.session
    };
    return JSON.stringify(prompt, null, 2);
  }
}
function preserveIframes(content) {
  const temp = document.createElement("div");
  temp.innerHTML = content;
  const iframes = [];
  temp.querySelectorAll("iframe").forEach((iframe, index2) => {
    const placeholder = `<!--iframe-${index2}-->`;
    iframes.push(iframe.cloneNode(true));
    iframe.replaceWith(placeholder);
  });
  return {
    html: temp.innerHTML,
    iframes
  };
}
function restoreIframes(doc, content, iframes) {
  const placeholderPattern = /<!--iframe-(\d+)-->/g;
  doc.body.innerHTML = content.replace(placeholderPattern, (_2, index2) => {
    const iframe = iframes[Number(index2)];
    return iframe ? iframe.outerHTML : "";
  });
}
function useEditor() {
  const modal = useModal();
  let cleanupListeners = null;
  const state2 = reactive({
    content: "",
    doc: void 0,
    selection: null,
    selectedStyles: /* @__PURE__ */ new Set(),
    isFullscreen: false,
    isSplitView: false,
    isCodeView: false,
    hasInit: false,
    undoStack: [],
    redoStack: [],
    rangeCount: 0,
    range: null,
    modal,
    debug: void 0
  });
  const updateState = {
    styles: () => {
      if (!state2.doc) return;
      const styles = /* @__PURE__ */ new Set();
      const styleTypes = [
        "bold",
        "italic",
        "underline",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "blockquote",
        "table",
        "p",
        "ol",
        "li"
      ];
      styleTypes.forEach((style) => {
        if (state2.doc && isStyleActive(style, state2.doc)) {
          styles.add(style);
        }
      });
      state2.selectedStyles = styles;
    },
    content: (source) => {
      if (!state2.doc) return;
      const currentContent = state2.doc.body.innerHTML;
      if (currentContent !== state2.content) {
        state2.undoStack.push(state2.content);
        state2.redoStack = [];
      }
      const selection = state2.doc.getSelection();
      const range2 = (selection == null ? void 0 : selection.rangeCount) ? selection.getRangeAt(0).cloneRange() : null;
      if (source === "html") {
        const preserved = preserveIframes(state2.content);
        state2.doc.body.innerHTML = preserved.html;
        setTimeout(() => {
          if (state2.doc) {
            restoreIframes(state2.doc, state2.content, preserved.iframes);
            if (range2 && selection) {
              try {
                selection.removeAllRanges();
                selection.addRange(range2);
              } catch (e) {
              }
            }
          }
        }, 0);
      } else {
        state2.doc.body.textContent = state2.content;
      }
    },
    selection: () => {
      if (!state2.doc) return;
      const newSelection = state2.doc.getSelection();
      if (!newSelection) {
        return;
      }
      try {
        if (!state2.doc.body.contains(newSelection.anchorNode)) {
          state2.doc.body.focus();
          return;
        }
        const hasSelectionChanged = !state2.selection || state2.selection !== newSelection || state2.rangeCount !== newSelection.rangeCount || newSelection.rangeCount > 0 && state2.range && (state2.range.startContainer !== newSelection.getRangeAt(0).startContainer || state2.range.startOffset !== newSelection.getRangeAt(0).startOffset || state2.range.endContainer !== newSelection.getRangeAt(0).endContainer || state2.range.endOffset !== newSelection.getRangeAt(0).endOffset);
        if (hasSelectionChanged) {
          state2.selection = newSelection;
          state2.rangeCount = newSelection.rangeCount;
          if (newSelection.rangeCount > 0) {
            state2.range = newSelection.getRangeAt(0).cloneRange();
          }
          requestAnimationFrame(() => {
            updateState.styles();
          });
        }
      } catch (e) {
        state2.selection = null;
        state2.range = null;
        state2.rangeCount = 0;
        state2.selectedStyles = /* @__PURE__ */ new Set();
      }
    }
  };
  const history = {
    undo: () => {
      if (state2.undoStack.length === 0) return;
      state2.redoStack.push(state2.content);
      const lastContent = state2.undoStack.pop();
      if (lastContent !== void 0) {
        state2.content = lastContent;
        updateState.content("html");
      }
    },
    redo: () => {
      if (state2.redoStack.length === 0) return;
      state2.undoStack.push(state2.content);
      const nextContent = state2.redoStack.pop();
      if (nextContent !== void 0) {
        state2.content = nextContent;
        updateState.content("html");
      }
    }
  };
  const cleanup = {
    emptyTags: (doc) => {
      var _a, _b;
      const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_ELEMENT, null);
      const nodesToRemove = [];
      let node = walker.nextNode();
      while (node) {
        if (["br", "img", "hr", "input"].includes(node.tagName.toLowerCase())) {
          node = walker.nextNode();
          continue;
        }
        const textContent = ((_a = node.textContent) == null ? void 0 : _a.trim()) || "";
        const innerHTML = node.innerHTML.trim();
        const hasOnlyBr = innerHTML === "<br>" || innerHTML === "<br/>";
        const hasOnlyNbsp = innerHTML === "&nbsp;" || textContent === " ";
        const isEmpty = !textContent && !innerHTML;
        const isDirectChildOfBody = node.parentElement === doc.body;
        if (isEmpty || hasOnlyNbsp || hasOnlyBr && !isDirectChildOfBody) {
          if (isDirectChildOfBody && !node.matches("p")) {
            const p2 = doc.createElement("p");
            p2.innerHTML = "<br>";
            (_b = node.parentNode) == null ? void 0 : _b.replaceChild(p2, node);
          } else {
            nodesToRemove.push(node);
          }
        }
        node = walker.nextNode();
      }
      nodesToRemove.forEach((node2) => {
        node2.remove();
      });
    },
    normalizeContent: (doc) => {
      if (!doc.body.firstElementChild) {
        const p2 = doc.createElement("p");
        p2.dir = doc.body.dir;
        p2.innerHTML = "<br>";
        doc.body.appendChild(p2);
      } else {
        const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
        const textNodes = [];
        let node;
        while (node = walker.nextNode()) {
          if (node.parentElement === doc.body) {
            textNodes.push(node);
          }
        }
        textNodes.forEach((textNode) => {
          var _a;
          if ((_a = textNode.textContent) == null ? void 0 : _a.trim()) {
            const p2 = doc.createElement("p");
            p2.dir = doc.body.dir;
            p2.appendChild(textNode.cloneNode());
            doc.body.replaceChild(p2, textNode);
          } else {
            doc.body.removeChild(textNode);
          }
        });
      }
    }
  };
  function setupEventListeners(doc) {
    if (cleanupListeners) {
      cleanupListeners();
      cleanupListeners = null;
    }
    let isUpdating = false;
    const events = {
      input: () => {
        if (isUpdating) return;
        isUpdating = true;
        const newContent = doc.body.innerHTML;
        if (newContent !== state2.content) {
          state2.content = newContent;
        }
        isUpdating = false;
      },
      selectionchange: () => {
        if (!isUpdating) {
          updateState.selection();
        }
      },
      mouseup: () => {
        if (!isUpdating) {
          updateState.selection();
        }
      },
      keyup: (e) => {
        if (!isUpdating) {
          if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
            updateState.selection();
          }
        }
      }
    };
    Object.entries(events).forEach(([event, handler]) => {
      doc.addEventListener(event, handler);
    });
    cleanupListeners = () => {
      Object.entries(events).forEach(([event, handler]) => {
        doc.removeEventListener(event, handler);
      });
    };
    return cleanupListeners;
  }
  function init(doc) {
    if (state2.hasInit) {
      if (cleanupListeners) {
        cleanupListeners();
        cleanupListeners = null;
      }
    }
    state2.doc = doc;
    state2.hasInit = true;
    doc.editorState = state2;
    if (state2.content) {
      const preserved = preserveIframes(state2.content);
      doc.body.innerHTML = preserved.html;
      setTimeout(() => {
        if (state2.doc) {
          restoreIframes(doc, state2.content, preserved.iframes);
        }
      }, 0);
    }
    cleanup.normalizeContent(doc);
    const range2 = doc.createRange();
    const selection = doc.getSelection();
    if (selection) {
      range2.selectNodeContents(doc.body);
      range2.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range2);
      state2.range = range2.cloneRange();
      state2.selection = selection;
      state2.rangeCount = selection.rangeCount;
    }
    cleanupListeners = setupEventListeners(doc);
  }
  function initDebugger() {
    if (!state2.debug) {
      const debugInstance = new EditorDebugger();
      const debug = {
        debugger: debugInstance,
        logCommand: (command, value) => {
          debugInstance.logCommand(command, value, state2);
        },
        getSession: () => debugInstance.getSession(),
        clearSession: () => {
          debugInstance.clearSession();
        },
        downloadSession: () => {
          debugInstance.downloadSession();
        },
        exportDebugWithPrompt: (message) => debugInstance.exportSessionWithPrompt(message)
      };
      state2.debug = debug;
    }
  }
  if (typeof window !== "undefined") {
    window.addEventListener("beforeunload", () => {
      if (cleanupListeners) {
        cleanupListeners();
      }
    });
  }
  return {
    state: state2,
    init,
    updateState,
    history,
    initDebugger,
    cleanup: () => {
      if (cleanupListeners) {
        cleanupListeners();
        cleanupListeners = null;
      }
    }
  };
}
const shortcuts = [
  { key: "b", command: "bold" },
  { key: "i", command: "italic" },
  { key: "u", command: "underline" },
  { key: "z", command: "undo" },
  { key: "z", modifiers: { shift: true }, command: "redo" },
  { key: "y", command: "redo" },
  { key: ".", modifiers: { shift: true }, command: "orderedList" },
  { key: "/", modifiers: { shift: true }, command: "unorderedList" },
  { key: "]", command: "indent" },
  { key: "[", command: "outdent" },
  ...Array.from({ length: 6 }, (_2, i2) => ({
    key: String(i2 + 1),
    modifiers: { alt: true },
    command: `h${i2 + 1}`
  }))
];
function useEditorKeyboard(doc, executor) {
  doc.addEventListener("keydown", (e) => {
    var _a, _b;
    if (e.key === "Enter" && !e.shiftKey) {
      const selection = doc.getSelection();
      if (!selection || !selection.rangeCount) return;
      const range2 = selection.getRangeAt(0);
      const container = range2.commonAncestorContainer;
      const listItem = (_a = container.nodeType === 3 ? container.parentElement : container) == null ? void 0 : _a.closest("li");
      if (listItem) {
        if (range2.collapsed && isAtEndOfNode(listItem, range2)) {
          if (isNodeEmpty(listItem)) {
            e.preventDefault();
            const list = listItem.parentElement;
            if (!list) return;
            listItem.remove();
            if (!list.querySelector("li")) {
              const p2 = doc.createElement("p");
              p2.innerHTML = "<br>";
              (_b = list.parentNode) == null ? void 0 : _b.replaceChild(p2, list);
              range2.selectNodeContents(p2);
              range2.collapse(true);
              selection.removeAllRanges();
              selection.addRange(range2);
            }
          } else {
            e.preventDefault();
            const newLi = doc.createElement("li");
            newLi.innerHTML = "&nbsp;<br>";
            listItem.insertAdjacentElement("afterend", newLi);
            range2.selectNodeContents(newLi);
            range2.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range2);
          }
        }
      }
    }
    if (!e.ctrlKey && !e.metaKey) return;
    const matchingShortcut = shortcuts.find((shortcut) => {
      const keyMatch = shortcut.key === e.key;
      const modifiersMatch = !shortcut.modifiers || (!shortcut.modifiers.ctrl || e.ctrlKey || e.metaKey) && (!shortcut.modifiers.alt || e.altKey) && (!shortcut.modifiers.shift || e.shiftKey);
      return keyMatch && modifiersMatch;
    });
    if (matchingShortcut) {
      e.preventDefault();
      executor.execute(matchingShortcut.command);
    }
  });
}
function isAtEndOfNode(node, range2) {
  var _a;
  if (node.nodeType === 3) {
    return range2.startOffset === node.length;
  }
  const { lastChild: lastChild2 } = node;
  if (!lastChild2) return true;
  if (lastChild2.nodeType === 3) {
    return range2.startContainer === lastChild2 && range2.startOffset === ((_a = lastChild2.textContent) == null ? void 0 : _a.length);
  }
  return range2.startContainer === node && range2.startOffset === node.childNodes.length;
}
function isNodeEmpty(node) {
  var _a;
  const text = ((_a = node.textContent) == null ? void 0 : _a.replace(/\s/g, "")) || "";
  if (text) return false;
  const brElements = node.getElementsByTagName("br");
  if (brElements.length === 0) return true;
  return brElements.length === 1 && node.childNodes.length <= 2;
}
const _hoisted_1$s = { class: "bagel-input" };
const _hoisted_2$i = { class: "content-area radius-05" };
const _hoisted_3$f = {
  key: 1,
  class: "flex"
};
const _sfc_main$z = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    modelValue: {},
    toolbarConfig: {},
    debug: { type: Boolean },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const iframe = ref();
    const editor = useEditor();
    const isInitializing = ref(false);
    const hasInitialized = ref(false);
    if (props2.debug) {
      editor.initDebugger();
    }
    const commands = useCommands(editor.state, editor.state.debug);
    const debugMethods = computed(() => editor.state.debug);
    const hasRTL = computed(() => /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(props2.modelValue));
    onUnmounted(() => {
      editor.cleanup();
    });
    async function initEditor() {
      var _a;
      if (isInitializing.value || !iframe.value || hasInitialized.value) {
        return;
      }
      isInitializing.value = true;
      try {
        const editorStyles = await import("./editor-7QC0nG_c.js");
        const htmlContent = `
			<!DOCTYPE html>
			<html>
			<head>
				<meta charset="UTF-8">
				<meta name="viewport" content="width=device-width, initial-scale=1.0">
				<meta http-equiv="Content-Security-Policy" content="
					default-src * data: blob: 'unsafe-inline' 'unsafe-eval';
					img-src * data: blob:;
					style-src * 'unsafe-inline';
					script-src * 'unsafe-inline' 'unsafe-eval';
					frame-src * data: blob:;
					connect-src *;
					media-src *;
				">
				<base target="_blank">
				<style id="editor-styles">${editorStyles.default}</style>
			</head>
			<body>${props2.modelValue || ""}</body>
			</html>
		`;
        const doc = iframe.value.contentDocument || ((_a = iframe.value.contentWindow) == null ? void 0 : _a.document);
        if (!doc) return;
        doc.open();
        doc.write(htmlContent);
        doc.close();
        await new Promise((resolve) => setTimeout(resolve, 0));
        doc.designMode = "on";
        doc.body.contentEditable = "true";
        doc.body.dir = hasRTL.value ? "rtl" : "ltr";
        editor.init(doc);
        useEditorKeyboard(doc, commands);
        if (!doc.body.firstElementChild) {
          const p2 = doc.createElement("p");
          p2.dir = doc.body.dir;
          p2.innerHTML = "<br>";
          doc.body.appendChild(p2);
        } else {
          const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
          const textNodes = [];
          let node;
          while (node = walker.nextNode()) {
            if (node.parentElement === doc.body) {
              textNodes.push(node);
            }
          }
          textNodes.forEach((textNode) => {
            var _a2;
            if ((_a2 = textNode.textContent) == null ? void 0 : _a2.trim()) {
              const p2 = doc.createElement("p");
              p2.dir = doc.body.dir;
              p2.appendChild(textNode.cloneNode());
              doc.body.replaceChild(p2, textNode);
            } else {
              doc.body.removeChild(textNode);
            }
          });
        }
        doc.body.focus();
        hasInitialized.value = true;
      } catch (error) {
        console.error("Error during editor initialization:", error);
      } finally {
        isInitializing.value = false;
      }
    }
    watch(() => props2.modelValue, (newValue, oldValue) => {
      if (newValue !== editor.state.content) {
        if (!oldValue || Math.abs(newValue.length - oldValue.length) > 50) {
          hasInitialized.value = false;
          editor.state.content = newValue;
          editor.updateState.content("html");
        }
      }
    });
    watch(() => editor.state.content, (newValue) => {
      var _a;
      if ((_a = editor.state.doc) == null ? void 0 : _a.body.innerHTML) {
        editor.state.doc.body.dir = hasRTL.value ? "rtl" : "ltr";
      }
      emit2("update:modelValue", newValue);
    });
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", _hoisted_1$s, [
        createElementVNode("label", null, toDisplayString(_ctx.label), 1),
        createElementVNode("div", {
          class: normalizeClass(["rich-text-editor rounded pt-05 px-05 pb-075", { "fullscreen-mode": unref(editor).state.isFullscreen }])
        }, [
          unref(editor).state.hasInit ? (openBlock(), createBlock(EditorToolbar, {
            key: 0,
            config: _ctx.toolbarConfig,
            selectedStyles: unref(editor).state.selectedStyles,
            onAction: unref(commands).execute
          }, null, 8, ["config", "selectedStyles", "onAction"])) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(["editor-container", { "split-view": unref(editor).state.isSplitView }])
          }, [
            createElementVNode("div", _hoisted_2$i, [
              createElementVNode("iframe", {
                id: "rich-text-iframe",
                ref_key: "iframe",
                ref: iframe,
                class: "editableContent",
                title: "Editor",
                srcdoc: "",
                sandbox: "allow-same-origin allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-scripts allow-top-navigation allow-top-navigation-by-user-activation",
                onLoad: initEditor
              }, null, 544)
            ]),
            unref(editor).state.isSplitView ? (openBlock(), createBlock(unref(CodeEditor), {
              key: 0,
              modelValue: unref(editor).state.content,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event) => unref(editor).state.content = $event),
                _cache[1] || (_cache[1] = ($event) => unref(editor).updateState.content("html"))
              ],
              language: "html",
              class: "code-editor"
            }, null, 8, ["modelValue"])) : createCommentVNode("", true)
          ], 2),
          _ctx.debug ? (openBlock(), createElementBlock("div", _hoisted_3$f, [
            _cache[6] || (_cache[6] = createElementVNode("p", { class: "text12 txt-gray mb-0 p-0" }, " Debug ", -1)),
            createVNode(unref(Btn), {
              thin: "",
              color: "gray",
              icon: "delete",
              onClick: (_a = debugMethods.value) == null ? void 0 : _a.clearSession
            }, {
              default: withCtx(() => _cache[3] || (_cache[3] = [
                createTextVNode(" Clear Session ")
              ])),
              _: 1
            }, 8, ["onClick"]),
            createVNode(unref(Btn), {
              thin: "",
              color: "gray",
              icon: "download",
              onClick: (_b = debugMethods.value) == null ? void 0 : _b.downloadSession
            }, {
              default: withCtx(() => _cache[4] || (_cache[4] = [
                createTextVNode(" Download Log ")
              ])),
              _: 1
            }, 8, ["onClick"]),
            createVNode(unref(Btn), {
              thin: "",
              color: "gray",
              icon: "content_copy",
              onClick: _cache[2] || (_cache[2] = ($event) => {
                var _a2;
                return unref(copyText)(((_a2 = debugMethods.value) == null ? void 0 : _a2.exportDebugWithPrompt()) || "");
              })
            }, {
              default: withCtx(() => _cache[5] || (_cache[5] = [
                createTextVNode(" Copy Log ")
              ])),
              _: 1
            })
          ])) : createCommentVNode("", true)
        ], 2)
      ]);
    };
  }
});
const RichText = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["__scopeId", "data-v-30bcda4c"]]);
const _hoisted_1$r = { class: "flex gap-05" };
const _hoisted_2$h = ["disabled"];
const _hoisted_3$e = { key: 1 };
const _hoisted_4$8 = {
  key: 2,
  class: "ms-auto ps-05 me-05"
};
const _hoisted_5$8 = ["value"];
const _hoisted_6$7 = ["aria-selected", "onClick", "onKeydown"];
const _hoisted_7$5 = { class: "block" };
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "SelectInput",
  props: {
    options: {},
    placeholder: { default: "Select" },
    disabled: { type: Boolean },
    modelValue: { type: [String, Number, Boolean, Object] },
    searchable: { type: Boolean },
    required: { type: Boolean },
    label: {},
    fullWidth: { type: Boolean },
    multiselect: { type: Boolean },
    icon: {},
    hideLabel: { type: Boolean },
    defaultValue: { type: [String, Number, Boolean, Object] },
    clearable: { type: Boolean },
    placement: { default: "bottom-start" },
    searchPlaceholder: {},
    onSearch: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const searchInput = ref();
    let selectedItems = ref([]);
    const selectedItemCount = computed(() => selectedItems.value.length ?? 0);
    const search = ref("");
    const dropdown = ref();
    let selected = ref(false);
    let open = ref(false);
    const selectedLabel = computed(() => {
      if (selectedItemCount.value === 0) return props2.placeholder;
      if (selectedItemCount.value > 4) {
        const str = selectedItems.value.slice(0, 4).map((item) => getLabel(item)).join(", ");
        return `${str}... +${selectedItemCount.value - 4}`;
      }
      return selectedItems.value.map((item) => getLabel(item)).join(", ");
    });
    const searchPlaceholder = computed(() => props2.searchPlaceholder ?? selectedLabel.value ?? "Search");
    let serverOptions = ref([]);
    let isSearching = ref(false);
    async function runServerSearch() {
      if (props2.onSearch !== void 0) {
        isSearching.value = true;
        serverOptions.value = await props2.onSearch(search.value);
        isSearching.value = false;
      }
    }
    const filteredOptions = computed(() => {
      if (props2.onSearch !== void 0) {
        if (isSearching.value) return [];
        if (search.value.trim().length) return serverOptions.value;
        return props2.options;
      }
      return props2.options.filter((option2) => {
        const searchTerm = search.value.split(/\s+/).filter(Boolean).map((t) => new RegExp(t.replaceAll(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi"));
        return Boolean(option2) && searchTerm.every((s2) => getLabel(option2).match(s2));
      });
    });
    let highlightedIndex = ref(-1);
    const selectOptions = ref();
    function navigate(direction) {
      if (!open.value) {
        open.value = true;
        setTimeout(() => {
          navigate(direction);
        }, 210);
        return;
      }
      if (direction === "up") {
        highlightedIndex.value = highlightedIndex.value > 0 ? highlightedIndex.value - 1 : filteredOptions.value.length - 1;
      } else if (direction === "down") {
        highlightedIndex.value = highlightedIndex.value < filteredOptions.value.length - 1 ? highlightedIndex.value + 1 : 0;
      }
      setTimeout(() => {
        var _a;
        const el = (_a = selectOptions.value) == null ? void 0 : _a.children[highlightedIndex.value];
        if (el) el.focus();
        else highlightedIndex.value = -1;
      }, 10);
    }
    const isSelected = (option2) => selectedItems.value.find((item) => getValue(option2) === getValue(item)) !== void 0;
    function getLabel(option2) {
      if (!option2) return "";
      if (typeof option2 === "string") return option2;
      if (typeof option2 === "number") return `${option2}`;
      if (typeof option2 === "boolean") return option2 ? "Yes" : "No";
      return option2.label;
    }
    function getValue(option2) {
      if (!option2) return;
      if (typeof option2 === "string") return option2;
      if (typeof option2 === "number") return option2;
      if (typeof option2 === "boolean") return option2 ? "Yes" : "No";
      return option2.value;
    }
    function focusInput() {
      open.value = true;
      setTimeout(() => {
        if (searchInput.value) searchInput.value.focus();
      }, 10);
    }
    function select2(option2) {
      selected.value = true;
      const existingIndex = selectedItems.value.findIndex(
        (item) => getValue(item) === getValue(option2)
      );
      if (existingIndex > -1) {
        selectedItems.value.splice(existingIndex, 1);
      } else if (props2.multiselect) {
        const current = [...selectedItems.value];
        current.push(option2);
        selectedItems.value = current;
      } else {
        selectedItems.value.splice(0, selectedItemCount.value, option2);
      }
      if (!props2.multiselect) open.value = false;
      emitUpdate();
    }
    function emitUpdate() {
      if (props2.multiselect) {
        emit2("update:modelValue", selectedItems.value.map(getValue).filter(Boolean));
      } else {
        const [item] = selectedItems.value;
        emit2("update:modelValue", getValue(item));
      }
    }
    function compareArrays(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      const arr1Values = [...arr1].map((a2) => getValue(a2)).filter(Boolean);
      const arr2Values = [...arr2].map((a2) => getValue(a2)).filter(Boolean);
      const isSame = arr1Values.every((item) => arr2Values.includes(item));
      return isSame;
    }
    watch(
      () => props2.modelValue,
      (newVal) => {
        if (!props2.multiselect) {
          const newOption = props2.options.find((o2) => getValue(o2) === newVal) ?? newVal;
          if (newOption && !isSelected(newOption)) selectedItems.value = [newOption];
        } else {
          const newData = [newVal].flat();
          const isSame = compareArrays(newData, selectedItems.value);
          if (!isSame) {
            selectedItems.value.splice(0, selectedItemCount.value, ...newData);
          }
        }
      },
      { immediate: true }
    );
    watch(() => open.value, (value) => {
      if (value) {
        highlightedIndex.value = -1;
      }
    });
    watch(
      () => props2.options,
      () => {
        selectedItems.value.forEach((option2, i2) => {
          const exists = props2.options.find(
            (o2) => getValue(o2) === getValue(option2)
          );
          if (exists === void 0) selectedItems.value.splice(i2, 1);
          else selectedItems.value.splice(i2, 1, exists);
        });
      },
      { deep: true, immediate: true }
    );
    onMounted(() => {
      if (props2.defaultValue !== void 0) {
        const defaultOption = props2.options.find(
          (o2) => getValue(o2) === getValue(props2.defaultValue)
        );
        if (defaultOption === void 0) return;
        selectedItems.value = [defaultOption];
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$W), {
        ref_key: "dropdown",
        ref: dropdown,
        shown: unref(open),
        "onUpdate:shown": _cache[9] || (_cache[9] = ($event) => isRef(open) ? open.value = $event : open = $event),
        placement: _ctx.placement,
        class: "bagel-input selectinput",
        "no-auto-focus": ""
      }, {
        trigger: withCtx(() => [
          createElementVNode("label", null, [
            createTextVNode(toDisplayString(_ctx.label) + " ", 1),
            createElementVNode("div", _hoisted_1$r, [
              _ctx.searchable && unref(open) ? (openBlock(), createBlock(unref(TextInput), {
                key: 0,
                ref_key: "searchInput",
                ref: searchInput,
                modelValue: search.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => search.value = $event),
                class: "mb-0",
                placeholder: searchPlaceholder.value,
                icon: "search",
                onDebounce: runServerSearch,
                onInput: _cache[1] || (_cache[1] = ($event) => isRef(selected) ? selected.value = false : selected = false),
                onClick: focusInput,
                onKeydown: [
                  _cache[2] || (_cache[2] = withKeys(withModifiers(($event) => navigate("down"), ["prevent"]), ["down"])),
                  _cache[3] || (_cache[3] = withKeys(withModifiers(($event) => navigate("up"), ["prevent"]), ["up"]))
                ]
              }, null, 8, ["modelValue", "placeholder"])) : (openBlock(), createElementBlock("button", {
                key: 1,
                disabled: _ctx.disabled,
                type: "button",
                class: normalizeClass(["selectinput-btn", { isEmpty: selectedItemCount.value === 0 }]),
                onKeydown: [
                  _cache[5] || (_cache[5] = withKeys(withModifiers(($event) => navigate("down"), ["prevent"]), ["down"])),
                  _cache[6] || (_cache[6] = withKeys(withModifiers(($event) => navigate("up"), ["prevent"]), ["up"]))
                ]
              }, [
                _ctx.icon ? (openBlock(), createBlock(unref(_sfc_main$s), {
                  key: 0,
                  icon: _ctx.icon
                }, null, 8, ["icon"])) : createCommentVNode("", true),
                !_ctx.hideLabel ? (openBlock(), createElementBlock("p", _hoisted_3$e, toDisplayString(selectedLabel.value), 1)) : createCommentVNode("", true),
                _ctx.clearable && selectedItemCount.value > 0 ? (openBlock(), createElementBlock("div", _hoisted_4$8, [
                  createVNode(unref(Btn), {
                    flat: "",
                    thin: "",
                    icon: "clear",
                    class: "color-gray",
                    onClick: _cache[4] || (_cache[4] = ($event) => {
                      isRef(selectedItems) ? selectedItems.value = [] : selectedItems = [];
                      emitUpdate();
                    })
                  })
                ])) : createCommentVNode("", true),
                !_ctx.disabled ? (openBlock(), createBlock(unref(_sfc_main$s), mergeProps({
                  key: 3,
                  thin: ""
                }, { icon: unref(open) ? "unfold_less" : "unfold_more" }), null, 16)) : createCommentVNode("", true)
              ], 42, _hoisted_2$h)),
              _ctx.required ? (openBlock(), createElementBlock("input", {
                key: 2,
                tabindex: "-1",
                style: { "width": "0", "height": "0", "position": "absolute", "opacity": "0", "z-index": "-1" },
                value: unref(selectedItems),
                required: ""
              }, null, 8, _hoisted_5$8)) : createCommentVNode("", true)
            ])
          ])
        ]),
        default: withCtx(() => [
          unref(isSearching) ? (openBlock(), createBlock(unref(Skeleton), {
            key: 0,
            count: 6,
            width: "200px",
            height: "25px",
            class: "mx-1 my-1"
          })) : createCommentVNode("", true),
          createVNode(unref(_sfc_main$10), {
            class: "p-05",
            style: normalizeStyle({ width: _ctx.fullWidth ? "100%" : "auto" })
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                ref_key: "selectOptions",
                ref: selectOptions,
                class: normalizeClass(["selectinput-options", { multiselect: _ctx.multiselect }])
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(filteredOptions.value, (option2, i2) => {
                  return openBlock(), createElementBlock("div", {
                    key: `${option2}${i2}`,
                    class: normalizeClass(["selectinput-option hover gap-1 align-items-center", { selected: isSelected(option2) }]),
                    role: "option",
                    tabindex: "0",
                    "aria-selected": isSelected(option2),
                    onClick: ($event) => select2(option2),
                    onKeydown: [
                      withKeys(($event) => select2(option2), ["enter"]),
                      _cache[7] || (_cache[7] = withKeys(withModifiers(($event) => navigate("down"), ["prevent"]), ["down"])),
                      _cache[8] || (_cache[8] = withKeys(withModifiers(($event) => navigate("up"), ["prevent"]), ["up"]))
                    ]
                  }, [
                    _ctx.multiselect ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                      isSelected(option2) ? (openBlock(), createBlock(unref(_sfc_main$s), {
                        key: 0,
                        size: 1.1,
                        icon: "select_check_box"
                      })) : createCommentVNode("", true),
                      !isSelected(option2) ? (openBlock(), createBlock(unref(_sfc_main$s), {
                        key: 1,
                        class: "opacity-3",
                        icon: "check_box_outline_blank",
                        size: 1.1
                      })) : createCommentVNode("", true)
                    ], 64)) : createCommentVNode("", true),
                    createElementVNode("span", _hoisted_7$5, toDisplayString(getLabel(option2)), 1)
                  ], 42, _hoisted_6$7);
                }), 128))
              ], 2),
              renderSlot(_ctx.$slots, "last", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["style"])
        ]),
        _: 3
      }, 8, ["shown", "placement"]);
    };
  }
});
const SelectInput = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["__scopeId", "data-v-da5bc268"]]);
/*!
 * Signature Pad v5.0.7 | https://github.com/szimek/signature_pad
 * (c) 2025 Szymon Nowak | Released under the MIT license
 */
class Point {
  constructor(x2, y2, pressure, time) {
    if (isNaN(x2) || isNaN(y2)) {
      throw new Error(`Point is invalid: (${x2}, ${y2})`);
    }
    this.x = +x2;
    this.y = +y2;
    this.pressure = pressure || 0;
    this.time = time || Date.now();
  }
  distanceTo(start) {
    return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
  }
  equals(other) {
    return this.x === other.x && this.y === other.y && this.pressure === other.pressure && this.time === other.time;
  }
  velocityFrom(start) {
    return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 0;
  }
}
class Bezier {
  static fromPoints(points, widths) {
    const c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
    const c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
    return new Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
  }
  static calculateControlPoints(s1, s2, s3) {
    const dx1 = s1.x - s2.x;
    const dy1 = s1.y - s2.y;
    const dx2 = s2.x - s3.x;
    const dy2 = s2.y - s3.y;
    const m1 = { x: (s1.x + s2.x) / 2, y: (s1.y + s2.y) / 2 };
    const m2 = { x: (s2.x + s3.x) / 2, y: (s2.y + s3.y) / 2 };
    const l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    const l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
    const dxm = m1.x - m2.x;
    const dym = m1.y - m2.y;
    const k2 = l1 + l2 == 0 ? 0 : l2 / (l1 + l2);
    const cm = { x: m2.x + dxm * k2, y: m2.y + dym * k2 };
    const tx = s2.x - cm.x;
    const ty = s2.y - cm.y;
    return {
      c1: new Point(m1.x + tx, m1.y + ty),
      c2: new Point(m2.x + tx, m2.y + ty)
    };
  }
  constructor(startPoint, control2, control1, endPoint, startWidth, endWidth) {
    this.startPoint = startPoint;
    this.control2 = control2;
    this.control1 = control1;
    this.endPoint = endPoint;
    this.startWidth = startWidth;
    this.endWidth = endWidth;
  }
  length() {
    const steps = 10;
    let length = 0;
    let px;
    let py;
    for (let i2 = 0; i2 <= steps; i2 += 1) {
      const t = i2 / steps;
      const cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
      const cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
      if (i2 > 0) {
        const xdiff = cx - px;
        const ydiff = cy - py;
        length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
      }
      px = cx;
      py = cy;
    }
    return length;
  }
  point(t, start, c1, c2, end) {
    return start * (1 - t) * (1 - t) * (1 - t) + 3 * c1 * (1 - t) * (1 - t) * t + 3 * c2 * (1 - t) * t * t + end * t * t * t;
  }
}
class SignatureEventTarget {
  constructor() {
    try {
      this._et = new EventTarget();
    } catch (_a) {
      this._et = document;
    }
  }
  addEventListener(type3, listener, options) {
    this._et.addEventListener(type3, listener, options);
  }
  dispatchEvent(event) {
    return this._et.dispatchEvent(event);
  }
  removeEventListener(type3, callback, options) {
    this._et.removeEventListener(type3, callback, options);
  }
}
function throttle$1(fn, wait = 250) {
  let previous = 0;
  let timeout = null;
  let result2;
  let storedContext;
  let storedArgs;
  const later = () => {
    previous = Date.now();
    timeout = null;
    result2 = fn.apply(storedContext, storedArgs);
    if (!timeout) {
      storedContext = null;
      storedArgs = [];
    }
  };
  return function wrapper(...args) {
    const now = Date.now();
    const remaining = wait - (now - previous);
    storedContext = this;
    storedArgs = args;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result2 = fn.apply(storedContext, storedArgs);
      if (!timeout) {
        storedContext = null;
        storedArgs = [];
      }
    } else if (!timeout) {
      timeout = window.setTimeout(later, remaining);
    }
    return result2;
  };
}
class SignaturePad extends SignatureEventTarget {
  constructor(canvas, options = {}) {
    var _a, _b, _c;
    super();
    this.canvas = canvas;
    this._drawingStroke = false;
    this._isEmpty = true;
    this._lastPoints = [];
    this._data = [];
    this._lastVelocity = 0;
    this._lastWidth = 0;
    this._handleMouseDown = (event) => {
      if (!this._isLeftButtonPressed(event, true) || this._drawingStroke) {
        return;
      }
      this._strokeBegin(this._pointerEventToSignatureEvent(event));
    };
    this._handleMouseMove = (event) => {
      if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
        this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
        return;
      }
      this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
    };
    this._handleMouseUp = (event) => {
      if (this._isLeftButtonPressed(event)) {
        return;
      }
      this._strokeEnd(this._pointerEventToSignatureEvent(event));
    };
    this._handleTouchStart = (event) => {
      if (event.targetTouches.length !== 1 || this._drawingStroke) {
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      this._strokeBegin(this._touchEventToSignatureEvent(event));
    };
    this._handleTouchMove = (event) => {
      if (event.targetTouches.length !== 1) {
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      if (!this._drawingStroke) {
        this._strokeEnd(this._touchEventToSignatureEvent(event), false);
        return;
      }
      this._strokeMoveUpdate(this._touchEventToSignatureEvent(event));
    };
    this._handleTouchEnd = (event) => {
      if (event.targetTouches.length !== 0) {
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      this.canvas.removeEventListener("touchmove", this._handleTouchMove);
      this._strokeEnd(this._touchEventToSignatureEvent(event));
    };
    this._handlePointerDown = (event) => {
      if (!event.isPrimary || !this._isLeftButtonPressed(event) || this._drawingStroke) {
        return;
      }
      event.preventDefault();
      this._strokeBegin(this._pointerEventToSignatureEvent(event));
    };
    this._handlePointerMove = (event) => {
      if (!event.isPrimary) {
        return;
      }
      if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
        this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
        return;
      }
      event.preventDefault();
      this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
    };
    this._handlePointerUp = (event) => {
      if (!event.isPrimary || this._isLeftButtonPressed(event)) {
        return;
      }
      event.preventDefault();
      this._strokeEnd(this._pointerEventToSignatureEvent(event));
    };
    this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
    this.minWidth = options.minWidth || 0.5;
    this.maxWidth = options.maxWidth || 2.5;
    this.throttle = (_a = options.throttle) !== null && _a !== void 0 ? _a : 16;
    this.minDistance = (_b = options.minDistance) !== null && _b !== void 0 ? _b : 5;
    this.dotSize = options.dotSize || 0;
    this.penColor = options.penColor || "black";
    this.backgroundColor = options.backgroundColor || "rgba(0,0,0,0)";
    this.compositeOperation = options.compositeOperation || "source-over";
    this.canvasContextOptions = (_c = options.canvasContextOptions) !== null && _c !== void 0 ? _c : {};
    this._strokeMoveUpdate = this.throttle ? throttle$1(SignaturePad.prototype._strokeUpdate, this.throttle) : SignaturePad.prototype._strokeUpdate;
    this._ctx = canvas.getContext("2d", this.canvasContextOptions);
    this.clear();
    this.on();
  }
  clear() {
    const { _ctx: ctx, canvas } = this;
    ctx.fillStyle = this.backgroundColor;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    this._data = [];
    this._reset(this._getPointGroupOptions());
    this._isEmpty = true;
  }
  fromDataURL(dataUrl, options = {}) {
    return new Promise((resolve, reject3) => {
      const image = new Image();
      const ratio = options.ratio || window.devicePixelRatio || 1;
      const width = options.width || this.canvas.width / ratio;
      const height = options.height || this.canvas.height / ratio;
      const xOffset = options.xOffset || 0;
      const yOffset = options.yOffset || 0;
      this._reset(this._getPointGroupOptions());
      image.onload = () => {
        this._ctx.drawImage(image, xOffset, yOffset, width, height);
        resolve();
      };
      image.onerror = (error) => {
        reject3(error);
      };
      image.crossOrigin = "anonymous";
      image.src = dataUrl;
      this._isEmpty = false;
    });
  }
  toDataURL(type3 = "image/png", encoderOptions) {
    switch (type3) {
      case "image/svg+xml":
        if (typeof encoderOptions !== "object") {
          encoderOptions = void 0;
        }
        return `data:image/svg+xml;base64,${btoa(this.toSVG(encoderOptions))}`;
      default:
        if (typeof encoderOptions !== "number") {
          encoderOptions = void 0;
        }
        return this.canvas.toDataURL(type3, encoderOptions);
    }
  }
  on() {
    this.canvas.style.touchAction = "none";
    this.canvas.style.msTouchAction = "none";
    this.canvas.style.userSelect = "none";
    const isIOS2 = /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document;
    if (window.PointerEvent && !isIOS2) {
      this._handlePointerEvents();
    } else {
      this._handleMouseEvents();
      if ("ontouchstart" in window) {
        this._handleTouchEvents();
      }
    }
  }
  off() {
    this.canvas.style.touchAction = "auto";
    this.canvas.style.msTouchAction = "auto";
    this.canvas.style.userSelect = "auto";
    this.canvas.removeEventListener("pointerdown", this._handlePointerDown);
    this.canvas.removeEventListener("mousedown", this._handleMouseDown);
    this.canvas.removeEventListener("touchstart", this._handleTouchStart);
    this._removeMoveUpEventListeners();
  }
  _getListenerFunctions() {
    var _a;
    const canvasWindow = window.document === this.canvas.ownerDocument ? window : (_a = this.canvas.ownerDocument.defaultView) !== null && _a !== void 0 ? _a : this.canvas.ownerDocument;
    return {
      addEventListener: canvasWindow.addEventListener.bind(canvasWindow),
      removeEventListener: canvasWindow.removeEventListener.bind(canvasWindow)
    };
  }
  _removeMoveUpEventListeners() {
    const { removeEventListener } = this._getListenerFunctions();
    removeEventListener("pointermove", this._handlePointerMove);
    removeEventListener("pointerup", this._handlePointerUp);
    removeEventListener("mousemove", this._handleMouseMove);
    removeEventListener("mouseup", this._handleMouseUp);
    removeEventListener("touchmove", this._handleTouchMove);
    removeEventListener("touchend", this._handleTouchEnd);
  }
  isEmpty() {
    return this._isEmpty;
  }
  fromData(pointGroups, { clear = true } = {}) {
    if (clear) {
      this.clear();
    }
    this._fromData(pointGroups, this._drawCurve.bind(this), this._drawDot.bind(this));
    this._data = this._data.concat(pointGroups);
  }
  toData() {
    return this._data;
  }
  _isLeftButtonPressed(event, only) {
    if (only) {
      return event.buttons === 1;
    }
    return (event.buttons & 1) === 1;
  }
  _pointerEventToSignatureEvent(event) {
    return {
      event,
      type: event.type,
      x: event.clientX,
      y: event.clientY,
      pressure: "pressure" in event ? event.pressure : 0
    };
  }
  _touchEventToSignatureEvent(event) {
    const touch = event.changedTouches[0];
    return {
      event,
      type: event.type,
      x: touch.clientX,
      y: touch.clientY,
      pressure: touch.force
    };
  }
  _getPointGroupOptions(group) {
    return {
      penColor: group && "penColor" in group ? group.penColor : this.penColor,
      dotSize: group && "dotSize" in group ? group.dotSize : this.dotSize,
      minWidth: group && "minWidth" in group ? group.minWidth : this.minWidth,
      maxWidth: group && "maxWidth" in group ? group.maxWidth : this.maxWidth,
      velocityFilterWeight: group && "velocityFilterWeight" in group ? group.velocityFilterWeight : this.velocityFilterWeight,
      compositeOperation: group && "compositeOperation" in group ? group.compositeOperation : this.compositeOperation
    };
  }
  _strokeBegin(event) {
    const cancelled = !this.dispatchEvent(new CustomEvent("beginStroke", { detail: event, cancelable: true }));
    if (cancelled) {
      return;
    }
    const { addEventListener } = this._getListenerFunctions();
    switch (event.event.type) {
      case "mousedown":
        addEventListener("mousemove", this._handleMouseMove);
        addEventListener("mouseup", this._handleMouseUp);
        break;
      case "touchstart":
        addEventListener("touchmove", this._handleTouchMove);
        addEventListener("touchend", this._handleTouchEnd);
        break;
      case "pointerdown":
        addEventListener("pointermove", this._handlePointerMove);
        addEventListener("pointerup", this._handlePointerUp);
        break;
    }
    this._drawingStroke = true;
    const pointGroupOptions = this._getPointGroupOptions();
    const newPointGroup = Object.assign(Object.assign({}, pointGroupOptions), { points: [] });
    this._data.push(newPointGroup);
    this._reset(pointGroupOptions);
    this._strokeUpdate(event);
  }
  _strokeUpdate(event) {
    if (!this._drawingStroke) {
      return;
    }
    if (this._data.length === 0) {
      this._strokeBegin(event);
      return;
    }
    this.dispatchEvent(new CustomEvent("beforeUpdateStroke", { detail: event }));
    const point2 = this._createPoint(event.x, event.y, event.pressure);
    const lastPointGroup = this._data[this._data.length - 1];
    const lastPoints = lastPointGroup.points;
    const lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
    const isLastPointTooClose = lastPoint ? point2.distanceTo(lastPoint) <= this.minDistance : false;
    const pointGroupOptions = this._getPointGroupOptions(lastPointGroup);
    if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
      const curve = this._addPoint(point2, pointGroupOptions);
      if (!lastPoint) {
        this._drawDot(point2, pointGroupOptions);
      } else if (curve) {
        this._drawCurve(curve, pointGroupOptions);
      }
      lastPoints.push({
        time: point2.time,
        x: point2.x,
        y: point2.y,
        pressure: point2.pressure
      });
    }
    this.dispatchEvent(new CustomEvent("afterUpdateStroke", { detail: event }));
  }
  _strokeEnd(event, shouldUpdate = true) {
    this._removeMoveUpEventListeners();
    if (!this._drawingStroke) {
      return;
    }
    if (shouldUpdate) {
      this._strokeUpdate(event);
    }
    this._drawingStroke = false;
    this.dispatchEvent(new CustomEvent("endStroke", { detail: event }));
  }
  _handlePointerEvents() {
    this._drawingStroke = false;
    this.canvas.addEventListener("pointerdown", this._handlePointerDown);
  }
  _handleMouseEvents() {
    this._drawingStroke = false;
    this.canvas.addEventListener("mousedown", this._handleMouseDown);
  }
  _handleTouchEvents() {
    this.canvas.addEventListener("touchstart", this._handleTouchStart);
  }
  _reset(options) {
    this._lastPoints = [];
    this._lastVelocity = 0;
    this._lastWidth = (options.minWidth + options.maxWidth) / 2;
    this._ctx.fillStyle = options.penColor;
    this._ctx.globalCompositeOperation = options.compositeOperation;
  }
  _createPoint(x2, y2, pressure) {
    const rect = this.canvas.getBoundingClientRect();
    return new Point(x2 - rect.left, y2 - rect.top, pressure, (/* @__PURE__ */ new Date()).getTime());
  }
  _addPoint(point2, options) {
    const { _lastPoints } = this;
    _lastPoints.push(point2);
    if (_lastPoints.length > 2) {
      if (_lastPoints.length === 3) {
        _lastPoints.unshift(_lastPoints[0]);
      }
      const widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2], options);
      const curve = Bezier.fromPoints(_lastPoints, widths);
      _lastPoints.shift();
      return curve;
    }
    return null;
  }
  _calculateCurveWidths(startPoint, endPoint, options) {
    const velocity = options.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - options.velocityFilterWeight) * this._lastVelocity;
    const newWidth = this._strokeWidth(velocity, options);
    const widths = {
      end: newWidth,
      start: this._lastWidth
    };
    this._lastVelocity = velocity;
    this._lastWidth = newWidth;
    return widths;
  }
  _strokeWidth(velocity, options) {
    return Math.max(options.maxWidth / (velocity + 1), options.minWidth);
  }
  _drawCurveSegment(x2, y2, width) {
    const ctx = this._ctx;
    ctx.moveTo(x2, y2);
    ctx.arc(x2, y2, width, 0, 2 * Math.PI, false);
    this._isEmpty = false;
  }
  _drawCurve(curve, options) {
    const ctx = this._ctx;
    const widthDelta = curve.endWidth - curve.startWidth;
    const drawSteps = Math.ceil(curve.length()) * 2;
    ctx.beginPath();
    ctx.fillStyle = options.penColor;
    for (let i2 = 0; i2 < drawSteps; i2 += 1) {
      const t = i2 / drawSteps;
      const tt2 = t * t;
      const ttt = tt2 * t;
      const u2 = 1 - t;
      const uu = u2 * u2;
      const uuu = uu * u2;
      let x2 = uuu * curve.startPoint.x;
      x2 += 3 * uu * t * curve.control1.x;
      x2 += 3 * u2 * tt2 * curve.control2.x;
      x2 += ttt * curve.endPoint.x;
      let y2 = uuu * curve.startPoint.y;
      y2 += 3 * uu * t * curve.control1.y;
      y2 += 3 * u2 * tt2 * curve.control2.y;
      y2 += ttt * curve.endPoint.y;
      const width = Math.min(curve.startWidth + ttt * widthDelta, options.maxWidth);
      this._drawCurveSegment(x2, y2, width);
    }
    ctx.closePath();
    ctx.fill();
  }
  _drawDot(point2, options) {
    const ctx = this._ctx;
    const width = options.dotSize > 0 ? options.dotSize : (options.minWidth + options.maxWidth) / 2;
    ctx.beginPath();
    this._drawCurveSegment(point2.x, point2.y, width);
    ctx.closePath();
    ctx.fillStyle = options.penColor;
    ctx.fill();
  }
  _fromData(pointGroups, drawCurve, drawDot) {
    for (const group of pointGroups) {
      const { points } = group;
      const pointGroupOptions = this._getPointGroupOptions(group);
      if (points.length > 1) {
        for (let j = 0; j < points.length; j += 1) {
          const basicPoint = points[j];
          const point2 = new Point(basicPoint.x, basicPoint.y, basicPoint.pressure, basicPoint.time);
          if (j === 0) {
            this._reset(pointGroupOptions);
          }
          const curve = this._addPoint(point2, pointGroupOptions);
          if (curve) {
            drawCurve(curve, pointGroupOptions);
          }
        }
      } else {
        this._reset(pointGroupOptions);
        drawDot(points[0], pointGroupOptions);
      }
    }
  }
  toSVG({ includeBackgroundColor = false } = {}) {
    const pointGroups = this._data;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const minX = 0;
    const minY = 0;
    const maxX = this.canvas.width / ratio;
    const maxY = this.canvas.height / ratio;
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
    svg.setAttribute("viewBox", `${minX} ${minY} ${maxX} ${maxY}`);
    svg.setAttribute("width", maxX.toString());
    svg.setAttribute("height", maxY.toString());
    if (includeBackgroundColor && this.backgroundColor) {
      const rect = document.createElement("rect");
      rect.setAttribute("width", "100%");
      rect.setAttribute("height", "100%");
      rect.setAttribute("fill", this.backgroundColor);
      svg.appendChild(rect);
    }
    this._fromData(pointGroups, (curve, { penColor }) => {
      const path = document.createElement("path");
      if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
        const attr = `M ${curve.startPoint.x.toFixed(3)},${curve.startPoint.y.toFixed(3)} C ${curve.control1.x.toFixed(3)},${curve.control1.y.toFixed(3)} ${curve.control2.x.toFixed(3)},${curve.control2.y.toFixed(3)} ${curve.endPoint.x.toFixed(3)},${curve.endPoint.y.toFixed(3)}`;
        path.setAttribute("d", attr);
        path.setAttribute("stroke-width", (curve.endWidth * 2.25).toFixed(3));
        path.setAttribute("stroke", penColor);
        path.setAttribute("fill", "none");
        path.setAttribute("stroke-linecap", "round");
        svg.appendChild(path);
      }
    }, (point2, { penColor, dotSize, minWidth, maxWidth }) => {
      const circle = document.createElement("circle");
      const size2 = dotSize > 0 ? dotSize : (minWidth + maxWidth) / 2;
      circle.setAttribute("r", size2.toString());
      circle.setAttribute("cx", point2.x.toString());
      circle.setAttribute("cy", point2.y.toString());
      circle.setAttribute("fill", penColor);
      svg.appendChild(circle);
    });
    return svg.outerHTML;
  }
}
const _hoisted_1$q = ["disabled"];
const _hoisted_2$g = {
  key: 1,
  placeholder: "required",
  type: "text",
  required: "",
  class: "pixel opacity-0"
};
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "SignaturePad",
  props: /* @__PURE__ */ mergeModels({
    sigOption: {},
    width: {},
    height: {},
    ratio: {},
    clearOnResize: { type: Boolean },
    waterMark: {},
    disabled: { type: Boolean },
    defaultUrl: {},
    format: {},
    clearable: { type: Boolean, default: true },
    required: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
    "file": {},
    "fileModifiers": {}
  }),
  emits: ["update:modelValue", "update:file"],
  setup(__props, { expose: __expose }) {
    const props2 = __props;
    const sigData = useModel(__props, "modelValue");
    const fileData = useModel(__props, "file");
    const vCanvas = ref();
    let sig = ref();
    let _isEmpty = ref(true);
    function clear() {
      var _a;
      (_a = sig.value) == null ? void 0 : _a.clear();
      _isEmpty.value = true;
      sigData.value = void 0;
    }
    function save2(format2) {
      var _a, _b;
      format2 = format2 || props2.format;
      return format2 ? (_a = sig.value) == null ? void 0 : _a.toDataURL(format2) : (_b = sig.value) == null ? void 0 : _b.toDataURL();
    }
    function saveFile() {
      const data2 = save2();
      if (!data2) return;
      if (props2.format === "image/svg+xml") {
        fileData.value = new File([data2], "signature.svg", { type: "image/svg+xml" });
      } else {
        const base64Data = data2.split(",")[1];
        const byteCharacters = atob(base64Data);
        const byteNumbers = Array.from({ length: byteCharacters.length });
        for (let i2 = 0; i2 < byteCharacters.length; i2++) {
          byteNumbers[i2] = byteCharacters.charCodeAt(i2);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: props2.format || "image/png" });
        const extension = (props2.format || "image/png").split("/")[1];
        fileData.value = new File([blob], `signature.${extension}`, { type: props2.format || "image/png" });
      }
    }
    const fromDataURL = (url) => {
      var _a;
      return (_a = sig.value) == null ? void 0 : _a.fromDataURL(url);
    };
    const isEmpty = () => {
      var _a;
      return (_a = sig.value) == null ? void 0 : _a.isEmpty();
    };
    function undo() {
      var _a, _b;
      const data2 = (_a = sig.value) == null ? void 0 : _a.toData();
      if (data2) {
        data2.pop();
        (_b = sig.value) == null ? void 0 : _b.fromData(data2);
      }
    }
    const defaultOptions = ref({
      penColor: "rgb(0, 0, 0)",
      backgroundColor: "rgb(255, 255, 255)"
    });
    const signatureOptions = computed(() => ({ ...defaultOptions.value, ...props2.sigOption }));
    watch(
      () => props2.disabled,
      (val) => {
        var _a, _b;
        if (val) (_a = sig.value) == null ? void 0 : _a.off();
        else (_b = sig.value) == null ? void 0 : _b.on();
      }
    );
    function addWaterMark(data2) {
      var _a;
      if (!(Object.prototype.toString.call(data2) === "[object Object]")) {
        throw new Error(`Expected Object, got ${typeof data2}.`);
      } else {
        const textData = {
          text: data2.text || "",
          x: data2.x || 20,
          y: data2.y || 20,
          sx: data2.sx || 40,
          sy: data2.sy || 40
        };
        const ctx = (_a = vCanvas.value) == null ? void 0 : _a.getContext("2d");
        if (!ctx) return;
        ctx.font = data2.font || "20px sans-serif";
        ctx.fillStyle = data2.fillStyle || "#333";
        ctx.strokeStyle = data2.strokeStyle || "#333";
        if (data2.style === "all") {
          ctx.fillText(textData.text, textData.x, textData.y);
          ctx.strokeText(textData.text, textData.sx, textData.sy);
        } else if (data2.style === "stroke") {
          ctx.strokeText(textData.text, textData.sx, textData.sy);
        } else {
          ctx.fillText(textData.text, textData.x, textData.y);
        }
      }
    }
    function onEndStroke() {
      var _a;
      _isEmpty.value = ((_a = sig.value) == null ? void 0 : _a.isEmpty()) ?? false;
      const data2 = save2();
      sigData.value = data2;
      saveFile();
    }
    async function loadFile(file) {
      if (!file) return;
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.onload = (e) => {
          var _a;
          const dataUrl = (_a = e.target) == null ? void 0 : _a.result;
          fromDataURL(dataUrl);
          _isEmpty.value = false;
          sigData.value = dataUrl;
          resolve(true);
        };
        reader.readAsDataURL(file);
      });
    }
    watch(fileData, (newFile) => {
      loadFile(newFile);
    });
    function draw() {
      const canvas = vCanvas.value;
      sig.value = new SignaturePad(canvas, signatureOptions.value);
      function resizeCanvas(c2) {
        let url;
        if (!isEmpty()) url = save2();
        const ratio = props2.ratio ?? 1 / 2;
        const { width } = c2.getBoundingClientRect();
        c2.width = props2.width ? Number(props2.width.replaceAll("px", "")) : width;
        c2.height = props2.height ? Number(props2.height.replaceAll("px", "")) : width * ratio;
        clear();
        if (!props2.clearOnResize && url !== void 0) fromDataURL(url);
        if (props2.waterMark) addWaterMark(props2.waterMark);
      }
      window.addEventListener("resize", () => {
        resizeCanvas(canvas);
      });
      resizeCanvas(canvas);
      if (props2.disabled) sig.value.off();
      else sig.value.on();
      _isEmpty.value = sig.value.isEmpty();
      sig.value.addEventListener("endStroke", onEndStroke);
      if (fileData.value) {
        loadFile(fileData.value);
      }
    }
    onMounted(draw);
    onUnmounted(() => {
      var _a;
      (_a = sig.value) == null ? void 0 : _a.removeEventListener("endStroke", onEndStroke);
    });
    __expose({
      save: save2,
      clear,
      isEmpty,
      undo,
      addWaterMark,
      fromDataURL
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bgl_input signature-pad relative", { "bg-transparent": _ctx.disabled }]),
        onTouchmove: _cache[0] || (_cache[0] = withModifiers(() => {
        }, ["prevent"]))
      }, [
        _ctx.clearable && !_ctx.disabled ? (openBlock(), createBlock(unref(Btn), {
          key: 0,
          flat: "",
          thin: "",
          icon: "refresh",
          class: "position-bottom-end",
          onClick: clear
        })) : createCommentVNode("", true),
        createElementVNode("canvas", {
          ref_key: "vCanvas",
          ref: vCanvas,
          class: "canvas",
          disabled: _ctx.disabled
        }, null, 8, _hoisted_1$q),
        _ctx.required && unref(_isEmpty) ? (openBlock(), createElementBlock("input", _hoisted_2$g)) : createCommentVNode("", true)
      ], 34);
    };
  }
});
/*!
  * vue-draggable-next v2.2.0
  * (c) 2023 Anish George
  * @license MIT
  */
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var version = "1.14.0";
function userAgent(pattern2) {
  if (typeof window !== "undefined" && window.navigator) {
    return !!/* @__PURE__ */ navigator.userAgent.match(pattern2);
  }
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
  capture: false,
  passive: false
};
function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches(el, selector2) {
  if (!selector2) return;
  selector2[0] === ">" && (selector2 = selector2.substring(1));
  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector2);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector2);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector2);
      }
    } catch (_2) {
      return false;
    }
  }
  return false;
}
function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest(el, selector2, ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;
    do {
      if (selector2 != null && (selector2[0] === ">" ? el.parentNode === ctx && matches(el, selector2) : matches(el, selector2)) || includeCTX && el === ctx) {
        return el;
      }
      if (el === ctx) break;
    } while (el = getParentOrHost(el));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name, state2) {
  if (el && name) {
    if (el.classList) {
      el.classList[state2 ? "add" : "remove"](name);
    } else {
      var className = (" " + el.className + " ").replace(R_SPACE, " ").replace(" " + name + " ", " ");
      el.className = (className + (state2 ? " " + name : "")).replace(R_SPACE, " ");
    }
  }
}
function css(el, prop3, val) {
  var style = el && el.style;
  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, "");
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }
      return prop3 === void 0 ? val : val[prop3];
    } else {
      if (!(prop3 in style) && prop3.indexOf("webkit") === -1) {
        prop3 = "-webkit-" + prop3;
      }
      style[prop3] = val + (typeof val === "string" ? "" : "px");
    }
  }
}
function matrix(el, selfOnly) {
  var appliedTransforms = "";
  if (typeof el === "string") {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, "transform");
      if (transform && transform !== "none") {
        appliedTransforms = transform + " " + appliedTransforms;
      }
    } while (!selfOnly && (el = el.parentNode));
  }
  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName), i2 = 0, n2 = list.length;
    if (iterator) {
      for (; i2 < n2; i2++) {
        iterator(list[i2], i2);
      }
    }
    return list;
  }
  return [];
}
function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;
  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top2, left2, bottom2, right2, height, width;
  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top2 = elRect.top;
    left2 = elRect.left;
    bottom2 = elRect.bottom;
    right2 = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top2 = 0;
    left2 = 0;
    bottom2 = window.innerHeight;
    right2 = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }
  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    container = container || el.parentNode;
    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, "transform") !== "none" || relativeToNonStaticParent && css(container, "position") !== "static")) {
          var containerRect = container.getBoundingClientRect();
          top2 -= containerRect.top + parseInt(css(container, "border-top-width"));
          left2 -= containerRect.left + parseInt(css(container, "border-left-width"));
          bottom2 = top2 + elRect.height;
          right2 = left2 + elRect.width;
          break;
        }
      } while (container = container.parentNode);
    }
  }
  if (undoScale && el !== window) {
    var elMatrix = matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
    if (elMatrix) {
      top2 /= scaleY;
      left2 /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom2 = top2 + height;
      right2 = left2 + width;
    }
  }
  return {
    top: top2,
    left: left2,
    bottom: bottom2,
    right: right2,
    width,
    height
  };
}
function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
  while (parent) {
    var parentSideVal = getRect(parent)[parentSide], visible = void 0;
    {
      visible = elSideVal >= parentSideVal;
    }
    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }
  return false;
}
function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0, i2 = 0, children2 = el.children;
  while (i2 < children2.length) {
    if (children2[i2].style.display !== "none" && children2[i2] !== Sortable.ghost && (includeDragEl || children2[i2] !== Sortable.dragged) && closest(children2[i2], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children2[i2];
      }
      currentChild++;
    }
    i2++;
  }
  return null;
}
function lastChild(el, selector2) {
  var last = el.lastElementChild;
  while (last && (last === Sortable.ghost || css(last, "display") === "none" || selector2 && !matches(last, selector2))) {
    last = last.previousElementSibling;
  }
  return last || null;
}
function index(el, selector2) {
  var index2 = 0;
  if (!el || !el.parentNode) {
    return -1;
  }
  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== Sortable.clone && (!selector2 || matches(el, selector2))) {
      index2++;
    }
  }
  return index2;
}
function getRelativeScrollOffset(el) {
  var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
  if (el) {
    do {
      var elMatrix = matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }
  return [offsetLeft, offsetTop];
}
function indexOfObject(arr, obj) {
  for (var i2 in arr) {
    if (!arr.hasOwnProperty(i2)) continue;
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i2][key]) return Number(i2);
    }
  }
  return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;
  do {
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);
      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
  } while (elem = elem.parentNode);
  return getWindowScrollingElement();
}
function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }
  return dst;
}
function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle(callback, ms) {
  return function() {
    if (!_throttleTimeout) {
      var args = arguments, _this = this;
      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }
      _throttleTimeout = setTimeout(function() {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}
function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}
function scrollBy(el, x2, y2) {
  el.scrollLeft += x2;
  el.scrollTop += y2;
}
function clone(el) {
  var Polymer = window.Polymer;
  var $2 = window.jQuery || window.Zepto;
  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($2) {
    return $2(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}
var expando = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function AnimationStateManager() {
  var animationStates = [], animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children2 = [].slice.call(this.el.children);
      children2.forEach(function(child) {
        if (css(child, "display") === "none" || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });
        var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);
        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);
          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }
        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state2) {
      animationStates.push(state2);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;
      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === "function") callback();
        return;
      }
      var animating = false, animationTime = 0;
      animationStates.forEach(function(state2) {
        var time = 0, target = state2.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state2.rect, targetMatrix = matrix(target, true);
        if (targetMatrix) {
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }
        target.toRect = toRect;
        if (target.thisAnimationDuration) {
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        }
        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;
          if (!time) {
            time = _this.options.animation;
          }
          _this.animate(target, animatingRect, toRect, time);
        }
        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function() {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);
      if (!animating) {
        if (typeof callback === "function") callback();
      } else {
        animationCallbackId = setTimeout(function() {
          if (typeof callback === "function") callback();
        }, animationTime);
      }
      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, "transition", "");
        css(target, "transform", "");
        var elMatrix = matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX2 = (currentRect.left - toRect.left) / (scaleX || 1), translateY2 = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX2;
        target.animatingY = !!translateY2;
        css(target, "transform", "translate3d(" + translateX2 + "px," + translateY2 + "px,0)");
        this.forRepaintDummy = repaint(target);
        css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
        css(target, "transform", "translate3d(0,0,0)");
        typeof target.animated === "number" && clearTimeout(target.animated);
        target.animated = setTimeout(function() {
          css(target, "transition", "");
          css(target, "transform", "");
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}
function repaint(target) {
  return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    for (var option2 in defaults) {
      if (defaults.hasOwnProperty(option2) && !(option2 in plugin)) {
        plugin[option2] = defaults[option2];
      }
    }
    plugins.forEach(function(p2) {
      if (p2.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent2(eventName, sortable, evt) {
    var _this = this;
    this.eventCanceled = false;
    evt.cancel = function() {
      _this.eventCanceled = true;
    };
    var eventNameGlobal = eventName + "Global";
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName]) return;
      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
          sortable
        }, evt));
      }
      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2({
          sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults2, options) {
    plugins.forEach(function(plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized;
      _extends(defaults2, initialized.defaults);
    });
    for (var option2 in sortable.options) {
      if (!sortable.options.hasOwnProperty(option2)) continue;
      var modified = this.modifyOption(sortable, option2, sortable.options[option2]);
      if (typeof modified !== "undefined") {
        sortable.options[option2] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function(plugin) {
      if (typeof plugin.eventProperties !== "function") return;
      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName]) return;
      if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};
function dispatchEvent(_ref) {
  var sortable = _ref.sortable, rootEl2 = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl2 = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex2 = _ref.oldIndex, newIndex2 = _ref.newIndex, oldDraggableIndex2 = _ref.oldDraggableIndex, newDraggableIndex2 = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl2 && rootEl2[expando];
  if (!sortable) return;
  var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent(name, true, true);
  }
  evt.to = toEl || rootEl2;
  evt.from = fromEl || rootEl2;
  evt.item = targetEl || rootEl2;
  evt.clone = cloneEl2;
  evt.oldIndex = oldIndex2;
  evt.newIndex = newIndex2;
  evt.oldDraggableIndex = oldDraggableIndex2;
  evt.newDraggableIndex = newDraggableIndex2;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable2 ? putSortable2.lastPutMode : void 0;
  var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
  for (var option2 in allEventProperties) {
    evt[option2] = allEventProperties[option2];
  }
  if (rootEl2) {
    rootEl2.dispatchEvent(evt);
  }
  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}
var _excluded = ["evt"];
var pluginEvent = function pluginEvent3(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, originalEvent = _ref.evt, data2 = _objectWithoutProperties(_ref, _excluded);
  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
    dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    dragStarted: moved,
    putSortable,
    activeSortable: Sortable.active,
    originalEvent,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable,
        name,
        originalEvent
      });
    }
  }, data2));
};
function _dispatchEvent(info) {
  dispatchEvent(_objectSpread2({
    putSortable,
    cloneEl,
    targetEl: dragEl,
    rootEl,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex
  }, info));
}
var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = false, ignoreNextClick = false, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = false, isCircumstantialInvert = false, targetMoveDistance, ghostRelativeParent, ghostRelativeParentInitialScroll = [], _silent = false, savedInputChecked = [];
var documentExists = typeof document !== "undefined", PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float", supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div"), supportCssPointerEvents = function() {
  if (!documentExists) return;
  if (IE11OrLess) {
    return false;
  }
  var el = document.createElement("x");
  el.style.cssText = "pointer-events:auto";
  return el.style.pointerEvents === "auto";
}(), _detectDirection = function _detectDirection2(el, options) {
  var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
  if (elCSS.display === "flex") {
    return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  }
  if (elCSS.display === "grid") {
    return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  }
  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
    var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
    return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
  }
  return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === "none" || child2 && elCSS[CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, _dragElInRowColumn = function _dragElInRowColumn2(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, _detectNearestEmptySortable = function _detectNearestEmptySortable2(x2, y2) {
  var ret;
  sortables.some(function(sortable) {
    var threshold = sortable[expando].options.emptyInsertThreshold;
    if (!threshold || lastChild(sortable)) return;
    var rect = getRect(sortable), insideHorizontally = x2 >= rect.left - threshold && x2 <= rect.right + threshold, insideVertically = y2 >= rect.top - threshold && y2 <= rect.bottom + threshold;
    if (insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
}, _prepareGroup = function _prepareGroup2(options) {
  function toFn(value, pull) {
    return function(to, from, dragEl2, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
      if (value == null && (pull || sameGroup)) {
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === "clone") {
        return value;
      } else if (typeof value === "function") {
        return toFn(value(to, from, dragEl2, evt), pull)(to, from, dragEl2, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }
  var group = {};
  var originalGroup = options.group;
  if (!originalGroup || _typeof(originalGroup) != "object") {
    originalGroup = {
      name: originalGroup
    };
  }
  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
}, _hideGhostForTarget = function _hideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "none");
  }
}, _unhideGhostForTarget = function _unhideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "");
  }
};
if (documentExists) {
  document.addEventListener("click", function(evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent2(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;
    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
    if (nearest) {
      var event = {};
      for (var i2 in evt) {
        if (evt.hasOwnProperty(i2)) {
          event[i2] = evt[i2];
        }
      }
      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;
      nearest[expando]._onDragOver(event);
    }
  }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl2(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }
  this.el = el;
  this.options = options = _extends({}, options);
  el[expando] = this;
  var defaults2 = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl2) {
      dataTransfer.setData("Text", dragEl2.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && "PointerEvent" in window && !Safari,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults2);
  for (var name in defaults2) {
    !(name in options) && (options[name] = defaults2[name]);
  }
  _prepareGroup(options);
  for (var fn in this) {
    if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
      this[fn] = this[fn].bind(this);
    }
  }
  this.nativeDraggable = options.forceFallback ? false : supportDraggable;
  if (this.nativeDraggable) {
    this.options.touchStartThreshold = 1;
  }
  if (options.supportPointer) {
    on(el, "pointerdown", this._onTapStart);
  } else {
    on(el, "mousedown", this._onTapStart);
    on(el, "touchstart", this._onTapStart);
  }
  if (this.nativeDraggable) {
    on(el, "dragover", this);
    on(el, "dragenter", this);
  }
  sortables.push(this.el);
  options.store && options.store.get && this.sort(options.store.get(this) || []);
  _extends(this, AnimationStateManager());
}
Sortable.prototype = /** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(evt) {
    if (!evt.cancelable) return;
    var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type3 = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter3 = options.filter;
    _saveInputCheckedState(el);
    if (dragEl) {
      return;
    }
    if (/mousedown|pointerdown/.test(type3) && evt.button !== 0 || options.disabled) {
      return;
    }
    if (originalTarget.isContentEditable) {
      return;
    }
    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === "SELECT") {
      return;
    }
    target = closest(target, options.draggable, el, false);
    if (target && target.animated) {
      return;
    }
    if (lastDownEl === target) {
      return;
    }
    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable);
    if (typeof filter3 === "function") {
      if (filter3.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: "filter",
          targetEl: target,
          toEl: el,
          fromEl: el
        });
        pluginEvent("filter", _this, {
          evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    } else if (filter3) {
      filter3 = filter3.split(",").some(function(criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);
        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: "filter",
            targetEl: target,
            fromEl: el,
            toEl: el
          });
          pluginEvent("filter", _this, {
            evt
          });
          return true;
        }
      });
      if (filter3) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    }
    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    }
    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(evt, touch, target) {
    var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style["will-change"] = "all";
      dragStartFn = function dragStartFn2() {
        pluginEvent("delayEnded", _this, {
          evt
        });
        if (Sortable.eventCanceled) {
          _this._onDrop();
          return;
        }
        _this._disableDelayedDragEvents();
        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        }
        _this._triggerDragStart(evt, touch);
        _dispatchEvent({
          sortable: _this,
          name: "choose",
          originalEvent: evt
        });
        toggleClass(dragEl, options.chosenClass, true);
      };
      options.ignore.split(",").forEach(function(criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, "dragover", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mousemove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "touchmove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mouseup", _this._onDrop);
      on(ownerDocument, "touchend", _this._onDrop);
      on(ownerDocument, "touchcancel", _this._onDrop);
      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }
      pluginEvent("delayStart", this, {
        evt
      });
      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        on(ownerDocument, "mouseup", _this._disableDelayedDrag);
        on(ownerDocument, "touchend", _this._disableDelayedDrag);
        on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
        on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
        on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
    var touch = e.touches ? e.touches[0] : e;
    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);
    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._disableDelayedDrag);
    off(ownerDocument, "touchend", this._disableDelayedDrag);
    off(ownerDocument, "touchcancel", this._disableDelayedDrag);
    off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(evt, touch) {
    touch = touch || evt.pointerType == "touch" && evt;
    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, "pointermove", this._onTouchMove);
      } else if (touch) {
        on(document, "touchmove", this._onTouchMove);
      } else {
        on(document, "mousemove", this._onTouchMove);
      }
    } else {
      on(dragEl, "dragend", this);
      on(rootEl, "dragstart", this._onDragStart);
    }
    try {
      if (document.selection) {
        _nextTick(function() {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {
    }
  },
  _dragStarted: function _dragStarted(fallback, evt) {
    awaitingDragStarted = false;
    if (rootEl && dragEl) {
      pluginEvent("dragStarted", this, {
        evt
      });
      if (this.nativeDraggable) {
        on(document, "dragover", _checkOutsideTargetEl);
      }
      var options = this.options;
      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost();
      _dispatchEvent({
        sortable: this,
        name: "start",
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;
      _hideGhostForTarget();
      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;
      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }
      dragEl.parentNode[expando]._isOutsideThisEl(target);
      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target,
              rootEl: parent
            });
            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }
          target = parent;
        } while (parent = parent.parentNode);
      }
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(evt) {
    if (tapEvt) {
      var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX = ghostEl && ghostMatrix && ghostMatrix.a, scaleY = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }
        this._onDragStart(evt, true);
      }
      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }
        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, "webkitTransform", cssMatrix);
        css(ghostEl, "mozTransform", cssMatrix);
        css(ghostEl, "msTransform", cssMatrix);
        css(ghostEl, "transform", cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }
      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
      if (PositionGhostAbsolutely) {
        ghostRelativeParent = container;
        while (css(ghostRelativeParent, "position") === "static" && css(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }
        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }
        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, "transition", "");
      css(ghostEl, "transform", "");
      css(ghostEl, "box-sizing", "border-box");
      css(ghostEl, "margin", 0);
      css(ghostEl, "top", rect.top);
      css(ghostEl, "left", rect.left);
      css(ghostEl, "width", rect.width);
      css(ghostEl, "height", rect.height);
      css(ghostEl, "opacity", "0.8");
      css(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed");
      css(ghostEl, "zIndex", "100000");
      css(ghostEl, "pointerEvents", "none");
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl);
      css(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
    }
  },
  _onDragStart: function _onDragStart(evt, fallback) {
    var _this = this;
    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent("dragStart", this, {
      evt
    });
    if (Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent("setupClone", this);
    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style["will-change"] = "";
      this._hideClone();
      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    }
    _this.cloneId = _nextTick(function() {
      pluginEvent("clone", _this);
      if (Sortable.eventCanceled) return;
      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }
      _this._hideClone();
      _dispatchEvent({
        sortable: _this,
        name: "clone"
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true);
    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      off(document, "mouseup", _this._onDrop);
      off(document, "touchend", _this._onDrop);
      off(document, "touchcancel", _this._onDrop);
      if (dataTransfer) {
        dataTransfer.effectAllowed = "move";
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }
      on(document, "drop", _this);
      css(dragEl, "transform", "translateZ(0)");
    }
    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, "selectstart", _this);
    moved = true;
    if (Safari) {
      css(document.body, "user-select", "none");
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(evt) {
    var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this = this, completedFired = false;
    if (_silent) return;
    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread2({
        evt,
        isOwner,
        axis: vertical ? "vertical" : "horizontal",
        revert,
        dragRect,
        targetRect,
        canSort,
        fromSortable,
        target,
        completed,
        onMove: function onMove(target2, after2) {
          return _onMove(rootEl, el, dragEl, dragRect, target2, getRect(target2), evt, after2);
        },
        changed
      }, extra));
    }
    function capture() {
      dragOverEvent("dragOverAnimationCapture");
      _this.captureAnimationState();
      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    }
    function completed(insertion) {
      dragOverEvent("dragOverCompleted", {
        insertion
      });
      if (insertion) {
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }
        if (_this !== fromSortable) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }
        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        }
        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }
        _this.animateAll(function() {
          dragOverEvent("dragOverAnimationComplete");
          _this._ignoreWhileAnimating = null;
        });
        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      }
      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      }
      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        !insertion && nearestEmptyInsertDetectEvent(evt);
      }
      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    }
    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      _dispatchEvent({
        sortable: _this,
        name: "change",
        toEl: el,
        newIndex,
        newDraggableIndex,
        originalEvent: evt
      });
    }
    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }
    target = closest(target, options.draggable, el, true);
    dragOverEvent("dragOver");
    if (Sortable.eventCanceled) return completedFired;
    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }
    ignoreNextClick = false;
    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === "vertical";
      dragRect = getRect(dragEl);
      dragOverEvent("dragOverValid");
      if (Sortable.eventCanceled) return completedFired;
      if (revert) {
        parentEl = rootEl;
        capture();
        this._hideClone();
        dragOverEvent("revert");
        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }
        return completed(true);
      }
      var elLastChild = lastChild(el, options.draggable);
      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        if (elLastChild === dragEl) {
          return completed(false);
        }
        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }
        if (target) {
          targetRect = getRect(target);
        }
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        var firstChild = getChild(el, 0, options, true);
        if (firstChild === dragEl) {
          return completed(false);
        }
        target = firstChild;
        targetRect = getRect(target);
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = isScrolledPast(target, "top", "top") || isScrolledPast(dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }
        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;
        if (direction !== 0) {
          var dragIndex = index(dragEl);
          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, "display") === "none" || sibling === ghostEl));
        }
        if (direction === 0 || sibling === target) {
          return completed(false);
        }
        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling, after = false;
        after = direction === 1;
        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }
          _silent = true;
          setTimeout(_unsilent, 30);
          capture();
          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          }
          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }
          parentEl = dragEl.parentNode;
          if (targetBeforeFirstSwap !== void 0 && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }
          changed();
          return completed(true);
        }
      }
      if (el.contains(dragEl)) {
        return completed(false);
      }
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, "mousemove", this._onTouchMove);
    off(document, "touchmove", this._onTouchMove);
    off(document, "pointermove", this._onTouchMove);
    off(document, "dragover", nearestEmptyInsertDetectEvent);
    off(document, "mousemove", nearestEmptyInsertDetectEvent);
    off(document, "touchmove", nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._onDrop);
    off(ownerDocument, "touchend", this._onDrop);
    off(ownerDocument, "pointerup", this._onDrop);
    off(ownerDocument, "touchcancel", this._onDrop);
    off(document, "selectstart", this);
  },
  _onDrop: function _onDrop(evt) {
    var el = this.el, options = this.options;
    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent("drop", this, {
      evt
    });
    parentEl = dragEl && dragEl.parentNode;
    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    if (Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);
    _cancelNextTick(this.cloneId);
    _cancelNextTick(this._dragStartId);
    if (this.nativeDraggable) {
      off(document, "drop", this);
      off(el, "dragstart", this._onDragStart);
    }
    this._offMoveEvents();
    this._offUpEvents();
    if (Safari) {
      css(document.body, "user-select", "");
    }
    css(dragEl, "transform", "");
    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }
      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") {
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }
      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, "dragend", this);
        }
        _disableDraggable(dragEl);
        dragEl.style["will-change"] = "";
        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }
        toggleClass(dragEl, this.options.chosenClass, false);
        _dispatchEvent({
          sortable: this,
          name: "unchoose",
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });
        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            _dispatchEvent({
              rootEl: parentEl,
              name: "add",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "remove",
              toEl: parentEl,
              originalEvent: evt
            });
            _dispatchEvent({
              rootEl: parentEl,
              name: "sort",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "sort",
              toEl: parentEl,
              originalEvent: evt
            });
          }
          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              _dispatchEvent({
                sortable: this,
                name: "update",
                toEl: parentEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: "sort",
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }
        if (Sortable.active) {
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }
          _dispatchEvent({
            sortable: this,
            name: "end",
            toEl: parentEl,
            originalEvent: evt
          });
          this.save();
        }
      }
    }
    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent("nulling", this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function(el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(evt) {
    switch (evt.type) {
      case "drop":
      case "dragend":
        this._onDrop(evt);
        break;
      case "dragenter":
      case "dragover":
        if (dragEl) {
          this._onDragOver(evt);
          _globalDragOver(evt);
        }
        break;
      case "selectstart":
        evt.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray2() {
    var order = [], el, children2 = this.el.children, i2 = 0, n2 = children2.length, options = this.options;
    for (; i2 < n2; i2++) {
      el = children2[i2];
      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }
    return order;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order, useAnimation) {
    var items = {}, rootEl2 = this.el;
    this.toArray().forEach(function(id, i2) {
      var el = rootEl2.children[i2];
      if (closest(el, this.options.draggable, rootEl2, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function(id) {
      if (items[id]) {
        rootEl2.removeChild(items[id]);
        rootEl2.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector2) {
    return closest(el, selector2 || this.options.draggable, this.el, false);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;
    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);
      if (typeof modifiedValue !== "undefined") {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }
      if (name === "group") {
        _prepareGroup(options);
      }
    }
  },
  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent("destroy", this);
    var el = this.el;
    el[expando] = null;
    off(el, "mousedown", this._onTapStart);
    off(el, "touchstart", this._onTapStart);
    off(el, "pointerdown", this._onTapStart);
    if (this.nativeDraggable) {
      off(el, "dragover", this);
      off(el, "dragenter", this);
    }
    Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el2) {
      el2.removeAttribute("draggable");
    });
    this._onDrop();
    this._disableDelayedDragEvents();
    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent("hideClone", this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, "display", "none");
      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }
      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable2) {
    if (putSortable2.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      pluginEvent("showClone", this);
      if (Sortable.eventCanceled) return;
      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }
      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }
      css(cloneEl, "display", "");
      cloneHidden = false;
    }
  }
};
function _globalDragOver(evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = "move";
  }
  evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl2, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent("move", {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent("move", true, true);
  }
  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl2;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);
  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }
  return retVal;
}
function _disableDraggable(el) {
  el.draggable = false;
}
function _unsilent() {
  _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
  var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var spacer = 10;
  return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
  if (!invertSwap) {
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        pastFirstInvertThresh = true;
      }
      if (!pastFirstInvertThresh) {
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }
  invert = invert || invertSwap;
  if (invert) {
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }
  return 0;
}
function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent, i2 = str.length, sum = 0;
  while (i2--) {
    sum += str.charCodeAt(i2);
  }
  return sum.toString(36);
}
function _saveInputCheckedState(root2) {
  savedInputChecked.length = 0;
  var inputs = root2.getElementsByTagName("input");
  var idx = inputs.length;
  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}
function _nextTick(fn) {
  return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
  return clearTimeout(id);
}
if (documentExists) {
  on(document, "touchmove", function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
}
Sortable.utils = {
  on,
  off,
  css,
  find,
  is: function is3(el, selector2) {
    return !!closest(el, selector2, el, false);
  },
  extend,
  throttle,
  closest,
  toggleClass,
  clone,
  index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild
};
Sortable.get = function(element) {
  return element[expando];
};
Sortable.mount = function() {
  for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins2[_key] = arguments[_key];
  }
  if (plugins2[0].constructor === Array) plugins2 = plugins2[0];
  plugins2.forEach(function(plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }
    if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};
Sortable.create = function(el, options) {
  return new Sortable(el, options);
};
Sortable.version = version;
var autoScrolls = [], scrollEl, scrollRootEl, scrolling = false, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var fn in this) {
      if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
        this[fn] = this[fn].bind(this);
      }
    }
  }
  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;
      if (this.sortable.nativeDraggable) {
        on(document, "dragover", this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, "pointermove", this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, "touchmove", this._handleFallbackAutoScroll);
        } else {
          on(document, "mousemove", this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop3() {
      if (this.sortable.nativeDraggable) {
        off(document, "dragover", this._handleAutoScroll);
      } else {
        off(document, "pointermove", this._handleFallbackAutoScroll);
        off(document, "touchmove", this._handleFallbackAutoScroll);
        off(document, "mousemove", this._handleFallbackAutoScroll);
      }
      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;
      var x2 = (evt.touches ? evt.touches[0] : evt).clientX, y2 = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x2, y2);
      touchEvt$1 = evt;
      if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback);
        var ogElemScroller = getParentAutoScrollElement(elem, true);
        if (scrolling && (!pointerElemChangedInterval || x2 !== lastAutoScrollX || y2 !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval();
          pointerElemChangedInterval = setInterval(function() {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x2, y2), true);
            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }
            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x2;
          lastAutoScrollY = y2;
        }
      } else {
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }
        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function clearAutoScrolls() {
  autoScrolls.forEach(function(autoScroll2) {
    clearInterval(autoScroll2.pid);
  });
  autoScrolls = [];
}
function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle(function(evt, options, rootEl2, isFallback) {
  if (!options.scroll) return;
  var x2 = (evt.touches ? evt.touches[0] : evt).clientX, y2 = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
  var scrollThisInstance = false, scrollCustomFn;
  if (scrollRootEl !== rootEl2) {
    scrollRootEl = rootEl2;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;
    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl2, true);
    }
  }
  var layersOut = 0;
  var currentParent = scrollEl;
  do {
    var el = currentParent, rect = getRect(el), top2 = rect.top, bottom2 = rect.bottom, left2 = rect.left, right2 = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
    }
    var vx = canScrollX && (Math.abs(right2 - x2) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left2 - x2) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom2 - y2) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top2 - y2) <= sens && !!scrollPosY);
    if (!autoScrolls[layersOut]) {
      for (var i2 = 0; i2 <= layersOut; i2++) {
        if (!autoScrolls[i2]) {
          autoScrolls[i2] = {};
        }
      }
    }
    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);
      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        autoScrolls[layersOut].pid = setInterval((function() {
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1);
          }
          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
          if (typeof scrollCustomFn === "function") {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== "continue") {
              return;
            }
          }
          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }).bind({
          layer: layersOut
        }), 24);
      }
    }
    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
  scrolling = scrollThisInstance;
}, 30);
var drop = function drop2(_ref) {
  var originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, dragEl2 = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable2 || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();
  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent("spill");
    this.onSpill({
      dragEl: dragEl2,
      putSortable: putSortable2
    });
  }
};
function Revert() {
}
Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex2 = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex2;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl2 = _ref3.dragEl, putSortable2 = _ref3.putSortable;
    this.sortable.captureAnimationState();
    if (putSortable2) {
      putSortable2.captureAnimationState();
    }
    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl2, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl2);
    }
    this.sortable.animateAll();
    if (putSortable2) {
      putSortable2.animateAll();
    }
  },
  drop
};
_extends(Revert, {
  pluginName: "revertOnSpill"
});
function Remove() {
}
Remove.prototype = {
  onSpill: function onSpill2(_ref4) {
    var dragEl2 = _ref4.dragEl, putSortable2 = _ref4.putSortable;
    var parentSortable = putSortable2 || this.sortable;
    parentSortable.captureAnimationState();
    dragEl2.parentNode && dragEl2.parentNode.removeChild(dragEl2);
    parentSortable.animateAll();
  },
  drop
};
_extends(Remove, {
  pluginName: "removeOnSpill"
});
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }
  return global.console;
}
const console$1 = getConsole();
function cached(fn) {
  const cache = /* @__PURE__ */ Object.create(null);
  return function cachedFn(str) {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}
const regex = /-(\w)/g;
const camelize = cached((str) => str.replace(regex, (_2, c2) => c2 ? c2.toUpperCase() : ""));
function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}
function insertNodeAt(fatherNode, node, position) {
  const refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}
function computeVmIndex(vnodes, element) {
  return Object.values(vnodes).indexOf(element);
}
function computeIndexes(slots, children2, isTransition2, footerOffset) {
  if (!slots) {
    return [];
  }
  const elmFromNodes = Object.values(slots);
  const footerIndex = children2.length - footerOffset;
  const rawIndexes = [...children2].map((elt, idx) => idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt));
  return rawIndexes;
}
function emit(evtName, evtData) {
  this.$nextTick(() => this.$emit(evtName.toLowerCase(), evtData));
}
function delegateAndEmit(evtName) {
  return (evtData) => {
    if (this.realList !== null) {
      this["onDrag" + evtName](evtData);
    }
    emit.call(this, evtName, evtData);
  };
}
function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}
function isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }
  const [{ type: type3 }] = slots;
  if (!type3) {
    return false;
  }
  return isTransitionName(type3.name);
}
function getComponentAttributes($attrs, componentData) {
  if (!componentData) {
    return $attrs;
  }
  return { ...componentData.props, ...componentData.attrs };
}
const eventsListened = ["Start", "Add", "Remove", "Update", "End"];
const eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
const readonlyProperties = ["Move", ...eventsListened, ...eventsToEmit].map((evt) => "on" + evt);
let draggingElement = null;
const props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: (original) => {
      return original;
    }
  },
  tag: {
    type: String,
    default: "div"
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  },
  component: {
    type: String,
    default: null
  },
  modelValue: {
    type: Array,
    required: false,
    default: null
  }
};
const VueDraggableNext = defineComponent({
  name: "VueDraggableNext",
  inheritAttrs: false,
  emits: [
    "update:modelValue",
    "move",
    "change",
    ...eventsListened.map((s2) => s2.toLowerCase()),
    ...eventsToEmit.map((s2) => s2.toLowerCase())
  ],
  props,
  data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false,
      headerOffset: 0,
      footerOffset: 0,
      _sortable: {},
      visibleIndexes: [],
      context: {}
    };
  },
  render() {
    const slots = this.$slots.default ? this.$slots.default() : null;
    const attrs = getComponentAttributes(this.$attrs, this.componentData);
    if (!slots)
      return h$2(this.getTag(), attrs, []);
    this.transitionMode = isTransition(slots);
    return h$2(this.getTag(), attrs, slots);
  },
  created() {
    if (this.list !== null && this.modelValue !== null) {
      console$1.error("list props are mutually exclusive! Please set one.");
    }
  },
  mounted() {
    const optionsAdded = {};
    eventsListened.forEach((elt) => {
      optionsAdded["on" + elt] = delegateAndEmit.call(this, elt);
    });
    eventsToEmit.forEach((elt) => {
      optionsAdded["on" + elt] = emit.bind(this, elt);
    });
    const attributes = Object.keys(this.$attrs).reduce((res, key) => {
      res[camelize(key)] = this.$attrs[key];
      return res;
    }, {});
    const options = Object.assign({}, attributes, optionsAdded, {
      onMove: (evt, originalEvent) => {
        return this.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    const targetDomElement = this.$el.nodeType === 1 ? this.$el : this.$el.parentElement;
    this._sortable = new Sortable(targetDomElement, options);
    targetDomElement.__draggable_component__ = this;
    this.computeIndexes();
  },
  beforeUnmount() {
    try {
      if (this._sortable !== void 0)
        this._sortable.destroy();
    } catch (error) {
    }
  },
  computed: {
    realList() {
      return this.list ? this.list : this.modelValue;
    }
  },
  watch: {
    $attrs: {
      handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getTag() {
      return this.component ? resolveComponent(this.component) : this.tag;
    },
    updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        const value = camelize(property);
        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes() {
      return this.$el.children;
    },
    computeIndexes() {
      this.$nextTick(() => {
        this.visibleIndexes = computeIndexes(this.getChildrenNodes(), this.$el.children, this.transitionMode, this.footerOffset);
      });
    },
    getUnderlyingVm(htmlElt) {
      const index2 = computeVmIndex(this.getChildrenNodes() || [], htmlElt);
      if (index2 === -1) {
        return null;
      }
      const element = this.realList[index2];
      return { index: index2, element };
    },
    emitChanges(evt) {
      this.$nextTick(() => {
        this.$emit("change", evt);
      });
    },
    alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }
      const newList = [...this.modelValue];
      onList(newList);
      this.$emit("update:modelValue", newList);
    },
    spliceList() {
      const spliceList = (list) => list.splice(...arguments);
      this.alterList(spliceList);
    },
    updatePosition(oldIndex2, newIndex2) {
      const updatePosition = (list) => list.splice(newIndex2, 0, list.splice(oldIndex2, 1)[0]);
      this.alterList(updatePosition);
    },
    getVmIndex(domIndex) {
      const indexes = this.visibleIndexes;
      const numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent() {
      return this.$slots.default ? (
        //@ts-ignore
        this.$slots.default()[0].componentInstance
      ) : null;
    },
    resetTransitionData(index2) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }
      var nodes = this.getChildrenNodes();
      nodes[index2].data = null;
      const transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = void 0;
    },
    onDragStart(evt) {
      this.computeIndexes();
      this.context = this.getUnderlyingVm(evt.item);
      if (!this.context)
        return;
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd(evt) {
      const element = evt.item._underlying_vm_;
      if (element === void 0) {
        return;
      }
      removeNode(evt.item);
      const newIndex2 = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex2, 0, element);
      this.computeIndexes();
      const added = { element, newIndex: newIndex2 };
      this.emitChanges({ added });
    },
    onDragRemove(evt) {
      insertNodeAt(this.$el, evt.item, evt.oldIndex);
      if (evt.pullMode === "clone") {
        removeNode(evt.clone);
        return;
      }
      if (!this.context)
        return;
      const oldIndex2 = this.context.index;
      this.spliceList(oldIndex2, 1);
      const removed = { element: this.context.element, oldIndex: oldIndex2 };
      this.resetTransitionData(oldIndex2);
      this.emitChanges({ removed });
    },
    onDragUpdate(evt) {
      removeNode(evt.item);
      insertNodeAt(evt.from, evt.item, evt.oldIndex);
      const oldIndex2 = this.context.index;
      const newIndex2 = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex2, newIndex2);
      const moved2 = { element: this.context.element, oldIndex: oldIndex2, newIndex: newIndex2 };
      this.emitChanges({ moved: moved2 });
    },
    updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    onDragMove(evt, originalEvent) {
      const onMove = this.move;
      if (!onMove || !this.realList) {
        return true;
      }
      const relatedContext = this.getRelatedContextFromMoveEvent(evt);
      const draggedContext = this.context;
      const futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, { futureIndex });
      const sendEvt = Object.assign({}, evt, {
        relatedContext,
        draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    },
    getTrargetedComponent(htmElement) {
      return htmElement.__draggable_component__;
    },
    getRelatedContextFromMoveEvent({ to, related }) {
      const component = this.getTrargetedComponent(to);
      if (!component) {
        return { component };
      }
      const list = component.realList;
      const context = { list, component };
      if (to !== related && list && component.getUnderlyingVm) {
        const destination = component.getUnderlyingVm(related);
        if (destination) {
          return Object.assign(destination, context);
        }
      }
      return context;
    },
    computeFutureIndex(relatedContext, evt) {
      const domChildren = [...evt.to.children].filter((el) => el.style["display"] !== "none");
      if (domChildren.length === 0)
        return 0;
      const currentDOMIndex = domChildren.indexOf(evt.related);
      const currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      const draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    }
  }
});
const _hoisted_1$p = ["title"];
const _hoisted_2$f = { class: "bagel-input" };
const _hoisted_3$d = { class: "table-side-scroll" };
const _hoisted_4$7 = { class: "table-header" };
const _hoisted_5$7 = { class: "table-reorder" };
const _hoisted_6$6 = { class: "table-action" };
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  __name: "TableField",
  props: {
    description: { default: "" },
    meta: {},
    fieldname: {},
    bagelApp: { default: void 0 },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emits = __emit;
    let bagel;
    let api;
    const listRef = ref(props2.modelValue);
    const fieldMeta = props2.meta.doc_meta.fields.find(
      (field) => field.fieldname === props2.fieldname
    );
    const entityMeta = props2.meta.links.find(
      (link) => link.id === (fieldMeta == null ? void 0 : fieldMeta.options)
    );
    function handleUpdateModelValue(value, index2, fieldname) {
      const rows = [...props2.modelValue];
      rows[index2][fieldname] = value;
      emits("update:modelValue", rows);
    }
    function addRow2() {
      const rows = [...props2.modelValue];
      const entry = {
        idx: rows.length
      };
      entityMeta == null ? void 0 : entityMeta.fields.forEach((field) => {
        if (field.default) {
          if (field.fieldtype === "Check") {
            entry[field.fieldname] = Number.parseInt(field.default);
          } else {
            entry[field.fieldname] = field.default;
          }
        }
      });
      rows.push(entry);
      emits("update:modelValue", rows);
    }
    function removeRow(idx) {
      const rows = [...props2.modelValue];
      rows.splice(idx, 1);
      emits("update:modelValue", rows);
    }
    function ended() {
      listRef.value.forEach((item, index2) => {
        item.idx = index2 + 1;
      });
      emits("update:modelValue", listRef.value);
    }
    onMounted(() => {
      bagel = props2.bagelApp || api;
    });
    return (_ctx, _cache) => {
      var _a, _b;
      const _component_BagelInput = resolveComponent("BagelInput");
      return openBlock(), createElementBlock("div", {
        class: "table-field-wrap",
        title: _ctx.description
      }, [
        createElementVNode("div", _hoisted_2$f, [
          createElementVNode("label", null, toDisplayString((_a = unref(fieldMeta)) == null ? void 0 : _a.label), 1)
        ]),
        createElementVNode("div", _hoisted_3$d, [
          createElementVNode("div", _hoisted_4$7, [
            (openBlock(true), createElementBlock(Fragment, null, renderList((_b = unref(entityMeta)) == null ? void 0 : _b.fields, (field) => {
              return openBlock(), createElementBlock("div", {
                key: `${field.fieldname}header`,
                class: normalizeClass(["header-col", unref(formatString)(field.fieldtype, "pascal")])
              }, toDisplayString(field.label), 3);
            }), 128))
          ]),
          createVNode(unref(VueDraggableNext), {
            modelValue: listRef.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => listRef.value = $event),
            animation: "150",
            handle: ".table-reorder",
            group: "mainGroup",
            easing: "cubic-bezier(1, 0, 0, 1)",
            "ghost-class": "ghost",
            onEnd: ended
          }, {
            default: withCtx(() => [
              createVNode(TransitionGroup, null, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelValue, (row, index2) => {
                    var _a2;
                    return openBlock(), createElementBlock("div", {
                      key: row.id,
                      class: "flex table-row"
                    }, [
                      createElementVNode("div", _hoisted_5$7, [
                        createVNode(unref(_sfc_main$s), { icon: "more_vert" })
                      ]),
                      (openBlock(true), createElementBlock(Fragment, null, renderList((_a2 = unref(entityMeta)) == null ? void 0 : _a2.fields, (field) => {
                        return openBlock(), createElementBlock("div", {
                          key: `${field.fieldname}${row.id}`,
                          class: normalizeClass(["table-cell", unref(formatString)(field.fieldtype, "pascal")])
                        }, [
                          createVNode(_component_BagelInput, {
                            "no-label": "",
                            "field-meta": field,
                            "bagel-app": unref(bagel),
                            "model-value": row[field.fieldname],
                            "onUpdate:modelValue": (value) => handleUpdateModelValue(value, index2, field.fieldname)
                          }, null, 8, ["field-meta", "bagel-app", "model-value", "onUpdate:modelValue"])
                        ], 2);
                      }), 128)),
                      createElementVNode("div", _hoisted_6$6, [
                        createVNode(unref(_sfc_main$s), {
                          icon: "delete",
                          onClick: ($event) => removeRow(index2)
                        }, null, 8, ["onClick"])
                      ])
                    ]);
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        createVNode(unref(Btn), {
          thin: "",
          flat: "",
          icon: "add",
          color: "light",
          onClick: addRow2
        }, {
          default: withCtx(() => _cache[1] || (_cache[1] = [
            createTextVNode(" New ")
          ])),
          _: 1
        })
      ], 8, _hoisted_1$p);
    };
  }
});
const TableField = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["__scopeId", "data-v-e9632f79"]]);
const _hoisted_1$o = ["title"];
const _hoisted_2$e = ["for"];
const _hoisted_3$c = ["id", "name", "title", "autocomplete", "type", "placeholder", "disabled", "required", "pattern"];
const _hoisted_4$6 = ["id", "name", "title", "type", "rows", "placeholder", "disabled", "required", "pattern"];
const _hoisted_5$6 = {
  key: 2,
  class: "opacity-7 light"
};
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "TextInput",
  props: {
    id: {},
    title: {},
    helptext: {},
    name: {},
    placeholder: {},
    modelValue: { default: "" },
    label: {},
    small: { type: Boolean },
    dense: { type: Boolean },
    required: { type: Boolean },
    pattern: {},
    defaultValue: {},
    shrink: { type: Boolean },
    disabled: { type: Boolean },
    type: { default: "text" },
    nativeInputAttrs: {},
    icon: {},
    iconStart: {},
    multiline: { type: Boolean },
    autoheight: { type: Boolean },
    code: { type: Boolean },
    rows: {},
    autocomplete: {},
    autofocus: { type: Boolean },
    onFocusout: {},
    onFocus: {}
  },
  emits: ["update:modelValue", "debounce"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    let inputVal = ref();
    const input = ref();
    const inputRows = computed(() => {
      let rows = Number(props2.rows) || 1;
      if (props2.autoheight) rows = Math.max(rows, String(inputVal.value).split("\n").length);
      if (props2.multiline || props2.code) rows = Math.max(rows, 4);
      return rows;
    });
    const debouncedEmit = useDebounceFn(() => {
      emit2("debounce", inputVal.value);
    }, 700);
    function updateInputVal() {
      if (props2.disabled) return;
      emit2("update:modelValue", inputVal.value);
      debouncedEmit();
    }
    watch(
      () => props2.modelValue,
      (newVal) => {
        if (newVal !== inputVal.value) inputVal.value = newVal;
      },
      { immediate: true }
    );
    const hasFocus = () => document.activeElement === input.value;
    const focus = () => {
      var _a;
      return (_a = input.value) == null ? void 0 : _a.focus();
    };
    __expose({ focus, hasFocus });
    onMounted(() => {
      if (props2.autofocus) setTimeout(() => {
        var _a;
        return (_a = input.value) == null ? void 0 : _a.focus();
      }, 10);
      if (props2.defaultValue && !props2.modelValue) inputVal.value = props2.defaultValue;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bagel-input text-input", {
          dense: _ctx.dense,
          small: _ctx.small,
          shrink: _ctx.shrink,
          code: _ctx.code,
          textInputIconWrap: _ctx.icon,
          txtInputIconStart: _ctx.iconStart
        }]),
        title: _ctx.title
      }, [
        createElementVNode("label", { for: _ctx.id }, [
          createTextVNode(toDisplayString(_ctx.label) + " ", 1),
          !_ctx.multiline && !_ctx.autoheight && !_ctx.code ? withDirectives((openBlock(), createElementBlock("input", mergeProps({
            key: 0,
            id: _ctx.id,
            ref_key: "input",
            ref: input,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(inputVal) ? inputVal.value = $event : inputVal = $event),
            name: _ctx.name,
            title: _ctx.title,
            autocomplete: _ctx.autocomplete,
            type: _ctx.type,
            rows: 1,
            placeholder: _ctx.placeholder || _ctx.label,
            disabled: _ctx.disabled,
            required: _ctx.required,
            pattern: _ctx.pattern
          }, _ctx.nativeInputAttrs, {
            onFocusout: _cache[1] || (_cache[1] = //@ts-ignore
            (...args) => _ctx.onFocusout && _ctx.onFocusout(...args)),
            onFocus: _cache[2] || (_cache[2] = //@ts-ignore
            (...args) => _ctx.onFocus && _ctx.onFocus(...args)),
            onInput: updateInputVal
          }), null, 16, _hoisted_3$c)), [
            [
              vModelDynamic,
              unref(inputVal),
              void 0,
              { trim: true }
            ]
          ]) : withDirectives((openBlock(), createElementBlock("textarea", mergeProps({
            key: 1,
            id: _ctx.id,
            ref_key: "input",
            ref: input,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => isRef(inputVal) ? inputVal.value = $event : inputVal = $event),
            name: _ctx.name,
            title: _ctx.title,
            type: _ctx.type,
            rows: inputRows.value,
            placeholder: _ctx.placeholder || _ctx.label,
            disabled: _ctx.disabled,
            required: _ctx.required,
            pattern: _ctx.pattern
          }, _ctx.nativeInputAttrs, {
            onInput: updateInputVal,
            onFocusout: _cache[4] || (_cache[4] = //@ts-ignore
            (...args) => _ctx.onFocusout && _ctx.onFocusout(...args))
          }), null, 16, _hoisted_4$6)), [
            [vModelText, unref(inputVal)]
          ]),
          _ctx.helptext ? (openBlock(), createElementBlock("p", _hoisted_5$6, toDisplayString(_ctx.helptext), 1)) : createCommentVNode("", true),
          _ctx.iconStart ? (openBlock(), createBlock(unref(_sfc_main$s), {
            key: 3,
            class: "iconStart",
            icon: _ctx.iconStart
          }, null, 8, ["icon"])) : createCommentVNode("", true),
          _ctx.icon ? (openBlock(), createBlock(unref(_sfc_main$s), {
            key: 4,
            icon: _ctx.icon
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ], 8, _hoisted_2$e)
      ], 10, _hoisted_1$o);
    };
  }
});
const TextInput = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["__scopeId", "data-v-dbcf2010"]]);
const _hoisted_1$n = ["title"];
const _hoisted_2$d = ["id", "required"];
const _hoisted_3$b = ["for"];
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "ToggleInput",
  props: /* @__PURE__ */ mergeModels({
    label: {},
    id: {},
    title: {},
    small: { type: Boolean },
    required: { type: Boolean },
    defaultValue: { type: Boolean, default: false }
  }, {
    "modelValue": { type: Boolean, ...{ default: void 0 } },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props2 = __props;
    const inputId = ref(props2.id || Math.random().toString(36).slice(7));
    const checked = useModel(__props, "modelValue");
    onMounted(() => {
      if (checked.value === void 0) checked.value = props2.defaultValue;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bagel-input bgl-toggle", { small: _ctx.small }]),
        title: _ctx.title
      }, [
        createElementVNode("div", {
          class: normalizeClass(["switch", { checked: checked.value }])
        }, _cache[1] || (_cache[1] = [
          createElementVNode("span", { class: "slider rounded" }, null, -1)
        ]), 2),
        withDirectives(createElementVNode("input", {
          id: inputId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => checked.value = $event),
          type: "checkbox",
          required: _ctx.required
        }, null, 8, _hoisted_2$d), [
          [vModelCheckbox, checked.value]
        ]),
        createElementVNode("label", { for: inputId.value }, [
          renderSlot(_ctx.$slots, "label", {}, () => [
            createTextVNode(toDisplayString(_ctx.label), 1)
          ], true)
        ], 8, _hoisted_3$b)
      ], 10, _hoisted_1$n);
    };
  }
});
const ToggleInput = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["__scopeId", "data-v-ebe691ee"]]);
const files = {
  setBaseUrl: (baseUrl) => {
    if (!baseUrl) return;
    baseUrl = baseUrl.replace(/\/$/, "");
    axios$1.defaults.baseURL = baseUrl;
  },
  get: async (pathKey) => {
    return axios$1.get("/files_v2/", { params: { path_key: pathKey } });
  },
  put: async (bglFilePatch, pathKey) => {
    return axios$1.put("/files_v2/", bglFilePatch, { params: { path_key: pathKey } });
  },
  delete: async (pathKey) => {
    return axios$1.delete("/files_v2/", { params: { path_key: pathKey } });
  },
  upload: async (file, options) => {
    const formData = new FormData();
    formData.append("upload", file);
    return axios$1.post("/files_v2/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: options == null ? void 0 : options.onUploadProgress,
      params: { dir_path: options == null ? void 0 : options.dirPath, tags: options == null ? void 0 : options.tags }
    });
  },
  list: async (dirPath) => {
    return axios$1.get("/files_v2/list", { params: { dir_path: dirPath } });
  }
};
const _hoisted_1$m = { class: "bagel-input" };
const _hoisted_2$c = { key: 0 };
const _hoisted_3$a = {
  key: 1,
  placeholder: "required",
  type: "text",
  required: "",
  class: "pixel"
};
const _hoisted_4$5 = { class: "m-05 flex opacity-7 z-99" };
const _hoisted_5$5 = { class: "flex gap-025 rounded pe-1 ps-05 py-025 bg-gray-80 -my-1" };
const _hoisted_6$5 = { class: "ellipsis-1 word-break-all h-20 m-0 color-black txt16" };
const _hoisted_7$4 = {
  key: 1,
  class: "txt-gray txt-12"
};
const _hoisted_8$3 = {
  key: 0,
  class: "bgl-multi-preview"
};
const _hoisted_9$2 = { class: "m-0" };
const _hoisted_10$2 = { class: "no-margin multi-preview-txt" };
const _hoisted_11$2 = {
  key: 0,
  class: "progress"
};
const _hoisted_12$1 = {
  key: 1,
  class: "bgl-single-preview"
};
const _hoisted_13 = { class: "position-start m-05 flex opacity-7 z-99 gap-025" };
const _hoisted_14 = {
  key: 0,
  class: "h-100"
};
const _hoisted_15 = {
  key: 0,
  class: "progress"
};
const _hoisted_16 = { class: "p-1 flex column hover fileUploadPlaceHolder justify-content-center mb-05" };
const _hoisted_17 = { class: "pretty balance" };
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "UploadInput",
  props: {
    label: {},
    multiple: { type: Boolean },
    modelValue: {},
    width: {},
    height: { default: "215px" },
    dirPath: {},
    fill: { type: Boolean },
    oval: { type: Boolean },
    theme: { default: "dropzone" },
    accept: { default: "*" },
    required: { type: Boolean },
    disabled: { type: Boolean },
    baseURL: {},
    dropPlaceholder: {},
    noFilePlaceholder: {},
    btnPlaceholder: {}
  },
  emits: ["update:modelValue", "addFileStart"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const bagel = useBagel(bagelInjectionKey);
    files.setBaseUrl(bagel.host);
    const fileQueue = ref([]);
    let storageFiles = ref([]);
    const pk = ref([props2.modelValue].flat().filter(Boolean));
    const pathKeys = computed(() => {
      const sf = storageFiles.value.map((file) => file.path_key);
      return [...pk.value, ...sf];
    });
    watch(() => pk.value, (value) => {
      if (props2.multiple) emit2("update:modelValue", value);
      else emit2("update:modelValue", value[0] || void 0);
    }, { deep: true });
    const isImage = (str) => IMAGE_FORMATS_REGEXP.test(str);
    const fileToUrl = (file) => URL.createObjectURL(file);
    let isDragOver = ref(false);
    async function removeFile(path_key) {
      storageFiles.value = storageFiles.value.filter((file) => file.path_key !== path_key);
      const pki = pk.value.indexOf(path_key);
      if (pki !== -1) pk.value.splice(pki, 1);
      try {
        await files.delete(path_key);
      } catch (error) {
        console.error(error);
      }
    }
    async function flushQueue() {
      emit2("addFileStart");
      for (const file of fileQueue.value) {
        file.uploading = true;
        if (!props2.multiple) pk.value.splice(0, 1);
        try {
          const { data: data2 } = await files.upload(file.file, {
            onUploadProgress: (e) => {
              file.progress = e.loaded / e.total * 100 - 1;
            },
            dirPath: props2.dirPath
          });
          pk.value.push(data2.path_key);
        } catch (error) {
          console.error("error flushing queue", error);
        }
      }
      fileQueue.value.splice(0, fileQueue.value.length);
    }
    function browse() {
      if (props2.disabled) return;
      const input = document.createElement("input");
      input.type = "file";
      input.multiple = props2.multiple;
      input.accept = props2.accept;
      input.onchange = (e) => {
        const files2 = Array.from(e.target.files || []);
        fileQueue.value.push(...files2.map((file) => ({ name: file.name, file, progress: 0 })));
        flushQueue();
      };
      input.click();
    }
    function handleDrag(e, isDragging = false) {
      e.preventDefault();
      e.stopPropagation();
      if (!props2.disabled) isDragOver.value = isDragging;
    }
    function handleDrop(e) {
      var _a;
      if (props2.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      if ((_a = e.dataTransfer) == null ? void 0 : _a.files) {
        fileQueue.value.push(...Array.from(e.dataTransfer.files).map((file) => ({ name: file.name, file, progress: 0 })));
        flushQueue();
      }
      isDragOver.value = false;
    }
    if (props2.dirPath) {
      files.list(props2.dirPath).then((response) => storageFiles.value.push(...[response.data].flat())).catch(console.error);
    }
    watch(() => props2.dirPath, () => {
      if (props2.dirPath) {
        files.list(props2.dirPath).then((response) => storageFiles.value.push(...[response.data].flat())).catch(console.error);
      }
    });
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      const _directive_lightbox = resolveDirective("lightbox");
      return openBlock(), createElementBlock("div", _hoisted_1$m, [
        _ctx.label ? (openBlock(), createElementBlock("label", _hoisted_2$c, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
        _ctx.required && !pathKeys.value.length ? (openBlock(), createElementBlock("input", _hoisted_3$a)) : createCommentVNode("", true),
        _ctx.theme === "basic" ? (openBlock(), createBlock(unref(_sfc_main$10), {
          key: 2,
          outline: "",
          class: "flex p-05 gap-1",
          onDragover: _cache[0] || (_cache[0] = (e) => handleDrag(e, true)),
          onDrop: handleDrop
        }, {
          default: withCtx(() => [
            !pathKeys.value.length && !fileQueue.value.length ? (openBlock(), createBlock(unref(Btn), {
              key: 0,
              class: "px-1-5",
              icon: "upload",
              outline: "",
              value: _ctx.btnPlaceholder || "Upload",
              onClick: browse
            }, null, 8, ["value"])) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(pathKeys.value, (path_key) => {
              return openBlock(), createElementBlock("div", {
                key: path_key,
                class: "txt-gray txt-12 flex"
              }, [
                createElementVNode("div", _hoisted_4$5, [
                  withDirectives(createVNode(unref(Btn), {
                    color: "gray",
                    thin: "",
                    icon: "delete",
                    onClick: ($event) => removeFile(path_key)
                  }, null, 8, ["onClick"]), [
                    [_directive_tooltip, "Delete"]
                  ]),
                  withDirectives(createVNode(unref(Btn), {
                    color: "gray",
                    thin: "",
                    icon: "autorenew",
                    onClick: browse
                  }, null, 512), [
                    [_directive_tooltip, "Replace"]
                  ]),
                  createVNode(unref(Btn), {
                    icon: "download",
                    flat: "",
                    thin: "",
                    href: unref(pathKeyToURL)(path_key),
                    download: path_key.split("/").pop()
                  }, null, 8, ["href", "download"]),
                  createElementVNode("div", _hoisted_5$5, [
                    createVNode(unref(_sfc_main$s), {
                      icon: "draft",
                      size: 1.5
                    }),
                    withDirectives((openBlock(), createElementBlock("p", _hoisted_6$5, [
                      createTextVNode(toDisplayString(path_key.split("/").pop()), 1)
                    ])), [
                      [_directive_lightbox, { src: unref(pathKeyToURL)(path_key), download: true }]
                    ])
                  ])
                ])
              ]);
            }), 128)),
            !pathKeys.value.length && !fileQueue.value.length ? (openBlock(), createElementBlock("span", _hoisted_7$4, toDisplayString(_ctx.noFilePlaceholder || "No file selected"), 1)) : createCommentVNode("", true)
          ]),
          _: 1
        })) : (openBlock(), createElementBlock("div", {
          key: 3,
          class: normalizeClass(["fileUploadWrap", {
            "fileDropZone": !pathKeys.value.length && !fileQueue.value.length,
            "dragover": unref(isDragOver),
            "bgl_oval-upload": _ctx.oval
          }]),
          style: normalizeStyle({ width: _ctx.width, height: _ctx.height }),
          onClick: browse,
          onDragover: _cache[1] || (_cache[1] = (e) => handleDrag(e, true)),
          onDrop: handleDrop,
          onDragleave: _cache[2] || (_cache[2] = (e) => handleDrag(e))
        }, [
          renderSlot(_ctx.$slots, "files", {
            files: pathKeys.value,
            fileQueue: fileQueue.value
          }, () => [
            _ctx.multiple ? (openBlock(), createElementBlock("div", _hoisted_8$3, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(pathKeys.value, (path_key) => {
                return withDirectives((openBlock(), createElementBlock("div", {
                  key: path_key,
                  class: normalizeClass(["multi-image-item-preview", { "bgl_fill-image": _ctx.fill }])
                }, [
                  isImage(path_key) ? (openBlock(), createBlock(unref(Image$1), {
                    key: 0,
                    pathKey: path_key,
                    class: "multi-preview"
                  }, null, 8, ["pathKey"])) : (openBlock(), createBlock(unref(_sfc_main$s), {
                    key: 1,
                    icon: "description",
                    class: "multi-preview"
                  })),
                  createElementVNode("p", _hoisted_9$2, toDisplayString(path_key.split("/").pop()), 1),
                  createVNode(unref(Btn), {
                    thin: "",
                    flat: "",
                    icon: "delete",
                    color: "red",
                    onClick: ($event) => removeFile(path_key)
                  }, null, 8, ["onClick"])
                ], 2)), [
                  [_directive_lightbox, { src: unref(pathKeyToURL)(path_key), download: true }]
                ]);
              }), 128)),
              (openBlock(true), createElementBlock(Fragment, null, renderList(fileQueue.value, (file) => {
                return openBlock(), createElementBlock("div", {
                  key: file.name,
                  class: normalizeClass(["multi-image-item-preview", { "bgl_fill-image": _ctx.fill }])
                }, [
                  isImage(file.file.type) ? (openBlock(), createBlock(unref(Image$1), {
                    key: 0,
                    class: "multi-preview",
                    src: fileToUrl(file.file),
                    alt: ""
                  }, null, 8, ["src"])) : (openBlock(), createBlock(unref(_sfc_main$s), {
                    key: 1,
                    icon: "description",
                    class: "multi-preview"
                  })),
                  createElementVNode("p", _hoisted_10$2, toDisplayString(file.name), 1),
                  createElementVNode("div", {
                    class: normalizeClass(["pie", { complete: file.progress === 100 }]),
                    style: normalizeStyle([{ "--p": file.progress }, { "--b": "2px" }])
                  }, [
                    file.progress < 100 ? (openBlock(), createElementBlock("span", _hoisted_11$2, toDisplayString(file.progress.toFixed(0)), 1)) : createCommentVNode("", true),
                    createVNode(unref(_sfc_main$s), {
                      class: "success",
                      icon: "check_circle"
                    })
                  ], 6)
                ], 2);
              }), 128))
            ])) : pathKeys.value.length > 0 || fileQueue.value.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_12$1, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(pathKeys.value, (path_key) => {
                return openBlock(), createElementBlock("div", {
                  key: path_key,
                  class: normalizeClass(["single-image-item-preview", { "bgl_fill-image": _ctx.fill }])
                }, [
                  createElementVNode("div", _hoisted_13, [
                    withDirectives(createVNode(unref(Btn), {
                      color: "gray",
                      thin: "",
                      icon: "delete",
                      onClick: ($event) => removeFile(path_key)
                    }, null, 8, ["onClick"]), [
                      [_directive_tooltip, "Delete"]
                    ]),
                    withDirectives(createVNode(unref(Btn), {
                      color: "gray",
                      thin: "",
                      icon: "autorenew",
                      onClick: browse
                    }, null, 512), [
                      [_directive_tooltip, "Replace"]
                    ]),
                    withDirectives(createVNode(unref(Btn), {
                      color: "gray",
                      thin: "",
                      icon: "download",
                      href: unref(pathKeyToURL)(path_key),
                      download: path_key.split("/").pop()
                    }, null, 8, ["href", "download"]), [
                      [_directive_tooltip, "Download"]
                    ])
                  ]),
                  isImage(path_key) ? (openBlock(), createElementBlock("div", _hoisted_14, [
                    withDirectives(createVNode(unref(Image$1), {
                      class: "single-preview",
                      pathKey: path_key,
                      alt: ""
                    }, null, 8, ["pathKey"]), [
                      [_directive_lightbox, { src: unref(pathKeyToURL)(path_key), download: true }]
                    ])
                  ])) : withDirectives((openBlock(), createBlock(unref(_sfc_main$s), {
                    key: 1,
                    size: 4,
                    weight: "2",
                    icon: "description",
                    class: "color-primary w-100"
                  }, null, 512)), [
                    [_directive_lightbox, { src: unref(pathKeyToURL)(path_key), download: true }]
                  ])
                ], 2);
              }), 128)),
              (openBlock(true), createElementBlock(Fragment, null, renderList(fileQueue.value, (file) => {
                return openBlock(), createElementBlock("div", {
                  key: file.name,
                  class: normalizeClass(["single-image-item-preview", { "bgl_fill-image": _ctx.fill }])
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(["pie", { complete: file.progress === 100 }]),
                    style: normalizeStyle([{ "--p": file.progress }, { "--b": "2px" }])
                  }, [
                    file.progress < 100 ? (openBlock(), createElementBlock("span", _hoisted_15, toDisplayString(file.progress.toFixed(0)), 1)) : createCommentVNode("", true),
                    createVNode(unref(_sfc_main$s), {
                      class: "success",
                      icon: "check_circle"
                    })
                  ], 6),
                  isImage(file.file.type) ? withDirectives((openBlock(), createBlock(unref(Image$1), {
                    key: 0,
                    class: "single-preview",
                    src: fileToUrl(file.file),
                    alt: ""
                  }, null, 8, ["src"])), [
                    [_directive_lightbox, { src: fileToUrl(file.file), download: true }]
                  ]) : createCommentVNode("", true)
                ], 2);
              }), 128))
            ])) : createCommentVNode("", true)
          ], true),
          !pathKeys.value.length && !fileQueue.value.length || _ctx.multiple ? renderSlot(_ctx.$slots, "placeholder", {
            key: 0,
            files: pathKeys.value,
            fileQueue: fileQueue.value,
            browse
          }, () => [
            createElementVNode("p", _hoisted_16, [
              createVNode(unref(_sfc_main$s), { icon: "upload_2" }),
              createElementVNode("span", _hoisted_17, toDisplayString(_ctx.dropPlaceholder || "Drag and Drop files here or click to upload"), 1)
            ])
          ], true) : createCommentVNode("", true)
        ], 38))
      ]);
    };
  }
});
const UploadInput = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["__scopeId", "data-v-d8f3ff01"]]);
const FONT_AWESOME_ICONS = [
  "trash-can",
  "message",
  "file-lines",
  "calendar-days",
  "hand-point-right",
  "face-smile-beam",
  "face-grin-stars",
  "address-book",
  "comments",
  "paste",
  "face-grin-tongue-squint",
  "face-flushed",
  "square-caret-right",
  "square-minus",
  "compass",
  "square-caret-down",
  "face-kiss-beam",
  "lightbulb",
  "flag",
  "square-check",
  "circle-dot",
  "face-dizzy",
  "futbol",
  "pen-to-square",
  "hourglass-half",
  "eye-slash",
  "hand",
  "hand-spock",
  "face-kiss",
  "face-grin-tongue",
  "chess-bishop",
  "face-grin-wink",
  "face-grin-wide",
  "face-frown-open",
  "hand-point-up",
  "bookmark",
  "hand-point-down",
  "folder",
  "user",
  "square-caret-left",
  "star",
  "chess-knight",
  "face-laugh-squint",
  "face-laugh",
  "folder-open",
  "clipboard",
  "chess-queen",
  "hand-back-fist",
  "square-caret-up",
  "chart-bar",
  "window-restore",
  "square-plus",
  "image",
  "folder-closed",
  "lemon",
  "handshake",
  "gem",
  "circle-play",
  "circle-check",
  "circle-stop",
  "id-badge",
  "face-laugh-beam",
  "registered",
  "address-card",
  "face-tired",
  "font-awesome",
  "face-smile-wink",
  "file-word",
  "file-powerpoint",
  "envelope-open",
  "file-zipper",
  "square",
  "snowflake",
  "newspaper",
  "face-kiss-wink-heart",
  "star-half-stroke",
  "file-excel",
  "face-grin-beam",
  "object-ungroup",
  "circle-right",
  "face-rolling-eyes",
  "object-group",
  "heart",
  "face-surprise",
  "circle-pause",
  "circle",
  "circle-up",
  "file-audio",
  "file-image",
  "circle-question",
  "face-meh-blank",
  "eye",
  "face-sad-cry",
  "file-code",
  "window-maximize",
  "face-frown",
  "floppy-disk",
  "comment-dots",
  "face-grin-squint",
  "hand-pointer",
  "hand-scissors",
  "face-grin-tears",
  "calendar-xmark",
  "file-video",
  "file-pdf",
  "comment",
  "envelope",
  "hourglass",
  "calendar-check",
  "hard-drive",
  "face-grin-squint-tears",
  "rectangle-list",
  "calendar-plus",
  "circle-left",
  "money-bill-1",
  "clock",
  "keyboard",
  "closed-captioning",
  "images",
  "face-grin",
  "face-meh",
  "id-card",
  "sun",
  "face-laugh-wink",
  "circle-down",
  "thumbs-down",
  "chess-pawn",
  "credit-card",
  "bell",
  "file",
  "hospital",
  "chess-rook",
  "star-half",
  "chess-king",
  "circle-user",
  "copy",
  "share-from-square",
  "copyright",
  "map",
  "bell-slash",
  "hand-lizard",
  "face-smile",
  "hand-peace",
  "face-grin-hearts",
  "building",
  "face-grin-beam-sweat",
  "moon",
  "calendar",
  "face-grin-tongue-wink",
  "clone",
  "face-angry",
  "rectangle-xmark",
  "paper-plane",
  "life-ring",
  "face-grimace",
  "calendar-minus",
  "circle-xmark",
  "thumbs-up",
  "window-minimize",
  "square-full",
  "note-sticky",
  "face-sad-tear",
  "hand-point-left"
];
const FONT_AWESOME_BRANDS_ICONS = [
  "monero",
  "hooli",
  "yelp",
  "cc-visa",
  "lastfm",
  "shopware",
  "creative-commons-nc",
  "aws",
  "redhat",
  "yoast",
  "cloudflare",
  "ups",
  "pixiv",
  "wpexplorer",
  "dyalog",
  "bity",
  "stackpath",
  "buysellads",
  "first-order",
  "modx",
  "guilded",
  "vnv",
  "square-js",
  "microsoft",
  "qq",
  "orcid",
  "java",
  "invision",
  "creative-commons-pd-alt",
  "centercode",
  "glide-g",
  "drupal",
  "jxl",
  "dart-lang",
  "hire-a-helper",
  "creative-commons-by",
  "unity",
  "whmcs",
  "rocketchat",
  "vk",
  "untappd",
  "mailchimp",
  "css3-alt",
  "square-reddit",
  "vimeo-v",
  "contao",
  "square-font-awesome",
  "deskpro",
  "brave",
  "sistrix",
  "square-instagram",
  "battle-net",
  "the-red-yeti",
  "square-hacker-news",
  "edge",
  "threads",
  "napster",
  "square-snapchat",
  "google-plus-g",
  "artstation",
  "markdown",
  "sourcetree",
  "google-plus",
  "diaspora",
  "foursquare",
  "stack-overflow",
  "github-alt",
  "phoenix-squadron",
  "pagelines",
  "algolia",
  "red-river",
  "creative-commons-sa",
  "safari",
  "google",
  "square-font-awesome-stroke",
  "atlassian",
  "linkedin-in",
  "digital-ocean",
  "nimblr",
  "chromecast",
  "evernote",
  "hacker-news",
  "creative-commons-sampling",
  "adversal",
  "creative-commons",
  "watchman-monitoring",
  "fonticons",
  "weixin",
  "shirtsinbulk",
  "codepen",
  "git-alt",
  "lyft",
  "rev",
  "windows",
  "wizards-of-the-coast",
  "square-viadeo",
  "meetup",
  "centos",
  "adn",
  "cloudsmith",
  "opensuse",
  "pied-piper-alt",
  "square-dribbble",
  "codiepie",
  "node",
  "mix",
  "steam",
  "cc-apple-pay",
  "scribd",
  "debian",
  "openid",
  "instalod",
  "files-pinwheel",
  "expeditedssl",
  "sellcast",
  "square-twitter",
  "r-project",
  "delicious",
  "freebsd",
  "vuejs",
  "accusoft",
  "ioxhost",
  "fonticons-fi",
  "app-store",
  "cc-mastercard",
  "itunes-note",
  "golang",
  "kickstarter",
  "grav",
  "weibo",
  "uncharted",
  "firstdraft",
  "square-youtube",
  "wikipedia-w",
  "wpressr",
  "angellist",
  "galactic-republic",
  "nfc-directional",
  "skype",
  "joget",
  "fedora",
  "stripe-s",
  "meta",
  "laravel",
  "hotjar",
  "bluetooth-b",
  "square-letterboxd",
  "sticker-mule",
  "creative-commons-zero",
  "hips",
  "css",
  "behance",
  "reddit",
  "discord",
  "chrome",
  "app-store-ios",
  "cc-discover",
  "wpbeginner",
  "confluence",
  "shoelace",
  "mdb",
  "dochub",
  "accessible-icon",
  "ebay",
  "amazon",
  "unsplash",
  "yarn",
  "square-steam",
  "500px",
  "square-vimeo",
  "asymmetrik",
  "font-awesome",
  "gratipay",
  "apple",
  "hive",
  "gitkraken",
  "keybase",
  "apple-pay",
  "padlet",
  "amazon-pay",
  "square-github",
  "stumbleupon",
  "fedex",
  "phoenix-framework",
  "shopify",
  "neos",
  "square-threads",
  "hackerrank",
  "researchgate",
  "swift",
  "angular",
  "speakap",
  "angrycreative",
  "y-combinator",
  "empire",
  "envira",
  "google-scholar",
  "square-gitlab",
  "studiovinari",
  "pied-piper",
  "wordpress",
  "product-hunt",
  "firefox",
  "linode",
  "goodreads",
  "square-odnoklassniki",
  "jsfiddle",
  "sith",
  "themeisle",
  "page4",
  "hashnode",
  "react",
  "cc-paypal",
  "squarespace",
  "cc-stripe",
  "creative-commons-share",
  "bitcoin",
  "keycdn",
  "opera",
  "itch-io",
  "umbraco",
  "galactic-senate",
  "ubuntu",
  "draft2digital",
  "stripe",
  "houzz",
  "gg",
  "dhl",
  "square-pinterest",
  "xing",
  "blackberry",
  "creative-commons-pd",
  "playstation",
  "quinscape",
  "less",
  "blogger-b",
  "opencart",
  "vine",
  "signal-messenger",
  "paypal",
  "gitlab",
  "typo3",
  "reddit-alien",
  "yahoo",
  "dailymotion",
  "affiliatetheme",
  "pied-piper-pp",
  "bootstrap",
  "odnoklassniki",
  "nfc-symbol",
  "mintbit",
  "ethereum",
  "speaker-deck",
  "creative-commons-nc-eu",
  "patreon",
  "avianex",
  "ello",
  "gofore",
  "bimobject",
  "brave-reverse",
  "facebook-f",
  "square-google-plus",
  "web-awesome",
  "mandalorian",
  "first-order-alt",
  "osi",
  "google-wallet",
  "d-and-d-beyond",
  "periscope",
  "fulcrum",
  "cloudscale",
  "forumbee",
  "mizuni",
  "schlix",
  "square-xing",
  "bandcamp",
  "wpforms",
  "cloudversify",
  "usps",
  "megaport",
  "magento",
  "spotify",
  "optin-monster",
  "fly",
  "square-bluesky",
  "aviato",
  "itunes",
  "cuttlefish",
  "blogger",
  "flickr",
  "viber",
  "soundcloud",
  "digg",
  "tencent-weibo",
  "letterboxd",
  "symfony",
  "maxcdn",
  "etsy",
  "facebook-messenger",
  "audible",
  "think-peaks",
  "bilibili",
  "erlang",
  "x-twitter",
  "cotton-bureau",
  "dashcube",
  "42-group",
  "stack-exchange",
  "elementor",
  "square-pied-piper",
  "creative-commons-nd",
  "palfed",
  "superpowers",
  "resolving",
  "xbox",
  "square-web-awesome-stroke",
  "searchengin",
  "tiktok",
  "square-facebook",
  "renren",
  "linux",
  "glide",
  "linkedin",
  "hubspot",
  "deploydog",
  "twitch",
  "flutter",
  "ravelry",
  "mixer",
  "square-lastfm",
  "vimeo",
  "mendeley",
  "uniregistry",
  "figma",
  "creative-commons-remix",
  "cc-amazon-pay",
  "dropbox",
  "instagram",
  "cmplid",
  "upwork",
  "facebook",
  "gripfire",
  "jedi-order",
  "uikit",
  "fort-awesome-alt",
  "phabricator",
  "ussunnah",
  "earlybirds",
  "trade-federation",
  "autoprefixer",
  "whatsapp",
  "square-upwork",
  "slideshare",
  "google-play",
  "viadeo",
  "line",
  "google-drive",
  "servicestack",
  "simplybuilt",
  "bitbucket",
  "imdb",
  "deezer",
  "raspberry-pi",
  "jira",
  "docker",
  "screenpal",
  "bluetooth",
  "gitter",
  "d-and-d",
  "microblog",
  "cc-diners-club",
  "gg-circle",
  "pied-piper-hat",
  "kickstarter-k",
  "yandex",
  "readme",
  "html5",
  "sellsy",
  "square-web-awesome",
  "sass",
  "wirsindhandwerk",
  "buromobelexperte",
  "salesforce",
  "octopus-deploy",
  "medapps",
  "ns8",
  "pinterest-p",
  "apper",
  "fort-awesome",
  "waze",
  "bluesky",
  "cc-jcb",
  "snapchat",
  "fantasy-flight-games",
  "rust",
  "wix",
  "square-behance",
  "supple",
  "webflow",
  "rebel",
  "css3",
  "staylinked",
  "kaggle",
  "space-awesome",
  "deviantart",
  "cpanel",
  "goodreads-g",
  "square-git",
  "square-tumblr",
  "trello",
  "creative-commons-nc-jp",
  "get-pocket",
  "perbyte",
  "grunt",
  "weebly",
  "connectdevelop",
  "leanpub",
  "black-tie",
  "themeco",
  "python",
  "android",
  "bots",
  "free-code-camp",
  "hornbill",
  "js",
  "ideal",
  "git",
  "dev",
  "sketch",
  "yandex-international",
  "cc-amex",
  "uber",
  "github",
  "php",
  "alipay",
  "youtube",
  "skyatlas",
  "firefox-browser",
  "replyd",
  "suse",
  "jenkins",
  "twitter",
  "rockrms",
  "pinterest",
  "buffer",
  "npm",
  "yammer",
  "btc",
  "dribbble",
  "stumbleupon-circle",
  "internet-explorer",
  "stubber",
  "telegram",
  "old-republic",
  "odysee",
  "square-whatsapp",
  "node-js",
  "edge-legacy",
  "slack",
  "medrt",
  "usb",
  "tumblr",
  "vaadin",
  "quora",
  "square-x-twitter",
  "reacteurope",
  "medium",
  "amilia",
  "mixcloud",
  "flipboard",
  "viacoin",
  "critical-role",
  "sitrox",
  "discourse",
  "joomla",
  "mastodon",
  "airbnb",
  "wolf-pack-battalion",
  "buy-n-large",
  "gulp",
  "creative-commons-sampling-plus",
  "strava",
  "ember",
  "canadian-maple-leaf",
  "teamspeak",
  "pushed",
  "wordpress-simple",
  "nutritionix",
  "wodu",
  "google-pay",
  "intercom",
  "zhihu",
  "korvue",
  "pix",
  "steam-symbol"
];
const MATERIAL_ICONS = [
  "10k",
  "10mp",
  "11mp",
  "123",
  "12mp",
  "13mp",
  "14mp",
  "15mp",
  "16mp",
  "17mp",
  "18_up_rating",
  "18mp",
  "19mp",
  "1k",
  "1k_plus",
  "1x_mobiledata",
  "1x_mobiledata_badge",
  "20mp",
  "21mp",
  "22mp",
  "23mp",
  "24fps_select",
  "24mp",
  "2d",
  "2k",
  "2k_plus",
  "2mp",
  "30fps",
  "30fps_select",
  "360",
  "3d_rotation",
  "3g_mobiledata",
  "3g_mobiledata_badge",
  "3k",
  "3k_plus",
  "3mp",
  "3p",
  "4g_mobiledata",
  "4g_mobiledata_badge",
  "4g_plus_mobiledata",
  "4k",
  "4k_plus",
  "4mp",
  "50mp",
  "5g",
  "5g_mobiledata_badge",
  "5k",
  "5k_plus",
  "5mp",
  "60fps",
  "60fps_select",
  "6_ft_apart",
  "6k",
  "6k_plus",
  "6mp",
  "7k",
  "7k_plus",
  "7mp",
  "8k",
  "8k_plus",
  "8mp",
  "9k",
  "9k_plus",
  "9mp",
  "abc",
  "ac_unit",
  "access_alarm",
  "access_alarms",
  "access_time",
  "access_time_filled",
  "accessibility",
  "accessibility_new",
  "accessible",
  "accessible_forward",
  "account_balance",
  "account_balance_wallet",
  "account_box",
  "account_child",
  "account_child_invert",
  "account_circle",
  "account_circle_off",
  "account_tree",
  "action_key",
  "activity_zone",
  "acute",
  "ad",
  "ad_group",
  "ad_group_off",
  "ad_off",
  "ad_units",
  "adaptive_audio_mic",
  "adaptive_audio_mic_off",
  "adb",
  "add",
  "add_2",
  "add_a_photo",
  "add_ad",
  "add_alarm",
  "add_alert",
  "add_box",
  "add_business",
  "add_call",
  "add_card",
  "add_chart",
  "add_circle",
  "add_circle_outline",
  "add_column_left",
  "add_column_right",
  "add_comment",
  "add_diamond",
  "add_home",
  "add_home_work",
  "add_ic_call",
  "add_link",
  "add_location",
  "add_location_alt",
  "add_moderator",
  "add_notes",
  "add_photo_alternate",
  "add_reaction",
  "add_road",
  "add_row_above",
  "add_row_below",
  "add_shopping_cart",
  "add_task",
  "add_to_drive",
  "add_to_home_screen",
  "add_to_photos",
  "add_to_queue",
  "add_triangle",
  "addchart",
  "adf_scanner",
  "adjust",
  "admin_meds",
  "admin_panel_settings",
  "ads_click",
  "agender",
  "agriculture",
  "air",
  "air_freshener",
  "air_purifier",
  "air_purifier_gen",
  "airline_seat_flat",
  "airline_seat_flat_angled",
  "airline_seat_individual_suite",
  "airline_seat_legroom_extra",
  "airline_seat_legroom_normal",
  "airline_seat_legroom_reduced",
  "airline_seat_recline_extra",
  "airline_seat_recline_normal",
  "airline_stops",
  "airlines",
  "airplane_ticket",
  "airplanemode_active",
  "airplanemode_inactive",
  "airplay",
  "airport_shuttle",
  "airware",
  "airwave",
  "alarm",
  "alarm_add",
  "alarm_off",
  "alarm_on",
  "alarm_smart_wake",
  "album",
  "align_center",
  "align_end",
  "align_flex_center",
  "align_flex_end",
  "align_flex_start",
  "align_horizontal_center",
  "align_horizontal_left",
  "align_horizontal_right",
  "align_items_stretch",
  "align_justify_center",
  "align_justify_flex_end",
  "align_justify_flex_start",
  "align_justify_space_around",
  "align_justify_space_between",
  "align_justify_space_even",
  "align_justify_stretch",
  "align_self_stretch",
  "align_space_around",
  "align_space_between",
  "align_space_even",
  "align_start",
  "align_stretch",
  "align_vertical_bottom",
  "align_vertical_center",
  "align_vertical_top",
  "all_inbox",
  "all_inclusive",
  "all_match",
  "all_out",
  "allergies",
  "allergy",
  "alt_route",
  "alternate_email",
  "altitude",
  "ambulance",
  "amend",
  "amp_stories",
  "analytics",
  "anchor",
  "android",
  "animated_images",
  "animation",
  "announcement",
  "aod",
  "aod_tablet",
  "aod_watch",
  "apartment",
  "api",
  "apk_document",
  "apk_install",
  "app_badging",
  "app_blocking",
  "app_promo",
  "app_registration",
  "app_settings_alt",
  "app_shortcut",
  "apparel",
  "approval",
  "approval_delegation",
  "apps",
  "apps_outage",
  "aq",
  "aq_indoor",
  "ar_on_you",
  "ar_stickers",
  "architecture",
  "archive",
  "area_chart",
  "arming_countdown",
  "arrow_and_edge",
  "arrow_back",
  "arrow_back_2",
  "arrow_back_ios",
  "arrow_back_ios_new",
  "arrow_circle_down",
  "arrow_circle_left",
  "arrow_circle_right",
  "arrow_circle_up",
  "arrow_cool_down",
  "arrow_downward",
  "arrow_downward_alt",
  "arrow_drop_down",
  "arrow_drop_down_circle",
  "arrow_drop_up",
  "arrow_forward",
  "arrow_forward_ios",
  "arrow_insert",
  "arrow_left",
  "arrow_left_alt",
  "arrow_menu_close",
  "arrow_menu_open",
  "arrow_or_edge",
  "arrow_outward",
  "arrow_range",
  "arrow_right",
  "arrow_right_alt",
  "arrow_selector_tool",
  "arrow_split",
  "arrow_top_left",
  "arrow_top_right",
  "arrow_upload_progress",
  "arrow_upload_ready",
  "arrow_upward",
  "arrow_upward_alt",
  "arrow_warm_up",
  "arrows_input",
  "arrows_more_down",
  "arrows_more_up",
  "arrows_output",
  "arrows_outward",
  "art_track",
  "article",
  "article_shortcut",
  "artist",
  "aspect_ratio",
  "assessment",
  "assignment",
  "assignment_add",
  "assignment_ind",
  "assignment_late",
  "assignment_return",
  "assignment_returned",
  "assignment_turned_in",
  "assist_walker",
  "assistant",
  "assistant_device",
  "assistant_direction",
  "assistant_navigation",
  "assistant_on_hub",
  "assistant_photo",
  "assured_workload",
  "asterisk",
  "atm",
  "atr",
  "attach_email",
  "attach_file",
  "attach_file_add",
  "attach_file_off",
  "attach_money",
  "attachment",
  "attractions",
  "attribution",
  "audio_description",
  "audio_file",
  "audio_video_receiver",
  "audiotrack",
  "auto_awesome",
  "auto_awesome_mosaic",
  "auto_awesome_motion",
  "auto_delete",
  "auto_fix_high",
  "auto_fix_normal",
  "auto_fix_off",
  "auto_graph",
  "auto_mode",
  "auto_read_pause",
  "auto_read_play",
  "auto_stories",
  "auto_towing",
  "auto_transmission",
  "autofps_select",
  "automation",
  "autopause",
  "autoplay",
  "autorenew",
  "autostop",
  "av1",
  "av_timer",
  "avc",
  "avg_pace",
  "avg_time",
  "award_star",
  "azm",
  "baby_changing_station",
  "back_hand",
  "back_to_tab",
  "background_dot_large",
  "background_dot_small",
  "background_grid_small",
  "background_replace",
  "backlight_high",
  "backlight_high_off",
  "backlight_low",
  "backpack",
  "backspace",
  "backup",
  "backup_table",
  "badge",
  "badge_critical_battery",
  "bakery_dining",
  "balance",
  "balcony",
  "ballot",
  "bar_chart",
  "bar_chart_4_bars",
  "bar_chart_off",
  "barcode",
  "barcode_reader",
  "barcode_scanner",
  "barefoot",
  "batch_prediction",
  "bath_outdoor",
  "bath_private",
  "bath_public_large",
  "bathroom",
  "bathtub",
  "battery_0_bar",
  "battery_1_bar",
  "battery_20",
  "battery_2_bar",
  "battery_30",
  "battery_3_bar",
  "battery_4_bar",
  "battery_50",
  "battery_5_bar",
  "battery_60",
  "battery_6_bar",
  "battery_80",
  "battery_90",
  "battery_alert",
  "battery_change",
  "battery_charging_20",
  "battery_charging_30",
  "battery_charging_50",
  "battery_charging_60",
  "battery_charging_80",
  "battery_charging_90",
  "battery_charging_full",
  "battery_error",
  "battery_full",
  "battery_full_alt",
  "battery_horiz_000",
  "battery_horiz_050",
  "battery_horiz_075",
  "battery_low",
  "battery_plus",
  "battery_profile",
  "battery_saver",
  "battery_share",
  "battery_status_good",
  "battery_std",
  "battery_unknown",
  "battery_very_low",
  "beach_access",
  "bed",
  "bedroom_baby",
  "bedroom_child",
  "bedroom_parent",
  "bedtime",
  "bedtime_off",
  "beenhere",
  "bento",
  "bia",
  "bid_landscape",
  "bid_landscape_disabled",
  "bigtop_updates",
  "bike_dock",
  "bike_lane",
  "bike_scooter",
  "biotech",
  "blanket",
  "blender",
  "blind",
  "blinds",
  "blinds_closed",
  "block",
  "block_flipped",
  "blood_pressure",
  "bloodtype",
  "bluetooth",
  "bluetooth_audio",
  "bluetooth_connected",
  "bluetooth_disabled",
  "bluetooth_drive",
  "bluetooth_searching",
  "blur_circular",
  "blur_linear",
  "blur_medium",
  "blur_off",
  "blur_on",
  "blur_short",
  "body_fat",
  "body_system",
  "bolt",
  "bomb",
  "book",
  "book_2",
  "book_3",
  "book_4",
  "book_4_spark",
  "book_5",
  "book_6",
  "book_online",
  "book_ribbon",
  "bookmark",
  "bookmark_add",
  "bookmark_added",
  "bookmark_bag",
  "bookmark_border",
  "bookmark_check",
  "bookmark_flag",
  "bookmark_heart",
  "bookmark_manager",
  "bookmark_remove",
  "bookmark_star",
  "bookmarks",
  "books_movies_and_music",
  "border_all",
  "border_bottom",
  "border_clear",
  "border_color",
  "border_horizontal",
  "border_inner",
  "border_left",
  "border_outer",
  "border_right",
  "border_style",
  "border_top",
  "border_vertical",
  "borg",
  "bottom_app_bar",
  "bottom_drawer",
  "bottom_navigation",
  "bottom_panel_close",
  "bottom_panel_open",
  "bottom_right_click",
  "bottom_sheets",
  "box",
  "box_add",
  "box_edit",
  "boy",
  "brand_awareness",
  "brand_family",
  "branding_watermark",
  "breakfast_dining",
  "breaking_news",
  "breaking_news_alt_1",
  "breastfeeding",
  "brick",
  "brightness_1",
  "brightness_2",
  "brightness_3",
  "brightness_4",
  "brightness_5",
  "brightness_6",
  "brightness_7",
  "brightness_alert",
  "brightness_auto",
  "brightness_empty",
  "brightness_high",
  "brightness_low",
  "brightness_medium",
  "bring_your_own_ip",
  "broadcast_on_home",
  "broadcast_on_personal",
  "broken_image",
  "browse",
  "browse_activity",
  "browse_gallery",
  "browser_not_supported",
  "browser_updated",
  "brunch_dining",
  "brush",
  "bubble",
  "bubble_chart",
  "bubbles",
  "bug_report",
  "build",
  "build_circle",
  "bungalow",
  "burst_mode",
  "bus_alert",
  "business",
  "business_center",
  "business_chip",
  "business_messages",
  "buttons_alt",
  "cabin",
  "cable",
  "cable_car",
  "cached",
  "cadence",
  "cake",
  "cake_add",
  "calculate",
  "calendar_add_on",
  "calendar_apps_script",
  "calendar_clock",
  "calendar_month",
  "calendar_today",
  "calendar_view_day",
  "calendar_view_month",
  "calendar_view_week",
  "call",
  "call_end",
  "call_log",
  "call_made",
  "call_merge",
  "call_missed",
  "call_missed_outgoing",
  "call_quality",
  "call_received",
  "call_split",
  "call_to_action",
  "camera",
  "camera_alt",
  "camera_enhance",
  "camera_front",
  "camera_indoor",
  "camera_outdoor",
  "camera_rear",
  "camera_roll",
  "camera_video",
  "cameraswitch",
  "campaign",
  "camping",
  "cancel",
  "cancel_presentation",
  "cancel_schedule_send",
  "candle",
  "candlestick_chart",
  "captive_portal",
  "capture",
  "car_crash",
  "car_rental",
  "car_repair",
  "car_tag",
  "card_giftcard",
  "card_membership",
  "card_travel",
  "cardio_load",
  "cardiology",
  "cards",
  "cards_star",
  "carpenter",
  "carry_on_bag",
  "carry_on_bag_checked",
  "carry_on_bag_inactive",
  "carry_on_bag_question",
  "cases",
  "casino",
  "cast",
  "cast_connected",
  "cast_for_education",
  "cast_pause",
  "cast_warning",
  "castle",
  "catching_pokemon",
  "category",
  "category_search",
  "celebration",
  "cell_merge",
  "cell_tower",
  "cell_wifi",
  "center_focus_strong",
  "center_focus_weak",
  "chair",
  "chair_alt",
  "chalet",
  "change_circle",
  "change_history",
  "charger",
  "charging_station",
  "chart_data",
  "chat",
  "chat_add_on",
  "chat_apps_script",
  "chat_bubble",
  "chat_bubble_outline",
  "chat_error",
  "chat_info",
  "chat_paste_go",
  "chat_paste_go_2",
  "check",
  "check_box",
  "check_box_outline_blank",
  "check_circle",
  "check_circle_outline",
  "check_in_out",
  "check_indeterminate_small",
  "check_small",
  "checkbook",
  "checked_bag",
  "checked_bag_question",
  "checklist",
  "checklist_rtl",
  "checkroom",
  "cheer",
  "chess",
  "chess_pawn",
  "chevron_backward",
  "chevron_forward",
  "chevron_left",
  "chevron_right",
  "child_care",
  "child_friendly",
  "chip_extraction",
  "chips",
  "chrome_reader_mode",
  "chromecast_2",
  "chromecast_device",
  "chronic",
  "church",
  "cinematic_blur",
  "circle",
  "circle_notifications",
  "circles",
  "circles_ext",
  "clarify",
  "class",
  "clean_hands",
  "cleaning",
  "cleaning_bucket",
  "cleaning_services",
  "clear",
  "clear_all",
  "clear_day",
  "climate_mini_split",
  "clinical_notes",
  "clock_arrow_down",
  "clock_arrow_up",
  "clock_loader_10",
  "clock_loader_20",
  "clock_loader_40",
  "clock_loader_60",
  "clock_loader_80",
  "clock_loader_90",
  "close",
  "close_fullscreen",
  "close_small",
  "closed_caption",
  "closed_caption_add",
  "closed_caption_disabled",
  "closed_caption_off",
  "cloud",
  "cloud_alert",
  "cloud_circle",
  "cloud_done",
  "cloud_download",
  "cloud_lock",
  "cloud_off",
  "cloud_queue",
  "cloud_sync",
  "cloud_upload",
  "cloudy_snowing",
  "co2",
  "co_present",
  "code",
  "code_blocks",
  "code_off",
  "coffee",
  "coffee_maker",
  "cognition",
  "cognition_2",
  "collapse_all",
  "collapse_content",
  "collections",
  "collections_bookmark",
  "color_lens",
  "colorize",
  "colors",
  "combine_columns",
  "comedy_mask",
  "comic_bubble",
  "comment",
  "comment_bank",
  "comments_disabled",
  "commit",
  "communication",
  "communities",
  "commute",
  "compare",
  "compare_arrows",
  "compass_calibration",
  "component_exchange",
  "compost",
  "compress",
  "computer",
  "concierge",
  "conditions",
  "confirmation_number",
  "congenital",
  "connect_without_contact",
  "connected_tv",
  "connecting_airports",
  "construction",
  "contact_emergency",
  "contact_mail",
  "contact_page",
  "contact_phone",
  "contact_support",
  "contactless",
  "contactless_off",
  "contacts",
  "contacts_product",
  "content_copy",
  "content_cut",
  "content_paste",
  "content_paste_go",
  "content_paste_off",
  "content_paste_search",
  "contextual_token",
  "contextual_token_add",
  "contract",
  "contract_delete",
  "contract_edit",
  "contrast",
  "contrast_circle",
  "contrast_rtl_off",
  "contrast_square",
  "control_camera",
  "control_point",
  "control_point_duplicate",
  "controller_gen",
  "conversion_path",
  "conversion_path_off",
  "convert_to_text",
  "conveyor_belt",
  "cookie",
  "cookie_off",
  "cooking",
  "cool_to_dry",
  "copy_all",
  "copyright",
  "coronavirus",
  "corporate_fare",
  "cottage",
  "counter_0",
  "counter_1",
  "counter_2",
  "counter_3",
  "counter_4",
  "counter_5",
  "counter_6",
  "counter_7",
  "counter_8",
  "counter_9",
  "countertops",
  "create",
  "create_new_folder",
  "credit_card",
  "credit_card_clock",
  "credit_card_gear",
  "credit_card_heart",
  "credit_card_off",
  "credit_score",
  "crib",
  "crisis_alert",
  "crop",
  "crop_16_9",
  "crop_3_2",
  "crop_5_4",
  "crop_7_5",
  "crop_9_16",
  "crop_din",
  "crop_free",
  "crop_landscape",
  "crop_original",
  "crop_portrait",
  "crop_rotate",
  "crop_square",
  "crossword",
  "crowdsource",
  "cruelty_free",
  "css",
  "csv",
  "currency_bitcoin",
  "currency_exchange",
  "currency_franc",
  "currency_lira",
  "currency_pound",
  "currency_ruble",
  "currency_rupee",
  "currency_rupee_circle",
  "currency_yen",
  "currency_yuan",
  "curtains",
  "curtains_closed",
  "custom_typography",
  "cycle",
  "cyclone",
  "dangerous",
  "dark_mode",
  "dashboard",
  "dashboard_2",
  "dashboard_customize",
  "data_alert",
  "data_array",
  "data_check",
  "data_exploration",
  "data_info_alert",
  "data_loss_prevention",
  "data_object",
  "data_saver_off",
  "data_saver_on",
  "data_table",
  "data_thresholding",
  "data_usage",
  "database",
  "database_off",
  "database_search",
  "database_upload",
  "dataset",
  "dataset_linked",
  "date_range",
  "deblur",
  "deceased",
  "decimal_decrease",
  "decimal_increase",
  "deck",
  "dehaze",
  "delete",
  "delete_forever",
  "delete_history",
  "delete_outline",
  "delete_sweep",
  "delivery_dining",
  "delivery_truck_bolt",
  "delivery_truck_speed",
  "demography",
  "density_large",
  "density_medium",
  "density_small",
  "dentistry",
  "departure_board",
  "deployed_code",
  "deployed_code_account",
  "deployed_code_alert",
  "deployed_code_history",
  "deployed_code_update",
  "dermatology",
  "description",
  "deselect",
  "design_services",
  "desk",
  "deskphone",
  "desktop_access_disabled",
  "desktop_cloud",
  "desktop_cloud_stack",
  "desktop_landscape",
  "desktop_landscape_add",
  "desktop_mac",
  "desktop_portrait",
  "desktop_windows",
  "destruction",
  "details",
  "detection_and_zone",
  "detector",
  "detector_alarm",
  "detector_battery",
  "detector_co",
  "detector_offline",
  "detector_smoke",
  "detector_status",
  "developer_board",
  "developer_board_off",
  "developer_guide",
  "developer_mode",
  "developer_mode_tv",
  "device_hub",
  "device_thermostat",
  "device_unknown",
  "devices",
  "devices_fold",
  "devices_fold_2",
  "devices_off",
  "devices_other",
  "devices_wearables",
  "dew_point",
  "diagnosis",
  "diagonal_line",
  "dialer_sip",
  "dialogs",
  "dialpad",
  "diamond",
  "dictionary",
  "difference",
  "digital_out_of_home",
  "digital_wellbeing",
  "dining",
  "dinner_dining",
  "directions",
  "directions_alt",
  "directions_alt_off",
  "directions_bike",
  "directions_boat",
  "directions_boat_filled",
  "directions_bus",
  "directions_bus_filled",
  "directions_car",
  "directions_car_filled",
  "directions_off",
  "directions_railway",
  "directions_railway_2",
  "directions_railway_filled",
  "directions_run",
  "directions_subway",
  "directions_subway_filled",
  "directions_transit",
  "directions_transit_filled",
  "directions_walk",
  "directory_sync",
  "dirty_lens",
  "disabled_by_default",
  "disabled_visible",
  "disc_full",
  "discount",
  "discover_tune",
  "dishwasher",
  "dishwasher_gen",
  "display_external_input",
  "display_settings",
  "distance",
  "diversity_1",
  "diversity_2",
  "diversity_3",
  "diversity_4",
  "dns",
  "do_disturb",
  "do_disturb_alt",
  "do_disturb_off",
  "do_disturb_on",
  "do_not_disturb",
  "do_not_disturb_alt",
  "do_not_disturb_off",
  "do_not_disturb_on",
  "do_not_disturb_on_total_silence",
  "do_not_step",
  "do_not_touch",
  "dock",
  "dock_to_bottom",
  "dock_to_left",
  "dock_to_right",
  "docs",
  "docs_add_on",
  "docs_apps_script",
  "document_scanner",
  "document_search",
  "domain",
  "domain_add",
  "domain_disabled",
  "domain_verification",
  "domain_verification_off",
  "domino_mask",
  "done",
  "done_all",
  "done_outline",
  "donut_large",
  "donut_small",
  "door_back",
  "door_front",
  "door_open",
  "door_sensor",
  "door_sliding",
  "doorbell",
  "doorbell_3p",
  "doorbell_chime",
  "double_arrow",
  "downhill_skiing",
  "download",
  "download_2",
  "download_done",
  "download_for_offline",
  "downloading",
  "draft",
  "draft_orders",
  "drafts",
  "drag_click",
  "drag_handle",
  "drag_indicator",
  "drag_pan",
  "draw",
  "draw_abstract",
  "draw_collage",
  "dresser",
  "drive_eta",
  "drive_export",
  "drive_file_move",
  "drive_file_move_outline",
  "drive_file_move_rtl",
  "drive_file_rename_outline",
  "drive_folder_upload",
  "dropdown",
  "dry",
  "dry_cleaning",
  "dual_screen",
  "duo",
  "dvr",
  "dynamic_feed",
  "dynamic_form",
  "e911_avatar",
  "e911_emergency",
  "e_mobiledata",
  "e_mobiledata_badge",
  "earbuds",
  "earbuds_battery",
  "early_on",
  "earthquake",
  "east",
  "ecg",
  "ecg_heart",
  "eco",
  "eda",
  "edgesensor_high",
  "edgesensor_low",
  "edit",
  "edit_arrow_down",
  "edit_arrow_up",
  "edit_attributes",
  "edit_audio",
  "edit_calendar",
  "edit_document",
  "edit_location",
  "edit_location_alt",
  "edit_note",
  "edit_notifications",
  "edit_off",
  "edit_road",
  "edit_square",
  "editor_choice",
  "egg",
  "egg_alt",
  "eject",
  "elderly",
  "elderly_woman",
  "electric_bike",
  "electric_bolt",
  "electric_car",
  "electric_meter",
  "electric_moped",
  "electric_rickshaw",
  "electric_scooter",
  "electrical_services",
  "elevation",
  "elevator",
  "email",
  "emergency",
  "emergency_heat",
  "emergency_heat_2",
  "emergency_home",
  "emergency_recording",
  "emergency_share",
  "emergency_share_off",
  "emoji_emotions",
  "emoji_events",
  "emoji_food_beverage",
  "emoji_language",
  "emoji_nature",
  "emoji_objects",
  "emoji_people",
  "emoji_symbols",
  "emoji_transportation",
  "emoticon",
  "empty_dashboard",
  "enable",
  "encrypted",
  "encrypted_add",
  "encrypted_add_circle",
  "encrypted_minus_circle",
  "encrypted_off",
  "endocrinology",
  "energy",
  "energy_program_saving",
  "energy_program_time_used",
  "energy_savings_leaf",
  "engineering",
  "enhanced_encryption",
  "ent",
  "enterprise",
  "enterprise_off",
  "equal",
  "equalizer",
  "eraser_size_1",
  "eraser_size_2",
  "eraser_size_3",
  "eraser_size_4",
  "eraser_size_5",
  "error",
  "error_med",
  "error_outline",
  "escalator",
  "escalator_warning",
  "euro",
  "euro_symbol",
  "ev_mobiledata_badge",
  "ev_shadow",
  "ev_shadow_add",
  "ev_shadow_minus",
  "ev_station",
  "event",
  "event_available",
  "event_busy",
  "event_list",
  "event_note",
  "event_repeat",
  "event_seat",
  "event_upcoming",
  "exclamation",
  "exercise",
  "exit_to_app",
  "expand",
  "expand_all",
  "expand_circle_down",
  "expand_circle_right",
  "expand_circle_up",
  "expand_content",
  "expand_less",
  "expand_more",
  "expansion_panels",
  "experiment",
  "explicit",
  "explore",
  "explore_nearby",
  "explore_off",
  "explosion",
  "export_notes",
  "exposure",
  "exposure_neg_1",
  "exposure_neg_2",
  "exposure_plus_1",
  "exposure_plus_2",
  "exposure_zero",
  "extension",
  "extension_off",
  "eye_tracking",
  "eyeglasses",
  "face",
  "face_2",
  "face_3",
  "face_4",
  "face_5",
  "face_6",
  "face_down",
  "face_left",
  "face_nod",
  "face_retouching_natural",
  "face_retouching_off",
  "face_right",
  "face_shake",
  "face_unlock",
  "face_up",
  "fact_check",
  "factory",
  "falling",
  "familiar_face_and_zone",
  "family_history",
  "family_home",
  "family_link",
  "family_restroom",
  "family_star",
  "farsight_digital",
  "fast_forward",
  "fast_rewind",
  "fastfood",
  "faucet",
  "favorite",
  "favorite_border",
  "fax",
  "feature_search",
  "featured_play_list",
  "featured_seasonal_and_gifts",
  "featured_video",
  "feed",
  "feedback",
  "female",
  "femur",
  "femur_alt",
  "fence",
  "fertile",
  "festival",
  "fiber_dvr",
  "fiber_manual_record",
  "fiber_new",
  "fiber_pin",
  "fiber_smart_record",
  "file_copy",
  "file_copy_off",
  "file_download",
  "file_download_done",
  "file_download_off",
  "file_export",
  "file_json",
  "file_map",
  "file_map_stack",
  "file_open",
  "file_png",
  "file_present",
  "file_save",
  "file_save_off",
  "file_upload",
  "file_upload_off",
  "files",
  "filter",
  "filter_1",
  "filter_2",
  "filter_3",
  "filter_4",
  "filter_5",
  "filter_6",
  "filter_7",
  "filter_8",
  "filter_9",
  "filter_9_plus",
  "filter_alt",
  "filter_alt_off",
  "filter_arrow_right",
  "filter_b_and_w",
  "filter_center_focus",
  "filter_drama",
  "filter_frames",
  "filter_hdr",
  "filter_list",
  "filter_list_alt",
  "filter_list_off",
  "filter_none",
  "filter_retrolux",
  "filter_tilt_shift",
  "filter_vintage",
  "finance",
  "finance_chip",
  "finance_mode",
  "find_in_page",
  "find_replace",
  "fingerprint",
  "fingerprint_off",
  "fire_extinguisher",
  "fire_hydrant",
  "fire_hydrant_alt",
  "fire_truck",
  "fireplace",
  "first_page",
  "fit_page",
  "fit_page_height",
  "fit_page_width",
  "fit_screen",
  "fit_width",
  "fitbit",
  "fitness_center",
  "fitness_tracker",
  "flag",
  "flag_2",
  "flag_check",
  "flag_circle",
  "flaky",
  "flare",
  "flash_auto",
  "flash_off",
  "flash_on",
  "flashlight_off",
  "flashlight_on",
  "flatware",
  "flex_direction",
  "flex_no_wrap",
  "flex_wrap",
  "flight",
  "flight_class",
  "flight_land",
  "flight_takeoff",
  "flights_and_hotels",
  "flip",
  "flip_camera_android",
  "flip_camera_ios",
  "flip_to_back",
  "flip_to_front",
  "float_landscape_2",
  "float_portrait_2",
  "flood",
  "floor",
  "floor_lamp",
  "flowchart",
  "flowsheet",
  "fluid",
  "fluid_balance",
  "fluid_med",
  "fluorescent",
  "flutter",
  "flutter_dash",
  "flyover",
  "fmd_bad",
  "fmd_good",
  "foggy",
  "folded_hands",
  "folder",
  "folder_check",
  "folder_check_2",
  "folder_code",
  "folder_copy",
  "folder_data",
  "folder_delete",
  "folder_eye",
  "folder_info",
  "folder_limited",
  "folder_managed",
  "folder_match",
  "folder_off",
  "folder_open",
  "folder_shared",
  "folder_special",
  "folder_supervised",
  "folder_zip",
  "follow_the_signs",
  "font_download",
  "font_download_off",
  "food_bank",
  "foot_bones",
  "footprint",
  "for_you",
  "forest",
  "fork_left",
  "fork_right",
  "fork_spoon",
  "forklift",
  "format_align_center",
  "format_align_justify",
  "format_align_left",
  "format_align_right",
  "format_bold",
  "format_clear",
  "format_color_fill",
  "format_color_reset",
  "format_color_text",
  "format_h1",
  "format_h2",
  "format_h3",
  "format_h4",
  "format_h5",
  "format_h6",
  "format_image_left",
  "format_image_right",
  "format_indent_decrease",
  "format_indent_increase",
  "format_ink_highlighter",
  "format_italic",
  "format_letter_spacing",
  "format_letter_spacing_2",
  "format_letter_spacing_standard",
  "format_letter_spacing_wide",
  "format_letter_spacing_wider",
  "format_line_spacing",
  "format_list_bulleted",
  "format_list_bulleted_add",
  "format_list_numbered",
  "format_list_numbered_rtl",
  "format_overline",
  "format_paint",
  "format_paragraph",
  "format_quote",
  "format_quote_off",
  "format_shapes",
  "format_size",
  "format_strikethrough",
  "format_text_clip",
  "format_text_overflow",
  "format_text_wrap",
  "format_textdirection_l_to_r",
  "format_textdirection_r_to_l",
  "format_textdirection_vertical",
  "format_underlined",
  "format_underlined_squiggle",
  "forms_add_on",
  "forms_apps_script",
  "fort",
  "forum",
  "forward",
  "forward_10",
  "forward_30",
  "forward_5",
  "forward_circle",
  "forward_media",
  "forward_to_inbox",
  "foundation",
  "frame_inspect",
  "frame_person",
  "frame_person_mic",
  "frame_person_off",
  "frame_reload",
  "frame_source",
  "free_breakfast",
  "free_cancellation",
  "front_hand",
  "front_loader",
  "full_coverage",
  "full_hd",
  "full_stacked_bar_chart",
  "fullscreen",
  "fullscreen_exit",
  "fullscreen_portrait",
  "function",
  "functions",
  "funicular",
  "g_mobiledata",
  "g_mobiledata_badge",
  "g_translate",
  "gallery_thumbnail",
  "gamepad",
  "games",
  "garage",
  "garage_door",
  "garage_home",
  "garden_cart",
  "gas_meter",
  "gastroenterology",
  "gate",
  "gavel",
  "general_device",
  "generating_tokens",
  "genetics",
  "genres",
  "gesture",
  "gesture_select",
  "get_app",
  "gif",
  "gif_2",
  "gif_box",
  "girl",
  "gite",
  "glass_cup",
  "globe",
  "globe_asia",
  "globe_book",
  "globe_uk",
  "glucose",
  "glyphs",
  "go_to_line",
  "golf_course",
  "gondola_lift",
  "google_home_devices",
  "google_tv_remote",
  "google_wifi",
  "gpp_bad",
  "gpp_good",
  "gpp_maybe",
  "gps_fixed",
  "gps_not_fixed",
  "gps_off",
  "grade",
  "gradient",
  "grading",
  "grain",
  "graph_1",
  "graph_2",
  "graph_3",
  "graph_4",
  "graph_5",
  "graph_6",
  "graphic_eq",
  "grass",
  "grid_3x3",
  "grid_3x3_off",
  "grid_4x4",
  "grid_goldenratio",
  "grid_guides",
  "grid_off",
  "grid_on",
  "grid_view",
  "grocery",
  "group",
  "group_add",
  "group_off",
  "group_remove",
  "group_search",
  "group_work",
  "grouped_bar_chart",
  "groups",
  "groups_2",
  "groups_3",
  "guardian",
  "gynecology",
  "h_mobiledata",
  "h_mobiledata_badge",
  "h_plus_mobiledata",
  "h_plus_mobiledata_badge",
  "hail",
  "hallway",
  "hand_bones",
  "hand_gesture",
  "hand_gesture_off",
  "handheld_controller",
  "handshake",
  "handyman",
  "hangout_video",
  "hangout_video_off",
  "hard_disk",
  "hard_drive",
  "hard_drive_2",
  "hardware",
  "hd",
  "hdr_auto",
  "hdr_auto_select",
  "hdr_enhanced_select",
  "hdr_off",
  "hdr_off_select",
  "hdr_on",
  "hdr_on_select",
  "hdr_plus",
  "hdr_plus_off",
  "hdr_strong",
  "hdr_weak",
  "head_mounted_device",
  "headphones",
  "headphones_battery",
  "headset",
  "headset_mic",
  "headset_off",
  "healing",
  "health_and_beauty",
  "health_and_safety",
  "health_metrics",
  "heap_snapshot_large",
  "heap_snapshot_multiple",
  "heap_snapshot_thumbnail",
  "hearing",
  "hearing_aid",
  "hearing_aid_disabled",
  "hearing_disabled",
  "heart_broken",
  "heart_check",
  "heart_minus",
  "heart_plus",
  "heat",
  "heat_pump",
  "heat_pump_balance",
  "height",
  "helicopter",
  "help",
  "help_center",
  "help_clinic",
  "help_outline",
  "hematology",
  "hevc",
  "hexagon",
  "hide",
  "hide_image",
  "hide_source",
  "high_density",
  "high_quality",
  "high_res",
  "highlight",
  "highlight_alt",
  "highlight_keyboard_focus",
  "highlight_mouse_cursor",
  "highlight_off",
  "highlight_text_cursor",
  "highlighter_size_1",
  "highlighter_size_2",
  "highlighter_size_3",
  "highlighter_size_4",
  "highlighter_size_5",
  "hiking",
  "history",
  "history_2",
  "history_edu",
  "history_off",
  "history_toggle_off",
  "hive",
  "hls",
  "hls_off",
  "holiday_village",
  "home",
  "home_and_garden",
  "home_app_logo",
  "home_filled",
  "home_health",
  "home_improvement_and_tools",
  "home_iot_device",
  "home_max",
  "home_max_dots",
  "home_mini",
  "home_pin",
  "home_repair_service",
  "home_speaker",
  "home_storage",
  "home_work",
  "horizontal_distribute",
  "horizontal_rule",
  "horizontal_split",
  "host",
  "hot_tub",
  "hotel",
  "hotel_class",
  "hourglass",
  "hourglass_arrow_down",
  "hourglass_arrow_up",
  "hourglass_bottom",
  "hourglass_disabled",
  "hourglass_empty",
  "hourglass_full",
  "hourglass_pause",
  "hourglass_top",
  "house",
  "house_siding",
  "house_with_shield",
  "houseboat",
  "household_supplies",
  "hov",
  "how_to_reg",
  "how_to_vote",
  "hr_resting",
  "html",
  "http",
  "https",
  "hub",
  "humerus",
  "humerus_alt",
  "humidity_high",
  "humidity_indoor",
  "humidity_low",
  "humidity_mid",
  "humidity_percentage",
  "hvac",
  "ice_skating",
  "icecream",
  "id_card",
  "identity_aware_proxy",
  "identity_platform",
  "ifl",
  "iframe",
  "iframe_off",
  "image",
  "image_aspect_ratio",
  "image_not_supported",
  "image_search",
  "imagesearch_roller",
  "imagesmode",
  "immunology",
  "import_contacts",
  "import_export",
  "important_devices",
  "in_home_mode",
  "inactive_order",
  "inbox",
  "inbox_customize",
  "inbox_text",
  "incomplete_circle",
  "indeterminate_check_box",
  "indeterminate_question_box",
  "info",
  "info_i",
  "info_outline",
  "infrared",
  "ink_eraser",
  "ink_eraser_off",
  "ink_highlighter",
  "ink_highlighter_move",
  "ink_marker",
  "ink_pen",
  "ink_selection",
  "inpatient",
  "input",
  "input_circle",
  "insert_chart",
  "insert_chart_outlined",
  "insert_comment",
  "insert_drive_file",
  "insert_emoticon",
  "insert_invitation",
  "insert_link",
  "insert_page_break",
  "insert_photo",
  "insert_text",
  "insights",
  "install_desktop",
  "install_mobile",
  "instant_mix",
  "integration_instructions",
  "interactive_space",
  "interests",
  "interpreter_mode",
  "inventory",
  "inventory_2",
  "invert_colors",
  "invert_colors_off",
  "ios",
  "ios_share",
  "iron",
  "iso",
  "jamboard_kiosk",
  "javascript",
  "join",
  "join_full",
  "join_inner",
  "join_left",
  "join_right",
  "joystick",
  "jump_to_element",
  "kayaking",
  "kebab_dining",
  "keep",
  "keep_off",
  "keep_public",
  "kettle",
  "key",
  "key_off",
  "key_vertical",
  "key_visualizer",
  "keyboard",
  "keyboard_alt",
  "keyboard_arrow_down",
  "keyboard_arrow_left",
  "keyboard_arrow_right",
  "keyboard_arrow_up",
  "keyboard_backspace",
  "keyboard_capslock",
  "keyboard_capslock_badge",
  "keyboard_command_key",
  "keyboard_control_key",
  "keyboard_double_arrow_down",
  "keyboard_double_arrow_left",
  "keyboard_double_arrow_right",
  "keyboard_double_arrow_up",
  "keyboard_external_input",
  "keyboard_full",
  "keyboard_hide",
  "keyboard_keys",
  "keyboard_lock",
  "keyboard_lock_off",
  "keyboard_off",
  "keyboard_onscreen",
  "keyboard_option_key",
  "keyboard_previous_language",
  "keyboard_return",
  "keyboard_tab",
  "keyboard_tab_rtl",
  "keyboard_voice",
  "kid_star",
  "king_bed",
  "kitchen",
  "kitesurfing",
  "lab_panel",
  "lab_profile",
  "lab_research",
  "label",
  "label_important",
  "label_important_outline",
  "label_off",
  "labs",
  "lan",
  "landscape",
  "landscape_2",
  "landscape_2_off",
  "landslide",
  "language",
  "language_chinese_array",
  "language_chinese_cangjie",
  "language_chinese_dayi",
  "language_chinese_pinyin",
  "language_chinese_quick",
  "language_chinese_wubi",
  "language_french",
  "language_gb_english",
  "language_international",
  "language_japanese_kana",
  "language_korean_latin",
  "language_pinyin",
  "language_spanish",
  "language_us",
  "language_us_colemak",
  "language_us_dvorak",
  "laps",
  "laptop",
  "laptop_car",
  "laptop_chromebook",
  "laptop_mac",
  "laptop_windows",
  "lasso_select",
  "last_page",
  "launch",
  "laundry",
  "layers",
  "layers_clear",
  "lda",
  "leaderboard",
  "leak_add",
  "leak_remove",
  "left_click",
  "left_panel_close",
  "left_panel_open",
  "legend_toggle",
  "lens",
  "lens_blur",
  "letter_switch",
  "library_add",
  "library_add_check",
  "library_books",
  "library_music",
  "license",
  "lift_to_talk",
  "light",
  "light_group",
  "light_mode",
  "light_off",
  "lightbulb",
  "lightbulb_2",
  "lightbulb_circle",
  "lightbulb_outline",
  "lightning_stand",
  "line_axis",
  "line_curve",
  "line_end",
  "line_end_arrow",
  "line_end_arrow_notch",
  "line_end_circle",
  "line_end_diamond",
  "line_end_square",
  "line_start",
  "line_start_arrow",
  "line_start_arrow_notch",
  "line_start_circle",
  "line_start_diamond",
  "line_start_square",
  "line_style",
  "line_weight",
  "linear_scale",
  "link",
  "link_off",
  "linked_camera",
  "linked_services",
  "liquor",
  "list",
  "list_alt",
  "list_alt_add",
  "list_alt_check",
  "lists",
  "live_help",
  "live_tv",
  "living",
  "local_activity",
  "local_airport",
  "local_atm",
  "local_bar",
  "local_cafe",
  "local_car_wash",
  "local_convenience_store",
  "local_dining",
  "local_drink",
  "local_fire_department",
  "local_florist",
  "local_gas_station",
  "local_grocery_store",
  "local_hospital",
  "local_hotel",
  "local_laundry_service",
  "local_library",
  "local_mall",
  "local_movies",
  "local_offer",
  "local_parking",
  "local_pharmacy",
  "local_phone",
  "local_pizza",
  "local_play",
  "local_police",
  "local_post_office",
  "local_printshop",
  "local_see",
  "local_shipping",
  "local_taxi",
  "location_away",
  "location_chip",
  "location_city",
  "location_disabled",
  "location_home",
  "location_off",
  "location_on",
  "location_pin",
  "location_searching",
  "lock",
  "lock_clock",
  "lock_open",
  "lock_open_right",
  "lock_outline",
  "lock_person",
  "lock_reset",
  "login",
  "logo_dev",
  "logout",
  "looks",
  "looks_3",
  "looks_4",
  "looks_5",
  "looks_6",
  "looks_one",
  "looks_two",
  "loop",
  "loupe",
  "low_density",
  "low_priority",
  "lowercase",
  "loyalty",
  "lte_mobiledata",
  "lte_mobiledata_badge",
  "lte_plus_mobiledata",
  "lte_plus_mobiledata_badge",
  "luggage",
  "lunch_dining",
  "lyrics",
  "macro_auto",
  "macro_off",
  "magnification_large",
  "magnification_small",
  "magnify_docked",
  "magnify_fullscreen",
  "mail",
  "mail_lock",
  "mail_off",
  "mail_outline",
  "male",
  "man",
  "man_2",
  "man_3",
  "man_4",
  "manage_accounts",
  "manage_history",
  "manage_search",
  "manga",
  "manufacturing",
  "map",
  "map_search",
  "maps_home_work",
  "maps_ugc",
  "margin",
  "mark_as_unread",
  "mark_chat_read",
  "mark_chat_unread",
  "mark_email_read",
  "mark_email_unread",
  "mark_unread_chat_alt",
  "markdown",
  "markdown_copy",
  "markdown_paste",
  "markunread",
  "markunread_mailbox",
  "masked_transitions",
  "masked_transitions_add",
  "masks",
  "match_case",
  "match_case_off",
  "match_word",
  "matter",
  "maximize",
  "measuring_tape",
  "media_bluetooth_off",
  "media_bluetooth_on",
  "media_link",
  "media_output",
  "media_output_off",
  "mediation",
  "medical_information",
  "medical_mask",
  "medical_services",
  "medication",
  "medication_liquid",
  "meeting_room",
  "memory",
  "memory_alt",
  "menstrual_health",
  "menu",
  "menu_book",
  "menu_open",
  "merge",
  "merge_type",
  "message",
  "metabolism",
  "metro",
  "mfg_nest_yale_lock",
  "mic",
  "mic_alert",
  "mic_double",
  "mic_external_off",
  "mic_external_on",
  "mic_none",
  "mic_off",
  "microbiology",
  "microwave",
  "microwave_gen",
  "military_tech",
  "mimo",
  "mimo_disconnect",
  "mindfulness",
  "minimize",
  "minor_crash",
  "mintmark",
  "miscellaneous_services",
  "missed_video_call",
  "missing_controller",
  "mist",
  "mitre",
  "mixture_med",
  "mms",
  "mobile_friendly",
  "mobile_off",
  "mobile_screen_share",
  "mobiledata_off",
  "mode",
  "mode_comment",
  "mode_cool",
  "mode_cool_off",
  "mode_dual",
  "mode_edit",
  "mode_edit_outline",
  "mode_fan",
  "mode_fan_off",
  "mode_heat",
  "mode_heat_cool",
  "mode_heat_off",
  "mode_night",
  "mode_of_travel",
  "mode_off_on",
  "mode_standby",
  "model_training",
  "modeling",
  "monetization_on",
  "money",
  "money_bag",
  "money_off",
  "money_off_csred",
  "monitor",
  "monitor_heart",
  "monitor_weight",
  "monitor_weight_gain",
  "monitor_weight_loss",
  "monitoring",
  "monochrome_photos",
  "monorail",
  "mood",
  "mood_bad",
  "mop",
  "moped",
  "more",
  "more_down",
  "more_horiz",
  "more_time",
  "more_up",
  "more_vert",
  "mosque",
  "motion_blur",
  "motion_mode",
  "motion_photos_auto",
  "motion_photos_off",
  "motion_photos_on",
  "motion_photos_pause",
  "motion_photos_paused",
  "motion_play",
  "motion_sensor_active",
  "motion_sensor_alert",
  "motion_sensor_idle",
  "motion_sensor_urgent",
  "motorcycle",
  "mountain_flag",
  "mouse",
  "mouse_lock",
  "mouse_lock_off",
  "move",
  "move_down",
  "move_group",
  "move_item",
  "move_location",
  "move_selection_down",
  "move_selection_left",
  "move_selection_right",
  "move_selection_up",
  "move_to_inbox",
  "move_up",
  "moved_location",
  "movie",
  "movie_creation",
  "movie_edit",
  "movie_filter",
  "movie_info",
  "movie_off",
  "moving",
  "moving_beds",
  "moving_ministry",
  "mp",
  "multicooker",
  "multiline_chart",
  "multimodal_hand_eye",
  "multiple_airports",
  "multiple_stop",
  "museum",
  "music_cast",
  "music_note",
  "music_note_add",
  "music_off",
  "music_video",
  "my_location",
  "mystery",
  "nat",
  "nature",
  "nature_people",
  "navigate_before",
  "navigate_next",
  "navigation",
  "near_me",
  "near_me_disabled",
  "nearby",
  "nearby_error",
  "nearby_off",
  "nephrology",
  "nest_audio",
  "nest_cam_floodlight",
  "nest_cam_indoor",
  "nest_cam_iq",
  "nest_cam_iq_outdoor",
  "nest_cam_magnet_mount",
  "nest_cam_outdoor",
  "nest_cam_stand",
  "nest_cam_wall_mount",
  "nest_cam_wired_stand",
  "nest_clock_farsight_analog",
  "nest_clock_farsight_digital",
  "nest_connect",
  "nest_detect",
  "nest_display",
  "nest_display_max",
  "nest_doorbell_visitor",
  "nest_eco_leaf",
  "nest_farsight_weather",
  "nest_found_savings",
  "nest_gale_wifi",
  "nest_heat_link_e",
  "nest_heat_link_gen_3",
  "nest_hello_doorbell",
  "nest_mini",
  "nest_multi_room",
  "nest_protect",
  "nest_remote",
  "nest_remote_comfort_sensor",
  "nest_secure_alarm",
  "nest_sunblock",
  "nest_tag",
  "nest_thermostat",
  "nest_thermostat_e_eu",
  "nest_thermostat_gen_3",
  "nest_thermostat_sensor",
  "nest_thermostat_sensor_eu",
  "nest_thermostat_zirconium_eu",
  "nest_true_radiant",
  "nest_wake_on_approach",
  "nest_wake_on_press",
  "nest_wifi_point",
  "nest_wifi_pro",
  "nest_wifi_pro_2",
  "nest_wifi_router",
  "network_cell",
  "network_check",
  "network_intel_node",
  "network_intelligence",
  "network_intelligence_history",
  "network_intelligence_update",
  "network_locked",
  "network_manage",
  "network_node",
  "network_ping",
  "network_wifi",
  "network_wifi_1_bar",
  "network_wifi_1_bar_locked",
  "network_wifi_2_bar",
  "network_wifi_2_bar_locked",
  "network_wifi_3_bar",
  "network_wifi_3_bar_locked",
  "network_wifi_locked",
  "neurology",
  "new_label",
  "new_releases",
  "new_window",
  "news",
  "newsmode",
  "newspaper",
  "newsstand",
  "next_plan",
  "next_week",
  "nfc",
  "night_shelter",
  "night_sight_auto",
  "night_sight_auto_off",
  "night_sight_max",
  "nightlife",
  "nightlight",
  "nightlight_round",
  "nights_stay",
  "no_accounts",
  "no_adult_content",
  "no_backpack",
  "no_cell",
  "no_crash",
  "no_drinks",
  "no_encryption",
  "no_encryption_gmailerrorred",
  "no_flash",
  "no_food",
  "no_luggage",
  "no_meals",
  "no_meals_ouline",
  "no_meeting_room",
  "no_photography",
  "no_sim",
  "no_sound",
  "no_stroller",
  "no_transfer",
  "noise_aware",
  "noise_control_off",
  "noise_control_on",
  "nordic_walking",
  "north",
  "north_east",
  "north_west",
  "not_accessible",
  "not_accessible_forward",
  "not_interested",
  "not_listed_location",
  "not_started",
  "note",
  "note_add",
  "note_alt",
  "note_stack",
  "note_stack_add",
  "notes",
  "notification_add",
  "notification_important",
  "notification_multiple",
  "notifications",
  "notifications_active",
  "notifications_none",
  "notifications_off",
  "notifications_paused",
  "notifications_unread",
  "numbers",
  "nutrition",
  "ods",
  "odt",
  "offline_bolt",
  "offline_pin",
  "offline_pin_off",
  "offline_share",
  "oil_barrel",
  "on_device_training",
  "on_hub_device",
  "oncology",
  "ondemand_video",
  "online_prediction",
  "onsen",
  "opacity",
  "open_in_browser",
  "open_in_full",
  "open_in_new",
  "open_in_new_down",
  "open_in_new_off",
  "open_in_phone",
  "open_jam",
  "open_run",
  "open_with",
  "ophthalmology",
  "oral_disease",
  "orbit",
  "order_approve",
  "order_play",
  "orders",
  "orthopedics",
  "other_admission",
  "other_houses",
  "outbound",
  "outbox",
  "outbox_alt",
  "outdoor_garden",
  "outdoor_grill",
  "outgoing_mail",
  "outlet",
  "outlined_flag",
  "outpatient",
  "outpatient_med",
  "output",
  "output_circle",
  "oven",
  "oven_gen",
  "overview",
  "overview_key",
  "owl",
  "oxygen_saturation",
  "p2p",
  "pace",
  "pacemaker",
  "package",
  "package_2",
  "padding",
  "page_control",
  "page_footer",
  "page_header",
  "page_info",
  "pageless",
  "pages",
  "pageview",
  "paid",
  "palette",
  "pallet",
  "pan_tool",
  "pan_tool_alt",
  "pan_zoom",
  "panorama",
  "panorama_fish_eye",
  "panorama_horizontal",
  "panorama_horizontal_select",
  "panorama_photosphere",
  "panorama_photosphere_select",
  "panorama_vertical",
  "panorama_vertical_select",
  "panorama_wide_angle",
  "panorama_wide_angle_select",
  "paragliding",
  "park",
  "partly_cloudy_day",
  "partly_cloudy_night",
  "partner_exchange",
  "partner_reports",
  "party_mode",
  "passkey",
  "password",
  "password_2",
  "password_2_off",
  "patient_list",
  "pattern",
  "pause",
  "pause_circle",
  "pause_circle_filled",
  "pause_circle_outline",
  "pause_presentation",
  "payment",
  "payments",
  "pedal_bike",
  "pediatrics",
  "pen_size_1",
  "pen_size_2",
  "pen_size_3",
  "pen_size_4",
  "pen_size_5",
  "pending",
  "pending_actions",
  "pentagon",
  "people",
  "people_alt",
  "people_outline",
  "percent",
  "pergola",
  "perm_camera_mic",
  "perm_contact_calendar",
  "perm_data_setting",
  "perm_device_information",
  "perm_identity",
  "perm_media",
  "perm_phone_msg",
  "perm_scan_wifi",
  "person",
  "person_2",
  "person_3",
  "person_4",
  "person_add",
  "person_add_alt",
  "person_add_alt_1",
  "person_add_disabled",
  "person_alert",
  "person_apron",
  "person_book",
  "person_cancel",
  "person_celebrate",
  "person_check",
  "person_edit",
  "person_off",
  "person_outline",
  "person_pin",
  "person_pin_circle",
  "person_play",
  "person_raised_hand",
  "person_remove",
  "person_remove_alt_1",
  "person_search",
  "personal_bag",
  "personal_bag_off",
  "personal_bag_question",
  "personal_injury",
  "personal_places",
  "personal_video",
  "pest_control",
  "pest_control_rodent",
  "pet_supplies",
  "pets",
  "phishing",
  "phone",
  "phone_android",
  "phone_bluetooth_speaker",
  "phone_callback",
  "phone_disabled",
  "phone_enabled",
  "phone_forwarded",
  "phone_in_talk",
  "phone_iphone",
  "phone_locked",
  "phone_missed",
  "phone_paused",
  "phonelink",
  "phonelink_erase",
  "phonelink_lock",
  "phonelink_off",
  "phonelink_ring",
  "phonelink_ring_off",
  "phonelink_setup",
  "photo",
  "photo_album",
  "photo_auto_merge",
  "photo_camera",
  "photo_camera_back",
  "photo_camera_front",
  "photo_filter",
  "photo_frame",
  "photo_library",
  "photo_prints",
  "photo_size_select_actual",
  "photo_size_select_large",
  "photo_size_select_small",
  "php",
  "physical_therapy",
  "piano",
  "piano_off",
  "picture_as_pdf",
  "picture_in_picture",
  "picture_in_picture_alt",
  "picture_in_picture_center",
  "picture_in_picture_large",
  "picture_in_picture_medium",
  "picture_in_picture_mobile",
  "picture_in_picture_off",
  "picture_in_picture_small",
  "pie_chart",
  "pie_chart_outline",
  "pie_chart_outlined",
  "pill",
  "pill_off",
  "pin",
  "pin_drop",
  "pin_end",
  "pin_invoke",
  "pinboard",
  "pinboard_unread",
  "pinch",
  "pinch_zoom_in",
  "pinch_zoom_out",
  "pip",
  "pip_exit",
  "pivot_table_chart",
  "pix",
  "place",
  "place_item",
  "plagiarism",
  "planet",
  "planner_banner_ad_pt",
  "planner_review",
  "play_arrow",
  "play_circle",
  "play_circle_filled",
  "play_circle_outline",
  "play_disabled",
  "play_for_work",
  "play_lesson",
  "play_pause",
  "playing_cards",
  "playlist_add",
  "playlist_add_check",
  "playlist_add_check_circle",
  "playlist_add_circle",
  "playlist_play",
  "playlist_remove",
  "plumbing",
  "plus_one",
  "podcasts",
  "podiatry",
  "podium",
  "point_of_sale",
  "point_scan",
  "poker_chip",
  "policy",
  "policy_alert",
  "poll",
  "polyline",
  "polymer",
  "pool",
  "portable_wifi_off",
  "portrait",
  "position_bottom_left",
  "position_bottom_right",
  "position_top_right",
  "post",
  "post_add",
  "potted_plant",
  "power",
  "power_input",
  "power_off",
  "power_settings_circle",
  "power_settings_new",
  "prayer_times",
  "precision_manufacturing",
  "pregnancy",
  "pregnant_woman",
  "preliminary",
  "prescriptions",
  "present_to_all",
  "preview",
  "preview_off",
  "price_change",
  "price_check",
  "print",
  "print_add",
  "print_connect",
  "print_disabled",
  "print_error",
  "print_lock",
  "priority",
  "priority_high",
  "privacy",
  "privacy_tip",
  "private_connectivity",
  "problem",
  "procedure",
  "process_chart",
  "production_quantity_limits",
  "productivity",
  "progress_activity",
  "prompt_suggestion",
  "propane",
  "propane_tank",
  "psychiatry",
  "psychology",
  "psychology_alt",
  "public",
  "public_off",
  "publish",
  "published_with_changes",
  "pulmonology",
  "pulse_alert",
  "punch_clock",
  "push_pin",
  "qr_code",
  "qr_code_2",
  "qr_code_2_add",
  "qr_code_scanner",
  "query_builder",
  "query_stats",
  "question_answer",
  "question_exchange",
  "question_mark",
  "queue",
  "queue_music",
  "queue_play_next",
  "quick_phrases",
  "quick_reference",
  "quick_reference_all",
  "quick_reorder",
  "quickreply",
  "quiz",
  "r_mobiledata",
  "radar",
  "radio",
  "radio_button_checked",
  "radio_button_partial",
  "radio_button_unchecked",
  "radiology",
  "railway_alert",
  "railway_alert_2",
  "rainy",
  "rainy_heavy",
  "rainy_light",
  "rainy_snow",
  "ramen_dining",
  "ramp_left",
  "ramp_right",
  "range_hood",
  "rate_review",
  "raven",
  "raw_off",
  "raw_on",
  "read_more",
  "readiness_score",
  "real_estate_agent",
  "rear_camera",
  "rebase",
  "rebase_edit",
  "receipt",
  "receipt_long",
  "receipt_long_off",
  "recent_actors",
  "recent_patient",
  "recenter",
  "recommend",
  "record_voice_over",
  "rectangle",
  "recycling",
  "redeem",
  "redo",
  "reduce_capacity",
  "refresh",
  "regular_expression",
  "relax",
  "release_alert",
  "remember_me",
  "reminder",
  "remote_gen",
  "remove",
  "remove_circle",
  "remove_circle_outline",
  "remove_done",
  "remove_from_queue",
  "remove_moderator",
  "remove_red_eye",
  "remove_road",
  "remove_selection",
  "remove_shopping_cart",
  "reopen_window",
  "reorder",
  "repartition",
  "repeat",
  "repeat_on",
  "repeat_one",
  "repeat_one_on",
  "replace_audio",
  "replace_image",
  "replace_video",
  "replay",
  "replay_10",
  "replay_30",
  "replay_5",
  "replay_circle_filled",
  "reply",
  "reply_all",
  "report",
  "report_gmailerrorred",
  "report_off",
  "report_problem",
  "request_page",
  "request_quote",
  "reset_brightness",
  "reset_focus",
  "reset_image",
  "reset_iso",
  "reset_settings",
  "reset_shadow",
  "reset_shutter_speed",
  "reset_tv",
  "reset_white_balance",
  "reset_wrench",
  "resize",
  "respiratory_rate",
  "responsive_layout",
  "restart_alt",
  "restaurant",
  "restaurant_menu",
  "restore",
  "restore_from_trash",
  "restore_page",
  "resume",
  "reviews",
  "rewarded_ads",
  "rheumatology",
  "rib_cage",
  "rice_bowl",
  "right_click",
  "right_panel_close",
  "right_panel_open",
  "ring_volume",
  "ripples",
  "road",
  "robot",
  "robot_2",
  "rocket",
  "rocket_launch",
  "roller_shades",
  "roller_shades_closed",
  "roller_skating",
  "roofing",
  "room",
  "room_preferences",
  "room_service",
  "rotate_90_degrees_ccw",
  "rotate_90_degrees_cw",
  "rotate_auto",
  "rotate_left",
  "rotate_right",
  "roundabout_left",
  "roundabout_right",
  "rounded_corner",
  "route",
  "router",
  "routine",
  "rowing",
  "rss_feed",
  "rsvp",
  "rtt",
  "rubric",
  "rule",
  "rule_folder",
  "rule_settings",
  "run_circle",
  "running_with_errors",
  "rv_hookup",
  "safety_check",
  "safety_check_off",
  "safety_divider",
  "sailing",
  "salinity",
  "sanitizer",
  "satellite",
  "satellite_alt",
  "sauna",
  "save",
  "save_alt",
  "save_as",
  "save_clock",
  "saved_search",
  "savings",
  "scale",
  "scan",
  "scan_delete",
  "scanner",
  "scatter_plot",
  "scene",
  "schedule",
  "schedule_send",
  "schema",
  "school",
  "science",
  "science_off",
  "scooter",
  "score",
  "scoreboard",
  "screen_lock_landscape",
  "screen_lock_portrait",
  "screen_lock_rotation",
  "screen_record",
  "screen_rotation",
  "screen_rotation_alt",
  "screen_rotation_up",
  "screen_search_desktop",
  "screen_share",
  "screenshot",
  "screenshot_frame",
  "screenshot_frame_2",
  "screenshot_keyboard",
  "screenshot_monitor",
  "screenshot_region",
  "screenshot_tablet",
  "script",
  "scrollable_header",
  "scuba_diving",
  "sd",
  "sd_card",
  "sd_card_alert",
  "sd_storage",
  "sdk",
  "search",
  "search_activity",
  "search_check",
  "search_check_2",
  "search_hands_free",
  "search_insights",
  "search_off",
  "security",
  "security_key",
  "security_update",
  "security_update_good",
  "security_update_warning",
  "segment",
  "select",
  "select_all",
  "select_check_box",
  "select_to_speak",
  "select_window",
  "select_window_2",
  "select_window_off",
  "self_care",
  "self_improvement",
  "sell",
  "send",
  "send_and_archive",
  "send_money",
  "send_time_extension",
  "send_to_mobile",
  "sensor_door",
  "sensor_occupied",
  "sensor_window",
  "sensors",
  "sensors_krx",
  "sensors_krx_off",
  "sensors_off",
  "sentiment_calm",
  "sentiment_content",
  "sentiment_dissatisfied",
  "sentiment_excited",
  "sentiment_extremely_dissatisfied",
  "sentiment_frustrated",
  "sentiment_neutral",
  "sentiment_sad",
  "sentiment_satisfied",
  "sentiment_satisfied_alt",
  "sentiment_stressed",
  "sentiment_very_dissatisfied",
  "sentiment_very_satisfied",
  "sentiment_worried",
  "serif",
  "server_person",
  "service_toolbox",
  "set_meal",
  "settings",
  "settings_accessibility",
  "settings_account_box",
  "settings_alert",
  "settings_applications",
  "settings_b_roll",
  "settings_backup_restore",
  "settings_bluetooth",
  "settings_brightness",
  "settings_cell",
  "settings_cinematic_blur",
  "settings_ethernet",
  "settings_heart",
  "settings_input_antenna",
  "settings_input_component",
  "settings_input_composite",
  "settings_input_hdmi",
  "settings_input_svideo",
  "settings_motion_mode",
  "settings_night_sight",
  "settings_overscan",
  "settings_panorama",
  "settings_phone",
  "settings_photo_camera",
  "settings_power",
  "settings_remote",
  "settings_slow_motion",
  "settings_suggest",
  "settings_system_daydream",
  "settings_timelapse",
  "settings_video_camera",
  "settings_voice",
  "settop_component",
  "severe_cold",
  "shadow",
  "shadow_add",
  "shadow_minus",
  "shape_line",
  "shapes",
  "share",
  "share_eta",
  "share_location",
  "share_off",
  "share_reviews",
  "share_windows",
  "sheets_rtl",
  "shelf_auto_hide",
  "shelf_position",
  "shelves",
  "shield",
  "shield_lock",
  "shield_locked",
  "shield_moon",
  "shield_person",
  "shield_question",
  "shield_with_heart",
  "shield_with_house",
  "shift",
  "shift_lock",
  "shift_lock_off",
  "shop",
  "shop_2",
  "shop_two",
  "shopping_bag",
  "shopping_bag_speed",
  "shopping_basket",
  "shopping_cart",
  "shopping_cart_checkout",
  "shopping_cart_off",
  "shoppingmode",
  "short_stay",
  "short_text",
  "shortcut",
  "show_chart",
  "shower",
  "shuffle",
  "shuffle_on",
  "shutter_speed",
  "shutter_speed_add",
  "shutter_speed_minus",
  "sick",
  "side_navigation",
  "sign_language",
  "signal_cellular_0_bar",
  "signal_cellular_1_bar",
  "signal_cellular_2_bar",
  "signal_cellular_3_bar",
  "signal_cellular_4_bar",
  "signal_cellular_add",
  "signal_cellular_alt",
  "signal_cellular_alt_1_bar",
  "signal_cellular_alt_2_bar",
  "signal_cellular_connected_no_internet_0_bar",
  "signal_cellular_connected_no_internet_1_bar",
  "signal_cellular_connected_no_internet_2_bar",
  "signal_cellular_connected_no_internet_3_bar",
  "signal_cellular_connected_no_internet_4_bar",
  "signal_cellular_no_sim",
  "signal_cellular_nodata",
  "signal_cellular_null",
  "signal_cellular_off",
  "signal_cellular_pause",
  "signal_disconnected",
  "signal_wifi_0_bar",
  "signal_wifi_1_bar",
  "signal_wifi_1_bar_lock",
  "signal_wifi_2_bar",
  "signal_wifi_2_bar_lock",
  "signal_wifi_3_bar",
  "signal_wifi_3_bar_lock",
  "signal_wifi_4_bar",
  "signal_wifi_4_bar_lock",
  "signal_wifi_bad",
  "signal_wifi_connected_no_internet_0",
  "signal_wifi_connected_no_internet_1",
  "signal_wifi_connected_no_internet_2",
  "signal_wifi_connected_no_internet_3",
  "signal_wifi_connected_no_internet_4",
  "signal_wifi_off",
  "signal_wifi_statusbar_1_bar",
  "signal_wifi_statusbar_2_bar",
  "signal_wifi_statusbar_3_bar",
  "signal_wifi_statusbar_4_bar",
  "signal_wifi_statusbar_connected_no_internet",
  "signal_wifi_statusbar_connected_no_internet_1",
  "signal_wifi_statusbar_connected_no_internet_2",
  "signal_wifi_statusbar_connected_no_internet_3",
  "signal_wifi_statusbar_connected_no_internet_4",
  "signal_wifi_statusbar_not_connected",
  "signal_wifi_statusbar_null",
  "signature",
  "signpost",
  "sim_card",
  "sim_card_alert",
  "sim_card_download",
  "simulation",
  "single_bed",
  "sip",
  "siren",
  "siren_check",
  "siren_open",
  "siren_question",
  "skateboarding",
  "skeleton",
  "skillet",
  "skillet_cooktop",
  "skip_next",
  "skip_previous",
  "skull",
  "skull_list",
  "slab_serif",
  "sledding",
  "sleep_score",
  "slide_library",
  "sliders",
  "slideshow",
  "slow_motion_video",
  "smart_button",
  "smart_card_reader",
  "smart_card_reader_off",
  "smart_display",
  "smart_outlet",
  "smart_screen",
  "smart_toy",
  "smartphone",
  "smartphone_camera",
  "smb_share",
  "smoke_free",
  "smoking_rooms",
  "sms",
  "sms_failed",
  "snippet_folder",
  "snooze",
  "snowboarding",
  "snowing",
  "snowing_heavy",
  "snowmobile",
  "snowshoeing",
  "soap",
  "social_distance",
  "social_leaderboard",
  "solar_power",
  "sort",
  "sort_by_alpha",
  "sos",
  "sound_detection_dog_barking",
  "sound_detection_glass_break",
  "sound_detection_loud_sound",
  "sound_sampler",
  "soup_kitchen",
  "source",
  "source_environment",
  "source_notes",
  "south",
  "south_america",
  "south_east",
  "south_west",
  "spa",
  "space_bar",
  "space_dashboard",
  "spatial_audio",
  "spatial_audio_off",
  "spatial_speaker",
  "spatial_tracking",
  "speaker",
  "speaker_group",
  "speaker_notes",
  "speaker_notes_off",
  "speaker_phone",
  "special_character",
  "specific_gravity",
  "speech_to_text",
  "speed",
  "speed_0_25",
  "speed_0_2x",
  "speed_0_5",
  "speed_0_5x",
  "speed_0_75",
  "speed_0_7x",
  "speed_1_2",
  "speed_1_25",
  "speed_1_2x",
  "speed_1_5",
  "speed_1_5x",
  "speed_1_75",
  "speed_1_7x",
  "speed_2x",
  "speed_camera",
  "spellcheck",
  "split_scene",
  "splitscreen",
  "splitscreen_add",
  "splitscreen_bottom",
  "splitscreen_landscape",
  "splitscreen_left",
  "splitscreen_portrait",
  "splitscreen_right",
  "splitscreen_top",
  "splitscreen_vertical_add",
  "spo2",
  "spoke",
  "sports",
  "sports_and_outdoors",
  "sports_bar",
  "sports_baseball",
  "sports_basketball",
  "sports_cricket",
  "sports_esports",
  "sports_football",
  "sports_golf",
  "sports_gymnastics",
  "sports_handball",
  "sports_hockey",
  "sports_kabaddi",
  "sports_martial_arts",
  "sports_mma",
  "sports_motorsports",
  "sports_rugby",
  "sports_score",
  "sports_soccer",
  "sports_tennis",
  "sports_volleyball",
  "sprinkler",
  "sprint",
  "square",
  "square_dot",
  "square_foot",
  "ssid_chart",
  "stack",
  "stack_hexagon",
  "stack_off",
  "stack_star",
  "stacked_bar_chart",
  "stacked_email",
  "stacked_inbox",
  "stacked_line_chart",
  "stacks",
  "stadia_controller",
  "stadium",
  "stairs",
  "stairs_2",
  "star",
  "star_border",
  "star_border_purple500",
  "star_half",
  "star_outline",
  "star_purple500",
  "star_rate",
  "star_rate_half",
  "stars",
  "start",
  "stat_0",
  "stat_1",
  "stat_2",
  "stat_3",
  "stat_minus_1",
  "stat_minus_2",
  "stat_minus_3",
  "stay_current_landscape",
  "stay_current_portrait",
  "stay_primary_landscape",
  "stay_primary_portrait",
  "step",
  "step_into",
  "step_out",
  "step_over",
  "steppers",
  "steps",
  "stethoscope",
  "stethoscope_arrow",
  "stethoscope_check",
  "sticky_note",
  "sticky_note_2",
  "stock_media",
  "stockpot",
  "stop",
  "stop_circle",
  "stop_screen_share",
  "storage",
  "store",
  "store_mall_directory",
  "storefront",
  "storm",
  "straight",
  "straighten",
  "strategy",
  "stream",
  "stream_apps",
  "streetview",
  "stress_management",
  "strikethrough_s",
  "stroke_full",
  "stroke_partial",
  "stroller",
  "style",
  "styler",
  "stylus",
  "stylus_laser_pointer",
  "stylus_note",
  "subdirectory_arrow_left",
  "subdirectory_arrow_right",
  "subheader",
  "subject",
  "subscript",
  "subscriptions",
  "subtitles",
  "subtitles_off",
  "subway",
  "summarize",
  "sunny",
  "sunny_snowing",
  "superscript",
  "supervised_user_circle",
  "supervised_user_circle_off",
  "supervisor_account",
  "support",
  "support_agent",
  "surfing",
  "surgical",
  "surround_sound",
  "swap_calls",
  "swap_driving_apps",
  "swap_driving_apps_wheel",
  "swap_horiz",
  "swap_horizontal_circle",
  "swap_vert",
  "swap_vertical_circle",
  "sweep",
  "swipe",
  "swipe_down",
  "swipe_down_alt",
  "swipe_left",
  "swipe_left_alt",
  "swipe_right",
  "swipe_right_alt",
  "swipe_up",
  "swipe_up_alt",
  "swipe_vertical",
  "switch",
  "switch_access",
  "switch_access_2",
  "switch_access_shortcut",
  "switch_access_shortcut_add",
  "switch_account",
  "switch_camera",
  "switch_left",
  "switch_right",
  "switch_video",
  "switches",
  "sword_rose",
  "swords",
  "symptoms",
  "synagogue",
  "sync",
  "sync_alt",
  "sync_arrow_down",
  "sync_arrow_up",
  "sync_desktop",
  "sync_disabled",
  "sync_lock",
  "sync_problem",
  "sync_saved_locally",
  "syringe",
  "system_security_update",
  "system_security_update_good",
  "system_security_update_warning",
  "system_update",
  "system_update_alt",
  "tab",
  "tab_close",
  "tab_close_inactive",
  "tab_close_right",
  "tab_duplicate",
  "tab_group",
  "tab_inactive",
  "tab_move",
  "tab_new_right",
  "tab_recent",
  "tab_unselected",
  "table",
  "table_bar",
  "table_chart",
  "table_chart_view",
  "table_convert",
  "table_edit",
  "table_eye",
  "table_lamp",
  "table_restaurant",
  "table_rows",
  "table_rows_narrow",
  "table_view",
  "tablet",
  "tablet_android",
  "tablet_camera",
  "tablet_mac",
  "tabs",
  "tactic",
  "tag",
  "tag_faces",
  "takeout_dining",
  "tamper_detection_off",
  "tamper_detection_on",
  "tap_and_play",
  "tapas",
  "target",
  "task",
  "task_alt",
  "taunt",
  "taxi_alert",
  "team_dashboard",
  "temp_preferences_eco",
  "temple_buddhist",
  "temple_hindu",
  "tenancy",
  "terminal",
  "terrain",
  "text_ad",
  "text_compare",
  "text_decrease",
  "text_fields",
  "text_fields_alt",
  "text_format",
  "text_increase",
  "text_rotate_up",
  "text_rotate_vertical",
  "text_rotation_angledown",
  "text_rotation_angleup",
  "text_rotation_down",
  "text_rotation_none",
  "text_select_end",
  "text_select_jump_to_beginning",
  "text_select_jump_to_end",
  "text_select_move_back_character",
  "text_select_move_back_word",
  "text_select_move_down",
  "text_select_move_forward_character",
  "text_select_move_forward_word",
  "text_select_move_up",
  "text_select_start",
  "text_snippet",
  "text_to_speech",
  "text_up",
  "textsms",
  "texture",
  "texture_add",
  "texture_minus",
  "theater_comedy",
  "theaters",
  "thermometer",
  "thermometer_add",
  "thermometer_gain",
  "thermometer_loss",
  "thermometer_minus",
  "thermostat",
  "thermostat_arrow_down",
  "thermostat_arrow_up",
  "thermostat_auto",
  "thermostat_carbon",
  "things_to_do",
  "thread_unread",
  "threat_intelligence",
  "thumb_down",
  "thumb_down_alt",
  "thumb_down_off_alt",
  "thumb_up",
  "thumb_up_alt",
  "thumb_up_off_alt",
  "thumbnail_bar",
  "thumbs_up_down",
  "thunderstorm",
  "tibia",
  "tibia_alt",
  "tile_large",
  "tile_medium",
  "tile_small",
  "time_auto",
  "time_to_leave",
  "timelapse",
  "timeline",
  "timer",
  "timer_10",
  "timer_10_alt_1",
  "timer_10_select",
  "timer_3",
  "timer_3_alt_1",
  "timer_3_select",
  "timer_5",
  "timer_5_shutter",
  "timer_arrow_down",
  "timer_arrow_up",
  "timer_off",
  "timer_pause",
  "timer_play",
  "tips_and_updates",
  "tire_repair",
  "title",
  "titlecase",
  "toast",
  "toc",
  "today",
  "toggle_off",
  "toggle_on",
  "token",
  "toll",
  "tonality",
  "toolbar",
  "tools_flat_head",
  "tools_installation_kit",
  "tools_ladder",
  "tools_level",
  "tools_phillips",
  "tools_pliers_wire_stripper",
  "tools_power_drill",
  "tooltip",
  "tooltip_2",
  "top_panel_close",
  "top_panel_open",
  "topic",
  "tornado",
  "total_dissolved_solids",
  "touch_app",
  "touch_double",
  "touch_long",
  "touch_triple",
  "touchpad_mouse",
  "touchpad_mouse_off",
  "tour",
  "toys",
  "toys_and_games",
  "toys_fan",
  "track_changes",
  "trackpad_input",
  "trackpad_input_2",
  "trackpad_input_3",
  "traffic",
  "traffic_jam",
  "trail_length",
  "trail_length_medium",
  "trail_length_short",
  "train",
  "tram",
  "transcribe",
  "transfer_within_a_station",
  "transform",
  "transgender",
  "transit_enterexit",
  "transit_ticket",
  "transition_chop",
  "transition_dissolve",
  "transition_fade",
  "transition_push",
  "transition_slide",
  "translate",
  "transportation",
  "travel",
  "travel_explore",
  "travel_luggage_and_bags",
  "trending_down",
  "trending_flat",
  "trending_up",
  "trip",
  "trip_origin",
  "trolley",
  "trolley_cable_car",
  "trophy",
  "troubleshoot",
  "try",
  "tsunami",
  "tsv",
  "tty",
  "tune",
  "tungsten",
  "turn_left",
  "turn_right",
  "turn_sharp_left",
  "turn_sharp_right",
  "turn_slight_left",
  "turn_slight_right",
  "turned_in",
  "turned_in_not",
  "tv",
  "tv_displays",
  "tv_gen",
  "tv_guide",
  "tv_next",
  "tv_off",
  "tv_options_edit_channels",
  "tv_options_input_settings",
  "tv_remote",
  "tv_signin",
  "tv_with_assistant",
  "two_pager",
  "two_pager_store",
  "two_wheeler",
  "type_specimen",
  "u_turn_left",
  "u_turn_right",
  "ulna_radius",
  "ulna_radius_alt",
  "umbrella",
  "unarchive",
  "undo",
  "unfold_less",
  "unfold_less_double",
  "unfold_more",
  "unfold_more_double",
  "ungroup",
  "universal_currency",
  "universal_currency_alt",
  "universal_local",
  "unknown_2",
  "unknown_5",
  "unknown_7",
  "unknown_document",
  "unknown_med",
  "unlicense",
  "unpaved_road",
  "unpublished",
  "unsubscribe",
  "upcoming",
  "update",
  "update_disabled",
  "upgrade",
  "upi_pay",
  "upload",
  "upload_2",
  "upload_file",
  "uppercase",
  "urology",
  "usb",
  "usb_off",
  "user_attributes",
  "vaccines",
  "vacuum",
  "valve",
  "vape_free",
  "vaping_rooms",
  "variable_add",
  "variable_insert",
  "variable_remove",
  "variables",
  "ventilator",
  "verified",
  "verified_user",
  "vertical_align_bottom",
  "vertical_align_center",
  "vertical_align_top",
  "vertical_distribute",
  "vertical_shades",
  "vertical_shades_closed",
  "vertical_split",
  "vibration",
  "video_call",
  "video_camera_back",
  "video_camera_back_add",
  "video_camera_front",
  "video_camera_front_off",
  "video_chat",
  "video_file",
  "video_label",
  "video_library",
  "video_search",
  "video_settings",
  "video_stable",
  "videocam",
  "videocam_alert",
  "videocam_off",
  "videogame_asset",
  "videogame_asset_off",
  "view_agenda",
  "view_apps",
  "view_array",
  "view_carousel",
  "view_column",
  "view_column_2",
  "view_comfy",
  "view_comfy_alt",
  "view_compact",
  "view_compact_alt",
  "view_cozy",
  "view_day",
  "view_headline",
  "view_in_ar",
  "view_in_ar_off",
  "view_kanban",
  "view_list",
  "view_module",
  "view_object_track",
  "view_quilt",
  "view_real_size",
  "view_sidebar",
  "view_stream",
  "view_timeline",
  "view_week",
  "vignette",
  "villa",
  "visibility",
  "visibility_lock",
  "visibility_off",
  "vital_signs",
  "vo2_max",
  "voice_chat",
  "voice_over_off",
  "voice_selection",
  "voice_selection_off",
  "voicemail",
  "volcano",
  "volume_down",
  "volume_down_alt",
  "volume_mute",
  "volume_off",
  "volume_up",
  "volunteer_activism",
  "voting_chip",
  "vpn_key",
  "vpn_key_alert",
  "vpn_key_off",
  "vpn_lock",
  "vr180_create2d",
  "vr180_create2d_off",
  "vrpano",
  "wall_art",
  "wall_lamp",
  "wallet",
  "wallpaper",
  "wallpaper_slideshow",
  "ward",
  "warehouse",
  "warning",
  "warning_amber",
  "warning_off",
  "wash",
  "watch",
  "watch_button_press",
  "watch_check",
  "watch_later",
  "watch_off",
  "watch_screentime",
  "watch_vibration",
  "watch_wake",
  "water",
  "water_bottle",
  "water_bottle_large",
  "water_damage",
  "water_do",
  "water_drop",
  "water_ec",
  "water_full",
  "water_heater",
  "water_lock",
  "water_loss",
  "water_lux",
  "water_medium",
  "water_orp",
  "water_ph",
  "water_pump",
  "water_voc",
  "waterfall_chart",
  "waves",
  "waving_hand",
  "wb_auto",
  "wb_cloudy",
  "wb_incandescent",
  "wb_iridescent",
  "wb_shade",
  "wb_sunny",
  "wb_twighlight",
  "wb_twilight",
  "wc",
  "weather_hail",
  "weather_mix",
  "weather_snowy",
  "web",
  "web_asset",
  "web_asset_off",
  "web_stories",
  "web_traffic",
  "webhook",
  "weekend",
  "weight",
  "west",
  "whatshot",
  "wheelchair_pickup",
  "where_to_vote",
  "widget_medium",
  "widget_small",
  "widget_width",
  "widgets",
  "width_full",
  "width_normal",
  "width_wide",
  "wifi",
  "wifi_1_bar",
  "wifi_2_bar",
  "wifi_add",
  "wifi_calling",
  "wifi_calling_1",
  "wifi_calling_2",
  "wifi_calling_3",
  "wifi_calling_bar_1",
  "wifi_calling_bar_2",
  "wifi_calling_bar_3",
  "wifi_channel",
  "wifi_find",
  "wifi_home",
  "wifi_lock",
  "wifi_notification",
  "wifi_off",
  "wifi_password",
  "wifi_protected_setup",
  "wifi_proxy",
  "wifi_tethering",
  "wifi_tethering_error",
  "wifi_tethering_off",
  "wind_power",
  "window",
  "window_closed",
  "window_open",
  "window_sensor",
  "wine_bar",
  "woman",
  "woman_2",
  "work",
  "work_alert",
  "work_history",
  "work_off",
  "work_outline",
  "work_update",
  "workspace_premium",
  "workspaces",
  "workspaces_filled",
  "workspaces_outline",
  "wounds_injuries",
  "wrap_text",
  "wrist",
  "wrong_location",
  "wysiwyg",
  "yard",
  "your_trips",
  "youtube_activity",
  "youtube_searched_for",
  "zone_person_alert",
  "zone_person_idle",
  "zone_person_urgent",
  "zoom_in",
  "zoom_in_map",
  "zoom_out",
  "zoom_out_map"
];
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  __name: "Icon",
  props: {
    icon: {},
    name: {},
    size: {},
    color: {},
    weight: {}
  },
  setup(__props) {
    const props2 = __props;
    const iconRender = computed(() => props2.icon || props2.name);
    const iconRenderType = computed(() => {
      if (MATERIAL_ICONS.includes(iconRender.value)) return "material";
      if (FONT_AWESOME_ICONS.includes(iconRender.value) || FONT_AWESOME_BRANDS_ICONS.includes(iconRender.value)) return "font-awesome";
      return "material";
    });
    const isFaBrand = computed(() => FONT_AWESOME_BRANDS_ICONS.includes(iconRender.value));
    return (_ctx, _cache) => {
      return iconRenderType.value === "material" ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "bgl_icon-font",
        style: normalizeStyle({ "fontSize": `${_ctx.size}rem`, color: _ctx.color, "font-variation-settings": `'wght' ${_ctx.weight || 400}` })
      }, toDisplayString(iconRender.value), 5)) : iconRenderType.value === "font-awesome" ? (openBlock(), createElementBlock("span", {
        key: 1,
        class: normalizeClass(["fa far bgl_icon-font", [`fa-${iconRender.value}`, { "fa-brands": isFaBrand.value }]]),
        style: normalizeStyle({ "fontSize": `${_ctx.size}rem`, color: _ctx.color, "font-variation-settings": `'wght' ${_ctx.weight || 400}` })
      }, null, 6)) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$l = ["src", "title", "width", "height", "marginwidth", "marginheight", "csp", "scrolling", "srcset"];
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "IframeVue",
  props: {
    src: {},
    title: {},
    height: {},
    width: {},
    name: {},
    sandbox: {},
    allow: {},
    allowfullscreen: { type: Boolean },
    loading: {},
    referrerpolicy: {},
    marginwidth: {},
    marginheight: {},
    scrolling: {},
    csp: {},
    srcset: {}
  },
  emits: ["message", "load"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit2 = __emit;
    const iframe = ref();
    function handleMessage(event) {
      emit2("message", event.data);
    }
    function handleMessageWrapper(event) {
      var _a;
      if (event.source === ((_a = iframe.value) == null ? void 0 : _a.contentWindow)) {
        handleMessage(event);
      }
    }
    onMounted(() => {
      window.addEventListener("message", handleMessageWrapper);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("message", handleMessageWrapper);
    });
    const contentWindow = () => {
      var _a;
      return (_a = iframe.value) == null ? void 0 : _a.contentWindow;
    };
    __expose({ contentWindow });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("iframe", {
        ref_key: "iframe",
        ref: iframe,
        src: _ctx.src,
        title: _ctx.title,
        frameborder: "none",
        width: _ctx.width,
        height: _ctx.height,
        allowpaymentrequest: "true",
        marginwidth: _ctx.marginwidth,
        marginheight: _ctx.marginheight,
        csp: _ctx.csp,
        scrolling: _ctx.scrolling,
        srcset: _ctx.srcset,
        onLoad: _cache[0] || (_cache[0] = ($event) => emit2("load", $event))
      }, null, 40, _hoisted_1$l);
    };
  }
});
const _hoisted_1$k = { key: 0 };
const _hoisted_2$b = ["src", "alt", "width", "height"];
const _hoisted_3$9 = ["src", "alt", "width", "height"];
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  __name: "Image",
  props: {
    src: {},
    pathKey: {},
    alt: {},
    width: {},
    height: {},
    caption: {}
  },
  setup(__props) {
    const props2 = __props;
    let imageSrc = ref(void 0);
    let loadingError = ref(false);
    function getImageUrl() {
      if (!props2.src && !props2.pathKey) return;
      return pathKeyToURL(props2.src || props2.pathKey);
    }
    async function getCachedImage(url) {
      if (!("caches" in window)) return void 0;
      try {
        const imgCache = await window.caches.open("img-cache");
        const cachedResponse = await imgCache.match(url);
        if (cachedResponse) {
          return URL.createObjectURL(await cachedResponse.blob());
        }
      } catch (error) {
        console.warn("Cache access error:", error);
      }
      return void 0;
    }
    async function cacheImage(url, blob) {
      if (!("caches" in window)) return;
      try {
        const imgCache = await window.caches.open("img-cache");
        await imgCache.put(url, new Response(blob));
      } catch (error) {
        console.warn("Cache write error:", error);
      }
    }
    async function convertHeicImage(url) {
      await appendScript("https://cdnjs.cloudflare.com/ajax/libs/heic2any/0.0.1/index.min.js");
      const response = await fetch(normalizeURL(url));
      const blob = await response.blob();
      const convertedBlob = await window.heic2any({ blob });
      await cacheImage(url, convertedBlob);
      return URL.createObjectURL(convertedBlob);
    }
    async function loadImage() {
      var _a;
      loadingError.value = false;
      const url = getImageUrl();
      if (!url) {
        imageSrc.value = void 0;
        return;
      }
      try {
        const ext = (_a = url.split(".").pop()) == null ? void 0 : _a.toLowerCase().split("?")[0];
        if (ext === "heic") {
          const cachedSrc = await getCachedImage(url);
          if (cachedSrc) {
            imageSrc.value = cachedSrc;
            return;
          }
          imageSrc.value = await convertHeicImage(url);
        } else {
          imageSrc.value = url;
        }
      } catch (error) {
        console.error("Image loading error:", error);
        loadingError.value = true;
        imageSrc.value = void 0;
      }
    }
    watch(() => [props2.src, props2.pathKey], loadImage, { immediate: true });
    return (_ctx, _cache) => {
      return _ctx.caption ? (openBlock(), createElementBlock("figcaption", _hoisted_1$k, [
        unref(imageSrc) ? (openBlock(), createElementBlock("img", mergeProps({
          key: 0,
          src: unref(imageSrc)
        }, _ctx.$attrs, {
          alt: _ctx.alt,
          width: unref(normalizeDimension)(_ctx.width),
          height: unref(normalizeDimension)(_ctx.height)
        }), null, 16, _hoisted_2$b)) : (openBlock(), createBlock(unref(Skeleton), {
          key: 1,
          class: "img-web-kit",
          width: unref(normalizeDimension)(_ctx.width),
          height: unref(normalizeDimension)(_ctx.height)
        }, null, 8, ["width", "height"]))
      ])) : unref(imageSrc) ? (openBlock(), createElementBlock("img", mergeProps({
        key: 1,
        src: unref(imageSrc)
      }, _ctx.$attrs, {
        alt: _ctx.alt,
        width: unref(normalizeDimension)(_ctx.width),
        height: unref(normalizeDimension)(_ctx.height)
      }), null, 16, _hoisted_3$9)) : unref(loadingError) ? (openBlock(), createElementBlock("div", {
        key: 2,
        class: "flex-center error-image",
        style: normalizeStyle({
          width: unref(normalizeDimension)(_ctx.width),
          height: unref(normalizeDimension)(_ctx.height)
        })
      }, [
        createVNode(unref(_sfc_main$s), { name: "broken_image" })
      ], 4)) : (openBlock(), createBlock(unref(Skeleton), {
        key: 3,
        class: "img-web-kit",
        width: unref(normalizeDimension)(_ctx.width),
        height: unref(normalizeDimension)(_ctx.height)
      }, null, 8, ["width", "height"]));
    };
  }
});
const Image$1 = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["__scopeId", "data-v-2f5e271c"]]);
const _hoisted_1$j = { class: "m-0 pb-025 txt10 line-height-1 w60 menu-text" };
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "BottomMenu",
  props: {
    navLinks: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$10), { class: "hide m_grid gap-05 bgl_bottombar px-1 txt14 justify-content-start align-items-center overflow-x" }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "brand", {}, void 0, true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navLinks, (nav, i2) => {
            return openBlock(), createBlock(unref(Btn), {
              key: i2,
              to: nav.to,
              class: "m_h-auto",
              onClick: nav.onClick
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$s), {
                  icon: nav.icon,
                  size: 1.4,
                  class: "m-0 line-height-14"
                }, null, 8, ["icon"]),
                createElementVNode("p", _hoisted_1$j, toDisplayString(nav.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "onClick"]);
          }), 128)),
          renderSlot(_ctx.$slots, "end", {}, void 0, true)
        ]),
        _: 3
      });
    };
  }
});
const BottomMenu = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["__scopeId", "data-v-2227f9cc"]]);
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "Layout",
  props: {
    gap: { default: 1 },
    h100: { type: Boolean, default: false },
    columns: { default: () => [] },
    mColumns: { default: () => [] },
    mRows: { default: () => [] },
    rows: { default: () => [] }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "16111f2e": gapSize.value,
      "2c189afc": gridTemplateRows.value,
      "243c3a94": gridTemplateColumns.value,
      "84a9b646": mGridTemplateRows.value,
      "55be334e": mGridTemplateColumns.value
    }));
    const props2 = __props;
    const gridTemplateRows = computed(() => props2.rows.length > 0 ? props2.rows.join(" ") : "auto");
    const gapSize = computed(() => `${props2.gap}rem`);
    const mGridTemplateRows = computed(() => {
      var _a;
      if ((_a = props2.mRows) == null ? void 0 : _a.length) return props2.mRows.join(" ");
      return gridTemplateRows.value;
    });
    const gridTemplateColumns = computed(() => props2.columns.length > 0 ? props2.columns.join(" ") : "auto");
    const mGridTemplateColumns = computed(() => {
      var _a;
      if ((_a = props2.mColumns) == null ? void 0 : _a.length) return props2.mColumns.join(" ");
      return gridTemplateColumns.value;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["layout", { "layout-h-100": _ctx.h100 }])
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 2);
    };
  }
});
const Layout = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["__scopeId", "data-v-1814129a"]]);
const _hoisted_1$i = { key: 0 };
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "SidebarMenu",
  props: {
    navLinks: {},
    expandable: { type: Boolean },
    open: { type: Boolean }
  },
  emits: ["update:open"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const slots = useSlots();
    let isOpen = ref(props2.open);
    const toggleMenu = useDebounceFn(() => {
      isOpen.value = !isOpen.value;
      emit2("update:open", isOpen.value);
    });
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["vh-100 relative p-05 bgl_sidebar", { wideNav: unref(isOpen) }])
      }, [
        createVNode(unref(Btn), {
          thin: "",
          color: "white",
          class: "mb-05 absolute toggleNav z-2 border",
          icon: "keyboard_arrow_right",
          onClick: unref(toggleMenu)
        }, null, 8, ["onClick"]),
        createVNode(unref(_sfc_main$10), { class: "py-1 px-05 h-100 flex column gap-05 rounded relative bg-primary font-light overflow-y" }, {
          default: withCtx(() => [
            !unref(isOpen) || !unref(slots)["brand-open"] ? renderSlot(_ctx.$slots, "brand", { key: 0 }, void 0, true) : createCommentVNode("", true),
            unref(isOpen) ? renderSlot(_ctx.$slots, "brand-open", { key: 1 }, void 0, true) : createCommentVNode("", true),
            !_ctx.navLinks ? renderSlot(_ctx.$slots, "default", { key: 2 }, void 0, true) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navLinks, (nav, i2) => {
              return withDirectives((openBlock(), createBlock(unref(Btn), {
                key: i2,
                to: nav.to,
                class: "nav-button px-075 me-auto w-100"
              }, {
                default: withCtx(() => [
                  createVNode(unref(_sfc_main$s), {
                    icon: nav.icon,
                    size: 1.4
                  }, null, 8, ["icon"]),
                  createVNode(Transition, { name: "showP" }, {
                    default: withCtx(() => [
                      _ctx.open ? (openBlock(), createElementBlock("p", _hoisted_1$i, toDisplayString(nav.label), 1)) : createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["to"])), [
                [
                  _directive_tooltip,
                  {
                    content: nav.label,
                    disabled: _ctx.open
                  },
                  void 0,
                  { right: true }
                ]
              ]);
            }), 128)),
            _cache[0] || (_cache[0] = createElementVNode("div", { style: { "flex-grow": "1" } }, null, -1)),
            renderSlot(_ctx.$slots, "footer", {}, void 0, true)
          ]),
          _: 3
        })
      ], 2);
    };
  }
});
const SidebarMenu = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["__scopeId", "data-v-951fdacc"]]);
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "Skeleton",
  props: {
    count: { default: 1 },
    height: {},
    width: {},
    round: { type: Boolean, default: false },
    borderRadius: { default: "var(--skeleton-radius)" },
    class: { default: "" }
  },
  setup(__props) {
    const className = toRef(__props, "class");
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(true), createElementBlock(Fragment, null, renderList(+_ctx.count, (i2) => {
        return openBlock(), createElementBlock(Fragment, { key: i2 }, [
          unref(slots).default ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["skeleton-wrap", className.value])
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 2)) : (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(["skeleton", { round: _ctx.round, [className.value]: true }]),
            style: normalizeStyle({ height: _ctx.height, width: _ctx.width, borderRadius: _ctx.borderRadius })
          }, null, 6))
        ], 64);
      }), 128);
    };
  }
});
const Skeleton = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["__scopeId", "data-v-8788ed73"]]);
const _hoisted_1$h = { class: "bgl_card tabs-top" };
const _hoisted_2$a = { class: "tabs grid auto-flow-columns fit-content" };
const _hoisted_3$8 = ["onClick"];
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "TabbedLayout",
  props: {
    title: {},
    tabs: {},
    modelValue: {},
    router: {},
    sideTabs: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    let activeTab = ref();
    function changeTab(tab) {
      activeTab.value = tab;
      emit2("update:modelValue", activeTab.value);
      if (!props2.router) return;
      void props2.router.push({
        path: props2.router.currentRoute.value.path,
        query: { ...props2.router.currentRoute.value.query, t: tab },
        hash: props2.router.currentRoute.value.hash
      });
    }
    onMounted(() => {
      var _a;
      const firstTab = props2.modelValue || ((_a = props2.router) == null ? void 0 : _a.currentRoute.value.query.t) || props2.tabs[0];
      activeTab.value = firstTab;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["h-100 grid list-view gap-1", { "side-tabs": _ctx.sideTabs }])
      }, [
        createElementVNode("div", _hoisted_1$h, [
          renderSlot(_ctx.$slots, "top-section", {}, void 0, true),
          createElementVNode("div", _hoisted_2$a, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tabs, (tab) => {
              var _a;
              return openBlock(), createElementBlock("div", {
                key: tab,
                class: normalizeClass([{
                  active: tab === unref(activeTab) || tab === ((_a = _ctx.router) == null ? void 0 : _a.currentRoute.value.path.split("/").slice(-1)[0])
                }, "tab"]),
                onClick: ($event) => changeTab(tab)
              }, toDisplayString(tab), 11, _hoisted_3$8);
            }), 128))
          ])
        ]),
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tabs.filter((item) => item === unref(activeTab)), (tab) => {
          return openBlock(), createElementBlock("div", {
            key: tab,
            class: "list-content"
          }, [
            renderSlot(_ctx.$slots, tab, { key: tab }, void 0, true)
          ]);
        }), 128))
      ], 2);
    };
  }
});
const TabbedLayout = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["__scopeId", "data-v-915732c1"]]);
const state = reactive(/* @__PURE__ */ new Map());
function useTabs(group) {
  if (!state.has(group)) {
    state.set(group, reactive({ currentTab: void 0 }));
  }
  const currentTab = computed({
    get: () => state.get(group).currentTab,
    set: (val) => {
      state.get(group).currentTab = val;
    }
  });
  return { currentTab };
}
const _hoisted_1$g = { key: 0 };
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "Tabs",
  props: {
    tabs: {},
    modelValue: {},
    flat: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const slots = useSlots();
    const group = Math.random().toString(36).slice(7);
    const { currentTab } = useTabs(group);
    const tabValue = (tab) => typeof tab === "string" ? tab : tab.id;
    const slctTab = computed({
      get: () => props2.modelValue || tabValue(props2.tabs[0]),
      set: (value) => {
        emit2("update:modelValue", value);
      }
    });
    const tabComponent = defineComponent({
      render() {
        var _a, _b;
        const currentTabIndex = props2.tabs.findIndex(
          (tab) => tabValue(tab) === currentTab.value
        );
        if (currentTabIndex === -1) return;
        const slotChildren = (_b = (_a = slots.default) == null ? void 0 : _a.call(slots)[1]) == null ? void 0 : _b.children;
        return h$2("div", slotChildren[currentTabIndex]);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(TabsNav), {
          modelValue: slctTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => slctTab.value = $event),
          flat: _ctx.flat,
          tabs: _ctx.tabs,
          group: unref(group),
          class: "mb-05"
        }, null, 8, ["modelValue", "flat", "tabs", "group"]),
        unref(currentTab) ? (openBlock(), createElementBlock("div", _hoisted_1$g, [
          unref(slots)[unref(currentTab)] ? renderSlot(_ctx.$slots, unref(currentTab), { key: 0 }) : unref(currentTab) ? (openBlock(), createBlock(resolveDynamicComponent(unref(tabComponent)), { key: 1 })) : createCommentVNode("", true)
        ])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "TabsBody",
  props: {
    group: {}
  },
  setup(__props) {
    const props2 = __props;
    const { currentTab } = useTabs(props2.group);
    return (_ctx, _cache) => {
      return unref(currentTab) ? renderSlot(_ctx.$slots, unref(currentTab), { key: 0 }) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$f = ["onClick"];
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "TabsNav",
  props: {
    title: {},
    tabs: {},
    modelValue: {},
    sideTabs: { type: Boolean },
    group: {},
    flat: { type: Boolean },
    vertical: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const { currentTab } = useTabs(props2.group);
    currentTab.value = props2.modelValue || typeof props2.tabs[0] === "string" ? props2.tabs[0] : props2.tabs[0].id;
    const tabsWrap = ref(void 0);
    const tabs = ref([]);
    function updateIndicator() {
      nextTick(() => {
        if (!tabsWrap.value) return;
        const activeTab = tabs.value.find((tab) => tab.classList.contains("active"));
        if (activeTab) {
          const { offsetLeft, offsetWidth } = activeTab;
          tabsWrap.value.style.setProperty("--indicator-left", `${offsetLeft}px`);
          tabsWrap.value.style.setProperty("--indicator-width", `${offsetWidth}px`);
        }
      });
    }
    function selectTab(tab) {
      currentTab.value = typeof tab === "string" ? tab : tab.id;
      emit2("update:modelValue", currentTab.value);
      nextTick(() => {
        updateIndicator();
      });
    }
    function isActive(tab) {
      if (typeof tab === "string") return currentTab.value === tab;
      return currentTab.value === tab.id;
    }
    function tabLabel(tab) {
      if (typeof tab === "string") return tab;
      return tab.label;
    }
    watch(
      () => props2.modelValue,
      (value) => {
        if (value && !isActive(value)) currentTab.value = value;
        nextTick(() => {
          updateIndicator();
        });
      },
      { immediate: true }
    );
    onMounted(() => {
      var _a;
      tabs.value = Array.from(((_a = tabsWrap.value) == null ? void 0 : _a.querySelectorAll(".bgl_tab")) || []);
      updateIndicator();
      window.addEventListener("resize", updateIndicator);
    });
    watch(
      () => tabs.value,
      () => {
        nextTick(() => {
          updateIndicator();
        });
      },
      { deep: true }
    );
    onBeforeUnmount(() => {
      window.removeEventListener("resize", updateIndicator);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "tabsWrap",
        ref: tabsWrap,
        class: normalizeClass(["grid auto-flow-columns relative fit-content bgl_tabs_wrap overflow-hidden", { "bgl_flat-tabs": _ctx.flat, "bgl_vertical-tabs": _ctx.vertical }])
      }, [
        renderSlot(_ctx.$slots, "tabs", normalizeProps(guardReactiveProps({ selectTab, isActive, tabLabel, tabs: tabs.value })), () => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props2.tabs, (tab, i2) => {
            return openBlock(), createElementBlock("button", {
              key: i2,
              type: "button",
              class: normalizeClass([{ active: isActive(tab) }, "bgl_tab relative z-1"]),
              onClick: ($event) => selectTab(tab)
            }, [
              typeof tab !== "string" && tab.icon ? (openBlock(), createBlock(unref(_sfc_main$s), {
                key: 0,
                icon: tab.icon
              }, null, 8, ["icon"])) : createCommentVNode("", true),
              createTextVNode(" " + toDisplayString(tabLabel(tab)), 1)
            ], 10, _hoisted_1$f);
          }), 128))
        ], true)
      ], 2);
    };
  }
});
const TabsNav = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["__scopeId", "data-v-6ece2018"]]);
const _hoisted_1$e = {
  key: 0,
  class: "txt10 no-margin txt-gray ellipsis"
};
const _hoisted_2$9 = { class: "no-margin ellipsis line-height-14 pb-025" };
const _hoisted_3$7 = {
  key: 1,
  class: "txt12 no-margin txt-gray ellipsis"
};
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "ListItem",
  props: {
    src: {},
    showAvatar: { type: Boolean },
    to: {},
    href: {},
    icon: {},
    title: {},
    subtitle: {},
    flat: { type: Boolean },
    disabled: { type: Boolean },
    lead: {},
    iconEnd: {},
    target: {},
    onClick: { type: Function }
  },
  setup(__props) {
    const props2 = __props;
    const isComponent = computed(() => {
      if (props2.to) return "router-link";
      if (props2.href) return "a";
      if (props2.onClick) return "button";
      return "div";
    });
    const bind3 = computed(() => {
      const obj = {};
      if (props2.to) obj.to = props2.to;
      else if (props2.href) obj.href = props2.href;
      if (props2.target && (props2.to || props2.href)) obj.target = props2.target;
      obj.class = {
        "notClickable": !(props2.to || props2.onClick),
        "no-border-list": props2.flat
      };
      if (props2.disabled) obj.disabled = true;
      return obj;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(isComponent.value), mergeProps(bind3.value, {
        class: "flex gap-05 list-item",
        onClick: _ctx.onClick
      }), {
        default: withCtx(() => [
          _ctx.src || _ctx.showAvatar ? (openBlock(), createBlock(unref(Avatar), {
            key: 0,
            style: { "flex-basis": "1" },
            name: _ctx.title,
            src: _ctx.src,
            size: 40
          }, null, 8, ["name", "src"])) : createCommentVNode("", true),
          _ctx.icon ? (openBlock(), createBlock(unref(_sfc_main$s), {
            key: 1,
            size: "1.2",
            class: "color-primary",
            icon: _ctx.icon
          }, null, 8, ["icon"])) : createCommentVNode("", true),
          createElementVNode("div", null, [
            _ctx.lead ? (openBlock(), createElementBlock("p", _hoisted_1$e, [
              createTextVNode(toDisplayString(_ctx.lead) + " ", 1),
              renderSlot(_ctx.$slots, "lead")
            ])) : createCommentVNode("", true),
            createElementVNode("p", _hoisted_2$9, [
              createTextVNode(toDisplayString(_ctx.title) + " ", 1),
              renderSlot(_ctx.$slots, "default")
            ]),
            _ctx.subtitle ? (openBlock(), createElementBlock("p", _hoisted_3$7, [
              createTextVNode(toDisplayString(_ctx.subtitle) + " ", 1),
              renderSlot(_ctx.$slots, "subtitle")
            ])) : createCommentVNode("", true)
          ]),
          _ctx.iconEnd ? (openBlock(), createBlock(unref(_sfc_main$s), {
            key: 2,
            icon: _ctx.iconEnd,
            class: "transition-400"
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["onClick"]);
    };
  }
});
const _sfc_main$g = {};
const _hoisted_1$d = { class: "list-wrap bgl_card thin grid overflow-hidden pt-0 pb-05 px-0 m_pb-0" };
const _hoisted_2$8 = { class: "p-0" };
const _hoisted_3$6 = { class: "list-content auto-flow-rows align-items-start overflow-y h-100" };
function _sfc_render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$d, [
    createElementVNode("div", _hoisted_2$8, [
      renderSlot(_ctx.$slots, "header")
    ]),
    createElementVNode("div", _hoisted_3$6, [
      renderSlot(_ctx.$slots, "default")
    ])
  ]);
}
const ListView = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$3]]);
const _hoisted_1$c = { class: "flex-center" };
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "Loading",
  props: {
    size: { default: 50 },
    thickness: {},
    duration: { default: 1.2 },
    type: { default: "ring" },
    color: {}
  },
  setup(__props) {
    const theme = toRef(__props, "type");
    function standardSize(value, unit2 = "px") {
      if (!value) return `${__props.size}${unit2}`;
      return typeof value === "number" ? `${value}${unit2}` : value.endsWith(unit2) ? value : `${value}${unit2}`;
    }
    const computedSize = computed(() => standardSize(__props.size));
    const animationDuration = computed(() => `${__props.duration}s`);
    const computedBorder = computed(() => {
      const borderValue = __props.thickness ?? Math.max(Number.parseInt(computedSize.value) / 9, 2);
      return standardSize(borderValue);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$c, [
        theme.value === "bar" ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "lds-bar",
          style: normalizeStyle({ animationDuration: animationDuration.value, color: _ctx.color })
        }, null, 4)) : createCommentVNode("", true),
        theme.value === "ellipsis" ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "lds-ellipsis",
          style: normalizeStyle({ "--size": computedSize.value })
        }, [
          (openBlock(), createElementBlock(Fragment, null, renderList(4, (n2) => {
            return createElementVNode("div", {
              key: n2,
              style: normalizeStyle({ color: _ctx.color, "--size": computedSize.value })
            }, null, 4);
          }), 64))
        ], 4)) : createCommentVNode("", true),
        theme.value === "ring" ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: "lds-ring",
          style: normalizeStyle({ "--size": computedSize.value, "--thickness": computedBorder.value })
        }, [
          (openBlock(), createElementBlock(Fragment, null, renderList(4, (n2) => {
            return createElementVNode("div", {
              key: n2,
              style: normalizeStyle({
                color: _ctx.color,
                "width": computedSize.value,
                "height": computedSize.value,
                "borderWidth": computedBorder.value,
                "--animation-duration": animationDuration.value,
                "--size": computedSize.value,
                "--thickness": computedBorder.value
              })
            }, null, 4);
          }), 64))
        ], 4)) : createCommentVNode("", true)
      ]);
    };
  }
});
const Loading = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["__scopeId", "data-v-221a3053"]]);
const _hoisted_1$b = ["id"];
const defaultMarkerSVG = '<svg width="28" height="38" viewBox="0 0 28 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.2263 37.7955C17.0897 37.7955 19.4109 37.0138 19.4109 36.0496C19.4109 35.0854 17.0897 34.3037 14.2263 34.3037C11.363 34.3037 9.04175 35.0854 9.04175 36.0496C9.04175 37.0138 11.363 37.7955 14.2263 37.7955Z" fill="black" fill-opacity="0.1"/><path d="M14.2265 0.549591C21.2842 0.549591 27.0131 6.23786 27.0787 13.28V13.4024C27.0787 19.3328 24.4759 24.4306 21.5627 28.2764C18.6511 32.12 15.4577 34.6754 14.3457 35.5097C14.2748 35.5629 14.1778 35.5629 14.1068 35.5097C12.9947 34.675 9.80135 32.1197 6.88984 28.2762C3.97665 24.4304 1.37378 19.3328 1.37378 13.4024C1.37378 6.30387 7.12806 0.549591 14.2265 0.549591Z" fill="#ED1b3E" stroke="#ED6C6F"/><path d="M14.2263 21.6185C18.7639 21.6185 22.4424 17.94 22.4424 13.4024C22.4424 8.86477 18.7639 5.18631 14.2263 5.18631C9.68872 5.18631 6.01025 8.86477 6.01025 13.4024C6.01025 17.94 9.68872 21.6185 14.2263 21.6185Z" fill="white"/></svg>';
const leafletScriptUrl = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "Index",
  props: {
    center: { default: () => [31.7683, 35.2137] },
    zoom: { default: 15 },
    height: { default: 400 },
    zoomControl: { type: Boolean, default: true },
    markers: {},
    markerIcon: { default: "" }
  },
  emits: ["select"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    let L2 = ref();
    let map3 = ref();
    const _markers = ref([]);
    const id = ref(Math.random().toString(36).slice(2, 10));
    async function loadGlobalL() {
      while (!window.L) await sleep(100);
      return window.L;
    }
    async function initializeMap() {
      await appendScript(leafletScriptUrl);
      L2.value = await loadGlobalL();
      if (!map3.value) {
        map3.value = L2.value.map(id.value, {
          center: props2.center,
          zoom: props2.zoom,
          zoomControl: props2.zoomControl
        });
        L2.value.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 18 }).addTo(map3.value);
      }
    }
    async function addMarker(marker) {
      var _a, _b;
      const iconSVG = props2.markerIcon || defaultMarkerSVG;
      const icon = (_a = L2.value) == null ? void 0 : _a.icon({
        iconUrl: `data:image/svg+xml;utf8,${encodeURIComponent(iconSVG)}`,
        iconSize: [32, 32]
      });
      const latlng = latLangFromMarker(marker);
      const title = Array.isArray(marker) ? marker[2] : marker.title ?? marker.tooltip;
      const tooltip = Array.isArray(marker) ? marker[2] : marker.tooltip;
      const m2 = (_b = L2.value) == null ? void 0 : _b.marker(latlng, { title, icon, interactive: true }).addTo(map3.value);
      if (tooltip) m2.bindTooltip(tooltip, { direction: "top" });
      m2.on("click", () => {
        emit2("select", marker);
      });
      _markers.value.push(m2);
    }
    function fitMarkers(L22) {
      var _a, _b;
      if (_markers.value.length > 0) {
        const latLngs = _markers.value.map((marker) => marker.getLatLng());
        const bounds = L22.latLngBounds(latLngs);
        const center2 = bounds.getCenter();
        (_a = map3.value) == null ? void 0 : _a.setView(center2, props2.zoom);
        (_b = map3.value) == null ? void 0 : _b.fitBounds(bounds, {
          animate: true,
          padding: [20, 20]
          // Adjust padding as needed
        });
      }
    }
    function latLangFromMarker(marker) {
      const [lat, lng] = Array.isArray(marker) ? [marker[0], marker[1]] : [marker.lat, marker.lng];
      return { lat: +lat, lng: +lng };
    }
    async function watchMarkers(markers) {
      if (!L2.value) L2.value = await loadGlobalL();
      _markers.value.forEach((marker) => marker.remove());
      if (!markers) return;
      for (const marker of markers) {
        if (!map3.value) await initializeMap();
        addMarker(marker);
      }
      fitMarkers(L2.value);
    }
    watch(() => props2.markers, watchMarkers, { immediate: true });
    watch(() => props2.center, (center2) => {
      var _a;
      return (_a = map3.value) == null ? void 0 : _a.setView(center2, props2.zoom);
    }, { immediate: true });
    onMounted(initializeMap);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: id.value,
        class: "leaflet-map",
        style: normalizeStyle({ height: `${props2.height || 400}px` }),
        dir: "ltr"
      }, null, 12, _hoisted_1$b);
    };
  }
});
const _hoisted_1$a = {
  key: 0,
  class: "tool-bar"
};
const _hoisted_2$7 = {
  key: 1,
  class: "sticky z-index-999 -mt-1 -ms-1 px-025 h-30px pt-025 modal-no-title"
};
const _hoisted_3$5 = {
  key: 2,
  class: "modal-footer mt-1"
};
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "Modal",
  props: {
    thin: { type: Boolean },
    side: { type: Boolean },
    title: {},
    width: {},
    dismissable: { type: Boolean },
    actions: {},
    visible: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const slots = useSlots();
    let isVisible = ref(false);
    watch(
      () => props2.visible,
      (val) => {
        if (val === isVisible.value || val === void 0) return;
        if (val) openModal();
        else closeModal();
      },
      { immediate: true }
    );
    const maxWidth = computed(() => {
      const { width } = props2;
      if (width == null ? void 0 : width.match(/px|em|rem|vw|vh|%/)) return { "max-width": width };
      if (width == null ? void 0 : width.match(/\d+/)) return { "max-width": `${width}px` };
      return { "max-width": "720px" };
    });
    function closeModal() {
      isVisible.value = false;
      setTimeout(() => {
        emit2("update:visible", false);
      }, 200);
    }
    __expose({ closeModal });
    const escapeKeyClose = (e) => props2.dismissable && useEscape(e, () => {
      closeModal();
    });
    function openModal() {
      setTimeout(() => isVisible.value = true, 1);
    }
    onMounted(() => {
      document.addEventListener("keydown", escapeKeyClose);
    });
    onUnmounted(() => {
      document.removeEventListener("keydown", escapeKeyClose);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["bg-dark", { "is-side": _ctx.side, "is-active": unref(isVisible), "bg-lignt": false }]),
        onClick: _cache[1] || (_cache[1] = () => _ctx.dismissable ? closeModal() : ""),
        onKeydown: withKeys(closeModal, ["esc"])
      }, [
        createVNode(unref(_sfc_main$10), {
          class: "modal",
          style: normalizeStyle({ ...maxWidth.value }),
          thin: _ctx.thin,
          onClick: _cache[0] || (_cache[0] = withModifiers(() => {
          }, ["stop"]))
        }, {
          default: withCtx(() => {
            var _a;
            return [
              unref(slots).toolbar || _ctx.title ? (openBlock(), createElementBlock("header", _hoisted_1$a, [
                renderSlot(_ctx.$slots, "toolbar"),
                createVNode(unref(Btn), {
                  style: normalizeStyle({ float: _ctx.side ? "left" : "right" }),
                  flat: "",
                  icon: "close",
                  thin: "",
                  onClick: closeModal
                }, null, 8, ["style"]),
                _ctx.title ? (openBlock(), createBlock(unref(_sfc_main$4), {
                  key: 0,
                  class: "modal-title",
                  tag: "h3",
                  label: _ctx.title
                }, null, 8, ["label"])) : createCommentVNode("", true)
              ])) : (openBlock(), createElementBlock("div", _hoisted_2$7, [
                createVNode(unref(Btn), {
                  class: "position-start",
                  icon: "close",
                  thin: "",
                  round: "",
                  color: "white",
                  onClick: closeModal
                })
              ])),
              renderSlot(_ctx.$slots, "default"),
              unref(slots).footer || ((_a = _ctx.actions) == null ? void 0 : _a.length) ? (openBlock(), createElementBlock("footer", _hoisted_3$5, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.actions, (action, i2) => {
                  return openBlock(), createBlock(unref(Btn), mergeProps({
                    key: i2,
                    color: "gray",
                    ref_for: true
                  }, action, { onClick: closeModal }), null, 16);
                }), 128)),
                renderSlot(_ctx.$slots, "footer")
              ])) : createCommentVNode("", true)
            ];
          }),
          _: 3
        }, 8, ["style", "thin"])
      ], 34);
    };
  }
});
const _hoisted_1$9 = { class: "pb-05 pretty" };
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "ModalConfirm",
  props: {
    title: {},
    message: {},
    confirmText: {},
    confirmBtnColor: {},
    cancelBtnColor: {},
    cancelText: {},
    resolve: { type: Function }
  },
  emits: ["update:visible"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    function select2(val) {
      props2.resolve(val);
      emit2("update:visible");
    }
    const title = props2.title || "Confirm";
    const message = props2.message || "Are you sure you want to continue?";
    const confirmText = props2.confirmText || "Confirm";
    const cancelText = props2.cancelText || "Cancel";
    const confirmBtnColor = props2.confirmBtnColor || "green";
    const cancelBtnColor = props2.cancelBtnColor || "gray";
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$d), {
        title: unref(title),
        width: "380px",
        dismissable: false,
        class: "txt-center"
      }, {
        footer: withCtx(() => [
          createVNode(unref(Btn), {
            color: unref(cancelBtnColor),
            value: unref(cancelText),
            onClick: _cache[0] || (_cache[0] = ($event) => select2(false))
          }, null, 8, ["color", "value"]),
          createVNode(unref(Btn), {
            color: unref(confirmBtnColor),
            value: unref(confirmText),
            onClick: _cache[1] || (_cache[1] = ($event) => select2(true))
          }, null, 8, ["color", "value"])
        ]),
        default: withCtx(() => [
          createElementVNode("p", _hoisted_1$9, toDisplayString(unref(message)), 1)
        ]),
        _: 1
      }, 8, ["title"]);
    };
  }
});
const _hoisted_1$8 = { class: "flex gap-0" };
const _hoisted_2$6 = { class: "flex gap-05" };
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "ModalForm",
  props: /* @__PURE__ */ mergeModels({
    schema: {},
    modelValue: {},
    "onUpdate:modelValue": { type: Function },
    onSubmit: { type: Function },
    onDelete: { type: Function },
    onDuplicate: { type: Function },
    submitText: {},
    cancelText: {},
    deleteText: {},
    duplicateText: {},
    onError: { type: Function },
    side: { type: Boolean },
    title: {},
    width: {},
    dismissable: { type: Boolean },
    visible: { type: Boolean },
    actions: {},
    class: {}
  }, {
    "modelValue": {
      default: {}
    },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["update:modelValue", "update:visible"], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const bagel = useBagel();
    const modal = ref();
    const formData = useModel(__props, "modelValue");
    const form = ref();
    const closeModal = () => {
      var _a;
      return (_a = modal.value) == null ? void 0 : _a.closeModal();
    };
    let submitting = ref(false);
    async function runSubmit() {
      var _a, _b, _c;
      if (submitting.value) return;
      if (((_a = form.value) == null ? void 0 : _a.validateForm()) === false) return;
      submitting.value = true;
      try {
        await ((_b = props2.onSubmit) == null ? void 0 : _b.call(props2, formData.value));
        closeModal();
      } catch (err) {
        submitting.value = false;
        if (props2.onError) props2.onError(err);
        else (_c = bagel.onError) == null ? void 0 : _c.call(bagel, err);
      }
    }
    function runDelete() {
      var _a;
      (_a = props2.onDelete) == null ? void 0 : _a.call(props2, formData.value);
      closeModal();
    }
    function setFormValues(values3) {
      Object.assign(formData, values3);
    }
    __expose({ setFormValues });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$d), {
        ref_key: "modal",
        ref: modal,
        side: _ctx.side,
        width: _ctx.width,
        visible: _ctx.visible,
        dismissable: _ctx.dismissable,
        title: _ctx.title,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event) => emit2("update:visible", $event))
      }, createSlots({
        default: withCtx(() => [
          _ctx.visible ? (openBlock(), createBlock(unref(_sfc_main$T), {
            key: 0,
            ref_key: "form",
            ref: form,
            modelValue: formData.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event) => formData.value = $event),
              _cache[1] || (_cache[1] = ($event) => emit2("update:modelValue", $event))
            ],
            schema: _ctx.schema,
            onSubmit: runSubmit
          }, null, 8, ["modelValue", "schema"])) : createCommentVNode("", true)
        ]),
        _: 2
      }, [
        _ctx.onDelete || _ctx.onSubmit ? {
          name: "footer",
          fn: withCtx(() => [
            createElementVNode("div", _hoisted_1$8, [
              createVNode(unref(Btn), {
                thin: "",
                flat: "",
                value: _ctx.cancelText || "Cancel",
                onClick: closeModal
              }, null, 8, ["value"]),
              _ctx.onDelete ? (openBlock(), createBlock(unref(Btn), {
                key: 0,
                thin: "",
                icon: "delete",
                flat: "",
                value: _ctx.deleteText || "Delete",
                color: "red",
                onClick: runDelete
              }, null, 8, ["value"])) : createCommentVNode("", true)
            ]),
            createElementVNode("div", _hoisted_2$6, [
              _ctx.onDuplicate ? (openBlock(), createBlock(unref(Btn), {
                key: 0,
                outline: "",
                class: "px-1",
                icon: "copy_all",
                flat: "",
                value: _ctx.duplicateText || "Duplicate",
                onClick: _cache[2] || (_cache[2] = ($event) => {
                  var _a;
                  return (_a = _ctx.onDuplicate) == null ? void 0 : _a.call(_ctx, formData.value);
                })
              }, null, 8, ["value"])) : createCommentVNode("", true),
              _ctx.onSubmit ? (openBlock(), createBlock(unref(Btn), {
                key: 1,
                value: _ctx.submitText || "Submit",
                onClick: runSubmit
              }, null, 8, ["value"])) : createCommentVNode("", true)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["side", "width", "visible", "dismissable", "title"]);
    };
  }
});
const ModalForm = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["__scopeId", "data-v-1c0f6894"]]);
const _hoisted_1$7 = { class: "full-nav" };
const _hoisted_2$5 = { class: "nav-scroll" };
const _hoisted_3$4 = { class: "nav-links-wrapper" };
const _hoisted_4$4 = { class: "tooltip" };
const _hoisted_5$4 = { class: "bot-buttons-wrapper" };
const _hoisted_6$4 = { class: "tooltip" };
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "NavBar",
  props: {
    footerLinks: { default: () => [] },
    links: { default: () => [] },
    homeIcon: { default: "home" },
    homeLabel: { default: "Home" },
    homeTo: { default: "/" }
  },
  setup(__props) {
    let isOpen = ref(true);
    function calcIsOpen() {
      isOpen.value = window.innerWidth < 1100;
      const storedNavOpenVal = localStorage.getItem("navOpen");
      if (storedNavOpenVal === "true" || storedNavOpenVal === null) isOpen.value = true;
    }
    function toggleMenu() {
      isOpen.value = !isOpen.value;
      localStorage.setItem("navOpen", `${isOpen.value}`);
    }
    onMounted(calcIsOpen);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass({ open: unref(isOpen), closed: !unref(isOpen) })
      }, [
        renderSlot(_ctx.$slots, "top", { isOpen: unref(isOpen) }, void 0, true),
        createElementVNode("div", {
          class: "nav-expend",
          role: "button",
          "aria-label": "Toggle Navigation",
          tabindex: "0",
          onClick: toggleMenu,
          onKeypress: withKeys(toggleMenu, ["enter"])
        }, [
          createVNode(unref(_sfc_main$s), {
            icon: "chevron_right",
            class: "top-arrow"
          })
        ], 32),
        createElementVNode("div", _hoisted_1$7, [
          createElementVNode("div", _hoisted_2$5, [
            createElementVNode("div", _hoisted_3$4, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.links, (link) => {
                return openBlock(), createBlock(resolveDynamicComponent(link.to ? "router-link" : "div"), {
                  key: link.label,
                  class: "nav-button",
                  to: link.to,
                  onClick: ($event) => {
                    var _a;
                    return (_a = link.onClick) == null ? void 0 : _a.call(link);
                  }
                }, {
                  default: withCtx(() => [
                    createVNode(unref(_sfc_main$s), {
                      icon: link.icon
                    }, null, 8, ["icon"]),
                    createElementVNode("div", _hoisted_4$4, toDisplayString(link.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"]);
              }), 128))
            ])
          ]),
          createElementVNode("div", _hoisted_5$4, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.footerLinks, (link) => {
              return openBlock(), createBlock(resolveDynamicComponent(link.to ? "router-link" : "div"), {
                key: link.label,
                class: "nav-button",
                to: link.to,
                onClick: ($event) => {
                  var _a;
                  return (_a = link.onClick) == null ? void 0 : _a.call(link);
                }
              }, {
                default: withCtx(() => [
                  createVNode(unref(_sfc_main$s), {
                    icon: link.icon
                  }, null, 8, ["icon"]),
                  createElementVNode("div", _hoisted_6$4, toDisplayString(link.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "onClick"]);
            }), 128)),
            renderSlot(_ctx.$slots, "floor", {}, void 0, true)
          ])
        ])
      ], 2);
    };
  }
});
const NavBar = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["__scopeId", "data-v-f3df1ee7"]]);
const _hoisted_1$6 = { class: "page-top" };
const _hoisted_2$4 = { class: "top-title m-0" };
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "PageTitle",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$6, [
        createElementVNode("h1", _hoisted_2$4, [
          renderSlot(_ctx.$slots, "default"),
          createTextVNode(" " + toDisplayString(__props.value), 1)
        ])
      ]);
    };
  }
});
const _hoisted_1$5 = ["disabled"];
const _hoisted_2$3 = { class: "bgl_pill-flex" };
const _hoisted_3$3 = {
  key: 0,
  class: "loading"
};
const _hoisted_4$3 = { key: 1 };
const _hoisted_5$3 = {
  key: 0,
  class: "flex h-100"
};
const _hoisted_6$3 = {
  key: 5,
  class: "loading"
};
const _hoisted_7$3 = { key: 6 };
const _hoisted_8$2 = {
  key: 0,
  class: "flex h-100"
};
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "Pill",
  props: {
    disabled: { type: Boolean },
    icon: {},
    iconEnd: {},
    color: {},
    theme: {},
    flat: { type: Boolean },
    border: { type: Boolean },
    outline: { type: Boolean },
    loading: { type: Boolean },
    value: {},
    modelValue: {},
    round: { type: Boolean },
    btn: {},
    btnEnd: {}
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "dbb738e2": computedBackgroundColor.value,
      "418961aa": cumputedTextColor.value
    }));
    const props2 = __props;
    const slots = useSlots();
    const computedTheme = computed(
      () => {
        if (props2.disabled) return "gray-light";
        return props2.color || props2.theme;
      }
    );
    const computedDefaultColors = computed(
      () => ({
        backgroundColor: "var(--bgl-primary)",
        color: props2.flat ? "var(--bgl-text-color)" : "var(--bgl-light-text)"
      })
    );
    function getThemeColors(theme) {
      return {
        ...computedDefaultColors.value,
        ...theme,
        color: props2.flat ? theme.backgroundColor : theme.color
      };
    }
    const themes = {
      "red": getThemeColors({ backgroundColor: "var(--bgl-red)" }),
      "white": getThemeColors({ backgroundColor: "var(--bgl-white)", color: "var(--bgl-black)" }),
      "black": getThemeColors({ backgroundColor: "var(--bgl-black)", color: "var(--bgl-white)" }),
      "green": getThemeColors({ backgroundColor: "var(--bgl-green)", color: "var(--bgl-white)" }),
      "primary": getThemeColors({ backgroundColor: "var(--bgl-primary)", color: "var(--bgl-white)" }),
      "yellow": getThemeColors({ backgroundColor: "var(--bgl-yellow)", color: "var(--bgl-black)" }),
      "gray": getThemeColors({ backgroundColor: "var(--bgl-gray-light)", color: "var(--bgl-black)" }),
      "light": getThemeColors({ backgroundColor: "var(--bgl-primary-light)", color: "var(--bgl-primary)" }),
      "gray-light": getThemeColors({ backgroundColor: "var(--bgl-gray-light)", color: "var(--bgl-gray)" }),
      "blue": getThemeColors({})
    };
    const cumputedTextColor = computed(
      () => {
        var _a;
        return ((_a = themes[computedTheme.value]) == null ? void 0 : _a.color) ?? computedDefaultColors.value.color;
      }
    );
    const computedBackgroundColor = computed(
      () => {
        var _a;
        return ((_a = themes[computedTheme.value]) == null ? void 0 : _a.backgroundColor) ?? computedDefaultColors.value.backgroundColor;
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        disabled: _ctx.disabled,
        class: normalizeClass({
          "bgl_pill": !_ctx.icon || unref(slots).default || _ctx.value,
          round: _ctx.round,
          "bgl_flatPill": _ctx.flat,
          "bgl_pill-border": _ctx.border || _ctx.outline
        })
      }, [
        createElementVNode("div", _hoisted_2$3, [
          _ctx.loading ? (openBlock(), createElementBlock("div", _hoisted_3$3)) : (openBlock(), createElementBlock("div", _hoisted_4$3, [
            _ctx.btn ? (openBlock(), createElementBlock("div", _hoisted_5$3, [
              createVNode(unref(Btn), mergeProps({
                class: "bgl_pill-btn",
                round: "",
                thin: ""
              }, _ctx.btn), null, 16)
            ])) : createCommentVNode("", true)
          ])),
          _ctx.icon ? (openBlock(), createBlock(unref(_sfc_main$s), {
            key: 2,
            icon: _ctx.icon
          }, null, 8, ["icon"])) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "default", {}, void 0, true),
          !unref(slots).default ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
            createTextVNode(toDisplayString(_ctx.value || _ctx.modelValue), 1)
          ], 64)) : createCommentVNode("", true),
          _ctx.iconEnd ? (openBlock(), createBlock(unref(_sfc_main$s), {
            key: 4,
            icon: _ctx.iconEnd
          }, null, 8, ["icon"])) : createCommentVNode("", true),
          _ctx.loading ? (openBlock(), createElementBlock("div", _hoisted_6$3)) : (openBlock(), createElementBlock("div", _hoisted_7$3, [
            _ctx.btnEnd ? (openBlock(), createElementBlock("div", _hoisted_8$2, [
              createVNode(unref(Btn), mergeProps({
                class: "bgl_pill-btn",
                round: "",
                thin: ""
              }, _ctx.btnEnd), null, 16)
            ])) : createCommentVNode("", true)
          ]))
        ])
      ], 10, _hoisted_1$5);
    };
  }
});
const Pill = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__scopeId", "data-v-764b6b8b"]]);
const _sfc_main$7 = {};
function _sfc_render$2(_ctx, _cache) {
  const _component_router_view = resolveComponent("router-view");
  return openBlock(), createBlock(_component_router_view, null, {
    default: withCtx(({ Component, route }) => [
      createVNode(Transition, {
        duration: 300,
        name: "slide-fade",
        mode: "out-in",
        appear: ""
      }, {
        default: withCtx(() => [
          (openBlock(), createBlock(resolveDynamicComponent(Component), {
            key: route == null ? void 0 : route.params.itemID
          }))
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  });
}
const RouterWrapper = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$2]]);
const _hoisted_1$4 = {
  key: 0,
  class: "row-number-header bg-white"
};
const _hoisted_2$2 = { class: "th-content" };
const _hoisted_3$2 = ["onClick"];
const _hoisted_4$2 = ["onMousedown"];
const _hoisted_5$2 = ["onClick"];
const _hoisted_6$2 = ["tabindex", "onMousedown", "onMouseover", "onFocusin", "onDblclick", "onKeydown"];
const _hoisted_7$2 = ["value", "onInput"];
const _hoisted_8$1 = { class: "spreadsheet-cell spreadsheetCellPlaceHolder" };
const _hoisted_9$1 = {
  key: 0,
  class: "h40px w-100p flex align-items-center justify-content-center overflow-hidden"
};
const _hoisted_10$1 = ["src", "alt"];
const _hoisted_11$1 = {
  key: 2,
  class: "spreadsheet-cell"
};
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "SpreadsheetTable",
  props: {
    columns: {},
    rows: {},
    isFixed: { type: Boolean },
    showRowNumbers: { type: Boolean },
    columnWidths: {},
    sortColumn: {},
    sortDirection: {},
    selectionStart: {},
    selectionEnd: {},
    editingCell: {},
    baseColumnIndex: {}
  },
  emits: ["sortColumn", "resizeStart", "selectRow", "cellMouseDown", "cellMouseOver", "cellEditStart", "cellKeyDown", "updateCell", "stopEditing", "setInputRef"],
  setup(__props) {
    const props2 = __props;
    const getActualColumnIndex = (localIndex) => props2.baseColumnIndex + localIndex;
    function isCellSelected(row, localColIndex) {
      if (!props2.selectionStart || !props2.selectionEnd) return false;
      const colIndex = getActualColumnIndex(localColIndex);
      const startRow = Math.min(props2.selectionStart.row, props2.selectionEnd.row);
      const endRow = Math.max(props2.selectionStart.row, props2.selectionEnd.row);
      const startCol = Math.min(props2.selectionStart.col, props2.selectionEnd.col);
      const endCol = Math.max(props2.selectionStart.col, props2.selectionEnd.col);
      return row >= startRow && row <= endRow && colIndex >= startCol && colIndex <= endCol;
    }
    function isCellEditable(columnKey) {
      const column = props2.columns.find((col) => col.key === columnKey);
      return !((column == null ? void 0 : column.locked) ?? false);
    }
    function isEditing(row, localColIndex) {
      if (!props2.editingCell) return false;
      const colIndex = getActualColumnIndex(localColIndex);
      return props2.editingCell.row === row && props2.editingCell.col === colIndex;
    }
    function formatCellValue(value, format2) {
      if (value === null || value === void 0) return "";
      switch (format2) {
        case "image":
          return String(value);
        // Return raw value for images
        case "boolean":
          return "";
        // Return empty string since we're using CheckInput component
        case "number":
          return Number(value).toLocaleString();
        case "currency":
          return Number(value).toLocaleString(void 0, {
            style: "currency",
            currency: "USD"
          });
        case "date":
          return value ? new Date(value).toLocaleDateString() : "";
        case "percentage":
          return Number(value).toLocaleString(void 0, {
            style: "percent",
            minimumFractionDigits: 2
          });
        default:
          return String(value);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("table", {
        class: normalizeClass({ "fixed-columns": _ctx.isFixed, "w-100p": !_ctx.isFixed })
      }, [
        createElementVNode("thead", null, [
          createElementVNode("tr", null, [
            _ctx.showRowNumbers ? (openBlock(), createElementBlock("th", _hoisted_1$4)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columns, (col) => {
              return openBlock(), createElementBlock("th", {
                key: col.key,
                style: normalizeStyle({ width: _ctx.columnWidths.get(col.key) ? `${_ctx.columnWidths.get(col.key)}px` : col.width })
              }, [
                createElementVNode("div", _hoisted_2$2, [
                  createElementVNode("span", {
                    onClick: ($event) => col.sortable && _ctx.$emit("sortColumn", col.key)
                  }, toDisplayString(col.label || col.key), 9, _hoisted_3$2),
                  _ctx.sortColumn === col.key ? (openBlock(), createBlock(unref(_sfc_main$s), {
                    key: 0,
                    class: normalizeClass(["line-height-0 transition-400", { "rotate-180": _ctx.sortDirection === "desc" }]),
                    name: "keyboard_arrow_down"
                  }, null, 8, ["class"])) : createCommentVNode("", true),
                  createElementVNode("div", {
                    class: "resize-handle",
                    onMousedown: withModifiers(($event) => _ctx.$emit("resizeStart", $event, col.key), ["stop"])
                  }, null, 40, _hoisted_4$2)
                ])
              ], 4);
            }), 128))
          ])
        ]),
        createElementVNode("tbody", null, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.rows, (row, rowIndex) => {
            return openBlock(), createElementBlock("tr", { key: rowIndex }, [
              _ctx.showRowNumbers ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: "row-number txt-center hover user-select-none pointer txt12 regular",
                onClick: ($event) => _ctx.$emit("selectRow", rowIndex)
              }, toDisplayString(rowIndex + 1), 9, _hoisted_5$2)) : createCommentVNode("", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columns, (col, colIndex) => {
                return openBlock(), createElementBlock("td", {
                  key: col.key,
                  class: normalizeClass({
                    selected: isCellSelected(rowIndex, colIndex),
                    locked: !isCellEditable(col.key)
                  }),
                  style: normalizeStyle({ width: _ctx.columnWidths.get(col.key) ? `${_ctx.columnWidths.get(col.key)}px` : col.width }),
                  tabindex: col.hidden ? void 0 : 0,
                  onMousedown: ($event) => _ctx.$emit("cellMouseDown", rowIndex, getActualColumnIndex(colIndex)),
                  onMouseover: ($event) => _ctx.$emit("cellMouseOver", rowIndex, getActualColumnIndex(colIndex)),
                  onFocusin: ($event) => _ctx.$emit("cellMouseOver", rowIndex, getActualColumnIndex(colIndex)),
                  onDblclick: ($event) => _ctx.$emit("cellEditStart", rowIndex, getActualColumnIndex(colIndex)),
                  onKeydown: ($event) => _ctx.$emit("cellKeyDown", $event, rowIndex, getActualColumnIndex(colIndex))
                }, [
                  isEditing(rowIndex, colIndex) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createElementVNode("input", {
                      ref_for: true,
                      ref: (el) => _ctx.$emit("setInputRef", el, `cell-${rowIndex}-${getActualColumnIndex(colIndex)}`),
                      value: row[col.key],
                      type: "text",
                      class: "spreadsheet-input",
                      onInput: (e) => _ctx.$emit("updateCell", rowIndex, col.key, e.target.value),
                      onBlur: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("stopEditing", false)),
                      onKeydown: [
                        _cache[1] || (_cache[1] = withKeys(withModifiers(($event) => _ctx.$emit("stopEditing", false), ["prevent"]), ["enter"])),
                        _cache[2] || (_cache[2] = withKeys(withModifiers(($event) => _ctx.$emit("stopEditing", true), ["prevent"]), ["esc"]))
                      ],
                      onMousedown: _cache[3] || (_cache[3] = withModifiers(() => {
                      }, ["stop"]))
                    }, null, 40, _hoisted_7$2),
                    createElementVNode("span", _hoisted_8$1, toDisplayString(formatCellValue(row[col.key], col.format)), 1)
                  ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    col.format === "image" ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
                      createElementVNode("img", {
                        class: "w-100p h-100p contain radius-05",
                        src: row[col.key],
                        alt: col.label || col.key
                      }, null, 8, _hoisted_10$1)
                    ])) : col.format === "boolean" ? (openBlock(), createBlock(unref(CheckInput), {
                      key: 1,
                      modelValue: !!row[col.key],
                      disabled: !isCellEditable(col.key),
                      "onUpdate:modelValue": (value) => _ctx.$emit("updateCell", rowIndex, col.key, !!value),
                      onMousedown: _cache[4] || (_cache[4] = withModifiers(() => {
                      }, ["stop"]))
                    }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"])) : (openBlock(), createElementBlock("span", _hoisted_11$1, toDisplayString(formatCellValue(row[col.key], col.format)), 1))
                  ], 64))
                ], 46, _hoisted_6$2);
              }), 128))
            ]);
          }), 128))
        ])
      ], 2);
    };
  }
});
const SpreadsheetTable = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-5386c509"]]);
const _hoisted_1$3 = { class: "flex gap-05 py-05 justify-content-end m_flex-wrap" };
const _hoisted_2$1 = {
  key: 0,
  class: "label me-auto"
};
const _hoisted_3$1 = { class: "flex gap-075" };
const _hoisted_4$1 = { class: "p-05" };
const _hoisted_5$1 = { class: "flex space-between" };
const _hoisted_6$1 = { class: "flex w-100p relative" };
const _hoisted_7$1 = { class: "flex-shrink flex-grow overflow-x" };
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "Index",
  props: {
    modelValue: {},
    columnConfig: {},
    label: {},
    allowAddRow: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emit2 = __emit;
    function flattenObject(obj, prefix = "") {
      const flattened = {};
      for (const key in obj) {
        if (Object.hasOwn(obj, key)) {
          const value = obj[key];
          const newKey = prefix ? `${prefix}.${key}` : key;
          if (value && typeof value === "object" && !Array.isArray(value)) {
            Object.assign(flattened, flattenObject(value, newKey));
          } else {
            flattened[newKey] = value;
          }
        }
      }
      return flattened;
    }
    function unflattenObject(obj) {
      const result2 = {};
      for (const key in obj) {
        if (Object.hasOwn(obj, key)) {
          const keys4 = key.split(".");
          let current = result2;
          for (let i2 = 0; i2 < keys4.length - 1; i2++) {
            const k2 = keys4[i2];
            if (!current[k2]) {
              current[k2] = {};
            }
            current = current[k2];
          }
          current[keys4[keys4.length - 1]] = obj[key];
        }
      }
      return result2;
    }
    const localRows = ref(
      __props.modelValue ? __props.modelValue.map((row) => flattenObject({ ...row })) : []
    );
    watch(() => __props.modelValue, (newVal) => {
      localRows.value = newVal ? newVal.map((row) => flattenObject({ ...row })) : [];
    });
    function emitUpdate() {
      emit2("update:modelValue", localRows.value.map((row) => unflattenObject({ ...row })));
    }
    const visibleColumns = ref([]);
    const sortColumn = ref(null);
    const sortDirection = ref("asc");
    const columns = computed(() => {
      var _a;
      const dataKeys = localRows.value.length ? new Set(localRows.value.flatMap((row) => Object.keys(row))) : /* @__PURE__ */ new Set();
      const configMap = new Map(
        (__props.columnConfig || []).map((config) => [config.key, config])
      );
      const allKeys = /* @__PURE__ */ new Set([...dataKeys, ...((_a = __props.columnConfig) == null ? void 0 : _a.map((c2) => c2.key)) || []]);
      return Array.from(allKeys).map((key) => {
        const configuredColumn = configMap.get(key);
        return {
          key,
          label: (configuredColumn == null ? void 0 : configuredColumn.label) ?? key,
          locked: (configuredColumn == null ? void 0 : configuredColumn.locked) ?? false,
          sortable: (configuredColumn == null ? void 0 : configuredColumn.sortable) ?? true,
          format: (configuredColumn == null ? void 0 : configuredColumn.format) ?? "text",
          width: configuredColumn == null ? void 0 : configuredColumn.width,
          fixed: (configuredColumn == null ? void 0 : configuredColumn.fixed) ?? false,
          hidden: (configuredColumn == null ? void 0 : configuredColumn.hidden) ?? false,
          defaultValue: configuredColumn == null ? void 0 : configuredColumn.defaultValue
        };
      });
    });
    function formatCellValue(value, format2) {
      if (value === null || value === void 0) return "";
      switch (format2) {
        case "image":
          return String(value);
        // Return raw value for images
        case "boolean":
          return "";
        // Return empty string since we're using CheckInput component
        case "number":
          return Number(value).toLocaleString();
        case "currency":
          return Number(value).toLocaleString(void 0, {
            style: "currency",
            currency: "USD"
          });
        case "date":
          return value ? new Date(value).toLocaleDateString() : "";
        case "percentage":
          return Number(value).toLocaleString(void 0, {
            style: "percent",
            minimumFractionDigits: 2
          });
        default:
          return String(value);
      }
    }
    function parseValueForFormat(value, format2) {
      switch (format2) {
        case "boolean":
          return typeof value === "boolean" ? value : value === "true";
        case "number":
        case "percentage":
        case "currency":
          if (typeof value === "boolean") return null;
          return value === "" ? null : Number(String(value).replace(/[^0-9.-]/g, ""));
        case "date":
          if (typeof value === "boolean") return null;
          return value === "" ? null : new Date(String(value)).toISOString();
        default:
          return String(value);
      }
    }
    function isCellEditable(columnKey) {
      const column = columns.value.find((col) => col.key === columnKey);
      return !((column == null ? void 0 : column.locked) ?? false);
    }
    function sortByColumn(columnKey) {
      const column = columns.value.find((col) => col.key === columnKey);
      if (!(column == null ? void 0 : column.sortable)) return;
      if (sortColumn.value === columnKey) {
        sortDirection.value = sortDirection.value === "desc" ? "asc" : "desc";
      } else {
        sortColumn.value = columnKey;
        sortDirection.value = "desc";
      }
      const sorted = [...localRows.value].sort((a2, b2) => {
        const aVal = a2[columnKey];
        const bVal = b2[columnKey];
        if (aVal === bVal) return 0;
        if (aVal === null || aVal === void 0) return 1;
        if (bVal === null || bVal === void 0) return -1;
        const modifier = sortDirection.value === "desc" ? 1 : -1;
        return aVal < bVal ? -modifier : modifier;
      });
      const currentVisibleColumns = [...visibleColumns.value];
      localRows.value = sorted;
      emitUpdate();
      nextTick(() => {
        visibleColumns.value = currentVisibleColumns;
      });
    }
    const isSelecting = ref(false);
    const selectionStart = ref(null);
    const selectionEnd = ref(null);
    const editingCell = ref(null);
    const editInputRef = ref(/* @__PURE__ */ new Map());
    function setInputRef(el, key) {
      if ((el == null ? void 0 : el.$el) instanceof HTMLInputElement) {
        editInputRef.value.set(key, el.$el);
      } else if (el instanceof HTMLInputElement) {
        editInputRef.value.set(key, el);
      } else {
        editInputRef.value.delete(key);
      }
    }
    function handleMouseDown(row, col) {
      selectionStart.value = { row, col };
      selectionEnd.value = { row, col };
      isSelecting.value = true;
    }
    function handleMouseOver(row, col) {
      if (isSelecting.value && selectionStart.value) {
        selectionEnd.value = { row, col };
      }
    }
    function handleMouseUp() {
      isSelecting.value = false;
    }
    const undoStack = ref([]);
    const redoStack = ref([]);
    function saveState(type3) {
      undoStack.value.push({
        type: type3,
        data: {
          rows: JSON.parse(JSON.stringify(localRows.value)),
          selection: selectionStart.value && selectionEnd.value ? {
            start: { ...selectionStart.value },
            end: { ...selectionEnd.value }
          } : void 0
        }
      });
      redoStack.value = [];
    }
    function undo() {
      const change = undoStack.value.pop();
      if (change) {
        redoStack.value.push({
          type: change.type,
          data: {
            rows: JSON.parse(JSON.stringify(localRows.value)),
            selection: selectionStart.value && selectionEnd.value ? {
              start: { ...selectionStart.value },
              end: { ...selectionEnd.value }
            } : void 0
          }
        });
        localRows.value = JSON.parse(JSON.stringify(change.data.rows));
        if (change.data.selection) {
          selectionStart.value = { ...change.data.selection.start };
          selectionEnd.value = { ...change.data.selection.end };
        }
        emitUpdate();
      }
    }
    function redo() {
      const change = redoStack.value.pop();
      if (change) {
        undoStack.value.push({
          type: change.type,
          data: {
            rows: JSON.parse(JSON.stringify(localRows.value)),
            selection: selectionStart.value && selectionEnd.value ? {
              start: { ...selectionStart.value },
              end: { ...selectionEnd.value }
            } : void 0
          }
        });
        localRows.value = JSON.parse(JSON.stringify(change.data.rows));
        if (change.data.selection) {
          selectionStart.value = { ...change.data.selection.start };
          selectionEnd.value = { ...change.data.selection.end };
        }
        emitUpdate();
      }
    }
    function updateCell(rowIndex, key, newValue) {
      const column = columns.value.find((col) => col.key === key);
      if (column == null ? void 0 : column.locked) return;
      saveState("cell");
      const parsedValue = parseValueForFormat(newValue, column == null ? void 0 : column.format);
      localRows.value[rowIndex][key] = parsedValue ?? (column == null ? void 0 : column.defaultValue) ?? ((column == null ? void 0 : column.format) === "boolean" ? false : "");
      emitUpdate();
    }
    watch(() => columns.value, (newColumns) => {
      if (newColumns.length > 0 && visibleColumns.value.length === 0) {
        visibleColumns.value = newColumns.filter((col) => !col.hidden).map((col) => col.key);
      }
    });
    const fixedColumns = computed(() => {
      return columns.value.filter((col) => col.fixed && !col.hidden && visibleColumns.value.includes(col.key));
    });
    const scrollableColumns = computed(() => {
      return columns.value.filter((col) => !col.fixed && !col.hidden && visibleColumns.value.includes(col.key));
    });
    function createEmptyRow() {
      const newRow = {};
      columns.value.forEach((col) => {
        if (col.defaultValue !== void 0) {
          newRow[col.key] = col.defaultValue;
        } else {
          newRow[col.key] = col.format === "boolean" ? false : "";
        }
      });
      return newRow;
    }
    function addRow2() {
      if (columns.value.length) {
        saveState("row");
        localRows.value.push(createEmptyRow());
        emitUpdate();
      }
    }
    async function copySelection() {
      if (!selectionStart.value || !selectionEnd.value) return;
      const startRow = Math.min(selectionStart.value.row, selectionEnd.value.row);
      const endRow = Math.max(selectionStart.value.row, selectionEnd.value.row);
      const startCol = Math.min(selectionStart.value.col, selectionEnd.value.col);
      const endCol = Math.max(selectionStart.value.col, selectionEnd.value.col);
      const selectedData = [];
      for (let i2 = startRow; i2 <= endRow; i2++) {
        const rowData = [];
        for (let j = startCol; j <= endCol; j++) {
          const columnKey = columns.value[j].key;
          const value = localRows.value[i2][columnKey];
          rowData.push(formatCellValue(value, columns.value[j].format));
        }
        selectedData.push(rowData);
      }
      const tsvContent = selectedData.map((row) => row.join("	")).join("\n");
      try {
        await navigator.clipboard.writeText(tsvContent);
      } catch (err) {
        console.error("Failed to copy to clipboard:", err);
      }
    }
    const searchInputRef = ref(null);
    function isSearchFocused() {
      var _a, _b;
      const inputElement = (_b = (_a = searchInputRef.value) == null ? void 0 : _a.$el) == null ? void 0 : _b.querySelector("input");
      return document.activeElement === inputElement;
    }
    async function pasteSelection() {
      if (!selectionStart.value) return;
      try {
        const clipboardText = await navigator.clipboard.readText();
        const rows = clipboardText.split("\n").map((row) => row.split("	"));
        saveState("paste");
        const startRow = selectionStart.value.row;
        const startCol = selectionStart.value.col;
        const neededRows = startRow + rows.length - localRows.value.length;
        if (neededRows > 0) {
          for (let i2 = 0; i2 < neededRows; i2++) {
            localRows.value.push(createEmptyRow());
          }
        }
        rows.forEach((rowData, rowIndex) => {
          const targetRow = startRow + rowIndex;
          rowData.forEach((cellValue, colIndex) => {
            const targetCol = startCol + colIndex;
            if (targetCol >= columns.value.length) return;
            const columnKey = columns.value[targetCol].key;
            if (!isCellEditable(columnKey)) return;
            const { format: format2 } = columns.value[targetCol];
            localRows.value[targetRow][columnKey] = parseValueForFormat(cellValue, format2);
          });
        });
        emitUpdate();
      } catch (err) {
        console.error("Failed to paste from clipboard:", err);
      }
    }
    const editingOriginalValue = ref(null);
    function startEditing(row, col, initialKey) {
      var _a, _b;
      const columnKey = (_a = columns.value[col]) == null ? void 0 : _a.key;
      if (!columnKey) return;
      if (initialKey !== void 0 && !isCellEditable(columnKey)) return;
      editingCell.value = { row, col };
      editingOriginalValue.value = ((_b = localRows.value[row][columnKey]) == null ? void 0 : _b.toString()) ?? "";
      if (initialKey !== void 0) {
        updateCell(row, columnKey, initialKey);
      }
      nextTick(() => {
        const inputKey = `cell-${row}-${col}`;
        const input = editInputRef.value.get(inputKey);
        if (input) {
          input.focus();
          if (initialKey !== void 0) {
            input.value = initialKey;
          }
        }
      });
    }
    function stopEditing(cancelled = false) {
      var _a;
      if (cancelled && editingCell.value && editingOriginalValue.value !== null) {
        const { row, col } = editingCell.value;
        const columnKey = (_a = columns.value[col]) == null ? void 0 : _a.key;
        if (columnKey) {
          localRows.value[row][columnKey] = editingOriginalValue.value;
        }
      }
      editingCell.value = null;
      editingOriginalValue.value = null;
    }
    function handleStopEditingAndBlur(cancelled = false) {
      nextTick(() => {
        stopEditing(cancelled);
        nextTick(() => {
          const spreadsheet = document.querySelector(".spreadsheet");
          if (spreadsheet) {
            spreadsheet.focus();
          }
        });
      });
    }
    window.addEventListener("mouseup", handleMouseUp);
    function selectEntireRow(rowIndex) {
      selectionStart.value = { row: rowIndex, col: 0 };
      selectionEnd.value = { row: rowIndex, col: columns.value.length - 1 };
    }
    function handleCellKeyDown(event, row, col) {
      if (!(editingCell.value && editingCell.value.row === row && editingCell.value.col === col)) {
        if (event.key.length === 1 && !event.ctrlKey && !event.metaKey || event.key === "Enter") {
          event.preventDefault();
          startEditing(row, col, event.key.length === 1 ? event.key : void 0);
        }
      }
    }
    function handleSpreadsheetKeyDown(event) {
      if (editingCell.value || isSearchFocused()) return;
      console.log("handleSpreadsheetKeyDown", event);
      const isCtrlOrCmd = event.ctrlKey || event.metaKey;
      if (isCtrlOrCmd) {
        switch (event.key.toLowerCase()) {
          case "c":
            event.preventDefault();
            copySelection();
            break;
          case "v":
            event.preventDefault();
            pasteSelection();
            break;
          case "z":
            event.preventDefault();
            if (event.shiftKey) {
              redo();
            } else {
              undo();
            }
            break;
          case "y":
            event.preventDefault();
            redo();
            break;
        }
      }
    }
    const canUndo = computed(() => undoStack.value.length > 0);
    const canRedo = computed(() => redoStack.value.length > 0);
    const search = ref("");
    const filteredRows = computed(() => {
      if (!search.value) return localRows.value;
      const searchTerm = search.value.toLowerCase();
      return localRows.value.filter((row) => {
        return Object.values(row).some((value) => {
          if (value === null || value === void 0) return false;
          return String(value).toLowerCase().includes(searchTerm);
        });
      });
    });
    const columnWidths = ref(/* @__PURE__ */ new Map());
    const isResizing = ref(false);
    const resizingColumn = ref(null);
    const startX = ref(0);
    const startWidth = ref(0);
    function handleResizeStart(e, columnKey) {
      isResizing.value = true;
      resizingColumn.value = columnKey;
      startX.value = e.pageX;
      const columnHeader = e.target.closest("th");
      if (!columnHeader) return;
      const computedWidth = columnHeader.getBoundingClientRect().width;
      const currentWidth = columnWidths.value.get(columnKey) || computedWidth;
      startWidth.value = currentWidth;
      document.addEventListener("mousemove", handleResizeMove);
      document.addEventListener("mouseup", handleResizeEnd);
    }
    function handleResizeMove(e) {
      if (!isResizing.value || !resizingColumn.value) return;
      e.preventDefault();
      const diff = e.pageX - startX.value;
      const newWidth = Math.max(80, startWidth.value + diff);
      columnWidths.value.set(resizingColumn.value, newWidth);
    }
    function handleResizeEnd() {
      isResizing.value = false;
      resizingColumn.value = null;
      document.removeEventListener("mousemove", handleResizeMove);
      document.removeEventListener("mouseup", handleResizeEnd);
    }
    onUnmounted(() => {
      document.removeEventListener("mousemove", handleResizeMove);
      document.removeEventListener("mouseup", handleResizeEnd);
    });
    const columnOptions = computed(() => {
      return columns.value.filter((col) => !col.hidden);
    });
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      return openBlock(), createElementBlock("div", {
        class: "w-100p overflow-hidden",
        tabindex: "-1",
        onKeydown: handleSpreadsheetKeyDown
      }, [
        createElementVNode("div", _hoisted_1$3, [
          _ctx.label ? (openBlock(), createElementBlock("label", _hoisted_2$1, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_3$1, [
            createVNode(_sfc_main$W, {
              flat: "",
              thin: "",
              icon: "view_column"
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_4$1, [
                  createElementVNode("div", _hoisted_5$1, [
                    createVNode(unref(Btn), {
                      flat: "",
                      thin: "",
                      small: "",
                      value: "Select All",
                      onClick: _cache[0] || (_cache[0] = ($event) => visibleColumns.value = columnOptions.value.map((col) => col.key))
                    }),
                    createVNode(unref(Btn), {
                      flat: "",
                      thin: "",
                      small: "",
                      value: "Clear All",
                      onClick: _cache[1] || (_cache[1] = ($event) => visibleColumns.value = [])
                    })
                  ]),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(columnOptions.value, (col) => {
                    return openBlock(), createBlock(unref(CheckInput), {
                      key: col.key,
                      modelValue: visibleColumns.value,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event) => visibleColumns.value = $event),
                        _cache[3] || (_cache[3] = (val) => void 0)
                      ],
                      value: col.key,
                      label: col.label || col.key
                    }, null, 8, ["modelValue", "value", "label"]);
                  }), 128))
                ])
              ]),
              _: 1
            }),
            createVNode(unref(TextInput), {
              ref_key: "searchInputRef",
              ref: searchInputRef,
              modelValue: search.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => search.value = $event),
              icon: "search",
              placeholder: "Search",
              class: "m-0 max-w200px"
            }, null, 8, ["modelValue"]),
            withDirectives(createVNode(unref(Btn), {
              flat: "",
              thin: "",
              round: "",
              icon: "paste",
              onClick: pasteSelection
            }, null, 512), [
              [_directive_tooltip, "Paste"]
            ]),
            withDirectives(createVNode(unref(Btn), {
              flat: "",
              thin: "",
              round: "",
              icon: "copy",
              onClick: copySelection
            }, null, 512), [
              [_directive_tooltip, "copy"]
            ]),
            withDirectives(createVNode(unref(Btn), {
              flat: "",
              thin: "",
              round: "",
              icon: "undo",
              disabled: !canUndo.value,
              onClick: undo
            }, null, 8, ["disabled"]), [
              [_directive_tooltip, "Undo"]
            ]),
            withDirectives(createVNode(unref(Btn), {
              flat: "",
              thin: "",
              round: "",
              icon: "redo",
              disabled: !canRedo.value,
              onClick: redo
            }, null, 8, ["disabled"]), [
              [_directive_tooltip, "Redo"]
            ])
          ])
        ]),
        createElementVNode("div", {
          class: "spreadsheet",
          onMouseup: handleMouseUp
        }, [
          createElementVNode("div", _hoisted_6$1, [
            fixedColumns.value.length ? (openBlock(), createBlock(SpreadsheetTable, {
              key: 0,
              columns: fixedColumns.value,
              rows: filteredRows.value,
              "is-fixed": true,
              "show-row-numbers": true,
              "column-widths": columnWidths.value,
              "sort-column": sortColumn.value,
              "sort-direction": sortDirection.value,
              "selection-start": selectionStart.value,
              "selection-end": selectionEnd.value,
              "editing-cell": editingCell.value,
              "base-column-index": 0,
              class: "sticky z-2 start-0 bg-white",
              onSortColumn: sortByColumn,
              onResizeStart: handleResizeStart,
              onSelectRow: selectEntireRow,
              onCellMouseDown: handleMouseDown,
              onCellMouseOver: handleMouseOver,
              onCellEditStart: startEditing,
              onCellKeyDown: handleCellKeyDown,
              onUpdateCell: updateCell,
              onStopEditing: handleStopEditingAndBlur,
              onSetInputRef: setInputRef
            }, null, 8, ["columns", "rows", "column-widths", "sort-column", "sort-direction", "selection-start", "selection-end", "editing-cell"])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_7$1, [
              createVNode(SpreadsheetTable, {
                columns: scrollableColumns.value,
                rows: filteredRows.value,
                "is-fixed": false,
                "show-row-numbers": !fixedColumns.value.length,
                "column-widths": columnWidths.value,
                "sort-column": sortColumn.value,
                "sort-direction": sortDirection.value,
                "selection-start": selectionStart.value,
                "selection-end": selectionEnd.value,
                "editing-cell": editingCell.value,
                "base-column-index": fixedColumns.value.length,
                onSortColumn: sortByColumn,
                onResizeStart: handleResizeStart,
                onSelectRow: selectEntireRow,
                onCellMouseDown: handleMouseDown,
                onCellMouseOver: handleMouseOver,
                onCellEditStart: startEditing,
                onCellKeyDown: handleCellKeyDown,
                onUpdateCell: updateCell,
                onStopEditing: handleStopEditingAndBlur,
                onSetInputRef: setInputRef
              }, null, 8, ["columns", "rows", "show-row-numbers", "column-widths", "sort-column", "sort-direction", "selection-start", "selection-end", "editing-cell", "base-column-index"])
            ])
          ]),
          _ctx.allowAddRow ? (openBlock(), createBlock(unref(Btn), {
            key: 0,
            outline: "",
            thin: "",
            round: "",
            icon: "add",
            value: "Add Row",
            class: "mt-05",
            onClick: addRow2
          })) : createCommentVNode("", true)
        ], 32)
      ], 32);
    };
  }
});
const Index = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["__scopeId", "data-v-42b4475d"]]);
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "Title",
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    tag: {
      type: String,
      default: "h1"
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), null, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(__props.label || __props.value) + " ", 1),
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      });
    };
  }
});
const _sfc_main$3 = {};
const _hoisted_1$2 = { class: "bg-red" };
function _sfc_render$1(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, " 123 ");
}
const ToolBar = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$1]]);
const _sfc_main$2 = {};
const _hoisted_1$1 = { class: "flex space-between" };
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const TopBar = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render]]);
class TapDetector {
  constructor() {
    __publicField(this, "singleTapCallbacks", []);
    __publicField(this, "doubleTapCallbacks", []);
    __publicField(this, "isTouchMode", false);
    __publicField(this, "lastTapTimestamp", 0);
    __publicField(this, "tappedCount", 0);
    __publicField(this, "touchMovedLength", 0);
    __publicField(this, "lastPointerX", 0);
    __publicField(this, "lastPointerY", 0);
    __publicField(this, "onTouchStart", (event) => {
      this.isTouchMode = true;
      if (event.touches.length === 1) {
        this.onPointerDown(event.touches[0].clientX, event.touches[0].clientY);
      }
    });
    __publicField(this, "onTouchMove", (event) => {
      if (event.touches.length === 1) {
        this.onPointerMove(event.touches[0].clientX, event.touches[0].clientY);
      }
    });
    __publicField(this, "onTouchEnd", () => {
      if (this.isTouchMode) this.onPointerUp();
    });
    __publicField(this, "onMouseDown", (event) => {
      if (!this.isTouchMode) {
        this.onPointerDown(event.clientX, event.clientY);
      }
    });
    __publicField(this, "onMouseMove", (event) => {
      if (!this.isTouchMode && event.button === 0) {
        this.onPointerMove(event.clientX, event.clientY);
      }
    });
    __publicField(this, "onMouseUp", () => {
      if (!this.isTouchMode) this.onPointerUp();
    });
  }
  attach(dom) {
    if (!(dom instanceof Element)) {
      console.error("TapDetector.attach: arg must be an Element");
      return;
    }
    dom.addEventListener("touchstart", this.onTouchStart);
    dom.addEventListener("touchmove", this.onTouchMove);
    dom.addEventListener("touchend", this.onTouchEnd);
    dom.addEventListener("mousedown", this.onMouseDown);
    dom.addEventListener("mouseup", this.onMouseUp);
    dom.addEventListener("mousemove", this.onMouseMove);
  }
  detach(dom) {
    dom.removeEventListener("touchstart", this.onTouchStart);
    dom.removeEventListener("touchmove", this.onTouchMove);
    dom.removeEventListener("touchend", this.onTouchEnd);
    dom.removeEventListener("mousedown", this.onMouseDown);
    dom.removeEventListener("mouseup", this.onMouseUp);
    dom.removeEventListener("mousemove", this.onMouseMove);
  }
  onSingleTap(callback) {
    if (typeof callback === "function" && !this.singleTapCallbacks.includes(callback)) {
      this.singleTapCallbacks.push(callback);
    }
  }
  onDoubleTap(callback) {
    if (typeof callback === "function" && !this.doubleTapCallbacks.includes(callback)) {
      this.doubleTapCallbacks.push(callback);
    }
  }
  triggerCallbacks(callbackType, event) {
    const callbacks = callbackType === "single" ? this.singleTapCallbacks : this.doubleTapCallbacks;
    callbacks.forEach((callback) => {
      callback(event);
    });
  }
  onPointerDown(x2, y2) {
    this.lastPointerX = x2;
    this.lastPointerY = y2;
    this.touchMovedLength = 0;
  }
  onPointerUp() {
    const currTimeStamp = Date.now();
    if (this.touchMovedLength < 10) {
      if (currTimeStamp - this.lastTapTimestamp < 300) {
        this.tappedCount++;
      } else {
        this.tappedCount = 1;
      }
      this.lastTapTimestamp = currTimeStamp;
      this.triggerCallbacks("single", { clientX: this.lastPointerX, clientY: this.lastPointerY });
      if (this.tappedCount === 2) {
        this.triggerCallbacks("double", { clientX: this.lastPointerX, clientY: this.lastPointerY });
        this.tappedCount = 0;
      }
    }
    this.touchMovedLength = 0;
  }
  onPointerMove(x2, y2) {
    const deltaX = this.lastPointerX - x2;
    const deltaY = this.lastPointerY - y2;
    this.touchMovedLength += Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    this.lastPointerX = x2;
    this.lastPointerY = y2;
  }
}
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "Zoomer",
  props: {
    minScale: { default: 1 },
    maxScale: { default: 5 },
    zoom: {},
    resetTrigger: {},
    aspectRatio: { default: 1 },
    backgroundColor: { default: "transparent" },
    pivot: { default: "cursor" },
    zoomingElastic: { type: Boolean, default: true },
    limitTranslation: { type: Boolean, default: true },
    doubleClickToZoom: { type: Boolean, default: true },
    mouseWheelToZoom: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:zoom"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit2 = __emit;
    const zoomElement = ref();
    let containerWidth = ref(1);
    let containerHeight = ref(1);
    let containerLeft = ref(0);
    let containerTop = ref(0);
    let translateX2 = ref(0);
    let animTranslateX = ref(0);
    let translateY2 = ref(0);
    let animTranslateY = ref(0);
    let _zoom = ref(__props.zoom || 1);
    let scale = computed({
      get: () => __props.zoom === void 0 ? _zoom.value : __props.zoom,
      set: (val) => {
        _zoom.value = val;
        emit2("update:zoom", _zoom.value);
      }
    });
    let animScale = ref(1);
    let lastFullWheelTime = ref(0);
    let lastWheelTime = ref(0);
    let lastWheelDirection = ref("y");
    let isPointerDown = ref(false);
    let pointerPosX = ref(-1);
    let pointerPosY = ref(-1);
    let twoFingerInitDist = ref(0);
    let panLocked = ref(true);
    let raf = ref();
    let tapDetector = ref();
    let translateXValue = ref(0);
    let translateYValue = ref(0);
    const wrapperStyle = computed(() => {
      translateXValue.value = containerWidth.value * animTranslateX.value;
      translateYValue.value = containerHeight.value * animTranslateY.value;
      return {
        transform: [
          `translate(${translateXValue.value}px, ${translateYValue.value}px)`,
          `scale(${animScale.value})`
        ].join(" ")
      };
    });
    watch(() => scale.value, (newScale) => {
      const { x: x2, y: y2 } = calcTranslateLimit();
      translateX2.value = Math.max(-x2, Math.min(x2, translateX2.value));
      translateY2.value = Math.max(-y2, Math.min(y2, translateY2.value));
      if (newScale !== 1) {
        panLocked.value = false;
      }
    });
    function reset() {
      scale.value = 1;
      panLocked.value = true;
      translateX2.value = 0;
      translateY2.value = 0;
    }
    __expose({ reset });
    function tryToScale(scaleDelta) {
      if (__props.disabled) return;
      let newScale = scale.value * scaleDelta;
      if (__props.zoomingElastic) {
        if (newScale < __props.minScale || newScale > __props.maxScale) {
          let log = Math.log2(scaleDelta);
          log *= 0.2;
          scaleDelta = 2 ** log;
          newScale = scale.value * scaleDelta;
        }
      } else {
        if (newScale < __props.minScale) newScale = __props.minScale;
        else if (newScale > __props.maxScale) newScale = __props.maxScale;
      }
      scaleDelta = newScale / scale.value;
      scale.value = newScale;
      if (__props.pivot !== "image-center") {
        const normMousePosX = (pointerPosX.value - containerLeft.value) / containerWidth.value;
        const normMousePosY = (pointerPosY.value - containerTop.value) / containerHeight.value;
        translateX2.value = (0.5 + translateX2.value - normMousePosX) * scaleDelta + normMousePosX - 0.5;
        translateY2.value = (0.5 + translateY2.value - normMousePosY) * scaleDelta + normMousePosY - 0.5;
      }
    }
    function setPointerPosCenter() {
      pointerPosX.value = containerLeft.value + containerWidth.value / 2;
      pointerPosY.value = containerTop.value + containerHeight.value / 2;
    }
    function onPointerMove(newMousePosX, newMousePosY) {
      if (isPointerDown.value) {
        const pixelDeltaX = newMousePosX - pointerPosX.value;
        const pixelDeltaY = newMousePosY - pointerPosY.value;
        if (!panLocked.value) {
          const translateLimit = calcTranslateLimit();
          const maxTranslateX = translateLimit.x;
          const maxTranslateY = translateLimit.y;
          const newTranslateX = translateX2.value + pixelDeltaX / containerWidth.value;
          const newTranslateY = translateY2.value + pixelDeltaY / containerHeight.value;
          translateX2.value = Math.max(-maxTranslateX, Math.min(maxTranslateX, newTranslateX));
          translateY2.value = Math.max(-maxTranslateY, Math.min(maxTranslateY, newTranslateY));
        }
      }
      pointerPosX.value = newMousePosX;
      pointerPosY.value = newMousePosY;
    }
    const onInteractionEnd = useDebounceFn(() => {
      limit();
      panLocked.value = scale.value === 1;
    }, 100);
    function limit() {
      if (scale.value < __props.minScale) {
        scale.value = __props.minScale;
      } else if (scale.value > __props.maxScale) {
        tryToScale(__props.maxScale / scale.value);
      }
      if (__props.limitTranslation) {
        const translateLimit = calcTranslateLimit();
        if (Math.abs(translateX2.value) > translateLimit.x) {
          translateX2.value *= translateLimit.x / Math.abs(translateX2.value);
        }
        if (Math.abs(translateY2.value) > translateLimit.y) {
          translateY2.value *= translateLimit.y / Math.abs(translateY2.value);
        }
      }
    }
    function calcTranslateLimit() {
      if (getMarginDirection() === "y") {
        const imageToContainerRatio2 = containerWidth.value / __props.aspectRatio / containerHeight.value;
        let translateLimitY = (scale.value * imageToContainerRatio2 - 1) / 2;
        if (translateLimitY < 0) translateLimitY = 0;
        return {
          x: scale.value - 1,
          // Allow full movement to edges horizontally
          y: translateLimitY * 2
          // Allow full movement to edges vertically
        };
      }
      const imageToContainerRatio = containerHeight.value * __props.aspectRatio / containerWidth.value;
      let translateLimitX = (scale.value * imageToContainerRatio - 1) / 2;
      if (translateLimitX < 0) translateLimitX = 0;
      return {
        x: translateLimitX * 2,
        // Allow full movement to edges horizontally
        y: scale.value - 1
        // Allow full movement to edges vertically
      };
    }
    function getMarginDirection() {
      const containerRatio = containerWidth.value / containerHeight.value;
      return containerRatio > __props.aspectRatio ? "x" : "y";
    }
    function onMouseWheel(ev) {
      if (!__props.mouseWheelToZoom) return;
      ev.preventDefault();
      const currTime = Date.now();
      if (Math.abs(ev.deltaY) === 120) {
        if (currTime - lastFullWheelTime.value > 50) {
          onMouseWheelDo(ev.deltaY);
          lastFullWheelTime.value = currTime;
        }
      } else {
        if (currTime - lastWheelTime.value > 50) {
          lastWheelDirection.value = ev.deltaX > ev.deltaY ? "x" : "y";
          if (lastWheelDirection.value === "y") {
            onMouseWheelDo(ev.deltaY);
          }
        }
        lastWheelTime.value = currTime;
      }
    }
    function onMouseWheelDo(wheelDelta) {
      const scaleDelta = 1.25 ** (wheelDelta / 120);
      tryToScale(scaleDelta);
      onInteractionEnd();
    }
    function onMouseDown(ev) {
      refreshContainerPos();
      isPointerDown.value = true;
      pointerPosX.value = ev.clientX;
      pointerPosY.value = ev.clientY;
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }
    function onMouseUp() {
      isPointerDown.value = false;
      onInteractionEnd();
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mousemove", onMouseMove);
    }
    function onMouseMove(ev) {
      onPointerMove(ev.clientX, ev.clientY);
    }
    function onTouchStart(ev) {
      if (ev.touches.length === 1) {
        refreshContainerPos();
        pointerPosX.value = ev.touches[0].clientX;
        pointerPosY.value = ev.touches[0].clientY;
        isPointerDown.value = true;
      } else if (ev.touches.length === 2) {
        isPointerDown.value = true;
        pointerPosX.value = (ev.touches[0].clientX + ev.touches[1].clientX) / 2;
        pointerPosY.value = (ev.touches[0].clientY + ev.touches[1].clientY) / 2;
        const distX = ev.touches[0].clientX - ev.touches[1].clientX;
        const distY = ev.touches[0].clientY - ev.touches[1].clientY;
        twoFingerInitDist.value = Math.sqrt(distX * distX + distY * distY);
      }
      document.addEventListener("touchend", onTouchEnd);
    }
    function onTouchEnd(ev) {
      if (ev.touches.length === 0) {
        isPointerDown.value = false;
        if (Math.abs(scale.value - 1) < 0.1) scale.value = 1;
        onInteractionEnd();
      } else if (ev.touches.length === 1) {
        pointerPosX.value = ev.touches[0].clientX;
        pointerPosY.value = ev.touches[0].clientY;
      }
      document.removeEventListener("touchend", onTouchEnd);
    }
    function onTouchMove(ev) {
      if (ev.touches.length === 1) {
        onPointerMove(ev.touches[0].clientX, ev.touches[0].clientY);
      } else if (ev.touches.length === 2) {
        const distX = ev.touches[0].clientX - ev.touches[1].clientX;
        const distY = ev.touches[0].clientY - ev.touches[1].clientY;
        const newTwoFingerDist = Math.sqrt(distX * distX + distY * distY);
        tryToScale(newTwoFingerDist / twoFingerInitDist.value);
        twoFingerInitDist.value = newTwoFingerDist;
      }
    }
    function refreshContainerPos() {
      if (zoomElement.value) {
        const rect = zoomElement.value.getBoundingClientRect();
        containerLeft.value = rect.left;
        containerTop.value = rect.top;
      }
    }
    function loop() {
      animScale.value = gainOn(animScale.value, scale.value);
      animTranslateX.value = gainOn(animTranslateX.value, translateX2.value);
      animTranslateY.value = gainOn(animTranslateY.value, translateY2.value);
      raf.value = window.requestAnimationFrame(loop);
    }
    function gainOn(from, to) {
      const delta = (to - from) * 0.3;
      return Math.abs(delta) > 1e-5 ? from + delta : to;
    }
    onMounted(() => {
      tapDetector.value = new TapDetector();
      if (zoomElement.value) tapDetector.value.attach(zoomElement.value);
      if (__props.doubleClickToZoom) {
        tapDetector.value.onDoubleTap(onDoubleTap);
      }
      window.addEventListener("resize", onWindowResize);
      onWindowResize();
      refreshContainerPos();
      loop();
    });
    onUnmounted(() => {
      var _a;
      if (zoomElement.value) (_a = tapDetector.value) == null ? void 0 : _a.detach(zoomElement.value);
      window.removeEventListener("resize", onWindowResize);
      if (raf.value) window.cancelAnimationFrame(raf.value);
    });
    function onDoubleTap(ev) {
      if (scale.value === 1) {
        if (ev.clientX > 0) {
          pointerPosX.value = ev.clientX;
          pointerPosY.value = ev.clientY;
        }
        tryToScale(Math.min(3, __props.maxScale));
      } else {
        reset();
      }
    }
    function onWindowResize() {
      if (zoomElement.value) {
        const styles = window.getComputedStyle(zoomElement.value);
        containerWidth.value = Number.parseFloat(styles.width);
        containerHeight.value = Number.parseFloat(styles.height);
        setPointerPosCenter();
        limit();
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "zoomElement",
        ref: zoomElement,
        class: "vue-zoomer",
        style: normalizeStyle({ backgroundColor: _ctx.backgroundColor }),
        onMousewheel: onMouseWheel,
        "on:DOMMouseScroll": onMouseWheel,
        onMousedown: onMouseDown,
        onMouseout: setPointerPosCenter,
        onFocusout: setPointerPosCenter,
        onTouchstart: onTouchStart,
        onTouchmove: onTouchMove
      }, [
        createElementVNode("div", {
          class: "zoomer",
          style: normalizeStyle(wrapperStyle.value)
        }, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 4)
      ], 36);
    };
  }
});
const Zoomer = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-379819e1"]]);
const FORM_STATE_KEY = Symbol("bagelFormState");
function safeClone(obj) {
  if (obj === null || typeof obj !== "object") return obj;
  const seen = /* @__PURE__ */ new WeakSet();
  return JSON.parse(JSON.stringify(obj, (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return void 0;
      }
      seen.add(value);
    }
    return value;
  }));
}
function provideBagelFormState(initialData) {
  const data2 = ref(initialData);
  const isDirty = ref(false);
  const getFieldData = (path) => getNestedValue(data2.value, path, "");
  const updateField = (path, value) => {
    const keys4 = path.split(/[.[]/);
    if (typeof data2.value !== "object" || data2.value === null) {
      data2.value = {};
    }
    let current = data2.value;
    for (let i2 = 0; i2 < keys4.length - 1; i2++) {
      const key = keys4[i2];
      if (!(key in current) || typeof current[key] !== "object" || current[key] === null) {
        current[key] = {};
      }
      current = current[key];
    }
    const safeValue = safeClone(value);
    current[keys4[keys4.length - 1]] = safeValue;
    isDirty.value = true;
  };
  const state2 = {
    data: data2,
    getFieldData,
    updateField,
    isDirty
  };
  provide(FORM_STATE_KEY, state2);
  return state2;
}
function useBagelFormState(injectionKey = FORM_STATE_KEY) {
  const state2 = inject(injectionKey);
  if (!state2) throw new Error("BagelFormState must be provided");
  return state2;
}
function useDevice() {
  const innerWidth = ref(window.innerWidth);
  const isMobile = ref(window.innerWidth < 768);
  function updateDeviceInfo() {
    innerWidth.value = window.innerWidth;
    isMobile.value = window.innerWidth < 768;
  }
  onMounted(() => {
    window.addEventListener("resize", updateDeviceInfo);
  });
  onUnmounted(() => {
    window.removeEventListener("resize", updateDeviceInfo);
  });
  return {
    innerWidth,
    isMobile
  };
}
function useBglSchema({ schema, columns, data: data2 } = {}) {
  let _schema = schema;
  if (typeof _schema === "function") {
    _schema = _schema();
  }
  if (_schema) {
    return columns && columns.length > 0 ? _schema.filter((f2) => columns.includes(f2.id)) : _schema;
  }
  return getFallbackSchema(data2, columns);
}
function localRef(key, initialValue) {
  const storedValue = localStorage.getItem(key);
  const initial = storedValue !== null ? JSON.parse(storedValue) : initialValue;
  const value = ref(initial);
  watch(() => value.value, (val) => {
    localStorage.setItem(key, JSON.stringify(val));
  }, { immediate: true, deep: true });
  return value;
}
const useLocalStorage = localRef;
const axios = axios$1.create({
  withCredentials: true
});
class DataRequest {
  constructor(table, bagel) {
    __publicField(this, "data_table");
    __publicField(this, "bagel");
    __publicField(this, "itemID");
    __publicField(this, "_filter", {});
    this.data_table = table;
    this.bagel = bagel;
    this.itemID = "";
  }
  async post(item) {
    if (!this.data_table) throw new Error("Data table not set");
    const { data: data2 } = await axios.post(`/data/${this.data_table}`, item);
    return data2;
  }
  filter(filter3) {
    this._filter = filter3;
    return this;
  }
  async get() {
    var _a, _b;
    if (!this.data_table) throw new Error("Data table not set");
    const filterStr = Object.keys(this._filter).length > 0 ? `?filter={${Object.entries(this._filter).map(([k2, v2]) => `${k2}:${v2}`).join(",")}}` : "";
    const url = `/data/${this.data_table}${this.itemID ? `/${this.itemID}` : ""}${filterStr}`;
    try {
      const { data: data2 } = await axios.get(url);
      return data2;
    } catch (err) {
      console.log(err);
      (_b = (_a = this.bagel).onError) == null ? void 0 : _b.call(_a, err);
      return void 0;
    }
  }
  item(id) {
    this.itemID = id;
    return this;
  }
  async delete() {
    if (!this.data_table) throw new Error("Data table not set");
    const { data: data2 } = await axios.delete(
      `/data/${this.data_table}/${this.itemID}`
    );
    return data2;
  }
  async put(updatedItem) {
    const { data_table, itemID } = this;
    if (!data_table) throw new Error("Data table not set");
    if (!itemID) throw new Error("Item ID not set");
    const { data: data2 } = await axios.put(
      `/data/${data_table}/${itemID}`,
      updatedItem
    );
    return data2;
  }
}
function responses(key) {
  const res = {
    LOGIN_BAD_CREDENTIALS: "Invalid username or password",
    RESET_PASSWORD_BAD_TOKEN: "This reset password link is invalid or expired."
  };
  return res[key] || key;
}
class BagelAuth {
  constructor(bagel) {
    __publicField(this, "user");
    this.bagel = bagel;
    this.bagel = bagel;
  }
  async validateUser() {
    try {
      const { data: usr } = await axios.get("/users/me", {
        withCredentials: true
      });
      this.user = usr;
      return usr;
    } catch {
    }
  }
  async resetPassword(ctx) {
    return this.bagel.post("auth/reset-password", ctx).catch((err) => {
      var _a, _b;
      throw responses((_b = (_a = err.response) == null ? void 0 : _a.data) == null ? void 0 : _b.detail);
    });
  }
  async forgotPassword(email) {
    var _a, _b;
    try {
      await this.bagel.post("auth/forgot-password", { email });
    } catch (err) {
      throw responses((_b = (_a = err == null ? void 0 : err.response) == null ? void 0 : _a.data) == null ? void 0 : _b.detail);
    }
  }
  async login(user) {
    var _a, _b;
    const formData = new FormData();
    formData.append("username", user.email || "");
    formData.append("password", user.password || "");
    console.log("Logging in");
    try {
      await axios.post("/auth/cookie/login", formData, {
        headers: {
          "withCredentials": true,
          "Content-Type": "multipart/form-data"
        }
      });
      axios.defaults.withCredentials = true;
      return this.validateUser();
    } catch (err) {
      throw responses(((_b = (_a = err.response) == null ? void 0 : _a.data) == null ? void 0 : _b.detail) || "LOGIN_BAD_CREDENTIALS");
    }
  }
  async logout() {
    var _a, _b;
    try {
      await axios.post("/auth/cookie/logout");
    } catch (err) {
      (_b = (_a = this.bagel).onError) == null ? void 0 : _b.call(_a, err);
      console.log(err);
    }
    this.user = void 0;
  }
  async acceptInvite(token, user) {
    await axios.post(`/auth/accept-invite/${token}`, user);
    await this.login(user);
  }
  async register(user, errors) {
    try {
      await axios.post("/auth/register", user);
      return this.login(user);
    } catch (err) {
      console.error(err);
      errors.email = err.response.data.detail;
      throw err;
    }
  }
}
class Bagel {
  constructor({ host, fileBaseUrl: fileBaseUrl2, onError }) {
    __publicField(this, "host");
    __publicField(this, "fileBaseUrl");
    __publicField(this, "onError");
    __publicField(this, "read_table");
    __publicField(this, "auth", new BagelAuth(this));
    this.host = host == null ? void 0 : host.replace(/\/$/, "");
    this.fileBaseUrl = fileBaseUrl2 == null ? void 0 : fileBaseUrl2.replace(/\/$/, "");
    if (!this.host) {
      return this;
    }
    axios.defaults.baseURL = this.host;
    this.onError = onError;
  }
  data(table) {
    return new DataRequest(table, this);
  }
  _endpointCleaner(endpoint) {
    const url = `${endpoint.replace(/^\//, "").replaceAll(/\/$/g, "")}`;
    return url;
  }
  async api(endpoint, query) {
    if (query) {
      const queryParams = Object.entries(query).map(([key, value]) => `${key}=${value}`).join("&");
      endpoint = `${endpoint}?${queryParams}`;
    }
    return axios.get(`/api/${endpoint}`).then(({ data: data2 }) => data2);
  }
  async get(endpoint, query) {
    this._setAuthorization();
    endpoint = this._endpointCleaner(endpoint);
    if (/undefined|null/.test(endpoint)) throw new Error(`Invalid endpoint: ${endpoint}`);
    if (query) {
      const queryParams = Object.entries(query).filter(([_2, value]) => !!value).map(([key, value]) => `${key}=${value}`).join("&");
      if (queryParams) endpoint = `${endpoint}?${queryParams}`;
    }
    const url = `/${endpoint}`;
    return axios.get(url).then(({ data: data2 }) => data2).catch((err) => {
      var _a;
      (_a = this.onError) == null ? void 0 : _a.call(this, err);
      throw err;
    });
  }
  async delete(endpoint) {
    this._setAuthorization();
    endpoint = this._endpointCleaner(endpoint);
    return axios.delete(`/${endpoint}`).then(({ data: data2 }) => data2).catch((err) => {
      var _a;
      (_a = this.onError) == null ? void 0 : _a.call(this, err);
      throw err;
    });
  }
  async put(endpoint, payload) {
    endpoint = this._endpointCleaner(endpoint);
    this._setAuthorization();
    return axios.put(`/${endpoint}`, payload).then(({ data: data2 }) => data2).catch((err) => {
      var _a;
      (_a = this.onError) == null ? void 0 : _a.call(this, err);
      throw err;
    });
  }
  async patch(endpoint, payload = {}) {
    endpoint = this._endpointCleaner(endpoint);
    return axios.patch(`/${endpoint}`, payload).then(({ data: data2 }) => data2).catch((err) => {
      var _a;
      (_a = this.onError) == null ? void 0 : _a.call(this, err);
      throw err;
    });
  }
  _setAuthorization() {
    const Authorization = localStorage.getItem("access_token");
    if (Authorization) {
      axios.defaults.headers.common.Authorization = `Bearer ${Authorization}`;
    }
  }
  async post(endpoint, payload = {}) {
    this._setAuthorization();
    endpoint = this._endpointCleaner(endpoint);
    return axios.post(`/${endpoint}`, payload).then(({ data: data2 }) => data2).catch((err) => {
      var _a;
      (_a = this.onError) == null ? void 0 : _a.call(this, err);
      throw err;
    });
  }
  async uploadFile(file, options) {
    this._setAuthorization();
    const formData = new FormData();
    formData.append("file", file);
    let url = "/static_files/upload";
    if (options == null ? void 0 : options.topic) url = `/static_files/upload?topic=${options.topic}`;
    const { data: data2 } = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: options == null ? void 0 : options.onUploadProgress
    });
    return data2;
  }
}
const _hoisted_1 = {
  key: 0,
  class: "navigation flex space-between px-3 w-100 absolute m_px-1 m_none z-9"
};
const _hoisted_2 = { class: "flex start fixed top-1 w-100 space-between px-1" };
const _hoisted_3 = {
  key: 0,
  class: "center"
};
const _hoisted_4 = { key: 3 };
const _hoisted_5 = ["src", "title"];
const _hoisted_6 = {
  key: 3,
  class: "file-info txt-white flex m_block align-items-start gap-025"
};
const _hoisted_7 = { class: "txt-start" };
const _hoisted_8 = { class: "mx-0 light" };
const _hoisted_9 = { class: "semi word-break-all" };
const _hoisted_10 = { class: "mx-0" };
const _hoisted_11 = { class: "semi" };
const _hoisted_12 = {
  key: 0,
  class: "flex justify-content-center mt-2 overflow p-1 fixed bottom start end gap-1 m_justify-content-start"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Lightbox",
  setup(__props, { expose: __expose }) {
    let isOpen = ref(false);
    let group = ref([]);
    let currentIndex = ref(0);
    let currentItem = computed(() => group.value[currentIndex.value]);
    function open(item, groupItems) {
      isOpen.value = true;
      group.value = groupItems || [item];
      currentIndex.value = group.value.findIndex(({ src }) => item.src === src);
      document.addEventListener("keydown", handleKeydown);
    }
    function close() {
      isOpen.value = false;
      document.removeEventListener("keydown", handleKeydown);
    }
    function next() {
      if (group.value.length > 1) {
        currentIndex.value = (currentIndex.value + 1) % group.value.length;
        currentItem.value = group.value[currentIndex.value];
      }
    }
    function prev() {
      if (group.value.length > 1) {
        currentIndex.value = (currentIndex.value - 1 + group.value.length) % group.value.length;
        currentItem.value = group.value[currentIndex.value];
      }
    }
    function selectItem(index2) {
      currentIndex.value = index2;
      currentItem.value = group.value[index2];
    }
    watch(() => isOpen.value, (val) => {
      if (val) document.body.style.overflow = "hidden";
      else document.body.style.overflow = "";
    });
    function handleKeydown(event) {
      if (event.key === "Escape") {
        close();
      } else if (event.key === "ArrowLeft") {
        prev();
      } else if (event.key === "ArrowRight") {
        next();
      }
    }
    const zoom = ref(1);
    function clickOutside2() {
      if (zoom.value === 1) close();
    }
    const upgradeHeaders = (url) => url.replace(/http:\/\//, "//");
    __expose({ open, close });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, { name: "fade" }, {
        default: withCtx(() => {
          var _a, _b, _c, _d, _e2, _f, _g, _h, _i, _j;
          return [
            unref(isOpen) ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "bgl-lightbox-overlay fixed w-100 h-100 flex justify-content-center z-9999 inset mx-auto",
              onKeydown: [
                withKeys(close, ["esc"]),
                withKeys(prev, ["left"]),
                withKeys(next, ["right"])
              ],
              onClick: clickOutside2
            }, [
              unref(group) && unref(group).length > 1 ? (openBlock(), createElementBlock("div", _hoisted_1, [
                createVNode(unref(Btn), {
                  class: "oval opacity-8",
                  icon: "arrow_back",
                  color: "black",
                  onClick: prev
                }),
                createVNode(unref(Btn), {
                  class: "oval opacity-8",
                  icon: "arrow_forward",
                  color: "black",
                  onClick: next
                })
              ])) : createCommentVNode("", true),
              createElementVNode("div", {
                class: "bgl-lightbox relative txt-center",
                onClick: _cache[5] || (_cache[5] = withModifiers(() => {
                }, ["stop"]))
              }, [
                createElementVNode("div", _hoisted_2, [
                  createVNode(unref(Btn), {
                    flat: "",
                    class: "color-white",
                    icon: "close",
                    onClick: close
                  }),
                  ((_a = unref(currentItem)) == null ? void 0 : _a.enableZoom) && ((_b = unref(currentItem)) == null ? void 0 : _b.type) === "image" ? (openBlock(), createElementBlock("div", _hoisted_3, [
                    createVNode(unref(Btn), {
                      flat: "",
                      class: "color-white",
                      icon: "remove",
                      disabled: zoom.value === 1,
                      onClick: _cache[0] || (_cache[0] = ($event) => zoom.value--)
                    }, null, 8, ["disabled"]),
                    createVNode(unref(Btn), {
                      flat: "",
                      class: "color-white",
                      icon: "zoom_in",
                      disabled: zoom.value === 1,
                      onClick: _cache[1] || (_cache[1] = ($event) => zoom.value = 1)
                    }, null, 8, ["disabled"]),
                    createVNode(unref(Btn), {
                      flat: "",
                      class: "color-white",
                      icon: "add",
                      disabled: zoom.value === 3,
                      onClick: _cache[2] || (_cache[2] = ($event) => zoom.value++)
                    }, null, 8, ["disabled"])
                  ])) : createCommentVNode("", true),
                  ((_c = unref(currentItem)) == null ? void 0 : _c.openFile) && ((_d = unref(currentItem)) == null ? void 0 : _d.src) ? (openBlock(), createBlock(unref(Btn), {
                    key: 1,
                    class: "color-white",
                    round: "",
                    thin: "",
                    flat: "",
                    iconEnd: "arrow_outward",
                    value: "Open File",
                    href: (_e2 = unref(currentItem)) == null ? void 0 : _e2.src,
                    target: "_blank"
                  }, null, 8, ["href"])) : createCommentVNode("", true),
                  ((_f = unref(currentItem)) == null ? void 0 : _f.download) && ((_g = unref(currentItem)) == null ? void 0 : _g.src) ? (openBlock(), createBlock(unref(Btn), {
                    key: 2,
                    class: "color-white",
                    round: "",
                    thin: "",
                    flat: "",
                    icon: "download",
                    value: "Download File",
                    href: upgradeHeaders((_h = unref(currentItem)) == null ? void 0 : _h.src),
                    download: ""
                  }, null, 8, ["href"])) : createCommentVNode("", true),
                  !((_i = unref(currentItem)) == null ? void 0 : _i.openFile) && !((_j = unref(currentItem)) == null ? void 0 : _j.download) ? (openBlock(), createElementBlock("div", _hoisted_4)) : createCommentVNode("", true)
                ]),
                createVNode(unref(Carousel), {
                  index: unref(currentIndex),
                  "onUpdate:index": _cache[4] || (_cache[4] = ($event) => isRef(currentIndex) ? currentIndex.value = $event : currentIndex = $event),
                  items: 1,
                  class: normalizeClass(["bgl-lightbox-item", { zoomed: zoom.value > 1 }]),
                  freeDrag: zoom.value === 1
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(group), (item) => {
                      return openBlock(), createElementBlock(Fragment, {
                        key: item.src
                      }, [
                        item.type === "image" ? (openBlock(), createBlock(unref(Zoomer), {
                          key: 0,
                          zoom: zoom.value,
                          "onUpdate:zoom": _cache[3] || (_cache[3] = ($event) => zoom.value = $event),
                          disabled: !(item == null ? void 0 : item.enableZoom),
                          "mouse-wheel-to-zoom": false
                        }, {
                          default: withCtx(() => [
                            createVNode(unref(Image$1), {
                              draggable: false,
                              src: item == null ? void 0 : item.src,
                              alt: "Preview",
                              class: "vw90 lightbox-image"
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1032, ["zoom", "disabled"])) : (item == null ? void 0 : item.type) === "video" && (item == null ? void 0 : item.src) ? (openBlock(), createBlock(unref(BglVideo), {
                          key: 1,
                          src: item == null ? void 0 : item.src,
                          autoplay: "",
                          controls: "",
                          class: "vw90"
                        }, null, 8, ["src"])) : (item == null ? void 0 : item.type) === "pdf" && (item == null ? void 0 : item.src) ? (openBlock(), createElementBlock("embed", {
                          key: 2,
                          src: unref(normalizeURL)(item == null ? void 0 : item.src),
                          type: "application/pdf",
                          width: "100%",
                          height: "1080",
                          title: item == null ? void 0 : item.name,
                          class: "vw90"
                        }, null, 8, _hoisted_5)) : (openBlock(), createElementBlock("div", _hoisted_6, [
                          createVNode(unref(_sfc_main$s), {
                            class: "m-0 m_none",
                            icon: "draft",
                            size: 10,
                            weight: "12"
                          }),
                          createVNode(unref(_sfc_main$s), {
                            class: "m-0 none m_block m_-mb-1",
                            icon: "draft",
                            size: 4,
                            weight: "2"
                          }),
                          createElementVNode("div", _hoisted_7, [
                            createElementVNode("p", _hoisted_8, [
                              _cache[6] || (_cache[6] = createTextVNode(" File: ")),
                              createElementVNode("span", _hoisted_9, toDisplayString(item == null ? void 0 : item.name), 1)
                            ]),
                            createElementVNode("p", _hoisted_10, [
                              _cache[7] || (_cache[7] = createTextVNode(" Type: ")),
                              createElementVNode("span", _hoisted_11, toDisplayString(item == null ? void 0 : item.type), 1)
                            ]),
                            createVNode(unref(Btn), {
                              href: item == null ? void 0 : item.src,
                              target: "_blank",
                              round: "",
                              thin: "",
                              class: "mt-1",
                              value: "Open file"
                            }, null, 8, ["href"])
                          ])
                        ]))
                      ], 64);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["index", "class", "freeDrag"]),
                unref(group) && unref(group).length > 1 ? (openBlock(), createElementBlock("div", _hoisted_12, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(group), (item, index2) => {
                    return openBlock(), createElementBlock(Fragment, { key: index2 }, [
                      item.type === "image" ? (openBlock(), createBlock(unref(Image$1), {
                        key: 0,
                        class: normalizeClass(["thumbnail object-fit-cover hover opacity-5 rounded flex bg-popup justify-content-center align-items-center flex-shrink-0", { active: unref(currentIndex) === index2 }]),
                        src: item.src,
                        alt: "",
                        onClick: ($event) => selectItem(index2)
                      }, null, 8, ["src", "class", "onClick"])) : (openBlock(), createBlock(unref(_sfc_main$s), {
                        key: 1,
                        class: normalizeClass(["thumbnail object-fit-cover hover opacity-5 ed flex bg-popup justify-content-center align-items-center flex-shrink-0", { active: unref(currentIndex) === index2 }]),
                        icon: "description",
                        onClick: ($event) => selectItem(index2)
                      }, null, 8, ["class", "onClick"]))
                    ], 64);
                  }), 128))
                ])) : createCommentVNode("", true)
              ])
            ], 32)) : createCommentVNode("", true)
          ];
        }),
        _: 1
      });
    };
  }
});
const Lightbox = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-fb2d5763"]]);
const groups = {};
let clickHandler = (_e2) => void 0;
const lightboxDirective = {
  mounted(el, binding) {
    const item = bindingToItem(binding, el);
    groupHandler(item);
    clickHandler = (e) => {
      openClickHandler(e, el, binding);
    };
    el.addEventListener("click", clickHandler);
  },
  updated(el, binding) {
    const item = bindingToItem(binding, el);
    groupHandler(item);
    el.removeEventListener("click", clickHandler);
    clickHandler = (e) => {
      openClickHandler(e, el, binding);
    };
    el.addEventListener("click", clickHandler);
  },
  unmounted(el) {
    el.removeEventListener("click", clickHandler);
  }
};
function groupHandler(item) {
  if (item.group) {
    if (!groups[item.group]) groups[item.group] = [];
    const currentIndex = groups[item.group].findIndex((i2) => i2.src === item.src);
    if (currentIndex === -1) groups[item.group].push(item);
  }
}
function openClickHandler(e, el, binding) {
  e.stopPropagation();
  const item = bindingToItem(binding, el);
  const lightboxInstance2 = getLightboxInstance();
  if (!lightboxInstance2 || !lightboxInstance2.open) return;
  const open = lightboxInstance2.open;
  const group = item && item.group ? groups[item.group] : void 0;
  open(item, group);
}
function bindingToItem(binding, el) {
  let { group, src, type: type3, name, thumbnail, enableZoom, openFile, download, pathKey } = binding.value || {};
  src = pathKeyToURL(src || pathKey) || binding.value || el.getAttribute("src") || "";
  type3 = type3 || determineFileType(src);
  name = name || urlToName(src) || el.getAttribute("alt") || "";
  return { src, type: type3, name, thumbnail, group, enableZoom, openFile, download };
}
const youtubeRegex = /youtube\.com|youtu\.be/;
const vimeoRegex = /vimeo\.com/;
function urlToName(url) {
  if (!url) return "";
  const name = url.split("/").pop() || "";
  return name.replace(/\.[^/.]+$/, "");
}
function determineFileType(url) {
  var _a;
  if (!url) return "unknown";
  const extension = (url.split(".").pop() || "").toLowerCase();
  const altExtension = ((_a = url.split("?")[0].split(".").pop()) == null ? void 0 : _a.toLowerCase()) || "";
  if (IMAGE_FORMATS_REGEXP.test(extension) || IMAGE_FORMATS_REGEXP.test(altExtension)) return "image";
  if (VIDEO_FORMATS_REGEXP.test(extension) || youtubeRegex.test(url) || vimeoRegex.test(url)) return "video";
  if (["pdf"].includes(extension)) return "pdf";
  return extension ?? "unknown";
}
let lightboxInstance;
function getLightboxInstance() {
  if (!lightboxInstance) {
    const lightboxEl = document.createElement("div");
    document.body.prepend(lightboxEl);
    const app = createApp(Lightbox);
    lightboxInstance = app.mount(lightboxEl);
  }
  return lightboxInstance;
}
const lightboxPlugin = {
  install(app) {
    app.directive("lightbox", lightboxDirective);
  }
};
const DEFAULT_PATTERNS = {
  pint: { pattern: /\d/ },
  int: { pattern: /[\d-]/ },
  pnum: { pattern: /[\d.]/ },
  tel: { pattern: /[\d.\-()\s+]/ },
  money: { pattern: /[\d.\s,]/ },
  number: { pattern: /[\d\-.]/ },
  num: { pattern: /[\d\-.]/ },
  hex: { pattern: /[0-9a-f]/i },
  email: { pattern: /[\w.\-@]/ },
  alpha: { pattern: /[a-z_]/i },
  alphanum: { pattern: /\w/ },
  lower: { pattern: /[a-z]/, transform: (v2) => v2.toLowerCase() },
  upper: { pattern: /[A-Z]/, transform: (v2) => v2.toUpperCase() },
  slug: { pattern: /[a-z0-9-]/i, transform: (v2) => v2.toLowerCase().replace(/\s/g, "-") }
};
const stateMap = /* @__PURE__ */ new WeakMap();
function getTarget(el) {
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
    return el;
  }
  const target = el.querySelector("input, textarea");
  return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement ? target : null;
}
function getModifiers(binding) {
  const modifiers = Object.keys(binding.modifiers || {});
  return modifiers.length ? modifiers[modifiers.length - 1] : "";
}
function getRegex(state2) {
  if (state2.pattern) return state2.pattern;
  if (state2.modifier) return DEFAULT_PATTERNS[state2.modifier].pattern || /./;
  return /./;
}
function bindEvents(el, target, state2) {
  state2.keydownEvent = (event) => {
    onKeydown(event, target, state2);
  };
  state2.pasteEvent = (event) => {
    onPaste(event, target, state2);
  };
  target.addEventListener("keydown", state2.keydownEvent);
  target.addEventListener("paste", state2.pasteEvent);
}
function unbindEvents(target, state2) {
  if (state2.keydownEvent) target.removeEventListener("keydown", state2.keydownEvent);
  if (state2.pasteEvent) target.removeEventListener("paste", state2.pasteEvent);
  state2.keydownEvent = void 0;
  state2.pasteEvent = void 0;
}
function onKeydown(event, target, state2) {
  if (event.ctrlKey || event.altKey || event.metaKey || event.key === "Tab" || event.key === "Backspace" || event.key === "Delete" || event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "Enter") return;
  const regex2 = getRegex(state2);
  const testKey = event.key;
  if (!regex2.test(testKey)) {
    event.preventDefault();
  } else if (state2.modifier) {
    const { transform } = DEFAULT_PATTERNS[state2.modifier];
    if (transform) {
      event.preventDefault();
      const transformedValue = transform(testKey);
      const cursorPos = target.selectionStart ?? 0;
      const newValue = target.value.slice(0, cursorPos) + transformedValue + target.value.slice(cursorPos);
      target.value = newValue;
      target.setSelectionRange(cursorPos + transformedValue.length, cursorPos + transformedValue.length);
    }
  }
}
function onPaste(event, target, state2) {
  var _a;
  const regex2 = getRegex(state2);
  const clipboardData = ((_a = event.clipboardData) == null ? void 0 : _a.getData("text")) || "";
  if (!regex2.test(clipboardData)) {
    event.preventDefault();
  } else if (state2.modifier) {
    const { transform } = DEFAULT_PATTERNS[state2.modifier];
    if (transform) {
      event.preventDefault();
      const transformedValue = transform(clipboardData);
      const cursorPos = target.selectionStart ?? 0;
      const newValue = target.value.slice(0, cursorPos) + transformedValue + target.value.slice(cursorPos);
      target.value = newValue;
      target.setSelectionRange(cursorPos + transformedValue.length, cursorPos + transformedValue.length);
    }
  }
}
const pattern = {
  beforeMount(el, binding) {
    const target = getTarget(el);
    if (!target) return;
    const state2 = {
      modifier: getModifiers(binding)
    };
    if (typeof binding.value === "object") {
      state2.pattern = binding.value.pattern || /./;
      state2.validateOnly = binding.value.validateOnly || false;
    }
    stateMap.set(el, state2);
    bindEvents(el, target, state2);
  },
  updated(el, binding) {
    const target = getTarget(el);
    if (!target) return;
    const state2 = stateMap.get(el);
    if (!state2) return;
    unbindEvents(target, state2);
    state2.modifier = getModifiers(binding);
    if (typeof binding.value === "object") {
      state2.pattern = binding.value.pattern || /./;
      state2.validateOnly = binding.value.validateOnly || false;
    }
    bindEvents(el, target, state2);
  },
  unmounted(el) {
    const target = getTarget(el);
    const state2 = stateMap.get(el);
    if (target && state2) {
      unbindEvents(target, state2);
    }
    stateMap.delete(el);
  }
};
const ripple = {
  mounted(el, binding) {
    const clickHandler2 = (e) => {
      const rect = el.getBoundingClientRect();
      const size2 = Math.max(rect.width, rect.height);
      const ripple2 = document.createElement("span");
      ripple2.className = "ripple";
      Object.assign(ripple2.style, {
        width: `${size2}px`,
        height: `${size2}px`,
        left: `${e.clientX - rect.left - size2 / 2}px`,
        top: `${e.clientY - rect.top - size2 / 2}px`,
        position: "absolute",
        borderRadius: "50%",
        transform: "scale(0)",
        background: "rgba(0, 0, 0, 0.3)",
        pointerEvents: "none",
        animation: "rippleEffect 0.6s ease-out"
      });
      el.appendChild(ripple2);
      setTimeout(() => {
        ripple2.remove();
      }, 600);
    };
    el.__rippleClickHandler = clickHandler2;
    if (binding.value !== false) {
      if (getComputedStyle(el).position === "static") {
        el.style.position = "relative";
      }
      el.style.overflow = "hidden";
      el.addEventListener("mousedown", clickHandler2);
    }
  },
  updated(el, binding) {
    const clickHandler2 = el.__rippleClickHandler;
    if (binding.value === false) {
      el.removeEventListener("mousedown", clickHandler2);
    } else {
      if (getComputedStyle(el).position === "static") {
        el.style.position = "relative";
      }
      el.style.overflow = "hidden";
      el.addEventListener("mousedown", clickHandler2);
    }
  },
  unmounted(el) {
    const clickHandler2 = el.__rippleClickHandler;
    if (clickHandler2) {
      el.removeEventListener("mousedown", clickHandler2);
      delete el.__rippleClickHandler;
    }
  }
};
const clickOutside = {
  beforeMount(el, binding) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el) {
    document.removeEventListener("click", el.clickOutsideEvent);
  }
};
const bagelInjectionKey = Symbol("bagel");
const i18nTInjectionKey = Symbol("bagel");
function useBagel(injectionKey = bagelInjectionKey) {
  const bagel = inject(injectionKey);
  if (!bagel) throw new Error("No bagel provided");
  return bagel;
}
function useI18nT(injectionKey = i18nTInjectionKey) {
  const i18nT = inject(injectionKey);
  if (!i18nT) throw new Error("No i18nT provided");
  return i18nT;
}
const BagelVue = {
  install: (app, options) => {
    const bagel = new Bagel({ host: options.host, fileBaseUrl: options.fileBaseUrl, onError: options.onError });
    app.directive("click-outside", clickOutside);
    app.directive("ripple", ripple);
    app.directive("pattern", pattern);
    app.use(lightboxPlugin);
    app.use(Gt, {
      themes: {
        "bgl-theme": {
          triggers: ["click"],
          autoHide: true,
          placement: "bottom"
        }
      }
    });
    const { availableLangs, defaultLang, lang } = useLang();
    if (options.availableLangs) availableLangs.value = options.availableLangs;
    if (options.defaultLang) defaultLang.value = options.defaultLang;
    if (options.language) lang.value = options.language;
    app.config.globalProperties.$bagel = bagel;
    app.provide(bagelInjectionKey, bagel);
    app.config.globalProperties.$i18T = options.i18nT || ((key) => key);
    app.provide(i18nTInjectionKey, options.i18nT || ((key) => key));
  }
};
const ModalSymbol = Symbol("modal");
function useModal() {
  const modalApi = inject(ModalSymbol);
  if (!modalApi) throw new Error("Modal API not provided");
  return modalApi;
}
const ModalPlugin = {
  install: (app) => {
    const modalStack = ref([]);
    const hideModal = (index2) => {
      modalStack.value.splice(index2, 1);
    };
    const confirmModal = (options) => {
      return new Promise((resolve) => {
        const confirmOptions = typeof options === "string" ? { title: "", message: options } : options;
        modalStack.value.push({
          modalOptions: { ...confirmOptions, resolve },
          modalType: "confirmModal",
          componentSlots: {}
        });
      });
    };
    const showModal = (modalType, options, slots = {}) => {
      const modalComponent = {
        modalOptions: options,
        modalType,
        componentSlots: slots
      };
      modalStack.value.push(modalComponent);
      if (modalType === "modalForm") {
        return modalComponent;
      }
      return modalComponent;
    };
    app.provide(ModalSymbol, {
      showModal: (options, slots) => showModal("modal", options, slots),
      showModalForm: (options, slots) => showModal("modalForm", options, slots),
      confirmModal: (options) => confirmModal(options),
      hideModal: (index2 = modalStack.value.length - 1) => {
        hideModal(index2);
      }
    });
    const ModalComponent = defineComponent({
      data: () => ({ modalStack: modalStack.value }),
      render() {
        return this.modalStack.map((modal, index2) => {
          const props2 = {
            ...modal.modalOptions,
            "visible": true,
            "onUpdate:visible": () => {
              hideModal(index2);
            }
          };
          switch (modal.modalType) {
            case "modalForm":
              return h$2(ModalForm, props2, modal.componentSlots);
            case "confirmModal":
              return h$2(_sfc_main$c, props2, {});
            default:
              return h$2(_sfc_main$d, props2, modal.componentSlots);
          }
        });
      }
    });
    app.component("ModalContainer", ModalComponent);
  }
};
const countryArray = [
  ["Afghanistan (افغانستان)", "AF", "93"],
  ["Albania (Shqipëri)", "AL", "355"],
  ["Algeria (الجزائر)", "DZ", "213"],
  ["American Samoa", "AS", "1", 5, ["684"]],
  ["Andorra", "AD", "376"],
  ["Angola", "AO", "244"],
  ["Anguilla", "AI", "1", 6, ["264"]],
  ["Antigua and Barbuda", "AG", "1", 7, ["268"]],
  ["Argentina", "AR", "54"],
  ["Armenia (Հայաստան)", "AM", "374"],
  ["Aruba", "AW", "297"],
  ["Ascension Island", "AC", "247"],
  ["Australia", "AU", "61", 0],
  ["Austria (Österreich)", "AT", "43"],
  ["Azerbaijan (Azərbaycan)", "AZ", "994"],
  ["Bahamas", "BS", "1", 8, ["242"]],
  ["Bahrain (البحرين)", "BH", "973"],
  ["Bangladesh (বাংলাদেশ)", "BD", "880"],
  ["Barbados", "BB", "1", 9, ["246"]],
  ["Belarus (Беларусь)", "BY", "375"],
  ["Belgium (België)", "BE", "32"],
  ["Belize", "BZ", "501"],
  ["Benin (Bénin)", "BJ", "229"],
  ["Bermuda", "BM", "1", 10, ["441"]],
  ["Bhutan (འབྲུག)", "BT", "975"],
  ["Bolivia", "BO", "591"],
  ["Bosnia and Herzegovina (Босна и Херцеговина)", "BA", "387"],
  ["Botswana", "BW", "267"],
  ["Brazil (Brasil)", "BR", "55"],
  ["British Indian Ocean Territory", "IO", "246"],
  ["British Virgin Islands", "VG", "1", 11, ["284"]],
  ["Brunei", "BN", "673"],
  ["Bulgaria (България)", "BG", "359"],
  ["Burkina Faso", "BF", "226"],
  ["Burundi (Uburundi)", "BI", "257"],
  ["Cambodia (កម្ពុជា)", "KH", "855"],
  ["Cameroon (Cameroun)", "CM", "237"],
  [
    "Canada",
    "CA",
    "1",
    1,
    [
      "204",
      "226",
      "236",
      "249",
      "250",
      "263",
      "289",
      "306",
      "343",
      "354",
      "365",
      "367",
      "368",
      "382",
      "387",
      "403",
      "416",
      "418",
      "428",
      "431",
      "437",
      "438",
      "450",
      "584",
      "468",
      "474",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "584",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "683",
      "705",
      "709",
      "742",
      "753",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ]
  ],
  ["Cape Verde (Kabu Verdi)", "CV", "238"],
  ["Caribbean Netherlands", "BQ", "599", 1, ["3", "4", "7"]],
  ["Cayman Islands", "KY", "1", 12, ["345"]],
  ["Central African Republic (République centrafricaine)", "CF", "236"],
  ["Chad (Tchad)", "TD", "235"],
  ["Chile", "CL", "56"],
  ["China (中国)", "CN", "86"],
  ["Christmas Island", "CX", "61", 2, ["89164"]],
  ["Cocos (Keeling) Islands", "CC", "61", 1, ["89162"]],
  ["Colombia", "CO", "57"],
  ["Comoros (جزر القمر)", "KM", "269"],
  ["Congo (DRC) (République démocratique du Congo)", "CD", "243"],
  ["Congo (Republic) (Congo-Brazzaville)", "CG", "242"],
  ["Cook Islands", "CK", "682"],
  ["Costa Rica", "CR", "506"],
  ["Côte d’Ivoire", "CI", "225"],
  ["Croatia (Hrvatska)", "HR", "385"],
  ["Cuba", "CU", "53"],
  ["Curaçao", "CW", "599", 0],
  ["Cyprus (Κύπρος)", "CY", "357"],
  ["Czech Republic (Česká republika)", "CZ", "420"],
  ["Denmark (Danmark)", "DK", "45"],
  ["Djibouti", "DJ", "253"],
  ["Dominica", "DM", "1", 13, ["767"]],
  [
    "Dominican Republic (República Dominicana)",
    "DO",
    "1",
    2,
    ["809", "829", "849"]
  ],
  ["Ecuador", "EC", "593"],
  ["Egypt (مصر)", "EG", "20"],
  ["El Salvador", "SV", "503"],
  ["Equatorial Guinea (Guinea Ecuatorial)", "GQ", "240"],
  ["Eritrea", "ER", "291"],
  ["Estonia (Eesti)", "EE", "372"],
  ["Eswatini", "SZ", "268"],
  ["Ethiopia", "ET", "251"],
  ["Falkland Islands (Islas Malvinas)", "FK", "500"],
  ["Faroe Islands (Føroyar)", "FO", "298"],
  ["Fiji", "FJ", "679"],
  ["Finland (Suomi)", "FI", "358", 0],
  ["France", "FR", "33"],
  ["French Guiana (Guyane française)", "GF", "594"],
  ["French Polynesia (Polynésie française)", "PF", "689"],
  ["Gabon", "GA", "241"],
  ["Gambia", "GM", "220"],
  ["Georgia (საქართველო)", "GE", "995"],
  ["Germany (Deutschland)", "DE", "49"],
  ["Ghana (Gaana)", "GH", "233"],
  ["Gibraltar", "GI", "350"],
  ["Greece (Ελλάδα)", "GR", "30"],
  ["Greenland (Kalaallit Nunaat)", "GL", "299"],
  ["Grenada", "GD", "1", 14, ["473"]],
  ["Guadeloupe", "GP", "590", 0],
  ["Guam", "GU", "1", 15, ["671"]],
  ["Guatemala", "GT", "502"],
  ["Guernsey", "GG", "44", 1, ["1481", "7781", "7839", "7911"]],
  ["Guinea (Guinée)", "GN", "224"],
  ["Guinea-Bissau (Guiné Bissau)", "GW", "245"],
  ["Guyana", "GY", "592"],
  ["Haiti", "HT", "509"],
  ["Honduras", "HN", "504"],
  ["Hong Kong (香港)", "HK", "852"],
  ["Hungary (Magyarország)", "HU", "36"],
  ["Iceland (Ísland)", "IS", "354"],
  ["India (भारत)", "IN", "91"],
  ["Indonesia", "ID", "62"],
  ["Iran (ایران)", "IR", "98"],
  ["Iraq (العراق)", "IQ", "964"],
  ["Ireland", "IE", "353"],
  ["Isle of Man", "IM", "44", 2, ["1624", "74576", "7524", "7924", "7624"]],
  ["Israel (ישראל)", "IL", "972"],
  ["Italy (Italia)", "IT", "39", 0],
  ["Jamaica", "JM", "1", 4, ["876", "658"]],
  ["Japan (日本)", "JP", "81"],
  ["Jersey", "JE", "44", 3, ["1534", "7509", "7700", "7797", "7829", "7937"]],
  ["Jordan (الأردن)", "JO", "962"],
  ["Kazakhstan (Казахстан)", "KZ", "7", 1, ["33", "7"]],
  ["Kenya", "KE", "254"],
  ["Kiribati", "KI", "686"],
  ["Kosovo", "XK", "383"],
  ["Kuwait (الكويت)", "KW", "965"],
  ["Kyrgyzstan (Кыргызстан)", "KG", "996"],
  ["Laos (ລາວ)", "LA", "856"],
  ["Latvia (Latvija)", "LV", "371"],
  ["Lebanon (لبنان)", "LB", "961"],
  ["Lesotho", "LS", "266"],
  ["Liberia", "LR", "231"],
  ["Libya (ليبيا)", "LY", "218"],
  ["Liechtenstein", "LI", "423"],
  ["Lithuania (Lietuva)", "LT", "370"],
  ["Luxembourg", "LU", "352"],
  ["Macau (澳門)", "MO", "853"],
  ["Madagascar (Madagasikara)", "MG", "261"],
  ["Malawi", "MW", "265"],
  ["Malaysia", "MY", "60"],
  ["Maldives", "MV", "960"],
  ["Mali", "ML", "223"],
  ["Malta", "MT", "356"],
  ["Marshall Islands", "MH", "692"],
  ["Martinique", "MQ", "596"],
  ["Mauritania (موريتانيا)", "MR", "222"],
  ["Mauritius (Moris)", "MU", "230"],
  ["Mayotte", "YT", "262", 1, ["269", "639"]],
  ["Mexico (México)", "MX", "52"],
  ["Micronesia", "FM", "691"],
  ["Moldova (Republica Moldova)", "MD", "373"],
  ["Monaco", "MC", "377"],
  ["Mongolia (Монгол)", "MN", "976"],
  ["Montenegro (Crna Gora)", "ME", "382"],
  ["Montserrat", "MS", "1", 16, ["664"]],
  ["Morocco (المغرب)", "MA", "212", 0],
  ["Mozambique (Moçambique)", "MZ", "258"],
  ["Myanmar (Burma) (မြန်မာ)", "MM", "95"],
  ["Namibia (Namibië)", "NA", "264"],
  ["Nauru", "NR", "674"],
  ["Nepal (नेपाल)", "NP", "977"],
  ["Netherlands (Nederland)", "NL", "31"],
  ["New Caledonia (Nouvelle-Calédonie)", "NC", "687"],
  ["New Zealand", "NZ", "64"],
  ["Nicaragua", "NI", "505"],
  ["Niger (Nijar)", "NE", "227"],
  ["Nigeria", "NG", "234"],
  ["Niue", "NU", "683"],
  ["Norfolk Island", "NF", "672"],
  ["North Korea (조선 민주주의 인민 공화국)", "KP", "850"],
  ["North Macedonia (Северна Македонија)", "MK", "389"],
  ["Northern Mariana Islands", "MP", "1", 17, ["670"]],
  ["Norway (Norge)", "NO", "47", 0],
  ["Oman (عُمان)", "OM", "968"],
  ["Pakistan (پاکستان)", "PK", "92"],
  ["Palau", "PW", "680"],
  ["Palestine (فلسطين)", "PS", "970"],
  ["Panama (Panamá)", "PA", "507"],
  ["Papua New Guinea", "PG", "675"],
  ["Paraguay", "PY", "595"],
  ["Peru (Perú)", "PE", "51"],
  ["Philippines", "PH", "63"],
  ["Poland (Polska)", "PL", "48"],
  ["Portugal", "PT", "351"],
  ["Puerto Rico", "PR", "1", 3, ["787", "939"]],
  ["Qatar (قطر)", "QA", "974"],
  ["Réunion (La Réunion)", "RE", "262", 0],
  ["Romania (România)", "RO", "40"],
  ["Russia (Россия)", "RU", "7", 0],
  ["Rwanda", "RW", "250"],
  ["Saint Barthélemy", "BL", "590", 1],
  ["Saint Helena", "SH", "290"],
  ["Saint Kitts and Nevis", "KN", "1", 18, ["869"]],
  ["Saint Lucia", "LC", "1", 19, ["758"]],
  ["Saint Martin (Saint-Martin (partie française))", "MF", "590", 2],
  ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "PM", "508"],
  ["Saint Vincent and the Grenadines", "VC", "1", 20, ["784"]],
  ["Samoa", "WS", "685"],
  ["San Marino", "SM", "378"],
  ["São Tomé and Príncipe (São Tomé e Príncipe)", "ST", "239"],
  ["Saudi Arabia (المملكة العربية السعودية)", "SA", "966"],
  ["Senegal (Sénégal)", "SN", "221"],
  ["Serbia (Србија)", "RS", "381"],
  ["Seychelles", "SC", "248"],
  ["Sierra Leone", "SL", "232"],
  ["Singapore", "SG", "65"],
  ["Sint Maarten", "SX", "1", 21, ["721"]],
  ["Slovakia (Slovensko)", "SK", "421"],
  ["Slovenia (Slovenija)", "SI", "386"],
  ["Solomon Islands", "SB", "677"],
  ["Somalia (Soomaaliya)", "SO", "252"],
  ["South Africa", "ZA", "27"],
  ["South Korea (대한민국)", "KR", "82"],
  ["South Sudan (جنوب السودان)", "SS", "211"],
  ["Spain (España)", "ES", "34"],
  ["Sri Lanka (ශ්‍රී ලංකාව)", "LK", "94"],
  ["Sudan (السودان)", "SD", "249"],
  ["Suriname", "SR", "597"],
  ["Svalbard and Jan Mayen", "SJ", "47", 1, ["79"]],
  ["Sweden (Sverige)", "SE", "46"],
  ["Switzerland (Schweiz)", "CH", "41"],
  ["Syria (سوريا)", "SY", "963"],
  ["Taiwan (台灣)", "TW", "886"],
  ["Tajikistan", "TJ", "992"],
  ["Tanzania", "TZ", "255"],
  ["Thailand (ไทย)", "TH", "66"],
  ["Timor-Leste", "TL", "670"],
  ["Togo", "TG", "228"],
  ["Tokelau", "TK", "690"],
  ["Tonga", "TO", "676"],
  ["Trinidad and Tobago", "TT", "1", 22, ["868"]],
  ["Tunisia (تونس)", "TN", "216"],
  ["Turkey (Türkiye)", "TR", "90"],
  ["Turkmenistan", "TM", "993"],
  ["Turks and Caicos Islands", "TC", "1", 23, ["649"]],
  ["Tuvalu", "TV", "688"],
  ["U.S. Virgin Islands", "VI", "1", 24, ["340"]],
  ["Uganda", "UG", "256"],
  ["Ukraine (Україна)", "UA", "380"],
  ["United Arab Emirates (الإمارات العربية المتحدة)", "AE", "971"],
  ["United Kingdom", "GB", "44", 0],
  ["United States", "US", "1", 0],
  ["Uruguay", "UY", "598"],
  ["Uzbekistan (Oʻzbekiston)", "UZ", "998"],
  ["Vanuatu", "VU", "678"],
  ["Vatican City (Città del Vaticano)", "VA", "39", 1, ["06698"]],
  ["Venezuela", "VE", "58"],
  ["Vietnam (Việt Nam)", "VN", "84"],
  ["Wallis and Futuna (Wallis-et-Futuna)", "WF", "681"],
  ["Western Sahara (الصحراء الغربية)", "EH", "212", 1, ["5288", "5289"]],
  ["Yemen (اليمن)", "YE", "967"],
  ["Zambia", "ZM", "260"],
  ["Zimbabwe", "ZW", "263"],
  ["Åland Islands", "AX", "358", 1, ["18"]]
];
const allCountries = countryArray.map(
  ([name, iso2, dialCode, priority = 0, areaCodes = []]) => ({
    name,
    iso2,
    dialCode,
    priority,
    areaCodes
  })
);
const IMAGE_FORMATS = ["jpeg", "png", "webp", "avif", "apng", "gif", "avifs", "svg", "bmp", "jpg", "heic", "heif", "ico", "cur", "tif", "tiff"];
const IMAGE_FORMATS_REGEXP = new RegExp(`(${IMAGE_FORMATS.join("|")})$`, "i");
const VIDEO_FORMATS = ["mp4", "webm", "ogg", "mov", "avi", "flv", "wmv", "mkv", "ts", "m3u8"];
const VIDEO_FORMATS_REGEXP = new RegExp(`(${VIDEO_FORMATS.join("|")})$`, "i");
const translations = {
  en: {
    year: "year",
    month: "month",
    week: "week",
    day: "day",
    hour: "hour",
    minute: "minute",
    second: "second",
    ago: "ago",
    in: "in",
    justNow: "Just now"
  },
  es: {
    year: "año",
    month: "mes",
    week: "semana",
    day: "día",
    hour: "hora",
    minute: "minuto",
    second: "segundo",
    ago: "hace",
    in: "en",
    justNow: "Justo ahora"
  },
  fr: {
    year: "an",
    month: "mois",
    week: "semaine",
    day: "jour",
    hour: "heure",
    minute: "minute",
    second: "seconde",
    ago: "il y a",
    in: "dans",
    justNow: "À l'instant"
  },
  he: {
    year: { singular: "שנה", plural: "שנים" },
    month: { singular: "חודש", plural: "חודשים" },
    week: { singular: "שבוע", plural: "שבועות" },
    day: { singular: "יום", plural: "ימים" },
    hour: { singular: "שעה", plural: "שעות" },
    minute: { singular: "דקה", plural: "דקות" },
    second: { singular: "שנייה", plural: "שניות" },
    ago: "לפני",
    in: "בעוד",
    justNow: "זה עתה"
  }
};
function timeAgo(date2, lang = "en") {
  if (!date2) return "";
  if (typeof date2 === "string") date2 = new Date(date2);
  const now = /* @__PURE__ */ new Date();
  const nowNumber = now.getTime();
  const dateNumber = date2.getTime();
  const seconds = Math.floor((dateNumber - nowNumber) / 1e3);
  const intervals = [
    { label: "year", seconds: 31536e3 },
    { label: "month", seconds: 2592e3 },
    { label: "week", seconds: 604800 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 }
  ];
  const selectedLang = translations[lang];
  for (const interval of intervals) {
    const count2 = Math.floor(Math.abs(seconds) / interval.seconds);
    if (count2 >= 1) {
      const suffix = seconds < 0 ? ` ${selectedLang.ago}` : "";
      const prefix = seconds > 0 && selectedLang.in !== "in" ? `${selectedLang.in} ` : "";
      if (lang === "he") {
        const timeUnit = selectedLang[interval.label];
        const form = count2 === 1 ? timeUnit.singular : timeUnit.plural;
        const hebrewPrefix = seconds < 0 ? `${selectedLang.ago} ` : seconds > 0 ? `${selectedLang.in} ` : "";
        if (interval.label === "day" && seconds > 0) {
          const hours = Math.floor(Math.abs(seconds) % 86400 / 3600);
          const hourUnit = selectedLang.hour;
          const hourForm = hours === 1 ? hourUnit.singular : hourUnit.plural;
          return `${hebrewPrefix}${count2} ${form}${hours > 0 ? ` ${hours} ${hourForm}` : ""}`;
        }
        return `${hebrewPrefix}${count2} ${form}`;
      }
      if (interval.label === "day" && seconds > 0) {
        const hours = Math.floor(Math.abs(seconds) % 86400 / 3600);
        const hourLabel = hours > 1 ? `${selectedLang.hour}s` : selectedLang.hour;
        return `${prefix}${count2} ${selectedLang[interval.label]}${hours > 0 ? ` ${hours} ${hourLabel}` : ""}${suffix}`;
      }
      return `${prefix}${count2} ${selectedLang[interval.label]}${suffix}`;
    }
  }
  return selectedLang.justNow;
}
function getBrowserNavigatorLocale() {
  if (typeof navigator !== "object") return "en-US";
  return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
}
function getDatePartsMap(d2, locale2) {
  return {
    AmPm: d2.toLocaleString(locale2, { hour: "numeric", hour12: true, minute: "numeric" }).split(" ")[1],
    DD: String(d2.getDate()).padStart(2, "0"),
    DDD: d2.toLocaleString(locale2, { weekday: "short" }),
    DDDD: d2.toLocaleString(locale2, { weekday: "long" }),
    HH: String(d2.getHours()).padStart(2, "0"),
    mm: String(d2.getMinutes()).padStart(2, "0"),
    MM: String(d2.getMonth() + 1).padStart(2, "0"),
    MMM: d2.toLocaleString(locale2, { month: "short" }),
    MMMM: d2.toLocaleString(locale2, { month: "long" }),
    ss: String(d2.getSeconds()).padStart(2, "0"),
    sss: String(d2.getMilliseconds()).padStart(3, "0"),
    YY: String(d2.getFullYear()).slice(-2),
    YYYY: String(d2.getFullYear())
  };
}
const _datePartsMapNow = getDatePartsMap(/* @__PURE__ */ new Date(), getBrowserNavigatorLocale());
const _orderedDateTokens = Object.keys(_datePartsMapNow).sort((a2, b2) => b2.length - a2.length);
const _tokenRegExPattern = new RegExp(_orderedDateTokens.map((token) => token).join("|"), "g");
function formatDate(date2, format2 = "DD.MM.YY", locale2) {
  if (!date2) return "";
  locale2 = locale2 || getBrowserNavigatorLocale();
  try {
    const d2 = typeof date2 === "string" ? new Date(date2) : date2;
    if (Number.isNaN(d2.getTime())) {
      console.warn("Invalid date provided to formatDate:", date2);
      return "";
    }
    const datePartsMap = getDatePartsMap(d2, locale2);
    const formatter = new Intl.DateTimeFormat(locale2, {
      day: "numeric",
      hour: "2-digit",
      hour12: true,
      minute: "2-digit",
      month: "long",
      second: "2-digit",
      weekday: "long",
      year: "numeric"
    });
    const formattedParts = formatter.formatToParts(d2);
    const partsMap = {};
    formattedParts.forEach((part) => {
      if (part.type !== "literal") {
        partsMap[part.type] = part.value;
      }
    });
    if (partsMap.month) {
      datePartsMap.MMM = partsMap.month.substring(0, 3);
      datePartsMap.MMMM = partsMap.month;
    }
    if (partsMap.weekday) {
      datePartsMap.DDD = partsMap.weekday.substring(0, 3);
      datePartsMap.DDDD = partsMap.weekday;
    }
    if (partsMap.dayPeriod) {
      datePartsMap.AmPm = partsMap.dayPeriod;
    }
    return format2.replace(
      _tokenRegExPattern,
      (match) => datePartsMap[match]
    );
  } catch (error) {
    console.warn(`Error formatting date: ${date2} with format: ${format2}`, error);
    return "";
  }
}
export {
  _sfc_main$1n as Accordion,
  AccordionItem,
  _sfc_main$1l as AddressSearch,
  Alert,
  Avatar,
  Badge,
  _sfc_main$T as BagelForm,
  BagelVue,
  _sfc_main$T as BglForm,
  BglVideo,
  BottomMenu,
  Btn,
  _sfc_main$11 as Calendar,
  _sfc_main$10 as Card,
  Carousel,
  CheckInput,
  Checkbox,
  CodeEditor,
  _sfc_main$O as ColorInput,
  DataPreview,
  DataTable,
  DateInput,
  DatePick,
  _sfc_main$L as DatePicker,
  _sfc_main$X as Draggable,
  _sfc_main$W as Dropdown,
  FORM_STATE_KEY,
  _sfc_main$S as FieldArray,
  FieldSetVue,
  FileUpload,
  Flag,
  IMAGE_FORMATS,
  IMAGE_FORMATS_REGEXP,
  _sfc_main$s as Icon,
  _sfc_main$r as IframeVue,
  Image$1 as Image,
  JSONInput,
  Layout,
  _sfc_main$_ as Lineart,
  _sfc_main$h as ListItem,
  ListView,
  Loading,
  _sfc_main$e as MapEmbed,
  _sfc_main$d as Modal,
  _sfc_main$c as ModalConfirm,
  ModalForm,
  ModalPlugin,
  NavBar,
  NumberInput,
  OTP,
  _sfc_main$9 as PageTitle,
  _sfc_main$G as PasswordInput,
  Pill,
  RadioGroup,
  RadioPillsInput,
  RangeInput,
  RichText,
  RouterWrapper,
  SelectInput,
  SidebarMenu,
  _sfc_main$x as SignaturePad,
  Skeleton,
  Index as Spreadsheet,
  TabbedLayout,
  TableField,
  DataTable as TableSchema,
  _sfc_main$k as Tabs,
  _sfc_main$j as TabsBody,
  TabsNav,
  TelInput,
  TextInput,
  _sfc_main$4 as Title,
  ToggleInput,
  ToolBar,
  TopBar,
  UploadInput,
  VIDEO_FORMATS,
  VIDEO_FORMATS_REGEXP,
  Zoomer,
  allCountries,
  appendScript,
  appendStyle,
  BagelFormUtils as bagelFormUtils,
  bagelInjectionKey,
  bindAttrs,
  classify,
  copyText,
  debounce,
  denullify,
  formatDate,
  formatString,
  getDatePartsMap,
  getFallbackSchema,
  getNestedValue,
  i18nTInjectionKey,
  iffer,
  initials,
  isDate$1 as isDate,
  keyToLabel,
  localRef,
  normalizeDimension,
  normalizeURL,
  pathKeyToURL,
  provideBagelFormState,
  sleep,
  slugify,
  timeAgo,
  useBagel,
  useBagelFormState,
  useBglSchema,
  useDebounceFn,
  useDevice,
  useDraggable,
  useEscape,
  useI18nT,
  useLang,
  useLocalStorage,
  useModal,
  vDraggable
};
